const playerMapping = {
  "playerMapping": {
    "822": {
      "optaId": "asyzhp3qu95vmzdbau6nmoic5",
      "heimPlayer": {
        "id": "100153921",
        "team_id": "1052",
        "person": {
          "id": "822",
          "name": "Matteo Darmian",
          "firstname": "Matteo",
          "surname": "Darmian",
          "fullname": "Matteo Darmian",
          "gender": "male",
          "birthday": "02.12.1989",
          "height": "182",
          "weight": "70",
          "person_detail": {
            "id": "83869",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Legnano",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.02.2026 19:49",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "asyzhp3qu95vmzdbau6nmoic5",
        "firstName": "Matteo",
        "lastName": "Darmian",
        "shortFirstName": "Matteo",
        "shortLastName": "Darmian",
        "matchName": "M. Darmian",
        "shirtNumber": 36,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "10435": {
      "optaId": "64pzn3jdqo6y2izlpm8n3tvpx",
      "heimPlayer": {
        "id": "97638943",
        "team_id": "209",
        "person": {
          "id": "10435",
          "name": "Manuel Neuer",
          "firstname": "Manuel",
          "surname": "Neuer",
          "fullname": "Manuel Peter Neuer",
          "gender": "male",
          "birthday": "27.03.1986",
          "height": "193",
          "weight": "93",
          "person_detail": {
            "id": "21244",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Gelsenkirchen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "09.12.2025 17:35",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "64pzn3jdqo6y2izlpm8n3tvpx",
        "firstName": "Manuel Peter",
        "lastName": "Neuer",
        "shortFirstName": "Manuel",
        "shortLastName": "Neuer",
        "matchName": "M. Neuer",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1",
        "captain": "yes"
      }
    },
    "10596": {
      "optaId": "2gsq05yyxwe4f8t79j6d49q6t",
      "heimPlayer": {
        "id": "99153895",
        "team_id": "1502",
        "person": {
          "id": "10596",
          "name": "Ivan Perišić",
          "firstname": "Ivan",
          "surname": "Perišić",
          "fullname": "Ivan Perišić",
          "gender": "male",
          "birthday": "02.02.1989",
          "height": "186",
          "weight": "80",
          "person_detail": {
            "id": "87324",
            "position_1": "6",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Split",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "2gsq05yyxwe4f8t79j6d49q6t",
        "firstName": "Ivan",
        "lastName": "Perišić",
        "shortFirstName": "Ivan",
        "shortLastName": "Perisic",
        "matchName": "I. Perišić",
        "shirtNumber": 5,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "10864": {
      "optaId": "bagn0ce4xunsiz3mezrtqx1p1",
      "heimPlayer": {
        "id": "100492438",
        "team_id": "1052",
        "person": {
          "id": "10864",
          "name": "Yann Sommer",
          "firstname": "Yann",
          "surname": "Sommer",
          "fullname": "Yann Sommer",
          "gender": "male",
          "birthday": "17.12.1988",
          "height": "183",
          "weight": "79",
          "person_detail": {
            "id": "52811",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Morges",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "bagn0ce4xunsiz3mezrtqx1p1",
        "firstName": "Yann",
        "lastName": "Sommer",
        "shortFirstName": "Yann",
        "shortLastName": "Sommer",
        "matchName": "Y. Sommer",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "14872": {
      "optaId": "7w5ivtmbqzi4hfte330r1a505",
      "heimPlayer": {
        "id": "95819245",
        "team_id": "64",
        "person": {
          "id": "14872",
          "name": "Remko Pasveer",
          "firstname": "Remko",
          "surname": "Pasveer",
          "fullname": "Remko Pasveer",
          "gender": "male",
          "birthday": "08.11.1983",
          "height": "187",
          "weight": "88",
          "person_detail": {
            "id": "24229",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Enschede",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "05.11.2025 19:53",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "7w5ivtmbqzi4hfte330r1a505",
        "firstName": "Remko Jurian",
        "lastName": "Pasveer",
        "shortFirstName": "Remko",
        "shortLastName": "Pasveer",
        "matchName": "R. Pasveer",
        "shirtNumber": 22,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "16088": {
      "optaId": "94kzhufmz3ktpn1a9z1y91at",
      "heimPlayer": {
        "id": "99154444",
        "team_id": "13914",
        "person": {
          "id": "16088",
          "name": "Derrick Luckassen",
          "firstname": "Derrick",
          "surname": "Luckassen",
          "fullname": "Derrick Luckassen",
          "gender": "male",
          "birthday": "03.07.1995",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "115095",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "94kzhufmz3ktpn1a9z1y91at",
        "firstName": "Derrick",
        "lastName": "Luckassen",
        "shortFirstName": "Derrick",
        "shortLastName": "Luckassen",
        "matchName": "D. Luckassen",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "17534": {
      "optaId": "afxjicw89683nlpms9yy5x51x",
      "heimPlayer": {
        "id": "101855600",
        "team_id": "597",
        "person": {
          "id": "17534",
          "name": "Robert Lewandowski",
          "firstname": "Robert",
          "surname": "Lewandowski",
          "fullname": "Robert Lewandowski",
          "gender": "male",
          "birthday": "21.08.1988",
          "height": "185",
          "weight": "81",
          "person_detail": {
            "id": "119054",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Warszawa",
            "died": "no"
          },
          "country": [
            {
              "id": "166"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "afxjicw89683nlpms9yy5x51x",
        "firstName": "Robert",
        "lastName": "Lewandowski",
        "shortFirstName": "Robert",
        "shortLastName": "Lewandowski",
        "matchName": "R. Lewandowski",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "24032": {
      "optaId": "7goksqm8rew8chdswsx5cidhx",
      "heimPlayer": {
        "id": "99154441",
        "team_id": "13914",
        "person": {
          "id": "24032",
          "name": "David Luiz",
          "firstname": "",
          "surname": "David Luiz",
          "fullname": "David Luiz Moreira Marinho",
          "gender": "male",
          "birthday": "22.04.1987",
          "height": "189",
          "weight": "86",
          "person_detail": {
            "id": "73265",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Diadema",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "7goksqm8rew8chdswsx5cidhx",
        "firstName": "David Luiz",
        "lastName": "Moreira Marinho",
        "shortFirstName": "David Luiz",
        "shortLastName": "Moreira Marinho",
        "knownName": "David Luiz",
        "matchName": "David Luiz",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "26517": {
      "optaId": "cg6h7oq0b5zpx1g4brhzyk1xx",
      "heimPlayer": {
        "id": "97641757",
        "team_id": "136",
        "person": {
          "id": "26517",
          "name": "Lukáš Hrádecký",
          "firstname": "Lukáš",
          "surname": "Hrádecký",
          "fullname": "Lukáš Hrádecký",
          "gender": "male",
          "birthday": "24.11.1989",
          "height": "192",
          "weight": "85",
          "person_detail": {
            "id": "47921",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bratislava",
            "died": "no"
          },
          "country": [
            {
              "id": "60"
            }
          ]
        },
        "created": "09.12.2025 19:54",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "cg6h7oq0b5zpx1g4brhzyk1xx",
        "firstName": "Lukáš",
        "lastName": "Hrádecký",
        "shortFirstName": "Lukás",
        "shortLastName": "Hrádecky",
        "matchName": "L. Hrádecký",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "28316": {
      "optaId": "br2uswvdgoj7ndkx7mnbwgyd",
      "heimPlayer": {
        "id": "101489636",
        "team_id": "209",
        "person": {
          "id": "28316",
          "name": "Sven Ulreich",
          "firstname": "Sven",
          "surname": "Ulreich",
          "fullname": "Sven Ulreich",
          "gender": "male",
          "birthday": "03.08.1988",
          "height": "192",
          "weight": "87",
          "person_detail": {
            "id": "45974",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Schorndorf",
            "died": "no"
          }
        },
        "created": "14.03.2026 14:24",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "br2uswvdgoj7ndkx7mnbwgyd",
        "firstName": "Sven",
        "lastName": "Ulreich",
        "shortFirstName": "Sven",
        "shortLastName": "Ulreich",
        "matchName": "S. Ulreich",
        "shirtNumber": 26,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "101437": {
      "optaId": "1xscywgyfqisqexmpfvbf9g45",
      "heimPlayer": {
        "id": "100153912",
        "team_id": "1052",
        "person": {
          "id": "101437",
          "name": "Henrikh Mkhitaryan",
          "firstname": "Henrikh",
          "surname": "Mkhitaryan",
          "fullname": "Henrikh Mkhitaryan",
          "gender": "male",
          "birthday": "21.01.1989",
          "height": "178",
          "weight": "75",
          "person_detail": {
            "id": "82539",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Yerevan",
            "died": "no"
          },
          "country": [
            {
              "id": "13"
            }
          ]
        },
        "created": "18.02.2026 19:49",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "1xscywgyfqisqexmpfvbf9g45",
        "firstName": "Henrikh Hamlet",
        "lastName": "Mkhitaryan",
        "shortFirstName": "Henrikh",
        "shortLastName": "Mkhitaryan",
        "matchName": "H. Mkhitaryan",
        "shirtNumber": 22,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "101884": {
      "optaId": "8bvhibfn0481ckmmutiv1uhre",
      "heimPlayer": {
        "id": "100246291",
        "team_id": "9",
        "person": {
          "id": "101884",
          "name": "Joël Schmied",
          "firstname": "Joël",
          "surname": "Schmied",
          "fullname": "Joël Pascal Schmied",
          "gender": "male",
          "birthday": "23.09.1998",
          "height": "188",
          "weight": "84",
          "person_detail": {
            "id": "83016",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Bern",
            "died": "no"
          }
        },
        "created": "21.02.2026 14:21",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "8bvhibfn0481ckmmutiv1uhre",
        "firstName": "Joël Pascal",
        "lastName": "Schmied",
        "shortFirstName": "Joël",
        "shortLastName": "Schmied",
        "matchName": "J. Schmied",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "103575": {
      "optaId": "4wvi7b8voeb49ib86xt51uwgl",
      "heimPlayer": {
        "id": "99154639",
        "team_id": "17544",
        "person": {
          "id": "103575",
          "name": "Aleksandr Martynovich",
          "firstname": "Aleksandr",
          "surname": "Martynovich",
          "fullname": "Aleksandr Vladimirovich Martynovich",
          "gender": "male",
          "birthday": "26.08.1987",
          "height": "192",
          "weight": "85",
          "person_detail": {
            "id": "85301",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Minsk",
            "died": "no"
          },
          "country": [
            {
              "id": "22"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "4wvi7b8voeb49ib86xt51uwgl",
        "firstName": "Aleksandr",
        "lastName": "Martynovich",
        "shortFirstName": "Aleksandr",
        "shortLastName": "Martynovich",
        "matchName": "A. Martynovich",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "104379": {
      "optaId": "6ofu6yc2qwp5ii9cerdq1tk9h",
      "heimPlayer": {
        "id": "101864402",
        "team_id": "597",
        "person": {
          "id": "104379",
          "name": "Wojciech Szczęsny",
          "firstname": "Wojciech",
          "surname": "Szczęsny",
          "fullname": "Wojciech Tomasz Szczęsny",
          "gender": "male",
          "birthday": "18.04.1990",
          "height": "195",
          "weight": "90",
          "person_detail": {
            "id": "86378",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Warszawa",
            "died": "no"
          },
          "country": [
            {
              "id": "166"
            }
          ]
        },
        "created": "18.03.2026 20:32",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "6ofu6yc2qwp5ii9cerdq1tk9h",
        "firstName": "Wojciech Tomasz",
        "lastName": "Szczęsny",
        "shortFirstName": "Wojciech",
        "shortLastName": "Szczesny",
        "matchName": "W. Szczęsny",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Goalkeeper"
      }
    },
    "110264": {
      "optaId": "3tb27261f8mpzpq3prpv8ng0l",
      "heimPlayer": {
        "id": "100015123",
        "team_id": "29680",
        "person": {
          "id": "110264",
          "name": "Péter Gulácsi",
          "firstname": "Péter",
          "surname": "Gulácsi",
          "fullname": "Péter Gulácsi",
          "gender": "male",
          "birthday": "06.05.1990",
          "height": "191",
          "weight": "86",
          "person_detail": {
            "id": "95468",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Budapest",
            "died": "no"
          }
        },
        "created": "15.02.2026 16:15",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "3tb27261f8mpzpq3prpv8ng0l",
        "firstName": "Péter",
        "lastName": "Gulácsi",
        "shortFirstName": "Péter",
        "shortLastName": "Gulácsi",
        "matchName": "P. Gulácsi",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "111404": {
      "optaId": "axj39lx25teh62rih6uv9qor9",
      "heimPlayer": {
        "id": "93345349",
        "team_id": "29680",
        "person": {
          "id": "111404",
          "name": "Kevin Kampl",
          "firstname": "Kevin",
          "surname": "Kampl",
          "fullname": "Kevin Kampl",
          "gender": "male",
          "birthday": "09.10.1990",
          "height": "178",
          "weight": "66",
          "person_detail": {
            "id": "96784",
            "position_1": "13",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Solingen",
            "died": "no"
          }
        },
        "extra_minute": "3",
        "created": "27.09.2025 17:21",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "axj39lx25teh62rih6uv9qor9",
        "firstName": "Kevin",
        "lastName": "Kampl",
        "shortFirstName": "Kevin",
        "shortLastName": "Kampl",
        "matchName": "K. Kampl",
        "shirtNumber": 44,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "112350": {
      "optaId": "9wbf00lybk9fqablaqwg5cn2t",
      "heimPlayer": {
        "id": "101312783",
        "team_id": "853",
        "person": {
          "id": "112350",
          "name": "İlkay Gündoğan",
          "firstname": "İlkay",
          "surname": "Gündoğan",
          "fullname": "İlkay Gündoğan",
          "gender": "male",
          "birthday": "24.10.1990",
          "height": "180",
          "weight": "79",
          "person_detail": {
            "id": "97814",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Gelsenkirchen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "extra_minute": "3",
        "created": "10.03.2026 20:36",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "9wbf00lybk9fqablaqwg5cn2t",
        "firstName": "İlkay",
        "lastName": "Gündoğan",
        "shortFirstName": "Ilkay",
        "shortLastName": "Gündogan",
        "matchName": "İ. Gündoğan",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "114505": {
      "optaId": "c29mprqv2ulztd22b6uckczx1",
      "heimPlayer": {
        "id": "99159085",
        "team_id": "2102",
        "person": {
          "id": "114505",
          "name": "Dani Parejo",
          "firstname": "",
          "surname": "Dani Parejo",
          "fullname": "Daniel Parejo Muñoz",
          "gender": "male",
          "birthday": "16.04.1989",
          "height": "182",
          "weight": "74",
          "person_detail": {
            "id": "100307",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Coslada",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:25",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "c29mprqv2ulztd22b6uckczx1",
        "firstName": "Daniel",
        "lastName": "Parejo Muñoz",
        "shortFirstName": "Dani",
        "shortLastName": "Parejo",
        "matchName": "Dani Parejo",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "125938": {
      "optaId": "x32fbvwwxkda9ruezw67b3dh",
      "heimPlayer": {
        "id": "100521604",
        "team_id": "1731",
        "person": {
          "id": "125938",
          "name": "Nicolás Otamendi",
          "firstname": "Nicolás",
          "surname": "Otamendi",
          "fullname": "Nicolás Hernán Gonzalo Otamendi",
          "gender": "male",
          "birthday": "12.02.1988",
          "height": "183",
          "weight": "80",
          "person_detail": {
            "id": "113900",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "x32fbvwwxkda9ruezw67b3dh",
        "firstName": "Nicolás Hernán Gonzalo",
        "lastName": "Otamendi",
        "shortFirstName": "Nicolás",
        "shortLastName": "Otamendi",
        "matchName": "N. Otamendi",
        "shirtNumber": 30,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "131946": {
      "optaId": "cm8po8ez5w9ms01gid6w3kwk5",
      "heimPlayer": {
        "id": "101925821",
        "team_id": "24",
        "person": {
          "id": "131946",
          "name": "Oliver Baumann",
          "firstname": "Oliver",
          "surname": "Baumann",
          "fullname": "Oliver Baumann",
          "gender": "male",
          "birthday": "02.06.1990",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "121304",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Breisach am Rhein",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "cm8po8ez5w9ms01gid6w3kwk5",
        "firstName": "Oliver",
        "lastName": "Baumann",
        "shortFirstName": "Oliver",
        "shortLastName": "Baumann",
        "matchName": "O. Baumann",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1",
        "captain": "yes"
      }
    },
    "133206": {
      "optaId": "26wyfq7l14vnr0fvkl509ynkl",
      "heimPlayer": {
        "id": "92668811",
        "team_id": "1418",
        "person": {
          "id": "133206",
          "name": "Alexandros Paschalakis",
          "firstname": "Alexandros",
          "surname": "Paschalakis",
          "fullname": "Alexandros Paschalakis",
          "gender": "male",
          "birthday": "28.07.1989",
          "height": "197",
          "weight": "92",
          "person_detail": {
            "id": "122564",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Athina",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "17.09.2025 17:52",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "26wyfq7l14vnr0fvkl509ynkl",
        "firstName": "Alexandros",
        "lastName": "Paschalakis",
        "shortFirstName": "Alexandros",
        "shortLastName": "Paschalakis",
        "matchName": "A. Paschalakis",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "134830": {
      "optaId": "actvnm36s31zf8wh8hjikzlqt",
      "heimPlayer": {
        "id": "98856991",
        "team_id": "1421",
        "person": {
          "id": "134830",
          "name": "Pierre-Emerick Aubameyang",
          "firstname": "Pierre-Emerick",
          "surname": "Aubameyang",
          "fullname": "Pierre-Emerick Emiliano François Aubameyang",
          "gender": "male",
          "birthday": "18.06.1989",
          "height": "186",
          "weight": "80",
          "person_detail": {
            "id": "124188",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Laval",
            "died": "no"
          },
          "country": [
            {
              "id": "63"
            }
          ]
        },
        "created": "21.01.2026 22:28",
        "shirtnumber": "97"
      },
      "optaPlayer": {
        "playerId": "actvnm36s31zf8wh8hjikzlqt",
        "firstName": "Pierre-Emerick Emiliano François",
        "lastName": "Aubameyang",
        "shortFirstName": "Pierre-Emerick",
        "shortLastName": "Aubameyang",
        "matchName": "P. Aubameyang",
        "shirtNumber": 97,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "137598": {
      "optaId": "4l3qk2g87pa3bevo2nlwkf3rp",
      "heimPlayer": {
        "id": "102100457",
        "team_id": "21",
        "person": {
          "id": "137598",
          "name": "Daniel Batz",
          "firstname": "Daniel",
          "surname": "Batz",
          "fullname": "Daniel Batz",
          "gender": "male",
          "birthday": "12.01.1991",
          "height": "191",
          "weight": "87",
          "person_detail": {
            "id": "126956",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Erlangen",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "4l3qk2g87pa3bevo2nlwkf3rp",
        "firstName": "Daniel",
        "lastName": "Batz",
        "shortFirstName": "Daniel",
        "shortLastName": "Batz",
        "matchName": "D. Batz",
        "shirtNumber": 33,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "140333": {
      "optaId": "6w5wyari2p4bh2zzy2x2f6hg5",
      "heimPlayer": {
        "id": "100526497",
        "team_id": "1545",
        "person": {
          "id": "140333",
          "name": "David Alaba",
          "firstname": "David",
          "surname": "Alaba",
          "fullname": "David Olatukunbo Alaba",
          "gender": "male",
          "birthday": "24.06.1992",
          "height": "180",
          "weight": "78",
          "person_detail": {
            "id": "129691",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Wien",
            "died": "no"
          },
          "country": [
            {
              "id": "158"
            }
          ]
        },
        "created": "25.02.2026 22:37",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "6w5wyari2p4bh2zzy2x2f6hg5",
        "firstName": "David",
        "lastName": "Olatukunbo Alaba",
        "shortFirstName": "David",
        "shortLastName": "Alaba",
        "matchName": "D. Alaba",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "142033": {
      "optaId": "ejnh215cji6xou661kiwcc91x",
      "heimPlayer": {
        "id": "100767871",
        "team_id": "1639",
        "person": {
          "id": "142033",
          "name": "Nicolas Höfler",
          "firstname": "Nicolas",
          "surname": "Höfler",
          "fullname": "Nicolas Höfler",
          "gender": "male",
          "birthday": "09.03.1990",
          "height": "182",
          "weight": "81",
          "person_detail": {
            "id": "131387",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Überlingen",
            "died": "no"
          }
        },
        "created": "01.03.2026 19:10",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "ejnh215cji6xou661kiwcc91x",
        "firstName": "Nicolas",
        "lastName": "Höfler",
        "shortFirstName": "Nicolas",
        "shortLastName": "Höfler",
        "matchName": "N. Höfler",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "144110": {
      "optaId": "52t6t7cdsr0fjs9ukmwo9y7rp",
      "heimPlayer": {
        "id": "101976575",
        "team_id": "19",
        "person": {
          "id": "144110",
          "name": "Christopher Trimmel",
          "firstname": "Christopher",
          "surname": "Trimmel",
          "fullname": "Christopher Trimmel",
          "gender": "male",
          "birthday": "24.02.1987",
          "height": "189",
          "weight": "85",
          "person_detail": {
            "id": "133463",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Oberpullendorf",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "52t6t7cdsr0fjs9ukmwo9y7rp",
        "firstName": "Christopher",
        "lastName": "Trimmel",
        "shortFirstName": "Christopher",
        "shortLastName": "Trimmel",
        "matchName": "C. Trimmel",
        "shirtNumber": 28,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2",
        "captain": "yes"
      }
    },
    "150583": {
      "optaId": "6crmq7vzqts58wg196q48sc7p",
      "heimPlayer": {
        "id": "101813039",
        "team_id": "1545",
        "person": {
          "id": "150583",
          "name": "Thibaut Courtois",
          "firstname": "Thibaut",
          "surname": "Courtois",
          "fullname": "Thibaut Nicolas Marc Courtois",
          "gender": "male",
          "birthday": "11.05.1992",
          "height": "200",
          "weight": "96",
          "person_detail": {
            "id": "139932",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Bree",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "6crmq7vzqts58wg196q48sc7p",
        "firstName": "Thibaut Nicolas Marc",
        "lastName": "Courtois",
        "shortFirstName": "Thibaut",
        "shortLastName": "Courtois",
        "matchName": "T. Courtois",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "151555": {
      "optaId": "3k6znit6fd9mbfcnphlwyvj6d",
      "heimPlayer": {
        "id": "96893155",
        "team_id": "258",
        "person": {
          "id": "151555",
          "name": "Pascal Groß",
          "firstname": "Pascal",
          "surname": "Groß",
          "fullname": "Pascal Groß",
          "gender": "male",
          "birthday": "15.06.1991",
          "height": "181",
          "weight": "78",
          "person_detail": {
            "id": "140903",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Mannheim",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.11.2025 22:42",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "3k6znit6fd9mbfcnphlwyvj6d",
        "firstName": "Pascal Alexander",
        "lastName": "Groß",
        "shortFirstName": "Pascal",
        "shortLastName": "Groß",
        "matchName": "P. Groß",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "152915": {
      "optaId": "ew18qvvupaejxubhqmxmbd39x",
      "heimPlayer": {
        "id": "101934527",
        "team_id": "24",
        "person": {
          "id": "152915",
          "name": "Andrej Kramarić",
          "firstname": "Andrej",
          "surname": "Kramarić",
          "fullname": "Andrej Kramarić",
          "gender": "male",
          "birthday": "19.06.1991",
          "height": "177",
          "weight": "73",
          "person_detail": {
            "id": "142263",
            "position_1": "8",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Zagreb",
            "died": "no"
          }
        },
        "created": "20.03.2026 21:40",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "ew18qvvupaejxubhqmxmbd39x",
        "firstName": "Andrej",
        "lastName": "Kramarić",
        "shortFirstName": "Andrej",
        "shortLastName": "Kramaric",
        "matchName": "A. Kramarić",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "153414": {
      "optaId": "55z0yap5tml66nes2cchg7ahh",
      "heimPlayer": {
        "id": "102001616",
        "team_id": "9",
        "person": {
          "id": "153414",
          "name": "Florian Kainz",
          "firstname": "Florian",
          "surname": "Kainz",
          "fullname": "Florian Kainz",
          "gender": "male",
          "birthday": "24.10.1992",
          "height": "176",
          "weight": "71",
          "person_detail": {
            "id": "142762",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Graz",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:06",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "55z0yap5tml66nes2cchg7ahh",
        "firstName": "Florian",
        "lastName": "Kainz",
        "shortFirstName": "Florian",
        "shortLastName": "Kainz",
        "matchName": "F. Kainz",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "153968": {
      "optaId": "axcrcuv22693vn0a887samsph",
      "heimPlayer": {
        "id": "101812517",
        "team_id": "205",
        "person": {
          "id": "153968",
          "name": "Janis Blaswich",
          "firstname": "Janis",
          "surname": "Blaswich",
          "fullname": "Janis Jonathan Blaswich",
          "gender": "male",
          "birthday": "02.05.1991",
          "height": "193",
          "weight": "87",
          "person_detail": {
            "id": "143316",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Willich",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "axcrcuv22693vn0a887samsph",
        "firstName": "Janis Jonathan",
        "lastName": "Blaswich",
        "shortFirstName": "Janis",
        "shortLastName": "Blaswich",
        "matchName": "J. Blaswich",
        "shirtNumber": 28,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "158259": {
      "optaId": "65z99j774kjnbf7vm0u2q0jit",
      "heimPlayer": {
        "id": "101855720",
        "team_id": "1355",
        "person": {
          "id": "158259",
          "name": "Kieran Trippier",
          "firstname": "Kieran",
          "surname": "Trippier",
          "fullname": "Kieran John Trippier",
          "gender": "male",
          "birthday": "19.09.1990",
          "height": "173",
          "weight": "69",
          "person_detail": {
            "id": "147607",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Bury",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "65z99j774kjnbf7vm0u2q0jit",
        "firstName": "Kieran John",
        "lastName": "Trippier",
        "shortFirstName": "Kieran",
        "shortLastName": "Trippier",
        "matchName": "K. Trippier",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2",
        "captain": "yes"
      }
    },
    "158725": {
      "optaId": "1v8r5d4v9eh3011wmwhk3v36d",
      "heimPlayer": {
        "id": "99154462",
        "team_id": "13914",
        "person": {
          "id": "158725",
          "name": "Mislav Oršić",
          "firstname": "Mislav",
          "surname": "Oršić",
          "fullname": "Mislav Oršić",
          "gender": "male",
          "birthday": "29.12.1992",
          "height": "179",
          "weight": "69",
          "person_detail": {
            "id": "148073",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Zagreb",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "1v8r5d4v9eh3011wmwhk3v36d",
        "firstName": "Mislav",
        "lastName": "Oršić",
        "shortFirstName": "Mislav",
        "shortLastName": "Orsic",
        "matchName": "M. Oršić",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "161665": {
      "optaId": "3o573dblmfc1o3wkkt2nva8k5",
      "heimPlayer": {
        "id": "100521730",
        "team_id": "1094",
        "person": {
          "id": "161665",
          "name": "Mattia Perin",
          "firstname": "Mattia",
          "surname": "Perin",
          "fullname": "Mattia Perin",
          "gender": "male",
          "birthday": "10.11.1992",
          "height": "188",
          "weight": "77",
          "person_detail": {
            "id": "151012",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Latina",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "3o573dblmfc1o3wkkt2nva8k5",
        "firstName": "Mattia",
        "lastName": "Perin",
        "shortFirstName": "Mattia",
        "shortLastName": "Perin",
        "matchName": "M. Perin",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "163015": {
      "optaId": "8hm6d6395johhjsoe8jz6dcyd",
      "heimPlayer": {
        "id": "99154825",
        "team_id": "156",
        "person": {
          "id": "163015",
          "name": "Yuri",
          "firstname": "",
          "surname": "Yuri",
          "fullname": "Yuri Berchiche Izeta",
          "gender": "male",
          "birthday": "10.02.1990",
          "height": "181",
          "weight": "79",
          "person_detail": {
            "id": "152360",
            "position_1": "3",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Zarautz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "8hm6d6395johhjsoe8jz6dcyd",
        "firstName": "Yuri",
        "lastName": "Berchiche Izeta",
        "shortFirstName": "Yuri",
        "shortLastName": "Berchiche",
        "matchName": "Yuri",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "163477": {
      "optaId": "716n1970vi9rvw5b4w9qmjfth",
      "heimPlayer": {
        "id": "98854147",
        "team_id": "162",
        "person": {
          "id": "163477",
          "name": "Antoine Griezmann",
          "firstname": "Antoine",
          "surname": "Griezmann",
          "fullname": "Antoine Griezmann",
          "gender": "male",
          "birthday": "21.03.1991",
          "height": "176",
          "weight": "73",
          "person_detail": {
            "id": "152822",
            "position_1": "8",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Mâcon",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 20:03",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "716n1970vi9rvw5b4w9qmjfth",
        "firstName": "Antoine",
        "lastName": "Griezmann",
        "shortFirstName": "Antoine",
        "shortLastName": "Griezmann",
        "matchName": "A. Griezmann",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "164283": {
      "optaId": "b9kfek16otvdorssn0wzkb36d",
      "heimPlayer": {
        "id": "99152554",
        "team_id": "162",
        "person": {
          "id": "164283",
          "name": "Koke",
          "firstname": "",
          "surname": "Koke",
          "fullname": "Jorge Resurrección Merodio",
          "gender": "male",
          "birthday": "08.01.1992",
          "height": "176",
          "weight": "75",
          "person_detail": {
            "id": "153628",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "b9kfek16otvdorssn0wzkb36d",
        "firstName": "Jorge",
        "lastName": "Resurrección Merodio",
        "shortFirstName": "Jorge",
        "shortLastName": "Resurrección Merodio",
        "knownName": "Koke",
        "matchName": "Koke",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "166543": {
      "optaId": "2ciak27414tln8ac4t4xj38id",
      "heimPlayer": {
        "id": "102116576",
        "team_id": "702",
        "person": {
          "id": "166543",
          "name": "Jackson Irvine",
          "firstname": "Jackson",
          "surname": "Irvine",
          "fullname": "Jackson Alexander Irvine",
          "gender": "male",
          "birthday": "07.03.1993",
          "height": "189",
          "weight": "74",
          "person_detail": {
            "id": "155887",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Melbourne",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:18",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "2ciak27414tln8ac4t4xj38id",
        "firstName": "Jackson Alexander",
        "lastName": "Irvine",
        "shortFirstName": "Jackson",
        "shortLastName": "Irvine",
        "matchName": "J. Irvine",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "166807": {
      "optaId": "8ztjk6yu7qfb0aabjebf4513p",
      "heimPlayer": {
        "id": "99158680",
        "team_id": "1736",
        "person": {
          "id": "166807",
          "name": "Jan Bořil",
          "firstname": "Jan",
          "surname": "Bořil",
          "fullname": "Jan Bořil",
          "gender": "male",
          "birthday": "11.01.1991",
          "height": "175",
          "weight": "75",
          "person_detail": {
            "id": "156151",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Nymburk",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 22:13",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "8ztjk6yu7qfb0aabjebf4513p",
        "firstName": "Jan",
        "lastName": "Bořil",
        "shortFirstName": "Jan",
        "shortLastName": "Boril",
        "matchName": "J. Bořil",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "167830": {
      "optaId": "eqtsanns36za56h4pfqhbnh05",
      "heimPlayer": {
        "id": "98854462",
        "team_id": "530",
        "person": {
          "id": "167830",
          "name": "Mario Götze",
          "firstname": "Mario",
          "surname": "Götze",
          "fullname": "Mario Götze",
          "gender": "male",
          "birthday": "03.06.1992",
          "height": "176",
          "weight": "75",
          "person_detail": {
            "id": "157174",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Memmingen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.01.2026 20:15",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "eqtsanns36za56h4pfqhbnh05",
        "firstName": "Mario",
        "lastName": "Götze",
        "shortFirstName": "Mario",
        "shortLastName": "Götze",
        "matchName": "M. Götze",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "168116": {
      "optaId": "dxxc4dioaioidmvamkzqr4b85",
      "heimPlayer": {
        "id": "96884257",
        "team_id": "1355",
        "person": {
          "id": "168116",
          "name": "Fabian Schär",
          "firstname": "Fabian",
          "surname": "Schär",
          "fullname": "Fabian Lukas Schär",
          "gender": "male",
          "birthday": "20.12.1991",
          "height": "186",
          "weight": "85",
          "person_detail": {
            "id": "157460",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Wil",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "25.11.2025 19:57",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "dxxc4dioaioidmvamkzqr4b85",
        "firstName": "Fabian Lukas",
        "lastName": "Schär",
        "shortFirstName": "Fabian",
        "shortLastName": "Schär",
        "matchName": "F. Schär",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "168297": {
      "optaId": "by2gxuixij1eciu56k8mb3cgl",
      "heimPlayer": {
        "id": "95820451",
        "team_id": "1052",
        "person": {
          "id": "168297",
          "name": "Stefan de Vrij",
          "firstname": "Stefan",
          "surname": "de Vrij",
          "fullname": "Stefan de Vrij",
          "gender": "male",
          "birthday": "05.02.1992",
          "height": "189",
          "weight": "78",
          "person_detail": {
            "id": "157641",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ouderkerk aan den IJssel",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "05.11.2025 20:06",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "by2gxuixij1eciu56k8mb3cgl",
        "firstName": "Stefan",
        "lastName": "de Vrij",
        "shortFirstName": "Stefan",
        "shortLastName": "de Vrij",
        "matchName": "S. de Vrij",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "168416": {
      "optaId": "6f1ljb0an6d0g4nbap6xgxsyd",
      "heimPlayer": {
        "id": "101855714",
        "team_id": "1355",
        "person": {
          "id": "168416",
          "name": "Dan Burn",
          "firstname": "Dan",
          "surname": "Burn",
          "fullname": "Daniel Johnson Burn",
          "gender": "male",
          "birthday": "09.05.1992",
          "height": "201",
          "weight": "87",
          "person_detail": {
            "id": "157760",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Blyth",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "6f1ljb0an6d0g4nbap6xgxsyd",
        "firstName": "Daniel Johnson",
        "lastName": "Burn",
        "shortFirstName": "Dan",
        "shortLastName": "Burn",
        "matchName": "D. Burn",
        "shirtNumber": 33,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "169056": {
      "optaId": "awda32rw2clw0sjemf7rkcel1",
      "heimPlayer": {
        "id": "101972948",
        "team_id": "2086",
        "person": {
          "id": "169056",
          "name": "Christian Eriksen",
          "firstname": "Christian",
          "surname": "Eriksen",
          "fullname": "Christian Dannemann Eriksen",
          "gender": "male",
          "birthday": "14.02.1992",
          "height": "182",
          "weight": "76",
          "person_detail": {
            "id": "158400",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Middelfart",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "awda32rw2clw0sjemf7rkcel1",
        "firstName": "Christian",
        "lastName": "Dannemann Eriksen",
        "shortFirstName": "Christian",
        "shortLastName": "Eriksen",
        "matchName": "C. Eriksen",
        "shirtNumber": 24,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "173268": {
      "optaId": "7c6034wb3zsuq9nhxxiahiuol",
      "heimPlayer": {
        "id": "102154946",
        "team_id": "594",
        "person": {
          "id": "173268",
          "name": "Michael Gregoritsch",
          "firstname": "Michael",
          "surname": "Gregoritsch",
          "fullname": "Michael Gregoritsch",
          "gender": "male",
          "birthday": "18.04.1994",
          "height": "193",
          "weight": "91",
          "person_detail": {
            "id": "162610",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Graz",
            "died": "no"
          }
        },
        "created": "22.03.2026 20:35",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "7c6034wb3zsuq9nhxxiahiuol",
        "firstName": "Michael",
        "lastName": "Gregoritsch",
        "shortFirstName": "Michael",
        "shortLastName": "Gregoritsch",
        "matchName": "M. Gregoritsch",
        "shirtNumber": 38,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "173280": {
      "optaId": "bvifdvoxv9e8nq8qe37c0gvrp",
      "heimPlayer": {
        "id": "99879466",
        "team_id": "21",
        "person": {
          "id": "173280",
          "name": "Stefan Bell",
          "firstname": "Stefan",
          "surname": "Bell",
          "fullname": "Stefan Bell",
          "gender": "male",
          "birthday": "24.08.1991",
          "height": "192",
          "weight": "88",
          "person_detail": {
            "id": "162622",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Andernach",
            "died": "no"
          }
        },
        "created": "13.02.2026 19:16",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "bvifdvoxv9e8nq8qe37c0gvrp",
        "firstName": "Stefan",
        "lastName": "Bell",
        "shortFirstName": "Stefan",
        "shortLastName": "Bell",
        "matchName": "S. Bell",
        "shirtNumber": 16,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "173389": {
      "optaId": "8cho2d1nz18i5o0zt6aysd68l",
      "heimPlayer": {
        "id": "100134127",
        "team_id": "258",
        "person": {
          "id": "173389",
          "name": "Marcel Sabitzer",
          "firstname": "Marcel",
          "surname": "Sabitzer",
          "fullname": "Marcel Sabitzer",
          "gender": "male",
          "birthday": "17.03.1994",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "162731",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Wels",
            "died": "no"
          },
          "country": [
            {
              "id": "158"
            }
          ]
        },
        "created": "17.02.2026 22:55",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "8cho2d1nz18i5o0zt6aysd68l",
        "firstName": "Marcel",
        "lastName": "Sabitzer",
        "shortFirstName": "Marcel",
        "shortLastName": "Sabitzer",
        "matchName": "M. Sabitzer",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "173407": {
      "optaId": "9q01y4w4dwpaqf8lmpv9wnmc5",
      "heimPlayer": {
        "id": "101867963",
        "team_id": "155",
        "person": {
          "id": "173407",
          "name": "Marten de Roon",
          "firstname": "Marten",
          "surname": "de Roon",
          "fullname": "Marten Elco de Roon",
          "gender": "male",
          "birthday": "29.03.1991",
          "height": "185",
          "weight": "76",
          "person_detail": {
            "id": "162749",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Zwijndrecht",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 22:16",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "9q01y4w4dwpaqf8lmpv9wnmc5",
        "firstName": "Marten Elco",
        "lastName": "de Roon",
        "shortFirstName": "Marten",
        "shortLastName": "de Roon",
        "matchName": "M. de Roon",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "209470": {
      "optaId": "73aues52n0vmq59vvvsqrqcid",
      "heimPlayer": {
        "id": "100493305",
        "team_id": "18670",
        "person": {
          "id": "209470",
          "name": "Bədavi Hüseynov",
          "firstname": "Bədavi",
          "surname": "Hüseynov",
          "fullname": "Bədavi Ruslan Hüseynov",
          "gender": "male",
          "birthday": "11.07.1991",
          "height": "185",
          "weight": "",
          "person_detail": {
            "id": "218409",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Kaspiysk",
            "died": "no"
          },
          "country": [
            {
              "id": "15"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "55"
      },
      "optaPlayer": {
        "playerId": "73aues52n0vmq59vvvsqrqcid",
        "firstName": "Bədavi",
        "lastName": "Hüseynov",
        "shortFirstName": "Badavi",
        "shortLastName": "Hüseynov",
        "matchName": "B. Hüseynov",
        "shirtNumber": 55,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "215233": {
      "optaId": "dxze3b3fsfl814bjcs7q6wcet",
      "heimPlayer": {
        "id": "101861345",
        "team_id": "1226",
        "person": {
          "id": "215233",
          "name": "Virgil van Dijk",
          "firstname": "Virgil",
          "surname": "van Dijk",
          "fullname": "Virgil van Dijk",
          "gender": "male",
          "birthday": "08.07.1991",
          "height": "195",
          "weight": "92",
          "person_detail": {
            "id": "162897",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Breda",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "dxze3b3fsfl814bjcs7q6wcet",
        "firstName": "Virgil",
        "lastName": "van Dijk",
        "shortFirstName": "Virgil",
        "shortLastName": "van Dijk",
        "matchName": "V. van Dijk",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "215744": {
      "optaId": "2jk8zu0m0tf7if0pyrkbo82xh",
      "heimPlayer": {
        "id": "99013135",
        "team_id": "1639",
        "person": {
          "id": "215744",
          "name": "Lukas Kübler",
          "firstname": "Lukas",
          "surname": "Kübler",
          "fullname": "Lukas Kübler",
          "gender": "male",
          "birthday": "30.08.1992",
          "height": "182",
          "weight": "74",
          "person_detail": {
            "id": "163393",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Bonn",
            "died": "no"
          }
        },
        "created": "25.01.2026 16:17",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "2jk8zu0m0tf7if0pyrkbo82xh",
        "firstName": "Lukas",
        "lastName": "Kübler",
        "shortFirstName": "Lukas",
        "shortLastName": "Kübler",
        "matchName": "L. Kübler",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "223886": {
      "optaId": "7joybllup4h9oe6zfhcepjy6t",
      "heimPlayer": {
        "id": "93638890",
        "team_id": "64",
        "person": {
          "id": "223886",
          "name": "Steven Berghuis",
          "firstname": "Steven",
          "surname": "Berghuis",
          "fullname": "Steven Berghuis",
          "gender": "male",
          "birthday": "19.12.1991",
          "height": "182",
          "weight": "75",
          "person_detail": {
            "id": "167026",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Apeldoorn",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "30.09.2025 20:19",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "7joybllup4h9oe6zfhcepjy6t",
        "firstName": "Steven",
        "lastName": "Berghuis",
        "shortFirstName": "Steven",
        "shortLastName": "Berghuis",
        "matchName": "S. Berghuis",
        "shirtNumber": 23,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "225834": {
      "optaId": "bvymw4wbcvzoafi5600i3lql1",
      "heimPlayer": {
        "id": "97648384",
        "team_id": "853",
        "person": {
          "id": "225834",
          "name": "Günay Güvenc",
          "firstname": "Günay",
          "surname": "Güvenc",
          "fullname": "Günay Güvenc",
          "gender": "male",
          "birthday": "25.06.1991",
          "height": "187",
          "weight": "84",
          "person_detail": {
            "id": "168723",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Neu-Ulm",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "09.12.2025 22:24",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "bvymw4wbcvzoafi5600i3lql1",
        "firstName": "Günay",
        "lastName": "Güvenç",
        "shortFirstName": "Günay",
        "shortLastName": "Güvenç",
        "matchName": "G. Güvenç",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Goalkeeper"
      }
    },
    "226802": {
      "optaId": "8nug6t1cmn9pwhnwdf6nyhrrp",
      "heimPlayer": {
        "id": "99932170",
        "team_id": "1639",
        "person": {
          "id": "226802",
          "name": "Anthony Jung",
          "firstname": "Anthony",
          "surname": "Jung",
          "fullname": "Anthony Jung",
          "gender": "male",
          "birthday": "03.11.1991",
          "height": "186",
          "weight": "83",
          "person_detail": {
            "id": "169613",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Villajoyosa",
            "died": "no"
          }
        },
        "created": "14.02.2026 16:47",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "8nug6t1cmn9pwhnwdf6nyhrrp",
        "firstName": "Anthony",
        "lastName": "Jung",
        "shortFirstName": "Anthony",
        "shortLastName": "Jung",
        "matchName": "A. Jung",
        "shirtNumber": 5,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "227900": {
      "optaId": "ujb2hkujcnwnyrbsgk3ilmtx",
      "heimPlayer": {
        "id": "100153897",
        "team_id": "1052",
        "person": {
          "id": "227900",
          "name": "Francesco Acerbi",
          "firstname": "Francesco",
          "surname": "Acerbi",
          "fullname": "Francesco Acerbi",
          "gender": "male",
          "birthday": "10.02.1988",
          "height": "192",
          "weight": "90",
          "person_detail": {
            "id": "170632",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Vizzolo Predabissi",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.02.2026 19:49",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "ujb2hkujcnwnyrbsgk3ilmtx",
        "firstName": "Francesco",
        "lastName": "Acerbi",
        "shortFirstName": "Francesco",
        "shortLastName": "Acerbi",
        "matchName": "F. Acerbi",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "229557": {
      "optaId": "ns0d3voludn8of98yc2e6ehh",
      "heimPlayer": {
        "id": "101079376",
        "team_id": "9",
        "person": {
          "id": "229557",
          "name": "Dominique Heintz",
          "firstname": "Dominique",
          "surname": "Heintz",
          "fullname": "Dominique Heintz",
          "gender": "male",
          "birthday": "15.08.1993",
          "height": "188",
          "weight": "89",
          "person_detail": {
            "id": "172133",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Neustadt an der Weinstraße",
            "died": "no"
          }
        },
        "created": "07.03.2026 20:18",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "ns0d3voludn8of98yc2e6ehh",
        "firstName": "Dominique",
        "lastName": "Heintz",
        "shortFirstName": "Dominique",
        "shortLastName": "Heintz",
        "matchName": "D. Heintz",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "229558": {
      "optaId": "eapihgte8ydc4g6hzygsx2e39",
      "heimPlayer": {
        "id": "101925500",
        "team_id": "29680",
        "person": {
          "id": "229558",
          "name": "Willi Orbán",
          "firstname": "Willi",
          "surname": "Orbán",
          "fullname": "Vilmos Tamás Orbán",
          "gender": "male",
          "birthday": "03.11.1992",
          "height": "186",
          "weight": "87",
          "person_detail": {
            "id": "172134",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Kaiserslautern",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "eapihgte8ydc4g6hzygsx2e39",
        "firstName": "Vilmos Tamás",
        "lastName": "Orbán",
        "shortFirstName": "Willi",
        "shortLastName": "Orbán",
        "matchName": "W. Orbán",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "229649": {
      "optaId": "7kjhx78gpi6m3r4j1b4jdyh91",
      "heimPlayer": {
        "id": "101362943",
        "team_id": "205",
        "person": {
          "id": "229649",
          "name": "Jonas Hofmann",
          "firstname": "Jonas",
          "surname": "Hofmann",
          "fullname": "Jonas Hofmann",
          "gender": "male",
          "birthday": "14.07.1992",
          "height": "176",
          "weight": "73",
          "person_detail": {
            "id": "172224",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Heidelberg",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "11.03.2026 20:24",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "7kjhx78gpi6m3r4j1b4jdyh91",
        "firstName": "Jonas",
        "lastName": "Hofmann",
        "shortFirstName": "Jonas",
        "shortLastName": "Hofmann",
        "matchName": "J. Hofmann",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "229714": {
      "optaId": "7lai6ovwsl01gonutejt4mms5",
      "heimPlayer": {
        "id": "100518817",
        "team_id": "258",
        "person": {
          "id": "229714",
          "name": "Emre Can",
          "firstname": "Emre",
          "surname": "Can",
          "fullname": "Emre Can",
          "gender": "male",
          "birthday": "12.01.1994",
          "height": "186",
          "weight": "86",
          "person_detail": {
            "id": "172287",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "7lai6ovwsl01gonutejt4mms5",
        "firstName": "Emre",
        "lastName": "Can",
        "shortFirstName": "Emre",
        "shortLastName": "Can",
        "matchName": "E. Can",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "229795": {
      "optaId": "b7ve7k983eaewnupejiow3jdh",
      "heimPlayer": {
        "id": "101655611",
        "team_id": "1639",
        "person": {
          "id": "229795",
          "name": "Christian Günter",
          "firstname": "Christian",
          "surname": "Günter",
          "fullname": "Christian Günter",
          "gender": "male",
          "birthday": "28.02.1993",
          "height": "184",
          "weight": "83",
          "person_detail": {
            "id": "172368",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Villingen-Schwenningen",
            "died": "no"
          }
        },
        "created": "15.03.2026 19:14",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "b7ve7k983eaewnupejiow3jdh",
        "firstName": "Christian",
        "lastName": "Günter",
        "shortFirstName": "Christian",
        "shortLastName": "Günter",
        "matchName": "C. Günter",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "229806": {
      "optaId": "84mp3eqt1ckw107hwxpby9cd1",
      "heimPlayer": {
        "id": "102117152",
        "team_id": "1639",
        "person": {
          "id": "229806",
          "name": "Matthias Ginter",
          "firstname": "Matthias",
          "surname": "Ginter",
          "fullname": "Matthias Lukas Ginter",
          "gender": "male",
          "birthday": "19.01.1994",
          "height": "190",
          "weight": "86",
          "person_detail": {
            "id": "172379",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Freiburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "84mp3eqt1ckw107hwxpby9cd1",
        "firstName": "Matthias Lukas",
        "lastName": "Ginter",
        "shortFirstName": "Matthias",
        "shortLastName": "Ginter",
        "matchName": "M. Ginter",
        "shirtNumber": 28,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "229849": {
      "optaId": "9j742o5vdc7d54x1xdz4t9ck5",
      "heimPlayer": {
        "id": "101311529",
        "team_id": "155",
        "person": {
          "id": "229849",
          "name": "Sead Kolašinac",
          "firstname": "Sead",
          "surname": "Kolašinac",
          "fullname": "Sead Kolašinac",
          "gender": "male",
          "birthday": "20.06.1993",
          "height": "183",
          "weight": "85",
          "person_detail": {
            "id": "172422",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Karlsruhe",
            "died": "no"
          },
          "country": [
            {
              "id": "31"
            }
          ]
        },
        "created": "10.03.2026 20:10",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "9j742o5vdc7d54x1xdz4t9ck5",
        "firstName": "Sead",
        "lastName": "Kolašinac",
        "shortFirstName": "Sead",
        "shortLastName": "Kolasinac",
        "matchName": "S. Kolašinac",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "229855": {
      "optaId": "f2o5hj0e2k3kw0fj1xzom0cet",
      "heimPlayer": {
        "id": "101976023",
        "team_id": "253",
        "person": {
          "id": "229855",
          "name": "Kevin Stöger",
          "firstname": "Kevin",
          "surname": "Stöger",
          "fullname": "Kevin Stöger",
          "gender": "male",
          "birthday": "27.08.1993",
          "height": "175",
          "weight": "74",
          "person_detail": {
            "id": "172428",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Steyr",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "f2o5hj0e2k3kw0fj1xzom0cet",
        "firstName": "Kevin",
        "lastName": "Stöger",
        "shortFirstName": "Kevin",
        "shortLastName": "Stöger",
        "matchName": "K. Stöger",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "229902": {
      "optaId": "5ilkkfbsss0bxd6ttdlqg0uz9",
      "heimPlayer": {
        "id": "101861366",
        "team_id": "1226",
        "person": {
          "id": "229902",
          "name": "Mohamed Salah",
          "firstname": "Mohamed",
          "surname": "Salah",
          "fullname": "Mohamed Salah Hamed Mahrous Ghaly",
          "gender": "male",
          "birthday": "15.06.1992",
          "height": "175",
          "weight": "73",
          "person_detail": {
            "id": "172475",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Nagrig, Basyoun",
            "died": "no"
          },
          "country": [
            {
              "id": "2"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "5ilkkfbsss0bxd6ttdlqg0uz9",
        "firstName": "Mohamed",
        "lastName": "Salah Hamed Mahrous Ghaly",
        "shortFirstName": "Mohamed",
        "shortLastName": "Salah Hamed Mahrous Ghaly",
        "knownName": "Mohamed Salah",
        "matchName": "Mohamed Salah",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "230225": {
      "optaId": "3kti58d195gmtzwrjh5nprx05",
      "heimPlayer": {
        "id": "99156187",
        "team_id": "1226",
        "person": {
          "id": "230225",
          "name": "Wataru Endō",
          "firstname": "Wataru",
          "surname": "Endō",
          "fullname": "Wataru Endō",
          "gender": "male",
          "birthday": "09.02.1993",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "172778",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Yokohama, Kanagawa",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "28.01.2026 21:04",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "3kti58d195gmtzwrjh5nprx05",
        "firstName": "Wataru",
        "lastName": "Endo",
        "shortFirstName": "Wataru",
        "shortLastName": "Endo",
        "matchName": "W. Endo",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "230342": {
      "optaId": "amd4rodp6senk2c1mmlsqozpx",
      "heimPlayer": {
        "id": "102100478",
        "team_id": "21",
        "person": {
          "id": "230342",
          "name": "Danny da Costa",
          "firstname": "Danny",
          "surname": "da Costa",
          "fullname": "Danny Vieira da Costa",
          "gender": "male",
          "birthday": "13.07.1993",
          "height": "187",
          "weight": "87",
          "person_detail": {
            "id": "172890",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Neuss",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "amd4rodp6senk2c1mmlsqozpx",
        "firstName": "Danny",
        "lastName": "Vieira da Costa",
        "shortFirstName": "Danny",
        "shortLastName": "da Costa",
        "matchName": "D. da Costa",
        "shirtNumber": 21,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "230399": {
      "optaId": "8b60vtt1stnmt2uoj0f4lh49h",
      "heimPlayer": {
        "id": "102006200",
        "team_id": "943",
        "person": {
          "id": "230399",
          "name": "Daniel Heuer Fernandes",
          "firstname": "Daniel",
          "surname": "Heuer Fernandes",
          "fullname": "Daniel Heuer Fernandes",
          "gender": "male",
          "birthday": "13.11.1992",
          "height": "188",
          "weight": "81",
          "person_detail": {
            "id": "172947",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bochum",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "8b60vtt1stnmt2uoj0f4lh49h",
        "firstName": "Daniel",
        "lastName": "Heuer Fernandes",
        "shortFirstName": "Daniel",
        "shortLastName": "Heuer Fernandes",
        "knownName": "Daniel Heuer Fernandes",
        "matchName": "Daniel Heuer Fernandes",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "230406": {
      "optaId": "6fzbp94hf19ysotdassrqdc5x",
      "heimPlayer": {
        "id": "101813048",
        "team_id": "1545",
        "person": {
          "id": "230406",
          "name": "Antonio Rüdiger",
          "firstname": "Antonio",
          "surname": "Rüdiger",
          "fullname": "Antonio Rüdiger",
          "gender": "male",
          "birthday": "03.03.1993",
          "height": "190",
          "weight": "85",
          "person_detail": {
            "id": "172954",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "6fzbp94hf19ysotdassrqdc5x",
        "firstName": "Antonio",
        "lastName": "Rüdiger",
        "shortFirstName": "Antonio",
        "shortLastName": "Rüdiger",
        "matchName": "A. Rüdiger",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "230732": {
      "optaId": "2yt9oajv9dkbju8tgy1g2nmqd",
      "heimPlayer": {
        "id": "99152536",
        "team_id": "162",
        "person": {
          "id": "230732",
          "name": "Jan Oblak",
          "firstname": "Jan",
          "surname": "Oblak",
          "fullname": "Jan Oblak",
          "gender": "male",
          "birthday": "07.01.1993",
          "height": "188",
          "weight": "87",
          "person_detail": {
            "id": "173220",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Škofja Loka",
            "died": "no"
          },
          "country": [
            {
              "id": "191"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "2yt9oajv9dkbju8tgy1g2nmqd",
        "firstName": "Jan",
        "lastName": "Oblak",
        "shortFirstName": "Jan",
        "shortLastName": "Oblak",
        "matchName": "J. Oblak",
        "shirtNumber": 13,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "231272": {
      "optaId": "26nfmfc8p2doisd9p8vtd33dh",
      "heimPlayer": {
        "id": "101973236",
        "team_id": "2134",
        "person": {
          "id": "231272",
          "name": "Leonardo Bittencourt",
          "firstname": "Leonardo",
          "surname": "Bittencourt",
          "fullname": "Leonardo Jesus Loureiro Bittencourt",
          "gender": "male",
          "birthday": "19.12.1993",
          "height": "171",
          "weight": "63",
          "person_detail": {
            "id": "173723",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Leipzig",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "26nfmfc8p2doisd9p8vtd33dh",
        "firstName": "Leonardo Jesus",
        "lastName": "Loureiro Bittencourt",
        "shortFirstName": "Leonardo",
        "shortLastName": "Bittencourt",
        "matchName": "L. Bittencourt",
        "shirtNumber": 10,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "231374": {
      "optaId": "d2ykrr75737c8bzlwhjj90vkl",
      "heimPlayer": {
        "id": "101529185",
        "team_id": "2086",
        "person": {
          "id": "231374",
          "name": "Yannick Gerhardt",
          "firstname": "Yannick",
          "surname": "Gerhardt",
          "fullname": "Yannick Gerhardt",
          "gender": "male",
          "birthday": "13.03.1994",
          "height": "184",
          "weight": "81",
          "person_detail": {
            "id": "173824",
            "position_1": "13",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Würselen",
            "died": "no"
          }
        },
        "extra_minute": "6",
        "created": "14.03.2026 17:26",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "d2ykrr75737c8bzlwhjj90vkl",
        "firstName": "Yannick",
        "lastName": "Gerhardt",
        "shortFirstName": "Yannick",
        "shortLastName": "Gerhardt",
        "matchName": "Y. Gerhardt",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "231410": {
      "optaId": "7km4xkzmx7pytxxzcu7ugm0np",
      "heimPlayer": {
        "id": "99159553",
        "team_id": "853",
        "person": {
          "id": "231410",
          "name": "Kaan Ayhan",
          "firstname": "Kaan",
          "surname": "Ayhan",
          "fullname": "Kaan Ayhan",
          "gender": "male",
          "birthday": "10.11.1994",
          "height": "185",
          "weight": "84",
          "person_detail": {
            "id": "173860",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Gelsenkirchen",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "28.01.2026 22:37",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "7km4xkzmx7pytxxzcu7ugm0np",
        "firstName": "Kaan",
        "lastName": "Ayhan",
        "shortFirstName": "Kaan",
        "shortLastName": "Ayhan",
        "matchName": "K. Ayhan",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "231484": {
      "optaId": "97u083i6ktyeu7xf6aqfotzp",
      "heimPlayer": {
        "id": "92295140",
        "team_id": "5",
        "person": {
          "id": "231484",
          "name": "Leart Paçarada",
          "firstname": "Leart",
          "surname": "Paçarada",
          "fullname": "Leart Shukri Paçarada",
          "gender": "male",
          "birthday": "08.10.1994",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "173934",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Aachen",
            "died": "no"
          }
        },
        "created": "13.09.2025 14:15",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "97u083i6ktyeu7xf6aqfotzp",
        "firstName": "Leart",
        "lastName": "Paçarada",
        "shortFirstName": "Leart",
        "shortLastName": "Paçarada",
        "matchName": "L. Paçarada",
        "shirtNumber": 32,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "231490": {
      "optaId": "d608s0948uh3owqee7t0en7px",
      "heimPlayer": {
        "id": "102100802",
        "team_id": "21",
        "person": {
          "id": "231490",
          "name": "Dominik Kohr",
          "firstname": "Dominik",
          "surname": "Kohr",
          "fullname": "Dominik Kohr",
          "gender": "male",
          "birthday": "31.01.1994",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "173940",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Trier",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:26",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "d608s0948uh3owqee7t0en7px",
        "firstName": "Dominik",
        "lastName": "Kohr",
        "shortFirstName": "Dominik",
        "shortLastName": "Kohr",
        "matchName": "D. Kohr",
        "shirtNumber": 31,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "231497": {
      "optaId": "apdrig6xt1hxub1986s3uh1x",
      "heimPlayer": {
        "id": "97767490",
        "team_id": "943",
        "person": {
          "id": "231497",
          "name": "Jonas Meffert",
          "firstname": "Jonas",
          "surname": "Meffert",
          "fullname": "Jonas Meffert",
          "gender": "male",
          "birthday": "04.09.1994",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "173947",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Köln",
            "died": "no"
          }
        },
        "created": "13.12.2025 14:33",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "apdrig6xt1hxub1986s3uh1x",
        "firstName": "Jonas",
        "lastName": "Meffert",
        "shortFirstName": "Jonas",
        "shortLastName": "Meffert",
        "matchName": "J. Meffert",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "231656": {
      "optaId": "4w4ldzomkj7fhrc51iimz8no5",
      "heimPlayer": {
        "id": "101862251",
        "team_id": "209",
        "person": {
          "id": "231656",
          "name": "Leon Goretzka",
          "firstname": "Leon",
          "surname": "Goretzka",
          "fullname": "Leon Christoph Goretzka",
          "gender": "male",
          "birthday": "06.02.1995",
          "height": "189",
          "weight": "82",
          "person_detail": {
            "id": "174106",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bochum",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "4w4ldzomkj7fhrc51iimz8no5",
        "firstName": "Leon Christoph",
        "lastName": "Goretzka",
        "shortFirstName": "Leon",
        "shortLastName": "Goretzka",
        "matchName": "L. Goretzka",
        "shirtNumber": 8,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "231979": {
      "optaId": "effmy99qczj7w9kb28u5y7mqd",
      "heimPlayer": {
        "id": "102116573",
        "team_id": "702",
        "person": {
          "id": "231979",
          "name": "Hauke Wahl",
          "firstname": "Hauke",
          "surname": "Wahl",
          "fullname": "Hauke Finn Wahl",
          "gender": "male",
          "birthday": "15.04.1994",
          "height": "189",
          "weight": "85",
          "person_detail": {
            "id": "174398",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:18",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "effmy99qczj7w9kb28u5y7mqd",
        "firstName": "Hauke Finn",
        "lastName": "Wahl",
        "shortFirstName": "Hauke",
        "shortLastName": "Wahl",
        "matchName": "H. Wahl",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "232662": {
      "optaId": "4tev0kk0om8cr1xbwpt8bozit",
      "heimPlayer": {
        "id": "101812523",
        "team_id": "205",
        "person": {
          "id": "232662",
          "name": "Robert Andrich",
          "firstname": "Robert",
          "surname": "Andrich",
          "fullname": "Robert Andrich",
          "gender": "male",
          "birthday": "22.09.1994",
          "height": "187",
          "weight": "85",
          "person_detail": {
            "id": "174974",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Potsdam",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "4tev0kk0om8cr1xbwpt8bozit",
        "firstName": "Robert",
        "lastName": "Andrich",
        "shortFirstName": "Robert",
        "shortLastName": "Andrich",
        "matchName": "R. Andrich",
        "shirtNumber": 8,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "232676": {
      "optaId": "botfgp0oq4wqlwtcs9m90kded",
      "heimPlayer": {
        "id": "97640842",
        "team_id": "1052",
        "person": {
          "id": "232676",
          "name": "Hakan Çalhanoğlu",
          "firstname": "Hakan",
          "surname": "Çalhanoğlu",
          "fullname": "Hakan Çalhanoğlu",
          "gender": "male",
          "birthday": "08.02.1994",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "174988",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Mannheim",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "09.12.2025 19:49",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "botfgp0oq4wqlwtcs9m90kded",
        "firstName": "Hakan",
        "lastName": "Çalhanoğlu",
        "shortFirstName": "Hakan",
        "shortLastName": "Çalhanoglu",
        "matchName": "H. Çalhanoğlu",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "11"
      }
    },
    "233062": {
      "optaId": "acxwc7xxrtyssiy390t859kgl",
      "heimPlayer": {
        "id": "102001952",
        "team_id": "2086",
        "person": {
          "id": "233062",
          "name": "Maximilian Arnold",
          "firstname": "Maximilian",
          "surname": "Arnold",
          "fullname": "Maximilian Arnold",
          "gender": "male",
          "birthday": "27.05.1994",
          "height": "184",
          "weight": "74",
          "person_detail": {
            "id": "175291",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Riesa",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:07",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "acxwc7xxrtyssiy390t859kgl",
        "firstName": "Maximilian",
        "lastName": "Arnold",
        "shortFirstName": "Maximilian",
        "shortLastName": "Arnold",
        "matchName": "M. Arnold",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "233079": {
      "optaId": "98glpci54ztzmd3yn1kttlvpx",
      "heimPlayer": {
        "id": "101972414",
        "team_id": "5",
        "person": {
          "id": "233079",
          "name": "Marnon Busch",
          "firstname": "Marnon",
          "surname": "Busch",
          "fullname": "Marnon-Thomas Busch",
          "gender": "male",
          "birthday": "08.12.1994",
          "height": "182",
          "weight": "80",
          "person_detail": {
            "id": "175308",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Stade",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "98glpci54ztzmd3yn1kttlvpx",
        "firstName": "Marnon-Thomas",
        "lastName": "Busch",
        "shortFirstName": "Marnon",
        "shortLastName": "Busch",
        "matchName": "M. Busch",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "233151": {
      "optaId": "2p48525x4ap9m81g6ode51cyd",
      "heimPlayer": {
        "id": "101973224",
        "team_id": "2134",
        "person": {
          "id": "233151",
          "name": "Niklas Stark",
          "firstname": "Niklas",
          "surname": "Stark",
          "fullname": "Niklas Stark",
          "gender": "male",
          "birthday": "14.04.1995",
          "height": "190",
          "weight": "88",
          "person_detail": {
            "id": "175376",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Neustadt an der Aisch",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "2p48525x4ap9m81g6ode51cyd",
        "firstName": "Niklas",
        "lastName": "Stark",
        "shortFirstName": "Niklas",
        "shortLastName": "Stark",
        "matchName": "N. Stark",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "233382": {
      "optaId": "ci1nu5z8aiiikco8af0zk1lud",
      "heimPlayer": {
        "id": "96586333",
        "team_id": "21",
        "person": {
          "id": "233382",
          "name": "Robin Zentner",
          "firstname": "Robin",
          "surname": "Zentner",
          "fullname": "Robin Zentner",
          "gender": "male",
          "birthday": "28.10.1994",
          "height": "194",
          "weight": "96",
          "person_detail": {
            "id": "175585",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Rüdesheim",
            "died": "no"
          }
        },
        "created": "21.11.2025 19:20",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "ci1nu5z8aiiikco8af0zk1lud",
        "firstName": "Robin",
        "lastName": "Zentner",
        "shortFirstName": "Robin",
        "shortLastName": "Zentner",
        "matchName": "R. Zentner",
        "shirtNumber": 27,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "233619": {
      "optaId": "4zfgh6wq7svx418tzwf0gfavp",
      "heimPlayer": {
        "id": "101975930",
        "team_id": "9",
        "person": {
          "id": "233619",
          "name": "Marvin Schwäbe",
          "firstname": "Marvin",
          "surname": "Schwäbe",
          "fullname": "Marvin Schwäbe",
          "gender": "male",
          "birthday": "25.04.1995",
          "height": "190",
          "weight": "86",
          "person_detail": {
            "id": "175811",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Dieburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "4zfgh6wq7svx418tzwf0gfavp",
        "firstName": "Marvin",
        "lastName": "Schwäbe",
        "shortFirstName": "Marvin",
        "shortLastName": "Schwäbe",
        "matchName": "M. Schwäbe",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1",
        "captain": "yes"
      }
    },
    "234049": {
      "optaId": "58qeglyxdi7y8ttg8sddv8set",
      "heimPlayer": {
        "id": "98854033",
        "team_id": "1421",
        "person": {
          "id": "234049",
          "name": "Geoffrey Kondogbia",
          "firstname": "Geoffrey",
          "surname": "Kondogbia",
          "fullname": "Geoffrey Edwin Kondogbia",
          "gender": "male",
          "birthday": "15.02.1993",
          "height": "188",
          "weight": "80",
          "person_detail": {
            "id": "176193",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Nemours",
            "died": "no"
          },
          "country": [
            {
              "id": "238"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "58qeglyxdi7y8ttg8sddv8set",
        "firstName": "Geoffrey Edwin",
        "lastName": "Kondogbia",
        "shortFirstName": "Geoffrey",
        "shortLastName": "Kondogbia",
        "matchName": "G. Kondogbia",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "234080": {
      "optaId": "6yhylu5q0y924amgv7vlodkgl",
      "heimPlayer": {
        "id": "99643993",
        "team_id": "24",
        "person": {
          "id": "234080",
          "name": "Kevin Akpoguma",
          "firstname": "Kevin",
          "surname": "Akpoguma",
          "fullname": "Kevin John Ufuoma Akpoguma",
          "gender": "male",
          "birthday": "19.04.1995",
          "height": "192",
          "weight": "85",
          "person_detail": {
            "id": "176213",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Neustadt an der Weinstraße",
            "died": "no"
          }
        },
        "created": "08.02.2026 16:26",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "6yhylu5q0y924amgv7vlodkgl",
        "firstName": "Kevin John",
        "lastName": "Ufuoma Akpoguma",
        "shortFirstName": "Kevin",
        "shortLastName": "Akpoguma",
        "matchName": "K. Akpoguma",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "234281": {
      "optaId": "97nv3y9z2ajz6b4ynoo0jn3kl",
      "heimPlayer": {
        "id": "101310143",
        "team_id": "209",
        "person": {
          "id": "234281",
          "name": "Joshua Kimmich",
          "firstname": "Joshua",
          "surname": "Kimmich",
          "fullname": "Joshua Walter Kimmich",
          "gender": "male",
          "birthday": "08.02.1995",
          "height": "177",
          "weight": "75",
          "person_detail": {
            "id": "176403",
            "position_1": "7",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Rottweil",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "10.03.2026 19:57",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "97nv3y9z2ajz6b4ynoo0jn3kl",
        "firstName": "Joshua Walter",
        "lastName": "Kimmich",
        "shortFirstName": "Joshua",
        "shortLastName": "Kimmich",
        "matchName": "J. Kimmich",
        "shirtNumber": 6,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "234282": {
      "optaId": "7c8ms7bw3fva4xeubax4ep8et",
      "heimPlayer": {
        "id": "102100460",
        "team_id": "21",
        "person": {
          "id": "234282",
          "name": "Phillipp Mwene",
          "firstname": "Phillipp",
          "surname": "Mwene",
          "fullname": "Phillipp Mwene",
          "gender": "male",
          "birthday": "29.01.1994",
          "height": "170",
          "weight": "66",
          "person_detail": {
            "id": "176404",
            "position_1": "3",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Wien",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "7c8ms7bw3fva4xeubax4ep8et",
        "firstName": "Phillipp",
        "lastName": "Mwene",
        "shortFirstName": "Phillipp",
        "shortLastName": "Mwene",
        "matchName": "P. Mwene",
        "shirtNumber": 2,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "234287": {
      "optaId": "4ysxvym6ww4f9d3hflkqsbf11",
      "heimPlayer": {
        "id": "101868182",
        "team_id": "209",
        "person": {
          "id": "234287",
          "name": "Serge Gnabry",
          "firstname": "Serge",
          "surname": "Gnabry",
          "fullname": "Serge David Gnabry",
          "gender": "male",
          "birthday": "14.07.1995",
          "height": "176",
          "weight": "77",
          "person_detail": {
            "id": "176409",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Stuttgart",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 22:31",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "4ysxvym6ww4f9d3hflkqsbf11",
        "firstName": "Serge David",
        "lastName": "Gnabry",
        "shortFirstName": "Serge",
        "shortLastName": "Gnabry",
        "matchName": "S. Gnabry",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "234295": {
      "optaId": "1vv29mash2uijx542ssjk666t",
      "heimPlayer": {
        "id": "101976560",
        "team_id": "19",
        "person": {
          "id": "234295",
          "name": "Rani Khedira",
          "firstname": "Rani",
          "surname": "Khedira",
          "fullname": "Rani Khedira",
          "gender": "male",
          "birthday": "27.01.1994",
          "height": "189",
          "weight": "88",
          "person_detail": {
            "id": "176417",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Stuttgart",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "1vv29mash2uijx542ssjk666t",
        "firstName": "Rani",
        "lastName": "Khedira",
        "shortFirstName": "Rani",
        "shortLastName": "Khedira",
        "matchName": "R. Khedira",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "234396": {
      "optaId": "ehopba709zukxj4vgcync942d",
      "heimPlayer": {
        "id": "94854913",
        "team_id": "1267",
        "person": {
          "id": "234396",
          "name": "Mateo Kovačić",
          "firstname": "Mateo",
          "surname": "Kovačić",
          "fullname": "Mateo Kovačić",
          "gender": "male",
          "birthday": "06.05.1994",
          "height": "177",
          "weight": "75",
          "person_detail": {
            "id": "176489",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Linz",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "21.10.2025 22:14",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "ehopba709zukxj4vgcync942d",
        "firstName": "Mateo",
        "lastName": "Kovačić",
        "shortFirstName": "Mateo",
        "shortLastName": "Kovacic",
        "matchName": "M. Kovačić",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "236781": {
      "optaId": "b9g4qurpll4wizajo95c406hh",
      "heimPlayer": {
        "id": "101862263",
        "team_id": "209",
        "person": {
          "id": "236781",
          "name": "Harry Kane",
          "firstname": "Harry",
          "surname": "Kane",
          "fullname": "Harry Edward Kane",
          "gender": "male",
          "birthday": "28.07.1993",
          "height": "188",
          "weight": "86",
          "person_detail": {
            "id": "178271",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Walthamstow, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "b9g4qurpll4wizajo95c406hh",
        "firstName": "Harry Edward",
        "lastName": "Kane",
        "shortFirstName": "Harry",
        "shortLastName": "Kane",
        "matchName": "H. Kane",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9",
        "captain": "yes"
      }
    },
    "238788": {
      "optaId": "az7wa6km1zhvsb8y4mndlogyd",
      "heimPlayer": {
        "id": "98830243",
        "team_id": "136",
        "person": {
          "id": "238788",
          "name": "Eric Dier",
          "firstname": "Eric",
          "surname": "Dier",
          "fullname": "Eric Jeremy Edgar Dier",
          "gender": "male",
          "birthday": "15.01.1994",
          "height": "191",
          "weight": "91",
          "person_detail": {
            "id": "179254",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Cheltenham",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "20.01.2026 20:01",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "az7wa6km1zhvsb8y4mndlogyd",
        "firstName": "Eric Jeremy Edgar",
        "lastName": "Dier",
        "shortFirstName": "Eric",
        "shortLastName": "Dier",
        "matchName": "E. Dier",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "239213": {
      "optaId": "drkx7msmzruq5myxk9ani6z11",
      "heimPlayer": {
        "id": "101868374",
        "team_id": "853",
        "person": {
          "id": "239213",
          "name": "Mauro Icardi",
          "firstname": "Mauro",
          "surname": "Icardi",
          "fullname": "Mauro Emanuel Icardi Riveiro",
          "gender": "male",
          "birthday": "19.02.1993",
          "height": "181",
          "weight": "75",
          "person_detail": {
            "id": "179514",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Rosario",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "18.03.2026 22:40",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "drkx7msmzruq5myxk9ani6z11",
        "firstName": "Mauro Emanuel",
        "lastName": "Icardi Rivero",
        "shortFirstName": "Mauro",
        "shortLastName": "Icardi",
        "matchName": "M. Icardi",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "239680": {
      "optaId": "tedxo29s8xx0a71z6sidw7v9",
      "heimPlayer": {
        "id": "96094876",
        "team_id": "594",
        "person": {
          "id": "239680",
          "name": "Jeffrey Gouweleeuw",
          "firstname": "Jeffrey",
          "surname": "Gouweleeuw",
          "fullname": "Jeffrey Gouweleeuw",
          "gender": "male",
          "birthday": "10.07.1991",
          "height": "188",
          "weight": "83",
          "person_detail": {
            "id": "179656",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Heemskerk",
            "died": "no"
          }
        },
        "created": "09.11.2025 18:54",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "tedxo29s8xx0a71z6sidw7v9",
        "firstName": "Jeffrey",
        "lastName": "Gouweleeuw",
        "shortFirstName": "Jeffrey",
        "shortLastName": "Gouweleeuw",
        "matchName": "J. Gouweleeuw",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "240809": {
      "optaId": "oel537m4mtjwwnyusz6efj6d",
      "heimPlayer": {
        "id": "96927598",
        "team_id": "530",
        "person": {
          "id": "240809",
          "name": "Michy Batshuayi",
          "firstname": "Michy",
          "surname": "Batshuayi",
          "fullname": "Michy Batshuayi Atunga",
          "gender": "male",
          "birthday": "02.10.1993",
          "height": "185",
          "weight": "76",
          "person_detail": {
            "id": "180246",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bruxelles",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "26.11.2025 22:27",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "oel537m4mtjwwnyusz6efj6d",
        "firstName": "Michy",
        "lastName": "Batshuayi-Atunga",
        "shortFirstName": "Michy",
        "shortLastName": "Batshuayi",
        "matchName": "M. Batshuayi",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "242414": {
      "optaId": "d3ikbsb9xrytwlf4ls34cvqol",
      "heimPlayer": {
        "id": "100633264",
        "team_id": "702",
        "person": {
          "id": "242414",
          "name": "Karol Mets",
          "firstname": "Karol",
          "surname": "Mets",
          "fullname": "Karol Mets",
          "gender": "male",
          "birthday": "16.05.1993",
          "height": "191",
          "weight": "79",
          "person_detail": {
            "id": "181402",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Viljandi",
            "died": "no"
          }
        },
        "created": "28.02.2026 14:28",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "d3ikbsb9xrytwlf4ls34cvqol",
        "firstName": "Karol",
        "lastName": "Mets",
        "shortFirstName": "Karol",
        "shortLastName": "Mets",
        "matchName": "K. Mets",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "244396": {
      "optaId": "11iaca5nfeqabdba4646vje1h",
      "heimPlayer": {
        "id": "96892195",
        "team_id": "749",
        "person": {
          "id": "244396",
          "name": "Brede Moe",
          "firstname": "Brede",
          "surname": "Moe",
          "fullname": "Brede Mathias Moe",
          "gender": "male",
          "birthday": "15.12.1991",
          "height": "184",
          "weight": "80",
          "person_detail": {
            "id": "182864",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Flatanger",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "25.11.2025 22:19",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "11iaca5nfeqabdba4646vje1h",
        "firstName": "Brede Mathias",
        "lastName": "Moe",
        "shortFirstName": "Brede",
        "shortLastName": "Moe",
        "matchName": "B. Moe",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "249523": {
      "optaId": "3gem1jrrkgye0omb88fk1lsk5",
      "heimPlayer": {
        "id": "96883765",
        "team_id": "1267",
        "person": {
          "id": "249523",
          "name": "John Stones",
          "firstname": "John",
          "surname": "Stones",
          "fullname": "John Stones",
          "gender": "male",
          "birthday": "28.05.1994",
          "height": "188",
          "weight": "70",
          "person_detail": {
            "id": "187452",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Barnsley",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "25.11.2025 19:53",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "3gem1jrrkgye0omb88fk1lsk5",
        "firstName": "John",
        "lastName": "Stones",
        "shortFirstName": "John",
        "shortLastName": "Stones",
        "matchName": "J. Stones",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "253221": {
      "optaId": "8z0395s37qe2lqi9qsvyskgk5",
      "heimPlayer": {
        "id": "101812424",
        "team_id": "1457",
        "person": {
          "id": "253221",
          "name": "Marquinhos",
          "firstname": "",
          "surname": "Marquinhos",
          "fullname": "Marcos Aoás Corrêa",
          "gender": "male",
          "birthday": "14.05.1994",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "190169",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "8z0395s37qe2lqi9qsvyskgk5",
        "firstName": "Marcos",
        "lastName": "Aoás Corrêa",
        "shortFirstName": "Marcos",
        "shortLastName": "Aoás Corrêa",
        "knownName": "Marquinhos",
        "matchName": "Marquinhos",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "253321": {
      "optaId": "4zxrdmwphkxvkvo6bt30uanrp",
      "heimPlayer": {
        "id": "98854036",
        "team_id": "1421",
        "person": {
          "id": "253321",
          "name": "Pierre-Emile Højbjerg",
          "firstname": "Pierre-Emile",
          "surname": "Højbjerg",
          "fullname": "Pierre-Emile Kordt Højbjerg",
          "gender": "male",
          "birthday": "05.08.1995",
          "height": "185",
          "weight": "81",
          "person_detail": {
            "id": "190271",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "København",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "4zxrdmwphkxvkvo6bt30uanrp",
        "firstName": "Pierre-Emile Kordt",
        "lastName": "Højbjerg",
        "shortFirstName": "Pierre-Emile",
        "shortLastName": "Højbjerg",
        "matchName": "P. Højbjerg",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "253324": {
      "optaId": "8l0am8k4pg2s9g9qbkhwte6dx",
      "heimPlayer": {
        "id": "101053900",
        "team_id": "943",
        "person": {
          "id": "253324",
          "name": "Yussuf Poulsen",
          "firstname": "Yussuf",
          "surname": "Poulsen",
          "fullname": "Yussuf Yurary Poulsen",
          "gender": "male",
          "birthday": "15.06.1994",
          "height": "192",
          "weight": "84",
          "person_detail": {
            "id": "190274",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "København",
            "died": "no"
          }
        },
        "created": "07.03.2026 16:59",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "8l0am8k4pg2s9g9qbkhwte6dx",
        "firstName": "Yussuf Yurary",
        "lastName": "Poulsen",
        "shortFirstName": "Yussuf",
        "shortLastName": "Poulsen",
        "matchName": "Y. Poulsen",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "253477": {
      "optaId": "7fmpgkx58o9pivo2bbnxxkt05",
      "heimPlayer": {
        "id": "94903447",
        "team_id": "156",
        "person": {
          "id": "253477",
          "name": "Aymeric Laporte",
          "firstname": "Aymeric",
          "surname": "Laporte",
          "fullname": "Aymeric Jean Louis Gerard Alphonse Laporte",
          "gender": "male",
          "birthday": "27.05.1994",
          "height": "190",
          "weight": "87",
          "person_detail": {
            "id": "190427",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Agen",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "22.10.2025 18:47",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "7fmpgkx58o9pivo2bbnxxkt05",
        "firstName": "Aymeric Jean Louis Gérard Alphonse",
        "lastName": "Laporte",
        "shortFirstName": "Aymeric",
        "shortLastName": "Laporte",
        "matchName": "Aymeric Laporte",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "253515": {
      "optaId": "7jn9kl5wq29d41ekc2fz2rs2d",
      "heimPlayer": {
        "id": "101820986",
        "team_id": "1267",
        "person": {
          "id": "253515",
          "name": "Nathan Aké",
          "firstname": "Nathan",
          "surname": "Aké",
          "fullname": "Nathan Benjamin Aké",
          "gender": "male",
          "birthday": "18.02.1995",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "190465",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Den Haag",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "17.03.2026 22:04",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "7jn9kl5wq29d41ekc2fz2rs2d",
        "firstName": "Nathan Benjamin",
        "lastName": "Aké",
        "shortFirstName": "Nathan",
        "shortLastName": "Aké",
        "matchName": "N. Aké",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "253617": {
      "optaId": "csvqjyuk06gzvjm408513nydx",
      "heimPlayer": {
        "id": "97641781",
        "team_id": "136",
        "person": {
          "id": "253617",
          "name": "Takumi Minamino",
          "firstname": "Takumi",
          "surname": "Minamino",
          "fullname": "Takumi Minamino",
          "gender": "male",
          "birthday": "16.01.1995",
          "height": "174",
          "weight": "68",
          "person_detail": {
            "id": "190567",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Izumisano, Osaka",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "09.12.2025 19:54",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "csvqjyuk06gzvjm408513nydx",
        "firstName": "Takumi",
        "lastName": "Minamino",
        "shortFirstName": "Takumi",
        "shortLastName": "Minamino",
        "matchName": "T. Minamino",
        "shirtNumber": 18,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "254772": {
      "optaId": "8l1mv5qd9vwade754v3l8epjp",
      "heimPlayer": {
        "id": "101976551",
        "team_id": "19",
        "person": {
          "id": "254772",
          "name": "Frederik Rønnow",
          "firstname": "Frederik",
          "surname": "Rønnow",
          "fullname": "Frederik Riis Rønnow",
          "gender": "male",
          "birthday": "04.08.1992",
          "height": "188",
          "weight": "81",
          "person_detail": {
            "id": "191651",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Horsens",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "8l1mv5qd9vwade754v3l8epjp",
        "firstName": "Frederik",
        "lastName": "Riis Rønnow",
        "shortFirstName": "Frederik",
        "shortLastName": "Rønnow",
        "matchName": "F. Rønnow",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "255594": {
      "optaId": "7oykphzczagr975xsqt70s89h",
      "heimPlayer": {
        "id": "101824055",
        "team_id": "1545",
        "person": {
          "id": "255594",
          "name": "Dani Carvajal",
          "firstname": "",
          "surname": "Dani Carvajal",
          "fullname": "Daniel Carvajal Ramos",
          "gender": "male",
          "birthday": "11.01.1992",
          "height": "173",
          "weight": "74",
          "person_detail": {
            "id": "192342",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Leganés",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 22:43",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "7oykphzczagr975xsqt70s89h",
        "firstName": "Daniel",
        "lastName": "Carvajal Ramos",
        "shortFirstName": "Dani",
        "shortLastName": "Carvajal",
        "matchName": "Dani Carvajal",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "255723": {
      "optaId": "555z9bynvux7oruirg67r8i51",
      "heimPlayer": {
        "id": "100528849",
        "team_id": "1094",
        "person": {
          "id": "255723",
          "name": "Filip Kostić",
          "firstname": "Filip",
          "surname": "Kostić",
          "fullname": "Filip Kostić",
          "gender": "male",
          "birthday": "01.11.1992",
          "height": "184",
          "weight": "81",
          "person_detail": {
            "id": "192440",
            "position_1": "6",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Kragujevac",
            "died": "no"
          },
          "country": [
            {
              "id": "185"
            }
          ]
        },
        "created": "25.02.2026 23:24",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "555z9bynvux7oruirg67r8i51",
        "firstName": "Filip",
        "lastName": "Kostić",
        "shortFirstName": "Filip",
        "shortLastName": "Kostic",
        "matchName": "F. Kostić",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "256265": {
      "optaId": "4baqlwfu312pctopy1cx6s2c5",
      "heimPlayer": {
        "id": "102100484",
        "team_id": "21",
        "person": {
          "id": "256265",
          "name": "Silvan Widmer",
          "firstname": "Silvan",
          "surname": "Widmer",
          "fullname": "Silvan Dominic Widmer",
          "gender": "male",
          "birthday": "05.03.1993",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "192904",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Aarau",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "4baqlwfu312pctopy1cx6s2c5",
        "firstName": "Silvan Dominic",
        "lastName": "Widmer",
        "shortFirstName": "Silvan",
        "shortLastName": "Widmer",
        "matchName": "S. Widmer",
        "shirtNumber": 30,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2",
        "captain": "yes"
      }
    },
    "259105": {
      "optaId": "920yurg08gqayxwc80q9f8ixh",
      "heimPlayer": {
        "id": "97687135",
        "team_id": "205",
        "person": {
          "id": "259105",
          "name": "Mark Flekken",
          "firstname": "Mark",
          "surname": "Flekken",
          "fullname": "Mark Flekken",
          "gender": "male",
          "birthday": "13.06.1993",
          "height": "195",
          "weight": "87",
          "person_detail": {
            "id": "195312",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Bocholtz",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "10.12.2025 19:58",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "920yurg08gqayxwc80q9f8ixh",
        "firstName": "Mark",
        "lastName": "Flekken",
        "shortFirstName": "Mark",
        "shortLastName": "Flekken",
        "matchName": "M. Flekken",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "259142": {
      "optaId": "9s9i1a7hdq5bud8ma2dqi295h",
      "heimPlayer": {
        "id": "100150267",
        "team_id": "1355",
        "person": {
          "id": "259142",
          "name": "Nick Pope",
          "firstname": "Nick",
          "surname": "Pope",
          "fullname": "Nicholas David Pope",
          "gender": "male",
          "birthday": "19.04.1992",
          "height": "198",
          "weight": "78",
          "person_detail": {
            "id": "195347",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Soham",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.02.2026 17:38",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "9s9i1a7hdq5bud8ma2dqi295h",
        "firstName": "Nicholas David",
        "lastName": "Pope",
        "shortFirstName": "Nick",
        "shortLastName": "Pope",
        "matchName": "N. Pope",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "259299": {
      "optaId": "4vy3j1o829f561jf4fqum7ob9",
      "heimPlayer": {
        "id": "93676207",
        "team_id": "258",
        "person": {
          "id": "259299",
          "name": "Niklas Süle",
          "firstname": "Niklas",
          "surname": "Süle",
          "fullname": "Niklas Süle",
          "gender": "male",
          "birthday": "03.09.1995",
          "height": "195",
          "weight": "99",
          "person_detail": {
            "id": "195490",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "01.10.2025 19:55",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "4vy3j1o829f561jf4fqum7ob9",
        "firstName": "Niklas",
        "lastName": "Süle",
        "shortFirstName": "Niklas",
        "shortLastName": "Süle",
        "matchName": "N. Süle",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "259336": {
      "optaId": "2az0f39bhz2kvxhopalzi0h5h",
      "heimPlayer": {
        "id": "102117161",
        "team_id": "1639",
        "person": {
          "id": "259336",
          "name": "Vincenzo Grifo",
          "firstname": "Vincenzo",
          "surname": "Grifo",
          "fullname": "Vincenzo Grifo",
          "gender": "male",
          "birthday": "07.04.1993",
          "height": "180",
          "weight": "80",
          "person_detail": {
            "id": "195527",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Pforzheim",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "2az0f39bhz2kvxhopalzi0h5h",
        "firstName": "Vincenzo",
        "lastName": "Grifo",
        "shortFirstName": "Vincenzo",
        "shortLastName": "Grifo",
        "matchName": "V. Grifo",
        "shirtNumber": 32,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11",
        "captain": "yes"
      }
    },
    "259965": {
      "optaId": "24vavcwn4hco5je9kdu9ciwgl",
      "heimPlayer": {
        "id": "101976569",
        "team_id": "19",
        "person": {
          "id": "259965",
          "name": "Janik Haberer",
          "firstname": "Janik",
          "surname": "Haberer",
          "fullname": "Janik Haberer",
          "gender": "male",
          "birthday": "02.04.1994",
          "height": "186",
          "weight": "78",
          "person_detail": {
            "id": "196114",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Wangen im Allgäu",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "24vavcwn4hco5je9kdu9ciwgl",
        "firstName": "Janik",
        "lastName": "Haberer",
        "shortFirstName": "Janik",
        "shortLastName": "Haberer",
        "matchName": "J. Haberer",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "259967": {
      "optaId": "e7if3ma2jblaurrokcxadk0k5",
      "heimPlayer": {
        "id": "100211872",
        "team_id": "943",
        "person": {
          "id": "259967",
          "name": "Robert Glatzel",
          "firstname": "Robert",
          "surname": "Glatzel",
          "fullname": "Robert-Nesta Glatzel",
          "gender": "male",
          "birthday": "08.01.1994",
          "height": "193",
          "weight": "85",
          "person_detail": {
            "id": "196116",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "München",
            "died": "no"
          }
        },
        "created": "20.02.2026 19:58",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "e7if3ma2jblaurrokcxadk0k5",
        "firstName": "Robert-Nesta",
        "lastName": "Glatzel",
        "shortFirstName": "Robert",
        "shortLastName": "Glatzel",
        "matchName": "R. Glatzel",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "260377": {
      "optaId": "2idy9ngk2rojseoxxw9n98c7p",
      "heimPlayer": {
        "id": "101317460",
        "team_id": "155",
        "person": {
          "id": "260377",
          "name": "Berat Djimsiti",
          "firstname": "Berat",
          "surname": "Djimsiti",
          "fullname": "Berat Ridvan Djimsiti",
          "gender": "male",
          "birthday": "19.02.1993",
          "height": "191",
          "weight": "83",
          "person_detail": {
            "id": "196526",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Zürich",
            "died": "no"
          },
          "country": [
            {
              "id": "3"
            }
          ]
        },
        "created": "10.03.2026 22:02",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "2idy9ngk2rojseoxxw9n98c7p",
        "firstName": "Berat",
        "lastName": "Djimsiti",
        "shortFirstName": "Berat",
        "shortLastName": "Djimsiti",
        "matchName": "B. Djimsiti",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "262027": {
      "optaId": "2nqhczrkd45rdu5fcmq1wjo45",
      "heimPlayer": {
        "id": "97648672",
        "team_id": "530",
        "person": {
          "id": "262027",
          "name": "Mahmoud Dahoud",
          "firstname": "Mahmoud",
          "surname": "Dahoud",
          "fullname": "Mahmoud Dahoud",
          "gender": "male",
          "birthday": "01.01.1996",
          "height": "178",
          "weight": "68",
          "person_detail": {
            "id": "197701",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Amûdê‎",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "09.12.2025 22:31",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "2nqhczrkd45rdu5fcmq1wjo45",
        "firstName": "Mahmoud",
        "lastName": "Dahoud",
        "shortFirstName": "Mahmoud",
        "shortLastName": "Dahoud",
        "knownName": "Mahmoud Dahoud",
        "matchName": "Mahmoud Dahoud",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "262049": {
      "optaId": "ckjid5lfgbx8tdyoi32vbwn9x",
      "heimPlayer": {
        "id": "102004310",
        "team_id": "253",
        "person": {
          "id": "262049",
          "name": "Marvin Friedrich",
          "firstname": "Marvin",
          "surname": "Friedrich",
          "fullname": "Marvin Friedrich",
          "gender": "male",
          "birthday": "13.12.1995",
          "height": "193",
          "weight": "84",
          "person_detail": {
            "id": "197723",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Kassel",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:17",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "ckjid5lfgbx8tdyoi32vbwn9x",
        "firstName": "Marvin",
        "lastName": "Friedrich",
        "shortFirstName": "Marvin",
        "shortLastName": "Friedrich",
        "matchName": "M. Friedrich",
        "shirtNumber": 5,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "262055": {
      "optaId": "4603xrdk721lqhd1ejn62x5n9",
      "heimPlayer": {
        "id": "101867648",
        "team_id": "853",
        "person": {
          "id": "262055",
          "name": "Leroy Sané",
          "firstname": "Leroy",
          "surname": "Sané",
          "fullname": "Leroy Aziz Sané",
          "gender": "male",
          "birthday": "11.01.1996",
          "height": "183",
          "weight": "80",
          "person_detail": {
            "id": "197729",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Essen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 22:04",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "4603xrdk721lqhd1ejn62x5n9",
        "firstName": "Leroy Aziz",
        "lastName": "Sané",
        "shortFirstName": "Leroy",
        "shortLastName": "Sané",
        "matchName": "L. Sané",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "262601": {
      "optaId": "12f4mz064elnxecq2srl7r6j9",
      "heimPlayer": {
        "id": "101812529",
        "team_id": "205",
        "person": {
          "id": "262601",
          "name": "Álex Grimaldo",
          "firstname": "",
          "surname": "Álex Grimaldo",
          "fullname": "Alejandro Grimaldo García",
          "gender": "male",
          "birthday": "20.09.1995",
          "height": "171",
          "weight": "69",
          "person_detail": {
            "id": "198096",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Valencia",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "12f4mz064elnxecq2srl7r6j9",
        "firstName": "Alejandro",
        "lastName": "Grimaldo García",
        "shortFirstName": "Alejandro",
        "shortLastName": "Grimaldo",
        "matchName": "Alejandro Grimaldo",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "262708": {
      "optaId": "a69r2pf2w8da4dl0zl4k5vil1",
      "heimPlayer": {
        "id": "101311547",
        "team_id": "155",
        "person": {
          "id": "262708",
          "name": "Davide Zappacosta",
          "firstname": "Davide",
          "surname": "Zappacosta",
          "fullname": "Davide Zappacosta",
          "gender": "male",
          "birthday": "11.06.1992",
          "height": "182",
          "weight": "70",
          "person_detail": {
            "id": "198202",
            "position_1": "9",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Sora",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "10.03.2026 20:10",
        "shirtnumber": "77"
      },
      "optaPlayer": {
        "playerId": "a69r2pf2w8da4dl0zl4k5vil1",
        "firstName": "Davide",
        "lastName": "Zappacosta",
        "shortFirstName": "Davide",
        "shortLastName": "Zappacosta",
        "matchName": "D. Zappacosta",
        "shirtNumber": 77,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "262786": {
      "optaId": "5irixhhyayq9yl7sb2kohjrv9",
      "heimPlayer": {
        "id": "101524385",
        "team_id": "594",
        "person": {
          "id": "262786",
          "name": "Marius Wolf",
          "firstname": "Marius",
          "surname": "Wolf",
          "fullname": "Marius Wolf",
          "gender": "male",
          "birthday": "27.05.1995",
          "height": "188",
          "weight": "81",
          "person_detail": {
            "id": "198280",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Coburg",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:07",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "5irixhhyayq9yl7sb2kohjrv9",
        "firstName": "Marius",
        "lastName": "Wolf",
        "shortFirstName": "Marius",
        "shortLastName": "Wolf",
        "matchName": "M. Wolf",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "263056": {
      "optaId": "adwfwvdij6onaszluqocifahh",
      "heimPlayer": {
        "id": "101861117",
        "team_id": "853",
        "person": {
          "id": "263056",
          "name": "Abdülkerim Bardakçı",
          "firstname": "Abdülkerim",
          "surname": "Bardakçı",
          "fullname": "Abdülkerim Bardakçı",
          "gender": "male",
          "birthday": "07.09.1994",
          "height": "185",
          "weight": "81",
          "person_detail": {
            "id": "198541",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Konya",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "adwfwvdij6onaszluqocifahh",
        "firstName": "Abdülkerim",
        "lastName": "Bardakcı",
        "shortFirstName": "Abdülkerim",
        "shortLastName": "Bardakci",
        "matchName": "A. Bardakcı",
        "shirtNumber": 42,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "263391": {
      "optaId": "aopmwx748flafzpj58w2afwlx",
      "heimPlayer": {
        "id": "97000984",
        "team_id": "253",
        "person": {
          "id": "263391",
          "name": "Tim Kleindienst",
          "firstname": "Tim",
          "surname": "Kleindienst",
          "fullname": "Tim Kleindienst",
          "gender": "male",
          "birthday": "31.08.1995",
          "height": "194",
          "weight": "85",
          "person_detail": {
            "id": "198836",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Jüterbog",
            "died": "no"
          }
        },
        "created": "28.11.2025 22:17",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "aopmwx748flafzpj58w2afwlx",
        "firstName": "Tim",
        "lastName": "Kleindienst",
        "shortFirstName": "Tim",
        "shortLastName": "Kleindienst",
        "matchName": "T. Kleindienst",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "263530": {
      "optaId": "8ju1opnca42o8i00wq3onzmqd",
      "heimPlayer": {
        "id": "101822600",
        "team_id": "127",
        "person": {
          "id": "263530",
          "name": "Christian Nørgaard",
          "firstname": "Christian",
          "surname": "Nørgaard",
          "fullname": "Christian Thers Nørgaard",
          "gender": "male",
          "birthday": "10.03.1994",
          "height": "187",
          "weight": "77",
          "person_detail": {
            "id": "198968",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "København",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "17.03.2026 22:24",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "8ju1opnca42o8i00wq3onzmqd",
        "firstName": "Christian",
        "lastName": "Thers Barsøe Nørgaard",
        "shortFirstName": "Christian",
        "shortLastName": "Nørgaard",
        "matchName": "C. Nørgaard",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "263545": {
      "optaId": "55ashhvkh23ypnct70f9dgvkl",
      "heimPlayer": {
        "id": "101815415",
        "team_id": "749",
        "person": {
          "id": "263545",
          "name": "Ulrik Saltnes",
          "firstname": "Ulrik",
          "surname": "Saltnes",
          "fullname": "Ulrik Saltnes",
          "gender": "male",
          "birthday": "10.11.1992",
          "height": "187",
          "weight": "78",
          "person_detail": {
            "id": "198983",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Brønnøysund",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 20:22",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "55ashhvkh23ypnct70f9dgvkl",
        "firstName": "Ulrik",
        "lastName": "Saltnes",
        "shortFirstName": "Ulrik",
        "shortLastName": "Saltnes",
        "matchName": "U. Saltnes",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "263584": {
      "optaId": "5ec2ede9uwbft3wby33mwowyd",
      "heimPlayer": {
        "id": "101862239",
        "team_id": "209",
        "person": {
          "id": "263584",
          "name": "Jonathan Tah",
          "firstname": "Jonathan",
          "surname": "Tah",
          "fullname": "Jonathan Glao Tah",
          "gender": "male",
          "birthday": "11.02.1996",
          "height": "195",
          "weight": "94",
          "person_detail": {
            "id": "199016",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "5ec2ede9uwbft3wby33mwowyd",
        "firstName": "Jonathan Glao",
        "lastName": "Tah",
        "shortFirstName": "Jonathan",
        "shortLastName": "Tah",
        "matchName": "J. Tah",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "263614": {
      "optaId": "3uqn1adw8rarez1gpen9vng7p",
      "heimPlayer": {
        "id": "100518814",
        "team_id": "258",
        "person": {
          "id": "263614",
          "name": "Waldemar Anton",
          "firstname": "Waldemar",
          "surname": "Anton",
          "fullname": "Waldemar Anton",
          "gender": "male",
          "birthday": "20.07.1996",
          "height": "189",
          "weight": "86",
          "person_detail": {
            "id": "199047",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Olmaliq",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "3uqn1adw8rarez1gpen9vng7p",
        "firstName": "Waldemar",
        "lastName": "Riptsov Anton",
        "shortFirstName": "Waldemar",
        "shortLastName": "Anton",
        "matchName": "W. Anton",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "263670": {
      "optaId": "d3xdl3p9vd1c0m316oq2pblxx",
      "heimPlayer": {
        "id": "102134963",
        "team_id": "2076",
        "person": {
          "id": "263670",
          "name": "Alexander Nübel",
          "firstname": "Alexander",
          "surname": "Nübel",
          "fullname": "Alexander Nübel",
          "gender": "male",
          "birthday": "30.09.1996",
          "height": "193",
          "weight": "86",
          "person_detail": {
            "id": "199102",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Paderborn",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "d3xdl3p9vd1c0m316oq2pblxx",
        "firstName": "Alexander",
        "lastName": "Nübel",
        "shortFirstName": "Alexander",
        "shortLastName": "Nübel",
        "matchName": "A. Nübel",
        "shirtNumber": 33,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "263715": {
      "optaId": "3es8fg7y59lckypu11i68q6s5",
      "heimPlayer": {
        "id": "102001610",
        "team_id": "9",
        "person": {
          "id": "263715",
          "name": "Luca Waldschmidt",
          "firstname": "Luca",
          "surname": "Waldschmidt",
          "fullname": "Gian-Luca Waldschmidt",
          "gender": "male",
          "birthday": "19.05.1996",
          "height": "181",
          "weight": "74",
          "person_detail": {
            "id": "199147",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Siegen",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:06",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "3es8fg7y59lckypu11i68q6s5",
        "firstName": "Gian-Luca",
        "lastName": "Waldschmidt",
        "shortFirstName": "Luca",
        "shortLastName": "Waldschmidt",
        "matchName": "L. Waldschmidt",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "263720": {
      "optaId": "7llxni56g8q0yt33vhp1pt3o5",
      "heimPlayer": {
        "id": "97641688",
        "team_id": "530",
        "person": {
          "id": "263720",
          "name": "Michael Zetterer",
          "firstname": "Michael",
          "surname": "Zetterer",
          "fullname": "Michael Zetterer",
          "gender": "male",
          "birthday": "12.07.1995",
          "height": "187",
          "weight": "79",
          "person_detail": {
            "id": "199152",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "München",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "09.12.2025 19:53",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "7llxni56g8q0yt33vhp1pt3o5",
        "firstName": "Michael",
        "lastName": "Zetterer",
        "shortFirstName": "Michael",
        "shortLastName": "Zetterer",
        "matchName": "M. Zetterer",
        "shirtNumber": 23,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "263750": {
      "optaId": "5dcemmjwbguvnz7sz0m8uomad",
      "heimPlayer": {
        "id": "101995145",
        "team_id": "5",
        "person": {
          "id": "263750",
          "name": "Jonas Föhrenbach",
          "firstname": "Jonas",
          "surname": "Föhrenbach",
          "fullname": "Jonas Föhrenbach",
          "gender": "male",
          "birthday": "26.01.1996",
          "height": "184",
          "weight": "81",
          "person_detail": {
            "id": "199182",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Freiburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:33",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "5dcemmjwbguvnz7sz0m8uomad",
        "firstName": "Jonas",
        "lastName": "Föhrenbach",
        "shortFirstName": "Jonas",
        "shortLastName": "Föhrenbach",
        "matchName": "J. Föhrenbach",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "263930": {
      "optaId": "2pjr6yz65f4uqvwniy4vphn85",
      "heimPlayer": {
        "id": "98059702",
        "team_id": "29680",
        "person": {
          "id": "263930",
          "name": "Timo Werner",
          "firstname": "Timo",
          "surname": "Werner",
          "fullname": "Timo Werner",
          "gender": "male",
          "birthday": "06.03.1996",
          "height": "180",
          "weight": "76",
          "person_detail": {
            "id": "199336",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Stuttgart",
            "died": "no"
          }
        },
        "created": "20.12.2025 20:06",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "2pjr6yz65f4uqvwniy4vphn85",
        "firstName": "Timo",
        "lastName": "Werner",
        "shortFirstName": "Timo",
        "shortLastName": "Werner",
        "matchName": "T. Werner",
        "shirtNumber": 36,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "264078": {
      "optaId": "f4qcgzveslklfi8601tep77x1",
      "heimPlayer": {
        "id": "100518832",
        "team_id": "258",
        "person": {
          "id": "264078",
          "name": "Julian Brandt",
          "firstname": "Julian",
          "surname": "Brandt",
          "fullname": "Julian Brandt",
          "gender": "male",
          "birthday": "02.05.1996",
          "height": "185",
          "weight": "83",
          "person_detail": {
            "id": "199481",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Bremen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "f4qcgzveslklfi8601tep77x1",
        "firstName": "Julian",
        "lastName": "Brandt",
        "shortFirstName": "Julian",
        "shortLastName": "Brandt",
        "matchName": "J. Brandt",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "264096": {
      "optaId": "7gzdg0j9usc3yq0dd1ad57sgl",
      "heimPlayer": {
        "id": "97130050",
        "team_id": "2076",
        "person": {
          "id": "264096",
          "name": "Pascal Stenzel",
          "firstname": "Pascal",
          "surname": "Stenzel",
          "fullname": "Pascal Stenzel",
          "gender": "male",
          "birthday": "20.03.1996",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "199499",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Bünde",
            "died": "no"
          }
        },
        "created": "30.11.2025 14:35",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "7gzdg0j9usc3yq0dd1ad57sgl",
        "firstName": "Pascal",
        "lastName": "Stenzel",
        "shortFirstName": "Pascal",
        "shortLastName": "Stenzel",
        "matchName": "P. Stenzel",
        "shirtNumber": 15,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "264235": {
      "optaId": "1lgrnaje6y7un5dzzll84p91",
      "heimPlayer": {
        "id": "98854018",
        "team_id": "1421",
        "person": {
          "id": "264235",
          "name": "Gerónimo Rulli",
          "firstname": "Gerónimo",
          "surname": "Rulli",
          "fullname": "Gerónimo Rulli",
          "gender": "male",
          "birthday": "20.05.1992",
          "height": "189",
          "weight": "84",
          "person_detail": {
            "id": "199613",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "La Plata, Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "1lgrnaje6y7un5dzzll84p91",
        "firstName": "Gerónimo",
        "lastName": "Rulli",
        "shortFirstName": "Gerónimo",
        "shortLastName": "Rulli",
        "matchName": "G. Rulli",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "264597": {
      "optaId": "7ubtan6a51o79w469zawrqqqd",
      "heimPlayer": {
        "id": "99154837",
        "team_id": "156",
        "person": {
          "id": "264597",
          "name": "Ruiz de Galarreta",
          "firstname": "",
          "surname": "Ruiz de Galarreta",
          "fullname": "Iñigo Ruiz de Galarreta Etxeberria",
          "gender": "male",
          "birthday": "06.08.1993",
          "height": "175",
          "weight": "69",
          "person_detail": {
            "id": "199825",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "San Sebastián",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "7ubtan6a51o79w469zawrqqqd",
        "firstName": "Íñigo",
        "lastName": "Ruíz de Galarreta Etxeberria",
        "shortFirstName": "Íñigo",
        "shortLastName": "Ruíz de Galarreta",
        "matchName": "Íñigo Ruíz de Galarreta",
        "shirtNumber": 16,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "267392": {
      "optaId": "baakmd4ndnulbl9npvmq90mvp",
      "heimPlayer": {
        "id": "99152263",
        "team_id": "64",
        "person": {
          "id": "267392",
          "name": "Davy Klaassen",
          "firstname": "Davy",
          "surname": "Klaassen",
          "fullname": "Davy Klaassen",
          "gender": "male",
          "birthday": "21.02.1993",
          "height": "179",
          "weight": "70",
          "person_detail": {
            "id": "202612",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Hilversum",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "baakmd4ndnulbl9npvmq90mvp",
        "firstName": "Davy",
        "lastName": "Klaassen",
        "shortFirstName": "Davy",
        "shortLastName": "Klaassen",
        "matchName": "D. Klaassen",
        "shirtNumber": 18,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10",
        "captain": "yes"
      }
    },
    "267479": {
      "optaId": "dpcws493fepch23sk26m1a8yd",
      "heimPlayer": {
        "id": "100492453",
        "team_id": "1052",
        "person": {
          "id": "267479",
          "name": "Piotr Zieliński",
          "firstname": "Piotr",
          "surname": "Zieliński",
          "fullname": "Piotr Sebastian Zieliński",
          "gender": "male",
          "birthday": "20.05.1994",
          "height": "180",
          "weight": "76",
          "person_detail": {
            "id": "202699",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Ząbkowice Śląskie",
            "died": "no"
          },
          "country": [
            {
              "id": "166"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "dpcws493fepch23sk26m1a8yd",
        "firstName": "Piotr Sebastian",
        "lastName": "Zieliński",
        "shortFirstName": "Piotr",
        "shortLastName": "Zielinski",
        "matchName": "P. Zieliński",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "11"
      }
    },
    "267794": {
      "optaId": "b0qvtgy82m0or7vw2brgmpsyd",
      "heimPlayer": {
        "id": "98856856",
        "team_id": "1736",
        "person": {
          "id": "267794",
          "name": "Ivan Schranz",
          "firstname": "Ivan",
          "surname": "Schranz",
          "fullname": "Ivan Schranz",
          "gender": "male",
          "birthday": "13.09.1993",
          "height": "185",
          "weight": "73",
          "person_detail": {
            "id": "202944",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Bratislava",
            "died": "no"
          },
          "country": [
            {
              "id": "190"
            }
          ]
        },
        "created": "21.01.2026 22:26",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "b0qvtgy82m0or7vw2brgmpsyd",
        "firstName": "Ivan",
        "lastName": "Schranz",
        "shortFirstName": "Ivan",
        "shortLastName": "Schranz",
        "matchName": "I. Schranz",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "268467": {
      "optaId": "2biwwlvzgsu5kmyw5w1adpmtx",
      "heimPlayer": {
        "id": "98835673",
        "team_id": "2102",
        "person": {
          "id": "268467",
          "name": "Gerard Moreno",
          "firstname": "",
          "surname": "Gerard Moreno",
          "fullname": "Gerard Moreno Balagueró",
          "gender": "male",
          "birthday": "07.04.1992",
          "height": "180",
          "weight": "77",
          "person_detail": {
            "id": "203633",
            "position_1": "11",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Santa Perpètua de Mogoda",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 22:29",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "2biwwlvzgsu5kmyw5w1adpmtx",
        "firstName": "Gerard",
        "lastName": "Moreno Balagueró",
        "shortFirstName": "Gerard",
        "shortLastName": "Moreno",
        "matchName": "Gerard Moreno",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "271167": {
      "optaId": "6j3wbk9xlq4om4m8ih6b3tyvp",
      "heimPlayer": {
        "id": "99154564",
        "team_id": "127",
        "person": {
          "id": "271167",
          "name": "Kepa",
          "firstname": "",
          "surname": "Kepa",
          "fullname": "Kepa Arrizabalaga Revuelta",
          "gender": "male",
          "birthday": "03.10.1994",
          "height": "188",
          "weight": "85",
          "person_detail": {
            "id": "205441",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ondárroa",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "6j3wbk9xlq4om4m8ih6b3tyvp",
        "firstName": "Kepa",
        "lastName": "Arrizabalaga Revuelta",
        "shortFirstName": "Kepa",
        "shortLastName": "Arrizabalaga",
        "matchName": "Kepa Arrizabalaga",
        "shirtNumber": 13,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "273274": {
      "optaId": "8qezzr83ofw7htqufohg2fwlx",
      "heimPlayer": {
        "id": "96884308",
        "team_id": "1421",
        "person": {
          "id": "273274",
          "name": "Emerson",
          "firstname": "",
          "surname": "Emerson",
          "fullname": "Emerson Palmieri dos Santos",
          "gender": "male",
          "birthday": "03.08.1994",
          "height": "176",
          "weight": "79",
          "person_detail": {
            "id": "207222",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Santos",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "25.11.2025 20:00",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "8qezzr83ofw7htqufohg2fwlx",
        "firstName": "Emerson",
        "lastName": "Palmieri dos Santos",
        "shortFirstName": "Emerson",
        "shortLastName": "Palmieri dos Santos",
        "knownName": "Emerson",
        "matchName": "Emerson",
        "shirtNumber": 33,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "274163": {
      "optaId": "897kbab7cx7bnhxhaghpy3f11",
      "heimPlayer": {
        "id": "98853469",
        "team_id": "1736",
        "person": {
          "id": "274163",
          "name": "Tomáš Holeš",
          "firstname": "Tomáš",
          "surname": "Holeš",
          "fullname": "Tomáš Holeš",
          "gender": "male",
          "birthday": "31.03.1993",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "208022",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Hradec Králové",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "21.01.2026 19:52",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "897kbab7cx7bnhxhaghpy3f11",
        "firstName": "Tomáš",
        "lastName": "Holeš",
        "shortFirstName": "Tomás",
        "shortLastName": "Holes",
        "matchName": "T. Holeš",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2",
        "captain": "yes"
      }
    },
    "277577": {
      "optaId": "4dh4ws8ehn6uywozt6ygczs2d",
      "heimPlayer": {
        "id": "100521622",
        "team_id": "1731",
        "person": {
          "id": "277577",
          "name": "Fredrik Aursnes",
          "firstname": "Fredrik",
          "surname": "Aursnes",
          "fullname": "Fredrik Aursnes",
          "gender": "male",
          "birthday": "10.12.1995",
          "height": "181",
          "weight": "71",
          "person_detail": {
            "id": "211293",
            "position_1": "13",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Hareid",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "4dh4ws8ehn6uywozt6ygczs2d",
        "firstName": "Fredrik",
        "lastName": "Aursnes",
        "shortFirstName": "Fredrik",
        "shortLastName": "Aursnes",
        "matchName": "F. Aursnes",
        "shirtNumber": 8,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "278821": {
      "optaId": "3gsprcdyogabeb8lr2y0bmytx",
      "heimPlayer": {
        "id": "93637519",
        "team_id": "162",
        "person": {
          "id": "278821",
          "name": "Clément Lenglet",
          "firstname": "Clément",
          "surname": "Lenglet",
          "fullname": "Clément Nicolas Laurent Lenglet",
          "gender": "male",
          "birthday": "17.06.1995",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "212495",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Beauvais",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "30.09.2025 19:49",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "3gsprcdyogabeb8lr2y0bmytx",
        "firstName": "Clément Nicolas Laurent",
        "lastName": "Lenglet",
        "shortFirstName": "Clément",
        "shortLastName": "Lenglet",
        "matchName": "C. Lenglet",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "279262": {
      "optaId": "8qwpdf5jof7o6yy47v6iv11hx",
      "heimPlayer": {
        "id": "101812808",
        "team_id": "127",
        "person": {
          "id": "279262",
          "name": "Leandro Trossard",
          "firstname": "Leandro",
          "surname": "Trossard",
          "fullname": "Leandro Trossard",
          "gender": "male",
          "birthday": "04.12.1994",
          "height": "172",
          "weight": "61",
          "person_detail": {
            "id": "212927",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Waterschei",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "8qwpdf5jof7o6yy47v6iv11hx",
        "firstName": "Leandro",
        "lastName": "Trossard",
        "shortFirstName": "Leandro",
        "shortLastName": "Trossard",
        "matchName": "L. Trossard",
        "shirtNumber": 19,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "279830": {
      "optaId": "a07r604q1pzwqxqh6ci2euggl",
      "heimPlayer": {
        "id": "100493314",
        "team_id": "18670",
        "person": {
          "id": "279830",
          "name": "Marko Janković",
          "firstname": "Marko",
          "surname": "Janković",
          "fullname": "Marko Janković",
          "gender": "male",
          "birthday": "09.07.1995",
          "height": "172",
          "weight": "67",
          "person_detail": {
            "id": "213429",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Cetinje",
            "died": "no"
          },
          "country": [
            {
              "id": "137"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "a07r604q1pzwqxqh6ci2euggl",
        "firstName": "Marko",
        "lastName": "Janković",
        "shortFirstName": "Marko",
        "shortLastName": "Jankovic",
        "matchName": "M. Janković",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "279932": {
      "optaId": "29pq64smaxdwlraopnxoleqxh",
      "heimPlayer": {
        "id": "101855573",
        "team_id": "597",
        "person": {
          "id": "279932",
          "name": "João Cancelo",
          "firstname": "",
          "surname": "João Cancelo",
          "fullname": "João Pedro Cavaco Cancelo",
          "gender": "male",
          "birthday": "27.05.1994",
          "height": "182",
          "weight": "72",
          "person_detail": {
            "id": "213532",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Barreiro",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "29pq64smaxdwlraopnxoleqxh",
        "firstName": "João Pedro",
        "lastName": "Cavaco Cancelo",
        "shortFirstName": "João Pedro",
        "shortLastName": "Cavaco Cancelo",
        "knownName": "João Cancelo",
        "matchName": "João Cancelo",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "282936": {
      "optaId": "7drgir9lcwfst8vxz07jboe6t",
      "heimPlayer": {
        "id": "96923662",
        "team_id": "162",
        "person": {
          "id": "282936",
          "name": "Juan Musso",
          "firstname": "Juan",
          "surname": "Musso",
          "fullname": "Juan Agustín Musso",
          "gender": "male",
          "birthday": "06.05.1994",
          "height": "191",
          "weight": "93",
          "person_detail": {
            "id": "216130",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "San Nicolás de los Arroyos",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "26.11.2025 20:05",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "7drgir9lcwfst8vxz07jboe6t",
        "firstName": "Juan Agustín",
        "lastName": "Musso",
        "shortFirstName": "Juan",
        "shortLastName": "Musso",
        "matchName": "J. Musso",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "285208": {
      "optaId": "6ie5meimavc8kwohr6lrdyket",
      "heimPlayer": {
        "id": "101862257",
        "team_id": "209",
        "person": {
          "id": "285208",
          "name": "Raphaël Guerreiro",
          "firstname": "Raphaël",
          "surname": "Guerreiro",
          "fullname": "Raphaël Adelino José Guerreiro",
          "gender": "male",
          "birthday": "22.12.1993",
          "height": "170",
          "weight": "71",
          "person_detail": {
            "id": "217229",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Le Blanc-Mesnil",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "6ie5meimavc8kwohr6lrdyket",
        "firstName": "Raphaël Adelino José",
        "lastName": "Guerreiro",
        "shortFirstName": "Raphaël Adelino José",
        "shortLastName": "Guerreiro",
        "knownName": "Raphaël Guerreiro",
        "matchName": "Raphaël Guerreiro",
        "shirtNumber": 22,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "290289": {
      "optaId": "16rhwnvicrl1e9xqw867zuxn9",
      "heimPlayer": {
        "id": "101817323",
        "team_id": "749",
        "person": {
          "id": "290289",
          "name": "Haitam Aleesami",
          "firstname": "Haitam",
          "surname": "Aleesami",
          "fullname": "Haitam Aleesami",
          "gender": "male",
          "birthday": "31.07.1991",
          "height": "183",
          "weight": "79",
          "person_detail": {
            "id": "218410",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Oslo",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 21:03",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "16rhwnvicrl1e9xqw867zuxn9",
        "firstName": "Haitam",
        "lastName": "Aleesami",
        "shortFirstName": "Haitam",
        "shortLastName": "Aleesami",
        "matchName": "H. Aleesami",
        "shirtNumber": 5,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "290399": {
      "optaId": "9heh3f6hvyp4sgbu0ft4xfh05",
      "heimPlayer": {
        "id": "101972423",
        "team_id": "5",
        "person": {
          "id": "290399",
          "name": "Patrick Mainka",
          "firstname": "Patrick",
          "surname": "Mainka",
          "fullname": "Patrick Mainka",
          "gender": "male",
          "birthday": "06.11.1994",
          "height": "194",
          "weight": "86",
          "person_detail": {
            "id": "218517",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Gütersloh",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "9heh3f6hvyp4sgbu0ft4xfh05",
        "firstName": "Patrick",
        "lastName": "Mainka",
        "shortFirstName": "Patrick",
        "shortLastName": "Mainka",
        "matchName": "P. Mainka",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "290989": {
      "optaId": "57btqxe5sy3ygzxpp55p4umdx",
      "heimPlayer": {
        "id": "99159673",
        "team_id": "64",
        "person": {
          "id": "290989",
          "name": "Wout Weghorst",
          "firstname": "Wout",
          "surname": "Weghorst",
          "fullname": "Wout François Maria Weghorst",
          "gender": "male",
          "birthday": "07.08.1992",
          "height": "197",
          "weight": "84",
          "person_detail": {
            "id": "219086",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Borne",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 22:38",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "57btqxe5sy3ygzxpp55p4umdx",
        "firstName": "Wout François Maria",
        "lastName": "Weghorst",
        "shortFirstName": "Wout",
        "shortLastName": "Weghorst",
        "matchName": "W. Weghorst",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "291093": {
      "optaId": "57c808184l80uuuv7z3flcu6t",
      "heimPlayer": {
        "id": "101925830",
        "team_id": "24",
        "person": {
          "id": "291093",
          "name": "Grischa Prömel",
          "firstname": "Grischa",
          "surname": "Prömel",
          "fullname": "Grischa Prömel",
          "gender": "male",
          "birthday": "09.01.1995",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "219187",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Stuttgart",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "57c808184l80uuuv7z3flcu6t",
        "firstName": "Grischa",
        "lastName": "Prömel",
        "shortFirstName": "Grischa",
        "shortLastName": "Prömel",
        "matchName": "G. Prömel",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "291411": {
      "optaId": "aw10uq1kb2kgr79s8zbipts5x",
      "heimPlayer": {
        "id": "101440820",
        "team_id": "702",
        "person": {
          "id": "291411",
          "name": "Adam Dźwigała",
          "firstname": "Adam",
          "surname": "Dźwigała",
          "fullname": "Adam Dźwigała",
          "gender": "male",
          "birthday": "25.09.1995",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "219507",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Warszawa",
            "died": "no"
          }
        },
        "created": "13.03.2026 19:21",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "aw10uq1kb2kgr79s8zbipts5x",
        "firstName": "Adam",
        "lastName": "Dźwigała",
        "shortFirstName": "Adam",
        "shortLastName": "Dzwigala",
        "matchName": "A. Dźwigała",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "291435": {
      "optaId": "bkbmygo5f1glcs6xssawl26z9",
      "heimPlayer": {
        "id": "101524574",
        "team_id": "24",
        "person": {
          "id": "291435",
          "name": "Ihlas Bebou",
          "firstname": "Ihlas",
          "surname": "Bebou",
          "fullname": "Ihlas Bebou",
          "gender": "male",
          "birthday": "23.04.1994",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "219531",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Aledjo Kadara",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:08",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bkbmygo5f1glcs6xssawl26z9",
        "firstName": "Ihlas",
        "lastName": "Bebou",
        "shortFirstName": "Ihlas",
        "shortLastName": "Bebou",
        "matchName": "I. Bebou",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "291835": {
      "optaId": "s96k2x2cts0vo6y6aaeui5zp",
      "heimPlayer": {
        "id": "101804534",
        "team_id": "1776",
        "person": {
          "id": "291835",
          "name": "Rui Silva",
          "firstname": "",
          "surname": "Rui Silva",
          "fullname": "Rui Tiago Dantas da Silva",
          "gender": "male",
          "birthday": "07.02.1994",
          "height": "191",
          "weight": "91",
          "person_detail": {
            "id": "219905",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Maia",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "s96k2x2cts0vo6y6aaeui5zp",
        "firstName": "Rui Tiago",
        "lastName": "Dantas da Silva",
        "shortFirstName": "Rui Tiago",
        "shortLastName": "Dantas da Silva",
        "knownName": "Rui Silva",
        "matchName": "Rui Silva",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "292187": {
      "optaId": "bf2pf3hs8gcvub4ivlve12ymt",
      "heimPlayer": {
        "id": "100491679",
        "team_id": "205",
        "person": {
          "id": "292187",
          "name": "Lucas Vázquez",
          "firstname": "",
          "surname": "Lucas Vázquez",
          "fullname": "Lucas Vázquez Iglesias",
          "gender": "male",
          "birthday": "01.07.1991",
          "height": "173",
          "weight": "71",
          "person_detail": {
            "id": "220264",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Curtis (A Coruña)",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "24.02.2026 19:50",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "bf2pf3hs8gcvub4ivlve12ymt",
        "firstName": "Lucas",
        "lastName": "Vázquez Iglesias",
        "shortFirstName": "Lucas",
        "shortLastName": "Vázquez",
        "matchName": "Lucas Vázquez",
        "shirtNumber": 21,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "293134": {
      "optaId": "3ww5879aay1xf2a20nl9ihwid",
      "heimPlayer": {
        "id": "101862293",
        "team_id": "155",
        "person": {
          "id": "293134",
          "name": "Marco Sportiello",
          "firstname": "Marco",
          "surname": "Sportiello",
          "fullname": "Marco Sportiello",
          "gender": "male",
          "birthday": "10.05.1992",
          "height": "192",
          "weight": "87",
          "person_detail": {
            "id": "221208",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Desio",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "57"
      },
      "optaPlayer": {
        "playerId": "3ww5879aay1xf2a20nl9ihwid",
        "firstName": "Marco",
        "lastName": "Sportiello",
        "shortFirstName": "Marco",
        "shortLastName": "Sportiello",
        "matchName": "M. Sportiello",
        "shirtNumber": 57,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "293646": {
      "optaId": "37ao6cj3w5pd5v5ap79fqlxw5",
      "heimPlayer": {
        "id": "100521619",
        "team_id": "1731",
        "person": {
          "id": "293646",
          "name": "Rafa Silva",
          "firstname": "",
          "surname": "Rafa Silva",
          "fullname": "Rafael Alexandre Fernandes Ferreira Da Silva",
          "gender": "male",
          "birthday": "17.05.1993",
          "height": "172",
          "weight": "62",
          "person_detail": {
            "id": "221689",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Forte da Casa",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "37ao6cj3w5pd5v5ap79fqlxw5",
        "firstName": "Rafael Alexandre",
        "lastName": "Fernandes Ferreira da Silva",
        "shortFirstName": "Rafael Alexandre",
        "shortLastName": "Fernandes Ferreira da Silva",
        "knownName": "Rafa",
        "matchName": "Rafa",
        "shirtNumber": 27,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "294407": {
      "optaId": "24vsicnsc44o2mr9jk0qjvb2t",
      "heimPlayer": {
        "id": "101976029",
        "team_id": "253",
        "person": {
          "id": "294407",
          "name": "Haris Tabakovic",
          "firstname": "Haris",
          "surname": "Tabakovic",
          "fullname": "Haris Tabakovic",
          "gender": "male",
          "birthday": "20.06.1994",
          "height": "194",
          "weight": "90",
          "person_detail": {
            "id": "222450",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Grenchen",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "24vsicnsc44o2mr9jk0qjvb2t",
        "firstName": "Haris",
        "lastName": "Tabaković",
        "shortFirstName": "Haris",
        "shortLastName": "Tabakovic",
        "matchName": "H. Tabaković",
        "shirtNumber": 15,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "295669": {
      "optaId": "fs5utga62tud5s06xj27qdat",
      "heimPlayer": {
        "id": "102006221",
        "team_id": "943",
        "person": {
          "id": "295669",
          "name": "Jordan Torunarigha",
          "firstname": "Jordan",
          "surname": "Torunarigha",
          "fullname": "Jordan Torunarigha",
          "gender": "male",
          "birthday": "07.08.1997",
          "height": "191",
          "weight": "80",
          "person_detail": {
            "id": "223672",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Chemnitz",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "fs5utga62tud5s06xj27qdat",
        "firstName": "Jordan",
        "lastName": "Torunarigha",
        "shortFirstName": "Jordan",
        "shortLastName": "Torunarigha",
        "matchName": "J. Torunarigha",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "295870": {
      "optaId": "3tdsezcgdlm4laybvh4u49cr9",
      "heimPlayer": {
        "id": "95051917",
        "team_id": "9",
        "person": {
          "id": "295870",
          "name": "Timo Hübers",
          "firstname": "Timo",
          "surname": "Hübers",
          "fullname": "Timo Bernd Hübers",
          "gender": "male",
          "birthday": "20.07.1996",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "223870",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Hildesheim",
            "died": "no"
          }
        },
        "created": "25.10.2025 17:25",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "3tdsezcgdlm4laybvh4u49cr9",
        "firstName": "Timo Bernd",
        "lastName": "Hübers",
        "shortFirstName": "Timo",
        "shortLastName": "Hübers",
        "matchName": "T. Hübers",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "295922": {
      "optaId": "f5ln82l8q7gvouj3zhsp5t4gl",
      "heimPlayer": {
        "id": "102117143",
        "team_id": "1639",
        "person": {
          "id": "295922",
          "name": "Maximilian Eggestein",
          "firstname": "Maximilian",
          "surname": "Eggestein",
          "fullname": "Maximilian Eggestein",
          "gender": "male",
          "birthday": "08.12.1996",
          "height": "181",
          "weight": "77",
          "person_detail": {
            "id": "223907",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Hannover",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "f5ln82l8q7gvouj3zhsp5t4gl",
        "firstName": "Maximilian",
        "lastName": "Eggestein",
        "shortFirstName": "Maximilian",
        "shortLastName": "Eggestein",
        "matchName": "M. Eggestein",
        "shirtNumber": 8,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "297145": {
      "optaId": "7w63iqek6hmnizlirurla1cr9",
      "heimPlayer": {
        "id": "100211752",
        "team_id": "21",
        "person": {
          "id": "297145",
          "name": "Nadiem Amiri",
          "firstname": "Nadiem",
          "surname": "Amiri",
          "fullname": "Nadiem Amiri",
          "gender": "male",
          "birthday": "27.10.1996",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "225127",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Ludwigshafen",
            "died": "no"
          }
        },
        "created": "20.02.2026 19:57",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "7w63iqek6hmnizlirurla1cr9",
        "firstName": "Nadiem",
        "lastName": "Amiri",
        "shortFirstName": "Nadiem",
        "shortLastName": "Amiri",
        "matchName": "N. Amiri",
        "shirtNumber": 10,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "297902": {
      "optaId": "3isbv9egu9vzxnna4ix8gcudx",
      "heimPlayer": {
        "id": "101936498",
        "team_id": "29680",
        "person": {
          "id": "297902",
          "name": "Benjamin Henrichs",
          "firstname": "Benjamin",
          "surname": "Henrichs",
          "fullname": "Benjamin Henrichs",
          "gender": "male",
          "birthday": "23.02.1997",
          "height": "183",
          "weight": "79",
          "person_detail": {
            "id": "225864",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Bocholt",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:11",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "3isbv9egu9vzxnna4ix8gcudx",
        "firstName": "Benjamin Paa Kwesi",
        "lastName": "Henrichs",
        "shortFirstName": "Benjamin",
        "shortLastName": "Henrichs",
        "matchName": "B. Henrichs",
        "shirtNumber": 39,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "298038": {
      "optaId": "cm0gwoyh5rdb216fx685a7l5h",
      "heimPlayer": {
        "id": "100521937",
        "team_id": "136",
        "person": {
          "id": "298038",
          "name": "Thilo Kehrer",
          "firstname": "Thilo",
          "surname": "Kehrer",
          "fullname": "Jan Thilo Kehrer",
          "gender": "male",
          "birthday": "21.09.1996",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "225973",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Tübingen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "cm0gwoyh5rdb216fx685a7l5h",
        "firstName": "Jan Thilo",
        "lastName": "Kehrer",
        "shortFirstName": "Thilo",
        "shortLastName": "Kehrer",
        "matchName": "T. Kehrer",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "298723": {
      "optaId": "a4p1m3cqm6z2p1bw97s6k46ad",
      "heimPlayer": {
        "id": "102157526",
        "team_id": "2076",
        "person": {
          "id": "298723",
          "name": "Atakan Karazor",
          "firstname": "Atakan",
          "surname": "Karazor",
          "fullname": "Atakan Karazor",
          "gender": "male",
          "birthday": "13.10.1996",
          "height": "191",
          "weight": "76",
          "person_detail": {
            "id": "226608",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Essen",
            "died": "no"
          }
        },
        "created": "22.03.2026 21:00",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "a4p1m3cqm6z2p1bw97s6k46ad",
        "firstName": "Atakan",
        "lastName": "Karazor",
        "shortFirstName": "Atakan",
        "shortLastName": "Karazor",
        "matchName": "A. Karazor",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "298724": {
      "optaId": "3igg6gfmomgh1t5ohwzbpb5cl",
      "heimPlayer": {
        "id": "97001026",
        "team_id": "29680",
        "person": {
          "id": "298724",
          "name": "Lukas Klostermann",
          "firstname": "Lukas",
          "surname": "Klostermann",
          "fullname": "Lukas Manuel Klostermann",
          "gender": "male",
          "birthday": "03.06.1996",
          "height": "187",
          "weight": "88",
          "person_detail": {
            "id": "226609",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Gevelsberg",
            "died": "no"
          }
        },
        "extra_minute": "1",
        "created": "28.11.2025 22:19",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "3igg6gfmomgh1t5ohwzbpb5cl",
        "firstName": "Lukas Manuel",
        "lastName": "Klostermann",
        "shortFirstName": "Lukas",
        "shortLastName": "Klostermann",
        "matchName": "L. Klostermann",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "299046": {
      "optaId": "9x0m798xryi14snu8a7emtplh",
      "heimPlayer": {
        "id": "100492141",
        "team_id": "1418",
        "person": {
          "id": "299046",
          "name": "Rodinei",
          "firstname": "",
          "surname": "Rodinei",
          "fullname": "Rodinei Marcelo de Almeida",
          "gender": "male",
          "birthday": "29.01.1992",
          "height": "176",
          "weight": "78",
          "person_detail": {
            "id": "226933",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Tatuí",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "9x0m798xryi14snu8a7emtplh",
        "firstName": "Rodinei Marcelo",
        "lastName": "de Almeida",
        "shortFirstName": "Rodinei Marcelo",
        "shortLastName": "de Almeida",
        "knownName": "Rodinei",
        "matchName": "Rodinei",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "300038": {
      "optaId": "1rjzsyc8yt25tyelzg820if2t",
      "heimPlayer": {
        "id": "100492144",
        "team_id": "1418",
        "person": {
          "id": "300038",
          "name": "Dani García",
          "firstname": "",
          "surname": "Dani García",
          "fullname": "Daniel García Carrillo",
          "gender": "male",
          "birthday": "24.05.1990",
          "height": "179",
          "weight": "81",
          "person_detail": {
            "id": "227902",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Zumarraga",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "1rjzsyc8yt25tyelzg820if2t",
        "firstName": "Daniel",
        "lastName": "García Carrillo",
        "shortFirstName": "Daniel",
        "shortLastName": "García Carrillo",
        "knownName": "Dani García",
        "matchName": "Dani García",
        "shirtNumber": 14,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "300334": {
      "optaId": "9vdhoij110u7e94lh8uflo5w5",
      "heimPlayer": {
        "id": "99158674",
        "team_id": "1736",
        "person": {
          "id": "300334",
          "name": "Tomáš Chorý",
          "firstname": "Tomáš",
          "surname": "Chorý",
          "fullname": "Tomáš Chorý",
          "gender": "male",
          "birthday": "26.01.1995",
          "height": "199",
          "weight": "101",
          "person_detail": {
            "id": "228201",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Olomouc",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 22:13",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "9vdhoij110u7e94lh8uflo5w5",
        "firstName": "Tomáš",
        "lastName": "Chorý",
        "shortFirstName": "Tomás",
        "shortLastName": "Chory",
        "matchName": "T. Chorý",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "300684": {
      "optaId": "548jzfl9higq44w9bgqvcjh05",
      "heimPlayer": {
        "id": "99152542",
        "team_id": "162",
        "person": {
          "id": "300684",
          "name": "José Giménez",
          "firstname": "José",
          "surname": "Giménez",
          "fullname": "José María Giménez de Vargas",
          "gender": "male",
          "birthday": "20.01.1995",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "228537",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Toledo",
            "died": "no"
          },
          "country": [
            {
              "id": "227"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "548jzfl9higq44w9bgqvcjh05",
        "firstName": "José María",
        "lastName": "Giménez de Vargas",
        "shortFirstName": "José María",
        "shortLastName": "Giménez",
        "matchName": "J. Giménez",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "301301": {
      "optaId": "72m5u1rlgh6e229zpfvp7f5jp",
      "heimPlayer": {
        "id": "100492159",
        "team_id": "1418",
        "person": {
          "id": "301301",
          "name": "Gelson Martins",
          "firstname": "",
          "surname": "Gelson Martins",
          "fullname": "Gelson Dany Batalha Martins",
          "gender": "male",
          "birthday": "11.05.1995",
          "height": "173",
          "weight": "72",
          "person_detail": {
            "id": "229151",
            "position_1": "12",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Praia",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "72m5u1rlgh6e229zpfvp7f5jp",
        "firstName": "Gelson Dany",
        "lastName": "Batalha Martins",
        "shortFirstName": "Gelson Dany",
        "shortLastName": "Batalha Martins",
        "knownName": "Gelson Martins",
        "matchName": "Gelson Martins",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "301327": {
      "optaId": "2fqlri41xq6p924kine7pjr2t",
      "heimPlayer": {
        "id": "100526206",
        "team_id": "1094",
        "person": {
          "id": "301327",
          "name": "Jérémie Boga",
          "firstname": "Jérémie",
          "surname": "Boga",
          "fullname": "Jérémie Boga",
          "gender": "male",
          "birthday": "03.01.1997",
          "height": "172",
          "weight": "68",
          "person_detail": {
            "id": "229177",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Marseille",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "25.02.2026 22:28",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "2fqlri41xq6p924kine7pjr2t",
        "firstName": "Jérémie",
        "lastName": "Boga",
        "shortFirstName": "Jérémie",
        "shortLastName": "Boga",
        "matchName": "J. Boga",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "301385": {
      "optaId": "bh3b7e2qzh41dltd6h2obpln9",
      "heimPlayer": {
        "id": "94894285",
        "team_id": "1094",
        "person": {
          "id": "301385",
          "name": "Daniele Rugani",
          "firstname": "Daniele",
          "surname": "Rugani",
          "fullname": "Daniele Rugani",
          "gender": "male",
          "birthday": "29.07.1994",
          "height": "190",
          "weight": "84",
          "person_detail": {
            "id": "229235",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Lucca",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "22.10.2025 19:48",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "bh3b7e2qzh41dltd6h2obpln9",
        "firstName": "Daniele",
        "lastName": "Rugani",
        "shortFirstName": "Daniele",
        "shortLastName": "Rugani",
        "matchName": "D. Rugani",
        "shirtNumber": 24,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "301430": {
      "optaId": "6akzpi6rd6qq0ke07ojnhpoet",
      "heimPlayer": {
        "id": "99152566",
        "team_id": "162",
        "person": {
          "id": "301430",
          "name": "Alexander Sørloth",
          "firstname": "Alexander",
          "surname": "Sørloth",
          "fullname": "Alexander Sørloth",
          "gender": "male",
          "birthday": "05.12.1995",
          "height": "195",
          "weight": "94",
          "person_detail": {
            "id": "229281",
            "position_1": "11",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Trondheim",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "6akzpi6rd6qq0ke07ojnhpoet",
        "firstName": "Alexander",
        "lastName": "Sørloth",
        "shortFirstName": "Alexander",
        "shortLastName": "Sørloth",
        "matchName": "A. Sørloth",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "301680": {
      "optaId": "v7isqpxiursyjhj5rmhyhjv9",
      "heimPlayer": {
        "id": "98853208",
        "team_id": "156",
        "person": {
          "id": "301680",
          "name": "Iñigo Lekue",
          "firstname": "",
          "surname": "Iñigo Lekue",
          "fullname": "Iñigo Lekue Martínez",
          "gender": "male",
          "birthday": "04.05.1993",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "229531",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Bilbao",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "21.01.2026 19:50",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "v7isqpxiursyjhj5rmhyhjv9",
        "firstName": "Íñigo",
        "lastName": "Lekue Martínez",
        "shortFirstName": "Íñigo",
        "shortLastName": "Lekue",
        "matchName": "Íñigo Lekue",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "301688": {
      "optaId": "ddvvwqxpsqqboupi3gx1ijhed",
      "heimPlayer": {
        "id": "94887892",
        "team_id": "156",
        "person": {
          "id": "301688",
          "name": "Iñaki Williams",
          "firstname": "",
          "surname": "Iñaki Williams",
          "fullname": "Iñaki Williams Arthuer",
          "gender": "male",
          "birthday": "15.06.1994",
          "height": "186",
          "weight": "78",
          "person_detail": {
            "id": "229539",
            "position_1": "9",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Bilbao",
            "died": "no"
          },
          "country": [
            {
              "id": "66"
            }
          ]
        },
        "created": "22.10.2025 17:51",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "ddvvwqxpsqqboupi3gx1ijhed",
        "firstName": "Iñaki",
        "lastName": "Williams Arthuer",
        "shortFirstName": "Iñaki",
        "shortLastName": "Williams",
        "knownName": "Iñaki Williams",
        "matchName": "I. Williams",
        "shirtNumber": 9,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "301854": {
      "optaId": "4ryipy52oscxkv71ws0os5w5",
      "heimPlayer": {
        "id": "101925857",
        "team_id": "24",
        "person": {
          "id": "301854",
          "name": "Vladimír Coufal",
          "firstname": "Vladimír",
          "surname": "Coufal",
          "fullname": "Vladimír Coufal",
          "gender": "male",
          "birthday": "22.08.1992",
          "height": "174",
          "weight": "76",
          "person_detail": {
            "id": "229677",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Ostrava",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:19",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "4ryipy52oscxkv71ws0os5w5",
        "firstName": "Vladimír",
        "lastName": "Coufal",
        "shortFirstName": "Vladimír",
        "shortLastName": "Coufal",
        "matchName": "V. Coufal",
        "shirtNumber": 34,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "302020": {
      "optaId": "cywgibmici8hwp1ad1nhk3ufp",
      "heimPlayer": {
        "id": "102100481",
        "team_id": "21",
        "person": {
          "id": "302020",
          "name": "Sheraldo Becker",
          "firstname": "Sheraldo",
          "surname": "Becker",
          "fullname": "Sheraldo Rudi Becker",
          "gender": "male",
          "birthday": "09.02.1995",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "229845",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "cywgibmici8hwp1ad1nhk3ufp",
        "firstName": "Sheraldo Rudi Salomo Willem",
        "lastName": "Becker",
        "shortFirstName": "Sheraldo",
        "shortLastName": "Becker",
        "matchName": "S. Becker",
        "shirtNumber": 23,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "302645": {
      "optaId": "50y6nq2eok9lnmldevkamkkwl",
      "heimPlayer": {
        "id": "100153777",
        "team_id": "1418",
        "person": {
          "id": "302645",
          "name": "Daniel Podence",
          "firstname": "",
          "surname": "Daniel Podence",
          "fullname": "Daniel Pedro Castelo Podence",
          "gender": "male",
          "birthday": "21.10.1995",
          "height": "170",
          "weight": "",
          "person_detail": {
            "id": "230441",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Oeiras",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "18.02.2026 19:48",
        "shirtnumber": "56"
      },
      "optaPlayer": {
        "playerId": "50y6nq2eok9lnmldevkamkkwl",
        "firstName": "Daniel",
        "lastName": "Castelo Podence",
        "shortFirstName": "Daniel",
        "shortLastName": "Castelo Podence",
        "knownName": "Daniel Podence",
        "matchName": "Daniel Podence",
        "shirtNumber": 56,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "303116": {
      "optaId": "1av9mmv19jwvc4xdr0p9owyxh",
      "heimPlayer": {
        "id": "97649845",
        "team_id": "597",
        "person": {
          "id": "303116",
          "name": "Andreas Christensen",
          "firstname": "Andreas",
          "surname": "Christensen",
          "fullname": "Andreas Bødtker Christensen",
          "gender": "male",
          "birthday": "10.04.1996",
          "height": "187",
          "weight": "78",
          "person_detail": {
            "id": "230898",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Lillerød",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "09.12.2025 22:52",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "1av9mmv19jwvc4xdr0p9owyxh",
        "firstName": "Andreas",
        "lastName": "Bødtker Christensen",
        "shortFirstName": "Andreas",
        "shortLastName": "Christensen",
        "matchName": "A. Christensen",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "304437": {
      "optaId": "8rfgwq7hbi4a3imda845vdyvp",
      "heimPlayer": {
        "id": "101861126",
        "team_id": "853",
        "person": {
          "id": "304437",
          "name": "Mario Lemina",
          "firstname": "Mario",
          "surname": "Lemina",
          "fullname": "Mario René Junior Lemina",
          "gender": "male",
          "birthday": "01.09.1993",
          "height": "184",
          "weight": "84",
          "person_detail": {
            "id": "232160",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Libreville",
            "died": "no"
          },
          "country": [
            {
              "id": "63"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "99"
      },
      "optaPlayer": {
        "playerId": "8rfgwq7hbi4a3imda845vdyvp",
        "firstName": "Mario René Junior",
        "lastName": "Lemina",
        "shortFirstName": "Mario",
        "shortLastName": "Lemina",
        "matchName": "M. Lemina",
        "shirtNumber": 99,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "305568": {
      "optaId": "obyc7da7fzaztqjti91oqtp1",
      "heimPlayer": {
        "id": "100493323",
        "team_id": "18670",
        "person": {
          "id": "305568",
          "name": "Abdellah Zoubir",
          "firstname": "Abdellah",
          "surname": "Zoubir",
          "fullname": "Abdellah Zoubir",
          "gender": "male",
          "birthday": "05.12.1991",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "233158",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Lille",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "obyc7da7fzaztqjti91oqtp1",
        "firstName": "Abdellah",
        "lastName": "Zoubir",
        "shortFirstName": "Abdellah",
        "shortLastName": "Zoubir",
        "matchName": "A. Zoubir",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "309036": {
      "optaId": "6o2v57d92t1mejod24gmufcut",
      "heimPlayer": {
        "id": "102136106",
        "team_id": "1639",
        "person": {
          "id": "309036",
          "name": "Philipp Lienhart",
          "firstname": "Philipp",
          "surname": "Lienhart",
          "fullname": "Philipp Lienhart",
          "gender": "male",
          "birthday": "11.07.1996",
          "height": "189",
          "weight": "83",
          "person_detail": {
            "id": "235578",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Lilienfeld",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:34",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "6o2v57d92t1mejod24gmufcut",
        "firstName": "Philipp",
        "lastName": "Lienhart",
        "shortFirstName": "Philipp",
        "shortLastName": "Lienhart",
        "matchName": "P. Lienhart",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "309149": {
      "optaId": "dydwiixiims98cx2iihfuf8wl",
      "heimPlayer": {
        "id": "99153019",
        "team_id": "2102",
        "person": {
          "id": "309149",
          "name": "Thomas Partey",
          "firstname": "Thomas",
          "surname": "Partey",
          "fullname": "Thomas Teye Partey",
          "gender": "male",
          "birthday": "13.06.1993",
          "height": "185",
          "weight": "77",
          "person_detail": {
            "id": "235638",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Odumase Krobo",
            "died": "no"
          },
          "country": [
            {
              "id": "66"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "dydwiixiims98cx2iihfuf8wl",
        "firstName": "Thomas",
        "lastName": "Teye Partey",
        "shortFirstName": "Thomas",
        "shortLastName": "Partey",
        "matchName": "T. Partey",
        "shirtNumber": 16,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "309978": {
      "optaId": "6sv29rmngsiyx4pv6zto3mklx",
      "heimPlayer": {
        "id": "99159853",
        "team_id": "13914",
        "person": {
          "id": "309978",
          "name": "Ken Sema",
          "firstname": "Ken",
          "surname": "Sema",
          "fullname": "Ken Nlata Sema",
          "gender": "male",
          "birthday": "30.09.1993",
          "height": "180",
          "weight": "69",
          "person_detail": {
            "id": "236261",
            "position_1": "10",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Norrköping",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "28.01.2026 22:43",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "6sv29rmngsiyx4pv6zto3mklx",
        "firstName": "Kenneth Nlata",
        "lastName": "Sema",
        "shortFirstName": "Ken",
        "shortLastName": "Sema",
        "matchName": "K. Sema",
        "shirtNumber": 12,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "312667": {
      "optaId": "2fsgc0b4mvwpenawmit0q0bmd",
      "heimPlayer": {
        "id": "101862311",
        "team_id": "155",
        "person": {
          "id": "312667",
          "name": "Mario Pašalić",
          "firstname": "Mario",
          "surname": "Pašalić",
          "fullname": "Mario Pašalić",
          "gender": "male",
          "birthday": "09.02.1995",
          "height": "189",
          "weight": "82",
          "person_detail": {
            "id": "238418",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Mainz",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "2fsgc0b4mvwpenawmit0q0bmd",
        "firstName": "Mario",
        "lastName": "Pašalić",
        "shortFirstName": "Mario",
        "shortLastName": "Pasalic",
        "matchName": "M. Pašalić",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "313335": {
      "optaId": "w0wt7gjkdddn63a4258j8frp",
      "heimPlayer": {
        "id": "100245073",
        "team_id": "2086",
        "person": {
          "id": "313335",
          "name": "Denis Vavro",
          "firstname": "Denis",
          "surname": "Vavro",
          "fullname": "Denis Vavro",
          "gender": "male",
          "birthday": "10.04.1996",
          "height": "189",
          "weight": "81",
          "person_detail": {
            "id": "239080",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Partizánske",
            "died": "no"
          }
        },
        "created": "21.02.2026 14:15",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "w0wt7gjkdddn63a4258j8frp",
        "firstName": "Denis",
        "lastName": "Vavro",
        "shortFirstName": "Denis",
        "shortLastName": "Vavro",
        "matchName": "D. Vavro",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "314055": {
      "optaId": "8k5c8po5gx3vnxx36viq08xqt",
      "heimPlayer": {
        "id": "101976269",
        "team_id": "253",
        "person": {
          "id": "314055",
          "name": "Nico Elvedi",
          "firstname": "Nico",
          "surname": "Elvedi",
          "fullname": "Nico Elvedi",
          "gender": "male",
          "birthday": "30.09.1996",
          "height": "189",
          "weight": "84",
          "person_detail": {
            "id": "239801",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Zürich",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:28",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "8k5c8po5gx3vnxx36viq08xqt",
        "firstName": "Nico",
        "lastName": "Elvedi",
        "shortFirstName": "Nico",
        "shortLastName": "Elvedi",
        "matchName": "N. Elvedi",
        "shirtNumber": 30,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "314143": {
      "optaId": "19856wqwrmzmvfw9thf0tzrv9",
      "heimPlayer": {
        "id": "100492450",
        "team_id": "1052",
        "person": {
          "id": "314143",
          "name": "Federico Dimarco",
          "firstname": "Federico",
          "surname": "Dimarco",
          "fullname": "Federico Dimarco",
          "gender": "male",
          "birthday": "10.11.1997",
          "height": "175",
          "weight": "75",
          "person_detail": {
            "id": "239886",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Milano",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "19856wqwrmzmvfw9thf0tzrv9",
        "firstName": "Federico",
        "lastName": "Dimarco",
        "shortFirstName": "Federico",
        "shortLastName": "Dimarco",
        "matchName": "F. Dimarco",
        "shirtNumber": 32,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "314177": {
      "optaId": "ce2pidh4dpd1ccozn2lm3qtw5",
      "heimPlayer": {
        "id": "98854102",
        "team_id": "13914",
        "person": {
          "id": "314177",
          "name": "Ivan Šunjić",
          "firstname": "Ivan",
          "surname": "Šunjić",
          "fullname": "Ivan Šunjić",
          "gender": "male",
          "birthday": "09.10.1996",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "239920",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Zenica",
            "died": "no"
          },
          "country": [
            {
              "id": "31"
            }
          ]
        },
        "created": "21.01.2026 20:03",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "ce2pidh4dpd1ccozn2lm3qtw5",
        "firstName": "Ivan",
        "lastName": "Šunjić",
        "shortFirstName": "Ivan",
        "shortLastName": "Sunjic",
        "matchName": "I. Šunjić",
        "shirtNumber": 26,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "314191": {
      "optaId": "28x7i681wkjueanvkevew3bh1",
      "heimPlayer": {
        "id": "100126267",
        "team_id": "136",
        "person": {
          "id": "314191",
          "name": "Aleksandr Golovin",
          "firstname": "Aleksandr",
          "surname": "Golovin",
          "fullname": "Aleksandr Sergeyevich Golovin",
          "gender": "male",
          "birthday": "30.05.1996",
          "height": "178",
          "weight": "69",
          "person_detail": {
            "id": "239934",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Kaltan,Kemerovo Oblast",
            "died": "no"
          },
          "country": [
            {
              "id": "172"
            }
          ]
        },
        "created": "17.02.2026 19:56",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "28x7i681wkjueanvkevew3bh1",
        "firstName": "Aleksandr",
        "lastName": "Golovin",
        "shortFirstName": "Aleksandr",
        "shortLastName": "Golovin",
        "matchName": "A. Golovin",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "315269": {
      "optaId": "arwidogdfccsjv8fxa1veezf9",
      "heimPlayer": {
        "id": "92295512",
        "team_id": "19",
        "person": {
          "id": "315269",
          "name": "Robert Skov",
          "firstname": "Robert",
          "surname": "Skov",
          "fullname": "Robert Faxe Skov",
          "gender": "male",
          "birthday": "20.05.1996",
          "height": "185",
          "weight": "81",
          "person_detail": {
            "id": "241021",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Marbella",
            "died": "no"
          }
        },
        "created": "13.09.2025 14:18",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "arwidogdfccsjv8fxa1veezf9",
        "firstName": "Robert",
        "lastName": "Faxe Skov",
        "shortFirstName": "Robert",
        "shortLastName": "Skov",
        "matchName": "R. Skov",
        "shirtNumber": 24,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "316361": {
      "optaId": "eziqega9e25bg939pfh4vjp3p",
      "heimPlayer": {
        "id": "101311037",
        "team_id": "1226",
        "person": {
          "id": "316361",
          "name": "Andy Robertson",
          "firstname": "Andy",
          "surname": "Robertson",
          "fullname": "Andrew Henry Robertson",
          "gender": "male",
          "birthday": "11.03.1994",
          "height": "178",
          "weight": "64",
          "person_detail": {
            "id": "242101",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Glasgow",
            "died": "no"
          },
          "country": [
            {
              "id": "181"
            }
          ]
        },
        "created": "10.03.2026 20:03",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "eziqega9e25bg939pfh4vjp3p",
        "firstName": "Andrew Henry",
        "lastName": "Robertson",
        "shortFirstName": "Andy",
        "shortLastName": "Robertson",
        "matchName": "A. Robertson",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "316447": {
      "optaId": "6hotzhpidcjljm3u0ud1uqsid",
      "heimPlayer": {
        "id": "101972432",
        "team_id": "5",
        "person": {
          "id": "316447",
          "name": "Budu Zivzivadze",
          "firstname": "Budu",
          "surname": "Zivzivadze",
          "fullname": "Budu Zivzivadze",
          "gender": "male",
          "birthday": "10.03.1994",
          "height": "189",
          "weight": "85",
          "person_detail": {
            "id": "242188",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Kutaisi",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "6hotzhpidcjljm3u0ud1uqsid",
        "firstName": "Budu",
        "lastName": "Zivzivadze",
        "shortFirstName": "Budu",
        "shortLastName": "Zivzivadze",
        "matchName": "B. Zivzivadze",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "316508": {
      "optaId": "b3974hgsmyff5xtq7qf1onhlh",
      "heimPlayer": {
        "id": "101812994",
        "team_id": "1267",
        "person": {
          "id": "316508",
          "name": "Bernardo Silva",
          "firstname": "",
          "surname": "Bernardo Silva",
          "fullname": "Bernardo Mota Veiga de Carvalho e Silva",
          "gender": "male",
          "birthday": "10.08.1994",
          "height": "173",
          "weight": "64",
          "person_detail": {
            "id": "242249",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Lisboa",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "b3974hgsmyff5xtq7qf1onhlh",
        "firstName": "Bernardo",
        "lastName": "Mota Veiga de Carvalho e Silva",
        "shortFirstName": "Bernardo",
        "shortLastName": "Mota Veiga de Carvalho e Silva",
        "knownName": "Bernardo Silva",
        "matchName": "Bernardo Silva",
        "shirtNumber": 20,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "318906": {
      "optaId": "drwacyyicuhy3heg4j0ipqj85",
      "heimPlayer": {
        "id": "98830714",
        "team_id": "2102",
        "person": {
          "id": "318906",
          "name": "Ayoze Pérez",
          "firstname": "",
          "surname": "Ayoze Pérez",
          "fullname": "Ayoze Pérez Gutiérrez",
          "gender": "male",
          "birthday": "29.07.1993",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "244356",
            "position_1": "6",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Santa Cruz de Tenerife",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 20:04",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "drwacyyicuhy3heg4j0ipqj85",
        "firstName": "Ayoze",
        "lastName": "Pérez Gutiérrez",
        "shortFirstName": "Ayoze",
        "shortLastName": "Pérez",
        "matchName": "Ayoze Pérez",
        "shirtNumber": 22,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "319011": {
      "optaId": "1qthvf5krys0pzk24h8wtr9at",
      "heimPlayer": {
        "id": "101310137",
        "team_id": "209",
        "person": {
          "id": "319011",
          "name": "Konrad Laimer",
          "firstname": "Konrad",
          "surname": "Laimer",
          "fullname": "Konrad Laimer",
          "gender": "male",
          "birthday": "27.05.1997",
          "height": "180",
          "weight": "72",
          "person_detail": {
            "id": "244455",
            "position_1": "5",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Salzburg",
            "died": "no"
          },
          "country": [
            {
              "id": "158"
            }
          ]
        },
        "created": "10.03.2026 19:57",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "1qthvf5krys0pzk24h8wtr9at",
        "firstName": "Konrad",
        "lastName": "Laimer",
        "shortFirstName": "Konrad",
        "shortLastName": "Laimer",
        "matchName": "K. Laimer",
        "shirtNumber": 27,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "319421": {
      "optaId": "6govmi3dn4cxa3m0lyeqc1uj9",
      "heimPlayer": {
        "id": "102116570",
        "team_id": "702",
        "person": {
          "id": "319421",
          "name": "Nikola Vasilj",
          "firstname": "Nikola",
          "surname": "Vasilj",
          "fullname": "Nikola Vasilj",
          "gender": "male",
          "birthday": "02.12.1995",
          "height": "193",
          "weight": "86",
          "person_detail": {
            "id": "244842",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Mostar",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:18",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "6govmi3dn4cxa3m0lyeqc1uj9",
        "firstName": "Nikola",
        "lastName": "Vasilj",
        "shortFirstName": "Nikola",
        "shortLastName": "Vasilj",
        "matchName": "N. Vasilj",
        "shirtNumber": 22,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "322749": {
      "optaId": "3havaatbnk8p6gc9srgajc25l",
      "heimPlayer": {
        "id": "102134942",
        "team_id": "2076",
        "person": {
          "id": "322749",
          "name": "Chris Führich",
          "firstname": "Chris",
          "surname": "Führich",
          "fullname": "Chris Jan Führich",
          "gender": "male",
          "birthday": "09.01.1998",
          "height": "181",
          "weight": "70",
          "person_detail": {
            "id": "248041",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Castrop-Rauxel",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "3havaatbnk8p6gc9srgajc25l",
        "firstName": "Chris Jan",
        "lastName": "Führich",
        "shortFirstName": "Chris",
        "shortLastName": "Führich",
        "matchName": "C. Führich",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "323712": {
      "optaId": "bsyv3fmihshve4jcr11qmtmfp",
      "heimPlayer": {
        "id": "102143480",
        "team_id": "1639",
        "person": {
          "id": "323712",
          "name": "Lucas Höler",
          "firstname": "Lucas",
          "surname": "Höler",
          "fullname": "Lucas Höler",
          "gender": "male",
          "birthday": "10.07.1994",
          "height": "184",
          "weight": "83",
          "person_detail": {
            "id": "248887",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Achim",
            "died": "no"
          }
        },
        "created": "22.03.2026 19:14",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bsyv3fmihshve4jcr11qmtmfp",
        "firstName": "Lucas",
        "lastName": "Höler",
        "shortFirstName": "Lucas",
        "shortLastName": "Höler",
        "matchName": "L. Höler",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "327010": {
      "optaId": "53d0pvr7ylvfhp6p749iniqc5",
      "heimPlayer": {
        "id": "101861339",
        "team_id": "1226",
        "person": {
          "id": "327010",
          "name": "Alisson Becker",
          "firstname": "",
          "surname": "Alisson Becker",
          "fullname": "Alisson Ramses Becker",
          "gender": "male",
          "birthday": "02.10.1992",
          "height": "193",
          "weight": "88",
          "person_detail": {
            "id": "251311",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Novo Hamburgo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "53d0pvr7ylvfhp6p749iniqc5",
        "firstName": "Alisson Ramsés",
        "lastName": "Becker",
        "shortFirstName": "Alisson Ramsés",
        "shortLastName": "Becker",
        "knownName": "Alisson Becker",
        "matchName": "Alisson Becker",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "327636": {
      "optaId": "2tuglrftx5oh6v3vax2rufy6t",
      "heimPlayer": {
        "id": "99154645",
        "team_id": "17544",
        "person": {
          "id": "327636",
          "name": "Luís Mata",
          "firstname": "",
          "surname": "Luís Mata",
          "fullname": "Luís Carlos Machado Mata",
          "gender": "male",
          "birthday": "06.07.1997",
          "height": "181",
          "weight": "70",
          "person_detail": {
            "id": "251689",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Porto",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "2tuglrftx5oh6v3vax2rufy6t",
        "firstName": "Luís Carlos",
        "lastName": "Machado Mata",
        "shortFirstName": "Luís Carlos",
        "shortLastName": "Machado Mata",
        "knownName": "Luís Mata",
        "matchName": "Luís Mata",
        "shirtNumber": 3,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "330992": {
      "optaId": "661b6x35l9b9uieqbcq7el1hx",
      "heimPlayer": {
        "id": "101822972",
        "team_id": "373",
        "person": {
          "id": "330992",
          "name": "Tosin Adarabioyo",
          "firstname": "Tosin",
          "surname": "Adarabioyo",
          "fullname": "Abdul-Nasir Oluwatosin Oluwadoyinsolami Adarabioyo",
          "gender": "male",
          "birthday": "24.09.1997",
          "height": "197",
          "weight": "80",
          "person_detail": {
            "id": "254973",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 22:28",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "661b6x35l9b9uieqbcq7el1hx",
        "firstName": "Abdul-Nasir Oluwatosin Oluwadoyinsolami",
        "lastName": "Adarabioyo",
        "shortFirstName": "Tosin",
        "shortLastName": "Adarabioyo",
        "matchName": "T. Adarabioyo",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "331094": {
      "optaId": "b91n9sdabth8oocdawayybdud",
      "heimPlayer": {
        "id": "99154831",
        "team_id": "156",
        "person": {
          "id": "331094",
          "name": "Andoni Gorosabel",
          "firstname": "",
          "surname": "Andoni Gorosabel",
          "fullname": "Andoni Gorosabel Espinosa",
          "gender": "male",
          "birthday": "04.08.1996",
          "height": "174",
          "weight": "70",
          "person_detail": {
            "id": "255075",
            "position_1": "5",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Arrasate",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "b91n9sdabth8oocdawayybdud",
        "firstName": "Andoni",
        "lastName": "Gorosabel Espinosa",
        "shortFirstName": "Andoni",
        "shortLastName": "Gorosabel",
        "matchName": "Andoni Gorosabel",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "331149": {
      "optaId": "c80tzy7t4hoa8fpbek1od4lw5",
      "heimPlayer": {
        "id": "101822501",
        "team_id": "1457",
        "person": {
          "id": "331149",
          "name": "Lucas Hernández",
          "firstname": "Lucas",
          "surname": "Hernández",
          "fullname": "Lucas François Bernard Hernández Pi",
          "gender": "male",
          "birthday": "14.02.1996",
          "height": "184",
          "weight": "79",
          "person_detail": {
            "id": "255129",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Marseille",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 22:22",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "c80tzy7t4hoa8fpbek1od4lw5",
        "firstName": "Lucas François Bernard",
        "lastName": "Hernández",
        "shortFirstName": "Lucas",
        "shortLastName": "Hernández",
        "matchName": "L. Hernández",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "331355": {
      "optaId": "amxunh6enoc99r07cp7qt621h",
      "heimPlayer": {
        "id": "99152548",
        "team_id": "162",
        "person": {
          "id": "331355",
          "name": "Marcos Llorente",
          "firstname": "",
          "surname": "Marcos Llorente",
          "fullname": "Marcos Llorente Moreno",
          "gender": "male",
          "birthday": "30.01.1995",
          "height": "184",
          "weight": "74",
          "person_detail": {
            "id": "255334",
            "position_1": "5",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "amxunh6enoc99r07cp7qt621h",
        "firstName": "Marcos",
        "lastName": "Llorente Moreno",
        "shortFirstName": "Marcos",
        "shortLastName": "Llorente",
        "matchName": "Marcos Llorente",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "331449": {
      "optaId": "curznlsytjm07efqlmyp3br2t",
      "heimPlayer": {
        "id": "101134987",
        "team_id": "702",
        "person": {
          "id": "331449",
          "name": "Manolis Saliakas",
          "firstname": "Manolis",
          "surname": "Saliakas",
          "fullname": "Manolis Saliakas",
          "gender": "male",
          "birthday": "12.09.1996",
          "height": "177",
          "weight": "74",
          "person_detail": {
            "id": "255428",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Heraklion",
            "died": "no"
          }
        },
        "created": "08.03.2026 14:24",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "curznlsytjm07efqlmyp3br2t",
        "firstName": "Emmanouil",
        "lastName": "Saliakas",
        "shortFirstName": "Manolis",
        "shortLastName": "Saliakas",
        "matchName": "M. Saliakas",
        "shirtNumber": 2,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "331470": {
      "optaId": "a9ozu4hjaylfr4299ceryskid",
      "heimPlayer": {
        "id": "101815058",
        "team_id": "1776",
        "person": {
          "id": "331470",
          "name": "Nuno Santos",
          "firstname": "",
          "surname": "Nuno Santos",
          "fullname": "Nuno Miguel Gomes dos Santos",
          "gender": "male",
          "birthday": "13.02.1995",
          "height": "177",
          "weight": "71",
          "person_detail": {
            "id": "255449",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Trofa",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 20:11",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "a9ozu4hjaylfr4299ceryskid",
        "firstName": "Nuno Miguel",
        "lastName": "Gomes dos Santos",
        "shortFirstName": "Nuno Miguel",
        "shortLastName": "Gomes dos Santos",
        "knownName": "Nuno Santos",
        "matchName": "Nuno Santos",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "332809": {
      "optaId": "5lwvt18g3d2qpuce2nqul4cet",
      "heimPlayer": {
        "id": "99154522",
        "team_id": "1736",
        "person": {
          "id": "332809",
          "name": "Lukáš Provod",
          "firstname": "Lukáš",
          "surname": "Provod",
          "fullname": "Lukáš Provod",
          "gender": "male",
          "birthday": "23.10.1996",
          "height": "189",
          "weight": "85",
          "person_detail": {
            "id": "256749",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Plzeň",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "5lwvt18g3d2qpuce2nqul4cet",
        "firstName": "Lukáš",
        "lastName": "Provod",
        "shortFirstName": "Lukás",
        "shortLastName": "Provod",
        "matchName": "L. Provod",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11",
        "captain": "yes"
      }
    },
    "333730": {
      "optaId": "32eyq4xvy8s1ng11jnavvh32t",
      "heimPlayer": {
        "id": "94848850",
        "team_id": "1418",
        "person": {
          "id": "333730",
          "name": "Roman Yaremchuk",
          "firstname": "Roman",
          "surname": "Yaremchuk",
          "fullname": "Roman Olegovych Yaremchuk",
          "gender": "male",
          "birthday": "27.11.1995",
          "height": "191",
          "weight": "79",
          "person_detail": {
            "id": "257669",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Lviv",
            "died": "no"
          },
          "country": [
            {
              "id": "225"
            }
          ]
        },
        "created": "21.10.2025 20:21",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "32eyq4xvy8s1ng11jnavvh32t",
        "firstName": "Roman",
        "lastName": "Yaremchuk",
        "shortFirstName": "Roman",
        "shortLastName": "Yaremchuk",
        "matchName": "R. Yaremchuk",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "335762": {
      "optaId": "bmrdtenqr84jt4gmw6i7wez11",
      "heimPlayer": {
        "id": "100518838",
        "team_id": "258",
        "person": {
          "id": "335762",
          "name": "Serhou Guirassy",
          "firstname": "Serhou",
          "surname": "Guirassy",
          "fullname": "Serhou Yadaly Guirassy",
          "gender": "male",
          "birthday": "12.03.1996",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "259689",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Arles",
            "died": "no"
          },
          "country": [
            {
              "id": "75"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bmrdtenqr84jt4gmw6i7wez11",
        "firstName": "Serhou Yadaly",
        "lastName": "Guirassy",
        "shortFirstName": "Serhou",
        "shortLastName": "Guirassy",
        "matchName": "S. Guirassy",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "336243": {
      "optaId": "4k0ni039sbjs4sqipk4v7k79x",
      "heimPlayer": {
        "id": "101303546",
        "team_id": "853",
        "person": {
          "id": "336243",
          "name": "Davinson Sánchez",
          "firstname": "Davinson",
          "surname": "Sánchez",
          "fullname": "Davinson Sánchez Mina",
          "gender": "male",
          "birthday": "12.06.1996",
          "height": "187",
          "weight": "81",
          "person_detail": {
            "id": "260159",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Caloto",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "10.03.2026 17:43",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "4k0ni039sbjs4sqipk4v7k79x",
        "firstName": "Davinson",
        "lastName": "Sánchez Mina",
        "shortFirstName": "Davinson",
        "shortLastName": "Sánchez",
        "matchName": "D. Sánchez",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "336358": {
      "optaId": "emvi36y613e4lqlat3wfdih9l",
      "heimPlayer": {
        "id": "99566419",
        "team_id": "258",
        "person": {
          "id": "336358",
          "name": "Salih Özcan",
          "firstname": "Salih",
          "surname": "Özcan",
          "fullname": "Salih Özcan",
          "gender": "male",
          "birthday": "11.01.1998",
          "height": "182",
          "weight": "74",
          "person_detail": {
            "id": "260274",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Köln",
            "died": "no"
          }
        },
        "created": "07.02.2026 17:17",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "emvi36y613e4lqlat3wfdih9l",
        "firstName": "Salih",
        "lastName": "Özcan",
        "shortFirstName": "Salih",
        "shortLastName": "Özcan",
        "matchName": "S. Özcan",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "336538": {
      "optaId": "4kolmisdpprx0wrahisadl5n9",
      "heimPlayer": {
        "id": "102134453",
        "team_id": "594",
        "person": {
          "id": "336538",
          "name": "Elvis Rexhbeçaj",
          "firstname": "Elvis",
          "surname": "Rexhbeçaj",
          "fullname": "Elvis Rexhbeçaj",
          "gender": "male",
          "birthday": "01.11.1997",
          "height": "182",
          "weight": "75",
          "person_detail": {
            "id": "260454",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Prizren",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "4kolmisdpprx0wrahisadl5n9",
        "firstName": "Elvis",
        "lastName": "Rexhbeçaj",
        "shortFirstName": "Elvis",
        "shortLastName": "Rexhbeçaj",
        "matchName": "E. Rexhbeçaj",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "336676": {
      "optaId": "6q2mf0qrkt51z28b46wltxal1",
      "heimPlayer": {
        "id": "102134933",
        "team_id": "2076",
        "person": {
          "id": "336676",
          "name": "Maximilian Mittelstädt",
          "firstname": "Maximilian",
          "surname": "Mittelstädt",
          "fullname": "Maximilian Mittelstädt",
          "gender": "male",
          "birthday": "18.03.1997",
          "height": "180",
          "weight": "71",
          "person_detail": {
            "id": "260592",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "6q2mf0qrkt51z28b46wltxal1",
        "firstName": "Maximilian",
        "lastName": "Mittelstädt",
        "shortFirstName": "Maximilian",
        "shortLastName": "Mittelstädt",
        "matchName": "M. Mittelstädt",
        "shirtNumber": 7,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "336742": {
      "optaId": "4l09nrr75hpk80bq7himhav2t",
      "heimPlayer": {
        "id": "99154495",
        "team_id": "1736",
        "person": {
          "id": "336742",
          "name": "Jindřich Staněk",
          "firstname": "Jindřich",
          "surname": "Staněk",
          "fullname": "Jindřich Staněk",
          "gender": "male",
          "birthday": "27.04.1996",
          "height": "192",
          "weight": "90",
          "person_detail": {
            "id": "260658",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Strakonice",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "4l09nrr75hpk80bq7himhav2t",
        "firstName": "Jindřich",
        "lastName": "Staněk",
        "shortFirstName": "Jindrich",
        "shortLastName": "Stanek",
        "matchName": "J. Staněk",
        "shirtNumber": 36,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "336777": {
      "optaId": "2hrvu72syd3vyic6ylygxbyl1",
      "heimPlayer": {
        "id": "101972420",
        "team_id": "5",
        "person": {
          "id": "336777",
          "name": "Benedikt Gimber",
          "firstname": "Benedikt",
          "surname": "Gimber",
          "fullname": "Benedikt Steffen Gimber",
          "gender": "male",
          "birthday": "19.02.1997",
          "height": "187",
          "weight": "85",
          "person_detail": {
            "id": "260693",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Buchen",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "2hrvu72syd3vyic6ylygxbyl1",
        "firstName": "Benedikt Steffen",
        "lastName": "Gimber",
        "shortFirstName": "Benedikt",
        "shortLastName": "Gimber",
        "matchName": "B. Gimber",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "336779": {
      "optaId": "6x4ywqmispidw0tznzpjwd1hx",
      "heimPlayer": {
        "id": "102002585",
        "team_id": "5",
        "person": {
          "id": "336779",
          "name": "Adrian Beck",
          "firstname": "Adrian",
          "surname": "Beck",
          "fullname": "Adrian Beck",
          "gender": "male",
          "birthday": "09.06.1997",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "260695",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Crailsheim",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:11",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "6x4ywqmispidw0tznzpjwd1hx",
        "firstName": "Adrian",
        "lastName": "Beck",
        "shortFirstName": "Adrian",
        "shortLastName": "Beck",
        "matchName": "A. Beck",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "336883": {
      "optaId": "c0ewvrtk657uw4t5rlv87mq51",
      "heimPlayer": {
        "id": "101822903",
        "team_id": "205",
        "person": {
          "id": "336883",
          "name": "Patrik Schick",
          "firstname": "Patrik",
          "surname": "Schick",
          "fullname": "Patrik Schick",
          "gender": "male",
          "birthday": "24.01.1996",
          "height": "191",
          "weight": "87",
          "person_detail": {
            "id": "260799",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Praha",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "17.03.2026 22:26",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "c0ewvrtk657uw4t5rlv87mq51",
        "firstName": "Patrik",
        "lastName": "Schick",
        "shortFirstName": "Patrik",
        "shortLastName": "Schick",
        "matchName": "P. Schick",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "337004": {
      "optaId": "2zdyvjcz5672e6n7cmgo89tcl",
      "heimPlayer": {
        "id": "97686346",
        "team_id": "13914",
        "person": {
          "id": "337004",
          "name": "David Goldar",
          "firstname": "",
          "surname": "David Goldar",
          "fullname": "David Goldar Gómez",
          "gender": "male",
          "birthday": "15.09.1994",
          "height": "184",
          "weight": "79",
          "person_detail": {
            "id": "260918",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Romai-Portas",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "10.12.2025 19:52",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "2zdyvjcz5672e6n7cmgo89tcl",
        "firstName": "David",
        "lastName": "Goldar Gómez",
        "shortFirstName": "David",
        "shortLastName": "Goldar",
        "matchName": "David Goldar",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4",
        "captain": "yes"
      }
    },
    "337038": {
      "optaId": "514es9hzl2skv9dl5cofgkogl",
      "heimPlayer": {
        "id": "101456264",
        "team_id": "253",
        "person": {
          "id": "337038",
          "name": "Florian Neuhaus",
          "firstname": "Florian",
          "surname": "Neuhaus",
          "fullname": "Florian Christian Neuhaus",
          "gender": "male",
          "birthday": "16.03.1997",
          "height": "185",
          "weight": "77",
          "person_detail": {
            "id": "260951",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Landsberg am Lech",
            "died": "no"
          }
        },
        "created": "13.03.2026 22:04",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "514es9hzl2skv9dl5cofgkogl",
        "firstName": "Florian Christian",
        "lastName": "Neuhaus",
        "shortFirstName": "Florian",
        "shortLastName": "Neuhaus",
        "matchName": "F. Neuhaus",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "337062": {
      "optaId": "1ljgis575ujto4361ed15w0r9",
      "heimPlayer": {
        "id": "101976272",
        "team_id": "253",
        "person": {
          "id": "337062",
          "name": "Moritz Nicolas",
          "firstname": "Moritz",
          "surname": "Nicolas",
          "fullname": "Moritz Nicolas",
          "gender": "male",
          "birthday": "21.10.1997",
          "height": "193",
          "weight": "89",
          "person_detail": {
            "id": "260974",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Gladbeck",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:28",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "1ljgis575ujto4361ed15w0r9",
        "firstName": "Moritz",
        "lastName": "Nicolas",
        "shortFirstName": "Moritz",
        "shortLastName": "Nicolas",
        "matchName": "M. Nicolas",
        "shirtNumber": 33,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "337345": {
      "optaId": "dg6vrx8k026l7f8ytbu1xxj9x",
      "heimPlayer": {
        "id": "102100475",
        "team_id": "21",
        "person": {
          "id": "337345",
          "name": "Phillip Tietz",
          "firstname": "Phillip",
          "surname": "Tietz",
          "fullname": "Phillip Tietz",
          "gender": "male",
          "birthday": "09.07.1997",
          "height": "190",
          "weight": "89",
          "person_detail": {
            "id": "261233",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Braunschweig",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "dg6vrx8k026l7f8ytbu1xxj9x",
        "firstName": "Phillip",
        "lastName": "Tietz",
        "shortFirstName": "Phillip",
        "shortLastName": "Tietz",
        "matchName": "P. Tietz",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "337489": {
      "optaId": "e0hk5aepnpo7cne006zwahfx1",
      "heimPlayer": {
        "id": "101976026",
        "team_id": "253",
        "person": {
          "id": "337489",
          "name": "Franck Honorat",
          "firstname": "Franck",
          "surname": "Honorat",
          "fullname": "Franck Honorat",
          "gender": "male",
          "birthday": "11.08.1996",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "261377",
            "position_1": "12",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Toulon",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "e0hk5aepnpo7cne006zwahfx1",
        "firstName": "Franck",
        "lastName": "Honorat",
        "shortFirstName": "Franck",
        "shortLastName": "Honorat",
        "matchName": "F. Honorat",
        "shirtNumber": 9,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "338777": {
      "optaId": "83n1qv6ypl625aolzjeqifv11",
      "heimPlayer": {
        "id": "99159067",
        "team_id": "156",
        "person": {
          "id": "338777",
          "name": "Vesga",
          "firstname": "",
          "surname": "Vesga",
          "fullname": "Mikel Vesga Arruti",
          "gender": "male",
          "birthday": "08.04.1993",
          "height": "191",
          "weight": "83",
          "person_detail": {
            "id": "262666",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Vitoria-Gasteiz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:25",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "83n1qv6ypl625aolzjeqifv11",
        "firstName": "Mikel",
        "lastName": "Vesga Arruti",
        "shortFirstName": "Mikel",
        "shortLastName": "Vesga",
        "matchName": "Mikel Vesga",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "340208": {
      "optaId": "a1q3mystvi6gkv7tjrn75kw6h",
      "heimPlayer": {
        "id": "100521928",
        "team_id": "136",
        "person": {
          "id": "340208",
          "name": "Philipp Köhn",
          "firstname": "Philipp",
          "surname": "Köhn",
          "fullname": "Philipp Köhn",
          "gender": "male",
          "birthday": "02.04.1998",
          "height": "190",
          "weight": "80",
          "person_detail": {
            "id": "263852",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Dinslaken",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "a1q3mystvi6gkv7tjrn75kw6h",
        "firstName": "Philipp François",
        "lastName": "Köhn",
        "shortFirstName": "Philipp",
        "shortLastName": "Köhn",
        "matchName": "P. Köhn",
        "shirtNumber": 16,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "340226": {
      "optaId": "5nbk2xeyrs7pxdye1jtqudhpl",
      "heimPlayer": {
        "id": "96650806",
        "team_id": "253",
        "person": {
          "id": "340226",
          "name": "Robin Hack",
          "firstname": "Robin",
          "surname": "Hack",
          "fullname": "Robin Hack",
          "gender": "male",
          "birthday": "27.08.1998",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "263870",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Pforzheim",
            "died": "no"
          }
        },
        "created": "22.11.2025 17:10",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "5nbk2xeyrs7pxdye1jtqudhpl",
        "firstName": "Robin",
        "lastName": "Hack",
        "shortFirstName": "Robin",
        "shortLastName": "Hack",
        "matchName": "R. Hack",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "340729": {
      "optaId": "d2gbcc336c4zatpiif4cvm2fp",
      "heimPlayer": {
        "id": "102134447",
        "team_id": "594",
        "person": {
          "id": "340729",
          "name": "Finn Dahmen",
          "firstname": "Finn",
          "surname": "Dahmen",
          "fullname": "Finn Gilbert Dahmen",
          "gender": "male",
          "birthday": "27.03.1998",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "264353",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Wiesbaden",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "d2gbcc336c4zatpiif4cvm2fp",
        "firstName": "Finn Gilbert",
        "lastName": "Dahmen",
        "shortFirstName": "Finn",
        "shortLastName": "Dahmen",
        "matchName": "F. Dahmen",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "341022": {
      "optaId": "mgwgcv336wb93xvv0pfr6dih",
      "heimPlayer": {
        "id": "102134948",
        "team_id": "2076",
        "person": {
          "id": "341022",
          "name": "Jeff Chabot",
          "firstname": "Jeff",
          "surname": "Chabot",
          "fullname": "Jeffrey Julian Gaston Chabot",
          "gender": "male",
          "birthday": "12.02.1998",
          "height": "195",
          "weight": "85",
          "person_detail": {
            "id": "264646",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Hanau",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "mgwgcv336wb93xvv0pfr6dih",
        "firstName": "Julian Jeffrey Gaston",
        "lastName": "Chabot",
        "shortFirstName": "Jeff",
        "shortLastName": "Chabot",
        "matchName": "J. Chabot",
        "shirtNumber": 24,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "341169": {
      "optaId": "1psr9ra8k9j4r94p1xixagzbp",
      "heimPlayer": {
        "id": "98934283",
        "team_id": "2134",
        "person": {
          "id": "341169",
          "name": "Amos Pieper",
          "firstname": "Amos",
          "surname": "Pieper",
          "fullname": "Amos Pieper",
          "gender": "male",
          "birthday": "17.01.1998",
          "height": "192",
          "weight": "86",
          "person_detail": {
            "id": "264793",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Lüdinghausen",
            "died": "no"
          }
        },
        "created": "24.01.2026 14:21",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "1psr9ra8k9j4r94p1xixagzbp",
        "firstName": "Amos",
        "lastName": "Pieper",
        "shortFirstName": "Amos",
        "shortLastName": "Pieper",
        "matchName": "A. Pieper",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "341840": {
      "optaId": "5cw4n6kdaa7imeyaiuo2pnq39",
      "heimPlayer": {
        "id": "100133587",
        "team_id": "1731",
        "person": {
          "id": "341840",
          "name": "Dodi Lukébakio",
          "firstname": "Dodi",
          "surname": "Lukébakio",
          "fullname": "Dodi Lukébakio Ngandoli",
          "gender": "male",
          "birthday": "24.09.1997",
          "height": "187",
          "weight": "77",
          "person_detail": {
            "id": "265384",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Brussels",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "17.02.2026 22:39",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "5cw4n6kdaa7imeyaiuo2pnq39",
        "firstName": "Dodi",
        "lastName": "Lukébakio Ngandoli",
        "shortFirstName": "Dodi",
        "shortLastName": "Lukébakio",
        "matchName": "D. Lukébakio",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "343173": {
      "optaId": "37d7oej48pb143o5eilue1hhx",
      "heimPlayer": {
        "id": "101863367",
        "team_id": "1355",
        "person": {
          "id": "343173",
          "name": "Jacob Murphy",
          "firstname": "Jacob",
          "surname": "Murphy",
          "fullname": "Jacob Kai Murphy",
          "gender": "male",
          "birthday": "24.02.1995",
          "height": "179",
          "weight": "71",
          "person_detail": {
            "id": "266600",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Wembley, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 20:13",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "37d7oej48pb143o5eilue1hhx",
        "firstName": "Jacob Kai",
        "lastName": "Murphy",
        "shortFirstName": "Jacob",
        "shortLastName": "Murphy",
        "knownName": "Jacob Murphy",
        "matchName": "J. Murphy",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "346005": {
      "optaId": "almf0gtdjmsdm5zhyot1hvydx",
      "heimPlayer": {
        "id": "100492444",
        "team_id": "1052",
        "person": {
          "id": "346005",
          "name": "Manuel Akanji",
          "firstname": "Manuel",
          "surname": "Akanji",
          "fullname": "Manuel Obafemi Akanji",
          "gender": "male",
          "birthday": "19.07.1995",
          "height": "188",
          "weight": "91",
          "person_detail": {
            "id": "268517",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Wiesendangen",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "almf0gtdjmsdm5zhyot1hvydx",
        "firstName": "Manuel Obafemi",
        "lastName": "Akanji",
        "shortFirstName": "Manuel",
        "shortLastName": "Akanji",
        "matchName": "M. Akanji",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "346175": {
      "optaId": "4iijb6llnz28unsz4rirr3umt",
      "heimPlayer": {
        "id": "101812787",
        "team_id": "127",
        "person": {
          "id": "346175",
          "name": "David Raya",
          "firstname": "",
          "surname": "David Raya",
          "fullname": "David Raya Martín",
          "gender": "male",
          "birthday": "15.09.1995",
          "height": "183",
          "weight": "80",
          "person_detail": {
            "id": "268680",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Barcelona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "4iijb6llnz28unsz4rirr3umt",
        "firstName": "David",
        "lastName": "Raya Martín",
        "shortFirstName": "David",
        "shortLastName": "Raya",
        "matchName": "David Raya",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "346934": {
      "optaId": "1sun9nitagc7ikkpwzrdkj179",
      "heimPlayer": {
        "id": "101999585",
        "team_id": "5",
        "person": {
          "id": "346934",
          "name": "Sirlord Conteh",
          "firstname": "Sirlord",
          "surname": "Conteh",
          "fullname": "Sirlord Calvin Conteh",
          "gender": "male",
          "birthday": "09.07.1996",
          "height": "178",
          "weight": "78",
          "person_detail": {
            "id": "269336",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:51",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "1sun9nitagc7ikkpwzrdkj179",
        "firstName": "Sirlord Calvin",
        "lastName": "Conteh",
        "shortFirstName": "Sirlord",
        "shortLastName": "Conteh",
        "matchName": "S. Conteh",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "347498": {
      "optaId": "1s1v1tweyx8wxc9hj2jrnaggl",
      "heimPlayer": {
        "id": "101925521",
        "team_id": "29680",
        "person": {
          "id": "347498",
          "name": "Xaver Schlager",
          "firstname": "Xaver",
          "surname": "Schlager",
          "fullname": "Xaver Schlager",
          "gender": "male",
          "birthday": "28.09.1997",
          "height": "174",
          "weight": "76",
          "person_detail": {
            "id": "269818",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Linz",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "1s1v1tweyx8wxc9hj2jrnaggl",
        "firstName": "Xaver",
        "lastName": "Schlager",
        "shortFirstName": "Xaver",
        "shortLastName": "Schlager",
        "matchName": "X. Schlager",
        "shirtNumber": 24,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "347862": {
      "optaId": "aaoycxwi9jny6flm4apz8a2uh",
      "heimPlayer": {
        "id": "101973263",
        "team_id": "2134",
        "person": {
          "id": "347862",
          "name": "Marco Friedl",
          "firstname": "Marco",
          "surname": "Friedl",
          "fullname": "Marco Friedl",
          "gender": "male",
          "birthday": "16.03.1998",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "270159",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Kirchbichl",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "aaoycxwi9jny6flm4apz8a2uh",
        "firstName": "Marco",
        "lastName": "Friedl",
        "shortFirstName": "Marco",
        "shortLastName": "Friedl",
        "matchName": "M. Friedl",
        "shirtNumber": 32,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "348360": {
      "optaId": "bwqqecmqm76v5b83v1cz891p1",
      "heimPlayer": {
        "id": "102100469",
        "team_id": "21",
        "person": {
          "id": "348360",
          "name": "Jae-sung Lee",
          "firstname": "Jae-sung",
          "surname": "Lee",
          "fullname": "Jae-sung Lee II",
          "gender": "male",
          "birthday": "10.08.1992",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "270658",
            "position_1": "8",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Ulsan",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "bwqqecmqm76v5b83v1cz891p1",
        "firstName": "Jae-Sung",
        "lastName": "Lee",
        "shortFirstName": "Jae-Sung",
        "shortLastName": "Lee",
        "knownName": "Lee Jae-Sung",
        "matchName": "Lee Jae-Sung",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "349125": {
      "optaId": "oivi495h0xuu6sw8i1ra6dpl",
      "heimPlayer": {
        "id": "102134462",
        "team_id": "594",
        "person": {
          "id": "349125",
          "name": "Robin Fellhauer",
          "firstname": "Robin",
          "surname": "Fellhauer",
          "fullname": "Robin Salvatore Fellhauer",
          "gender": "male",
          "birthday": "21.01.1998",
          "height": "183",
          "weight": "76",
          "person_detail": {
            "id": "271178",
            "position_1": "7",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Mannheim",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "oivi495h0xuu6sw8i1ra6dpl",
        "firstName": "Robin Salvatore",
        "lastName": "Fellhauer",
        "shortFirstName": "Robin",
        "shortLastName": "Fellhauer",
        "matchName": "R. Fellhauer",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "349133": {
      "optaId": "e5gsmkgu13y4f0abcwmeyjwet",
      "heimPlayer": {
        "id": "99154453",
        "team_id": "13914",
        "person": {
          "id": "349133",
          "name": "Pêpê",
          "firstname": "",
          "surname": "Pêpê",
          "fullname": "Pedro Filipe Figueiredo Rodrigues",
          "gender": "male",
          "birthday": "20.05.1997",
          "height": "183",
          "weight": "69",
          "person_detail": {
            "id": "271186",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Sátão",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "88"
      },
      "optaPlayer": {
        "playerId": "e5gsmkgu13y4f0abcwmeyjwet",
        "firstName": "Pedro Filipe",
        "lastName": "Figueiredo Rodrigues",
        "shortFirstName": "Pedro Filipe",
        "shortLastName": "Figueiredo Rodrigues",
        "knownName": "Pêpê Rodrigues",
        "matchName": "Pêpê Rodrigues",
        "shirtNumber": 88,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "349135": {
      "optaId": "e91s5lp3fvfaav8w8xi7wdx3p",
      "heimPlayer": {
        "id": "96927829",
        "team_id": "530",
        "person": {
          "id": "349135",
          "name": "Aurélio Buta",
          "firstname": "",
          "surname": "Aurélio Buta",
          "fullname": "Aurélio Gabriel Ulineia Buta",
          "gender": "male",
          "birthday": "10.02.1997",
          "height": "172",
          "weight": "66",
          "person_detail": {
            "id": "271188",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Miconge",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "26.11.2025 22:35",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "e91s5lp3fvfaav8w8xi7wdx3p",
        "firstName": "Aurélio Gabriel Ulineia",
        "lastName": "Buta",
        "shortFirstName": "Aurélio Gabriel Ulineia",
        "shortLastName": "Buta",
        "knownName": "Aurélio Buta",
        "matchName": "Aurélio Buta",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "349139": {
      "optaId": "2t5s4f41jefzuzth0bhcixtcl",
      "heimPlayer": {
        "id": "101812976",
        "team_id": "1267",
        "person": {
          "id": "349139",
          "name": "Rúben Dias",
          "firstname": "",
          "surname": "Rúben Dias",
          "fullname": "Rúben Santos Gato Alves Dias",
          "gender": "male",
          "birthday": "14.05.1997",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "271192",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Amadora",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "2t5s4f41jefzuzth0bhcixtcl",
        "firstName": "Rúben",
        "lastName": "dos Santos Gato Alves Dias",
        "shortFirstName": "Rúben",
        "shortLastName": "dos Santos Gato Alves Dias",
        "knownName": "Rúben Dias",
        "matchName": "Rúben Dias",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "349562": {
      "optaId": "29dp5gmu5xbd04mozwxq5tjh1",
      "heimPlayer": {
        "id": "101303471",
        "team_id": "1226",
        "person": {
          "id": "349562",
          "name": "Joe Gomez",
          "firstname": "Joe",
          "surname": "Gomez",
          "fullname": "Joseph Dave Gomez",
          "gender": "male",
          "birthday": "23.05.1997",
          "height": "188",
          "weight": "77",
          "person_detail": {
            "id": "271604",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Catford, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "10.03.2026 17:41",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "29dp5gmu5xbd04mozwxq5tjh1",
        "firstName": "Joseph Dave",
        "lastName": "Gomez",
        "shortFirstName": "Joe",
        "shortLastName": "Gomez",
        "matchName": "J. Gomez",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "350226": {
      "optaId": "1po7tmdv73zfjentt0p20wdlh",
      "heimPlayer": {
        "id": "102100463",
        "team_id": "21",
        "person": {
          "id": "350226",
          "name": "Stefan Posch",
          "firstname": "Stefan",
          "surname": "Posch",
          "fullname": "Stefan Posch",
          "gender": "male",
          "birthday": "14.05.1997",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "272245",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Judenburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "1po7tmdv73zfjentt0p20wdlh",
        "firstName": "Stefan",
        "lastName": "Posch",
        "shortFirstName": "Stefan",
        "shortLastName": "Posch",
        "matchName": "S. Posch",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "350658": {
      "optaId": "2uz1cmslnjjzsgfcgji26kqg9",
      "heimPlayer": {
        "id": "101925515",
        "team_id": "29680",
        "person": {
          "id": "350658",
          "name": "David Raum",
          "firstname": "David",
          "surname": "Raum",
          "fullname": "David Raum",
          "gender": "male",
          "birthday": "22.04.1998",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "272671",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Nürnberg",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "2uz1cmslnjjzsgfcgji26kqg9",
        "firstName": "David",
        "lastName": "Raum",
        "shortFirstName": "David",
        "shortLastName": "Raum",
        "matchName": "D. Raum",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3",
        "captain": "yes"
      }
    },
    "351377": {
      "optaId": "8yiq2pl6mno23dgg2h7p2fcut",
      "heimPlayer": {
        "id": "102116579",
        "team_id": "702",
        "person": {
          "id": "351377",
          "name": "Eric Smith",
          "firstname": "Eric",
          "surname": "Smith",
          "fullname": "Eric Anders Smith",
          "gender": "male",
          "birthday": "08.01.1997",
          "height": "192",
          "weight": "86",
          "person_detail": {
            "id": "273304",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Halmstad",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:18",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "8yiq2pl6mno23dgg2h7p2fcut",
        "firstName": "Eric Anders",
        "lastName": "Smith",
        "shortFirstName": "Eric",
        "shortLastName": "Smith",
        "matchName": "E. Smith",
        "shirtNumber": 8,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "351497": {
      "optaId": "i48mf81fxn2af1xxjzfi8gr9",
      "heimPlayer": {
        "id": "98834365",
        "team_id": "1545",
        "person": {
          "id": "351497",
          "name": "Dani Ceballos",
          "firstname": "",
          "surname": "Dani Ceballos",
          "fullname": "Daniel Ceballos Fernández",
          "gender": "male",
          "birthday": "07.08.1996",
          "height": "179",
          "weight": "71",
          "person_detail": {
            "id": "273420",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Utrera, Sevilla",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 22:05",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "i48mf81fxn2af1xxjzfi8gr9",
        "firstName": "Daniel",
        "lastName": "Ceballos Fernández",
        "shortFirstName": "Dani",
        "shortLastName": "Ceballos",
        "matchName": "Dani Ceballos",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "352669": {
      "optaId": "b1lcxeihx8z6pfv1jef4j5jh1",
      "heimPlayer": {
        "id": "99157984",
        "team_id": "127",
        "person": {
          "id": "352669",
          "name": "Martin Ødegaard",
          "firstname": "Martin",
          "surname": "Ødegaard",
          "fullname": "Martin Ødegaard",
          "gender": "male",
          "birthday": "17.12.1998",
          "height": "178",
          "weight": "68",
          "person_detail": {
            "id": "274532",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Drammen",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "28.01.2026 22:03",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "b1lcxeihx8z6pfv1jef4j5jh1",
        "firstName": "Martin",
        "lastName": "Ødegaard",
        "shortFirstName": "Martin",
        "shortLastName": "Ødegaard",
        "matchName": "M. Ødegaard",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "353533": {
      "optaId": "payije8nojdfrbkuq9hj2sph",
      "heimPlayer": {
        "id": "102116831",
        "team_id": "702",
        "person": {
          "id": "353533",
          "name": "Mathias Rasmussen",
          "firstname": "Mathias",
          "surname": "Rasmussen",
          "fullname": "Mathias Knutsen Rasmussen",
          "gender": "male",
          "birthday": "25.11.1997",
          "height": "180",
          "weight": "65",
          "person_detail": {
            "id": "275313",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Lyngdal",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "payije8nojdfrbkuq9hj2sph",
        "firstName": "Mathias",
        "lastName": "Knutsen Rasmussen",
        "shortFirstName": "Mathias",
        "shortLastName": "Rasmussen",
        "matchName": "M. Rasmussen",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "353823": {
      "optaId": "do2fwr0qn3kg0qb40e3i36q51",
      "heimPlayer": {
        "id": "101804819",
        "team_id": "749",
        "person": {
          "id": "353823",
          "name": "Patrick Berg",
          "firstname": "Patrick",
          "surname": "Berg",
          "fullname": "Patrick Berg",
          "gender": "male",
          "birthday": "24.11.1997",
          "height": "178",
          "weight": "70",
          "person_detail": {
            "id": "275579",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Bodø",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "do2fwr0qn3kg0qb40e3i36q51",
        "firstName": "Patrick",
        "lastName": "Berg",
        "shortFirstName": "Patrick",
        "shortLastName": "Berg",
        "matchName": "P. Berg",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "354529": {
      "optaId": "9rjd95oqotnalxmv56v7p1r6d",
      "heimPlayer": {
        "id": "100518808",
        "team_id": "258",
        "person": {
          "id": "354529",
          "name": "Gregor Kobel",
          "firstname": "Gregor",
          "surname": "Kobel",
          "fullname": "Gregor Kobel",
          "gender": "male",
          "birthday": "06.12.1997",
          "height": "195",
          "weight": "88",
          "person_detail": {
            "id": "276282",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Zürich",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "9rjd95oqotnalxmv56v7p1r6d",
        "firstName": "Gregor",
        "lastName": "Kobel",
        "shortFirstName": "Gregor",
        "shortLastName": "Kobel",
        "matchName": "G. Kobel",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "354850": {
      "optaId": "2udtmz4lvh4vil16mxvo0j4l",
      "heimPlayer": {
        "id": "101812532",
        "team_id": "205",
        "person": {
          "id": "354850",
          "name": "Aleix García",
          "firstname": "",
          "surname": "Aleix García",
          "fullname": "Aleix García Serrano",
          "gender": "male",
          "birthday": "28.06.1997",
          "height": "173",
          "weight": "68",
          "person_detail": {
            "id": "276598",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Ulldecona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "2udtmz4lvh4vil16mxvo0j4l",
        "firstName": "Aleix",
        "lastName": "García Serrano",
        "shortFirstName": "Aleix",
        "shortLastName": "García",
        "matchName": "Aleix García",
        "shirtNumber": 24,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "354954": {
      "optaId": "f414ed8b0apdfxxa56mq04q1h",
      "heimPlayer": {
        "id": "95819662",
        "team_id": "1421",
        "person": {
          "id": "354954",
          "name": "Ulisses Garcia",
          "firstname": "Ulisses",
          "surname": "Garcia",
          "fullname": "Ulisses Alexandre Garcia Lopes",
          "gender": "male",
          "birthday": "11.01.1996",
          "height": "182",
          "weight": "73",
          "person_detail": {
            "id": "276703",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Almada",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "05.11.2025 19:55",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "f414ed8b0apdfxxa56mq04q1h",
        "firstName": "Ulisses Alexandre",
        "lastName": "Garcia Lopes",
        "shortFirstName": "Ulisses",
        "shortLastName": "Garcia",
        "matchName": "U. Garcia",
        "shirtNumber": 6,
        "position": "Wing Back",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "355253": {
      "optaId": "4as71su7n7lm5r2osfz1w8p1x",
      "heimPlayer": {
        "id": "99154459",
        "team_id": "13914",
        "person": {
          "id": "355253",
          "name": "Vlad Dragomir",
          "firstname": "Vlad",
          "surname": "Dragomir",
          "fullname": "Vlad Mihai Dragomir",
          "gender": "male",
          "birthday": "24.04.1999",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "276997",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Timişoara",
            "died": "no"
          },
          "country": [
            {
              "id": "171"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "4as71su7n7lm5r2osfz1w8p1x",
        "firstName": "Vlad Mihai",
        "lastName": "Dragomir",
        "shortFirstName": "Vlad",
        "shortLastName": "Dragomir",
        "matchName": "V. Dragomir",
        "shirtNumber": 30,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4",
        "captain": "yes"
      }
    },
    "355716": {
      "optaId": "c589fk8pfqvbukvtdqu1yhjv9",
      "heimPlayer": {
        "id": "101855723",
        "team_id": "1355",
        "person": {
          "id": "355716",
          "name": "Joelinton",
          "firstname": "",
          "surname": "Joelinton",
          "fullname": "Joelinton Cassio Apolinário de Lira",
          "gender": "male",
          "birthday": "14.08.1996",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "277452",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Aliança",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "c589fk8pfqvbukvtdqu1yhjv9",
        "firstName": "Joelinton Cássio",
        "lastName": "Apolinário de Lira",
        "shortFirstName": "Joelinton Cássio",
        "shortLastName": "Apolinário de Lira",
        "knownName": "Joelinton",
        "matchName": "Joelinton",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "355792": {
      "optaId": "egmcpa7j5clzga5m0zvg2f105",
      "heimPlayer": {
        "id": "99255619",
        "team_id": "594",
        "person": {
          "id": "355792",
          "name": "Mads Pedersen",
          "firstname": "Mads",
          "surname": "Pedersen",
          "fullname": "Mads Giersing Valentin Pedersen",
          "gender": "male",
          "birthday": "01.09.1996",
          "height": "174",
          "weight": "72",
          "person_detail": {
            "id": "277528",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Hørsholm",
            "died": "no"
          }
        },
        "created": "31.01.2026 17:06",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "egmcpa7j5clzga5m0zvg2f105",
        "firstName": "Mads Giersing Valentin",
        "lastName": "Pedersen",
        "shortFirstName": "Mads",
        "shortLastName": "Pedersen",
        "matchName": "M. Pedersen",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "356654": {
      "optaId": "ed20ebhqi5c32vbbsze8r6yuh",
      "heimPlayer": {
        "id": "101822891",
        "team_id": "127",
        "person": {
          "id": "356654",
          "name": "Kai Havertz",
          "firstname": "Kai",
          "surname": "Havertz",
          "fullname": "Kai Lukas Havertz",
          "gender": "male",
          "birthday": "11.06.1999",
          "height": "193",
          "weight": "82",
          "person_detail": {
            "id": "278354",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Aachen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "17.03.2026 22:25",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "ed20ebhqi5c32vbbsze8r6yuh",
        "firstName": "Kai Lukas",
        "lastName": "Havertz",
        "shortFirstName": "Kai",
        "shortLastName": "Havertz",
        "matchName": "K. Havertz",
        "shirtNumber": 29,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "356660": {
      "optaId": "23l48u4w5nj4036whjm3s49gp",
      "heimPlayer": {
        "id": "101925512",
        "team_id": "29680",
        "person": {
          "id": "356660",
          "name": "Ridle Baku",
          "firstname": "Ridle",
          "surname": "Baku",
          "fullname": "Bote Ridle Nzuzi Baku",
          "gender": "male",
          "birthday": "08.04.1998",
          "height": "176",
          "weight": "72",
          "person_detail": {
            "id": "278360",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Mainz",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "23l48u4w5nj4036whjm3s49gp",
        "firstName": "Bote Ridle",
        "lastName": "Nzuzi Baku",
        "shortFirstName": "Ridle",
        "shortLastName": "Baku",
        "matchName": "R. Baku",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "356698": {
      "optaId": "euywniqwcq40dqoo55xni961h",
      "heimPlayer": {
        "id": "101524364",
        "team_id": "5",
        "person": {
          "id": "356698",
          "name": "Mathias Honsak",
          "firstname": "Mathias",
          "surname": "Honsak",
          "fullname": "Mathias Honsak",
          "gender": "male",
          "birthday": "20.12.1996",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "278398",
            "position_1": "10",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Wien",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:07",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "euywniqwcq40dqoo55xni961h",
        "firstName": "Mathias",
        "lastName": "Honsak",
        "shortFirstName": "Mathias",
        "shortLastName": "Honsak",
        "matchName": "M. Honsak",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "358208": {
      "optaId": "dqrzogrwznyks6whhfhq748ut",
      "heimPlayer": {
        "id": "100518811",
        "team_id": "258",
        "person": {
          "id": "358208",
          "name": "Ramy Bensebaïni",
          "firstname": "Ramy",
          "surname": "Bensebaïni",
          "fullname": "Amir Selmane Ramy Bensebaïni",
          "gender": "male",
          "birthday": "16.04.1995",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "279893",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Constantine",
            "died": "no"
          },
          "country": [
            {
              "id": "4"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "dqrzogrwznyks6whhfhq748ut",
        "firstName": "Amir Selmane Ramy",
        "lastName": "Bensebaini",
        "shortFirstName": "Ramy",
        "shortLastName": "Bensebaini",
        "matchName": "R. Bensebaini",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "358706": {
      "optaId": "cio1emair88b1xnhiol0lr7px",
      "heimPlayer": {
        "id": "99154651",
        "team_id": "17544",
        "person": {
          "id": "358706",
          "name": "Dan Glazer",
          "firstname": "Dan",
          "surname": "Glazer",
          "fullname": "Dan Leon Glazer",
          "gender": "male",
          "birthday": "20.09.1996",
          "height": "178",
          "weight": "67",
          "person_detail": {
            "id": "280377",
            "position_1": "7",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Tel Aviv",
            "died": "no"
          },
          "country": [
            {
              "id": "88"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "cio1emair88b1xnhiol0lr7px",
        "firstName": "Dan Leon",
        "lastName": "Glazer",
        "shortFirstName": "Dan",
        "shortLastName": "Glazer",
        "matchName": "D. Glazer",
        "shirtNumber": 18,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "359012": {
      "optaId": "6b7p3ncup75mpop91n0u1mw2d",
      "heimPlayer": {
        "id": "102001826",
        "team_id": "9",
        "person": {
          "id": "359012",
          "name": "Marius Bülter",
          "firstname": "Marius",
          "surname": "Bülter",
          "fullname": "Marius Bülter",
          "gender": "male",
          "birthday": "29.03.1993",
          "height": "188",
          "weight": "85",
          "person_detail": {
            "id": "280680",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Ibbenbüren",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:06",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "6b7p3ncup75mpop91n0u1mw2d",
        "firstName": "Marius",
        "lastName": "Bülter",
        "shortFirstName": "Marius",
        "shortLastName": "Bülter",
        "matchName": "M. Bülter",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "359856": {
      "optaId": "1zumt9vkrqd8d3p3eqtwezi6t",
      "heimPlayer": {
        "id": "98850682",
        "team_id": "530",
        "person": {
          "id": "359856",
          "name": "Robin Koch",
          "firstname": "Robin",
          "surname": "Koch",
          "fullname": "Robin Leon Koch",
          "gender": "male",
          "birthday": "17.07.1996",
          "height": "191",
          "weight": "86",
          "person_detail": {
            "id": "281522",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Kaiserslautern",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "1zumt9vkrqd8d3p3eqtwezi6t",
        "firstName": "Robin Leon",
        "lastName": "Koch",
        "shortFirstName": "Robin",
        "shortLastName": "Koch",
        "matchName": "R. Koch",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "359911": {
      "optaId": "4gq1u1mqg0qzekh1u5djleeax",
      "heimPlayer": {
        "id": "101863535",
        "team_id": "597",
        "person": {
          "id": "359911",
          "name": "Dani Olmo",
          "firstname": "",
          "surname": "Dani Olmo",
          "fullname": "Daniel Olmo Carvajal",
          "gender": "male",
          "birthday": "07.05.1998",
          "height": "179",
          "weight": "72",
          "person_detail": {
            "id": "281578",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Terrassa",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 20:16",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "4gq1u1mqg0qzekh1u5djleeax",
        "firstName": "Daniel",
        "lastName": "Olmo Carvajal",
        "shortFirstName": "Dani",
        "shortLastName": "Olmo",
        "matchName": "Dani Olmo",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "360216": {
      "optaId": "dglkt5h4m18p1qcj2uhqymvv9",
      "heimPlayer": {
        "id": "101861138",
        "team_id": "853",
        "person": {
          "id": "360216",
          "name": "Roland Sallai",
          "firstname": "Roland",
          "surname": "Sallai",
          "fullname": "Roland Sallai",
          "gender": "male",
          "birthday": "22.05.1997",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "281882",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Budapest",
            "died": "no"
          },
          "country": [
            {
              "id": "226"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "dglkt5h4m18p1qcj2uhqymvv9",
        "firstName": "Roland",
        "lastName": "Sallai",
        "shortFirstName": "Roland",
        "shortLastName": "Sallai",
        "matchName": "R. Sallai",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "360368": {
      "optaId": "yzee990gbkpl00qdgr6h3r2t",
      "heimPlayer": {
        "id": "100492153",
        "team_id": "1418",
        "person": {
          "id": "360368",
          "name": "Chiquinho",
          "firstname": "",
          "surname": "Chiquinho",
          "fullname": "Francisco Leonel Lima Silva Machado",
          "gender": "male",
          "birthday": "19.07.1995",
          "height": "174",
          "weight": "66",
          "person_detail": {
            "id": "282029",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Santo Tirso",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "yzee990gbkpl00qdgr6h3r2t",
        "firstName": "Francisco Leonel",
        "lastName": "Lima Silva Machado",
        "shortFirstName": "Francisco Leonel",
        "shortLastName": "Lima Silva Machado",
        "knownName": "Chiquinho",
        "matchName": "Chiquinho",
        "shirtNumber": 22,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "360829": {
      "optaId": "avk9yje6h4nndg3cufnbu2imt",
      "heimPlayer": {
        "id": "102158366",
        "team_id": "2076",
        "person": {
          "id": "360829",
          "name": "Ermedin Demirović",
          "firstname": "Ermedin",
          "surname": "Demirović",
          "fullname": "Ermedin Demirović",
          "gender": "male",
          "birthday": "25.03.1998",
          "height": "185",
          "weight": "84",
          "person_detail": {
            "id": "282477",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 21:11",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "avk9yje6h4nndg3cufnbu2imt",
        "firstName": "Ermedin",
        "lastName": "Demirović",
        "shortFirstName": "Ermedin",
        "shortLastName": "Demirovic",
        "matchName": "E. Demirović",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "361297": {
      "optaId": "7xc0qldxpidl07vij2wgu1sk5",
      "heimPlayer": {
        "id": "101976017",
        "team_id": "253",
        "person": {
          "id": "361297",
          "name": "Kevin Diks",
          "firstname": "Kevin",
          "surname": "Diks",
          "fullname": "Kevin Diks Bakarbessy",
          "gender": "male",
          "birthday": "06.10.1996",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "282945",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Apeldoorn",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "7xc0qldxpidl07vij2wgu1sk5",
        "firstName": "Kevin",
        "lastName": "Diks Bakarbessy",
        "shortFirstName": "Kevin",
        "shortLastName": "Diks",
        "matchName": "K. Diks",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "361425": {
      "optaId": "943lx505f9ple1gtxx9m178q1",
      "heimPlayer": {
        "id": "102116834",
        "team_id": "702",
        "person": {
          "id": "361425",
          "name": "Lars Ritzka",
          "firstname": "Lars",
          "surname": "Ritzka",
          "fullname": "Lars Ritzka",
          "gender": "male",
          "birthday": "07.05.1998",
          "height": "185",
          "weight": "78",
          "person_detail": {
            "id": "283062",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Hannover",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "943lx505f9ple1gtxx9m178q1",
        "firstName": "Lars",
        "lastName": "Ritzka",
        "shortFirstName": "Lars",
        "shortLastName": "Ritzka",
        "matchName": "L. Ritzka",
        "shirtNumber": 21,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "361662": {
      "optaId": "cjok1odm3twxo7sqye3hua6eh",
      "heimPlayer": {
        "id": "97396402",
        "team_id": "21",
        "person": {
          "id": "361662",
          "name": "Maxim Leitsch",
          "firstname": "Maxim",
          "surname": "Leitsch",
          "fullname": "Maxim Leitsch",
          "gender": "male",
          "birthday": "18.05.1998",
          "height": "188",
          "weight": "75",
          "person_detail": {
            "id": "283288",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Essen",
            "died": "no"
          }
        },
        "created": "05.12.2025 19:24",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "cjok1odm3twxo7sqye3hua6eh",
        "firstName": "Maxim",
        "lastName": "Leitsch",
        "shortFirstName": "Maxim",
        "shortLastName": "Leitsch",
        "matchName": "M. Leitsch",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "362020": {
      "optaId": "5q3ft0wiy6lsy937j7nw6msq1",
      "heimPlayer": {
        "id": "101972441",
        "team_id": "5",
        "person": {
          "id": "362020",
          "name": "Niklas Dorsch",
          "firstname": "Niklas",
          "surname": "Dorsch",
          "fullname": "Niklas Bernd Dorsch",
          "gender": "male",
          "birthday": "15.01.1998",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "283628",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Lichtenfels",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "5q3ft0wiy6lsy937j7nw6msq1",
        "firstName": "Niklas Bernd",
        "lastName": "Dorsch",
        "shortFirstName": "Niklas",
        "shortLastName": "Dorsch",
        "matchName": "N. Dorsch",
        "shirtNumber": 30,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "362189": {
      "optaId": "2znc8bmjc183pmz1xe1j8z0fd",
      "heimPlayer": {
        "id": "101976728",
        "team_id": "19",
        "person": {
          "id": "362189",
          "name": "Derrick Köhn",
          "firstname": "Derrick",
          "surname": "Köhn",
          "fullname": "Derrick Arthur Köhn",
          "gender": "male",
          "birthday": "04.02.1999",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "283762",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:31",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "2znc8bmjc183pmz1xe1j8z0fd",
        "firstName": "Derrick Arthur",
        "lastName": "Köhn",
        "shortFirstName": "Derrick",
        "shortLastName": "Köhn",
        "matchName": "D. Köhn",
        "shirtNumber": 39,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "362904": {
      "optaId": "5hst73ivtxknjb3rrdivwygnp",
      "heimPlayer": {
        "id": "101804816",
        "team_id": "749",
        "person": {
          "id": "362904",
          "name": "Sondre Fet",
          "firstname": "Sondre",
          "surname": "Fet",
          "fullname": "Sondre Brunstad Fet",
          "gender": "male",
          "birthday": "17.01.1997",
          "height": "178",
          "weight": "74",
          "person_detail": {
            "id": "284310",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Aure",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "5hst73ivtxknjb3rrdivwygnp",
        "firstName": "Sondre",
        "lastName": "Brunstad Fet",
        "shortFirstName": "Sondre",
        "shortLastName": "Fet",
        "matchName": "S. Fet",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "364088": {
      "optaId": "c1yctqdku2vzho2azsgcy5dcl",
      "heimPlayer": {
        "id": "91714139",
        "team_id": "2086",
        "person": {
          "id": "364088",
          "name": "Vaclav Černý",
          "firstname": "Vaclav",
          "surname": "Černý",
          "fullname": "Vaclav Černý",
          "gender": "male",
          "birthday": "17.10.1997",
          "height": "182",
          "weight": "65",
          "person_detail": {
            "id": "285396",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Příbram",
            "died": "no"
          }
        },
        "created": "31.08.2025 16:36",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "c1yctqdku2vzho2azsgcy5dcl",
        "firstName": "Václav",
        "lastName": "Černý",
        "shortFirstName": "Václav",
        "shortLastName": "Cerny",
        "matchName": "V. Černý",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "364466": {
      "optaId": "atigcsq78g14w82lwvay26aj9",
      "heimPlayer": {
        "id": "98830576",
        "team_id": "127",
        "person": {
          "id": "364466",
          "name": "Mikel Merino",
          "firstname": "",
          "surname": "Mikel Merino",
          "fullname": "Mikel Merino Zazón",
          "gender": "male",
          "birthday": "22.06.1996",
          "height": "189",
          "weight": "83",
          "person_detail": {
            "id": "285774",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Pamplona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 20:03",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "atigcsq78g14w82lwvay26aj9",
        "firstName": "Mikel",
        "lastName": "Merino Zazón",
        "shortFirstName": "Mikel",
        "shortLastName": "Merino",
        "matchName": "Mikel Merino",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "364467": {
      "optaId": "do5tibysnhbnbw18nwdo39kut",
      "heimPlayer": {
        "id": "99158392",
        "team_id": "156",
        "person": {
          "id": "364467",
          "name": "Álex Berenguer",
          "firstname": "",
          "surname": "Álex Berenguer",
          "fullname": "Alejandro Berenguer Remiro",
          "gender": "male",
          "birthday": "04.07.1995",
          "height": "175",
          "weight": "73",
          "person_detail": {
            "id": "285775",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Barañain",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:09",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "do5tibysnhbnbw18nwdo39kut",
        "firstName": "Alejandro",
        "lastName": "Berenguer Remiro",
        "shortFirstName": "Alex",
        "shortLastName": "Berenguer",
        "matchName": "Alex Berenguer",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "364855": {
      "optaId": "ojqb7kv87o0cidbckgtg1rdh",
      "heimPlayer": {
        "id": "98850691",
        "team_id": "530",
        "person": {
          "id": "364855",
          "name": "Ellyes Skhiri",
          "firstname": "Ellyes",
          "surname": "Skhiri",
          "fullname": "Ellyes Joris Skhiri",
          "gender": "male",
          "birthday": "10.05.1995",
          "height": "185",
          "weight": "74",
          "person_detail": {
            "id": "286154",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Lunel",
            "died": "no"
          },
          "country": [
            {
              "id": "218"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "ojqb7kv87o0cidbckgtg1rdh",
        "firstName": "Ellyes Joris",
        "lastName": "Skhiri",
        "shortFirstName": "Ellyes",
        "shortLastName": "Skhiri",
        "matchName": "E. Skhiri",
        "shirtNumber": 15,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "365857": {
      "optaId": "bpprd2haoafk6y0rjans4iytx",
      "heimPlayer": {
        "id": "99152269",
        "team_id": "64",
        "person": {
          "id": "365857",
          "name": "Kasper Dolberg",
          "firstname": "Kasper",
          "surname": "Dolberg",
          "fullname": "Kasper Dolberg Rasmussen",
          "gender": "male",
          "birthday": "06.10.1997",
          "height": "187",
          "weight": "84",
          "person_detail": {
            "id": "287153",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Silkeborg",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bpprd2haoafk6y0rjans4iytx",
        "firstName": "Kasper",
        "lastName": "Dolberg Rasmussen",
        "shortFirstName": "Kasper",
        "shortLastName": "Dolberg",
        "matchName": "K. Dolberg",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "366271": {
      "optaId": "1px9whllb1pnprmgq4fjw3qhh",
      "heimPlayer": {
        "id": "102006227",
        "team_id": "943",
        "person": {
          "id": "366271",
          "name": "Miro Muheim",
          "firstname": "Miro",
          "surname": "Muheim",
          "fullname": "Miro Max Maria Muheim",
          "gender": "male",
          "birthday": "24.03.1998",
          "height": "182",
          "weight": "77",
          "person_detail": {
            "id": "287556",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Zürich",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "1px9whllb1pnprmgq4fjw3qhh",
        "firstName": "Miro Max Maria",
        "lastName": "Muheim",
        "shortFirstName": "Miro",
        "shortLastName": "Muheim",
        "matchName": "M. Muheim",
        "shirtNumber": 28,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3",
        "captain": "yes"
      }
    },
    "366468": {
      "optaId": "5e9ilgrz3tzg9kd1gk3yvrahh",
      "heimPlayer": {
        "id": "101823065",
        "team_id": "1545",
        "person": {
          "id": "366468",
          "name": "Kylian Mbappé",
          "firstname": "Kylian",
          "surname": "Mbappé",
          "fullname": "Kylian Mbappé Lottin",
          "gender": "male",
          "birthday": "20.12.1998",
          "height": "178",
          "weight": "73",
          "person_detail": {
            "id": "287752",
            "position_1": "11",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Paris",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 22:29",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "5e9ilgrz3tzg9kd1gk3yvrahh",
        "firstName": "Kylian",
        "lastName": "Mbappé Lottin",
        "shortFirstName": "Kylian",
        "shortLastName": "Mbappé",
        "matchName": "K. Mbappé",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "366737": {
      "optaId": "7dayrhr0c60zbc1b6lig8pm8l",
      "heimPlayer": {
        "id": "99211111",
        "team_id": "9",
        "person": {
          "id": "366737",
          "name": "Alessio Castro-Montes",
          "firstname": "Alessio",
          "surname": "Castro-Montes",
          "fullname": "Alessio Daniel Castro-Montes",
          "gender": "male",
          "birthday": "17.05.1997",
          "height": "175",
          "weight": "67",
          "person_detail": {
            "id": "288022",
            "position_1": "9",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Sint-Truiden",
            "died": "no"
          }
        },
        "created": "30.01.2026 19:23",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "7dayrhr0c60zbc1b6lig8pm8l",
        "firstName": "Alessio Daniel",
        "lastName": "Castro-Montes",
        "shortFirstName": "Alessio",
        "shortLastName": "Castro-Montes",
        "matchName": "A. Castro-Montes",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "366854": {
      "optaId": "3tzvbdszdrj1tayik9igbve8l",
      "heimPlayer": {
        "id": "99154840",
        "team_id": "156",
        "person": {
          "id": "366854",
          "name": "Guruzeta",
          "firstname": "",
          "surname": "Guruzeta",
          "fullname": "Gorka Guruzeta Rodríguez",
          "gender": "male",
          "birthday": "12.09.1996",
          "height": "188",
          "weight": "77",
          "person_detail": {
            "id": "288133",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Donostia-San Sebastián",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "3tzvbdszdrj1tayik9igbve8l",
        "firstName": "Gorka",
        "lastName": "Guruzeta Rodríguez",
        "shortFirstName": "Gorka",
        "shortLastName": "Guruzeta",
        "matchName": "Gorka Guruzeta",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "366906": {
      "optaId": "cu7dqkhlo7kms52cdes451bdh",
      "heimPlayer": {
        "id": "100492138",
        "team_id": "1418",
        "person": {
          "id": "366906",
          "name": "Panagiotis Retsos",
          "firstname": "Panagiotis",
          "surname": "Retsos",
          "fullname": "Panagiotis Retsos",
          "gender": "male",
          "birthday": "09.08.1998",
          "height": "186",
          "weight": "79",
          "person_detail": {
            "id": "288185",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Johannesburg",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "cu7dqkhlo7kms52cdes451bdh",
        "firstName": "Panagiotis",
        "lastName": "Retsos",
        "shortFirstName": "Panagiotis",
        "shortLastName": "Retsos",
        "matchName": "P. Retsos",
        "shirtNumber": 45,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "367040": {
      "optaId": "83khslfie3xuqs32hbfi9b9at",
      "heimPlayer": {
        "id": "99154636",
        "team_id": "17544",
        "person": {
          "id": "367040",
          "name": "Egor Sorokin",
          "firstname": "Egor",
          "surname": "Sorokin",
          "fullname": "Egor Andreevich Sorokin",
          "gender": "male",
          "birthday": "04.11.1995",
          "height": "191",
          "weight": "81",
          "person_detail": {
            "id": "288319",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "St. Petersburg",
            "died": "no"
          },
          "country": [
            {
              "id": "172"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "80"
      },
      "optaPlayer": {
        "playerId": "83khslfie3xuqs32hbfi9b9at",
        "firstName": "Egor",
        "lastName": "Sorokin",
        "shortFirstName": "Egor",
        "shortLastName": "Sorokin",
        "matchName": "E. Sorokin",
        "shirtNumber": 80,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "367263": {
      "optaId": "4ml8pyt3rxwxakjxslg0c8kb9",
      "heimPlayer": {
        "id": "101862323",
        "team_id": "155",
        "person": {
          "id": "367263",
          "name": "Gianluca Scamacca",
          "firstname": "Gianluca",
          "surname": "Scamacca",
          "fullname": "Gianluca Scamacca",
          "gender": "male",
          "birthday": "01.01.1999",
          "height": "195",
          "weight": "85",
          "person_detail": {
            "id": "288538",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Roma",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "4ml8pyt3rxwxakjxslg0c8kb9",
        "firstName": "Gianluca",
        "lastName": "Scamacca",
        "shortFirstName": "Gianluca",
        "shortLastName": "Scamacca",
        "matchName": "G. Scamacca",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "367421": {
      "optaId": "72d5uxwcmvhd6mzthxuvev1sl",
      "heimPlayer": {
        "id": "100521931",
        "team_id": "136",
        "person": {
          "id": "367421",
          "name": "Wout Faes",
          "firstname": "Wout",
          "surname": "Faes",
          "fullname": "Wout Felix Lina Faes",
          "gender": "male",
          "birthday": "03.04.1998",
          "height": "187",
          "weight": "84",
          "person_detail": {
            "id": "288696",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Mol",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "72d5uxwcmvhd6mzthxuvev1sl",
        "firstName": "Wout Felix Lina",
        "lastName": "Faes",
        "shortFirstName": "Wout",
        "shortLastName": "Faes",
        "matchName": "W. Faes",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "367620": {
      "optaId": "6s9jrt5xu2i7tqcfhqct64mhh",
      "heimPlayer": {
        "id": "98683723",
        "team_id": "943",
        "person": {
          "id": "367620",
          "name": "Guilherme Ramos",
          "firstname": "",
          "surname": "Guilherme Ramos",
          "fullname": "Guilherme Magro Pires Ramos",
          "gender": "male",
          "birthday": "11.08.1997",
          "height": "191",
          "weight": "86",
          "person_detail": {
            "id": "288893",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Lisboa",
            "died": "no"
          }
        },
        "created": "17.01.2026 17:13",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "6s9jrt5xu2i7tqcfhqct64mhh",
        "firstName": "Guilherme",
        "lastName": "Magro Pires Ramos",
        "shortFirstName": "Guilherme",
        "shortLastName": "Magro Pires Ramos",
        "knownName": "Guilherme Ramos",
        "matchName": "Guilherme Ramos",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "367915": {
      "optaId": "3er9krmf0k6dhv6f9ltztfend",
      "heimPlayer": {
        "id": "91178273",
        "team_id": "594",
        "person": {
          "id": "367915",
          "name": "Arne Maier",
          "firstname": "Arne",
          "surname": "Maier",
          "fullname": "Arne Maier",
          "gender": "male",
          "birthday": "08.01.1999",
          "height": "186",
          "weight": "85",
          "person_detail": {
            "id": "289178",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Ludwigsfelde",
            "died": "no"
          }
        },
        "created": "23.08.2025 17:20",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "3er9krmf0k6dhv6f9ltztfend",
        "firstName": "Arne Carl",
        "lastName": "Maier",
        "shortFirstName": "Arne",
        "shortLastName": "Maier",
        "matchName": "A. Maier",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "367921": {
      "optaId": "cnf7quyillyf560nh14taliw9",
      "heimPlayer": {
        "id": "101975957",
        "team_id": "9",
        "person": {
          "id": "367921",
          "name": "Linton Maina",
          "firstname": "Linton",
          "surname": "Maina",
          "fullname": "Linton Maina",
          "gender": "male",
          "birthday": "23.06.1999",
          "height": "173",
          "weight": "70",
          "person_detail": {
            "id": "289184",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "cnf7quyillyf560nh14taliw9",
        "firstName": "Linton",
        "lastName": "Maina",
        "shortFirstName": "Linton",
        "shortLastName": "Maina",
        "matchName": "L. Maina",
        "shirtNumber": 37,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "368328": {
      "optaId": "f3v58fkymhrprt5gs0ccm29xx",
      "heimPlayer": {
        "id": "98831065",
        "team_id": "1457",
        "person": {
          "id": "368328",
          "name": "Fabián Ruiz",
          "firstname": "",
          "surname": "Fabián Ruiz",
          "fullname": "Fabián Ruiz Peña",
          "gender": "male",
          "birthday": "03.04.1996",
          "height": "189",
          "weight": "70",
          "person_detail": {
            "id": "289587",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Los Palacios y Villafranca",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 20:06",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "f3v58fkymhrprt5gs0ccm29xx",
        "firstName": "Fabián",
        "lastName": "Ruiz Peña",
        "shortFirstName": "Fabián",
        "shortLastName": "Ruiz",
        "matchName": "Fabián Ruiz",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "368828": {
      "optaId": "4sd2zs6d5cd4d9n3oo54lglat",
      "heimPlayer": {
        "id": "100245100",
        "team_id": "2086",
        "person": {
          "id": "368828",
          "name": "Mattias Svanberg",
          "firstname": "Mattias",
          "surname": "Svanberg",
          "fullname": "Mattias Olof Svanberg",
          "gender": "male",
          "birthday": "05.01.1999",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "290067",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Malmö",
            "died": "no"
          }
        },
        "created": "21.02.2026 14:15",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "4sd2zs6d5cd4d9n3oo54lglat",
        "firstName": "Mattias Olof",
        "lastName": "Svanberg",
        "shortFirstName": "Mattias",
        "shortLastName": "Svanberg",
        "matchName": "M. Svanberg",
        "shirtNumber": 32,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "368872": {
      "optaId": "ahgd3on22t4h7gg9ipnj1itw5",
      "heimPlayer": {
        "id": "100492456",
        "team_id": "1052",
        "person": {
          "id": "368872",
          "name": "Nicolò Barella",
          "firstname": "Nicolò",
          "surname": "Barella",
          "fullname": "Nicolò Barella",
          "gender": "male",
          "birthday": "07.02.1997",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "290106",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Cagliari",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "ahgd3on22t4h7gg9ipnj1itw5",
        "firstName": "Nicolò",
        "lastName": "Barella",
        "shortFirstName": "Nicolò",
        "shortLastName": "Barella",
        "matchName": "N. Barella",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "369053": {
      "optaId": "3g5ot4cvu4g9lflwa4u8pcvrp",
      "heimPlayer": {
        "id": "101861111",
        "team_id": "853",
        "person": {
          "id": "369053",
          "name": "Uğurcan Çakır",
          "firstname": "Uğurcan",
          "surname": "Çakır",
          "fullname": "Uğurcan Çakır",
          "gender": "male",
          "birthday": "05.04.1996",
          "height": "191",
          "weight": "68",
          "person_detail": {
            "id": "290283",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Antalya",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "3g5ot4cvu4g9lflwa4u8pcvrp",
        "firstName": "Uğurcan",
        "lastName": "Çakır",
        "shortFirstName": "Ugurcan",
        "shortLastName": "Çakir",
        "matchName": "U. Çakır",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "369060": {
      "optaId": "9bq6ktvpmk31z74eqdwu4qk7p",
      "heimPlayer": {
        "id": "100150138",
        "team_id": "18670",
        "person": {
          "id": "369060",
          "name": "Bəhlul Mustafazadə",
          "firstname": "Bəhlul",
          "surname": "Mustafazadə",
          "fullname": "Bəhlul Ələmdar oğlu Mustafazadə",
          "gender": "male",
          "birthday": "27.02.1997",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "290290",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "İmişli",
            "died": "no"
          },
          "country": [
            {
              "id": "15"
            }
          ]
        },
        "created": "18.02.2026 17:36",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "9bq6ktvpmk31z74eqdwu4qk7p",
        "firstName": "Bəhlul",
        "lastName": "Mustafazadə",
        "shortFirstName": "Bahlul",
        "shortLastName": "Mustafazada",
        "matchName": "B. Mustafazadə",
        "shirtNumber": 13,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "369320": {
      "optaId": "7c2wnewpcf1idj6ghj6gu0wyd",
      "heimPlayer": {
        "id": "101811986",
        "team_id": "373",
        "person": {
          "id": "369320",
          "name": "Marc Cucurella",
          "firstname": "Marc",
          "surname": "Cucurella",
          "fullname": "Marc Cucurella Saseta",
          "gender": "male",
          "birthday": "22.07.1998",
          "height": "173",
          "weight": "68",
          "person_detail": {
            "id": "290547",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Alella",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "7c2wnewpcf1idj6ghj6gu0wyd",
        "firstName": "Marc",
        "lastName": "Cucurella Saseta",
        "shortFirstName": "Marc",
        "shortLastName": "Cucurella",
        "matchName": "Marc Cucurella",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "369321": {
      "optaId": "3zg0pvrja75d3l44dq0lh4kb9",
      "heimPlayer": {
        "id": "101815409",
        "team_id": "749",
        "person": {
          "id": "369321",
          "name": "Andreas Helmersen",
          "firstname": "Andreas",
          "surname": "Helmersen",
          "fullname": "Andreas Klausen Helmersen",
          "gender": "male",
          "birthday": "15.03.1998",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "290548",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Trondheim",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 20:22",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "3zg0pvrja75d3l44dq0lh4kb9",
        "firstName": "Andreas",
        "lastName": "Klausen Helmersen",
        "shortFirstName": "Andreas",
        "shortLastName": "Helmersen",
        "matchName": "A. Helmersen",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "369331": {
      "optaId": "byaovvyzh22vsvs0iitqeciy1",
      "heimPlayer": {
        "id": "100493326",
        "team_id": "18670",
        "person": {
          "id": "369331",
          "name": "Joni Montiel",
          "firstname": "",
          "surname": "Joni Montiel",
          "fullname": "Jonathan Montiel Caballero",
          "gender": "male",
          "birthday": "03.09.1998",
          "height": "173",
          "weight": "67",
          "person_detail": {
            "id": "290558",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "byaovvyzh22vsvs0iitqeciy1",
        "firstName": "Jonathan",
        "lastName": "Montiel Caballero",
        "shortFirstName": "Joni",
        "shortLastName": "Montiel",
        "matchName": "Joni Montiel",
        "shirtNumber": 9,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "369704": {
      "optaId": "21k54i5a6d9bi4f6gplgzxiw9",
      "heimPlayer": {
        "id": "99153892",
        "team_id": "1502",
        "person": {
          "id": "369704",
          "name": "Guus Til",
          "firstname": "Guus",
          "surname": "Til",
          "fullname": "Guus Berend Til",
          "gender": "male",
          "birthday": "22.12.1997",
          "height": "186",
          "weight": "79",
          "person_detail": {
            "id": "290929",
            "position_1": "8",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Samfya",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "21k54i5a6d9bi4f6gplgzxiw9",
        "firstName": "Guus Berend",
        "lastName": "Til",
        "shortFirstName": "Guus",
        "shortLastName": "Til",
        "matchName": "G. Til",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "369823": {
      "optaId": "6a0w73agnkslcc6gea1jxxzvt",
      "heimPlayer": {
        "id": "102117149",
        "team_id": "1639",
        "person": {
          "id": "369823",
          "name": "Jan-Niklas Beste",
          "firstname": "Jan-Niklas",
          "surname": "Beste",
          "fullname": "Jan-Niklas Beste",
          "gender": "male",
          "birthday": "04.01.1999",
          "height": "175",
          "weight": "66",
          "person_detail": {
            "id": "291046",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Hamm",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "6a0w73agnkslcc6gea1jxxzvt",
        "firstName": "Jan-Niklas",
        "lastName": "Beste",
        "shortFirstName": "Niklas",
        "shortLastName": "Beste",
        "matchName": "N. Beste",
        "shirtNumber": 19,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "370625": {
      "optaId": "19z8jmren3eytg7fbuzqv73kl",
      "heimPlayer": {
        "id": "101813051",
        "team_id": "1545",
        "person": {
          "id": "370625",
          "name": "Trent Alexander-Arnold",
          "firstname": "Trent",
          "surname": "Alexander-Arnold",
          "fullname": "Trent John Alexander-Arnold",
          "gender": "male",
          "birthday": "07.10.1998",
          "height": "175",
          "weight": "69",
          "person_detail": {
            "id": "291845",
            "position_1": "5",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Liverpool",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "19z8jmren3eytg7fbuzqv73kl",
        "firstName": "Trent John",
        "lastName": "Alexander-Arnold",
        "shortFirstName": "Trent",
        "shortLastName": "Alexander-Arnold",
        "matchName": "T. Alexander-Arnold",
        "shirtNumber": 12,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "370892": {
      "optaId": "cp5hkhz2p2twjtiw8vphfv9hx",
      "heimPlayer": {
        "id": "101861129",
        "team_id": "853",
        "person": {
          "id": "370892",
          "name": "Lucas Torreira",
          "firstname": "Lucas",
          "surname": "Torreira",
          "fullname": "Lucas Sebastián Torreira Di Pascua",
          "gender": "male",
          "birthday": "11.02.1996",
          "height": "166",
          "weight": "65",
          "person_detail": {
            "id": "292093",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Fray Bentos",
            "died": "no"
          },
          "country": [
            {
              "id": "227"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "cp5hkhz2p2twjtiw8vphfv9hx",
        "firstName": "Lucas Sebastián",
        "lastName": "Torreira di Pascua",
        "shortFirstName": "Lucas",
        "shortLastName": "Torreira",
        "matchName": "L. Torreira",
        "shirtNumber": 34,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "370974": {
      "optaId": "2r6hs8npijvt4wekd059t6tx",
      "heimPlayer": {
        "id": "100502632",
        "team_id": "1052",
        "person": {
          "id": "370974",
          "name": "Denzel Dumfries",
          "firstname": "Denzel",
          "surname": "Dumfries",
          "fullname": "Denzel Justus Morris Dumfries",
          "gender": "male",
          "birthday": "18.04.1996",
          "height": "189",
          "weight": "81",
          "person_detail": {
            "id": "292169",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Rotterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "24.02.2026 22:39",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "2r6hs8npijvt4wekd059t6tx",
        "firstName": "Denzel Justus Morris",
        "lastName": "Dumfries",
        "shortFirstName": "Denzel",
        "shortLastName": "Dumfries",
        "matchName": "D. Dumfries",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "371881": {
      "optaId": "38qnvrvf3y1xs22tovwy21jv9",
      "heimPlayer": {
        "id": "101804807",
        "team_id": "749",
        "person": {
          "id": "371881",
          "name": "Jostein Gundersen",
          "firstname": "Jostein",
          "surname": "Gundersen",
          "fullname": "Jostein Maurstad Gundersen",
          "gender": "male",
          "birthday": "02.04.1996",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "292728",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Tromsø",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "38qnvrvf3y1xs22tovwy21jv9",
        "firstName": "Jostein",
        "lastName": "Maurstad Gundersen",
        "shortFirstName": "Jostein",
        "shortLastName": "Gundersen",
        "matchName": "J. Gundersen",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "372547": {
      "optaId": "c6nl81c1q4unq5js94s6s942x",
      "heimPlayer": {
        "id": "101868563",
        "team_id": "1226",
        "person": {
          "id": "372547",
          "name": "Federico Chiesa",
          "firstname": "Federico",
          "surname": "Chiesa",
          "fullname": "Federico Chiesa",
          "gender": "male",
          "birthday": "25.10.1997",
          "height": "175",
          "weight": "70",
          "person_detail": {
            "id": "293209",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Genova",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 22:48",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "c6nl81c1q4unq5js94s6s942x",
        "firstName": "Federico",
        "lastName": "Chiesa",
        "shortFirstName": "Federico",
        "shortLastName": "Chiesa",
        "matchName": "F. Chiesa",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "372657": {
      "optaId": "2jc6sdkse1kxjztsgystidot1",
      "heimPlayer": {
        "id": "100521934",
        "team_id": "136",
        "person": {
          "id": "372657",
          "name": "Denis Zakaria",
          "firstname": "Denis",
          "surname": "Zakaria",
          "fullname": "Denis Lemi Zakaria Lako Lado",
          "gender": "male",
          "birthday": "20.11.1996",
          "height": "191",
          "weight": "76",
          "person_detail": {
            "id": "293315",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Genf",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "2jc6sdkse1kxjztsgystidot1",
        "firstName": "Denis Lemi",
        "lastName": "Zakaria Lako Lado",
        "shortFirstName": "Denis",
        "shortLastName": "Zakaria",
        "matchName": "D. Zakaria",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "373216": {
      "optaId": "b3hr4q25jvqr7565z5ydqylt5",
      "heimPlayer": {
        "id": "100120783",
        "team_id": "1094",
        "person": {
          "id": "373216",
          "name": "Michele Di Gregorio",
          "firstname": "Michele",
          "surname": "Di Gregorio",
          "fullname": "Michele Di Gregorio",
          "gender": "male",
          "birthday": "27.07.1997",
          "height": "187",
          "weight": "88",
          "person_detail": {
            "id": "293832",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Milano",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "17.02.2026 17:43",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "b3hr4q25jvqr7565z5ydqylt5",
        "firstName": "Michele",
        "lastName": "Di Gregorio",
        "shortFirstName": "Michele",
        "shortLastName": "Di Gregorio",
        "matchName": "M. Di Gregorio",
        "shirtNumber": 16,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "373271": {
      "optaId": "ahz2npxe4geixkaz25f2pc82d",
      "heimPlayer": {
        "id": "100521748",
        "team_id": "1094",
        "person": {
          "id": "373271",
          "name": "Manuel Locatelli",
          "firstname": "Manuel",
          "surname": "Locatelli",
          "fullname": "Manuel Locatelli",
          "gender": "male",
          "birthday": "08.01.1998",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "293887",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Lecco",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "ahz2npxe4geixkaz25f2pc82d",
        "firstName": "Manuel",
        "lastName": "Locatelli",
        "shortFirstName": "Manuel",
        "shortLastName": "Locatelli",
        "matchName": "M. Locatelli",
        "shirtNumber": 5,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4",
        "captain": "yes"
      }
    },
    "373513": {
      "optaId": "ezviixcyaaj162saxs2yl27s9",
      "heimPlayer": {
        "id": "98853802",
        "team_id": "597",
        "person": {
          "id": "373513",
          "name": "Frenkie de Jong",
          "firstname": "Frenkie",
          "surname": "de Jong",
          "fullname": "Frenkie de Jong",
          "gender": "male",
          "birthday": "12.05.1997",
          "height": "181",
          "weight": "74",
          "person_detail": {
            "id": "294116",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Arkel",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "21.01.2026 19:56",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "ezviixcyaaj162saxs2yl27s9",
        "firstName": "Frenkie",
        "lastName": "de Jong",
        "shortFirstName": "Frenkie",
        "shortLastName": "de Jong",
        "matchName": "F. de Jong",
        "shirtNumber": 21,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "374383": {
      "optaId": "4cetkl0w2uq40ccti5ka6a4t1",
      "heimPlayer": {
        "id": "101812970",
        "team_id": "1267",
        "person": {
          "id": "374383",
          "name": "Gianluigi Donnarumma",
          "firstname": "Gianluigi",
          "surname": "Donnarumma",
          "fullname": "Gianluigi Donnarumma",
          "gender": "male",
          "birthday": "25.02.1999",
          "height": "196",
          "weight": "90",
          "person_detail": {
            "id": "294899",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Castellammare di Stabia",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "4cetkl0w2uq40ccti5ka6a4t1",
        "firstName": "Gianluigi",
        "lastName": "Donnarumma",
        "shortFirstName": "Gianluigi",
        "shortLastName": "Donnarumma",
        "matchName": "G. Donnarumma",
        "shirtNumber": 25,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "374545": {
      "optaId": "3n9jnuteyjx6w6dxviuead0b9",
      "heimPlayer": {
        "id": "99153028",
        "team_id": "2102",
        "person": {
          "id": "374545",
          "name": "Nicolas Pépé",
          "firstname": "Nicolas",
          "surname": "Pépé",
          "fullname": "Nicolas Pépé",
          "gender": "male",
          "birthday": "29.05.1995",
          "height": "183",
          "weight": "74",
          "person_detail": {
            "id": "294973",
            "position_1": "9",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Mantes-la-Jolie",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "3n9jnuteyjx6w6dxviuead0b9",
        "firstName": "Nicolas",
        "lastName": "Pépé",
        "shortFirstName": "Nicolas",
        "shortLastName": "Pépé",
        "matchName": "N. Pépé",
        "shirtNumber": 19,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "375773": {
      "optaId": "4vlurpsi44g09g159t61u83bp",
      "heimPlayer": {
        "id": "99154819",
        "team_id": "156",
        "person": {
          "id": "375773",
          "name": "Unai Simón",
          "firstname": "",
          "surname": "Unai Simón",
          "fullname": "Unai Simón Mendibil",
          "gender": "male",
          "birthday": "11.06.1997",
          "height": "190",
          "weight": "88",
          "person_detail": {
            "id": "295935",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Vitoria-Gasteiz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "4vlurpsi44g09g159t61u83bp",
        "firstName": "Unai",
        "lastName": "Simón Mendibil",
        "shortFirstName": "Unai",
        "shortLastName": "Simón",
        "matchName": "Unai Simón",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "377193": {
      "optaId": "8kar47kxxc8f20vc9ul2ez3yt",
      "heimPlayer": {
        "id": "101174347",
        "team_id": "19",
        "person": {
          "id": "377193",
          "name": "Oliver Burke",
          "firstname": "Oliver",
          "surname": "Burke",
          "fullname": "Oliver Jasen Burke",
          "gender": "male",
          "birthday": "07.04.1997",
          "height": "188",
          "weight": "74",
          "person_detail": {
            "id": "297136",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Kirkcaldy",
            "died": "no"
          }
        },
        "created": "08.03.2026 19:14",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "8kar47kxxc8f20vc9ul2ez3yt",
        "firstName": "Oliver Jasen",
        "lastName": "Burke",
        "shortFirstName": "Oliver",
        "shortLastName": "Burke",
        "matchName": "O. Burke",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "377323": {
      "optaId": "6xulax65kp4aid70nk7g5jr2t",
      "heimPlayer": {
        "id": "99159538",
        "team_id": "162",
        "person": {
          "id": "377323",
          "name": "Robin Le Normand",
          "firstname": "Robin",
          "surname": "Le Normand",
          "fullname": "Robin Le Normand",
          "gender": "male",
          "birthday": "11.11.1996",
          "height": "187",
          "weight": "81",
          "person_detail": {
            "id": "297266",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Pabu",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:37",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "6xulax65kp4aid70nk7g5jr2t",
        "firstName": "Robin Aimé Robert",
        "lastName": "Le Normand Mainfray",
        "shortFirstName": "Robin",
        "shortLastName": "Le Normand",
        "matchName": "Robin Le Normand",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "379963": {
      "optaId": "yq0cm7vwr0tkv7nvt9vo77bp",
      "heimPlayer": {
        "id": "98854027",
        "team_id": "1421",
        "person": {
          "id": "379963",
          "name": "Benjamin Pavard",
          "firstname": "Benjamin",
          "surname": "Pavard",
          "fullname": "Benjamin Pavard",
          "gender": "male",
          "birthday": "28.03.1996",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "299588",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Maubeuge",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "yq0cm7vwr0tkv7nvt9vo77bp",
        "firstName": "Benjamin Jacques Marcel",
        "lastName": "Pavard",
        "shortFirstName": "Benjamin",
        "shortLastName": "Pavard",
        "matchName": "B. Pavard",
        "shirtNumber": 28,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "380226": {
      "optaId": "eh70fwampgdyfv3hu25o2qx",
      "heimPlayer": {
        "id": "95820691",
        "team_id": "2102",
        "person": {
          "id": "380226",
          "name": "Pedraza",
          "firstname": "",
          "surname": "Pedraza",
          "fullname": "Alfonso Pedraza Sag",
          "gender": "male",
          "birthday": "09.04.1996",
          "height": "184",
          "weight": "73",
          "person_detail": {
            "id": "299847",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "San Sebastián de los Ballesteros",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "05.11.2025 20:06",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "eh70fwampgdyfv3hu25o2qx",
        "firstName": "Alfonso",
        "lastName": "Pedraza Sag",
        "shortFirstName": "Alfonso",
        "shortLastName": "Pedraza",
        "matchName": "Alfonso Pedraza",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "384101": {
      "optaId": "7sd87ylfbtgwgpb70hf68cel1",
      "heimPlayer": {
        "id": "100521625",
        "team_id": "1731",
        "person": {
          "id": "384101",
          "name": "Vangelis Pavlidis",
          "firstname": "Vangelis",
          "surname": "Pavlidis",
          "fullname": "Evangelos Pavlidis",
          "gender": "male",
          "birthday": "21.11.1998",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "303401",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Thessaloniki",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "7sd87ylfbtgwgpb70hf68cel1",
        "firstName": "Evangelos",
        "lastName": "Pavlidis",
        "shortFirstName": "Vangelis",
        "shortLastName": "Pavlidis",
        "matchName": "V. Pavlidis",
        "shirtNumber": 14,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "384352": {
      "optaId": "b3vvxolwxcukqk76hb4scvh79",
      "heimPlayer": {
        "id": "98854039",
        "team_id": "1421",
        "person": {
          "id": "384352",
          "name": "Michael Murillo",
          "firstname": "Michael",
          "surname": "Murillo",
          "fullname": "Michael Amir Murillo Bermúdez",
          "gender": "male",
          "birthday": "11.02.1996",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "303642",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Colón",
            "died": "no"
          },
          "country": [
            {
              "id": "161"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "62"
      },
      "optaPlayer": {
        "playerId": "b3vvxolwxcukqk76hb4scvh79",
        "firstName": "Michael Amir",
        "lastName": "Murillo Bermúdez",
        "shortFirstName": "Amir",
        "shortLastName": "Murillo",
        "matchName": "A. Murillo",
        "shirtNumber": 62,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "384715": {
      "optaId": "dqfk7czrayirrvonirtk2mk15",
      "heimPlayer": {
        "id": "101812985",
        "team_id": "1267",
        "person": {
          "id": "384715",
          "name": "Rodri",
          "firstname": "",
          "surname": "Rodri",
          "fullname": "Rodrigo Hernández Cascante",
          "gender": "male",
          "birthday": "22.06.1996",
          "height": "191",
          "weight": "82",
          "person_detail": {
            "id": "303988",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "dqfk7czrayirrvonirtk2mk15",
        "firstName": "Rodrigo",
        "lastName": "Hernández Cascante",
        "shortFirstName": "Rodrigo",
        "shortLastName": "Hernández Cascante",
        "knownName": "Rodri",
        "matchName": "Rodri",
        "shirtNumber": 16,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "384958": {
      "optaId": "5g5ml1wwa9dfhsh55hv7br45x",
      "heimPlayer": {
        "id": "102029279",
        "team_id": "943",
        "person": {
          "id": "384958",
          "name": "Jean-Luc Dompé",
          "firstname": "Jean-Luc",
          "surname": "Dompé",
          "fullname": "Jean-Luc Mamadou Diarra Dompé",
          "gender": "male",
          "birthday": "12.08.1995",
          "height": "170",
          "weight": "65",
          "person_detail": {
            "id": "304202",
            "position_1": "10",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Arpajon",
            "died": "no"
          }
        },
        "extra_minute": "1",
        "created": "21.03.2026 20:20",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "5g5ml1wwa9dfhsh55hv7br45x",
        "firstName": "Jean-Luc",
        "lastName": "Mamadou Diarra Dompé",
        "shortFirstName": "Jean-Luc",
        "shortLastName": "Dompé",
        "matchName": "J. Dompé",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "385021": {
      "optaId": "4ax49niuix9tiqdv05y3vbdn9",
      "heimPlayer": {
        "id": "98830975",
        "team_id": "1776",
        "person": {
          "id": "385021",
          "name": "Ricardo Mangas",
          "firstname": "",
          "surname": "Ricardo Mangas",
          "fullname": "Ricardo Luís Chaby Mangas",
          "gender": "male",
          "birthday": "19.03.1998",
          "height": "179",
          "weight": "75",
          "person_detail": {
            "id": "304256",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Olhão",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "20.01.2026 20:06",
        "shirtnumber": "91"
      },
      "optaPlayer": {
        "playerId": "4ax49niuix9tiqdv05y3vbdn9",
        "firstName": "Ricardo Luís",
        "lastName": "Chaby Mangas",
        "shortFirstName": "Ricardo Luís",
        "shortLastName": "Chaby Mangas",
        "knownName": "Ricardo Mangas",
        "matchName": "Ricardo Mangas",
        "shirtNumber": 91,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "385424": {
      "optaId": "2ugzqrpaooto1r24a6kvqf2ll",
      "heimPlayer": {
        "id": "100521751",
        "team_id": "1094",
        "person": {
          "id": "385424",
          "name": "Teun Koopmeiners",
          "firstname": "Teun",
          "surname": "Koopmeiners",
          "fullname": "Teun Koopmeiners",
          "gender": "male",
          "birthday": "28.02.1998",
          "height": "184",
          "weight": "77",
          "person_detail": {
            "id": "304622",
            "position_1": "8",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Castricum",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "2ugzqrpaooto1r24a6kvqf2ll",
        "firstName": "Teun",
        "lastName": "Koopmeiners",
        "shortFirstName": "Teun",
        "shortLastName": "Koopmeiners",
        "matchName": "T. Koopmeiners",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "386503": {
      "optaId": "97vuoqg0x9nx56dmd9u5e12hh",
      "heimPlayer": {
        "id": "100492156",
        "team_id": "1418",
        "person": {
          "id": "386503",
          "name": "Mehdi Taremi",
          "firstname": "Mehdi",
          "surname": "Taremi",
          "fullname": "Mehdi Taremi",
          "gender": "male",
          "birthday": "18.07.1992",
          "height": "185",
          "weight": "82",
          "person_detail": {
            "id": "305654",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Bushehr",
            "died": "no"
          },
          "country": [
            {
              "id": "85"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "99"
      },
      "optaPlayer": {
        "playerId": "97vuoqg0x9nx56dmd9u5e12hh",
        "firstName": "Mehdi",
        "lastName": "Taremi",
        "shortFirstName": "Mehdi",
        "shortLastName": "Taremi",
        "matchName": "M. Taremi",
        "shirtNumber": 99,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "387975": {
      "optaId": "7o11dzx2cccrslutrjl16ik89",
      "heimPlayer": {
        "id": "98850700",
        "team_id": "530",
        "person": {
          "id": "387975",
          "name": "Ritsu Dōan",
          "firstname": "Ritsu",
          "surname": "Dōan",
          "fullname": "Ritsu Dōan",
          "gender": "male",
          "birthday": "16.06.1998",
          "height": "172",
          "weight": "70",
          "person_detail": {
            "id": "307021",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Amagasaki, Hyogo",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "7o11dzx2cccrslutrjl16ik89",
        "firstName": "Ritsu",
        "lastName": "Doan",
        "shortFirstName": "Ritsu",
        "shortLastName": "Doan",
        "matchName": "R. Doan",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "388224": {
      "optaId": "66nvc8a4kd3cyeyj3i474cudx",
      "heimPlayer": {
        "id": "100492465",
        "team_id": "1052",
        "person": {
          "id": "388224",
          "name": "Marcus Thuram",
          "firstname": "Marcus",
          "surname": "Thuram",
          "fullname": "Marcus Lilian Thuram-Ulien",
          "gender": "male",
          "birthday": "06.08.1997",
          "height": "192",
          "weight": "88",
          "person_detail": {
            "id": "307238",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Parma",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "66nvc8a4kd3cyeyj3i474cudx",
        "firstName": "Marcus Lilian",
        "lastName": "Thuram-Ulien",
        "shortFirstName": "Marcus",
        "shortLastName": "Thuram",
        "matchName": "M. Thuram",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "388404": {
      "optaId": "9kxuwgequrilkom3ru6sdxall",
      "heimPlayer": {
        "id": "102001313",
        "team_id": "19",
        "person": {
          "id": "388404",
          "name": "Josip Juranović",
          "firstname": "Josip",
          "surname": "Juranović",
          "fullname": "Josip Juranović",
          "gender": "male",
          "birthday": "16.08.1995",
          "height": "173",
          "weight": "68",
          "person_detail": {
            "id": "307392",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Zagreb",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:04",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "9kxuwgequrilkom3ru6sdxall",
        "firstName": "Josip",
        "lastName": "Juranović",
        "shortFirstName": "Josip",
        "shortLastName": "Juranovic",
        "matchName": "J. Juranović",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "389121": {
      "optaId": "6q69l3ppqfqbryjubcrujfi6t",
      "heimPlayer": {
        "id": "101360597",
        "team_id": "1545",
        "person": {
          "id": "389121",
          "name": "Ferland Mendy",
          "firstname": "Ferland",
          "surname": "Mendy",
          "fullname": "Ferland Sinna Mendy",
          "gender": "male",
          "birthday": "08.06.1995",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "308056",
            "position_1": "3",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Meulan-en-Yvelines",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "11.03.2026 19:57",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "6q69l3ppqfqbryjubcrujfi6t",
        "firstName": "Ferland Sinna",
        "lastName": "Mendy",
        "shortFirstName": "Ferland",
        "shortLastName": "Mendy",
        "matchName": "F. Mendy",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "390172": {
      "optaId": "bjgxlgzxbm2fj3c2xq6mtsru1",
      "heimPlayer": {
        "id": "101804801",
        "team_id": "749",
        "person": {
          "id": "390172",
          "name": "Nikita Haikin",
          "firstname": "Nikita",
          "surname": "Haikin",
          "fullname": "Nikita Ilyich Haikin",
          "gender": "male",
          "birthday": "11.07.1995",
          "height": "186",
          "weight": "74",
          "person_detail": {
            "id": "309057",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Netanya",
            "died": "no"
          },
          "country": [
            {
              "id": "172"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "bjgxlgzxbm2fj3c2xq6mtsru1",
        "firstName": "Nikita",
        "lastName": "Haikin",
        "shortFirstName": "Nikita",
        "shortLastName": "Haikin",
        "matchName": "N. Haikin",
        "shirtNumber": 12,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "391993": {
      "optaId": "ckaqxlw257qzj8vjdumvwbaad",
      "heimPlayer": {
        "id": "101812445",
        "team_id": "1457",
        "person": {
          "id": "391993",
          "name": "Ousmane Dembélé",
          "firstname": "Ousmane",
          "surname": "Dembélé",
          "fullname": "Ousmane Dembélé",
          "gender": "male",
          "birthday": "15.05.1997",
          "height": "178",
          "weight": "67",
          "person_detail": {
            "id": "310806",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Vernon",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "ckaqxlw257qzj8vjdumvwbaad",
        "firstName": "Masour Ousmane",
        "lastName": "Dembélé",
        "shortFirstName": "Ousmane",
        "shortLastName": "Dembélé",
        "matchName": "O. Dembélé",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "396833": {
      "optaId": "6rtpb71r317mn3nsaqn0ksc89",
      "heimPlayer": {
        "id": "99158722",
        "team_id": "17544",
        "person": {
          "id": "396833",
          "name": "Valeriy Gromyko",
          "firstname": "Valeriy",
          "surname": "Gromyko",
          "fullname": "Valeryi Iharavich Hramyka",
          "gender": "male",
          "birthday": "23.01.1997",
          "height": "178",
          "weight": "71",
          "person_detail": {
            "id": "311588",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Minsk",
            "died": "no"
          },
          "country": [
            {
              "id": "22"
            }
          ]
        },
        "created": "28.01.2026 22:17",
        "shirtnumber": "55"
      },
      "optaPlayer": {
        "playerId": "6rtpb71r317mn3nsaqn0ksc89",
        "firstName": "Valeri",
        "lastName": "Gromyko",
        "shortFirstName": "Valeri",
        "shortLastName": "Gromyko",
        "matchName": "V. Gromyko",
        "shirtNumber": 55,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "397210": {
      "optaId": "55la79k6l8zifz8o9vbp20991",
      "heimPlayer": {
        "id": "101925836",
        "team_id": "24",
        "person": {
          "id": "397210",
          "name": "Bernardo",
          "firstname": "",
          "surname": "Bernardo",
          "fullname": "Bernardo Fernandes da Silva Junior",
          "gender": "male",
          "birthday": "14.05.1995",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "311947",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "São Paulo",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "55la79k6l8zifz8o9vbp20991",
        "firstName": "Bernardo",
        "lastName": "Fernandes da Silva Junior",
        "shortFirstName": "Bernardo",
        "shortLastName": "Fernandes da Silva Junior",
        "knownName": "Bernardo",
        "matchName": "Bernardo",
        "shirtNumber": 13,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "397215": {
      "optaId": "d66tmyj9pt69gub8pcjgo3bh1",
      "heimPlayer": {
        "id": "101362934",
        "team_id": "127",
        "person": {
          "id": "397215",
          "name": "Gabriel Jesus",
          "firstname": "",
          "surname": "Gabriel Jesus",
          "fullname": "Gabriel Fernando de Jesus",
          "gender": "male",
          "birthday": "03.04.1997",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "311952",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "11.03.2026 20:24",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "d66tmyj9pt69gub8pcjgo3bh1",
        "firstName": "Gabriel Fernando",
        "lastName": "de Jesus",
        "shortFirstName": "Gabriel Fernando",
        "shortLastName": "de Jesus",
        "knownName": "Gabriel Jesus",
        "matchName": "Gabriel Jesus",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "397535": {
      "optaId": "dnt7ahwfj8endqngxwfll1tjp",
      "heimPlayer": {
        "id": "98082895",
        "team_id": "21",
        "person": {
          "id": "397535",
          "name": "Andreas Hanche-Olsen",
          "firstname": "Andreas",
          "surname": "Hanche-Olsen",
          "fullname": "Andreas Schjølberg Hanche-Olsen",
          "gender": "male",
          "birthday": "17.01.1997",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "312220",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Bodø",
            "died": "no"
          }
        },
        "created": "21.12.2025 14:17",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "dnt7ahwfj8endqngxwfll1tjp",
        "firstName": "Andreas Schjølberg",
        "lastName": "Hanche-Olsen",
        "shortFirstName": "Andreas",
        "shortLastName": "Hanche-Olsen",
        "matchName": "A. Hanche-Olsen",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "398306": {
      "optaId": "6rutvrgco8li4nyz7tfayxb6x",
      "heimPlayer": {
        "id": "102134951",
        "team_id": "2076",
        "person": {
          "id": "398306",
          "name": "Deniz Undav",
          "firstname": "Deniz",
          "surname": "Undav",
          "fullname": "Deniz Undav",
          "gender": "male",
          "birthday": "19.07.1996",
          "height": "179",
          "weight": "86",
          "person_detail": {
            "id": "312966",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Varel",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "6rutvrgco8li4nyz7tfayxb6x",
        "firstName": "Deniz",
        "lastName": "Undav",
        "shortFirstName": "Deniz",
        "shortLastName": "Undav",
        "matchName": "D. Undav",
        "shirtNumber": 26,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9",
        "captain": "yes"
      }
    },
    "399317": {
      "optaId": "x4qyxhfr2vi007sazoqe5vit",
      "heimPlayer": {
        "id": "101310134",
        "team_id": "209",
        "person": {
          "id": "399317",
          "name": "Dayot Upamecano",
          "firstname": "Dayot",
          "surname": "Upamecano",
          "fullname": "Dayotchanculle Oswald Upamecano",
          "gender": "male",
          "birthday": "27.10.1998",
          "height": "186",
          "weight": "90",
          "person_detail": {
            "id": "313659",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Évreux",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "10.03.2026 19:57",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "x4qyxhfr2vi007sazoqe5vit",
        "firstName": "Dayotchanculle Oswald",
        "lastName": "Upamecano",
        "shortFirstName": "Dayot",
        "shortLastName": "Upamecano",
        "matchName": "D. Upamecano",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "399995": {
      "optaId": "9taxidttdt94nmvc3mqhqq0ut",
      "heimPlayer": {
        "id": "101999144",
        "team_id": "19",
        "person": {
          "id": "399995",
          "name": "Alex Král",
          "firstname": "Alex",
          "surname": "Král",
          "fullname": "Alex Král",
          "gender": "male",
          "birthday": "19.05.1998",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "314317",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Košice",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:49",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "9taxidttdt94nmvc3mqhqq0ut",
        "firstName": "Alex",
        "lastName": "Král",
        "shortFirstName": "Alex",
        "shortLastName": "Král",
        "matchName": "A. Král",
        "shirtNumber": 33,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "399996": {
      "optaId": "9qoc020keotb4s72a09zm5pzp",
      "heimPlayer": {
        "id": "99154513",
        "team_id": "1736",
        "person": {
          "id": "399996",
          "name": "Michal Sadílek",
          "firstname": "Michal",
          "surname": "Sadílek",
          "fullname": "Michal Sadílek",
          "gender": "male",
          "birthday": "31.05.1999",
          "height": "169",
          "weight": "61",
          "person_detail": {
            "id": "314318",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Uherské Hradištĕ",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "9qoc020keotb4s72a09zm5pzp",
        "firstName": "Michal",
        "lastName": "Sadílek",
        "shortFirstName": "Michal",
        "shortLastName": "Sadílek",
        "matchName": "M. Sadílek",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "401279": {
      "optaId": "8prrhz0d1i4vxkhgro8p42bxl",
      "heimPlayer": {
        "id": "101976572",
        "team_id": "19",
        "person": {
          "id": "401279",
          "name": "Tim Skarke",
          "firstname": "Tim",
          "surname": "Skarke",
          "fullname": "Tim Skarke",
          "gender": "male",
          "birthday": "07.09.1996",
          "height": "180",
          "weight": "79",
          "person_detail": {
            "id": "315255",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Heidenheim",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "8prrhz0d1i4vxkhgro8p42bxl",
        "firstName": "Tim",
        "lastName": "Skarke",
        "shortFirstName": "Tim",
        "shortLastName": "Skarke",
        "matchName": "T. Skarke",
        "shirtNumber": 21,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "401412": {
      "optaId": "9bqv99e39z86mn7dq3wnyt90p",
      "heimPlayer": {
        "id": "101861114",
        "team_id": "853",
        "person": {
          "id": "401412",
          "name": "Ismail Jakobs",
          "firstname": "Ismail",
          "surname": "Jakobs",
          "fullname": "Ismail Jakobs",
          "gender": "male",
          "birthday": "17.08.1999",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "315388",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Köln",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "9bqv99e39z86mn7dq3wnyt90p",
        "firstName": "Ismail Joshua",
        "lastName": "Jakobs",
        "shortFirstName": "Ismail",
        "shortLastName": "Jakobs",
        "matchName": "I. Jakobs",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "402171": {
      "optaId": "a3ib09ji7qsz6cgj3vmz5qort",
      "heimPlayer": {
        "id": "102157247",
        "team_id": "594",
        "person": {
          "id": "402171",
          "name": "Kristijan Jakić",
          "firstname": "Kristijan",
          "surname": "Jakić",
          "fullname": "Kristijan Jakić",
          "gender": "male",
          "birthday": "14.05.1997",
          "height": "181",
          "weight": "75",
          "person_detail": {
            "id": "316122",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Split",
            "died": "no"
          }
        },
        "created": "22.03.2026 20:55",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "a3ib09ji7qsz6cgj3vmz5qort",
        "firstName": "Kristijan",
        "lastName": "Jakić",
        "shortFirstName": "Kristijan",
        "shortLastName": "Jakic",
        "matchName": "K. Jakić",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "403139": {
      "optaId": "5pousbiuqbus68yekd0mhc5pl",
      "heimPlayer": {
        "id": "101925509",
        "team_id": "29680",
        "person": {
          "id": "403139",
          "name": "Christoph Baumgartner",
          "firstname": "Christoph",
          "surname": "Baumgartner",
          "fullname": "Christoph Baumgartner",
          "gender": "male",
          "birthday": "01.08.1999",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "317091",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Horn",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "5pousbiuqbus68yekd0mhc5pl",
        "firstName": "Christoph",
        "lastName": "Baumgartner",
        "shortFirstName": "Christoph",
        "shortLastName": "Baumgartner",
        "matchName": "C. Baumgartner",
        "shirtNumber": 14,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "404296": {
      "optaId": "3ojwbw6v83g9b0u2wssnkzzzd",
      "heimPlayer": {
        "id": "99153880",
        "team_id": "1502",
        "person": {
          "id": "404296",
          "name": "Armando Obispo",
          "firstname": "Armando",
          "surname": "Obispo",
          "fullname": "Armando Obispo",
          "gender": "male",
          "birthday": "05.03.1999",
          "height": "185",
          "weight": "72",
          "person_detail": {
            "id": "318215",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Boxtel",
            "died": "no"
          },
          "country": [
            {
              "id": "44"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "3ojwbw6v83g9b0u2wssnkzzzd",
        "firstName": "Armando Maria",
        "lastName": "Obispo",
        "shortFirstName": "Armando",
        "shortLastName": "Obispo",
        "matchName": "A. Obispo",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "406087": {
      "optaId": "3fo37mb4cp6lb0e86hhiyvu8l",
      "heimPlayer": {
        "id": "99156937",
        "team_id": "1776",
        "person": {
          "id": "406087",
          "name": "Matheus Reis",
          "firstname": "",
          "surname": "Matheus Reis",
          "fullname": "Matheus Reis de Lima",
          "gender": "male",
          "birthday": "18.02.1995",
          "height": "184",
          "weight": "80",
          "person_detail": {
            "id": "319766",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "São João da Boa Vista",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 21:26",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "3fo37mb4cp6lb0e86hhiyvu8l",
        "firstName": "Matheus",
        "lastName": "Reis de Lima",
        "shortFirstName": "Matheus",
        "shortLastName": "Reis de Lima",
        "knownName": "Matheus Reis",
        "matchName": "Matheus Reis",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "406438": {
      "optaId": "3ejpzdtnpo1r4yvxcq2e8cqg9",
      "heimPlayer": {
        "id": "99154447",
        "team_id": "13914",
        "person": {
          "id": "406438",
          "name": "Bruno",
          "firstname": "",
          "surname": "Bruno",
          "fullname": "Bruno Felipe Souza da Silva",
          "gender": "male",
          "birthday": "26.05.1994",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "320120",
            "position_1": "5",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "3ejpzdtnpo1r4yvxcq2e8cqg9",
        "firstName": "Bruno Felipe",
        "lastName": "Souza da Silva",
        "shortFirstName": "Bruno Felipe",
        "shortLastName": "Souza da Silva",
        "knownName": "Bruno Felipe",
        "matchName": "Bruno Felipe",
        "shirtNumber": 7,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "409131": {
      "optaId": "9psfk94nduz6icnuwty5v9all",
      "heimPlayer": {
        "id": "101868221",
        "team_id": "1226",
        "person": {
          "id": "409131",
          "name": "Cody Gakpo",
          "firstname": "Cody",
          "surname": "Gakpo",
          "fullname": "Cody Mathès Gakpo",
          "gender": "male",
          "birthday": "07.05.1999",
          "height": "193",
          "weight": "76",
          "person_detail": {
            "id": "322743",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Eindhoven",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 22:34",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "9psfk94nduz6icnuwty5v9all",
        "firstName": "Cody Mathès",
        "lastName": "Gakpo",
        "shortFirstName": "Cody",
        "shortLastName": "Gakpo",
        "matchName": "C. Gakpo",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "409138": {
      "optaId": "2e0o5pwinz3zhg9pqg5vej9ih",
      "heimPlayer": {
        "id": "100526002",
        "team_id": "136",
        "person": {
          "id": "409138",
          "name": "Jordan Teze",
          "firstname": "Jordan",
          "surname": "Teze",
          "fullname": "Jordan Teze",
          "gender": "male",
          "birthday": "30.09.1999",
          "height": "183",
          "weight": "68",
          "person_detail": {
            "id": "322750",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Groningen",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "25.02.2026 22:20",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "2e0o5pwinz3zhg9pqg5vej9ih",
        "firstName": "Jordan",
        "lastName": "Teze",
        "shortFirstName": "Jordan",
        "shortLastName": "Teze",
        "matchName": "J. Teze",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "409495": {
      "optaId": "dafbvyorudvujxw7zswicykmh",
      "heimPlayer": {
        "id": "99152245",
        "team_id": "64",
        "person": {
          "id": "409495",
          "name": "Owen Wijndal",
          "firstname": "Owen",
          "surname": "Wijndal",
          "fullname": "Owen Wijndal",
          "gender": "male",
          "birthday": "28.11.1999",
          "height": "176",
          "weight": "65",
          "person_detail": {
            "id": "323093",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Zaandam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "dafbvyorudvujxw7zswicykmh",
        "firstName": "Owen Colin",
        "lastName": "Wijndal",
        "shortFirstName": "Owen",
        "shortLastName": "Wijndal",
        "matchName": "O. Wijndal",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "409838": {
      "optaId": "afk5qdami9yzapywig6ds4quh",
      "heimPlayer": {
        "id": "102134459",
        "team_id": "594",
        "person": {
          "id": "409838",
          "name": "Cédric Zesiger",
          "firstname": "Cédric",
          "surname": "Zesiger",
          "fullname": "Cédric Zesiger",
          "gender": "male",
          "birthday": "24.06.1998",
          "height": "194",
          "weight": "92",
          "person_detail": {
            "id": "323432",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Meyriez FR",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "afk5qdami9yzapywig6ds4quh",
        "firstName": "Cédric Adrian",
        "lastName": "Zesiger",
        "shortFirstName": "Cédric",
        "shortLastName": "Zesiger",
        "matchName": "C. Zesiger",
        "shirtNumber": 16,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "410519": {
      "optaId": "9m66crpktao9g80wc8zi9y5ex",
      "heimPlayer": {
        "id": "97686370",
        "team_id": "13914",
        "person": {
          "id": "410519",
          "name": "João Correia",
          "firstname": "",
          "surname": "João Correia",
          "fullname": "João Pedro Araújo Correia",
          "gender": "male",
          "birthday": "05.09.1996",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "324110",
            "position_1": "5",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Setúbal",
            "died": "no"
          },
          "country": [
            {
              "id": "99"
            }
          ]
        },
        "created": "10.12.2025 19:52",
        "shirtnumber": "77"
      },
      "optaPlayer": {
        "playerId": "9m66crpktao9g80wc8zi9y5ex",
        "firstName": "João Pedro",
        "lastName": "Araújo Correia",
        "shortFirstName": "João Pedro",
        "shortLastName": "Araújo Correia",
        "knownName": "João Correia",
        "matchName": "João Correia",
        "shirtNumber": 77,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "410730": {
      "optaId": "cl6720rdjeubt0bc3su0qg3qh",
      "heimPlayer": {
        "id": "100518829",
        "team_id": "258",
        "person": {
          "id": "410730",
          "name": "Julian Ryerson",
          "firstname": "Julian",
          "surname": "Ryerson",
          "fullname": "Julian Ryerson",
          "gender": "male",
          "birthday": "17.11.1997",
          "height": "183",
          "weight": "86",
          "person_detail": {
            "id": "324320",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Lyngdal",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "cl6720rdjeubt0bc3su0qg3qh",
        "firstName": "Julian",
        "lastName": "Ryerson",
        "shortFirstName": "Julian",
        "shortLastName": "Ryerson",
        "matchName": "J. Ryerson",
        "shirtNumber": 26,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "413141": {
      "optaId": "73xu8dfkmgivh8l71hkqfe6sp",
      "heimPlayer": {
        "id": "101812817",
        "team_id": "127",
        "person": {
          "id": "413141",
          "name": "Viktor Gyökeres",
          "firstname": "Viktor",
          "surname": "Gyökeres",
          "fullname": "Viktor Einar Gyökeres",
          "gender": "male",
          "birthday": "04.06.1998",
          "height": "189",
          "weight": "90",
          "person_detail": {
            "id": "326711",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Stockholm",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "73xu8dfkmgivh8l71hkqfe6sp",
        "firstName": "Viktor Einar",
        "lastName": "Gyökeres",
        "shortFirstName": "Viktor",
        "shortLastName": "Gyökeres",
        "matchName": "V. Gyökeres",
        "shirtNumber": 14,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "413671": {
      "optaId": "bxjc2heo4ve54cyvw98qcck45",
      "heimPlayer": {
        "id": "100502062",
        "team_id": "1355",
        "person": {
          "id": "413671",
          "name": "Yoane Wissa",
          "firstname": "Yoane",
          "surname": "Wissa",
          "fullname": "Yoane Wissa",
          "gender": "male",
          "birthday": "03.09.1996",
          "height": "176",
          "weight": "74",
          "person_detail": {
            "id": "327203",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Villeneuve-Saint-George",
            "died": "no"
          },
          "country": [
            {
              "id": "51"
            }
          ]
        },
        "created": "24.02.2026 22:28",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bxjc2heo4ve54cyvw98qcck45",
        "firstName": "Yoane",
        "lastName": "Wissa Bileko",
        "shortFirstName": "Yoane",
        "shortLastName": "Wissa",
        "matchName": "Y. Wissa",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "413825": {
      "optaId": "6rg37ej1x7pwi7r4aq1107pih",
      "heimPlayer": {
        "id": "101812535",
        "team_id": "205",
        "person": {
          "id": "413825",
          "name": "Exequiel Palacios",
          "firstname": "Exequiel",
          "surname": "Palacios",
          "fullname": "Exequiel Alejandro Palacios",
          "gender": "male",
          "birthday": "05.10.1998",
          "height": "176",
          "weight": "69",
          "person_detail": {
            "id": "327357",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Famaillá",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "6rg37ej1x7pwi7r4aq1107pih",
        "firstName": "Exequiel Alejandro",
        "lastName": "Palacios",
        "shortFirstName": "Exequiel",
        "shortLastName": "Palacios",
        "matchName": "E. Palacios",
        "shirtNumber": 25,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "413869": {
      "optaId": "c6ip6gwp8yvchd1n3dv42go9",
      "heimPlayer": {
        "id": "99153877",
        "team_id": "1502",
        "person": {
          "id": "413869",
          "name": "Mauro Júnior",
          "firstname": "",
          "surname": "Mauro Júnior",
          "fullname": "Mauro Jaqueson Junior Ferreira dos Santos",
          "gender": "male",
          "birthday": "06.05.1999",
          "height": "171",
          "weight": "62",
          "person_detail": {
            "id": "327401",
            "position_1": "3",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "c6ip6gwp8yvchd1n3dv42go9",
        "firstName": "Mauro Jaqueson Júnior",
        "lastName": "Ferreira dos Santos",
        "shortFirstName": "Mauro Jaqueson Júnior",
        "shortLastName": "Ferreira dos Santos",
        "knownName": "Mauro Júnior",
        "matchName": "Mauro Júnior",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "413947": {
      "optaId": "7zbu2y3nlj4dyhe1qdj15g3xl",
      "heimPlayer": {
        "id": "101976032",
        "team_id": "253",
        "person": {
          "id": "413947",
          "name": "Philipp Sander",
          "firstname": "Philipp",
          "surname": "Sander",
          "fullname": "Philipp Sander",
          "gender": "male",
          "birthday": "21.02.1998",
          "height": "185",
          "weight": "78",
          "person_detail": {
            "id": "327479",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Rostock",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "7zbu2y3nlj4dyhe1qdj15g3xl",
        "firstName": "Philipp",
        "lastName": "Sander",
        "shortFirstName": "Philipp",
        "shortLastName": "Sander",
        "matchName": "P. Sander",
        "shirtNumber": 16,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "414043": {
      "optaId": "2o570lgb5c364c395zp1ccqqy",
      "heimPlayer": {
        "id": "100378591",
        "team_id": "5",
        "person": {
          "id": "414043",
          "name": "Tim Siersleben",
          "firstname": "Tim",
          "surname": "Siersleben",
          "fullname": "Tim Siersleben",
          "gender": "male",
          "birthday": "09.03.2000",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "327575",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Magdeburg",
            "died": "no"
          }
        },
        "created": "22.02.2026 18:15",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "2o570lgb5c364c395zp1ccqqy",
        "firstName": "Tim",
        "lastName": "Siersleben",
        "shortFirstName": "Tim",
        "shortLastName": "Siersleben",
        "matchName": "T. Siersleben",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "414117": {
      "optaId": "6dg2ztkkig9alktiq5zakbm5l",
      "heimPlayer": {
        "id": "101525261",
        "team_id": "5",
        "person": {
          "id": "414117",
          "name": "Omar Traoré",
          "firstname": "Omar",
          "surname": "Traoré",
          "fullname": "Omar Haktab Traoré",
          "gender": "male",
          "birthday": "04.02.1998",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "327649",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Osnabrück",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:11",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "6dg2ztkkig9alktiq5zakbm5l",
        "firstName": "Omar Haktab",
        "lastName": "Traoré",
        "shortFirstName": "Omar Haktab",
        "shortLastName": "Traoré",
        "matchName": "O. Traoré",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "414344": {
      "optaId": "d3tfdqfnab7bqxfdh3399y06i",
      "heimPlayer": {
        "id": "96922099",
        "team_id": "530",
        "person": {
          "id": "414344",
          "name": "Jonathan Burkardt",
          "firstname": "Jonathan",
          "surname": "Burkardt",
          "fullname": "Jonathan Michael Burkardt",
          "gender": "male",
          "birthday": "11.07.2000",
          "height": "181",
          "weight": "76",
          "person_detail": {
            "id": "327874",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Darmstadt",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "26.11.2025 19:52",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "d3tfdqfnab7bqxfdh3399y06i",
        "firstName": "Jonathan Michael",
        "lastName": "Burkardt",
        "shortFirstName": "Jonathan",
        "shortLastName": "Burkardt",
        "matchName": "J. Burkardt",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "414663": {
      "optaId": "7at6knpizbafid4br861pi6zt",
      "heimPlayer": {
        "id": "100595941",
        "team_id": "594",
        "person": {
          "id": "414663",
          "name": "Yannik Keitel",
          "firstname": "Yannik",
          "surname": "Keitel",
          "fullname": "Yannik Keitel",
          "gender": "male",
          "birthday": "15.02.2000",
          "height": "186",
          "weight": "85",
          "person_detail": {
            "id": "328192",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "both",
            "birth_place": "Breisach",
            "died": "no"
          }
        },
        "created": "27.02.2026 21:37",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "7at6knpizbafid4br861pi6zt",
        "firstName": "Yannik",
        "lastName": "Keitel",
        "shortFirstName": "Yannik",
        "shortLastName": "Keitel",
        "matchName": "Y. Keitel",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "415039": {
      "optaId": "ay6pvdyj5pjgwvjsqdfsrbw4q",
      "heimPlayer": {
        "id": "102126938",
        "team_id": "21",
        "person": {
          "id": "415039",
          "name": "Lennard Maloney",
          "firstname": "Lennard",
          "surname": "Maloney",
          "fullname": "Lennard Patrick Maloney",
          "gender": "male",
          "birthday": "08.10.1999",
          "height": "188",
          "weight": "89",
          "person_detail": {
            "id": "328559",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "extra_minute": "1",
        "created": "22.03.2026 17:20",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "ay6pvdyj5pjgwvjsqdfsrbw4q",
        "firstName": "Lennard Patrick",
        "lastName": "Maloney",
        "shortFirstName": "Lennard",
        "shortLastName": "Maloney",
        "matchName": "L. Maloney",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "415089": {
      "optaId": "f14n6d52p37nkvoo5n3i52x2h",
      "heimPlayer": {
        "id": "101999093",
        "team_id": "2134",
        "person": {
          "id": "415089",
          "name": "Felix Agu",
          "firstname": "Felix",
          "surname": "Agu",
          "fullname": "Felix Agu",
          "gender": "male",
          "birthday": "27.09.1999",
          "height": "180",
          "weight": "67",
          "person_detail": {
            "id": "328609",
            "position_1": "3",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Osnabrück",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:49",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "f14n6d52p37nkvoo5n3i52x2h",
        "firstName": "Felix",
        "lastName": "Agu",
        "shortFirstName": "Felix",
        "shortLastName": "Agu",
        "matchName": "F. Agu",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "415257": {
      "optaId": "1i9wi65k2foqwudeqiyih87hl",
      "heimPlayer": {
        "id": "101813063",
        "team_id": "1545",
        "person": {
          "id": "415257",
          "name": "Federico Valverde",
          "firstname": "Federico",
          "surname": "Valverde",
          "fullname": "Federico Santiago Valverde Dipetta",
          "gender": "male",
          "birthday": "22.07.1998",
          "height": "182",
          "weight": "78",
          "person_detail": {
            "id": "328777",
            "position_1": "13",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Montevideo",
            "died": "no"
          },
          "country": [
            {
              "id": "227"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "1i9wi65k2foqwudeqiyih87hl",
        "firstName": "Federico Santiago",
        "lastName": "Valverde Dipetta",
        "shortFirstName": "Federico",
        "shortLastName": "Valverde",
        "matchName": "F. Valverde",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "415412": {
      "optaId": "d5mck7rf48chzersephpx29d5",
      "heimPlayer": {
        "id": "99152599",
        "team_id": "258",
        "person": {
          "id": "415412",
          "name": "Nico Schlotterbeck",
          "firstname": "Nico",
          "surname": "Schlotterbeck",
          "fullname": "Nico Cedric Schlotterbeck",
          "gender": "male",
          "birthday": "01.12.1999",
          "height": "191",
          "weight": "86",
          "person_detail": {
            "id": "328932",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Waiblingen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "d5mck7rf48chzersephpx29d5",
        "firstName": "Nico Cedric",
        "lastName": "Schlotterbeck",
        "shortFirstName": "Nico",
        "shortLastName": "Schlotterbeck",
        "matchName": "N. Schlotterbeck",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "415615": {
      "optaId": "8sms9gmdoqxv60nckpyqxflqt",
      "heimPlayer": {
        "id": "102134456",
        "team_id": "594",
        "person": {
          "id": "415615",
          "name": "Dimitris Giannoulis",
          "firstname": "Dimitris",
          "surname": "Giannoulis",
          "fullname": "Dimitris Giannoulis",
          "gender": "male",
          "birthday": "17.10.1995",
          "height": "177",
          "weight": "71",
          "person_detail": {
            "id": "329135",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Katerini",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "8sms9gmdoqxv60nckpyqxflqt",
        "firstName": "Dimitrios Christos",
        "lastName": "Giannoulis",
        "shortFirstName": "Dimitrios",
        "shortLastName": "Giannoulis",
        "matchName": "D. Giannoulis",
        "shirtNumber": 13,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "416092": {
      "optaId": "980t379w5cp7umv1eltwlfca1",
      "heimPlayer": {
        "id": "101976725",
        "team_id": "19",
        "person": {
          "id": "416092",
          "name": "Stanley Nsoki",
          "firstname": "Stanley",
          "surname": "Nsoki",
          "fullname": "Stanley Pierre Nsoki",
          "gender": "male",
          "birthday": "09.04.1999",
          "height": "184",
          "weight": "83",
          "person_detail": {
            "id": "329594",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Poissy",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:31",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "980t379w5cp7umv1eltwlfca1",
        "firstName": "Stanley Pierre",
        "lastName": "Nsoki",
        "shortFirstName": "Stanley",
        "shortLastName": "Nsoki",
        "matchName": "S. Nsoki",
        "shirtNumber": 34,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "416097": {
      "optaId": "2zfjgh5747ge9r9q0thbk123t",
      "heimPlayer": {
        "id": "101861348",
        "team_id": "1226",
        "person": {
          "id": "416097",
          "name": "Ibrahima Konaté",
          "firstname": "Ibrahima",
          "surname": "Konaté",
          "fullname": "Ibrahima Konaté",
          "gender": "male",
          "birthday": "25.05.1999",
          "height": "194",
          "weight": "95",
          "person_detail": {
            "id": "329599",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Paris",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "2zfjgh5747ge9r9q0thbk123t",
        "firstName": "Ibrahima",
        "lastName": "Konaté",
        "shortFirstName": "Ibrahima",
        "shortLastName": "Konaté",
        "matchName": "I. Konaté",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "416099": {
      "optaId": "4xhnmoqgxoheel005ek6ckfs9",
      "heimPlayer": {
        "id": "96068722",
        "team_id": "2076",
        "person": {
          "id": "416099",
          "name": "Dan-Axel Zagadou",
          "firstname": "Dan-Axel",
          "surname": "Zagadou",
          "fullname": "Dan-Axel Zagadou",
          "gender": "male",
          "birthday": "03.06.1999",
          "height": "196",
          "weight": "90",
          "person_detail": {
            "id": "329601",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Créteil",
            "died": "no"
          }
        },
        "created": "09.11.2025 16:29",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "4xhnmoqgxoheel005ek6ckfs9",
        "firstName": "Dan-Axel",
        "lastName": "Zagadou",
        "shortFirstName": "Dan-Axel",
        "shortLastName": "Zagadou",
        "matchName": "D. Zagadou",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "416343": {
      "optaId": "6disrpsqjrkg0ye06a5y6box5",
      "heimPlayer": {
        "id": "98836951",
        "team_id": "1776",
        "person": {
          "id": "416343",
          "name": "Giorgi Kochorashvili",
          "firstname": "Giorgi",
          "surname": "Kochorashvili",
          "fullname": "Giorgi Kochorashvili",
          "gender": "male",
          "birthday": "29.06.1999",
          "height": "178",
          "weight": "74",
          "person_detail": {
            "id": "329845",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Tbilisi",
            "died": "no"
          },
          "country": [
            {
              "id": "65"
            }
          ]
        },
        "extra_minute": "6",
        "created": "20.01.2026 22:56",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "6disrpsqjrkg0ye06a5y6box5",
        "firstName": "Giorgi",
        "lastName": "Kochorashvili",
        "shortFirstName": "Giorgi",
        "shortLastName": "Kochorashvili",
        "matchName": "G. Kochorashvili",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "417147": {
      "optaId": "4pxoxtkjnhgmvxrwsgfzfl7md",
      "heimPlayer": {
        "id": "97686343",
        "team_id": "13914",
        "person": {
          "id": "417147",
          "name": "Neofytos Michail",
          "firstname": "Neofytos",
          "surname": "Michail",
          "fullname": "Neofytos Michail",
          "gender": "male",
          "birthday": "16.12.1993",
          "height": "190",
          "weight": "70",
          "person_detail": {
            "id": "330373",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Nikosia",
            "died": "no"
          },
          "country": [
            {
              "id": "239"
            }
          ]
        },
        "created": "10.12.2025 19:52",
        "shirtnumber": "93"
      },
      "optaPlayer": {
        "playerId": "4pxoxtkjnhgmvxrwsgfzfl7md",
        "firstName": "Neofytos",
        "lastName": "Michael",
        "shortFirstName": "Neofytos",
        "shortLastName": "Michael",
        "knownName": "Neofytos Michael",
        "matchName": "N. Michael",
        "shirtNumber": 93,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "417654": {
      "optaId": "q6ns1fyw7w10xkkubh8etfc9",
      "heimPlayer": {
        "id": "100492441",
        "team_id": "1052",
        "person": {
          "id": "417654",
          "name": "Alessandro Bastoni",
          "firstname": "Alessandro",
          "surname": "Bastoni",
          "fullname": "Alessandro Bastoni",
          "gender": "male",
          "birthday": "13.04.1999",
          "height": "190",
          "weight": "75",
          "person_detail": {
            "id": "330725",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Casalmaggiore",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "95"
      },
      "optaPlayer": {
        "playerId": "q6ns1fyw7w10xkkubh8etfc9",
        "firstName": "Alessandro",
        "lastName": "Bastoni",
        "shortFirstName": "Alessandro",
        "shortLastName": "Bastoni",
        "matchName": "A. Bastoni",
        "shirtNumber": 95,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "418606": {
      "optaId": "b5rea5r4h8bclpenau2au142x",
      "heimPlayer": {
        "id": "99153022",
        "team_id": "2102",
        "person": {
          "id": "418606",
          "name": "Santi Comesaña",
          "firstname": "",
          "surname": "Santi Comesaña",
          "fullname": "Santiago Comesaña Veiga",
          "gender": "male",
          "birthday": "05.10.1996",
          "height": "188",
          "weight": "75",
          "person_detail": {
            "id": "331550",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Vigo",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "b5rea5r4h8bclpenau2au142x",
        "firstName": "Santiago",
        "lastName": "Comesaña Veiga",
        "shortFirstName": "Santi",
        "shortLastName": "Comesaña",
        "matchName": "Santi Comesaña",
        "shirtNumber": 14,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4",
        "captain": "yes"
      }
    },
    "418685": {
      "optaId": "6qj9kdcrum9mqla72ytoojje1",
      "heimPlayer": {
        "id": "101973248",
        "team_id": "2134",
        "person": {
          "id": "418685",
          "name": "Marco Grüll",
          "firstname": "Marco",
          "surname": "Grüll",
          "fullname": "Marco Grüll",
          "gender": "male",
          "birthday": "06.07.1998",
          "height": "182",
          "weight": "74",
          "person_detail": {
            "id": "331618",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "both",
            "birth_place": "Schwarzach im Pongau",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "6qj9kdcrum9mqla72ytoojje1",
        "firstName": "Marco",
        "lastName": "Grüll",
        "shortFirstName": "Marco",
        "shortLastName": "Grüll",
        "matchName": "M. Grüll",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "420643": {
      "optaId": "bf6s84lavpij33riqec7y8445",
      "heimPlayer": {
        "id": "99256618",
        "team_id": "594",
        "person": {
          "id": "420643",
          "name": "Samuel Essende",
          "firstname": "Samuel",
          "surname": "Essende",
          "fullname": "Samuel Emmanuel Essende Mbongu",
          "gender": "male",
          "birthday": "23.01.1998",
          "height": "192",
          "weight": "91",
          "person_detail": {
            "id": "333154",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Montfermeil",
            "died": "no"
          }
        },
        "created": "31.01.2026 17:13",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bf6s84lavpij33riqec7y8445",
        "firstName": "Samuel Emmanuel",
        "lastName": "Essende Mbongu",
        "shortFirstName": "Samuel",
        "shortLastName": "Essende",
        "matchName": "S. Essende",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "420727": {
      "optaId": "604osk9a3lxpfpkavuziqmn6x",
      "heimPlayer": {
        "id": "101318150",
        "team_id": "597",
        "person": {
          "id": "420727",
          "name": "Marcus Rashford",
          "firstname": "Marcus",
          "surname": "Rashford",
          "fullname": "Marcus Rashford",
          "gender": "male",
          "birthday": "31.10.1997",
          "height": "185",
          "weight": "70",
          "person_detail": {
            "id": "333238",
            "position_1": "6",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Manchester",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "10.03.2026 22:25",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "604osk9a3lxpfpkavuziqmn6x",
        "firstName": "Marcus",
        "lastName": "Rashford",
        "shortFirstName": "Marcus",
        "shortLastName": "Rashford",
        "matchName": "M. Rashford",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "421272": {
      "optaId": "1vr896w03yky9kmu8x5tjkicp",
      "heimPlayer": {
        "id": "101812427",
        "team_id": "1457",
        "person": {
          "id": "421272",
          "name": "Achraf Hakimi",
          "firstname": "Achraf",
          "surname": "Hakimi",
          "fullname": "Achraf Hakimi Mouh",
          "gender": "male",
          "birthday": "04.11.1998",
          "height": "181",
          "weight": "73",
          "person_detail": {
            "id": "333759",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "1vr896w03yky9kmu8x5tjkicp",
        "firstName": "Achraf",
        "lastName": "Hakimi Mouh",
        "shortFirstName": "Achraf",
        "shortLastName": "Hakimi",
        "matchName": "A. Hakimi",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "421707": {
      "optaId": "5e2zgfe3ltc6qbnoqdfshqsph",
      "heimPlayer": {
        "id": "101811989",
        "team_id": "373",
        "person": {
          "id": "421707",
          "name": "Trevoh Chalobah",
          "firstname": "Trevoh",
          "surname": "Chalobah",
          "fullname": "Trevoh Thomas Chalobah",
          "gender": "male",
          "birthday": "05.07.1999",
          "height": "192",
          "weight": "84",
          "person_detail": {
            "id": "334174",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Freetown",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "5e2zgfe3ltc6qbnoqdfshqsph",
        "firstName": "Trevoh Tom",
        "lastName": "Chalobah",
        "shortFirstName": "Trevoh",
        "shortLastName": "Chalobah",
        "matchName": "T. Chalobah",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "421804": {
      "optaId": "cnmlhoum9aahwqruxgmz2gcfd",
      "heimPlayer": {
        "id": "101812799",
        "team_id": "127",
        "person": {
          "id": "421804",
          "name": "Ben White",
          "firstname": "Ben",
          "surname": "White",
          "fullname": "Benjamin William White",
          "gender": "male",
          "birthday": "08.10.1997",
          "height": "186",
          "weight": "77",
          "person_detail": {
            "id": "334271",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Poole",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "cnmlhoum9aahwqruxgmz2gcfd",
        "firstName": "Benjamin William",
        "lastName": "White",
        "shortFirstName": "Ben",
        "shortLastName": "White",
        "matchName": "B. White",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "422567": {
      "optaId": "dnw3y6r7bk0aqbta2s7ttivhl",
      "heimPlayer": {
        "id": "101804804",
        "team_id": "749",
        "person": {
          "id": "422567",
          "name": "Fredrik Bjørkan",
          "firstname": "Fredrik",
          "surname": "Bjørkan",
          "fullname": "Fredrik André Bjørkan",
          "gender": "male",
          "birthday": "21.08.1998",
          "height": "180",
          "weight": "74",
          "person_detail": {
            "id": "335241",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Bodø",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "dnw3y6r7bk0aqbta2s7ttivhl",
        "firstName": "Fredrik André",
        "lastName": "Bjørkan",
        "shortFirstName": "Fredrik",
        "shortLastName": "Bjørkan",
        "matchName": "F. Bjørkan",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "423365": {
      "optaId": "4jwkz8almo2997hvp09zl0p9l",
      "heimPlayer": {
        "id": "101863361",
        "team_id": "1355",
        "person": {
          "id": "423365",
          "name": "Sven Botman",
          "firstname": "Sven",
          "surname": "Botman",
          "fullname": "Sven Adriaan Botman",
          "gender": "male",
          "birthday": "12.01.2000",
          "height": "195",
          "weight": "83",
          "person_detail": {
            "id": "336010",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Badhoevedorp",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 20:13",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "4jwkz8almo2997hvp09zl0p9l",
        "firstName": "Sven Adriaan",
        "lastName": "Botman",
        "shortFirstName": "Sven",
        "shortLastName": "Botman",
        "matchName": "S. Botman",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "423368": {
      "optaId": "7ew7g18qo649t8ld44omgib55",
      "heimPlayer": {
        "id": "101867654",
        "team_id": "853",
        "person": {
          "id": "423368",
          "name": "Noa Lang",
          "firstname": "Noa",
          "surname": "Lang",
          "fullname": "Noa Noëll Lang",
          "gender": "male",
          "birthday": "17.06.1999",
          "height": "173",
          "weight": "70",
          "person_detail": {
            "id": "336013",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Capelle aan den IJssel",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 22:04",
        "shirtnumber": "77"
      },
      "optaPlayer": {
        "playerId": "7ew7g18qo649t8ld44omgib55",
        "firstName": "Noa Noëll",
        "lastName": "Lang",
        "shortFirstName": "Noa",
        "shortLastName": "Lang",
        "matchName": "N. Lang",
        "shirtNumber": 77,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "423541": {
      "optaId": "dn3llv8xjdbbndltfym5ar561",
      "heimPlayer": {
        "id": "98850688",
        "team_id": "530",
        "person": {
          "id": "423541",
          "name": "Rasmus Kristensen",
          "firstname": "Rasmus",
          "surname": "Kristensen",
          "fullname": "Rasmus Nissen Kristensen",
          "gender": "male",
          "birthday": "11.07.1997",
          "height": "187",
          "weight": "70",
          "person_detail": {
            "id": "336183",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Brande",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "dn3llv8xjdbbndltfym5ar561",
        "firstName": "Rasmus",
        "lastName": "Nissen Kristensen",
        "shortFirstName": "Rasmus",
        "shortLastName": "Kristensen",
        "matchName": "R. Kristensen",
        "shirtNumber": 13,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "424596": {
      "optaId": "6jgocc12bori2wygyu07c082x",
      "heimPlayer": {
        "id": "101812802",
        "team_id": "127",
        "person": {
          "id": "424596",
          "name": "Declan Rice",
          "firstname": "Declan",
          "surname": "Rice",
          "fullname": "Declan Rice",
          "gender": "male",
          "birthday": "14.01.1999",
          "height": "188",
          "weight": "80",
          "person_detail": {
            "id": "337222",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Kingston upon Thames, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "6jgocc12bori2wygyu07c082x",
        "firstName": "Declan",
        "lastName": "Rice",
        "shortFirstName": "Declan",
        "shortLastName": "Rice",
        "matchName": "D. Rice",
        "shirtNumber": 41,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "425050": {
      "optaId": "f0drogjsrwqv3hyjxuqcnk8vd",
      "heimPlayer": {
        "id": "95819788",
        "team_id": "2102",
        "person": {
          "id": "425050",
          "name": "Manor Solomon",
          "firstname": "Manor",
          "surname": "Solomon",
          "fullname": "Manor Solomon",
          "gender": "male",
          "birthday": "24.07.1999",
          "height": "170",
          "weight": "63",
          "person_detail": {
            "id": "337676",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Kfar Saba",
            "died": "no"
          },
          "country": [
            {
              "id": "88"
            }
          ]
        },
        "created": "05.11.2025 19:57",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "f0drogjsrwqv3hyjxuqcnk8vd",
        "firstName": "Manor",
        "lastName": "Solomon",
        "shortFirstName": "Manor",
        "shortLastName": "Solomon",
        "matchName": "M. Solomon",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "425547": {
      "optaId": "76n4eg1xu5qvf9bkwy4p8jsut",
      "heimPlayer": {
        "id": "99160042",
        "team_id": "13914",
        "person": {
          "id": "425547",
          "name": "Landry Dimata",
          "firstname": "Landry",
          "surname": "Dimata",
          "fullname": "Landry Nany Dimata",
          "gender": "male",
          "birthday": "01.09.1997",
          "height": "185",
          "weight": "77",
          "person_detail": {
            "id": "338152",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Mbuji-Mayi",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "28.01.2026 22:48",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "76n4eg1xu5qvf9bkwy4p8jsut",
        "firstName": "Landry Nany",
        "lastName": "Dimata",
        "shortFirstName": "Landry",
        "shortLastName": "Dimata",
        "matchName": "L. Dimata",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "425562": {
      "optaId": "eolso19u03zxw2pca2i95v4dl",
      "heimPlayer": {
        "id": "102134465",
        "team_id": "594",
        "person": {
          "id": "425562",
          "name": "Alexis Claude-Maurice",
          "firstname": "Alexis",
          "surname": "Claude-Maurice",
          "fullname": "Alexis Claude-Maurice",
          "gender": "male",
          "birthday": "06.06.1998",
          "height": "175",
          "weight": "66",
          "person_detail": {
            "id": "338166",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Noisy-le-Grand",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "eolso19u03zxw2pca2i95v4dl",
        "firstName": "Alexis",
        "lastName": "Claude-Maurice",
        "shortFirstName": "Alexis",
        "shortLastName": "Claude-Maurice",
        "matchName": "A. Claude-Maurice",
        "shirtNumber": 20,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "425636": {
      "optaId": "gq4abws0ogyk223tpkxy5ex",
      "heimPlayer": {
        "id": "99159427",
        "team_id": "1736",
        "person": {
          "id": "425636",
          "name": "Vasil Kušej",
          "firstname": "Vasil",
          "surname": "Kušej",
          "fullname": "Vasil Kušej",
          "gender": "male",
          "birthday": "24.05.2000",
          "height": "168",
          "weight": "67",
          "person_detail": {
            "id": "338240",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Ústí nad Labem",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 22:34",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "gq4abws0ogyk223tpkxy5ex",
        "firstName": "Vasil",
        "lastName": "Kušej",
        "shortFirstName": "Vasil",
        "shortLastName": "Kusej",
        "matchName": "V. Kušej",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "425666": {
      "optaId": "eikdf6bvfyzmb0ahxtyokd5gp",
      "heimPlayer": {
        "id": "92725049",
        "team_id": "853",
        "person": {
          "id": "425666",
          "name": "Ahmed Kutucu",
          "firstname": "Ahmed",
          "surname": "Kutucu",
          "fullname": "Ahmed Kutucu",
          "gender": "male",
          "birthday": "01.03.2000",
          "height": "181",
          "weight": "76",
          "person_detail": {
            "id": "338270",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Gelsenkirchen",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.09.2025 22:30",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "eikdf6bvfyzmb0ahxtyokd5gp",
        "firstName": "Ahmed",
        "lastName": "Kutucu",
        "shortFirstName": "Ahmed",
        "shortLastName": "Kutucu",
        "matchName": "A. Kutucu",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "425898": {
      "optaId": "eh86vsvlme3o95aw2z8tr89gp",
      "heimPlayer": {
        "id": "99154510",
        "team_id": "1736",
        "person": {
          "id": "425898",
          "name": "Oscar Dorley",
          "firstname": "Oscar",
          "surname": "Dorley",
          "fullname": "Oscar Murphy Dorley",
          "gender": "male",
          "birthday": "19.07.1998",
          "height": "174",
          "weight": "66",
          "person_detail": {
            "id": "338492",
            "position_1": "13",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Monrovia",
            "died": "no"
          },
          "country": [
            {
              "id": "116"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "eh86vsvlme3o95aw2z8tr89gp",
        "firstName": "Oscar Murphy",
        "lastName": "Dorley",
        "shortFirstName": "Oscar",
        "shortLastName": "Dorley",
        "matchName": "O. Dorley",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "425940": {
      "optaId": "8wvkrrbqqthuwda8twg03yuax",
      "heimPlayer": {
        "id": "95780734",
        "team_id": "1545",
        "person": {
          "id": "425940",
          "name": "Eder Militão",
          "firstname": "",
          "surname": "Eder Militão",
          "fullname": "Eder Gabriel Militão",
          "gender": "male",
          "birthday": "18.01.1998",
          "height": "186",
          "weight": "78",
          "person_detail": {
            "id": "338533",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Sertãozinho",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "04.11.2025 20:08",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "8wvkrrbqqthuwda8twg03yuax",
        "firstName": "Éder Gabriel",
        "lastName": "Militão Pinheiro",
        "shortFirstName": "Éder Gabriel",
        "shortLastName": "Militão Pinheiro",
        "knownName": "Éder Militão",
        "matchName": "Éder Militão",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "426073": {
      "optaId": "1wynwp4x95o9w5tt4cdog6i1",
      "heimPlayer": {
        "id": "101861141",
        "team_id": "853",
        "person": {
          "id": "426073",
          "name": "Victor Osimhen",
          "firstname": "Victor",
          "surname": "Osimhen",
          "fullname": "Victor James Osimhen",
          "gender": "male",
          "birthday": "29.12.1998",
          "height": "185",
          "weight": "78",
          "person_detail": {
            "id": "338665",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Lagos",
            "died": "no"
          },
          "country": [
            {
              "id": "151"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "1wynwp4x95o9w5tt4cdog6i1",
        "firstName": "Victor James",
        "lastName": "Osimhen",
        "shortFirstName": "Victor",
        "shortLastName": "Osimhen",
        "matchName": "V. Osimhen",
        "shirtNumber": 45,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "426360": {
      "optaId": "1vyh50nfaq2kq5pmivpkc1psl",
      "heimPlayer": {
        "id": "99152539",
        "team_id": "162",
        "person": {
          "id": "426360",
          "name": "Dávid Hancko",
          "firstname": "Dávid",
          "surname": "Hancko",
          "fullname": "Dávid Hancko",
          "gender": "male",
          "birthday": "13.12.1997",
          "height": "188",
          "weight": "79",
          "person_detail": {
            "id": "338952",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Prievidza",
            "died": "no"
          },
          "country": [
            {
              "id": "190"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "1vyh50nfaq2kq5pmivpkc1psl",
        "firstName": "Dávid",
        "lastName": "Hancko",
        "shortFirstName": "Dávid",
        "shortLastName": "Hancko",
        "matchName": "D. Hancko",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "426867": {
      "optaId": "b4q9q0qgmtz959rygieg9ln1l",
      "heimPlayer": {
        "id": "101973257",
        "team_id": "2134",
        "person": {
          "id": "426867",
          "name": "Romano Schmid",
          "firstname": "Romano",
          "surname": "Schmid",
          "fullname": "Romano Christian Schmid",
          "gender": "male",
          "birthday": "27.01.2000",
          "height": "168",
          "weight": "69",
          "person_detail": {
            "id": "339426",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Graz",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "b4q9q0qgmtz959rygieg9ln1l",
        "firstName": "Romano Christian",
        "lastName": "Schmid",
        "shortFirstName": "Romano",
        "shortLastName": "Schmid",
        "matchName": "R. Schmid",
        "shirtNumber": 20,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "426937": {
      "optaId": "3jln1gzc0859ymphvq83i0mp5",
      "heimPlayer": {
        "id": "101813069",
        "team_id": "1545",
        "person": {
          "id": "426937",
          "name": "Brahim Díaz",
          "firstname": "",
          "surname": "Brahim Díaz",
          "fullname": "Brahim Abdelkader Díaz",
          "gender": "male",
          "birthday": "03.08.1999",
          "height": "171",
          "weight": "68",
          "person_detail": {
            "id": "339496",
            "position_1": "8",
            "position_2": "9",
            "preferred_side": "both",
            "birth_place": "Málaga",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "3jln1gzc0859ymphvq83i0mp5",
        "firstName": "Brahim",
        "lastName": "Abdelkader Díaz",
        "shortFirstName": "Brahim",
        "shortLastName": "Díaz",
        "matchName": "Brahim Díaz",
        "shirtNumber": 21,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "427101": {
      "optaId": "18paf5a7rfe4kutxjl4cwd695",
      "heimPlayer": {
        "id": "101855732",
        "team_id": "1355",
        "person": {
          "id": "427101",
          "name": "Harvey Barnes",
          "firstname": "Harvey",
          "surname": "Barnes",
          "fullname": "Harvey Lewis Barnes",
          "gender": "male",
          "birthday": "09.12.1997",
          "height": "182",
          "weight": "66",
          "person_detail": {
            "id": "339659",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Burnley",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "18paf5a7rfe4kutxjl4cwd695",
        "firstName": "Harvey Lewis",
        "lastName": "Barnes",
        "shortFirstName": "Harvey",
        "shortLastName": "Barnes",
        "matchName": "H. Barnes",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "427502": {
      "optaId": "39tod1iad3ztq17qveh8pwp9l",
      "heimPlayer": {
        "id": "101151814",
        "team_id": "2134",
        "person": {
          "id": "427502",
          "name": "Senne Lynen",
          "firstname": "Senne",
          "surname": "Lynen",
          "fullname": "Senne Maaike Lynen",
          "gender": "male",
          "birthday": "19.02.1999",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "340039",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Borsbeek",
            "died": "no"
          }
        },
        "created": "08.03.2026 16:17",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "39tod1iad3ztq17qveh8pwp9l",
        "firstName": "Senne Maaike",
        "lastName": "Lynen",
        "shortFirstName": "Senne",
        "shortLastName": "Lynen",
        "matchName": "S. Lynen",
        "shirtNumber": 14,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "427662": {
      "optaId": "8sp01319vyxst4lfxjjp91ii1",
      "heimPlayer": {
        "id": "91514807",
        "team_id": "943",
        "person": {
          "id": "427662",
          "name": "Emir Sahiti",
          "firstname": "Emir",
          "surname": "Sahiti",
          "fullname": "Emir Sahiti",
          "gender": "male",
          "birthday": "29.11.1998",
          "height": "174",
          "weight": "65",
          "person_detail": {
            "id": "340229",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Zemun",
            "died": "no"
          }
        },
        "created": "29.08.2025 19:18",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "8sp01319vyxst4lfxjjp91ii1",
        "firstName": "Emir",
        "lastName": "Sahiti",
        "shortFirstName": "Emir",
        "shortLastName": "Sahiti",
        "matchName": "E. Sahiti",
        "shirtNumber": 29,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "427776": {
      "optaId": "d9yxninyn4bac8f0ufxsnlqll",
      "heimPlayer": {
        "id": "101811983",
        "team_id": "373",
        "person": {
          "id": "427776",
          "name": "Robert Sánchez",
          "firstname": "",
          "surname": "Robert Sánchez",
          "fullname": "Robert Lynch Sánchez",
          "gender": "male",
          "birthday": "18.11.1997",
          "height": "197",
          "weight": "90",
          "person_detail": {
            "id": "340342",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Cartagena",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "d9yxninyn4bac8f0ufxsnlqll",
        "firstName": "Robert",
        "lastName": "Lynch Sánchez",
        "shortFirstName": "Robert",
        "shortLastName": "Sánchez",
        "matchName": "Robert Sánchez",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "428046": {
      "optaId": "7x6mnev1ob4u5ffmdsvusb4rt",
      "heimPlayer": {
        "id": "97641910",
        "team_id": "1226",
        "person": {
          "id": "428046",
          "name": "Alexander Isak",
          "firstname": "Alexander",
          "surname": "Isak",
          "fullname": "Alexander Isak",
          "gender": "male",
          "birthday": "21.09.1999",
          "height": "192",
          "weight": "77",
          "person_detail": {
            "id": "340608",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Solna",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "09.12.2025 19:55",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "7x6mnev1ob4u5ffmdsvusb4rt",
        "firstName": "Alexander",
        "lastName": "Isak",
        "shortFirstName": "Alexander",
        "shortLastName": "Isak",
        "matchName": "A. Isak",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "428107": {
      "optaId": "7r2tgpdrr4v6n9d2gkzwmlazt",
      "heimPlayer": {
        "id": "100153924",
        "team_id": "1052",
        "person": {
          "id": "428107",
          "name": "Lautaro Martínez",
          "firstname": "Lautaro",
          "surname": "Martínez",
          "fullname": "Lautaro Javier Martínez",
          "gender": "male",
          "birthday": "22.08.1997",
          "height": "174",
          "weight": "72",
          "person_detail": {
            "id": "340667",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bahía Blanca",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "18.02.2026 19:49",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "7r2tgpdrr4v6n9d2gkzwmlazt",
        "firstName": "Lautaro Javier",
        "lastName": "Martínez",
        "shortFirstName": "Lautaro",
        "shortLastName": "Martínez",
        "knownName": "Lautaro Martínez",
        "matchName": "L. Martínez",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9",
        "captain": "yes"
      }
    },
    "428370": {
      "optaId": "8d04q3yp2kouwog0lj0s7ew2x",
      "heimPlayer": {
        "id": "98856769",
        "team_id": "155",
        "person": {
          "id": "428370",
          "name": "Ademola Lookman",
          "firstname": "Ademola",
          "surname": "Lookman",
          "fullname": "Ademola Olajide Alade Aylola Lookman",
          "gender": "male",
          "birthday": "20.10.1997",
          "height": "174",
          "weight": "71",
          "person_detail": {
            "id": "340930",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "151"
            }
          ]
        },
        "created": "21.01.2026 22:22",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "8d04q3yp2kouwog0lj0s7ew2x",
        "firstName": "Ademola Olajade",
        "lastName": "Alade Aylola Lookman",
        "shortFirstName": "Ademola",
        "shortLastName": "Lookman",
        "matchName": "A. Lookman",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "429890": {
      "optaId": "40gxfsz7bgrkdudqewlpxzyzt",
      "heimPlayer": {
        "id": "92676032",
        "team_id": "162",
        "person": {
          "id": "429890",
          "name": "Javi Galán",
          "firstname": "",
          "surname": "Javi Galán",
          "fullname": "Javier Galán Gil",
          "gender": "male",
          "birthday": "19.11.1994",
          "height": "172",
          "weight": "70",
          "person_detail": {
            "id": "342439",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Badajoz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.09.2025 19:57",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "40gxfsz7bgrkdudqewlpxzyzt",
        "firstName": "Javier",
        "lastName": "Galán Gil",
        "shortFirstName": "Javi",
        "shortLastName": "Galán",
        "matchName": "Javi Galán",
        "shirtNumber": 21,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "430005": {
      "optaId": "1ywfkwrcysdlvkt859q00kt7t",
      "heimPlayer": {
        "id": "101976554",
        "team_id": "19",
        "person": {
          "id": "430005",
          "name": "Danilho Doekhi",
          "firstname": "Danilho",
          "surname": "Doekhi",
          "fullname": "Danilho Raimundo Doekhi",
          "gender": "male",
          "birthday": "30.06.1998",
          "height": "190",
          "weight": "83",
          "person_detail": {
            "id": "342553",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Rotterdam",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "1ywfkwrcysdlvkt859q00kt7t",
        "firstName": "Danilho Raimundo",
        "lastName": "Doekhi",
        "shortFirstName": "Danilho",
        "shortLastName": "Doekhi",
        "matchName": "D. Doekhi",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "430170": {
      "optaId": "8k5rritl3k05hubghapadgx61",
      "heimPlayer": {
        "id": "102116819",
        "team_id": "702",
        "person": {
          "id": "430170",
          "name": "Danel Sinani",
          "firstname": "Danel",
          "surname": "Sinani",
          "fullname": "Danel Sinani",
          "gender": "male",
          "birthday": "05.04.1997",
          "height": "185",
          "weight": "70",
          "person_detail": {
            "id": "342719",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Beograd",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "8k5rritl3k05hubghapadgx61",
        "firstName": "Danel",
        "lastName": "Sinani",
        "shortFirstName": "Danel",
        "shortLastName": "Sinani",
        "matchName": "D. Sinani",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "432016": {
      "optaId": "d1d3v27d4r6vme6n2w5umaacp",
      "heimPlayer": {
        "id": "101804564",
        "team_id": "1776",
        "person": {
          "id": "432016",
          "name": "Luis Suárez",
          "firstname": "Luis",
          "surname": "Suárez",
          "fullname": "Luis Javier Suárez Charris",
          "gender": "male",
          "birthday": "02.12.1997",
          "height": "181",
          "weight": "79",
          "person_detail": {
            "id": "344107",
            "position_1": "11",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Santa Marta",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "97"
      },
      "optaPlayer": {
        "playerId": "d1d3v27d4r6vme6n2w5umaacp",
        "firstName": "Luis Javier",
        "lastName": "Suárez Charris",
        "shortFirstName": "Luis",
        "shortLastName": "Suárez",
        "matchName": "L. Suárez",
        "shirtNumber": 97,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "433306": {
      "optaId": "cscn06kwqfzo09h0dc5ybt1pl",
      "heimPlayer": {
        "id": "98853796",
        "team_id": "597",
        "person": {
          "id": "433306",
          "name": "Jules Koundé",
          "firstname": "Jules",
          "surname": "Koundé",
          "fullname": "Jules Olivier Koundé",
          "gender": "male",
          "birthday": "12.11.1998",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "345356",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Paris",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 19:56",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "cscn06kwqfzo09h0dc5ybt1pl",
        "firstName": "Jules Olivier",
        "lastName": "Koundé",
        "shortFirstName": "Jules",
        "shortLastName": "Koundé",
        "matchName": "J. Koundé",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "434092": {
      "optaId": "4qejyummzkrfllds8ord642qx",
      "heimPlayer": {
        "id": "100492459",
        "team_id": "1052",
        "person": {
          "id": "434092",
          "name": "Davide Frattesi",
          "firstname": "Davide",
          "surname": "Frattesi",
          "fullname": "Davide Frattesi",
          "gender": "male",
          "birthday": "22.09.1999",
          "height": "178",
          "weight": "74",
          "person_detail": {
            "id": "346114",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Roma",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "4qejyummzkrfllds8ord642qx",
        "firstName": "Davide",
        "lastName": "Frattesi",
        "shortFirstName": "Davide",
        "shortLastName": "Frattesi",
        "matchName": "D. Frattesi",
        "shirtNumber": 16,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "435112": {
      "optaId": "ieu0x9fy8hpqyztdjg8bgpnt",
      "heimPlayer": {
        "id": "99159037",
        "team_id": "162",
        "person": {
          "id": "435112",
          "name": "Nahuel Molina",
          "firstname": "Nahuel",
          "surname": "Molina",
          "fullname": "Nahuel Molina Lucero",
          "gender": "male",
          "birthday": "06.04.1998",
          "height": "175",
          "weight": "72",
          "person_detail": {
            "id": "347100",
            "position_1": "5",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Embalse, Córdoba",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "28.01.2026 22:23",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "ieu0x9fy8hpqyztdjg8bgpnt",
        "firstName": "Nahuel",
        "lastName": "Molina Lucero",
        "shortFirstName": "Nahuel",
        "shortLastName": "Molina",
        "matchName": "N. Molina",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "437235": {
      "optaId": "10fuwkejg59w68jmx1ae0cfe1",
      "heimPlayer": {
        "id": "101975939",
        "team_id": "9",
        "person": {
          "id": "437235",
          "name": "Ragnar Ache",
          "firstname": "Ragnar",
          "surname": "Ache",
          "fullname": "Ragnar Prince Friedel Ache",
          "gender": "male",
          "birthday": "28.07.1998",
          "height": "183",
          "weight": "81",
          "person_detail": {
            "id": "349181",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "10fuwkejg59w68jmx1ae0cfe1",
        "firstName": "Ragnar Prince",
        "lastName": "Friedel Ache",
        "shortFirstName": "Ragnar",
        "shortLastName": "Ache",
        "matchName": "R. Ache",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "437301": {
      "optaId": "64ubq0xra74xaunooi8knyajt",
      "heimPlayer": {
        "id": "100528843",
        "team_id": "1094",
        "person": {
          "id": "437301",
          "name": "Loïs Openda",
          "firstname": "Loïs",
          "surname": "Openda",
          "fullname": "Ikoma Loïs Openda",
          "gender": "male",
          "birthday": "16.02.2000",
          "height": "177",
          "weight": "75",
          "person_detail": {
            "id": "349228",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Liège",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "25.02.2026 23:24",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "64ubq0xra74xaunooi8knyajt",
        "firstName": "Ikoma-Loïs",
        "lastName": "Openda",
        "shortFirstName": "Loïs",
        "shortLastName": "Openda",
        "matchName": "L. Openda",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "437308": {
      "optaId": "8qlz4omhgfnzyb2cgeou7xn56",
      "heimPlayer": {
        "id": "98850685",
        "team_id": "530",
        "person": {
          "id": "437308",
          "name": "Arthur Theate",
          "firstname": "Arthur",
          "surname": "Theate",
          "fullname": "Arthur Nicolas Theate",
          "gender": "male",
          "birthday": "25.05.2000",
          "height": "186",
          "weight": "79",
          "person_detail": {
            "id": "349235",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Liège",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "8qlz4omhgfnzyb2cgeou7xn56",
        "firstName": "Arthur Nicolas R.",
        "lastName": "Theate",
        "shortFirstName": "Arthur",
        "shortLastName": "Theate",
        "matchName": "A. Theate",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "438600": {
      "optaId": "eu9b86opw6n66vftu1r5alfqh",
      "heimPlayer": {
        "id": "101311526",
        "team_id": "155",
        "person": {
          "id": "438600",
          "name": "Marco Carnesecchi",
          "firstname": "Marco",
          "surname": "Carnesecchi",
          "fullname": "Marco Carnesecchi",
          "gender": "male",
          "birthday": "01.07.2000",
          "height": "191",
          "weight": "80",
          "person_detail": {
            "id": "350836",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Rimini",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "10.03.2026 20:10",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "eu9b86opw6n66vftu1r5alfqh",
        "firstName": "Marco",
        "lastName": "Carnesecchi",
        "shortFirstName": "Marco",
        "shortLastName": "Carnesecchi",
        "matchName": "M. Carnesecchi",
        "shirtNumber": 29,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "440872": {
      "optaId": "2wl6h1rlrfnn2mr65vuo3t815",
      "heimPlayer": {
        "id": "101855591",
        "team_id": "597",
        "person": {
          "id": "440872",
          "name": "Raphinha",
          "firstname": "",
          "surname": "Raphinha",
          "fullname": "Raphael Dias Belloli",
          "gender": "male",
          "birthday": "14.12.1996",
          "height": "176",
          "weight": "68",
          "person_detail": {
            "id": "353024",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Porto Alegre",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "2wl6h1rlrfnn2mr65vuo3t815",
        "firstName": "Raphael",
        "lastName": "Dias Belloli",
        "shortFirstName": "Raphael",
        "shortLastName": "Dias Belloli",
        "knownName": "Raphinha",
        "matchName": "Raphinha",
        "shirtNumber": 11,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11",
        "captain": "yes"
      }
    },
    "441514": {
      "optaId": "3ynh418z6f6bfjz674vs40f6x",
      "heimPlayer": {
        "id": "102116840",
        "team_id": "702",
        "person": {
          "id": "441514",
          "name": "Mathias Pereira Lage",
          "firstname": "Mathias",
          "surname": "Pereira Lage",
          "fullname": "Mathias Pereira Lage",
          "gender": "male",
          "birthday": "30.11.1996",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "353649",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Clermont-Ferrand",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "3ynh418z6f6bfjz674vs40f6x",
        "firstName": "Mathias",
        "lastName": "Pereira Lage",
        "shortFirstName": "Mathias",
        "shortLastName": "Pereira Lage",
        "knownName": "Mathias Pereira Lage",
        "matchName": "Mathias Pereira Lage",
        "shirtNumber": 28,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "441599": {
      "optaId": "8s5u921me5pvsfyvysjgpu2qy",
      "heimPlayer": {
        "id": "99154519",
        "team_id": "1736",
        "person": {
          "id": "441599",
          "name": "Muhammed Cham",
          "firstname": "Muhammed",
          "surname": "Cham",
          "fullname": "Muhammed-Cham Saračević",
          "gender": "male",
          "birthday": "26.09.2000",
          "height": "180",
          "weight": "67",
          "person_detail": {
            "id": "353721",
            "position_1": "8",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Wien",
            "died": "no"
          },
          "country": [
            {
              "id": "158"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "8s5u921me5pvsfyvysjgpu2qy",
        "firstName": "Muhammed",
        "lastName": "Cham Saračević",
        "shortFirstName": "Muhammed",
        "shortLastName": "Cham",
        "matchName": "M. Cham",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "441955": {
      "optaId": "3g9riero16s160evc28u3q3u1",
      "heimPlayer": {
        "id": "99236347",
        "team_id": "19",
        "person": {
          "id": "441955",
          "name": "Diogo Leite",
          "firstname": "",
          "surname": "Diogo Leite",
          "fullname": "Diogo Filipe Monteiro Pinto Leite",
          "gender": "male",
          "birthday": "23.01.1999",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "354075",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Porto",
            "died": "no"
          }
        },
        "created": "31.01.2026 14:19",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "3g9riero16s160evc28u3q3u1",
        "firstName": "Diogo Filipe",
        "lastName": "Monteiro Pinto Leite",
        "shortFirstName": "Diogo Filipe",
        "shortLastName": "Monteiro Pinto Leite",
        "knownName": "Diogo Leite",
        "matchName": "Diogo Leite",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "442002": {
      "optaId": "aipyotc87m5bdvmvizd5n69k9",
      "heimPlayer": {
        "id": "101813057",
        "team_id": "1545",
        "person": {
          "id": "442002",
          "name": "Aurélien Tchouaméni",
          "firstname": "Aurélien",
          "surname": "Tchouaméni",
          "fullname": "Aurélien Djani Tchouaméni",
          "gender": "male",
          "birthday": "27.01.2000",
          "height": "188",
          "weight": "81",
          "person_detail": {
            "id": "354122",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Rouen",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "aipyotc87m5bdvmvizd5n69k9",
        "firstName": "Aurélien Djani",
        "lastName": "Tchouaméni",
        "shortFirstName": "Aurélien",
        "shortLastName": "Tchouaméni",
        "matchName": "A. Tchouaméni",
        "shirtNumber": 14,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "442004": {
      "optaId": "6u2ob6fv950r1qve8uejkq2uh",
      "heimPlayer": {
        "id": "98854048",
        "team_id": "1421",
        "person": {
          "id": "442004",
          "name": "Amine Gouiri",
          "firstname": "Amine",
          "surname": "Gouiri",
          "fullname": "Amine Ferid Gouiri",
          "gender": "male",
          "birthday": "16.02.2000",
          "height": "181",
          "weight": "80",
          "person_detail": {
            "id": "354124",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Bourgoin-Jallieu",
            "died": "no"
          },
          "country": [
            {
              "id": "4"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "6u2ob6fv950r1qve8uejkq2uh",
        "firstName": "Amine Ferid",
        "lastName": "Gouiri",
        "shortFirstName": "Amine",
        "shortLastName": "Gouiri",
        "matchName": "A. Gouiri",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "442135": {
      "optaId": "3ua8gs8tzx1dkdi9z88kjk9nt",
      "heimPlayer": {
        "id": "95781028",
        "team_id": "1094",
        "person": {
          "id": "442135",
          "name": "Dušan Vlahović",
          "firstname": "Dušan",
          "surname": "Vlahović",
          "fullname": "Dušan Vlahović",
          "gender": "male",
          "birthday": "28.01.2000",
          "height": "190",
          "weight": "88",
          "person_detail": {
            "id": "354243",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Beograd",
            "died": "no"
          },
          "country": [
            {
              "id": "185"
            }
          ]
        },
        "created": "04.11.2025 20:10",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "3ua8gs8tzx1dkdi9z88kjk9nt",
        "firstName": "Dušan",
        "lastName": "Vlahović",
        "shortFirstName": "Dusan",
        "shortLastName": "Vlahovic",
        "matchName": "D. Vlahović",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "442424": {
      "optaId": "4rh8xwozidxiwvl4wi2rn0fe1",
      "heimPlayer": {
        "id": "91152140",
        "team_id": "24",
        "person": {
          "id": "442424",
          "name": "Kōki Machida",
          "firstname": "Kōki",
          "surname": "Machida",
          "fullname": "Kōki Machida",
          "gender": "male",
          "birthday": "25.08.1997",
          "height": "190",
          "weight": "70",
          "person_detail": {
            "id": "354526",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Ibaraki",
            "died": "no"
          }
        },
        "created": "23.08.2025 14:23",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "4rh8xwozidxiwvl4wi2rn0fe1",
        "firstName": "Koki",
        "lastName": "Machida",
        "shortFirstName": "Koki",
        "shortLastName": "Machida",
        "matchName": "K. Machida",
        "shirtNumber": 28,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "442564": {
      "optaId": "70tsvrcmklvp4ecdhxlugf8ix",
      "heimPlayer": {
        "id": "98834731",
        "team_id": "64",
        "person": {
          "id": "442564",
          "name": "Kō Itakura",
          "firstname": "Kō",
          "surname": "Itakura",
          "fullname": "Kō Itakura",
          "gender": "male",
          "birthday": "27.01.1997",
          "height": "188",
          "weight": "80",
          "person_detail": {
            "id": "354666",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Yokohama, Kanagawa",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "20.01.2026 22:11",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "70tsvrcmklvp4ecdhxlugf8ix",
        "firstName": "Ko",
        "lastName": "Itakura",
        "shortFirstName": "Ko",
        "shortLastName": "Itakura",
        "matchName": "K. Itakura",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "442698": {
      "optaId": "14fw7p4fzaxprndgxnx0gxgbt",
      "heimPlayer": {
        "id": "101607638",
        "team_id": "2134",
        "person": {
          "id": "442698",
          "name": "Jens Stage",
          "firstname": "Jens",
          "surname": "Stage",
          "fullname": "Jens Dalsgaard Stage",
          "gender": "male",
          "birthday": "08.11.1996",
          "height": "187",
          "weight": "81",
          "person_detail": {
            "id": "354795",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Højbjerg",
            "died": "no"
          }
        },
        "created": "15.03.2026 14:15",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "14fw7p4fzaxprndgxnx0gxgbt",
        "firstName": "Jens",
        "lastName": "Dalsgaard Stage",
        "shortFirstName": "Jens",
        "shortLastName": "Stage",
        "matchName": "J. Stage",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "444311": {
      "optaId": "3ogcxokvirvqgt2o4rfyxx905",
      "heimPlayer": {
        "id": "99154654",
        "team_id": "17544",
        "person": {
          "id": "444311",
          "name": "Erkin Tapalov",
          "firstname": "Erkin",
          "surname": "Tapalov",
          "fullname": "Erkin Oleguly Tapalov",
          "gender": "male",
          "birthday": "03.09.1993",
          "height": "180",
          "weight": "",
          "person_detail": {
            "id": "356233",
            "position_1": "5",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Uralsk",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "3ogcxokvirvqgt2o4rfyxx905",
        "firstName": "Erkin",
        "lastName": "Tapalov",
        "shortFirstName": "Erkin",
        "shortLastName": "Tapalov",
        "matchName": "E. Tapalov",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "444551": {
      "optaId": "ctq9si3nbc6n8cznhlcvtixd6",
      "heimPlayer": {
        "id": "98854042",
        "team_id": "1421",
        "person": {
          "id": "444551",
          "name": "Hamed Traorè",
          "firstname": "Hamed",
          "surname": "Traorè",
          "fullname": "Hamed Junior Traorè",
          "gender": "male",
          "birthday": "16.02.2000",
          "height": "184",
          "weight": "77",
          "person_detail": {
            "id": "356470",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Abidjan",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "ctq9si3nbc6n8cznhlcvtixd6",
        "firstName": "Hamed Junior",
        "lastName": "Traoré",
        "shortFirstName": "Hamed",
        "shortLastName": "Traoré",
        "matchName": "H. Traoré",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "444854": {
      "optaId": "83ekq1r2omnsazmp41pio8s89",
      "heimPlayer": {
        "id": "101804558",
        "team_id": "1776",
        "person": {
          "id": "444854",
          "name": "Francisco Trincão",
          "firstname": "",
          "surname": "Francisco Trincão",
          "fullname": "Francisco António Machado Mota de Castro Trincão",
          "gender": "male",
          "birthday": "29.12.1999",
          "height": "184",
          "weight": "74",
          "person_detail": {
            "id": "356751",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Viana do Castelo",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "83ekq1r2omnsazmp41pio8s89",
        "firstName": "Francisco António",
        "lastName": "Machado Mota de Castro Trincão",
        "shortFirstName": "Francisco António",
        "shortLastName": "Machado Mota de Castro Trincão",
        "knownName": "Trincão",
        "matchName": "Trincão",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "446586": {
      "optaId": "81aug4xpk4fm2tii5dkg2tc5x",
      "heimPlayer": {
        "id": "99154438",
        "team_id": "13914",
        "person": {
          "id": "446586",
          "name": "Kostas Pileas",
          "firstname": "Kostas",
          "surname": "Pileas",
          "fullname": "Kostas Pileas",
          "gender": "male",
          "birthday": "11.12.1998",
          "height": "180",
          "weight": "",
          "person_detail": {
            "id": "358455",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Yeroskipou",
            "died": "no"
          },
          "country": [
            {
              "id": "239"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "81aug4xpk4fm2tii5dkg2tc5x",
        "firstName": "Kostas",
        "lastName": "Pileas",
        "shortFirstName": "Kostas",
        "shortLastName": "Pileas",
        "matchName": "K. Pileas",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "447210": {
      "optaId": "drmudc3n93faawruj8ct3bwmh",
      "heimPlayer": {
        "id": "101812415",
        "team_id": "1457",
        "person": {
          "id": "447210",
          "name": "Matvey Safonov",
          "firstname": "Matvey",
          "surname": "Safonov",
          "fullname": "Matvey Evgenevich Safonov",
          "gender": "male",
          "birthday": "25.02.1999",
          "height": "192",
          "weight": "82",
          "person_detail": {
            "id": "359063",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Krasnodar",
            "died": "no"
          },
          "country": [
            {
              "id": "172"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "drmudc3n93faawruj8ct3bwmh",
        "firstName": "Matvey",
        "lastName": "Safonov",
        "shortFirstName": "Matvey",
        "shortLastName": "Safonov",
        "matchName": "M. Safonov",
        "shirtNumber": 39,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "447799": {
      "optaId": "a79ojcztkvgui9sw4zbkmvr3d",
      "heimPlayer": {
        "id": "101972921",
        "team_id": "2086",
        "person": {
          "id": "447799",
          "name": "Kamil Grabara",
          "firstname": "Kamil",
          "surname": "Grabara",
          "fullname": "Kamil Mieczysław Grabara",
          "gender": "male",
          "birthday": "08.01.1999",
          "height": "195",
          "weight": "80",
          "person_detail": {
            "id": "359631",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ruda Śląska",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "a79ojcztkvgui9sw4zbkmvr3d",
        "firstName": "Kamil Mieczysław",
        "lastName": "Grabara",
        "shortFirstName": "Kamil",
        "shortLastName": "Grabara",
        "matchName": "K. Grabara",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "447930": {
      "optaId": "cxnlzyy9fxaca1u53y4soqk89",
      "heimPlayer": {
        "id": "98857633",
        "team_id": "1736",
        "person": {
          "id": "447930",
          "name": "Mojmír Chytil",
          "firstname": "Mojmír",
          "surname": "Chytil",
          "fullname": "Mojmír Chytil",
          "gender": "male",
          "birthday": "29.04.1999",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "359760",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Skalka",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "21.01.2026 22:40",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "cxnlzyy9fxaca1u53y4soqk89",
        "firstName": "Mojmír",
        "lastName": "Chytil",
        "shortFirstName": "Mojmír",
        "shortLastName": "Chytil",
        "matchName": "M. Chytil",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "447991": {
      "optaId": "eswxx8pxqyuj7rnpvqawpej1l",
      "heimPlayer": {
        "id": "101972945",
        "team_id": "2086",
        "person": {
          "id": "447991",
          "name": "Jonas Wind",
          "firstname": "Jonas",
          "surname": "Wind",
          "fullname": "Jonas Older Wind",
          "gender": "male",
          "birthday": "07.02.1999",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "359821",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Hvidovre",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "eswxx8pxqyuj7rnpvqawpej1l",
        "firstName": "Jonas",
        "lastName": "Older Wind",
        "shortFirstName": "Jonas",
        "shortLastName": "Wind",
        "matchName": "J. Wind",
        "shirtNumber": 23,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "448036": {
      "optaId": "8f3eqla9yo5js50fv2tdu5vjd",
      "heimPlayer": {
        "id": "99154450",
        "team_id": "13914",
        "person": {
          "id": "448036",
          "name": "Domingos Quina",
          "firstname": "",
          "surname": "Domingos Quina",
          "fullname": "Domingos Quina",
          "gender": "male",
          "birthday": "18.11.1999",
          "height": "173",
          "weight": "66",
          "person_detail": {
            "id": "359866",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bissau",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "8f3eqla9yo5js50fv2tdu5vjd",
        "firstName": "Domingos",
        "lastName": "Quina",
        "shortFirstName": "Domingos",
        "shortLastName": "Quina",
        "knownName": "Domingos Quina",
        "matchName": "Domingos Quina",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "448057": {
      "optaId": "7rvlba00jv66w7wtdmk178a95",
      "heimPlayer": {
        "id": "92721368",
        "team_id": "1776",
        "person": {
          "id": "448057",
          "name": "João Virgínia",
          "firstname": "",
          "surname": "João Virgínia",
          "fullname": "João Manuel Neves Virgínia",
          "gender": "male",
          "birthday": "10.10.1999",
          "height": "192",
          "weight": "83",
          "person_detail": {
            "id": "359886",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Faro",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "18.09.2025 19:58",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "7rvlba00jv66w7wtdmk178a95",
        "firstName": "João Manuel",
        "lastName": "Neves Virgínia",
        "shortFirstName": "João Manuel",
        "shortLastName": "Neves Virgínia",
        "knownName": "João Virgínia",
        "matchName": "João Virgínia",
        "shirtNumber": 12,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "448136": {
      "optaId": "7dnxkce4kn8qchaavv6e4tm21",
      "heimPlayer": {
        "id": "101804825",
        "team_id": "749",
        "person": {
          "id": "448136",
          "name": "Jens Hauge",
          "firstname": "Jens",
          "surname": "Hauge",
          "fullname": "Jens Petter Hauge",
          "gender": "male",
          "birthday": "12.10.1999",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "359964",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Bodø",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "7dnxkce4kn8qchaavv6e4tm21",
        "firstName": "Jens Petter",
        "lastName": "Hauge",
        "shortFirstName": "Jens",
        "shortLastName": "Hauge",
        "matchName": "J. Hauge",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "448347": {
      "optaId": "aripnzu9yo2wlr8ud93ufdhih",
      "heimPlayer": {
        "id": "101862314",
        "team_id": "155",
        "person": {
          "id": "448347",
          "name": "Raoul Bellanova",
          "firstname": "Raoul",
          "surname": "Bellanova",
          "fullname": "Raoul Bellanova",
          "gender": "male",
          "birthday": "17.05.2000",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "360174",
            "position_1": "9",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Rho",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "aripnzu9yo2wlr8ud93ufdhih",
        "firstName": "Raoul",
        "lastName": "Bellanova",
        "shortFirstName": "Raoul",
        "shortLastName": "Bellanova",
        "matchName": "R. Bellanova",
        "shirtNumber": 16,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "448430": {
      "optaId": "38bp85766w04a0nuulq5fiig9",
      "heimPlayer": {
        "id": "101820971",
        "team_id": "1545",
        "person": {
          "id": "448430",
          "name": "Andriy Lunin",
          "firstname": "Andriy",
          "surname": "Lunin",
          "fullname": "Andriy Oleksiyovych Lunin",
          "gender": "male",
          "birthday": "11.02.1999",
          "height": "191",
          "weight": "84",
          "person_detail": {
            "id": "360258",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Krasnograd",
            "died": "no"
          },
          "country": [
            {
              "id": "225"
            }
          ]
        },
        "created": "17.03.2026 22:04",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "38bp85766w04a0nuulq5fiig9",
        "firstName": "Andrii",
        "lastName": "Lunin",
        "shortFirstName": "Andrii",
        "shortLastName": "Lunin",
        "matchName": "A. Lunin",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Goalkeeper"
      }
    },
    "448432": {
      "optaId": "48xw6q1zl0wws78a4nxfbir55",
      "heimPlayer": {
        "id": "100501846",
        "team_id": "18670",
        "person": {
          "id": "448432",
          "name": "Oleksiy Kashchuk",
          "firstname": "Oleksiy",
          "surname": "Kashchuk",
          "fullname": "Oleksiy Mykolayovych Kashchuk",
          "gender": "male",
          "birthday": "29.06.2000",
          "height": "180",
          "weight": "72",
          "person_detail": {
            "id": "360260",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Novohrad-Volynskyi",
            "died": "no"
          },
          "country": [
            {
              "id": "225"
            }
          ]
        },
        "created": "24.02.2026 22:24",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "48xw6q1zl0wws78a4nxfbir55",
        "firstName": "Oleksii",
        "lastName": "Kashchuk",
        "shortFirstName": "Oleksii",
        "shortLastName": "Kashchuk",
        "matchName": "O. Kashchuk",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "448809": {
      "optaId": "11r7kkbcv2bn8lar3unczuz8p",
      "heimPlayer": {
        "id": "101868128",
        "team_id": "155",
        "person": {
          "id": "448809",
          "name": "Nikola Krstović",
          "firstname": "Nikola",
          "surname": "Krstović",
          "fullname": "Nikola Krstović",
          "gender": "male",
          "birthday": "05.04.2000",
          "height": "185",
          "weight": "83",
          "person_detail": {
            "id": "360616",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Golubovci",
            "died": "no"
          },
          "country": [
            {
              "id": "137"
            }
          ]
        },
        "created": "18.03.2026 22:30",
        "shirtnumber": "90"
      },
      "optaPlayer": {
        "playerId": "11r7kkbcv2bn8lar3unczuz8p",
        "firstName": "Nikola",
        "lastName": "Krstović",
        "shortFirstName": "Nikola",
        "shortLastName": "Krstovic",
        "matchName": "N. Krstović",
        "shirtNumber": 90,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "448876": {
      "optaId": "39c5g6782qlrtw55fsre7exnt",
      "heimPlayer": {
        "id": "101813042",
        "team_id": "1545",
        "person": {
          "id": "448876",
          "name": "Fran García",
          "firstname": "",
          "surname": "Fran García",
          "fullname": "Francisco José García Torres",
          "gender": "male",
          "birthday": "14.08.1999",
          "height": "169",
          "weight": "63",
          "person_detail": {
            "id": "360683",
            "position_1": "3",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Bolaños de Calatrava",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "39c5g6782qlrtw55fsre7exnt",
        "firstName": "Francisco José",
        "lastName": "García Torres",
        "shortFirstName": "Fran",
        "shortLastName": "García",
        "knownName": "Fran García",
        "matchName": "Fran García",
        "shirtNumber": 20,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "449030": {
      "optaId": "6yovfcug6e9hykfauqy0fq67d",
      "heimPlayer": {
        "id": "101855708",
        "team_id": "1355",
        "person": {
          "id": "449030",
          "name": "Aaron Ramsdale",
          "firstname": "Aaron",
          "surname": "Ramsdale",
          "fullname": "Aaron Christopher Ramsdale",
          "gender": "male",
          "birthday": "14.05.1998",
          "height": "190",
          "weight": "77",
          "person_detail": {
            "id": "360829",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Stoke-on-Trent",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "6yovfcug6e9hykfauqy0fq67d",
        "firstName": "Aaron Christopher",
        "lastName": "Ramsdale",
        "shortFirstName": "Aaron",
        "shortLastName": "Ramsdale",
        "matchName": "A. Ramsdale",
        "shirtNumber": 32,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "449453": {
      "optaId": "5asv6uc3a4xxsr9u30kdfc0ve",
      "heimPlayer": {
        "id": "95893825",
        "team_id": "2086",
        "person": {
          "id": "449453",
          "name": "Andreas Skov Olsen",
          "firstname": "Andreas",
          "surname": "Skov Olsen",
          "fullname": "Andreas Skov Olsen",
          "gender": "male",
          "birthday": "29.12.1999",
          "height": "187",
          "weight": "75",
          "person_detail": {
            "id": "361249",
            "position_1": "12",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Hillerød",
            "died": "no"
          }
        },
        "created": "07.11.2025 22:15",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "5asv6uc3a4xxsr9u30kdfc0ve",
        "firstName": "Andreas",
        "lastName": "Skov Olsen",
        "shortFirstName": "Andreas",
        "shortLastName": "Skov Olsen",
        "matchName": "A. Skov Olsen",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "449871": {
      "optaId": "atzboo800gv7gic2rgvgo0kq1",
      "heimPlayer": {
        "id": "101813000",
        "team_id": "1267",
        "person": {
          "id": "449871",
          "name": "Erling Haaland",
          "firstname": "Erling",
          "surname": "Haaland",
          "fullname": "Erling Braut Håland",
          "gender": "male",
          "birthday": "21.07.2000",
          "height": "195",
          "weight": "88",
          "person_detail": {
            "id": "361658",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Leeds",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "atzboo800gv7gic2rgvgo0kq1",
        "firstName": "Erling",
        "lastName": "Braut Haaland",
        "shortFirstName": "Erling",
        "shortLastName": "Haaland",
        "matchName": "E. Haaland",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "450033": {
      "optaId": "8im7pgnph2au11blma5pewe09",
      "heimPlayer": {
        "id": "102144029",
        "team_id": "702",
        "person": {
          "id": "450033",
          "name": "Martijn Kaars",
          "firstname": "Martijn",
          "surname": "Kaars",
          "fullname": "Martijn Kaars",
          "gender": "male",
          "birthday": "05.03.1999",
          "height": "183",
          "weight": "74",
          "person_detail": {
            "id": "361815",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Monnickendam",
            "died": "no"
          }
        },
        "created": "22.03.2026 19:17",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "8im7pgnph2au11blma5pewe09",
        "firstName": "Martijn",
        "lastName": "Kaars",
        "shortFirstName": "Martijn",
        "shortLastName": "Kaars",
        "matchName": "M. Kaars",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "450250": {
      "optaId": "e5xxqwz0sdlwkkmp8bgs1k6w9",
      "heimPlayer": {
        "id": "98854030",
        "team_id": "1421",
        "person": {
          "id": "450250",
          "name": "Timothy Weah",
          "firstname": "Timothy",
          "surname": "Weah",
          "fullname": "Timothy Tarpeh Weah",
          "gender": "male",
          "birthday": "22.02.2000",
          "height": "183",
          "weight": "66",
          "person_detail": {
            "id": "362030",
            "position_1": "9",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "New York City, NY",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "e5xxqwz0sdlwkkmp8bgs1k6w9",
        "firstName": "Timothy Tarpeh",
        "lastName": "Weah",
        "shortFirstName": "Timothy",
        "shortLastName": "Weah",
        "matchName": "T. Weah",
        "shirtNumber": 22,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "450473": {
      "optaId": "8libvn3hxypz8x7gm4mr7kj55",
      "heimPlayer": {
        "id": "101812793",
        "team_id": "127",
        "person": {
          "id": "450473",
          "name": "Gabriel Magalhães",
          "firstname": "",
          "surname": "Gabriel Magalhães",
          "fullname": "Gabriel dos Santos Magalhaes",
          "gender": "male",
          "birthday": "19.12.1997",
          "height": "190",
          "weight": "78",
          "person_detail": {
            "id": "362248",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "8libvn3hxypz8x7gm4mr7kj55",
        "firstName": "Gabriel",
        "lastName": "dos Santos Magalhães",
        "shortFirstName": "Gabriel",
        "shortLastName": "dos Santos Magalhães",
        "knownName": "Gabriel Magalhães",
        "matchName": "Gabriel Magalhães",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "450744": {
      "optaId": "dgysidzshgxqm3jegaihwi5wq",
      "heimPlayer": {
        "id": "101530619",
        "team_id": "9",
        "person": {
          "id": "450744",
          "name": "Tom Krauß",
          "firstname": "Tom",
          "surname": "Krauß",
          "fullname": "Tom Krauß",
          "gender": "male",
          "birthday": "22.06.2001",
          "height": "182",
          "weight": "72",
          "person_detail": {
            "id": "362519",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Leipzig",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:32",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "dgysidzshgxqm3jegaihwi5wq",
        "firstName": "Tom",
        "lastName": "Krauß",
        "shortFirstName": "Tom",
        "shortLastName": "Krauß",
        "matchName": "T. Krauß",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "450791": {
      "optaId": "3awoq36w443aauvv1xnffjlyh",
      "heimPlayer": {
        "id": "99276793",
        "team_id": "943",
        "person": {
          "id": "450791",
          "name": "Immanuël Pherai",
          "firstname": "Immanuël",
          "surname": "Pherai",
          "fullname": "Immanuël-Johannes Pherai",
          "gender": "male",
          "birthday": "25.04.2001",
          "height": "175",
          "weight": "74",
          "person_detail": {
            "id": "362565",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          }
        },
        "created": "31.01.2026 20:17",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "3awoq36w443aauvv1xnffjlyh",
        "firstName": "Immanuël-Johannes",
        "lastName": "Pherai",
        "shortFirstName": "Immanuël",
        "shortLastName": "Pherai",
        "matchName": "I. Pherai",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "450810": {
      "optaId": "ag6hkplnlodzxqrs9fh7mka5m",
      "heimPlayer": {
        "id": "101925839",
        "team_id": "24",
        "person": {
          "id": "450810",
          "name": "Wouter Burger",
          "firstname": "Wouter",
          "surname": "Burger",
          "fullname": "Wouter Burger",
          "gender": "male",
          "birthday": "16.02.2001",
          "height": "191",
          "weight": "83",
          "person_detail": {
            "id": "362584",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Zuid-Beijerland",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "ag6hkplnlodzxqrs9fh7mka5m",
        "firstName": "Wouter",
        "lastName": "Burger",
        "shortFirstName": "Wouter",
        "shortLastName": "Burger",
        "matchName": "W. Burger",
        "shirtNumber": 18,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "452072": {
      "optaId": "d4j19ipiaeuetyij08fofgs15",
      "heimPlayer": {
        "id": "99153889",
        "team_id": "1502",
        "person": {
          "id": "452072",
          "name": "Joey Veerman",
          "firstname": "Joey",
          "surname": "Veerman",
          "fullname": "Joey Veerman",
          "gender": "male",
          "birthday": "19.11.1998",
          "height": "185",
          "weight": "81",
          "person_detail": {
            "id": "363836",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Volendam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "d4j19ipiaeuetyij08fofgs15",
        "firstName": "Joey",
        "lastName": "Veerman",
        "shortFirstName": "Joey",
        "shortLastName": "Veerman",
        "matchName": "J. Veerman",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "453451": {
      "optaId": "3mp7p8tytgkbwi8itxl5mfkrt",
      "heimPlayer": {
        "id": "100211881",
        "team_id": "943",
        "person": {
          "id": "453451",
          "name": "Bakery Jatta",
          "firstname": "Bakery",
          "surname": "Jatta",
          "fullname": "Bakery Jatta",
          "gender": "male",
          "birthday": "06.06.1998",
          "height": "184",
          "weight": "79",
          "person_detail": {
            "id": "365000",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Gunjur",
            "died": "no"
          }
        },
        "created": "20.02.2026 19:58",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "3mp7p8tytgkbwi8itxl5mfkrt",
        "firstName": "Bakery",
        "lastName": "Jatta",
        "shortFirstName": "Bakery",
        "shortLastName": "Jatta",
        "matchName": "B. Jatta",
        "shirtNumber": 18,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "454296": {
      "optaId": "5lvdnoyknuoyr6kdruposgctl",
      "heimPlayer": {
        "id": "99153883",
        "team_id": "1502",
        "person": {
          "id": "454296",
          "name": "Jerdy Schouten",
          "firstname": "Jerdy",
          "surname": "Schouten",
          "fullname": "Jerdy Hendrikus Gerardus Bernardus Schouten",
          "gender": "male",
          "birthday": "12.01.1997",
          "height": "185",
          "weight": "77",
          "person_detail": {
            "id": "365782",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Spijkenisse",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "5lvdnoyknuoyr6kdruposgctl",
        "firstName": "Jerdy",
        "lastName": "Schouten",
        "shortFirstName": "Jerdy",
        "shortLastName": "Schouten",
        "matchName": "J. Schouten",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "454321": {
      "optaId": "9sexp3trzdm6h50dk2y9hrjl5",
      "heimPlayer": {
        "id": "101627792",
        "team_id": "19",
        "person": {
          "id": "454321",
          "name": "Matheo Raab",
          "firstname": "Matheo",
          "surname": "Raab",
          "fullname": "Matheo Raab",
          "gender": "male",
          "birthday": "18.12.1998",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "365806",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Weilburg",
            "died": "no"
          }
        },
        "created": "15.03.2026 16:17",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "9sexp3trzdm6h50dk2y9hrjl5",
        "firstName": "Matheo",
        "lastName": "Raab",
        "shortFirstName": "Matheo",
        "shortLastName": "Raab",
        "matchName": "M. Raab",
        "shirtNumber": 31,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "454658": {
      "optaId": "3hd9nxdb54zn4fhbf7qa7x0q1",
      "heimPlayer": {
        "id": "102000971",
        "team_id": "2086",
        "person": {
          "id": "454658",
          "name": "Lovro Majer",
          "firstname": "Lovro",
          "surname": "Majer",
          "fullname": "Lovro Majer",
          "gender": "male",
          "birthday": "17.01.1998",
          "height": "179",
          "weight": "75",
          "person_detail": {
            "id": "366136",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Zagreb",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:01",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "3hd9nxdb54zn4fhbf7qa7x0q1",
        "firstName": "Lovro",
        "lastName": "Majer",
        "shortFirstName": "Lovro",
        "shortLastName": "Majer",
        "matchName": "L. Majer",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "455381": {
      "optaId": "6lfje6glfgycun47flgmc9jvt",
      "heimPlayer": {
        "id": "101972942",
        "team_id": "2086",
        "person": {
          "id": "455381",
          "name": "Joakim Mæhle",
          "firstname": "Joakim",
          "surname": "Mæhle",
          "fullname": "Joakim Mæhle Pedersen",
          "gender": "male",
          "birthday": "20.05.1997",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "366571",
            "position_1": "3",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Østervrå",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "6lfje6glfgycun47flgmc9jvt",
        "firstName": "Joakim",
        "lastName": "Mæhle Pedersen",
        "shortFirstName": "Joakim",
        "shortLastName": "Mæhle",
        "matchName": "J. Mæhle",
        "shirtNumber": 21,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "455765": {
      "optaId": "4v1bqelw9bk1gftvzwzk6w6w9",
      "heimPlayer": {
        "id": "101524370",
        "team_id": "5",
        "person": {
          "id": "455765",
          "name": "Stefan Schimmer",
          "firstname": "Stefan",
          "surname": "Schimmer",
          "fullname": "Stefan Schimmer",
          "gender": "male",
          "birthday": "28.04.1994",
          "height": "185",
          "weight": "87",
          "person_detail": {
            "id": "366798",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Wertingen",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:07",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "4v1bqelw9bk1gftvzwzk6w6w9",
        "firstName": "Stefan",
        "lastName": "Schimmer",
        "shortFirstName": "Stefan",
        "shortLastName": "Schimmer",
        "matchName": "S. Schimmer",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "456328": {
      "optaId": "61buzozpq09ny7c0op8mj8a95",
      "heimPlayer": {
        "id": "100501528",
        "team_id": "18670",
        "person": {
          "id": "456328",
          "name": "Kady Borges",
          "firstname": "",
          "surname": "Kady Borges",
          "fullname": "Kady Iuri Borges Malinowski",
          "gender": "male",
          "birthday": "02.05.1996",
          "height": "173",
          "weight": "65",
          "person_detail": {
            "id": "367121",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Curitiba",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 22:17",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "61buzozpq09ny7c0op8mj8a95",
        "firstName": "Kady Iuri",
        "lastName": "Borges Malinowski",
        "shortFirstName": "Kady Iuri",
        "shortLastName": "Borges Malinowski",
        "knownName": "Kady Borges",
        "matchName": "Kady Borges",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "456333": {
      "optaId": "9jh6n6ztbudt5aluf0ibzls6h",
      "heimPlayer": {
        "id": "99154525",
        "team_id": "1736",
        "person": {
          "id": "456333",
          "name": "Erik Prekop",
          "firstname": "Erik",
          "surname": "Prekop",
          "fullname": "Erik Prekop",
          "gender": "male",
          "birthday": "08.10.1997",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "367126",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Trencin",
            "died": "no"
          },
          "country": [
            {
              "id": "190"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "9jh6n6ztbudt5aluf0ibzls6h",
        "firstName": "Erik",
        "lastName": "Prekop",
        "shortFirstName": "Erik",
        "shortLastName": "Prekop",
        "matchName": "E. Prekop",
        "shirtNumber": 31,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "456351": {
      "optaId": "cmxmyld8l4gjy03zxskyxf5gq",
      "heimPlayer": {
        "id": "98857648",
        "team_id": "13914",
        "person": {
          "id": "456351",
          "name": "Bruno Langa",
          "firstname": "",
          "surname": "Bruno Langa",
          "fullname": "Bruno Alberto Langa",
          "gender": "male",
          "birthday": "31.10.1997",
          "height": "178",
          "weight": "73",
          "person_detail": {
            "id": "367140",
            "position_1": "3",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Maputo",
            "died": "no"
          },
          "country": [
            {
              "id": "139"
            }
          ]
        },
        "created": "21.01.2026 22:41",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "cmxmyld8l4gjy03zxskyxf5gq",
        "firstName": "Bruno Alberto",
        "lastName": "Langa",
        "shortFirstName": "Bruno Alberto",
        "shortLastName": "Langa",
        "knownName": "Bruno Langa",
        "matchName": "Bruno Langa",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "457633": {
      "optaId": "582uvj0i3dvm0zwbou9q68pgp",
      "heimPlayer": {
        "id": "101317472",
        "team_id": "209",
        "person": {
          "id": "457633",
          "name": "Alphonso Davies",
          "firstname": "Alphonso",
          "surname": "Davies",
          "fullname": "Alphonso Boyle Davies",
          "gender": "male",
          "birthday": "02.11.2000",
          "height": "185",
          "weight": "77",
          "person_detail": {
            "id": "368244",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Buduburam",
            "died": "no"
          },
          "country": [
            {
              "id": "98"
            }
          ]
        },
        "created": "10.03.2026 22:02",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "582uvj0i3dvm0zwbou9q68pgp",
        "firstName": "Alphonso Boyle",
        "lastName": "Davies",
        "shortFirstName": "Alphonso",
        "shortLastName": "Davies",
        "matchName": "A. Davies",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "459904": {
      "optaId": "eh1ul4duphy1iz4odwx9tkjjd",
      "heimPlayer": {
        "id": "99152551",
        "team_id": "162",
        "person": {
          "id": "459904",
          "name": "Nicolás González",
          "firstname": "Nicolás",
          "surname": "González",
          "fullname": "Nicolás Iván González",
          "gender": "male",
          "birthday": "06.04.1998",
          "height": "180",
          "weight": "72",
          "person_detail": {
            "id": "369627",
            "position_1": "9",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Belén de Escobar",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "eh1ul4duphy1iz4odwx9tkjjd",
        "firstName": "Nicolás Iván",
        "lastName": "González",
        "shortFirstName": "Nico",
        "shortLastName": "González",
        "matchName": "N. González",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "459938": {
      "optaId": "9b7iei751ersl6ny0o0k8gn3d",
      "heimPlayer": {
        "id": "101812538",
        "team_id": "205",
        "person": {
          "id": "459938",
          "name": "Martin Terrier",
          "firstname": "Martin",
          "surname": "Terrier",
          "fullname": "Martin Albert Frédéric Terrier",
          "gender": "male",
          "birthday": "04.03.1997",
          "height": "184",
          "weight": "71",
          "person_detail": {
            "id": "369659",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Armentières",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "9b7iei751ersl6ny0o0k8gn3d",
        "firstName": "Martin Albert Frédéric",
        "lastName": "Terrier",
        "shortFirstName": "Martin",
        "shortLastName": "Terrier",
        "matchName": "M. Terrier",
        "shirtNumber": 11,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "460405": {
      "optaId": "bibz1qxakmbflq73marmo4nop",
      "heimPlayer": {
        "id": "102158360",
        "team_id": "2076",
        "person": {
          "id": "460405",
          "name": "Josha Vagnoman",
          "firstname": "Josha",
          "surname": "Vagnoman",
          "fullname": "Josha Mamadou Karaboue Vagnoman",
          "gender": "male",
          "birthday": "11.12.2000",
          "height": "190",
          "weight": "90",
          "person_detail": {
            "id": "369891",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 21:11",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "bibz1qxakmbflq73marmo4nop",
        "firstName": "Josha Mamadou Karaboue",
        "lastName": "Vagnoman",
        "shortFirstName": "Josha",
        "shortLastName": "Vagnoman",
        "matchName": "J. Vagnoman",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "460497": {
      "optaId": "du9vq193cqx7gmve30eijws15",
      "heimPlayer": {
        "id": "97649968",
        "team_id": "530",
        "person": {
          "id": "460497",
          "name": "Jessic Ngankam",
          "firstname": "Jessic",
          "surname": "Ngankam",
          "fullname": "Ngankam Jessic Gaïtan Ngankam",
          "gender": "male",
          "birthday": "20.07.2000",
          "height": "184",
          "weight": "84",
          "person_detail": {
            "id": "369970",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "09.12.2025 22:52",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "du9vq193cqx7gmve30eijws15",
        "firstName": "Ngankam Jessic Gaïtan",
        "lastName": "Ngankam",
        "shortFirstName": "Jessic",
        "shortLastName": "Ngankam",
        "matchName": "J. Ngankam",
        "shirtNumber": 32,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "461519": {
      "optaId": "l469vtpe0jbgg5sq1v2e67e1",
      "heimPlayer": {
        "id": "100521613",
        "team_id": "1731",
        "person": {
          "id": "461519",
          "name": "Leandro Barreiro",
          "firstname": "Leandro",
          "surname": "Barreiro",
          "fullname": "Leandro Barreiro Martins",
          "gender": "male",
          "birthday": "03.01.2000",
          "height": "174",
          "weight": "67",
          "person_detail": {
            "id": "370553",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Erpeldingen",
            "died": "no"
          },
          "country": [
            {
              "id": "120"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "l469vtpe0jbgg5sq1v2e67e1",
        "firstName": "Leandro",
        "lastName": "Barreiro Martins",
        "shortFirstName": "Leandro",
        "shortLastName": "Barreiro",
        "matchName": "L. Barreiro",
        "shirtNumber": 18,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "464299": {
      "optaId": "280fh7f5q9lud8lk8reyu7fxm",
      "heimPlayer": {
        "id": "100492447",
        "team_id": "1052",
        "person": {
          "id": "464299",
          "name": "Yann Bisseck",
          "firstname": "Yann",
          "surname": "Bisseck",
          "fullname": "Yann Aurel Ludger Bisseck",
          "gender": "male",
          "birthday": "29.11.2000",
          "height": "196",
          "weight": "87",
          "person_detail": {
            "id": "371819",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Köln",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "280fh7f5q9lud8lk8reyu7fxm",
        "firstName": "Yann Aurel Ludger",
        "lastName": "Bisseck",
        "shortFirstName": "Yann",
        "shortLastName": "Bisseck",
        "matchName": "Y. Bisseck",
        "shirtNumber": 31,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "464492": {
      "optaId": "6u47fsriz3ejlf72hxtsew5bd",
      "heimPlayer": {
        "id": "92793590",
        "team_id": "21",
        "person": {
          "id": "464492",
          "name": "Anthony Caci",
          "firstname": "Anthony",
          "surname": "Caci",
          "fullname": "Anthony Caci",
          "gender": "male",
          "birthday": "01.07.1997",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "371992",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Forbach",
            "died": "no"
          }
        },
        "created": "20.09.2025 14:34",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "6u47fsriz3ejlf72hxtsew5bd",
        "firstName": "Anthony",
        "lastName": "Caci",
        "shortFirstName": "Anthony",
        "shortLastName": "Caci",
        "matchName": "A. Caci",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "465657": {
      "optaId": "4y167h8sn9cnyrvb097lf8lbd",
      "heimPlayer": {
        "id": "102144035",
        "team_id": "1639",
        "person": {
          "id": "465657",
          "name": "Patrick Osterhage",
          "firstname": "Patrick",
          "surname": "Osterhage",
          "fullname": "Patrick Osterhage",
          "gender": "male",
          "birthday": "01.02.2000",
          "height": "186",
          "weight": "80",
          "person_detail": {
            "id": "372712",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Göttingen",
            "died": "no"
          }
        },
        "created": "22.03.2026 19:18",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "4y167h8sn9cnyrvb097lf8lbd",
        "firstName": "Patrick",
        "lastName": "Osterhage",
        "shortFirstName": "Patrick",
        "shortLastName": "Osterhage",
        "matchName": "P. Osterhage",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "465722": {
      "optaId": "f2ibn3ej2doay3b4u8ezeix62",
      "heimPlayer": {
        "id": "101972444",
        "team_id": "5",
        "person": {
          "id": "465722",
          "name": "Diant Ramaj",
          "firstname": "Diant",
          "surname": "Ramaj",
          "fullname": "Diant Ramaj",
          "gender": "male",
          "birthday": "19.09.2001",
          "height": "189",
          "weight": "81",
          "person_detail": {
            "id": "372774",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Stuttgart",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "f2ibn3ej2doay3b4u8ezeix62",
        "firstName": "Diant",
        "lastName": "Ramaj",
        "shortFirstName": "Diant",
        "shortLastName": "Ramaj",
        "matchName": "D. Ramaj",
        "shirtNumber": 41,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "465967": {
      "optaId": "43n323o8koqdvybews4kihel0",
      "heimPlayer": {
        "id": "98684188",
        "team_id": "21",
        "person": {
          "id": "465967",
          "name": "Fabio Moreno Fell",
          "firstname": "Fabio",
          "surname": "Moreno Fell",
          "fullname": "Fabio Moreno Fell",
          "gender": "male",
          "birthday": "04.06.2000",
          "height": "189",
          "weight": "82",
          "person_detail": {
            "id": "372961",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Las Palmas de Gran Canaria",
            "died": "no"
          }
        },
        "created": "17.01.2026 17:17",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "43n323o8koqdvybews4kihel0",
        "firstName": "Fabio",
        "lastName": "Moreno Fell",
        "shortFirstName": "Fabio",
        "shortLastName": "Moreno Fell",
        "matchName": "F. Moreno Fell",
        "shirtNumber": 36,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "466977": {
      "optaId": "5znvjp1ko1lm8wmiipd2cfget",
      "heimPlayer": {
        "id": "97634620",
        "team_id": "17544",
        "person": {
          "id": "466977",
          "name": "Giorgi Zaria",
          "firstname": "Giorgi",
          "surname": "Zaria",
          "fullname": "Giorgi Zaria",
          "gender": "male",
          "birthday": "14.07.1997",
          "height": "179",
          "weight": "",
          "person_detail": {
            "id": "373841",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Kutaisi",
            "died": "no"
          },
          "country": [
            {
              "id": "65"
            }
          ]
        },
        "created": "09.12.2025 15:26",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "5znvjp1ko1lm8wmiipd2cfget",
        "firstName": "Giorgi",
        "lastName": "Zaria",
        "shortFirstName": "Giorgi",
        "shortLastName": "Zaria",
        "matchName": "G. Zaria",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "468344": {
      "optaId": "1o7se1aziz6fpes5hey7yijft",
      "heimPlayer": {
        "id": "100521940",
        "team_id": "136",
        "person": {
          "id": "468344",
          "name": "Caio Henrique",
          "firstname": "",
          "surname": "Caio Henrique",
          "fullname": "Caio Henrique Oliveira Silva",
          "gender": "male",
          "birthday": "31.07.1997",
          "height": "178",
          "weight": "68",
          "person_detail": {
            "id": "375163",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Santos",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "1o7se1aziz6fpes5hey7yijft",
        "firstName": "Caio Henrique",
        "lastName": "Oliveira Silva",
        "shortFirstName": "Caio Henrique",
        "shortLastName": "Oliveira Silva",
        "knownName": "Caio Henrique",
        "matchName": "Caio Henrique",
        "shirtNumber": 12,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "468850": {
      "optaId": "f4pqxviuwzd6a803jfx9bh4o9",
      "heimPlayer": {
        "id": "95786527",
        "team_id": "1502",
        "person": {
          "id": "468850",
          "name": "Myron Boadu",
          "firstname": "Myron",
          "surname": "Boadu",
          "fullname": "Myron Boadu",
          "gender": "male",
          "birthday": "14.01.2001",
          "height": "181",
          "weight": "67",
          "person_detail": {
            "id": "375668",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "04.11.2025 22:43",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "f4pqxviuwzd6a803jfx9bh4o9",
        "firstName": "Myron",
        "lastName": "Boadu",
        "shortFirstName": "Myron",
        "shortLastName": "Boadu",
        "matchName": "M. Boadu",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "469097": {
      "optaId": "6ir1z8c3o7t4kqx04kw24i415",
      "heimPlayer": {
        "id": "98684164",
        "team_id": "21",
        "person": {
          "id": "469097",
          "name": "Arnaud Nordin",
          "firstname": "Arnaud",
          "surname": "Nordin",
          "fullname": "Arnaud Dominique Nordin",
          "gender": "male",
          "birthday": "17.06.1998",
          "height": "170",
          "weight": "70",
          "person_detail": {
            "id": "375917",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Paris",
            "died": "no"
          }
        },
        "created": "17.01.2026 17:17",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "6ir1z8c3o7t4kqx04kw24i415",
        "firstName": "Arnaud Dominique",
        "lastName": "Nordin",
        "shortFirstName": "Arnaud",
        "shortLastName": "Nordin",
        "matchName": "A. Nordin",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "469321": {
      "optaId": "djha3ac2mfhyb7oia64hq2nd",
      "heimPlayer": {
        "id": "101812520",
        "team_id": "205",
        "person": {
          "id": "469321",
          "name": "Edmond Tapsoba",
          "firstname": "Edmond",
          "surname": "Tapsoba",
          "fullname": "Edmond Fayçal Tapsoba",
          "gender": "male",
          "birthday": "02.02.1999",
          "height": "192",
          "weight": "85",
          "person_detail": {
            "id": "376140",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ouagadougou",
            "died": "no"
          },
          "country": [
            {
              "id": "37"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "djha3ac2mfhyb7oia64hq2nd",
        "firstName": "Edmond Fayçal",
        "lastName": "Tapsoba",
        "shortFirstName": "Edmond",
        "shortLastName": "Tapsoba",
        "matchName": "E. Tapsoba",
        "shirtNumber": 12,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "469807": {
      "optaId": "288nn7pbq5ewriiyb9o7da86h",
      "heimPlayer": {
        "id": "100521733",
        "team_id": "1094",
        "person": {
          "id": "469807",
          "name": "Weston McKennie",
          "firstname": "Weston",
          "surname": "McKennie",
          "fullname": "Weston James Earl McKennie",
          "gender": "male",
          "birthday": "28.08.1998",
          "height": "185",
          "weight": "84",
          "person_detail": {
            "id": "376600",
            "position_1": "13",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Little Elm, TX",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "288nn7pbq5ewriiyb9o7da86h",
        "firstName": "Weston James Earl",
        "lastName": "McKennie",
        "shortFirstName": "Weston",
        "shortLastName": "McKennie",
        "matchName": "W. McKennie",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "470298": {
      "optaId": "bm5w5xsbbflm26pdhmejwgvs9",
      "heimPlayer": {
        "id": "101972936",
        "team_id": "2086",
        "person": {
          "id": "470298",
          "name": "Moritz Jenz",
          "firstname": "Moritz",
          "surname": "Jenz",
          "fullname": "Moritz Jenz",
          "gender": "male",
          "birthday": "30.04.1999",
          "height": "190",
          "weight": "86",
          "person_detail": {
            "id": "377086",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "bm5w5xsbbflm26pdhmejwgvs9",
        "firstName": "Moritz",
        "lastName": "Jenz",
        "shortFirstName": "Moritz",
        "shortLastName": "Jenz",
        "matchName": "M. Jenz",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "470304": {
      "optaId": "3o0zpl9cnmna2hyk595ja0xrd",
      "heimPlayer": {
        "id": "95819653",
        "team_id": "1421",
        "person": {
          "id": "470304",
          "name": "Nayef Aguerd",
          "firstname": "Nayef",
          "surname": "Aguerd",
          "fullname": "Nayef Aguerd",
          "gender": "male",
          "birthday": "30.03.1996",
          "height": "190",
          "weight": "76",
          "person_detail": {
            "id": "377091",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Kénitra",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "05.11.2025 19:55",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "3o0zpl9cnmna2hyk595ja0xrd",
        "firstName": "Nayef",
        "lastName": "Aguerd",
        "shortFirstName": "Nayef",
        "shortLastName": "Aguerd",
        "matchName": "N. Aguerd",
        "shirtNumber": 21,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "471263": {
      "optaId": "abq67eup8kd31w8da2i0eftgp",
      "heimPlayer": {
        "id": "101868122",
        "team_id": "155",
        "person": {
          "id": "471263",
          "name": "Giacomo Raspadori",
          "firstname": "Giacomo",
          "surname": "Raspadori",
          "fullname": "Giacomo Raspadori",
          "gender": "male",
          "birthday": "18.02.2000",
          "height": "172",
          "weight": "69",
          "person_detail": {
            "id": "378023",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Bentivoglio",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 22:30",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "abq67eup8kd31w8da2i0eftgp",
        "firstName": "Giacomo",
        "lastName": "Raspadori",
        "shortFirstName": "Giacomo",
        "shortLastName": "Raspadori",
        "matchName": "G. Raspadori",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "472034": {
      "optaId": "44f0q2ucrld1rwcwx63vgs7hl",
      "heimPlayer": {
        "id": "97639180",
        "team_id": "1418",
        "person": {
          "id": "472034",
          "name": "Gabriel Strefezza",
          "firstname": "",
          "surname": "Gabriel Strefezza",
          "fullname": "Gabriel Tadeu Strefezza Rebelato",
          "gender": "male",
          "birthday": "18.04.1997",
          "height": "168",
          "weight": "63",
          "person_detail": {
            "id": "378775",
            "position_1": "12",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "09.12.2025 17:49",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "44f0q2ucrld1rwcwx63vgs7hl",
        "firstName": "Gabriel Tadeu",
        "lastName": "Strefezza Rebelato",
        "shortFirstName": "Gabriel Tadeu",
        "shortLastName": "Strefezza Rebelato",
        "knownName": "Gabriel Strefezza",
        "matchName": "Gabriel Strefezza",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "472183": {
      "optaId": "2mwe6l0eu1tisri3eu26fx8x6",
      "heimPlayer": {
        "id": "99548659",
        "team_id": "2086",
        "person": {
          "id": "472183",
          "name": "Kilian Fischer",
          "firstname": "Kilian",
          "surname": "Fischer",
          "fullname": "Kilian Fischer",
          "gender": "male",
          "birthday": "12.10.2000",
          "height": "182",
          "weight": "77",
          "person_detail": {
            "id": "378918",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "both",
            "birth_place": "Miltenberg",
            "died": "no"
          }
        },
        "created": "07.02.2026 14:13",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "2mwe6l0eu1tisri3eu26fx8x6",
        "firstName": "Kilian",
        "lastName": "Fischer",
        "shortFirstName": "Kilian",
        "shortLastName": "Fischer",
        "matchName": "K. Fischer",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "472194": {
      "optaId": "biee6dvb524juzai7iryyskix",
      "heimPlayer": {
        "id": "99153901",
        "team_id": "1502",
        "person": {
          "id": "472194",
          "name": "Dennis Man",
          "firstname": "Dennis",
          "surname": "Man",
          "fullname": "Dennis Man",
          "gender": "male",
          "birthday": "26.08.1998",
          "height": "183",
          "weight": "82",
          "person_detail": {
            "id": "378929",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Vladimirescu",
            "died": "no"
          },
          "country": [
            {
              "id": "171"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "biee6dvb524juzai7iryyskix",
        "firstName": "Dennis",
        "lastName": "Man",
        "shortFirstName": "Dennis",
        "shortLastName": "Man",
        "matchName": "D. Man",
        "shirtNumber": 27,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "472425": {
      "optaId": "ehbhpv43ealtggnkc4z2dtka1",
      "heimPlayer": {
        "id": "101815079",
        "team_id": "1776",
        "person": {
          "id": "472425",
          "name": "Daniel Bragança",
          "firstname": "",
          "surname": "Daniel Bragança",
          "fullname": "Daniel Santos Bragança",
          "gender": "male",
          "birthday": "27.05.1999",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "379157",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Almeirim",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 20:11",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "ehbhpv43ealtggnkc4z2dtka1",
        "firstName": "Daniel",
        "lastName": "Santos Bragança",
        "shortFirstName": "Daniel",
        "shortLastName": "Santos Bragança",
        "knownName": "Daniel Bragança",
        "matchName": "Daniel Bragança",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "472560": {
      "optaId": "6r4w05uhnwtloks9o59g6i221",
      "heimPlayer": {
        "id": "100493299",
        "team_id": "18670",
        "person": {
          "id": "472560",
          "name": "Mateusz Kochalski",
          "firstname": "Mateusz",
          "surname": "Kochalski",
          "fullname": "Mateusz Kochalski",
          "gender": "male",
          "birthday": "25.07.2000",
          "height": "190",
          "weight": "88",
          "person_detail": {
            "id": "379291",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Świdnik",
            "died": "no"
          },
          "country": [
            {
              "id": "166"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "99"
      },
      "optaPlayer": {
        "playerId": "6r4w05uhnwtloks9o59g6i221",
        "firstName": "Mateusz",
        "lastName": "Kochalski",
        "shortFirstName": "Mateusz",
        "shortLastName": "Kochalski",
        "matchName": "M. Kochalski",
        "shirtNumber": 99,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "472588": {
      "optaId": "4x1tm440b5cshi5gxkx5k9m95",
      "heimPlayer": {
        "id": "101804552",
        "team_id": "1776",
        "person": {
          "id": "472588",
          "name": "Morten Hjulmand",
          "firstname": "Morten",
          "surname": "Hjulmand",
          "fullname": "Morten Blom Due Hjulmand",
          "gender": "male",
          "birthday": "25.06.1999",
          "height": "185",
          "weight": "78",
          "person_detail": {
            "id": "379319",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Kastrup",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "4x1tm440b5cshi5gxkx5k9m95",
        "firstName": "Morten",
        "lastName": "Blom Due Hjulmand",
        "shortFirstName": "Morten",
        "shortLastName": "Hjulmand",
        "matchName": "M. Hjulmand",
        "shirtNumber": 42,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "472591": {
      "optaId": "1en0bgq0u842snszevlkscxk9",
      "heimPlayer": {
        "id": "102134954",
        "team_id": "2076",
        "person": {
          "id": "472591",
          "name": "Nikolas Nartey",
          "firstname": "Nikolas",
          "surname": "Nartey",
          "fullname": "Nikolas Terkelsen Nartey",
          "gender": "male",
          "birthday": "22.02.2000",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "379322",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Bagsværd",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "1en0bgq0u842snszevlkscxk9",
        "firstName": "Nikolas",
        "lastName": "Terkelsen Nartey",
        "shortFirstName": "Nikolas",
        "shortLastName": "Nartey",
        "matchName": "N. Nartey",
        "shirtNumber": 28,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "472830": {
      "optaId": "b8if5dg0k9prjik99aiutewh5",
      "heimPlayer": {
        "id": "101821889",
        "team_id": "1267",
        "person": {
          "id": "472830",
          "name": "Omar Marmoush",
          "firstname": "Omar",
          "surname": "Marmoush",
          "fullname": "Omar Khaled Mohamed Abd Elsala Marmoush",
          "gender": "male",
          "birthday": "07.02.1999",
          "height": "183",
          "weight": "81",
          "person_detail": {
            "id": "379561",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Cairo",
            "died": "no"
          },
          "country": [
            {
              "id": "2"
            }
          ]
        },
        "created": "17.03.2026 22:16",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "b8if5dg0k9prjik99aiutewh5",
        "firstName": "Omar Khaled Mohamed Abdelsalam",
        "lastName": "Marmoush",
        "shortFirstName": "Omar Khaled Mohamed Abdelsalam",
        "shortLastName": "Marmoush",
        "knownName": "Omar Marmoush",
        "matchName": "Omar Marmoush",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "472872": {
      "optaId": "2w7xspkzg7b9ghl20me202ove",
      "heimPlayer": {
        "id": "101812991",
        "team_id": "1267",
        "person": {
          "id": "472872",
          "name": "Tijjani Reijnders",
          "firstname": "Tijjani",
          "surname": "Reijnders",
          "fullname": "Tijjani Martinus Jan Reijnders Lekatompessy",
          "gender": "male",
          "birthday": "29.07.1998",
          "height": "185",
          "weight": "73",
          "person_detail": {
            "id": "379603",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Zwolle",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "2w7xspkzg7b9ghl20me202ove",
        "firstName": "Tijjani Martinus Jan",
        "lastName": "Reijnders Lekatompessy",
        "shortFirstName": "Tijjani",
        "shortLastName": "Reijnders",
        "matchName": "T. Reijnders",
        "shirtNumber": 4,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "473145": {
      "optaId": "cwr29t2879szijm010ae1u5m1",
      "heimPlayer": {
        "id": "91756055",
        "team_id": "9",
        "person": {
          "id": "473145",
          "name": "Jusuf Gazibegović",
          "firstname": "Jusuf",
          "surname": "Gazibegović",
          "fullname": "Jusuf Gazibegović",
          "gender": "male",
          "birthday": "11.03.2000",
          "height": "174",
          "weight": "67",
          "person_detail": {
            "id": "379869",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "both",
            "birth_place": "Salzburg",
            "died": "no"
          }
        },
        "created": "31.08.2025 21:01",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "cwr29t2879szijm010ae1u5m1",
        "firstName": "Jusuf",
        "lastName": "Gazibegović",
        "shortFirstName": "Jusuf",
        "shortLastName": "Gazibegovic",
        "matchName": "J. Gazibegović",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "473874": {
      "optaId": "1wse4b1hxu37e7t5ty5ykn7c9",
      "heimPlayer": {
        "id": "99152251",
        "team_id": "64",
        "person": {
          "id": "473874",
          "name": "Josip Šutalo",
          "firstname": "Josip",
          "surname": "Šutalo",
          "fullname": "Josip Šutalo",
          "gender": "male",
          "birthday": "28.02.2000",
          "height": "184",
          "weight": "82",
          "person_detail": {
            "id": "380596",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Čapljina",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "1wse4b1hxu37e7t5ty5ykn7c9",
        "firstName": "Josip",
        "lastName": "Šutalo",
        "shortFirstName": "Josip",
        "shortLastName": "Sutalo",
        "matchName": "J. Šutalo",
        "shirtNumber": 37,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "474118": {
      "optaId": "7nivkfkngr374fx5totgektm1",
      "heimPlayer": {
        "id": "96893272",
        "team_id": "1421",
        "person": {
          "id": "474118",
          "name": "Angel Gomes",
          "firstname": "Angel",
          "surname": "Gomes",
          "fullname": "Adilson Angel Abreu de Almeida Gomes",
          "gender": "male",
          "birthday": "31.08.2000",
          "height": "168",
          "weight": "56",
          "person_detail": {
            "id": "380828",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "25.11.2025 22:49",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "7nivkfkngr374fx5totgektm1",
        "firstName": "Adilson Angel",
        "lastName": "Abreu de Almeida Gomes",
        "shortFirstName": "Angel",
        "shortLastName": "Gomes",
        "matchName": "A. Gomes",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "474120": {
      "optaId": "693z0rzfh3m0h0wsma9v8c9ux",
      "heimPlayer": {
        "id": "99157162",
        "team_id": "1267",
        "person": {
          "id": "474120",
          "name": "Phil Foden",
          "firstname": "Phil",
          "surname": "Foden",
          "fullname": "Philip Walter Foden",
          "gender": "male",
          "birthday": "28.05.2000",
          "height": "171",
          "weight": "70",
          "person_detail": {
            "id": "380830",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Stockport",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "28.01.2026 21:36",
        "shirtnumber": "47"
      },
      "optaPlayer": {
        "playerId": "693z0rzfh3m0h0wsma9v8c9ux",
        "firstName": "Philip Walter",
        "lastName": "Foden",
        "shortFirstName": "Phil",
        "shortLastName": "Foden",
        "matchName": "P. Foden",
        "shirtNumber": 47,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "474588": {
      "optaId": "7xl111nfjcmqkj1n2a90p9p7t",
      "heimPlayer": {
        "id": "95820493",
        "team_id": "17544",
        "person": {
          "id": "474588",
          "name": "Ofri Arad",
          "firstname": "Ofri",
          "surname": "Arad",
          "fullname": "Ofri Arad",
          "gender": "male",
          "birthday": "11.09.1998",
          "height": "181",
          "weight": "",
          "person_detail": {
            "id": "381296",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "HaHotrim",
            "died": "no"
          },
          "country": [
            {
              "id": "88"
            }
          ]
        },
        "created": "05.11.2025 20:06",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "7xl111nfjcmqkj1n2a90p9p7t",
        "firstName": "Ofri",
        "lastName": "Arad",
        "shortFirstName": "Ofri",
        "shortLastName": "Arad",
        "matchName": "O. Arad",
        "shirtNumber": 15,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4",
        "captain": "yes"
      }
    },
    "475490": {
      "optaId": "2szgrzcosfeifh664tgt3mfvt",
      "heimPlayer": {
        "id": "101863526",
        "team_id": "597",
        "person": {
          "id": "475490",
          "name": "Ferran Torres",
          "firstname": "",
          "surname": "Ferran Torres",
          "fullname": "Ferran Torres García",
          "gender": "male",
          "birthday": "29.02.2000",
          "height": "184",
          "weight": "77",
          "person_detail": {
            "id": "382152",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Foios",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 20:16",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "2szgrzcosfeifh664tgt3mfvt",
        "firstName": "Ferran",
        "lastName": "Torres García",
        "shortFirstName": "Ferran",
        "shortLastName": "Torres",
        "matchName": "Ferran Torres",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "475905": {
      "optaId": "375gnysvjk9bvq02ex1lkmynd",
      "heimPlayer": {
        "id": "102006206",
        "team_id": "943",
        "person": {
          "id": "475905",
          "name": "Albert Lokonga",
          "firstname": "Albert",
          "surname": "Lokonga",
          "fullname": "Albert Mboyo Sambi Lokonga",
          "gender": "male",
          "birthday": "22.10.1999",
          "height": "183",
          "weight": "67",
          "person_detail": {
            "id": "382567",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Verviers",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "375gnysvjk9bvq02ex1lkmynd",
        "firstName": "Albert-Mboyo",
        "lastName": "Sambi Lokonga",
        "shortFirstName": "Albert",
        "shortLastName": "Sambi Lokonga",
        "matchName": "A. Sambi Lokonga",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "476044": {
      "optaId": "9nrt6uh2zw65jd7u2axlvxsoa",
      "heimPlayer": {
        "id": "102006209",
        "team_id": "943",
        "person": {
          "id": "476044",
          "name": "Ransford Königsdörffer",
          "firstname": "Ransford",
          "surname": "Königsdörffer",
          "fullname": "Ransford-Yeboah Königsdörffer",
          "gender": "male",
          "birthday": "13.09.2001",
          "height": "182",
          "weight": "78",
          "person_detail": {
            "id": "382690",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "9nrt6uh2zw65jd7u2axlvxsoa",
        "firstName": "Ransford-Yeboah",
        "lastName": "Königsdörffer",
        "shortFirstName": "Ransford",
        "shortLastName": "Königsdörffer",
        "matchName": "R. Königsdörffer",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "477198": {
      "optaId": "am6ppbdrbz4ml3xsbty53o73d",
      "heimPlayer": {
        "id": "101861354",
        "team_id": "1226",
        "person": {
          "id": "477198",
          "name": "Alexis Mac Allister",
          "firstname": "Alexis",
          "surname": "Mac Allister",
          "fullname": "Alexis Mac Allister",
          "gender": "male",
          "birthday": "24.12.1998",
          "height": "176",
          "weight": "72",
          "person_detail": {
            "id": "383837",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Santa Rosa",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "am6ppbdrbz4ml3xsbty53o73d",
        "firstName": "Alexis",
        "lastName": "Mac Allister",
        "shortFirstName": "Alexis",
        "shortLastName": "Mac Allister",
        "matchName": "A. Mac Allister",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "8"
      }
    },
    "478219": {
      "optaId": "330k0yqjq1ubnkfpfshp2h6qy",
      "heimPlayer": {
        "id": "95771260",
        "team_id": "1736",
        "person": {
          "id": "478219",
          "name": "Jakub Markovič",
          "firstname": "Jakub",
          "surname": "Markovič",
          "fullname": "Jakub Markovič",
          "gender": "male",
          "birthday": "13.07.2001",
          "height": "187",
          "weight": "78",
          "person_detail": {
            "id": "385011",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Přerov",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "04.11.2025 17:58",
        "shirtnumber": "35"
      },
      "optaPlayer": {
        "playerId": "330k0yqjq1ubnkfpfshp2h6qy",
        "firstName": "Jakub",
        "lastName": "Markovič",
        "shortFirstName": "Jakub",
        "shortLastName": "Markovic",
        "matchName": "J. Markovič",
        "shirtNumber": 35,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "478563": {
      "optaId": "br7zigajqee6fms35zhm1sb8p",
      "heimPlayer": {
        "id": "98854021",
        "team_id": "1421",
        "person": {
          "id": "478563",
          "name": "Facundo Medina",
          "firstname": "Facundo",
          "surname": "Medina",
          "fullname": "Facundo Axel Medina",
          "gender": "male",
          "birthday": "28.05.1999",
          "height": "184",
          "weight": "78",
          "person_detail": {
            "id": "385506",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "br7zigajqee6fms35zhm1sb8p",
        "firstName": "Facundo Axel",
        "lastName": "Medina",
        "shortFirstName": "Facundo",
        "shortLastName": "Medina",
        "matchName": "F. Medina",
        "shirtNumber": 32,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "478658": {
      "optaId": "avh60ensgiwz1qalvn1bbqkfd",
      "heimPlayer": {
        "id": "101861363",
        "team_id": "1226",
        "person": {
          "id": "478658",
          "name": "Dominik Szoboszlai",
          "firstname": "Dominik",
          "surname": "Szoboszlai",
          "fullname": "Dominik Szoboszlai",
          "gender": "male",
          "birthday": "25.10.2000",
          "height": "187",
          "weight": "74",
          "person_detail": {
            "id": "385601",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Székesfehérvár",
            "died": "no"
          },
          "country": [
            {
              "id": "226"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "avh60ensgiwz1qalvn1bbqkfd",
        "firstName": "Dominik",
        "lastName": "Szoboszlai",
        "shortFirstName": "Dominik",
        "shortLastName": "Szoboszlai",
        "matchName": "D. Szoboszlai",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "479759": {
      "optaId": "4zy4d60v2qmaplm9xbe51y1gp",
      "heimPlayer": {
        "id": "101812439",
        "team_id": "1457",
        "person": {
          "id": "479759",
          "name": "Khvicha Kvaratskhelia",
          "firstname": "Khvicha",
          "surname": "Kvaratskhelia",
          "fullname": "Khvicha Kvaratskhelia",
          "gender": "male",
          "birthday": "12.02.2001",
          "height": "183",
          "weight": "70",
          "person_detail": {
            "id": "386615",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "both",
            "birth_place": "Tbilisi",
            "died": "no"
          },
          "country": [
            {
              "id": "65"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "4zy4d60v2qmaplm9xbe51y1gp",
        "firstName": "Khvicha",
        "lastName": "Kvaratskhelia",
        "shortFirstName": "Khvicha",
        "shortLastName": "Kvaratskhelia",
        "matchName": "K. Kvaratskhelia",
        "shirtNumber": 7,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "479769": {
      "optaId": "20o2dr1mdk18xhxmkujzgak89",
      "heimPlayer": {
        "id": "101303459",
        "team_id": "1226",
        "person": {
          "id": "479769",
          "name": "Giorgi Mamardashvili",
          "firstname": "Giorgi",
          "surname": "Mamardashvili",
          "fullname": "Giorgi Mamardashvili",
          "gender": "male",
          "birthday": "29.09.2000",
          "height": "197",
          "weight": "93",
          "person_detail": {
            "id": "386625",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Tbilisi",
            "died": "no"
          },
          "country": [
            {
              "id": "65"
            }
          ]
        },
        "created": "10.03.2026 17:41",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "20o2dr1mdk18xhxmkujzgak89",
        "firstName": "Giorgi",
        "lastName": "Mamardashvili",
        "shortFirstName": "Giorgi",
        "shortLastName": "Mamardashvili",
        "matchName": "G. Mamardashvili",
        "shirtNumber": 25,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "480313": {
      "optaId": "6ki6rv564ybctrajr2xtgyeax",
      "heimPlayer": {
        "id": "101925827",
        "team_id": "24",
        "person": {
          "id": "480313",
          "name": "Ozan Kabak",
          "firstname": "Ozan",
          "surname": "Kabak",
          "fullname": "Ozan Muhammed Kabak",
          "gender": "male",
          "birthday": "25.03.2000",
          "height": "186",
          "weight": "86",
          "person_detail": {
            "id": "387098",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ankara",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "6ki6rv564ybctrajr2xtgyeax",
        "firstName": "Ozan Muhammed",
        "lastName": "Kabak",
        "shortFirstName": "Ozan",
        "shortLastName": "Kabak",
        "matchName": "O. Kabak",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "480323": {
      "optaId": "1h5s7q9ezqulz6mvvc9981vc9",
      "heimPlayer": {
        "id": "101867993",
        "team_id": "853",
        "person": {
          "id": "480323",
          "name": "Yunus Akgün",
          "firstname": "Yunus",
          "surname": "Akgün",
          "fullname": "Yunus Akgün",
          "gender": "male",
          "birthday": "07.07.2000",
          "height": "173",
          "weight": "65",
          "person_detail": {
            "id": "387108",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "İstanbul",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.03.2026 22:20",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "1h5s7q9ezqulz6mvvc9981vc9",
        "firstName": "Yunus",
        "lastName": "Akgün",
        "shortFirstName": "Yunus",
        "shortLastName": "Akgün",
        "matchName": "Y. Akgün",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "480535": {
      "optaId": "280u0x6o94auqt5e8ff89xune",
      "heimPlayer": {
        "id": "99235597",
        "team_id": "21",
        "person": {
          "id": "480535",
          "name": "Benedict Hollerbach",
          "firstname": "Benedict",
          "surname": "Hollerbach",
          "fullname": "Benedict Hollerbach",
          "gender": "male",
          "birthday": "17.05.2001",
          "height": "181",
          "weight": "83",
          "person_detail": {
            "id": "387304",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Starnberg",
            "died": "no"
          }
        },
        "created": "31.01.2026 14:11",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "280u0x6o94auqt5e8ff89xune",
        "firstName": "Benedict",
        "lastName": "Hollerbach",
        "shortFirstName": "Benedict",
        "shortLastName": "Hollerbach",
        "matchName": "B. Hollerbach",
        "shirtNumber": 17,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "480630": {
      "optaId": "byn8dfwg5zdefrca7wgn32qne",
      "heimPlayer": {
        "id": "98850706",
        "team_id": "530",
        "person": {
          "id": "480630",
          "name": "Ansgar Knauff",
          "firstname": "Ansgar",
          "surname": "Knauff",
          "fullname": "Ansgar Knauff",
          "gender": "male",
          "birthday": "10.01.2002",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "387398",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Göttingen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "byn8dfwg5zdefrca7wgn32qne",
        "firstName": "Ansgar",
        "lastName": "Knauff",
        "shortFirstName": "Ansgar",
        "shortLastName": "Knauff",
        "matchName": "A. Knauff",
        "shirtNumber": 7,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "480823": {
      "optaId": "6qoj7j99pfhszs5z75kti31wq",
      "heimPlayer": {
        "id": "97639318",
        "team_id": "17544",
        "person": {
          "id": "480823",
          "name": "Jug Stanojev",
          "firstname": "Jug",
          "surname": "Stanojev",
          "fullname": "Jug Stanojev",
          "gender": "male",
          "birthday": "29.07.1999",
          "height": "175",
          "weight": "69",
          "person_detail": {
            "id": "387566",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Novi Sad",
            "died": "no"
          },
          "country": [
            {
              "id": "185"
            }
          ]
        },
        "created": "09.12.2025 18:09",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "6qoj7j99pfhszs5z75kti31wq",
        "firstName": "Jug",
        "lastName": "Stanojev",
        "shortFirstName": "Jug",
        "shortLastName": "Stanojev",
        "matchName": "J. Stanojev",
        "shirtNumber": 33,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "481919": {
      "optaId": "4wic6z72nwmhkheme209fcmp5",
      "heimPlayer": {
        "id": "101812811",
        "team_id": "127",
        "person": {
          "id": "481919",
          "name": "Eberechi Eze",
          "firstname": "Eberechi",
          "surname": "Eze",
          "fullname": "Eberechi Oluchi Eze",
          "gender": "male",
          "birthday": "29.06.1998",
          "height": "178",
          "weight": "67",
          "person_detail": {
            "id": "388636",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Greenwich, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "4wic6z72nwmhkheme209fcmp5",
        "firstName": "Eberechi Oluchi",
        "lastName": "Eze",
        "shortFirstName": "Eberechi",
        "shortLastName": "Eze",
        "matchName": "E. Eze",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "482037": {
      "optaId": "7gyfpskzbb3r5nhiniky22o6h",
      "heimPlayer": {
        "id": "100521736",
        "team_id": "1094",
        "person": {
          "id": "482037",
          "name": "Lloyd Kelly",
          "firstname": "Lloyd",
          "surname": "Kelly",
          "fullname": "Lloyd Casius Kelly",
          "gender": "male",
          "birthday": "06.10.1998",
          "height": "190",
          "weight": "76",
          "person_detail": {
            "id": "388762",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Bristol",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "7gyfpskzbb3r5nhiniky22o6h",
        "firstName": "Lloyd Casius",
        "lastName": "Kelly",
        "shortFirstName": "Lloyd",
        "shortLastName": "Kelly",
        "matchName": "L. Kelly",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "482685": {
      "optaId": "5soi8e2hlk77rlsbsl76hg3xl",
      "heimPlayer": {
        "id": "96885067",
        "team_id": "2102",
        "person": {
          "id": "482685",
          "name": "Juan Foyth",
          "firstname": "Juan",
          "surname": "Foyth",
          "fullname": "Juan Marcos Foyth",
          "gender": "male",
          "birthday": "12.01.1998",
          "height": "187",
          "weight": "69",
          "person_detail": {
            "id": "389386",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "La Plata, Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "25.11.2025 20:07",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "5soi8e2hlk77rlsbsl76hg3xl",
        "firstName": "Juan Marcos",
        "lastName": "Foyth",
        "shortFirstName": "Juan",
        "shortLastName": "Foyth",
        "matchName": "J. Foyth",
        "shirtNumber": 8,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "482718": {
      "optaId": "5ch0r2awkzjfd4hv6kbw6c9gp",
      "heimPlayer": {
        "id": "101862254",
        "team_id": "209",
        "person": {
          "id": "482718",
          "name": "Luis Díaz",
          "firstname": "Luis",
          "surname": "Díaz",
          "fullname": "Luis Fernando Díaz Marulanda",
          "gender": "male",
          "birthday": "13.01.1997",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "389419",
            "position_1": "10",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Barrancas",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "5ch0r2awkzjfd4hv6kbw6c9gp",
        "firstName": "Luis Fernando",
        "lastName": "Díaz Marulanda",
        "shortFirstName": "Luis",
        "shortLastName": "Díaz",
        "matchName": "L. Díaz",
        "shirtNumber": 14,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "483953": {
      "optaId": "7rltyxkrvvfg7q1hppl631soa",
      "heimPlayer": {
        "id": "102000488",
        "team_id": "9",
        "person": {
          "id": "483953",
          "name": "Jan Thielmann",
          "firstname": "Jan",
          "surname": "Thielmann",
          "fullname": "Jan Uwe Thielmann",
          "gender": "male",
          "birthday": "26.05.2002",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "390557",
            "position_1": "9",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Föhren",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:59",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "7rltyxkrvvfg7q1hppl631soa",
        "firstName": "Jan Uwe",
        "lastName": "Thielmann",
        "shortFirstName": "Jan",
        "shortLastName": "Thielmann",
        "matchName": "J. Thielmann",
        "shirtNumber": 29,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "483954": {
      "optaId": "2kd2kqh0ykd5iuziic6590gve",
      "heimPlayer": {
        "id": "100492744",
        "team_id": "1355",
        "person": {
          "id": "483954",
          "name": "Nick Woltemade",
          "firstname": "Nick",
          "surname": "Woltemade",
          "fullname": "Nick Woltemade",
          "gender": "male",
          "birthday": "14.02.2002",
          "height": "199",
          "weight": "90",
          "person_detail": {
            "id": "390558",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bremen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "24.02.2026 19:56",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "2kd2kqh0ykd5iuziic6590gve",
        "firstName": "Nick",
        "lastName": "Woltemade",
        "shortFirstName": "Nick",
        "shortLastName": "Woltemade",
        "matchName": "N. Woltemade",
        "shirtNumber": 27,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "484685": {
      "optaId": "cm7l7qimy4iysm1khmpc7u961",
      "heimPlayer": {
        "id": "96892345",
        "team_id": "1421",
        "person": {
          "id": "484685",
          "name": "Matt O'Riley",
          "firstname": "Matt",
          "surname": "O'Riley",
          "fullname": "Matthew Sean O'Riley",
          "gender": "male",
          "birthday": "21.11.2000",
          "height": "189",
          "weight": "77",
          "person_detail": {
            "id": "391192",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Isleworth, London",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "25.11.2025 22:23",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "cm7l7qimy4iysm1khmpc7u961",
        "firstName": "Matthew Sean",
        "lastName": "O'Riley",
        "shortFirstName": "Matt",
        "shortLastName": "O'Riley",
        "matchName": "M. O'Riley",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "485107": {
      "optaId": "9sxg58hszjq17avxgumftdu22",
      "heimPlayer": {
        "id": "101855726",
        "team_id": "1355",
        "person": {
          "id": "485107",
          "name": "Sandro Tonali",
          "firstname": "Sandro",
          "surname": "Tonali",
          "fullname": "Sandro Tonali",
          "gender": "male",
          "birthday": "08.05.2000",
          "height": "181",
          "weight": "79",
          "person_detail": {
            "id": "391542",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Lodi",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "9sxg58hszjq17avxgumftdu22",
        "firstName": "Sandro",
        "lastName": "Tonali",
        "shortFirstName": "Sandro",
        "shortLastName": "Tonali",
        "matchName": "S. Tonali",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "485145": {
      "optaId": "6j0ogojh2b7poyceg7i3k09yi",
      "heimPlayer": {
        "id": "100521745",
        "team_id": "1094",
        "person": {
          "id": "485145",
          "name": "Khéphren Thuram",
          "firstname": "Khéphren",
          "surname": "Thuram",
          "fullname": "Khéphren Thuram-Ulien",
          "gender": "male",
          "birthday": "26.03.2001",
          "height": "192",
          "weight": "80",
          "person_detail": {
            "id": "391579",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Reggio Emilia",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "6j0ogojh2b7poyceg7i3k09yi",
        "firstName": "Khéphren",
        "lastName": "Thuram-Ulien",
        "shortFirstName": "Khéphren",
        "shortLastName": "Thuram",
        "matchName": "K. Thuram",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "485205": {
      "optaId": "6psklvi66inwws7buzf16yjft",
      "heimPlayer": {
        "id": "101812004",
        "team_id": "373",
        "person": {
          "id": "485205",
          "name": "Pedro Neto",
          "firstname": "",
          "surname": "Pedro Neto",
          "fullname": "Pedro Lomba Neto",
          "gender": "male",
          "birthday": "09.03.2000",
          "height": "174",
          "weight": "69",
          "person_detail": {
            "id": "391638",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Viana do Castelo",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "6psklvi66inwws7buzf16yjft",
        "firstName": "Pedro",
        "lastName": "Lomba Neto",
        "shortFirstName": "Pedro",
        "shortLastName": "Lomba Neto",
        "knownName": "Pedro Neto",
        "matchName": "Pedro Neto",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "485208": {
      "optaId": "cionsifzpx5rhc8es29wv6i95",
      "heimPlayer": {
        "id": "101812433",
        "team_id": "1457",
        "person": {
          "id": "485208",
          "name": "Vitinha",
          "firstname": "",
          "surname": "Vitinha",
          "fullname": "Vítor Machado Ferreira",
          "gender": "male",
          "birthday": "13.02.2000",
          "height": "172",
          "weight": "64",
          "person_detail": {
            "id": "391641",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Santo Tirso",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "cionsifzpx5rhc8es29wv6i95",
        "firstName": "Vítor",
        "lastName": "Machado Ferreira",
        "shortFirstName": "Vítor",
        "shortLastName": "Machado Ferreira",
        "knownName": "Vitinha",
        "matchName": "Vitinha",
        "shirtNumber": 17,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "485355": {
      "optaId": "8p2yagsx6ujdbmeonkd3u4c89",
      "heimPlayer": {
        "id": "101868479",
        "team_id": "209",
        "person": {
          "id": "485355",
          "name": "Hiroki Itō",
          "firstname": "Hiroki",
          "surname": "Itō",
          "fullname": "Hiroki Itō",
          "gender": "male",
          "birthday": "12.05.1999",
          "height": "188",
          "weight": "84",
          "person_detail": {
            "id": "391771",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Hamamatsu",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "18.03.2026 22:42",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "8p2yagsx6ujdbmeonkd3u4c89",
        "firstName": "Hiroki",
        "lastName": "Ito",
        "shortFirstName": "Hiroki",
        "shortLastName": "Ito",
        "matchName": "H. Ito",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "485977": {
      "optaId": "5a9y4yka5m1ft3f4e16f3ycfe",
      "heimPlayer": {
        "id": "102117155",
        "team_id": "1639",
        "person": {
          "id": "485977",
          "name": "Philipp Treu",
          "firstname": "Philipp",
          "surname": "Treu",
          "fullname": "Philipp Treu",
          "gender": "male",
          "birthday": "03.12.2000",
          "height": "173",
          "weight": "71",
          "person_detail": {
            "id": "392220",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Heidelberg",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "5a9y4yka5m1ft3f4e16f3ycfe",
        "firstName": "Philipp",
        "lastName": "Treu",
        "shortFirstName": "Philipp",
        "shortLastName": "Treu",
        "matchName": "P. Treu",
        "shirtNumber": 29,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "486788": {
      "optaId": "b4witgokm49tidm1a83qcvbop",
      "heimPlayer": {
        "id": "101813066",
        "team_id": "1545",
        "person": {
          "id": "486788",
          "name": "Vinícius Junior",
          "firstname": "",
          "surname": "Vinícius Junior",
          "fullname": "Vinícius José Paixão de Oliveira Junior",
          "gender": "male",
          "birthday": "12.07.2000",
          "height": "176",
          "weight": "73",
          "person_detail": {
            "id": "392805",
            "position_1": "6",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "São Gonçalo, Rio de Janeiro",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "b4witgokm49tidm1a83qcvbop",
        "firstName": "Vinícius José",
        "lastName": "Paixão de Oliveira Júnior",
        "shortFirstName": "Vinícius José",
        "shortLastName": "Paixão de Oliveira Júnior",
        "knownName": "Vinícius Júnior",
        "matchName": "Vinícius Júnior",
        "shirtNumber": 7,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "486981": {
      "optaId": "3wsyacqj7ci0ga9bzb988v7qh",
      "heimPlayer": {
        "id": "97156246",
        "team_id": "21",
        "person": {
          "id": "486981",
          "name": "Lasse Rieß",
          "firstname": "Lasse",
          "surname": "Rieß",
          "fullname": "Lasse Finn Rieß",
          "gender": "male",
          "birthday": "27.07.2001",
          "height": "191",
          "weight": "88",
          "person_detail": {
            "id": "392971",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Münster",
            "died": "no"
          }
        },
        "created": "30.11.2025 18:20",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "3wsyacqj7ci0ga9bzb988v7qh",
        "firstName": "Lasse Finn",
        "lastName": "Rieß",
        "shortFirstName": "Lasse",
        "shortLastName": "Rieß",
        "matchName": "L. Rieß",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "487254": {
      "optaId": "f5j3vhj805xtkos7l538u0d7t",
      "heimPlayer": {
        "id": "100132948",
        "team_id": "136",
        "person": {
          "id": "487254",
          "name": "Krépin Diatta",
          "firstname": "Krépin",
          "surname": "Diatta",
          "fullname": "Krépin Diatta",
          "gender": "male",
          "birthday": "25.02.1999",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "393168",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Dakar",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "17.02.2026 22:18",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "f5j3vhj805xtkos7l538u0d7t",
        "firstName": "Krépin",
        "lastName": "Diatta",
        "shortFirstName": "Krépin",
        "shortLastName": "Diatta",
        "matchName": "K. Diatta",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "488528": {
      "optaId": "ebj6t5jqzixrnww1z7qofznu2",
      "heimPlayer": {
        "id": "100522054",
        "team_id": "258",
        "person": {
          "id": "488528",
          "name": "Karim Adeyemi",
          "firstname": "Karim",
          "surname": "Adeyemi",
          "fullname": "Karim-David Adeyemi",
          "gender": "male",
          "birthday": "18.01.2002",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "394247",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "München",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 20:13",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "ebj6t5jqzixrnww1z7qofznu2",
        "firstName": "Karim-David",
        "lastName": "Adeyemi",
        "shortFirstName": "Karim",
        "shortLastName": "Adeyemi",
        "matchName": "K. Adeyemi",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "488698": {
      "optaId": "c83h08n0vnjvfgglyefy03h0p",
      "heimPlayer": {
        "id": "97648489",
        "team_id": "162",
        "person": {
          "id": "488698",
          "name": "Conor Gallagher",
          "firstname": "Conor",
          "surname": "Gallagher",
          "fullname": "Conor John Gallagher",
          "gender": "male",
          "birthday": "06.02.2000",
          "height": "182",
          "weight": "74",
          "person_detail": {
            "id": "394410",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Epsom",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "09.12.2025 22:26",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "c83h08n0vnjvfgglyefy03h0p",
        "firstName": "Conor John",
        "lastName": "Gallagher",
        "shortFirstName": "Conor",
        "shortLastName": "Gallagher",
        "matchName": "C. Gallagher",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "488712": {
      "optaId": "4ggz7e009bq3yltc9o6mifbah",
      "heimPlayer": {
        "id": "101855582",
        "team_id": "597",
        "person": {
          "id": "488712",
          "name": "Eric García",
          "firstname": "",
          "surname": "Eric García",
          "fullname": "Eric García Martret",
          "gender": "male",
          "birthday": "09.01.2001",
          "height": "182",
          "weight": "76",
          "person_detail": {
            "id": "394424",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Barcelona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "4ggz7e009bq3yltc9o6mifbah",
        "firstName": "Eric",
        "lastName": "García Martret",
        "shortFirstName": "Eric",
        "shortLastName": "García",
        "knownName": "Eric García",
        "matchName": "Eric García",
        "shirtNumber": 24,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "490011": {
      "optaId": "ekm47qd8w1x0456lm1tmf5re1",
      "heimPlayer": {
        "id": "99159802",
        "team_id": "2102",
        "person": {
          "id": "490011",
          "name": "Pape Gueye",
          "firstname": "Pape",
          "surname": "Gueye",
          "fullname": "Pape Alassane Gueye",
          "gender": "male",
          "birthday": "24.01.1999",
          "height": "189",
          "weight": "70",
          "person_detail": {
            "id": "395670",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Montreuil",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "28.01.2026 22:42",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "ekm47qd8w1x0456lm1tmf5re1",
        "firstName": "Pape Alassane",
        "lastName": "Gueye",
        "shortFirstName": "Pape",
        "shortLastName": "Gueye",
        "matchName": "P. Gueye",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "490342": {
      "optaId": "b2ibeioms7t9vb3au7tpqys4p",
      "heimPlayer": {
        "id": "101804822",
        "team_id": "749",
        "person": {
          "id": "490342",
          "name": "Håkon Evjen",
          "firstname": "Håkon",
          "surname": "Evjen",
          "fullname": "Håkon Evjen",
          "gender": "male",
          "birthday": "14.02.2000",
          "height": "178",
          "weight": "68",
          "person_detail": {
            "id": "396001",
            "position_1": "9",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Narvik",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "b2ibeioms7t9vb3au7tpqys4p",
        "firstName": "Håkon",
        "lastName": "Evjen",
        "shortFirstName": "Håkon",
        "shortLastName": "Evjen",
        "matchName": "H. Evjen",
        "shirtNumber": 26,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "490651": {
      "optaId": "9ipux4xiejibplsbbhqz8d5gp",
      "heimPlayer": {
        "id": "101820953",
        "team_id": "1267",
        "person": {
          "id": "490651",
          "name": "Marc Guéhi",
          "firstname": "Marc",
          "surname": "Guéhi",
          "fullname": "Addji Keaninkin Marc-Israel Guéhi",
          "gender": "male",
          "birthday": "13.07.2000",
          "height": "182",
          "weight": "75",
          "person_detail": {
            "id": "396325",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Abidjan",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 22:04",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "9ipux4xiejibplsbbhqz8d5gp",
        "firstName": "Addji Keaninkin Marc-Israel",
        "lastName": "Guéhi",
        "shortFirstName": "Marc",
        "shortLastName": "Guéhi",
        "matchName": "M. Guéhi",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "491170": {
      "optaId": "f0x3pa532agezdjdzcsp94l49",
      "heimPlayer": {
        "id": "101151403",
        "team_id": "19",
        "person": {
          "id": "491170",
          "name": "András Schäfer",
          "firstname": "András",
          "surname": "Schäfer",
          "fullname": "András Schäfer",
          "gender": "male",
          "birthday": "13.04.1999",
          "height": "179",
          "weight": "72",
          "person_detail": {
            "id": "396821",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Szombathely",
            "died": "no"
          }
        },
        "created": "08.03.2026 16:14",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "f0x3pa532agezdjdzcsp94l49",
        "firstName": "András",
        "lastName": "Schäfer",
        "shortFirstName": "András",
        "shortLastName": "Schäfer",
        "matchName": "A. Schäfer",
        "shirtNumber": 13,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "493957": {
      "optaId": "5tbabvk43ljv3z3wd9mh0y8r9",
      "heimPlayer": {
        "id": "101862857",
        "team_id": "1355",
        "person": {
          "id": "493957",
          "name": "Joe Willock",
          "firstname": "Joe",
          "surname": "Willock",
          "fullname": "Joseph George Willock",
          "gender": "male",
          "birthday": "20.08.1999",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "414876",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Waltham Forest, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 20:05",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "5tbabvk43ljv3z3wd9mh0y8r9",
        "firstName": "Joseph George",
        "lastName": "Willock",
        "shortFirstName": "Joe",
        "shortLastName": "Willock",
        "matchName": "J. Willock",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "494051": {
      "optaId": "80aqmv4ht6rs1812qrr5j8kix",
      "heimPlayer": {
        "id": "101812805",
        "team_id": "127",
        "person": {
          "id": "494051",
          "name": "Martín Zubimendi",
          "firstname": "",
          "surname": "Martín Zubimendi",
          "fullname": "Martín Zubimendi Ibáñez",
          "gender": "male",
          "birthday": "02.02.1999",
          "height": "181",
          "weight": "74",
          "person_detail": {
            "id": "414971",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Donostia-San Sebastián",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "80aqmv4ht6rs1812qrr5j8kix",
        "firstName": "Martín",
        "lastName": "Zubimendi Ibáñez",
        "shortFirstName": "Martín",
        "shortLastName": "Zubimendi",
        "matchName": "Martín Zubimendi",
        "shirtNumber": 36,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "494077": {
      "optaId": "dt8k9pwcj3zktd8xk3ai98vyt",
      "heimPlayer": {
        "id": "97691857",
        "team_id": "205",
        "person": {
          "id": "494077",
          "name": "Nathan Tella",
          "firstname": "Nathan",
          "surname": "Tella",
          "fullname": "Nathan Adewale Temitayo Tella",
          "gender": "male",
          "birthday": "05.07.1999",
          "height": "173",
          "weight": "70",
          "person_detail": {
            "id": "414997",
            "position_1": "9",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Stevenage",
            "died": "no"
          },
          "country": [
            {
              "id": "151"
            }
          ]
        },
        "created": "10.12.2025 22:30",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "dt8k9pwcj3zktd8xk3ai98vyt",
        "firstName": "Nathan Adewale Temitayo",
        "lastName": "Tella",
        "shortFirstName": "Nathan",
        "shortLastName": "Tella",
        "matchName": "N. Tella",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "494884": {
      "optaId": "dczrgxyolp7lcz413wkz7ap61",
      "heimPlayer": {
        "id": "101359964",
        "team_id": "373",
        "person": {
          "id": "494884",
          "name": "Reece James",
          "firstname": "Reece",
          "surname": "James",
          "fullname": "Reece James",
          "gender": "male",
          "birthday": "08.12.1999",
          "height": "180",
          "weight": "91",
          "person_detail": {
            "id": "415689",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Redbridge, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "11.03.2026 19:52",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "dczrgxyolp7lcz413wkz7ap61",
        "firstName": "Reece Lewis",
        "lastName": "James",
        "shortFirstName": "Reece",
        "shortLastName": "James",
        "matchName": "R. James",
        "shirtNumber": 24,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8",
        "captain": "yes"
      }
    },
    "497126": {
      "optaId": "72m84nwa6dshu3ibmy13dz5rd",
      "heimPlayer": {
        "id": "98853139",
        "team_id": "1355",
        "person": {
          "id": "497126",
          "name": "Bruno Guimarães",
          "firstname": "",
          "surname": "Bruno Guimarães",
          "fullname": "Bruno Guimarães Rodriguez Moura",
          "gender": "male",
          "birthday": "16.11.1997",
          "height": "182",
          "weight": "78",
          "person_detail": {
            "id": "417797",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Rio de Janeiro",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "21.01.2026 19:49",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "72m84nwa6dshu3ibmy13dz5rd",
        "firstName": "Bruno",
        "lastName": "Guimarães Rodriguez Moura",
        "shortFirstName": "Bruno",
        "shortLastName": "Guimarães Rodriguez Moura",
        "knownName": "Bruno Guimarães",
        "matchName": "Bruno Guimarães",
        "shirtNumber": 39,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "497278": {
      "optaId": "65rqu55qbzswixgqw2efna06i",
      "heimPlayer": {
        "id": "101812796",
        "team_id": "127",
        "person": {
          "id": "497278",
          "name": "William Saliba",
          "firstname": "William",
          "surname": "Saliba",
          "fullname": "William Alain André Gabriel Saliba",
          "gender": "male",
          "birthday": "24.03.2001",
          "height": "192",
          "weight": "87",
          "person_detail": {
            "id": "417938",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bondy",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "65rqu55qbzswixgqw2efna06i",
        "firstName": "William Alain André Gabriel",
        "lastName": "Saliba",
        "shortFirstName": "William",
        "shortLastName": "Saliba",
        "matchName": "W. Saliba",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "497462": {
      "optaId": "35qg0rrwtl00pycx468s62m3u",
      "heimPlayer": {
        "id": "96877195",
        "team_id": "64",
        "person": {
          "id": "497462",
          "name": "Kenneth Taylor",
          "firstname": "Kenneth",
          "surname": "Taylor",
          "fullname": "Kenneth Ina Dorothea Taylor",
          "gender": "male",
          "birthday": "16.05.2002",
          "height": "182",
          "weight": "66",
          "person_detail": {
            "id": "418066",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Alkmaar",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "25.11.2025 17:48",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "35qg0rrwtl00pycx468s62m3u",
        "firstName": "Kenneth Ina Dorothea",
        "lastName": "Taylor",
        "shortFirstName": "Kenneth",
        "shortLastName": "Taylor",
        "matchName": "K. Taylor",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "10"
      }
    },
    "497471": {
      "optaId": "dxmulnxbs11kpi1goq5hl9cve",
      "heimPlayer": {
        "id": "98853403",
        "team_id": "1502",
        "person": {
          "id": "497471",
          "name": "Anass Salah-Eddine",
          "firstname": "Anass",
          "surname": "Salah-Eddine",
          "fullname": "Anass Salah-Eddine",
          "gender": "male",
          "birthday": "18.01.2002",
          "height": "180",
          "weight": "66",
          "person_detail": {
            "id": "418075",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "21.01.2026 19:52",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "dxmulnxbs11kpi1goq5hl9cve",
        "firstName": "Anass",
        "lastName": "Salah-Eddine",
        "shortFirstName": "Anass",
        "shortLastName": "Salah-Eddine",
        "matchName": "A. Salah-Eddine",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "497476": {
      "optaId": "ftm7a5ulllwzj3n6oqa6awru",
      "heimPlayer": {
        "id": "102100472",
        "team_id": "21",
        "person": {
          "id": "497476",
          "name": "Paul Nebel",
          "firstname": "Paul",
          "surname": "Nebel",
          "fullname": "Paul Nebel",
          "gender": "male",
          "birthday": "10.10.2002",
          "height": "169",
          "weight": "66",
          "person_detail": {
            "id": "418080",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "both",
            "birth_place": "Bad Nauheim",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "ftm7a5ulllwzj3n6oqa6awru",
        "firstName": "Paul",
        "lastName": "Nebel",
        "shortFirstName": "Paul",
        "shortLastName": "Nebel",
        "matchName": "P. Nebel",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "497478": {
      "optaId": "25vb30mtetefhp3ix26nlhx0q",
      "heimPlayer": {
        "id": "101821829",
        "team_id": "205",
        "person": {
          "id": "497478",
          "name": "Malik Tillman",
          "firstname": "Malik",
          "surname": "Tillman",
          "fullname": "Malik Leon Tillman",
          "gender": "male",
          "birthday": "28.05.2002",
          "height": "187",
          "weight": "71",
          "person_detail": {
            "id": "418082",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Nürnberg",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "17.03.2026 22:16",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "25vb30mtetefhp3ix26nlhx0q",
        "firstName": "Malik Leon",
        "lastName": "Tillman",
        "shortFirstName": "Malik",
        "shortLastName": "Tillman",
        "matchName": "M. Tillman",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "498707": {
      "optaId": "ddfwtazsntda1pah2l454py3t",
      "heimPlayer": {
        "id": "99154435",
        "team_id": "13914",
        "person": {
          "id": "498707",
          "name": "Jay Gorter",
          "firstname": "Jay",
          "surname": "Gorter",
          "fullname": "Jay Gorter",
          "gender": "male",
          "birthday": "30.05.2000",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "419162",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "ddfwtazsntda1pah2l454py3t",
        "firstName": "Jay",
        "lastName": "Gorter",
        "shortFirstName": "Jay",
        "shortLastName": "Gorter",
        "matchName": "J. Gorter",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "498892": {
      "optaId": "arjwwth6yazptr851wu2u6e0a",
      "heimPlayer": {
        "id": "101999150",
        "team_id": "19",
        "person": {
          "id": "498892",
          "name": "Woo-yeong Jeong",
          "firstname": "Woo-yeong",
          "surname": "Jeong",
          "fullname": "Woo-yeong Jeong",
          "gender": "male",
          "birthday": "20.09.1999",
          "height": "179",
          "weight": "70",
          "person_detail": {
            "id": "419328",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Yeonsu-gu",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:49",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "arjwwth6yazptr851wu2u6e0a",
        "firstName": "Woo-Yeong",
        "lastName": "Jeong",
        "shortFirstName": "Woo-yeong",
        "shortLastName": "Jeong",
        "matchName": "Jeong Woo-Yeong",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "499332": {
      "optaId": "7ush9a10cc79gudlog12crt9l",
      "heimPlayer": {
        "id": "101134993",
        "team_id": "702",
        "person": {
          "id": "499332",
          "name": "James Sands",
          "firstname": "James",
          "surname": "Sands",
          "fullname": "James Hoban Sands",
          "gender": "male",
          "birthday": "06.07.2000",
          "height": "186",
          "weight": "84",
          "person_detail": {
            "id": "419746",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Rye, NY",
            "died": "no"
          }
        },
        "created": "08.03.2026 14:24",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "7ush9a10cc79gudlog12crt9l",
        "firstName": "James Hoban",
        "lastName": "Sands",
        "shortFirstName": "James",
        "shortLastName": "Sands",
        "matchName": "J. Sands",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "499512": {
      "optaId": "d196vatyvq6ycn1q7d477d2i1",
      "heimPlayer": {
        "id": "100120792",
        "team_id": "1094",
        "person": {
          "id": "499512",
          "name": "Bremer",
          "firstname": "",
          "surname": "Bremer",
          "fullname": "Gleison Bremer Silva Nascimento",
          "gender": "male",
          "birthday": "18.03.1997",
          "height": "188",
          "weight": "82",
          "person_detail": {
            "id": "419904",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Itapitanga",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.02.2026 17:43",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "d196vatyvq6ycn1q7d477d2i1",
        "firstName": "Gleison Bremer",
        "lastName": "Silva Nascimento",
        "shortFirstName": "Gleison Bremer",
        "shortLastName": "Silva Nascimento",
        "knownName": "Bremer",
        "matchName": "Bremer",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "499857": {
      "optaId": "c3mpk7pjhma4lwkjl8v5mhox6",
      "heimPlayer": {
        "id": "102157532",
        "team_id": "2076",
        "person": {
          "id": "499857",
          "name": "Ramon Hendriks",
          "firstname": "Ramon",
          "surname": "Hendriks",
          "fullname": "Ramon Hendriks",
          "gender": "male",
          "birthday": "18.07.2001",
          "height": "189",
          "weight": "83",
          "person_detail": {
            "id": "420244",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Hendrik-Ido-Ambacht",
            "died": "no"
          }
        },
        "created": "22.03.2026 21:00",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "c3mpk7pjhma4lwkjl8v5mhox6",
        "firstName": "Ramon",
        "lastName": "Hendriks",
        "shortFirstName": "Ramon",
        "shortLastName": "Hendriks",
        "matchName": "R. Hendriks",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "500797": {
      "optaId": "6qujoqysad60h70f3ac5n9ch6",
      "heimPlayer": {
        "id": "102134471",
        "team_id": "594",
        "person": {
          "id": "500797",
          "name": "Keven Schlotterbeck",
          "firstname": "Keven",
          "surname": "Schlotterbeck",
          "fullname": "Keven Schlotterbeck",
          "gender": "male",
          "birthday": "28.04.1997",
          "height": "189",
          "weight": "85",
          "person_detail": {
            "id": "421116",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Weinstadt",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "6qujoqysad60h70f3ac5n9ch6",
        "firstName": "Keven Matteo",
        "lastName": "Schlotterbeck",
        "shortFirstName": "Keven",
        "shortLastName": "Schlotterbeck",
        "matchName": "K. Schlotterbeck",
        "shirtNumber": 31,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "502117": {
      "optaId": "1igjz2w9dr9mj5f4ade5plsve",
      "heimPlayer": {
        "id": "102142988",
        "team_id": "702",
        "person": {
          "id": "502117",
          "name": "Connor Metcalfe",
          "firstname": "Connor",
          "surname": "Metcalfe",
          "fullname": "Connor Isaac Metcalfe",
          "gender": "male",
          "birthday": "05.11.1999",
          "height": "183",
          "weight": "70",
          "person_detail": {
            "id": "422209",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Newcastle",
            "died": "no"
          }
        },
        "created": "22.03.2026 19:13",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "1igjz2w9dr9mj5f4ade5plsve",
        "firstName": "Connor Isaac",
        "lastName": "Metcalfe",
        "shortFirstName": "Connor",
        "shortLastName": "Metcalfe",
        "matchName": "C. Metcalfe",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "503489": {
      "optaId": "4skrm2y64va3y5jk70gz4ylpm",
      "heimPlayer": {
        "id": "101862245",
        "team_id": "209",
        "person": {
          "id": "503489",
          "name": "Josip Stanišić",
          "firstname": "Josip",
          "surname": "Stanišić",
          "fullname": "Josip Stanišić",
          "gender": "male",
          "birthday": "02.04.2000",
          "height": "187",
          "weight": "77",
          "person_detail": {
            "id": "423443",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "both",
            "birth_place": "München",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "4skrm2y64va3y5jk70gz4ylpm",
        "firstName": "Josip",
        "lastName": "Stanišić",
        "shortFirstName": "Josip",
        "shortLastName": "Stanisic",
        "matchName": "J. Stanišić",
        "shirtNumber": 44,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "503593": {
      "optaId": "bc5vmdnoyshdi5hcgu8dgqxyi",
      "heimPlayer": {
        "id": "101976038",
        "team_id": "253",
        "person": {
          "id": "503593",
          "name": "Rocco Reitz",
          "firstname": "Rocco",
          "surname": "Reitz",
          "fullname": "Rocco Reitz",
          "gender": "male",
          "birthday": "29.05.2002",
          "height": "176",
          "weight": "72",
          "person_detail": {
            "id": "423541",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Duisburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "bc5vmdnoyshdi5hcgu8dgqxyi",
        "firstName": "Rocco",
        "lastName": "Reitz",
        "shortFirstName": "Rocco",
        "shortLastName": "Reitz",
        "matchName": "R. Reitz",
        "shirtNumber": 27,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "504064": {
      "optaId": "4st4hurqbtyzw1tbkzuuk78fe",
      "heimPlayer": {
        "id": "100526212",
        "team_id": "1094",
        "person": {
          "id": "504064",
          "name": "Edon Zhegrova",
          "firstname": "Edon",
          "surname": "Zhegrova",
          "fullname": "Edon Zhegrova",
          "gender": "male",
          "birthday": "31.03.1999",
          "height": "181",
          "weight": "72",
          "person_detail": {
            "id": "423979",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Herford",
            "died": "no"
          },
          "country": [
            {
              "id": "108"
            }
          ]
        },
        "created": "25.02.2026 22:28",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "4st4hurqbtyzw1tbkzuuk78fe",
        "firstName": "Edon",
        "lastName": "Zhegrova",
        "shortFirstName": "Edon",
        "shortLastName": "Zhegrova",
        "matchName": "E. Zhegrova",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "504616": {
      "optaId": "cfpaejad8i9p2r1fj0wx0g222",
      "heimPlayer": {
        "id": "101855717",
        "team_id": "1355",
        "person": {
          "id": "504616",
          "name": "Malick Thiaw",
          "firstname": "Malick",
          "surname": "Thiaw",
          "fullname": "Malick Laye Thiaw",
          "gender": "male",
          "birthday": "08.08.2001",
          "height": "194",
          "weight": "80",
          "person_detail": {
            "id": "424523",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "both",
            "birth_place": "Düsseldorf",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "cfpaejad8i9p2r1fj0wx0g222",
        "firstName": "Malick Laye",
        "lastName": "Thiaw",
        "shortFirstName": "Malick",
        "shortLastName": "Thiaw",
        "matchName": "M. Thiaw",
        "shirtNumber": 12,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "504777": {
      "optaId": "7hnmtyfmurizitwz1whecjnmy",
      "heimPlayer": {
        "id": "102134939",
        "team_id": "2076",
        "person": {
          "id": "504777",
          "name": "Angelo Stiller",
          "firstname": "Angelo",
          "surname": "Stiller",
          "fullname": "Angelo Stiller",
          "gender": "male",
          "birthday": "04.04.2001",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "424684",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "München",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "7hnmtyfmurizitwz1whecjnmy",
        "firstName": "Angelo",
        "lastName": "Stiller",
        "shortFirstName": "Angelo",
        "shortLastName": "Stiller",
        "matchName": "A. Stiller",
        "shirtNumber": 6,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "504793": {
      "optaId": "bt35y17wl42b5t5tw6z68uwyy",
      "heimPlayer": {
        "id": "101645855",
        "team_id": "2076",
        "person": {
          "id": "504793",
          "name": "Jamie Leweling",
          "firstname": "Jamie",
          "surname": "Leweling",
          "fullname": "Jamie Leweling",
          "gender": "male",
          "birthday": "26.02.2001",
          "height": "185",
          "weight": "86",
          "person_detail": {
            "id": "424700",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Nürnberg",
            "died": "no"
          }
        },
        "created": "15.03.2026 18:10",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "bt35y17wl42b5t5tw6z68uwyy",
        "firstName": "Jamie",
        "lastName": "Leweling",
        "shortFirstName": "Jamie",
        "shortLastName": "Leweling",
        "matchName": "J. Leweling",
        "shirtNumber": 18,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "505287": {
      "optaId": "1675dd1p91lb20f9b3w5v067e",
      "heimPlayer": {
        "id": "97766161",
        "team_id": "5",
        "person": {
          "id": "505287",
          "name": "Thomas Keller",
          "firstname": "Thomas",
          "surname": "Keller",
          "fullname": "Thomas Leon Keller",
          "gender": "male",
          "birthday": "05.08.1999",
          "height": "186",
          "weight": "82",
          "person_detail": {
            "id": "425193",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "München",
            "died": "no"
          }
        },
        "created": "13.12.2025 14:22",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "1675dd1p91lb20f9b3w5v067e",
        "firstName": "Thomas Leon",
        "lastName": "Keller",
        "shortFirstName": "Thomas",
        "shortLastName": "Keller",
        "matchName": "T. Keller",
        "shirtNumber": 27,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "506150": {
      "optaId": "evwzikhqpwulci3y20ckeoc15",
      "heimPlayer": {
        "id": "99154465",
        "team_id": "13914",
        "person": {
          "id": "506150",
          "name": "Anderson Silva",
          "firstname": "",
          "surname": "Anderson Silva",
          "fullname": "Anderson Oliveira Silva",
          "gender": "male",
          "birthday": "21.11.1997",
          "height": "186",
          "weight": "80",
          "person_detail": {
            "id": "425936",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "São Paulo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "evwzikhqpwulci3y20ckeoc15",
        "firstName": "Anderson",
        "lastName": "Oliveira Silva",
        "shortFirstName": "Anderson",
        "shortLastName": "Oliveira Silva",
        "knownName": "Anderson Silva",
        "matchName": "Anderson Silva",
        "shirtNumber": 33,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "506246": {
      "optaId": "6gjlcd7rzi3p74qwvj7ia6esq",
      "heimPlayer": {
        "id": "102117137",
        "team_id": "1639",
        "person": {
          "id": "506246",
          "name": "Noah Atubolu",
          "firstname": "Noah",
          "surname": "Atubolu",
          "fullname": "Noah Atubolu",
          "gender": "male",
          "birthday": "25.05.2002",
          "height": "190",
          "weight": "96",
          "person_detail": {
            "id": "426032",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Freiburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "6gjlcd7rzi3p74qwvj7ia6esq",
        "firstName": "Noah",
        "lastName": "Atubolu",
        "shortFirstName": "Noah",
        "shortLastName": "Atubolu",
        "matchName": "N. Atubolu",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "506636": {
      "optaId": "1yjv2fht4kuph088zlgwfwup6",
      "heimPlayer": {
        "id": "101925833",
        "team_id": "24",
        "person": {
          "id": "506636",
          "name": "Fisnik Asllani",
          "firstname": "Fisnik",
          "surname": "Asllani",
          "fullname": "Fisnik Asllani",
          "gender": "male",
          "birthday": "08.08.2002",
          "height": "191",
          "weight": "81",
          "person_detail": {
            "id": "426405",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "1yjv2fht4kuph088zlgwfwup6",
        "firstName": "Fisnik",
        "lastName": "Asllani",
        "shortFirstName": "Fisnik",
        "shortLastName": "Asllani",
        "matchName": "F. Asllani",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "507546": {
      "optaId": "25rjy5k2ogin7zcxqhwflls2y",
      "heimPlayer": {
        "id": "101995139",
        "team_id": "5",
        "person": {
          "id": "507546",
          "name": "Julian Niehues",
          "firstname": "Julian",
          "surname": "Niehues",
          "fullname": "Julian Niehues",
          "gender": "male",
          "birthday": "17.04.2001",
          "height": "195",
          "weight": "89",
          "person_detail": {
            "id": "427274",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Münster",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:33",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "25rjy5k2ogin7zcxqhwflls2y",
        "firstName": "Julian",
        "lastName": "Niehues",
        "shortFirstName": "Julian",
        "shortLastName": "Niehues",
        "matchName": "J. Niehues",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "507827": {
      "optaId": "bl76cebhta912vfi9z7ky32p6",
      "heimPlayer": {
        "id": "101867957",
        "team_id": "155",
        "person": {
          "id": "507827",
          "name": "Lazar Samardžić",
          "firstname": "Lazar",
          "surname": "Samardžić",
          "fullname": "Lazar Vujadin Samardžić",
          "gender": "male",
          "birthday": "24.02.2002",
          "height": "184",
          "weight": "79",
          "person_detail": {
            "id": "427537",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Berlin",
            "died": "no"
          },
          "country": [
            {
              "id": "185"
            }
          ]
        },
        "created": "18.03.2026 22:16",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "bl76cebhta912vfi9z7ky32p6",
        "firstName": "Lazar Vujadin",
        "lastName": "Samardžić",
        "shortFirstName": "Lazar",
        "shortLastName": "Samardzic",
        "matchName": "L. Samardžić",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "508042": {
      "optaId": "awsod0zmnrukk21d4882ji7e1",
      "heimPlayer": {
        "id": "101858795",
        "team_id": "597",
        "person": {
          "id": "508042",
          "name": "Ronald Araujo",
          "firstname": "Ronald",
          "surname": "Araujo",
          "fullname": "Ronald Federico Araujo da Silva",
          "gender": "male",
          "birthday": "07.03.1999",
          "height": "192",
          "weight": "79",
          "person_detail": {
            "id": "427704",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Rivera",
            "died": "no"
          },
          "country": [
            {
              "id": "227"
            }
          ]
        },
        "created": "18.03.2026 19:06",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "awsod0zmnrukk21d4882ji7e1",
        "firstName": "Ronald Federico",
        "lastName": "Araujo da Silva",
        "shortFirstName": "Ronald",
        "shortLastName": "Araujo",
        "matchName": "R. Araujo",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "508054": {
      "optaId": "vzbmf6lqvbw398clnt7jyiqy",
      "heimPlayer": {
        "id": "101976020",
        "team_id": "253",
        "person": {
          "id": "508054",
          "name": "Yannik Engelhardt",
          "firstname": "Yannik",
          "surname": "Engelhardt",
          "fullname": "Yannik Engelhardt",
          "gender": "male",
          "birthday": "07.02.2001",
          "height": "184",
          "weight": "74",
          "person_detail": {
            "id": "427716",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Göttingen",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "vzbmf6lqvbw398clnt7jyiqy",
        "firstName": "Yannik",
        "lastName": "Engelhardt",
        "shortFirstName": "Yannik",
        "shortLastName": "Engelhardt",
        "matchName": "Y. Engelhardt",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "508119": {
      "optaId": "eee0bq4dkdn91l81e8cf1zxpm",
      "heimPlayer": {
        "id": "101804555",
        "team_id": "1776",
        "person": {
          "id": "508119",
          "name": "Pedro Gonçalves",
          "firstname": "",
          "surname": "Pedro Gonçalves",
          "fullname": "Pedro António Pereira Gonçalves",
          "gender": "male",
          "birthday": "28.06.1998",
          "height": "173",
          "weight": "78",
          "person_detail": {
            "id": "427781",
            "position_1": "10",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Chaves",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "eee0bq4dkdn91l81e8cf1zxpm",
        "firstName": "Pedro António",
        "lastName": "Pereira Gonçalves",
        "shortFirstName": "Pedro António",
        "shortLastName": "Pereira Gonçalves",
        "knownName": "Pote",
        "matchName": "Pote",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "508417": {
      "optaId": "6hh1y9t572yqk7d1zegi0hm5m",
      "heimPlayer": {
        "id": "101972429",
        "team_id": "5",
        "person": {
          "id": "508417",
          "name": "Christian Conteh",
          "firstname": "Christian",
          "surname": "Conteh",
          "fullname": "Christian Joe Conteh",
          "gender": "male",
          "birthday": "27.08.1999",
          "height": "182",
          "weight": "72",
          "person_detail": {
            "id": "428077",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "6hh1y9t572yqk7d1zegi0hm5m",
        "firstName": "Christian Joe",
        "lastName": "Conteh",
        "shortFirstName": "Christian",
        "shortLastName": "Conteh",
        "matchName": "C. Conteh",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "508609": {
      "optaId": "85gmjxvy1g5aj1lcizegwuaui",
      "heimPlayer": {
        "id": "101812988",
        "team_id": "1267",
        "person": {
          "id": "508609",
          "name": "Jérémy Doku",
          "firstname": "Jérémy",
          "surname": "Doku",
          "fullname": "Jérémy Baffour Doku",
          "gender": "male",
          "birthday": "27.05.2002",
          "height": "173",
          "weight": "61",
          "person_detail": {
            "id": "428268",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Borgerhout",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "85gmjxvy1g5aj1lcizegwuaui",
        "firstName": "Jérémy Baffour",
        "lastName": "Doku",
        "shortFirstName": "Jérémy",
        "shortLastName": "Doku",
        "matchName": "J. Doku",
        "shirtNumber": 11,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "510292": {
      "optaId": "bxwa90x92eaokwxwylx7389re",
      "heimPlayer": {
        "id": "98017474",
        "team_id": "253",
        "person": {
          "id": "510292",
          "name": "Grant-Leon Ranos",
          "firstname": "Grant-Leon",
          "surname": "Ranos",
          "fullname": "Grant-Leon Ranos",
          "gender": "male",
          "birthday": "20.07.2003",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "429942",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Gehrden",
            "died": "no"
          }
        },
        "created": "19.12.2025 21:52",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "bxwa90x92eaokwxwylx7389re",
        "firstName": "Grant-Leon",
        "lastName": "Ranos",
        "shortFirstName": "Grant-Leon",
        "shortLastName": "Ranos",
        "matchName": "G. Ranos",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "510632": {
      "optaId": "5xk3t1pi394ojwyrhm00com7e",
      "heimPlayer": {
        "id": "97644460",
        "team_id": "1776",
        "person": {
          "id": "510632",
          "name": "Fotis Ioannidis",
          "firstname": "Fotis",
          "surname": "Ioannidis",
          "fullname": "Fotis Ioannidis",
          "gender": "male",
          "birthday": "10.01.2000",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "430280",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Athens",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "09.12.2025 20:23",
        "shirtnumber": "89"
      },
      "optaPlayer": {
        "playerId": "5xk3t1pi394ojwyrhm00com7e",
        "firstName": "Fotis",
        "lastName": "Ioannidis",
        "shortFirstName": "Fotis",
        "shortLastName": "Ioannidis",
        "matchName": "F. Ioannidis",
        "shirtNumber": 89,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "511190": {
      "optaId": "e5oet393vired282yco4i7gfd",
      "heimPlayer": {
        "id": "99158839",
        "team_id": "1736",
        "person": {
          "id": "511190",
          "name": "Daiki Hashioka",
          "firstname": "Daiki",
          "surname": "Hashioka",
          "fullname": "Daiki Hashioka",
          "gender": "male",
          "birthday": "17.05.1999",
          "height": "184",
          "weight": "81",
          "person_detail": {
            "id": "430833",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Urawa, Saitama",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "28.01.2026 22:18",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "e5oet393vired282yco4i7gfd",
        "firstName": "Daiki",
        "lastName": "Hashioka",
        "shortFirstName": "Daiki",
        "shortLastName": "Hashioka",
        "matchName": "D. Hashioka",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "511596": {
      "optaId": "22zaq3o78o5feeogqdsvig02y",
      "heimPlayer": {
        "id": "99237346",
        "team_id": "253",
        "person": {
          "id": "511596",
          "name": "Luca Netz",
          "firstname": "Luca",
          "surname": "Netz",
          "fullname": "Luca Netz",
          "gender": "male",
          "birthday": "15.05.2003",
          "height": "184",
          "weight": "83",
          "person_detail": {
            "id": "431237",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "31.01.2026 14:25",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "22zaq3o78o5feeogqdsvig02y",
        "firstName": "Luca",
        "lastName": "Netz",
        "shortFirstName": "Luca",
        "shortLastName": "Netz",
        "matchName": "L. Netz",
        "shirtNumber": 20,
        "position": "Wing Back",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "511928": {
      "optaId": "1f37bo8dikes3350u2a0h9hm2",
      "heimPlayer": {
        "id": "92682983",
        "team_id": "155",
        "person": {
          "id": "511928",
          "name": "Marco Brescianini",
          "firstname": "Marco",
          "surname": "Brescianini",
          "fullname": "Marco Brescianini",
          "gender": "male",
          "birthday": "20.01.2000",
          "height": "188",
          "weight": "80",
          "person_detail": {
            "id": "431559",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Calcinate",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "17.09.2025 22:35",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "1f37bo8dikes3350u2a0h9hm2",
        "firstName": "Marco",
        "lastName": "Brescianini",
        "shortFirstName": "Marco",
        "shortLastName": "Brescianini",
        "matchName": "M. Brescianini",
        "shirtNumber": 44,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "512593": {
      "optaId": "e3il1t1s5lrn4g8t85fcm40oa",
      "heimPlayer": {
        "id": "101361914",
        "team_id": "127",
        "person": {
          "id": "512593",
          "name": "Noni Madueke",
          "firstname": "Noni",
          "surname": "Madueke",
          "fullname": "Chukwunonso Azuka Tristan Madueke",
          "gender": "male",
          "birthday": "10.03.2002",
          "height": "182",
          "weight": "65",
          "person_detail": {
            "id": "432208",
            "position_1": "12",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Barnet, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "11.03.2026 20:02",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "e3il1t1s5lrn4g8t85fcm40oa",
        "firstName": "Chukwunonso Azuka Tristan",
        "lastName": "Madueke",
        "shortFirstName": "Noni",
        "shortLastName": "Madueke",
        "matchName": "N. Madueke",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "512671": {
      "optaId": "4ffmlhvbjvfjjnhr0byktvt62",
      "heimPlayer": {
        "id": "99153001",
        "team_id": "2102",
        "person": {
          "id": "512671",
          "name": "Arnau Tenas",
          "firstname": "",
          "surname": "Arnau Tenas",
          "fullname": "Arnau Tenas Ureña",
          "gender": "male",
          "birthday": "30.05.2001",
          "height": "185",
          "weight": "85",
          "person_detail": {
            "id": "432286",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Vic",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "4ffmlhvbjvfjjnhr0byktvt62",
        "firstName": "Arnau",
        "lastName": "Tenas Ureña",
        "shortFirstName": "Arnau",
        "shortLastName": "Tenas",
        "matchName": "Arnau Tenas",
        "shirtNumber": 25,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "512810": {
      "optaId": "aqlakf0mo95rlktf6xdbaegh5",
      "heimPlayer": {
        "id": "101353556",
        "team_id": "127",
        "person": {
          "id": "512810",
          "name": "Jurriën Timber",
          "firstname": "Jurriën",
          "surname": "Timber",
          "fullname": "Jurriën David Norman Timber (Maduro)",
          "gender": "male",
          "birthday": "17.06.2001",
          "height": "179",
          "weight": "62",
          "person_detail": {
            "id": "432424",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Utrecht",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "11.03.2026 18:03",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "aqlakf0mo95rlktf6xdbaegh5",
        "firstName": "Jurriën David Norman",
        "lastName": "Timber",
        "shortFirstName": "Jurriën",
        "shortLastName": "Timber",
        "matchName": "J. Timber",
        "shirtNumber": 12,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "512920": {
      "optaId": "5g5wwp5luxo1rz1kp6chvz0x6",
      "heimPlayer": {
        "id": "98853715",
        "team_id": "373",
        "person": {
          "id": "512920",
          "name": "Benoît Badiashile",
          "firstname": "Benoît",
          "surname": "Badiashile",
          "fullname": "Benoît Ntambue Badiashile Mukinayi",
          "gender": "male",
          "birthday": "26.03.2001",
          "height": "194",
          "weight": "75",
          "person_detail": {
            "id": "432534",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Limoges",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 19:55",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "5g5wwp5luxo1rz1kp6chvz0x6",
        "firstName": "Benoît",
        "lastName": "Ntambue Badiashile Mukinayi Baya",
        "shortFirstName": "Benoît",
        "shortLastName": "Badiashile",
        "matchName": "B. Badiashile",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "512955": {
      "optaId": "dowh6oc93ggduous7ligguqne",
      "heimPlayer": {
        "id": "93679522",
        "team_id": "1094",
        "person": {
          "id": "512955",
          "name": "João Mário",
          "firstname": "",
          "surname": "João Mário",
          "fullname": "João Mário Neto Lopes",
          "gender": "male",
          "birthday": "03.01.2000",
          "height": "178",
          "weight": "66",
          "person_detail": {
            "id": "432569",
            "position_1": "9",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "São João da Madeira",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "01.10.2025 21:17",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "dowh6oc93ggduous7ligguqne",
        "firstName": "João Mário",
        "lastName": "Neto Lopes",
        "shortFirstName": "João Mário",
        "shortLastName": "Neto Lopes",
        "knownName": "João Mário",
        "matchName": "João Mário",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "512957": {
      "optaId": "3kdl679ra6mlobdg09xqf7fft",
      "heimPlayer": {
        "id": "101868065",
        "team_id": "1226",
        "person": {
          "id": "512957",
          "name": "Curtis Jones",
          "firstname": "Curtis",
          "surname": "Jones",
          "fullname": "Curtis Julian Jones",
          "gender": "male",
          "birthday": "30.01.2001",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "432571",
            "position_1": "13",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Liverpool",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 22:27",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "3kdl679ra6mlobdg09xqf7fft",
        "firstName": "Curtis Julian",
        "lastName": "Jones",
        "shortFirstName": "Curtis",
        "shortLastName": "Jones",
        "matchName": "C. Jones",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "513231": {
      "optaId": "b0me6l44boibnwpbtasxoy02x",
      "heimPlayer": {
        "id": "99153886",
        "team_id": "1502",
        "person": {
          "id": "513231",
          "name": "Sergiño Dest",
          "firstname": "Sergiño",
          "surname": "Dest",
          "fullname": "Sergiño Gianni Dest",
          "gender": "male",
          "birthday": "03.11.2000",
          "height": "173",
          "weight": "62",
          "person_detail": {
            "id": "432845",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Almere",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "b0me6l44boibnwpbtasxoy02x",
        "firstName": "Sergiño Gianni",
        "lastName": "Dest",
        "shortFirstName": "Sergiño",
        "shortLastName": "Dest",
        "matchName": "S. Dest",
        "shirtNumber": 8,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "513233": {
      "optaId": "5ga7g20wsa7oqjbh4ijoeknl6",
      "heimPlayer": {
        "id": "101861357",
        "team_id": "1226",
        "person": {
          "id": "513233",
          "name": "Ryan Gravenberch",
          "firstname": "Ryan",
          "surname": "Gravenberch",
          "fullname": "Ryan Jiro Gravenberch",
          "gender": "male",
          "birthday": "16.05.2002",
          "height": "190",
          "weight": "83",
          "person_detail": {
            "id": "432847",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "5ga7g20wsa7oqjbh4ijoeknl6",
        "firstName": "Ryan Jiro",
        "lastName": "Gravenberch",
        "shortFirstName": "Ryan",
        "shortLastName": "Gravenberch",
        "matchName": "R. Gravenberch",
        "shirtNumber": 38,
        "position": "Defensive Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "513290": {
      "optaId": "7snt4uu7f2d0g7utjm2xfis8a",
      "heimPlayer": {
        "id": "100522015",
        "team_id": "258",
        "person": {
          "id": "513290",
          "name": "Fábio Silva",
          "firstname": "",
          "surname": "Fábio Silva",
          "fullname": "Fábio Daniel Soares Silva",
          "gender": "male",
          "birthday": "19.07.2002",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "432904",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Porto",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "25.02.2026 20:03",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "7snt4uu7f2d0g7utjm2xfis8a",
        "firstName": "Fábio Daniel",
        "lastName": "Soares Silva",
        "shortFirstName": "Fábio Daniel",
        "shortLastName": "Soares Silva",
        "knownName": "Fábio Silva",
        "matchName": "Fábio Silva",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "513295": {
      "optaId": "46vm60m1v8o9t0aesa0bpr42y",
      "heimPlayer": {
        "id": "102134450",
        "team_id": "594",
        "person": {
          "id": "513295",
          "name": "Han-Noah Massengo",
          "firstname": "Han-Noah",
          "surname": "Massengo",
          "fullname": "Han-Noah Massengo",
          "gender": "male",
          "birthday": "07.07.2001",
          "height": "178",
          "weight": "66",
          "person_detail": {
            "id": "432909",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Villepinte",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "46vm60m1v8o9t0aesa0bpr42y",
        "firstName": "Han-Noah",
        "lastName": "Massengo",
        "shortFirstName": "Han-Noah",
        "shortLastName": "Massengo",
        "matchName": "H. Massengo",
        "shirtNumber": 4,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "513309": {
      "optaId": "esb4b21x729db8od4c4xt8ciy",
      "heimPlayer": {
        "id": "100157386",
        "team_id": "1418",
        "person": {
          "id": "513309",
          "name": "Giulian Biancone",
          "firstname": "Giulian",
          "surname": "Biancone",
          "fullname": "Giulian Biancone",
          "gender": "male",
          "birthday": "31.03.2000",
          "height": "187",
          "weight": "79",
          "person_detail": {
            "id": "432920",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Fréjus",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "18.02.2026 22:11",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "esb4b21x729db8od4c4xt8ciy",
        "firstName": "Giulian",
        "lastName": "Biancone",
        "shortFirstName": "Giulian",
        "shortLastName": "Biancone",
        "matchName": "G. Biancone",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "513351": {
      "optaId": "9qo448ueot8pfc5oqo378wag9",
      "heimPlayer": {
        "id": "101861351",
        "team_id": "1226",
        "person": {
          "id": "513351",
          "name": "Jeremie Frimpong",
          "firstname": "Jeremie",
          "surname": "Frimpong",
          "fullname": "Jeremie Agyekum Frimpong",
          "gender": "male",
          "birthday": "10.12.2000",
          "height": "171",
          "weight": "65",
          "person_detail": {
            "id": "432959",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "9qo448ueot8pfc5oqo378wag9",
        "firstName": "Jeremie Agyekum",
        "lastName": "Frimpong",
        "shortFirstName": "Jeremie",
        "shortLastName": "Frimpong",
        "matchName": "J. Frimpong",
        "shirtNumber": 30,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "513358": {
      "optaId": "6384gzzxuxs6pvmrn8qx4d7u1",
      "heimPlayer": {
        "id": "100518823",
        "team_id": "258",
        "person": {
          "id": "513358",
          "name": "Felix Nmecha",
          "firstname": "Felix",
          "surname": "Nmecha",
          "fullname": "Felix Kalu Nmecha",
          "gender": "male",
          "birthday": "10.10.2000",
          "height": "190",
          "weight": "80",
          "person_detail": {
            "id": "432963",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "6384gzzxuxs6pvmrn8qx4d7u1",
        "firstName": "Felix Kalu",
        "lastName": "Nmecha",
        "shortFirstName": "Felix",
        "shortLastName": "Nmecha",
        "matchName": "F. Nmecha",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "513370": {
      "optaId": "ejuw5de99fjgrxdn79aulbm96",
      "heimPlayer": {
        "id": "98045020",
        "team_id": "1639",
        "person": {
          "id": "513370",
          "name": "Junior Adamu",
          "firstname": "Junior",
          "surname": "Adamu",
          "fullname": "Junior Chikwubuike Adamu",
          "gender": "male",
          "birthday": "06.06.2001",
          "height": "182",
          "weight": "79",
          "person_detail": {
            "id": "432975",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Kano",
            "died": "no"
          }
        },
        "created": "20.12.2025 17:11",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "ejuw5de99fjgrxdn79aulbm96",
        "firstName": "Chukwubuike Junior",
        "lastName": "Adamu",
        "shortFirstName": "Junior",
        "shortLastName": "Adamu",
        "matchName": "J. Adamu",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "513654": {
      "optaId": "9d5h5wxf44qu4fw3jk2pgis16",
      "heimPlayer": {
        "id": "98853205",
        "team_id": "156",
        "person": {
          "id": "513654",
          "name": "Daniel Vivian",
          "firstname": "",
          "surname": "Daniel Vivian",
          "fullname": "Daniel Vivian Moreno",
          "gender": "male",
          "birthday": "05.07.1999",
          "height": "184",
          "weight": "78",
          "person_detail": {
            "id": "433248",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Vitoria-Gasteiz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "21.01.2026 19:50",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "9d5h5wxf44qu4fw3jk2pgis16",
        "firstName": "Daniel",
        "lastName": "Vivian Moreno",
        "shortFirstName": "Dani",
        "shortLastName": "Vivian",
        "matchName": "Dani Vivian",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "514361": {
      "optaId": "bqdvz9kytf1u5iuv6m70k8i96",
      "heimPlayer": {
        "id": "99154516",
        "team_id": "1736",
        "person": {
          "id": "514361",
          "name": "David Douděra",
          "firstname": "David",
          "surname": "Douděra",
          "fullname": "David Douděra",
          "gender": "male",
          "birthday": "31.05.1998",
          "height": "175",
          "weight": "66",
          "person_detail": {
            "id": "433909",
            "position_1": "9",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Brandýs nad Labem-Stará Boleslav",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "bqdvz9kytf1u5iuv6m70k8i96",
        "firstName": "David",
        "lastName": "Douděra",
        "shortFirstName": "David",
        "shortLastName": "Doudera",
        "matchName": "D. Douděra",
        "shirtNumber": 21,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "514521": {
      "optaId": "7r7wgbcu7vmlj19m9jpjhu1yi",
      "heimPlayer": {
        "id": "98857396",
        "team_id": "156",
        "person": {
          "id": "514521",
          "name": "Areso",
          "firstname": "",
          "surname": "Areso",
          "fullname": "Jesús Areso Blanco",
          "gender": "male",
          "birthday": "02.07.1999",
          "height": "182",
          "weight": "81",
          "person_detail": {
            "id": "434054",
            "position_1": "5",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Cascante",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "21.01.2026 22:37",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "7r7wgbcu7vmlj19m9jpjhu1yi",
        "firstName": "Jesús",
        "lastName": "Areso Blanco",
        "shortFirstName": "Jesús",
        "shortLastName": "Areso",
        "matchName": "Jesús Areso",
        "shirtNumber": 12,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "514621": {
      "optaId": "edti8t30h7ukwi3wqlzaczje1",
      "heimPlayer": {
        "id": "100521958",
        "team_id": "136",
        "person": {
          "id": "514621",
          "name": "Folarin Balogun",
          "firstname": "Folarin",
          "surname": "Balogun",
          "fullname": "Folarin Jolaoluwa Jerry Balogun",
          "gender": "male",
          "birthday": "03.07.2001",
          "height": "178",
          "weight": "66",
          "person_detail": {
            "id": "434153",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "New York City, NY",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "edti8t30h7ukwi3wqlzaczje1",
        "firstName": "Folarin Jolaoluwa Jerry",
        "lastName": "Balogun",
        "shortFirstName": "Folarin",
        "shortLastName": "Balogun",
        "matchName": "F. Balogun",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "514679": {
      "optaId": "4qrvwap878sl5dz5n3o8mr71m",
      "heimPlayer": {
        "id": "102006215",
        "team_id": "943",
        "person": {
          "id": "514679",
          "name": "Fábio Vieira",
          "firstname": "",
          "surname": "Fábio Vieira",
          "fullname": "Fábio Daniel Ferreira Vieira",
          "gender": "male",
          "birthday": "30.05.2000",
          "height": "173",
          "weight": "63",
          "person_detail": {
            "id": "434211",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Santa Maria da Feira",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "4qrvwap878sl5dz5n3o8mr71m",
        "firstName": "Fábio Daniel",
        "lastName": "Ferreira Vieira",
        "shortFirstName": "Fábio Daniel",
        "shortLastName": "Ferreira Vieira",
        "knownName": "Fábio Vieira",
        "matchName": "Fábio Vieira",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "515588": {
      "optaId": "ad2qplv0aa66l11ipq6yh0hd5",
      "heimPlayer": {
        "id": "101973218",
        "team_id": "2134",
        "person": {
          "id": "515588",
          "name": "Yukinari Sugawara",
          "firstname": "Yukinari",
          "surname": "Sugawara",
          "fullname": "Yukinari Sugawara",
          "gender": "male",
          "birthday": "28.06.2000",
          "height": "179",
          "weight": "69",
          "person_detail": {
            "id": "435111",
            "position_1": "5",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Toyokawa, Aichi",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "ad2qplv0aa66l11ipq6yh0hd5",
        "firstName": "Yukinari",
        "lastName": "Sugawara",
        "shortFirstName": "Yukinari",
        "shortLastName": "Sugawara",
        "matchName": "Y. Sugawara",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "515774": {
      "optaId": "jflu7a5n4f3ezoj20z0kje5m",
      "heimPlayer": {
        "id": "101925791",
        "team_id": "29680",
        "person": {
          "id": "515774",
          "name": "Maarten Vandevoordt",
          "firstname": "Maarten",
          "surname": "Vandevoordt",
          "fullname": "Maarten Vandevoordt",
          "gender": "male",
          "birthday": "26.02.2002",
          "height": "192",
          "weight": "80",
          "person_detail": {
            "id": "435296",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Sint-Truiden",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "jflu7a5n4f3ezoj20z0kje5m",
        "firstName": "Maarten",
        "lastName": "Vandevoordt",
        "shortFirstName": "Maarten",
        "shortLastName": "Vandevoordt",
        "matchName": "M. Vandevoordt",
        "shirtNumber": 26,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "516473": {
      "optaId": "505oa888m5vi62ez2tsmod6ju",
      "heimPlayer": {
        "id": "100502329",
        "team_id": "18670",
        "person": {
          "id": "516473",
          "name": "Musa Qurbanli",
          "firstname": "Musa",
          "surname": "Qurbanli",
          "fullname": "Musa Qurban Oğlu Qurbanlı",
          "gender": "male",
          "birthday": "13.04.2002",
          "height": "183",
          "weight": "79",
          "person_detail": {
            "id": "435984",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Baku",
            "died": "no"
          },
          "country": [
            {
              "id": "15"
            }
          ]
        },
        "created": "24.02.2026 22:33",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "505oa888m5vi62ez2tsmod6ju",
        "firstName": "Musa",
        "lastName": "Qurbanlı",
        "shortFirstName": "Musa",
        "shortLastName": "Qurbanli",
        "matchName": "M. Qurbanlı",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "516503": {
      "optaId": "3i53phcjc5vwe7i0m9pqjo3fu",
      "heimPlayer": {
        "id": "100521595",
        "team_id": "1731",
        "person": {
          "id": "516503",
          "name": "Anatoliy Trubin",
          "firstname": "Anatoliy",
          "surname": "Trubin",
          "fullname": "Anatoliy Volodymyrovych Trubin",
          "gender": "male",
          "birthday": "01.08.2001",
          "height": "199",
          "weight": "86",
          "person_detail": {
            "id": "436014",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Donetsk",
            "died": "no"
          },
          "country": [
            {
              "id": "225"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "3i53phcjc5vwe7i0m9pqjo3fu",
        "firstName": "Anatoliy",
        "lastName": "Trubin",
        "shortFirstName": "Anatoliy",
        "shortLastName": "Trubin",
        "matchName": "A. Trubin",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "516755": {
      "optaId": "1zrqqif7sapaypdyrau1mauei",
      "heimPlayer": {
        "id": "98856346",
        "team_id": "1736",
        "person": {
          "id": "516755",
          "name": "Tomáš Vlček",
          "firstname": "Tomáš",
          "surname": "Vlček",
          "fullname": "Tomáš Vlček",
          "gender": "male",
          "birthday": "28.02.2001",
          "height": "181",
          "weight": "73",
          "person_detail": {
            "id": "436285",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Kladno",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "21.01.2026 22:06",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "1zrqqif7sapaypdyrau1mauei",
        "firstName": "Tomáš",
        "lastName": "Vlček",
        "shortFirstName": "Tomás",
        "shortLastName": "Vlcek",
        "matchName": "T. Vlček",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "517729": {
      "optaId": "5zoz3mjooujpv0wdcphyrztd6",
      "heimPlayer": {
        "id": "99152560",
        "team_id": "162",
        "person": {
          "id": "517729",
          "name": "Álex Baena",
          "firstname": "",
          "surname": "Álex Baena",
          "fullname": "Alejandro Baena Rodríguez",
          "gender": "male",
          "birthday": "20.07.2001",
          "height": "174",
          "weight": "69",
          "person_detail": {
            "id": "437251",
            "position_1": "6",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Roquetas de Mar",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "5zoz3mjooujpv0wdcphyrztd6",
        "firstName": "Alejandro",
        "lastName": "Baena Rodríguez",
        "shortFirstName": "Álex",
        "shortLastName": "Baena",
        "matchName": "Álex Baena",
        "shirtNumber": 10,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "518084": {
      "optaId": "59e0uusbhyz9wo8c3rtqlcve",
      "heimPlayer": {
        "id": "101359589",
        "team_id": "1776",
        "person": {
          "id": "518084",
          "name": "Georgios Vagiannidis",
          "firstname": "Georgios",
          "surname": "Vagiannidis",
          "fullname": "Georgios Vagiannidis",
          "gender": "male",
          "birthday": "12.09.2001",
          "height": "182",
          "weight": "68",
          "person_detail": {
            "id": "437606",
            "position_1": "5",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Athens",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "11.03.2026 19:49",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "59e0uusbhyz9wo8c3rtqlcve",
        "firstName": "Georgios",
        "lastName": "Vagiannidis",
        "shortFirstName": "Georgios",
        "shortLastName": "Vagiannidis",
        "matchName": "G. Vagiannidis",
        "shirtNumber": 13,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "518748": {
      "optaId": "etfmz143p0d2yowiiijd8g6sq",
      "heimPlayer": {
        "id": "101521418",
        "team_id": "5",
        "person": {
          "id": "518748",
          "name": "Mikkel Kaufmann",
          "firstname": "Mikkel",
          "surname": "Kaufmann",
          "fullname": "Mikkel Kaufmann Sørensen",
          "gender": "male",
          "birthday": "03.01.2001",
          "height": "190",
          "weight": "81",
          "person_detail": {
            "id": "438254",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Hjørring",
            "died": "no"
          }
        },
        "created": "14.03.2026 16:50",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "etfmz143p0d2yowiiijd8g6sq",
        "firstName": "Mikkel",
        "lastName": "Kaufmann Sørensen",
        "shortFirstName": "Mikkel",
        "shortLastName": "Kaufmann",
        "matchName": "M. Kaufmann",
        "shirtNumber": 29,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "518749": {
      "optaId": "e36lcgg2vegiecbez2j15fl9m",
      "heimPlayer": {
        "id": "93795674",
        "team_id": "2134",
        "person": {
          "id": "518749",
          "name": "Karl Hein",
          "firstname": "Karl",
          "surname": "Hein",
          "fullname": "Karl Jakob Hein",
          "gender": "male",
          "birthday": "13.04.2002",
          "height": "193",
          "weight": "76",
          "person_detail": {
            "id": "438255",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Põlva",
            "died": "no"
          }
        },
        "created": "04.10.2025 14:20",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "e36lcgg2vegiecbez2j15fl9m",
        "firstName": "Karl Jakob",
        "lastName": "Hein",
        "shortFirstName": "Karl",
        "shortLastName": "Hein",
        "matchName": "K. Hein",
        "shirtNumber": 13,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "518830": {
      "optaId": "307whzq643o50rd4g8niobyay",
      "heimPlayer": {
        "id": "101925506",
        "team_id": "29680",
        "person": {
          "id": "518830",
          "name": "Nicolas Seiwald",
          "firstname": "Nicolas",
          "surname": "Seiwald",
          "fullname": "Nicolas Seiwald",
          "gender": "male",
          "birthday": "04.05.2001",
          "height": "179",
          "weight": "79",
          "person_detail": {
            "id": "438336",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Kuchl",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "307whzq643o50rd4g8niobyay",
        "firstName": "Nicolas",
        "lastName": "Seiwald",
        "shortFirstName": "Nicolas",
        "shortLastName": "Seiwald",
        "matchName": "N. Seiwald",
        "shirtNumber": 13,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "519295": {
      "optaId": "dgubl900t52nssngev6atayju",
      "heimPlayer": {
        "id": "101999591",
        "team_id": "5",
        "person": {
          "id": "519295",
          "name": "Marvin Pieringer",
          "firstname": "Marvin",
          "surname": "Pieringer",
          "fullname": "Marvin Pieringer",
          "gender": "male",
          "birthday": "04.10.1999",
          "height": "191",
          "weight": "81",
          "person_detail": {
            "id": "438795",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bad Urach",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:52",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "dgubl900t52nssngev6atayju",
        "firstName": "Marvin",
        "lastName": "Pieringer",
        "shortFirstName": "Marvin",
        "shortLastName": "Pieringer",
        "matchName": "M. Pieringer",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "519933": {
      "optaId": "broq8imimhtlejtffissquy5m",
      "heimPlayer": {
        "id": "95785489",
        "team_id": "1545",
        "person": {
          "id": "519933",
          "name": "Rodrygo",
          "firstname": "",
          "surname": "Rodrygo",
          "fullname": "Rodrygo Silva de Goes",
          "gender": "male",
          "birthday": "09.01.2001",
          "height": "174",
          "weight": "64",
          "person_detail": {
            "id": "439277",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Osasco",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "04.11.2025 22:29",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "broq8imimhtlejtffissquy5m",
        "firstName": "Rodrygo",
        "lastName": "Silva de Goes",
        "shortFirstName": "Rodrygo",
        "shortLastName": "Silva de Goes",
        "knownName": "Rodrygo",
        "matchName": "Rodrygo",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "520205": {
      "optaId": "16rur8pbshrs9xypsq7mnxzhl",
      "heimPlayer": {
        "id": "95467165",
        "team_id": "702",
        "person": {
          "id": "520205",
          "name": "Oladapo Afolayan",
          "firstname": "Oladapo",
          "surname": "Afolayan",
          "fullname": "Oladapo Joshua Afolayan",
          "gender": "male",
          "birthday": "11.09.1997",
          "height": "180",
          "weight": "71",
          "person_detail": {
            "id": "439538",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          }
        },
        "created": "01.11.2025 14:21",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "16rur8pbshrs9xypsq7mnxzhl",
        "firstName": "Oladapo Joshua",
        "lastName": "Afolayan",
        "shortFirstName": "Oladapo",
        "shortLastName": "Afolayan",
        "matchName": "O. Afolayan",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "520526": {
      "optaId": "e4vr28e9cbq3q5nux1jlpuuei",
      "heimPlayer": {
        "id": "98045728",
        "team_id": "24",
        "person": {
          "id": "520526",
          "name": "Adam Hložek",
          "firstname": "Adam",
          "surname": "Hložek",
          "fullname": "Adam Hložek",
          "gender": "male",
          "birthday": "25.07.2002",
          "height": "188",
          "weight": "74",
          "person_detail": {
            "id": "439858",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Ivančice",
            "died": "no"
          }
        },
        "created": "20.12.2025 17:17",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "e4vr28e9cbq3q5nux1jlpuuei",
        "firstName": "Adam",
        "lastName": "Hložek",
        "shortFirstName": "Adam",
        "shortLastName": "Hlozek",
        "matchName": "A. Hložek",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "520543": {
      "optaId": "cs4aca71qkt1ru20ppmi6djl6",
      "heimPlayer": {
        "id": "99153874",
        "team_id": "1502",
        "person": {
          "id": "520543",
          "name": "Matěj Kovář",
          "firstname": "Matěj",
          "surname": "Kovář",
          "fullname": "Matěj Kovář",
          "gender": "male",
          "birthday": "17.05.2000",
          "height": "196",
          "weight": "88",
          "person_detail": {
            "id": "439875",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Uherské Hradiště",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "cs4aca71qkt1ru20ppmi6djl6",
        "firstName": "Matěj",
        "lastName": "Kovář",
        "shortFirstName": "Matej",
        "shortLastName": "Kovár",
        "matchName": "M. Kovář",
        "shirtNumber": 32,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "520545": {
      "optaId": "7oz324ar8tp6nkd934y096q22",
      "heimPlayer": {
        "id": "99154498",
        "team_id": "1736",
        "person": {
          "id": "520545",
          "name": "David Zima",
          "firstname": "David",
          "surname": "Zima",
          "fullname": "David Zima",
          "gender": "male",
          "birthday": "08.11.2000",
          "height": "192",
          "weight": "80",
          "person_detail": {
            "id": "439877",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Olomouc",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "7oz324ar8tp6nkd934y096q22",
        "firstName": "David",
        "lastName": "Zima",
        "shortFirstName": "David",
        "shortLastName": "Zima",
        "matchName": "D. Zima",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "520919": {
      "optaId": "9v4l7ic3ve6d22c0gs9p1oe3u",
      "heimPlayer": {
        "id": "101822507",
        "team_id": "1457",
        "person": {
          "id": "520919",
          "name": "Gonçalo Ramos",
          "firstname": "",
          "surname": "Gonçalo Ramos",
          "fullname": "Gonçalo Matias Ramos",
          "gender": "male",
          "birthday": "20.06.2001",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "440191",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Olhão",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 22:23",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "9v4l7ic3ve6d22c0gs9p1oe3u",
        "firstName": "Gonçalo",
        "lastName": "Matias Ramos",
        "shortFirstName": "Gonçalo",
        "shortLastName": "Matias Ramos",
        "knownName": "Gonçalo Ramos",
        "matchName": "Gonçalo Ramos",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "521107": {
      "optaId": "6kicom9a3lzp49urle78bevl6",
      "heimPlayer": {
        "id": "98854045",
        "team_id": "1421",
        "person": {
          "id": "521107",
          "name": "Mason Greenwood",
          "firstname": "Mason",
          "surname": "Greenwood",
          "fullname": "Mason Will John Greenwood",
          "gender": "male",
          "birthday": "01.10.2001",
          "height": "181",
          "weight": "70",
          "person_detail": {
            "id": "440349",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "both",
            "birth_place": "Wibsey",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "6kicom9a3lzp49urle78bevl6",
        "firstName": "Mason Will John",
        "lastName": "Greenwood",
        "shortFirstName": "Mason",
        "shortLastName": "Greenwood",
        "matchName": "M. Greenwood",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "524669": {
      "optaId": "pjbuqt8wiwm2ql2tfvvcn59m",
      "heimPlayer": {
        "id": "101925848",
        "team_id": "24",
        "person": {
          "id": "524669",
          "name": "Tim Lemperle",
          "firstname": "Tim",
          "surname": "Lemperle",
          "fullname": "Tim Lemperle",
          "gender": "male",
          "birthday": "05.02.2002",
          "height": "187",
          "weight": "78",
          "person_detail": {
            "id": "441132",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:19",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "pjbuqt8wiwm2ql2tfvvcn59m",
        "firstName": "Tim",
        "lastName": "Lemperle",
        "shortFirstName": "Tim",
        "shortLastName": "Lemperle",
        "matchName": "T. Lemperle",
        "shirtNumber": 19,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "524892": {
      "optaId": "ch0a4pjl5j095773ajdm9pn56",
      "heimPlayer": {
        "id": "100492132",
        "team_id": "1418",
        "person": {
          "id": "524892",
          "name": "Francisco Ortega",
          "firstname": "Francisco",
          "surname": "Ortega",
          "fullname": "Francisco Gabriel Ortega",
          "gender": "male",
          "birthday": "19.03.1999",
          "height": "178",
          "weight": "75",
          "person_detail": {
            "id": "441348",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Santa Fé",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "ch0a4pjl5j095773ajdm9pn56",
        "firstName": "Francisco Gabriel",
        "lastName": "Ortega",
        "shortFirstName": "Francisco",
        "shortLastName": "Ortega",
        "matchName": "F. Ortega",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "525762": {
      "optaId": "a86j56bn5wd6k9ut7ltf6whgq",
      "heimPlayer": {
        "id": "101861135",
        "team_id": "853",
        "person": {
          "id": "525762",
          "name": "Gabriel Sara",
          "firstname": "",
          "surname": "Gabriel Sara",
          "fullname": "Gabriel Davi Gomes Sara",
          "gender": "male",
          "birthday": "26.06.1999",
          "height": "176",
          "weight": "76",
          "person_detail": {
            "id": "442188",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Joinville",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "a86j56bn5wd6k9ut7ltf6whgq",
        "firstName": "Gabriel Davi",
        "lastName": "Gomes Sara",
        "shortFirstName": "Gabriel Davi",
        "shortLastName": "Gomes Sara",
        "knownName": "Gabriel Sara",
        "matchName": "Gabriel Sara",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "525891": {
      "optaId": "3mctpepmqunc1a8zro2nq1wtm",
      "heimPlayer": {
        "id": "99152242",
        "team_id": "64",
        "person": {
          "id": "525891",
          "name": "Vítězslav Jaroš",
          "firstname": "Vítězslav",
          "surname": "Jaroš",
          "fullname": "Vítězslav Jaroš",
          "gender": "male",
          "birthday": "23.07.2001",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "442325",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Příbram",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "3mctpepmqunc1a8zro2nq1wtm",
        "firstName": "Vítězslav",
        "lastName": "Jaroš",
        "shortFirstName": "Vítezslav",
        "shortLastName": "Jaros",
        "matchName": "V. Jaroš",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "526279": {
      "optaId": "8mjj0wgufggpc1ai2dk21h90p",
      "heimPlayer": {
        "id": "101855735",
        "team_id": "1355",
        "person": {
          "id": "526279",
          "name": "Anthony Gordon",
          "firstname": "Anthony",
          "surname": "Gordon",
          "fullname": "Anthony Michael Gordon",
          "gender": "male",
          "birthday": "24.02.2001",
          "height": "183",
          "weight": "70",
          "person_detail": {
            "id": "442711",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Liverpool",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "8mjj0wgufggpc1ai2dk21h90p",
        "firstName": "Anthony Michael",
        "lastName": "Gordon",
        "shortFirstName": "Anthony",
        "shortLastName": "Gordon",
        "matchName": "A. Gordon",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "527176": {
      "optaId": "di9k6xr6j4arjoltl7s9yp6cq",
      "heimPlayer": {
        "id": "101973251",
        "team_id": "2134",
        "person": {
          "id": "527176",
          "name": "Cameron Puertas",
          "firstname": "Cameron",
          "surname": "Puertas",
          "fullname": "Cameron Mitchel Puertas Castro",
          "gender": "male",
          "birthday": "18.08.1998",
          "height": "178",
          "weight": "74",
          "person_detail": {
            "id": "443591",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Lausanne",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "di9k6xr6j4arjoltl7s9yp6cq",
        "firstName": "Cameron Mitchel",
        "lastName": "Puertas Castro",
        "shortFirstName": "Cameron",
        "shortLastName": "Puertas",
        "matchName": "Cameron Puertas",
        "shirtNumber": 18,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "527188": {
      "optaId": "dx47szytc8vttuj4rcn4yzdre",
      "heimPlayer": {
        "id": "101634077",
        "team_id": "2134",
        "person": {
          "id": "527188",
          "name": "Isaac Schmidt",
          "firstname": "Isaac",
          "surname": "Schmidt",
          "fullname": "Isaac Osa's Schmidt",
          "gender": "male",
          "birthday": "07.12.1999",
          "height": "172",
          "weight": "68",
          "person_detail": {
            "id": "443605",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Lausanne",
            "died": "no"
          }
        },
        "created": "15.03.2026 16:57",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "dx47szytc8vttuj4rcn4yzdre",
        "firstName": "Isaac",
        "lastName": "Schmidt",
        "shortFirstName": "Isaac",
        "shortLastName": "Schmidt",
        "matchName": "I. Schmidt",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "527987": {
      "optaId": "8b3igmuipfhfzm39ack89de96",
      "heimPlayer": {
        "id": "101823086",
        "team_id": "1457",
        "person": {
          "id": "527987",
          "name": "Kang-in Lee",
          "firstname": "Kang-in",
          "surname": "Lee",
          "fullname": "Kang-in Lee",
          "gender": "male",
          "birthday": "19.02.2001",
          "height": "173",
          "weight": "66",
          "person_detail": {
            "id": "444220",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Incheon",
            "died": "no"
          },
          "country": [
            {
              "id": "203"
            }
          ]
        },
        "created": "17.03.2026 22:29",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "8b3igmuipfhfzm39ack89de96",
        "firstName": "Kang-In",
        "lastName": "Lee",
        "shortFirstName": "Kang-In",
        "shortLastName": "Lee",
        "knownName": "Lee Kang-In",
        "matchName": "Lee Kang-In",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "528820": {
      "optaId": "bbf1u7db2qw8u4bega6b0uesq",
      "heimPlayer": {
        "id": "100501660",
        "team_id": "1418",
        "person": {
          "id": "528820",
          "name": "Ayoub El Kaabi",
          "firstname": "Ayoub",
          "surname": "El Kaabi",
          "fullname": "Ayoub El Kaabi",
          "gender": "male",
          "birthday": "25.06.1993",
          "height": "182",
          "weight": "72",
          "person_detail": {
            "id": "444912",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Casablanca",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "24.02.2026 22:21",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bbf1u7db2qw8u4bega6b0uesq",
        "firstName": "Ayoub",
        "lastName": "El Kaabi",
        "shortFirstName": "Ayoub",
        "shortLastName": "El Kaabi",
        "matchName": "A. El Kaabi",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "530209": {
      "optaId": "5f8kjgsaabn2li5r7bvpebbsa",
      "heimPlayer": {
        "id": "101855570",
        "team_id": "597",
        "person": {
          "id": "530209",
          "name": "Joan García",
          "firstname": "",
          "surname": "Joan García",
          "fullname": "Joan García Pons",
          "gender": "male",
          "birthday": "04.05.2001",
          "height": "191",
          "weight": "79",
          "person_detail": {
            "id": "445842",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Sallent de Llobregat",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "5f8kjgsaabn2li5r7bvpebbsa",
        "firstName": "Joan",
        "lastName": "García Pons",
        "shortFirstName": "Joan",
        "shortLastName": "García",
        "knownName": "Joan García",
        "matchName": "Joan García",
        "shirtNumber": 13,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "530400": {
      "optaId": "e1islmeew98wa2ge0dicloay2",
      "heimPlayer": {
        "id": "98030182",
        "team_id": "2086",
        "person": {
          "id": "530400",
          "name": "Jenson Seelt",
          "firstname": "Jenson",
          "surname": "Seelt",
          "fullname": "Jenson Seelt",
          "gender": "male",
          "birthday": "23.05.2003",
          "height": "192",
          "weight": "84",
          "person_detail": {
            "id": "446032",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ede",
            "died": "no"
          }
        },
        "created": "20.12.2025 14:08",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "e1islmeew98wa2ge0dicloay2",
        "firstName": "Jenson",
        "lastName": "Seelt",
        "shortFirstName": "Jenson",
        "shortLastName": "Seelt",
        "matchName": "J. Seelt",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "530413": {
      "optaId": "7yirx71oya71zjsgldj5ucqcq",
      "heimPlayer": {
        "id": "101359955",
        "team_id": "373",
        "person": {
          "id": "530413",
          "name": "Wesley Fofana",
          "firstname": "Wesley",
          "surname": "Fofana",
          "fullname": "Wesley Fofana",
          "gender": "male",
          "birthday": "17.12.2000",
          "height": "188",
          "weight": "76",
          "person_detail": {
            "id": "446045",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Marseille",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "11.03.2026 19:52",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "7yirx71oya71zjsgldj5ucqcq",
        "firstName": "Wesley Tidjan",
        "lastName": "Fofana",
        "shortFirstName": "Wesley",
        "shortLastName": "Fofana",
        "matchName": "W. Fofana",
        "shirtNumber": 29,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "530777": {
      "optaId": "2p1pns6j6id4nx3nbi7fv0wrt",
      "heimPlayer": {
        "id": "101862242",
        "team_id": "209",
        "person": {
          "id": "530777",
          "name": "Min-jae Kim",
          "firstname": "Min-jae",
          "surname": "Kim",
          "fullname": "Min-jae Kim",
          "gender": "male",
          "birthday": "15.11.1996",
          "height": "190",
          "weight": "81",
          "person_detail": {
            "id": "446378",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Tongyeong, Gyeongnam",
            "died": "no"
          },
          "country": [
            {
              "id": "203"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "2p1pns6j6id4nx3nbi7fv0wrt",
        "firstName": "Min-Jae",
        "lastName": "Kim",
        "shortFirstName": "Min-Jae",
        "shortLastName": "Kim",
        "knownName": "Kim Min-Jae",
        "matchName": "Kim Min-Jae",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "530791": {
      "optaId": "2r1u01vlym0nwcwx86bwbuusq",
      "heimPlayer": {
        "id": "97641763",
        "team_id": "136",
        "person": {
          "id": "530791",
          "name": "Mohammed Salisu",
          "firstname": "Mohammed",
          "surname": "Salisu",
          "fullname": "Mohammed Salisu Abdul Karim",
          "gender": "male",
          "birthday": "17.04.1999",
          "height": "191",
          "weight": "82",
          "person_detail": {
            "id": "446392",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Kumasi",
            "died": "no"
          },
          "country": [
            {
              "id": "66"
            }
          ]
        },
        "created": "09.12.2025 19:54",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "2r1u01vlym0nwcwx86bwbuusq",
        "firstName": "Mohammed",
        "lastName": "Salisu Abdul Karim",
        "shortFirstName": "Mohammed",
        "shortLastName": "Salisu",
        "matchName": "M. Salisu",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "530903": {
      "optaId": "dedho18swt010xrsviuryauc4",
      "heimPlayer": {
        "id": "101645849",
        "team_id": "2076",
        "person": {
          "id": "530903",
          "name": "Luca Jaquez",
          "firstname": "Luca",
          "surname": "Jaquez",
          "fullname": "Luca Antony Jaquez",
          "gender": "male",
          "birthday": "02.06.2003",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "446504",
            "position_1": "4",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Luzern",
            "died": "no"
          }
        },
        "created": "15.03.2026 18:10",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "dedho18swt010xrsviuryauc4",
        "firstName": "Luca Antony",
        "lastName": "Jaquez",
        "shortFirstName": "Luca",
        "shortLastName": "Jaquez",
        "matchName": "L. Jaquez",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "530947": {
      "optaId": "bno18pni4atsobrxawb31vdd6",
      "heimPlayer": {
        "id": "100656439",
        "team_id": "5",
        "person": {
          "id": "530947",
          "name": "Leonidas Stergiou",
          "firstname": "Leonidas",
          "surname": "Stergiou",
          "fullname": "Leonidas Stergiou",
          "gender": "male",
          "birthday": "03.03.2002",
          "height": "181",
          "weight": "75",
          "person_detail": {
            "id": "446548",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Wattwil",
            "died": "no"
          }
        },
        "created": "28.02.2026 16:34",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "bno18pni4atsobrxawb31vdd6",
        "firstName": "Leonidas",
        "lastName": "Stergiou",
        "shortFirstName": "Leonidas",
        "shortLastName": "Stergiou",
        "matchName": "L. Stergiou",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "530961": {
      "optaId": "83usrrx99pkiihnkz44dt2gru",
      "heimPlayer": {
        "id": "102134474",
        "team_id": "594",
        "person": {
          "id": "530961",
          "name": "Fabian Rieder",
          "firstname": "Fabian",
          "surname": "Rieder",
          "fullname": "Fabian Rieder",
          "gender": "male",
          "birthday": "16.02.2002",
          "height": "179",
          "weight": "74",
          "person_detail": {
            "id": "446561",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Bern",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "83usrrx99pkiihnkz44dt2gru",
        "firstName": "Fabian",
        "lastName": "Rieder",
        "shortFirstName": "Fabian",
        "shortLastName": "Rieder",
        "matchName": "F. Rieder",
        "shirtNumber": 32,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "531018": {
      "optaId": "dhs8pujk55ewcis7y5alchu22",
      "heimPlayer": {
        "id": "99154570",
        "team_id": "127",
        "person": {
          "id": "531018",
          "name": "Riccardo Calafiori",
          "firstname": "Riccardo",
          "surname": "Calafiori",
          "fullname": "Riccardo Calafiori",
          "gender": "male",
          "birthday": "19.05.2002",
          "height": "188",
          "weight": "86",
          "person_detail": {
            "id": "446618",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Roma",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "dhs8pujk55ewcis7y5alchu22",
        "firstName": "Riccardo",
        "lastName": "Calafiori",
        "shortFirstName": "Riccardo",
        "shortLastName": "Calafiori",
        "matchName": "R. Calafiori",
        "shirtNumber": 33,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "531189": {
      "optaId": "b8ixf31bdyfqqcwoy4ulai73e",
      "heimPlayer": {
        "id": "98836303",
        "team_id": "64",
        "person": {
          "id": "531189",
          "name": "Kian Fitz-Jim",
          "firstname": "Kian",
          "surname": "Fitz-Jim",
          "fullname": "Kian Fitz-Jim",
          "gender": "male",
          "birthday": "05.07.2003",
          "height": "174",
          "weight": "",
          "person_detail": {
            "id": "446789",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "20.01.2026 22:41",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "b8ixf31bdyfqqcwoy4ulai73e",
        "firstName": "Kian Franklin",
        "lastName": "Fitz-Jim",
        "shortFirstName": "Kian",
        "shortLastName": "Fitz-Jim",
        "matchName": "K. Fitz-Jim",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "531273": {
      "optaId": "6jhavdnaitqn6ydme8a526aui",
      "heimPlayer": {
        "id": "99159667",
        "team_id": "1502",
        "person": {
          "id": "531273",
          "name": "Couhaib Driouech",
          "firstname": "Couhaib",
          "surname": "Driouech",
          "fullname": "Couhaib Driouech",
          "gender": "male",
          "birthday": "17.04.2002",
          "height": "175",
          "weight": "75",
          "person_detail": {
            "id": "446865",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Haarlem",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "28.01.2026 22:39",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "6jhavdnaitqn6ydme8a526aui",
        "firstName": "Couhaib",
        "lastName": "Driouech",
        "shortFirstName": "Couhaib",
        "shortLastName": "Driouech",
        "matchName": "C. Driouech",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "531921": {
      "optaId": "bhsh1n3qfg8awmctxlh8k7yzt",
      "heimPlayer": {
        "id": "101855729",
        "team_id": "1355",
        "person": {
          "id": "531921",
          "name": "Jacob Ramsey",
          "firstname": "Jacob",
          "surname": "Ramsey",
          "fullname": "Jacob Matthew Ramsey",
          "gender": "male",
          "birthday": "28.05.2001",
          "height": "180",
          "weight": "74",
          "person_detail": {
            "id": "447852",
            "position_1": "6",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Birmingham",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "bhsh1n3qfg8awmctxlh8k7yzt",
        "firstName": "Jacob Matthew",
        "lastName": "Ramsey",
        "shortFirstName": "Jacob",
        "shortLastName": "Ramsey",
        "matchName": "J. Ramsey",
        "shirtNumber": 41,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "532116": {
      "optaId": "d9i8y5vlymc2yggwxrax8wcbu",
      "heimPlayer": {
        "id": "101804549",
        "team_id": "1776",
        "person": {
          "id": "532116",
          "name": "Hidemasa Morita",
          "firstname": "Hidemasa",
          "surname": "Morita",
          "fullname": "Hidemasa Morita",
          "gender": "male",
          "birthday": "10.05.1995",
          "height": "177",
          "weight": "72",
          "person_detail": {
            "id": "448261",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Takatsuki, Osaka",
            "died": "no"
          },
          "country": [
            {
              "id": "91"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "d9i8y5vlymc2yggwxrax8wcbu",
        "firstName": "Hidemasa",
        "lastName": "Morita",
        "shortFirstName": "Hidemasa",
        "shortLastName": "Morita",
        "matchName": "H. Morita",
        "shirtNumber": 5,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "532144": {
      "optaId": "b7c3s9rkunqkgc3h3u8xbx71l",
      "heimPlayer": {
        "id": "100493308",
        "team_id": "18670",
        "person": {
          "id": "532144",
          "name": "Matheus Silva",
          "firstname": "",
          "surname": "Matheus Silva",
          "fullname": "Matheus de Barros da Silva",
          "gender": "male",
          "birthday": "03.10.1997",
          "height": "182",
          "weight": "76",
          "person_detail": {
            "id": "448344",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Marituba",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "b7c3s9rkunqkgc3h3u8xbx71l",
        "firstName": "Matheus",
        "lastName": "de Barros da Silva",
        "shortFirstName": "Matheus",
        "shortLastName": "de Barros da Silva",
        "knownName": "Matheus Silva",
        "matchName": "Matheus Silva",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "532203": {
      "optaId": "4o71xxq6qdkhug58a073fxega",
      "heimPlayer": {
        "id": "102004346",
        "team_id": "253",
        "person": {
          "id": "532203",
          "name": "Shūto Machino",
          "firstname": "Shūto",
          "surname": "Machino",
          "fullname": "Shūto Machino",
          "gender": "male",
          "birthday": "30.09.1999",
          "height": "185",
          "weight": "81",
          "person_detail": {
            "id": "448486",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Iga, Mie",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:17",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "4o71xxq6qdkhug58a073fxega",
        "firstName": "Shuto",
        "lastName": "Machino",
        "shortFirstName": "Shuto",
        "shortLastName": "Machino",
        "matchName": "S. Machino",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "532444": {
      "optaId": "8tc7dcuwdeqbjgt7vw5p38xgq",
      "heimPlayer": {
        "id": "101812814",
        "team_id": "127",
        "person": {
          "id": "532444",
          "name": "Bukayo Saka",
          "firstname": "Bukayo",
          "surname": "Saka",
          "fullname": "Bukayo Saka",
          "gender": "male",
          "birthday": "05.09.2001",
          "height": "178",
          "weight": "65",
          "person_detail": {
            "id": "449096",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Ealing, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "8tc7dcuwdeqbjgt7vw5p38xgq",
        "firstName": "Bukayo Ayoyinka Temidayo",
        "lastName": "Saka",
        "shortFirstName": "Bukayo",
        "shortLastName": "Saka",
        "matchName": "B. Saka",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7",
        "captain": "yes"
      }
    },
    "532583": {
      "optaId": "2n808wa0h841cn8xi78n21v8q",
      "heimPlayer": {
        "id": "99933616",
        "team_id": "702",
        "person": {
          "id": "532583",
          "name": "Taichi Hara",
          "firstname": "Taichi",
          "surname": "Hara",
          "fullname": "Taichi Hara",
          "gender": "male",
          "birthday": "05.05.1999",
          "height": "191",
          "weight": "84",
          "person_detail": {
            "id": "449561",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Hino, Tokio",
            "died": "no"
          }
        },
        "created": "14.02.2026 16:56",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "2n808wa0h841cn8xi78n21v8q",
        "firstName": "Taichi",
        "lastName": "Hara",
        "shortFirstName": "Taichi",
        "shortLastName": "Hara",
        "matchName": "T. Hara",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "533417": {
      "optaId": "ecwzzrkn1snbua5yu4gehxm2",
      "heimPlayer": {
        "id": "101812421",
        "team_id": "1457",
        "person": {
          "id": "533417",
          "name": "Willian Pacho",
          "firstname": "Willian",
          "surname": "Pacho",
          "fullname": "Willian Joel Pacho Tenorio",
          "gender": "male",
          "birthday": "16.10.2001",
          "height": "188",
          "weight": "81",
          "person_detail": {
            "id": "450958",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Quinindé",
            "died": "no"
          },
          "country": [
            {
              "id": "52"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "51"
      },
      "optaPlayer": {
        "playerId": "ecwzzrkn1snbua5yu4gehxm2",
        "firstName": "Willian Joel",
        "lastName": "Pacho Tenorio",
        "shortFirstName": "Willian",
        "shortLastName": "Pacho",
        "matchName": "W. Pacho",
        "shirtNumber": 51,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "534188": {
      "optaId": "7gqecbxztxxovmo1b6zqqcgve",
      "heimPlayer": {
        "id": "101804810",
        "team_id": "749",
        "person": {
          "id": "534188",
          "name": "Odin Bjørtuft",
          "firstname": "Odin",
          "surname": "Bjørtuft",
          "fullname": "Odin Lurås Bjørtuft",
          "gender": "male",
          "birthday": "19.12.1998",
          "height": "188",
          "weight": "80",
          "person_detail": {
            "id": "451862",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Porsgrunn",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "7gqecbxztxxovmo1b6zqqcgve",
        "firstName": "Odin",
        "lastName": "Lurås Bjørtuft",
        "shortFirstName": "Odin",
        "shortLastName": "Bjørtuft",
        "matchName": "O. Bjørtuft",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "534219": {
      "optaId": "f1b958d0xab1okq496kx0nfje",
      "heimPlayer": {
        "id": "99154501",
        "team_id": "1736",
        "person": {
          "id": "534219",
          "name": "Igoh Ogbu",
          "firstname": "Igoh",
          "surname": "Ogbu",
          "fullname": "Igoh Ogbu",
          "gender": "male",
          "birthday": "08.02.2000",
          "height": "187",
          "weight": "83",
          "person_detail": {
            "id": "451892",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Jos",
            "died": "no"
          },
          "country": [
            {
              "id": "151"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "f1b958d0xab1okq496kx0nfje",
        "firstName": "Igoh",
        "lastName": "Ogbu",
        "shortFirstName": "Igoh",
        "shortLastName": "Ogbu",
        "matchName": "I. Ogbu",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "535550": {
      "optaId": "1wzbok5h048nfbmusztsc3joq",
      "heimPlayer": {
        "id": "101804537",
        "team_id": "1776",
        "person": {
          "id": "535550",
          "name": "Maxi Araújo",
          "firstname": "Maxi",
          "surname": "Araújo",
          "fullname": "Maximiliano Javier Araújo Vilches",
          "gender": "male",
          "birthday": "15.02.2000",
          "height": "179",
          "weight": "73",
          "person_detail": {
            "id": "453200",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Montevideo",
            "died": "no"
          },
          "country": [
            {
              "id": "227"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "1wzbok5h048nfbmusztsc3joq",
        "firstName": "Maximiliano Javier",
        "lastName": "Araújo Vilches",
        "shortFirstName": "Maxi",
        "shortLastName": "Araújo",
        "matchName": "M. Araújo",
        "shirtNumber": 20,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "537044": {
      "optaId": "70esd7csbds20h5uazwktcbje",
      "heimPlayer": {
        "id": "101861123",
        "team_id": "853",
        "person": {
          "id": "537044",
          "name": "Sacha Boey",
          "firstname": "Sacha",
          "surname": "Boey",
          "fullname": "Sacha Boey",
          "gender": "male",
          "birthday": "13.09.2000",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "454655",
            "position_1": "5",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Montreuil",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "93"
      },
      "optaPlayer": {
        "playerId": "70esd7csbds20h5uazwktcbje",
        "firstName": "Sacha Gaston",
        "lastName": "Boey",
        "shortFirstName": "Sacha",
        "shortLastName": "Boey",
        "matchName": "S. Boey",
        "shirtNumber": 93,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "537046": {
      "optaId": "a9jc36ub52lh0jgq2ya56wyui",
      "heimPlayer": {
        "id": "101057992",
        "team_id": "24",
        "person": {
          "id": "537046",
          "name": "Valentin Gendrey",
          "firstname": "Valentin",
          "surname": "Gendrey",
          "fullname": "Valentin André Stanislas Gendrey",
          "gender": "male",
          "birthday": "21.06.2000",
          "height": "179",
          "weight": "75",
          "person_detail": {
            "id": "454657",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "La Garenne-Colombes",
            "died": "no"
          }
        },
        "created": "07.03.2026 17:20",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "a9jc36ub52lh0jgq2ya56wyui",
        "firstName": "Valentin André Stanislas",
        "lastName": "Gendrey",
        "shortFirstName": "Valentin",
        "shortLastName": "Gendrey",
        "matchName": "V. Gendrey",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "537058": {
      "optaId": "3coml6cxqa86px9up8yy3oz1m",
      "heimPlayer": {
        "id": "100492135",
        "team_id": "1418",
        "person": {
          "id": "537058",
          "name": "Lorenzo Pirola",
          "firstname": "Lorenzo",
          "surname": "Pirola",
          "fullname": "Lorenzo Pirola",
          "gender": "male",
          "birthday": "20.02.2002",
          "height": "188",
          "weight": "72",
          "person_detail": {
            "id": "454668",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Carate Brianza",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "3coml6cxqa86px9up8yy3oz1m",
        "firstName": "Lorenzo",
        "lastName": "Pirola",
        "shortFirstName": "Lorenzo",
        "shortLastName": "Pirola",
        "matchName": "L. Pirola",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "538284": {
      "optaId": "43eq31reskwn9veb3vickralm",
      "heimPlayer": {
        "id": "101976266",
        "team_id": "253",
        "person": {
          "id": "538284",
          "name": "Joe Scally",
          "firstname": "Joe",
          "surname": "Scally",
          "fullname": "Joseph Michael Scally",
          "gender": "male",
          "birthday": "31.12.2002",
          "height": "184",
          "weight": "80",
          "person_detail": {
            "id": "455842",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Lake Grove, NY",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:28",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "43eq31reskwn9veb3vickralm",
        "firstName": "Joseph Michael",
        "lastName": "Scally",
        "shortFirstName": "Joe",
        "shortLastName": "Scally",
        "matchName": "J. Scally",
        "shirtNumber": 29,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "538532": {
      "optaId": "74edqcuzfzy7nswqzn0v3pe22",
      "heimPlayer": {
        "id": "98854024",
        "team_id": "1421",
        "person": {
          "id": "538532",
          "name": "Leonardo Balerdi",
          "firstname": "Leonardo",
          "surname": "Balerdi",
          "fullname": "Leonardo Julián Balerdi Rosa",
          "gender": "male",
          "birthday": "26.01.1999",
          "height": "187",
          "weight": "76",
          "person_detail": {
            "id": "456048",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Villa Mercedes, San Luis",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "21.01.2026 20:01",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "74edqcuzfzy7nswqzn0v3pe22",
        "firstName": "Leonardo Julián",
        "lastName": "Balerdi Rosa",
        "shortFirstName": "Leonardo",
        "shortLastName": "Balerdi",
        "matchName": "L. Balerdi",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5",
        "captain": "yes"
      }
    },
    "538539": {
      "optaId": "4ea0sjczqa5ah1w720zlakkfe",
      "heimPlayer": {
        "id": "99158716",
        "team_id": "162",
        "person": {
          "id": "538539",
          "name": "Thiago Almada",
          "firstname": "Thiago",
          "surname": "Almada",
          "fullname": "Thiago Ezequiel Almada",
          "gender": "male",
          "birthday": "26.04.2001",
          "height": "171",
          "weight": "62",
          "person_detail": {
            "id": "456055",
            "position_1": "6",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "28.01.2026 22:16",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "4ea0sjczqa5ah1w720zlakkfe",
        "firstName": "Thiago Ezequiel",
        "lastName": "Almada",
        "shortFirstName": "Thiago",
        "shortLastName": "Almada",
        "matchName": "T. Almada",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "538921": {
      "optaId": "1arzd8hqj73byhduozscqz5uy",
      "heimPlayer": {
        "id": "97691728",
        "team_id": "749",
        "person": {
          "id": "538921",
          "name": "Mathias Jørgensen",
          "firstname": "Mathias",
          "surname": "Jørgensen",
          "fullname": "Mathias Jørgensen",
          "gender": "male",
          "birthday": "20.09.2000",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "456436",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Hundested",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "10.12.2025 22:26",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "1arzd8hqj73byhduozscqz5uy",
        "firstName": "Mathias",
        "lastName": "Jørgensen",
        "shortFirstName": "Mathias",
        "shortLastName": "Jørgensen",
        "matchName": "M. Jørgensen",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "539094": {
      "optaId": "7ox43isyywsnrfcd56nm65be",
      "heimPlayer": {
        "id": "101862320",
        "team_id": "155",
        "person": {
          "id": "539094",
          "name": "Charles De Ketelaere",
          "firstname": "Charles",
          "surname": "De Ketelaere",
          "fullname": "Charles Marc S. De Ketelaere",
          "gender": "male",
          "birthday": "10.03.2001",
          "height": "192",
          "weight": "74",
          "person_detail": {
            "id": "456598",
            "position_1": "8",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Brugge",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "7ox43isyywsnrfcd56nm65be",
        "firstName": "Charles Marc S.",
        "lastName": "De Ketelaere",
        "shortFirstName": "Charles",
        "shortLastName": "De Ketelaere",
        "matchName": "C. De Ketelaere",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "539578": {
      "optaId": "9jxhgh1vhc531ho0ez5alfazu",
      "heimPlayer": {
        "id": "101812973",
        "team_id": "1267",
        "person": {
          "id": "539578",
          "name": "Rayan Aït Nouri",
          "firstname": "Rayan",
          "surname": "Aït Nouri",
          "fullname": "Rayan Aït Nouri",
          "gender": "male",
          "birthday": "06.06.2001",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "456813",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Montreuil",
            "died": "no"
          },
          "country": [
            {
              "id": "4"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "9jxhgh1vhc531ho0ez5alfazu",
        "firstName": "Rayan",
        "lastName": "Aït-Nouri",
        "shortFirstName": "Rayan",
        "shortLastName": "Aït-Nouri",
        "matchName": "R. Aït-Nouri",
        "shirtNumber": 21,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "539693": {
      "optaId": "xuk3qlmk4985hs8ocjjd49ka",
      "heimPlayer": {
        "id": "100518835",
        "team_id": "258",
        "person": {
          "id": "539693",
          "name": "Maximilian Beier",
          "firstname": "Maximilian",
          "surname": "Beier",
          "fullname": "Maximilian Beier",
          "gender": "male",
          "birthday": "17.10.2002",
          "height": "185",
          "weight": "72",
          "person_detail": {
            "id": "456878",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Brandenburg an der Havel",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "xuk3qlmk4985hs8ocjjd49ka",
        "firstName": "Maximilian",
        "lastName": "Beier",
        "shortFirstName": "Maximilian",
        "shortLastName": "Beier",
        "matchName": "M. Beier",
        "shirtNumber": 14,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "540241": {
      "optaId": "2r893xoeuqhgoe2w2auhqb696",
      "heimPlayer": {
        "id": "101804828",
        "team_id": "749",
        "person": {
          "id": "540241",
          "name": "Kasper Høgh",
          "firstname": "Kasper",
          "surname": "Høgh",
          "fullname": "Kasper Waarts Thenza Høgh",
          "gender": "male",
          "birthday": "06.12.2000",
          "height": "186",
          "weight": "77",
          "person_detail": {
            "id": "457250",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Randers",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "2r893xoeuqhgoe2w2auhqb696",
        "firstName": "Kasper",
        "lastName": "Waarts Thenza Høgh",
        "shortFirstName": "Kasper",
        "shortLastName": "Høgh",
        "matchName": "K. Høgh",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9",
        "captain": "yes"
      }
    },
    "540688": {
      "optaId": "4d17grk2qflzake218uz76uei",
      "heimPlayer": {
        "id": "100502611",
        "team_id": "1052",
        "person": {
          "id": "540688",
          "name": "Carlos Augusto",
          "firstname": "",
          "surname": "Carlos Augusto",
          "fullname": "Carlos Augusto Zopolato Neves",
          "gender": "male",
          "birthday": "07.01.1999",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "457698",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Campinas",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 22:39",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "4d17grk2qflzake218uz76uei",
        "firstName": "Carlos Augusto",
        "lastName": "Zopolato Neves",
        "shortFirstName": "Carlos Augusto",
        "shortLastName": "Zopolato Neves",
        "knownName": "Carlos Augusto",
        "matchName": "Carlos Augusto",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "541309": {
      "optaId": "b33rlpjo3kx4477alx82si5wq",
      "heimPlayer": {
        "id": "100521742",
        "team_id": "1094",
        "person": {
          "id": "541309",
          "name": "Pierre Kalulu",
          "firstname": "Pierre",
          "surname": "Kalulu",
          "fullname": "Pierre Kazeye Rommel Kalulu Kyatengwa",
          "gender": "male",
          "birthday": "05.06.2000",
          "height": "182",
          "weight": "80",
          "person_detail": {
            "id": "458288",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Lyon",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "b33rlpjo3kx4477alx82si5wq",
        "firstName": "Pierre Kazeye Rommel",
        "lastName": "Kalulu Kyatengwa",
        "shortFirstName": "Pierre",
        "shortLastName": "Kalulu",
        "matchName": "P. Kalulu",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "541317": {
      "optaId": "degqtleco9n5tlt0yz3q5t9ii",
      "heimPlayer": {
        "id": "99152386",
        "team_id": "1418",
        "person": {
          "id": "541317",
          "name": "Costinha",
          "firstname": "",
          "surname": "Costinha",
          "fullname": "João Pedro Loureiro da Costa",
          "gender": "male",
          "birthday": "26.03.2000",
          "height": "181",
          "weight": "74",
          "person_detail": {
            "id": "458296",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Póvoa de Varzim",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "28.01.2026 19:52",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "degqtleco9n5tlt0yz3q5t9ii",
        "firstName": "João Pedro",
        "lastName": "Loureiro da Costa",
        "shortFirstName": "João Pedro",
        "shortLastName": "Loureiro da Costa",
        "knownName": "Costinha",
        "matchName": "Costinha",
        "shirtNumber": 20,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "541760": {
      "optaId": "bqjrib66m08p1qw8315ljc38q",
      "heimPlayer": {
        "id": "101972417",
        "team_id": "5",
        "person": {
          "id": "541760",
          "name": "Jan Schöppner",
          "firstname": "Jan",
          "surname": "Schöppner",
          "fullname": "Jan Schöppner",
          "gender": "male",
          "birthday": "12.06.1999",
          "height": "190",
          "weight": "78",
          "person_detail": {
            "id": "458760",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Homberg",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "bqjrib66m08p1qw8315ljc38q",
        "firstName": "Jan",
        "lastName": "Schöppner",
        "shortFirstName": "Jan",
        "shortLastName": "Schöppner",
        "matchName": "J. Schöppner",
        "shirtNumber": 3,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "541929": {
      "optaId": "e83ula4wockmc2xid7185kcq2",
      "heimPlayer": {
        "id": "98830192",
        "team_id": "1545",
        "person": {
          "id": "541929",
          "name": "Jude Bellingham",
          "firstname": "Jude",
          "surname": "Bellingham",
          "fullname": "Jude Victor William Bellingham",
          "gender": "male",
          "birthday": "29.06.2003",
          "height": "186",
          "weight": "75",
          "person_detail": {
            "id": "458929",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Stourbridge",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "20.01.2026 20:01",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "e83ula4wockmc2xid7185kcq2",
        "firstName": "Jude Victor William",
        "lastName": "Bellingham",
        "shortFirstName": "Jude",
        "shortLastName": "Bellingham",
        "matchName": "J. Bellingham",
        "shirtNumber": 5,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "541987": {
      "optaId": "1xofhzib5lyqx285j8x36xg8a",
      "heimPlayer": {
        "id": "95819659",
        "team_id": "1421",
        "person": {
          "id": "541987",
          "name": "CJ Egan-Riley",
          "firstname": "CJ",
          "surname": "Egan-Riley",
          "fullname": "Conrad Jaden Egan-Riley",
          "gender": "male",
          "birthday": "02.01.2003",
          "height": "183",
          "weight": "70",
          "person_detail": {
            "id": "458987",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Manchester",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "05.11.2025 19:55",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "1xofhzib5lyqx285j8x36xg8a",
        "firstName": "Conrad Jaden",
        "lastName": "Egan-Riley",
        "shortFirstName": "CJ",
        "shortLastName": "Egan-Riley",
        "matchName": "C. Egan-Riley",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "542264": {
      "optaId": "5ph2ln91ycq1qlq03cnqqs9re",
      "heimPlayer": {
        "id": "101972939",
        "team_id": "2086",
        "person": {
          "id": "542264",
          "name": "Jesper Lindstrøm",
          "firstname": "Jesper",
          "surname": "Lindstrøm",
          "fullname": "Jesper Grænge Lindstrøm",
          "gender": "male",
          "birthday": "29.02.2000",
          "height": "182",
          "weight": "66",
          "person_detail": {
            "id": "459260",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Taastrup",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "5ph2ln91ycq1qlq03cnqqs9re",
        "firstName": "Jesper",
        "lastName": "Grænge Lindstrøm",
        "shortFirstName": "Jesper",
        "shortLastName": "Lindstrøm",
        "matchName": "J. Lindstrøm",
        "shirtNumber": 19,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "542303": {
      "optaId": "lioz4hr2umpne2bwar18qa96",
      "heimPlayer": {
        "id": "99160123",
        "team_id": "749",
        "person": {
          "id": "542303",
          "name": "Anders Klynge",
          "firstname": "Anders",
          "surname": "Klynge",
          "fullname": "Anders Ferslev Klynge",
          "gender": "male",
          "birthday": "14.10.2000",
          "height": "175",
          "weight": "70",
          "person_detail": {
            "id": "459299",
            "position_1": "13",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Odense",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "28.01.2026 22:49",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "lioz4hr2umpne2bwar18qa96",
        "firstName": "Anders",
        "lastName": "Ferslev Klynge",
        "shortFirstName": "Anders",
        "shortLastName": "Klynge",
        "matchName": "A. Klynge",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "542661": {
      "optaId": "2k5g68ywtr79lc45wozvifqlm",
      "heimPlayer": {
        "id": "101861360",
        "team_id": "1226",
        "person": {
          "id": "542661",
          "name": "Florian Wirtz",
          "firstname": "Florian",
          "surname": "Wirtz",
          "fullname": "Florian Richard Wirtz",
          "gender": "male",
          "birthday": "03.05.2003",
          "height": "177",
          "weight": "71",
          "person_detail": {
            "id": "459657",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Pulheim-Brauweiler",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "2k5g68ywtr79lc45wozvifqlm",
        "firstName": "Florian Richard",
        "lastName": "Wirtz",
        "shortFirstName": "Florian",
        "shortLastName": "Wirtz",
        "matchName": "F. Wirtz",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "542721": {
      "optaId": "exhxdmdq49xj4dnguq03qnlgq",
      "heimPlayer": {
        "id": "91108646",
        "team_id": "29680",
        "person": {
          "id": "542721",
          "name": "Xavi Simons",
          "firstname": "Xavi",
          "surname": "Simons",
          "fullname": "Xavier Quentin Shay Simons",
          "gender": "male",
          "birthday": "21.04.2003",
          "height": "179",
          "weight": "58",
          "person_detail": {
            "id": "459717",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          }
        },
        "created": "22.08.2025 19:19",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "exhxdmdq49xj4dnguq03qnlgq",
        "firstName": "Xavier Quentin Shay",
        "lastName": "Simons",
        "shortFirstName": "Xavi",
        "shortLastName": "Simons",
        "matchName": "X. Simons",
        "shirtNumber": 10,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "542722": {
      "optaId": "2zkaf848fjcdhuii8783pkm7e",
      "heimPlayer": {
        "id": "99152260",
        "team_id": "64",
        "person": {
          "id": "542722",
          "name": "Youri Regeer",
          "firstname": "Youri",
          "surname": "Regeer",
          "fullname": "Youri Pieter Regeer",
          "gender": "male",
          "birthday": "18.08.2003",
          "height": "177",
          "weight": "",
          "person_detail": {
            "id": "459718",
            "position_1": "13",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Haarlem",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "2zkaf848fjcdhuii8783pkm7e",
        "firstName": "Youri Pieter",
        "lastName": "Regeer",
        "shortFirstName": "Youri",
        "shortLastName": "Regeer",
        "matchName": "Y. Regeer",
        "shirtNumber": 6,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "542920": {
      "optaId": "15nsr315qb7jhyeik47x9wrxm",
      "heimPlayer": {
        "id": "101975951",
        "team_id": "9",
        "person": {
          "id": "542920",
          "name": "Kristoffer Lund",
          "firstname": "Kristoffer",
          "surname": "Lund",
          "fullname": "Kristoffer Lund Hansen",
          "gender": "male",
          "birthday": "14.05.2002",
          "height": "184",
          "weight": "80",
          "person_detail": {
            "id": "459914",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Kerteminde",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "15nsr315qb7jhyeik47x9wrxm",
        "firstName": "Kristoffer",
        "lastName": "Lund Hansen",
        "shortFirstName": "Kristoffer",
        "shortLastName": "Lund",
        "matchName": "K. Lund",
        "shirtNumber": 32,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "543229": {
      "optaId": "7tnuxlg9l4rjhc7j3ko36hduy",
      "heimPlayer": {
        "id": "101821901",
        "team_id": "1267",
        "person": {
          "id": "543229",
          "name": "Antoine Semenyo",
          "firstname": "Antoine",
          "surname": "Semenyo",
          "fullname": "Antoine Serlom Semenyo",
          "gender": "male",
          "birthday": "07.01.2000",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "460173",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "66"
            }
          ]
        },
        "created": "17.03.2026 22:16",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "7tnuxlg9l4rjhc7j3ko36hduy",
        "firstName": "Antoine Serlom",
        "lastName": "Semenyo",
        "shortFirstName": "Antoine",
        "shortLastName": "Semenyo",
        "matchName": "A. Semenyo",
        "shirtNumber": 42,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "543462": {
      "optaId": "4z9prwdr22kb7vpemekkzqooa",
      "heimPlayer": {
        "id": "101934521",
        "team_id": "24",
        "person": {
          "id": "543462",
          "name": "Albian Hajdari",
          "firstname": "Albian",
          "surname": "Hajdari",
          "fullname": "Albian Hajdari",
          "gender": "male",
          "birthday": "18.05.2003",
          "height": "189",
          "weight": "80",
          "person_detail": {
            "id": "460396",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Binningen",
            "died": "no"
          }
        },
        "created": "20.03.2026 21:40",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "4z9prwdr22kb7vpemekkzqooa",
        "firstName": "Albian",
        "lastName": "Hajdari",
        "shortFirstName": "Albian",
        "shortLastName": "Hajdari",
        "matchName": "A. Hajdari",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "543466": {
      "optaId": "bx6j2y1hnu63lawn3rdoep1m2",
      "heimPlayer": {
        "id": "101671109",
        "team_id": "29680",
        "person": {
          "id": "543466",
          "name": "Johan Bakayoko",
          "firstname": "Johan",
          "surname": "Bakayoko",
          "fullname": "Saint-Cyr Johan Bakayoko",
          "gender": "male",
          "birthday": "20.04.2003",
          "height": "179",
          "weight": "76",
          "person_detail": {
            "id": "460400",
            "position_1": "12",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Overijse",
            "died": "no"
          }
        },
        "created": "15.03.2026 21:01",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "bx6j2y1hnu63lawn3rdoep1m2",
        "firstName": "Saint-Cyr Johan",
        "lastName": "Bakayoko",
        "shortFirstName": "Johan",
        "shortLastName": "Bakayoko",
        "matchName": "J. Bakayoko",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "543562": {
      "optaId": "cyz9jisw86vjjf85xxgbae0yy",
      "heimPlayer": {
        "id": "97766050",
        "team_id": "594",
        "person": {
          "id": "543562",
          "name": "Chrislain Matsima",
          "firstname": "Chrislain",
          "surname": "Matsima",
          "fullname": "Chrislain Matsima",
          "gender": "male",
          "birthday": "15.05.2002",
          "height": "193",
          "weight": "83",
          "person_detail": {
            "id": "460489",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Colombes",
            "died": "no"
          }
        },
        "created": "13.12.2025 14:20",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "cyz9jisw86vjjf85xxgbae0yy",
        "firstName": "Chrislain Iris Aurel",
        "lastName": "Matsima",
        "shortFirstName": "Chrislain",
        "shortLastName": "Matsima",
        "matchName": "C. Matsima",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "543572": {
      "optaId": "dw9fzixumboknmucqgqffurmy",
      "heimPlayer": {
        "id": "102100877",
        "team_id": "530",
        "person": {
          "id": "543572",
          "name": "Arnaud Kalimuendo",
          "firstname": "Arnaud",
          "surname": "Kalimuendo",
          "fullname": "Arnaud Kalimuendo Muinga",
          "gender": "male",
          "birthday": "20.01.2002",
          "height": "175",
          "weight": "79",
          "person_detail": {
            "id": "460499",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Suresnes",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:27",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "dw9fzixumboknmucqgqffurmy",
        "firstName": "Arnaud",
        "lastName": "Kalimuendo Muinga",
        "shortFirstName": "Arnaud",
        "shortLastName": "Kalimuendo",
        "matchName": "A. Kalimuendo",
        "shirtNumber": 25,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "543578": {
      "optaId": "ej8pxizgwjx9qjacvc136yusq",
      "heimPlayer": {
        "id": "101975948",
        "team_id": "9",
        "person": {
          "id": "543578",
          "name": "Ísak Jóhannesson",
          "firstname": "Ísak",
          "surname": "Jóhannesson",
          "fullname": "Ísak Bergmann Jóhannesson",
          "gender": "male",
          "birthday": "23.03.2003",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "460505",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Sutton Coldfield",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "ej8pxizgwjx9qjacvc136yusq",
        "firstName": "Ísak Bergmann",
        "lastName": "Jóhannesson",
        "shortFirstName": "Ísak Bergmann",
        "shortLastName": "Jóhannesson",
        "matchName": "Í. Jóhannesson",
        "shirtNumber": 18,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "543823": {
      "optaId": "b8dd5q3n5irlkcv0ekzqhzc2x",
      "heimPlayer": {
        "id": "100521757",
        "team_id": "1094",
        "person": {
          "id": "543823",
          "name": "Jonathan David",
          "firstname": "Jonathan",
          "surname": "David",
          "fullname": "Jonathan Christian David",
          "gender": "male",
          "birthday": "14.01.2000",
          "height": "178",
          "weight": "81",
          "person_detail": {
            "id": "460719",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Brooklyn, NY",
            "died": "no"
          },
          "country": [
            {
              "id": "98"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "b8dd5q3n5irlkcv0ekzqhzc2x",
        "firstName": "Jonathan Christian",
        "lastName": "David",
        "shortFirstName": "Jonathan",
        "shortLastName": "David",
        "matchName": "J. David",
        "shirtNumber": 30,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "545181": {
      "optaId": "d36na8jr6xcc8eronhy8mcz1m",
      "heimPlayer": {
        "id": "98853412",
        "team_id": "1502",
        "person": {
          "id": "545181",
          "name": "Kiliann Sildillia",
          "firstname": "Kiliann",
          "surname": "Sildillia",
          "fullname": "Kiliann Eric Sildillia",
          "gender": "male",
          "birthday": "16.05.2002",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "462060",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Metz",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 19:52",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "d36na8jr6xcc8eronhy8mcz1m",
        "firstName": "Kiliann Eric",
        "lastName": "Sildillia",
        "shortFirstName": "Kiliann",
        "shortLastName": "Sildillia",
        "matchName": "K. Sildillia",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "546623": {
      "optaId": "cakrv1htznb13clvaju68v04q",
      "heimPlayer": {
        "id": "101057851",
        "team_id": "21",
        "person": {
          "id": "546623",
          "name": "William Bøving",
          "firstname": "William",
          "surname": "Bøving",
          "fullname": "William Bøving Vick",
          "gender": "male",
          "birthday": "01.03.2003",
          "height": "176",
          "weight": "70",
          "person_detail": {
            "id": "463481",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "København",
            "died": "no"
          }
        },
        "extra_minute": "2",
        "created": "07.03.2026 17:20",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "cakrv1htznb13clvaju68v04q",
        "firstName": "William",
        "lastName": "Bøving Wick",
        "shortFirstName": "William",
        "shortLastName": "Bøving",
        "matchName": "W. Bøving",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "546632": {
      "optaId": "87kc5hjp3ry2z624wty5h7g4q",
      "heimPlayer": {
        "id": "95986678",
        "team_id": "253",
        "person": {
          "id": "546632",
          "name": "Oscar Fraulo",
          "firstname": "Oscar",
          "surname": "Fraulo",
          "fullname": "Oscar Luigi Fraulo",
          "gender": "male",
          "birthday": "06.12.2003",
          "height": "180",
          "weight": "77",
          "person_detail": {
            "id": "463490",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Odense",
            "died": "no"
          }
        },
        "extra_minute": "6",
        "created": "08.11.2025 20:25",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "87kc5hjp3ry2z624wty5h7g4q",
        "firstName": "Oscar Luigi",
        "lastName": "Fraulo",
        "shortFirstName": "Oscar",
        "shortLastName": "Fraulo",
        "matchName": "O. Fraulo",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "547634": {
      "optaId": "dchp4ud6043gahy06jrm7q6i2",
      "heimPlayer": {
        "id": "98850679",
        "team_id": "530",
        "person": {
          "id": "547634",
          "name": "Nnamdi Collins",
          "firstname": "Nnamdi",
          "surname": "Collins",
          "fullname": "Pharrel Nnamdi Collins",
          "gender": "male",
          "birthday": "10.01.2004",
          "height": "191",
          "weight": "81",
          "person_detail": {
            "id": "464465",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Düsseldorf",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "dchp4ud6043gahy06jrm7q6i2",
        "firstName": "Pharrell Nnamdi",
        "lastName": "Collins",
        "shortFirstName": "Nnamdi",
        "shortLastName": "Collins",
        "matchName": "N. Collins",
        "shirtNumber": 34,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "548619": {
      "optaId": "2we9yak4ipkr1ljigj20puv6y",
      "heimPlayer": {
        "id": "98682166",
        "team_id": "253",
        "person": {
          "id": "548619",
          "name": "Gio Reyna",
          "firstname": "Gio",
          "surname": "Reyna",
          "fullname": "Giovanni Alejandro Reyna",
          "gender": "male",
          "birthday": "13.11.2002",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "465425",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Sunderland",
            "died": "no"
          }
        },
        "created": "17.01.2026 16:58",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "2we9yak4ipkr1ljigj20puv6y",
        "firstName": "Giovanni Alejandro",
        "lastName": "Reyna",
        "shortFirstName": "Giovanni",
        "shortLastName": "Reyna",
        "matchName": "G. Reyna",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "549064": {
      "optaId": "68rs7juin2mmdok00hw6uvre2",
      "heimPlayer": {
        "id": "101973242",
        "team_id": "2134",
        "person": {
          "id": "549064",
          "name": "Justin Njinmah",
          "firstname": "Justin",
          "surname": "Njinmah",
          "fullname": "Justin Gideon Njinmah",
          "gender": "male",
          "birthday": "15.11.2000",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "465870",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "68rs7juin2mmdok00hw6uvre2",
        "firstName": "Justin Gideon",
        "lastName": "Njinmah",
        "shortFirstName": "Justin",
        "shortLastName": "Njinmah",
        "matchName": "J. Njinmah",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "549863": {
      "optaId": "c9lowjmj8dvkqzwtr1cuh1dqt",
      "heimPlayer": {
        "id": "100493302",
        "team_id": "18670",
        "person": {
          "id": "549863",
          "name": "Kevin Medina",
          "firstname": "Kevin",
          "surname": "Medina",
          "fullname": "Kevin David Medina Rentería",
          "gender": "male",
          "birthday": "09.03.1993",
          "height": "184",
          "weight": "",
          "person_detail": {
            "id": "466652",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "81"
      },
      "optaPlayer": {
        "playerId": "c9lowjmj8dvkqzwtr1cuh1dqt",
        "firstName": "Kevin David",
        "lastName": "Medina Renteria",
        "shortFirstName": "Kevin",
        "shortLastName": "Medina",
        "matchName": "K. Medina",
        "shirtNumber": 81,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "550082": {
      "optaId": "4jetfgij9sfzo09ffr558bwno",
      "heimPlayer": {
        "id": "100736707",
        "team_id": "2086",
        "person": {
          "id": "550082",
          "name": "Pharell Hensel",
          "firstname": "Pharell",
          "surname": "Hensel",
          "fullname": "Pharell Hensel",
          "gender": "male",
          "birthday": "08.06.2007",
          "height": "188",
          "weight": "",
          "person_detail": {
            "id": "466867",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "01.03.2026 14:21",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "4jetfgij9sfzo09ffr558bwno",
        "firstName": "Pharell",
        "lastName": "Hensel",
        "shortFirstName": "Pharell",
        "shortLastName": "Hensel",
        "matchName": "P. Hensel",
        "shirtNumber": 37,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "550931": {
      "optaId": "dfcbvsb7o18lavmonbp5ucwoa",
      "heimPlayer": {
        "id": "99154843",
        "team_id": "156",
        "person": {
          "id": "550931",
          "name": "Oihan Sancet",
          "firstname": "",
          "surname": "Oihan Sancet",
          "fullname": "Oihan Sancet Tirapu",
          "gender": "male",
          "birthday": "25.04.2000",
          "height": "188",
          "weight": "73",
          "person_detail": {
            "id": "467705",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Pamplona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "dfcbvsb7o18lavmonbp5ucwoa",
        "firstName": "Oihan",
        "lastName": "Sancet Tirapu",
        "shortFirstName": "Oihan",
        "shortLastName": "Sancet",
        "matchName": "Oihan Sancet",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "551467": {
      "optaId": "7aoe0u87gxgv9tvgrotcfue7e",
      "heimPlayer": {
        "id": "99154849",
        "team_id": "156",
        "person": {
          "id": "551467",
          "name": "Robert Navarro",
          "firstname": "",
          "surname": "Robert Navarro",
          "fullname": "Robert Navarro Muñoz",
          "gender": "male",
          "birthday": "12.04.2002",
          "height": "178",
          "weight": "69",
          "person_detail": {
            "id": "468241",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Barcelona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "7aoe0u87gxgv9tvgrotcfue7e",
        "firstName": "Roberto",
        "lastName": "Navarro Muñoz",
        "shortFirstName": "Robert",
        "shortLastName": "Navarro",
        "matchName": "Robert Navarro",
        "shirtNumber": 23,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "551681": {
      "optaId": "8h7u0a26g2yckx955e1g2kdbe",
      "heimPlayer": {
        "id": "101057845",
        "team_id": "21",
        "person": {
          "id": "551681",
          "name": "Armindo Sieb",
          "firstname": "Armindo",
          "surname": "Sieb",
          "fullname": "Armindo Sieb",
          "gender": "male",
          "birthday": "17.02.2003",
          "height": "175",
          "weight": "75",
          "person_detail": {
            "id": "468438",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Halle an der Saale",
            "died": "no"
          }
        },
        "extra_minute": "2",
        "created": "07.03.2026 17:20",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "8h7u0a26g2yckx955e1g2kdbe",
        "firstName": "Armindo",
        "lastName": "Sieb",
        "shortFirstName": "Armindo",
        "shortLastName": "Sieb",
        "matchName": "A. Sieb",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "551857": {
      "optaId": "5kd57453a90zahgdxwkghr816",
      "heimPlayer": {
        "id": "99154828",
        "team_id": "156",
        "person": {
          "id": "551857",
          "name": "Aitor Paredes",
          "firstname": "",
          "surname": "Aitor Paredes",
          "fullname": "Aitor Paredes Casamichana",
          "gender": "male",
          "birthday": "29.04.2000",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "468614",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Bilbao",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "5kd57453a90zahgdxwkghr816",
        "firstName": "Aitor",
        "lastName": "Paredes Casamichana",
        "shortFirstName": "Aitor",
        "shortLastName": "Paredes",
        "matchName": "Aitor Paredes",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "552982": {
      "optaId": "3saz8njlttx2i4ospcwmmaqga",
      "heimPlayer": {
        "id": "101975936",
        "team_id": "9",
        "person": {
          "id": "552982",
          "name": "Eric Martel",
          "firstname": "Eric",
          "surname": "Martel",
          "fullname": "Eric Martel",
          "gender": "male",
          "birthday": "29.04.2002",
          "height": "188",
          "weight": "81",
          "person_detail": {
            "id": "469728",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Straubing",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "3saz8njlttx2i4ospcwmmaqga",
        "firstName": "Eric",
        "lastName": "Martel",
        "shortFirstName": "Eric",
        "shortLastName": "Martel",
        "matchName": "E. Martel",
        "shirtNumber": 6,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "553517": {
      "optaId": "av18ek8zmx40sazfwerdp8wa2",
      "heimPlayer": {
        "id": "95826133",
        "team_id": "853",
        "person": {
          "id": "553517",
          "name": "Berkan Kutlu",
          "firstname": "Berkan",
          "surname": "Kutlu",
          "fullname": "Berkan İsmail Kutlu",
          "gender": "male",
          "birthday": "25.01.1998",
          "height": "186",
          "weight": "75",
          "person_detail": {
            "id": "470242",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Monthey",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "05.11.2025 22:49",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "av18ek8zmx40sazfwerdp8wa2",
        "firstName": "Berkan İsmail",
        "lastName": "Kutlu",
        "shortFirstName": "Berkan",
        "shortLastName": "Kutlu",
        "matchName": "B. Kutlu",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "554000": {
      "optaId": "6d88lw0gtv7ay0hk0p51fwhzo",
      "heimPlayer": {
        "id": "101551313",
        "team_id": "943",
        "person": {
          "id": "554000",
          "name": "Daniel Elfadli",
          "firstname": "Daniel",
          "surname": "Elfadli",
          "fullname": "Daniel Elfadli",
          "gender": "male",
          "birthday": "06.04.1997",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "470724",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Leonberg",
            "died": "no"
          }
        },
        "created": "14.03.2026 20:06",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "6d88lw0gtv7ay0hk0p51fwhzo",
        "firstName": "Daniel",
        "lastName": "Elfadli",
        "shortFirstName": "Daniel",
        "shortLastName": "Elfadli",
        "knownName": "Daniel Elfadli",
        "matchName": "Daniel Elfadli",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "555132": {
      "optaId": "eiqcjlj9kmitoj8g50vaglawa",
      "heimPlayer": {
        "id": "101359946",
        "team_id": "373",
        "person": {
          "id": "555132",
          "name": "Filip Jörgensen",
          "firstname": "Filip",
          "surname": "Jörgensen",
          "fullname": "Filip Jörgensen",
          "gender": "male",
          "birthday": "16.04.2002",
          "height": "192",
          "weight": "82",
          "person_detail": {
            "id": "471822",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Lomma",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "11.03.2026 19:52",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "eiqcjlj9kmitoj8g50vaglawa",
        "firstName": "Filip",
        "lastName": "Jörgensen",
        "shortFirstName": "Filip",
        "shortLastName": "Jörgensen",
        "matchName": "F. Jörgensen",
        "shirtNumber": 12,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "555362": {
      "optaId": "4uau3xuhrfugr5bo4sannz6x",
      "heimPlayer": {
        "id": "99159433",
        "team_id": "13914",
        "person": {
          "id": "555362",
          "name": "Mons Bassouamina",
          "firstname": "Mons",
          "surname": "Bassouamina",
          "fullname": "Mons Rogeani Bassouamina",
          "gender": "male",
          "birthday": "28.05.1998",
          "height": "172",
          "weight": "71",
          "person_detail": {
            "id": "472046",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Gonesse",
            "died": "no"
          },
          "country": [
            {
              "id": "107"
            }
          ]
        },
        "created": "28.01.2026 22:35",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "4uau3xuhrfugr5bo4sannz6x",
        "firstName": "Mons Rogeani Andre",
        "lastName": "Bassouamina",
        "shortFirstName": "Mons",
        "shortLastName": "Bassouamina",
        "matchName": "M. Bassouamina",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "556950": {
      "optaId": "dvhjw2ieemakzw9o56r6y4foq",
      "heimPlayer": {
        "id": "102117158",
        "team_id": "1639",
        "person": {
          "id": "556950",
          "name": "Igor Matanović",
          "firstname": "Igor",
          "surname": "Matanović",
          "fullname": "Igor Matanović",
          "gender": "male",
          "birthday": "31.03.2003",
          "height": "194",
          "weight": "90",
          "person_detail": {
            "id": "473339",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "dvhjw2ieemakzw9o56r6y4foq",
        "firstName": "Igor",
        "lastName": "Matanović",
        "shortFirstName": "Igor",
        "shortLastName": "Matanovic",
        "matchName": "I. Matanović",
        "shirtNumber": 31,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "558659": {
      "optaId": "3trkre1c81pzretsjsi8jk6sq",
      "heimPlayer": {
        "id": "101812982",
        "team_id": "1267",
        "person": {
          "id": "558659",
          "name": "Matheus Nunes",
          "firstname": "",
          "surname": "Matheus Nunes",
          "fullname": "Matheus Luiz Nunes",
          "gender": "male",
          "birthday": "27.08.1998",
          "height": "183",
          "weight": "78",
          "person_detail": {
            "id": "474893",
            "position_1": "5",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Rio de Janeiro",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "3trkre1c81pzretsjsi8jk6sq",
        "firstName": "Matheus Luiz",
        "lastName": "Nunes",
        "shortFirstName": "Matheus Luiz",
        "shortLastName": "Nunes",
        "knownName": "Matheus Nunes",
        "matchName": "Matheus Nunes",
        "shirtNumber": 27,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "558946": {
      "optaId": "849wrp9wm8cjyrbshlaukyz56",
      "heimPlayer": {
        "id": "102006218",
        "team_id": "943",
        "person": {
          "id": "558946",
          "name": "Nicolai Remberg",
          "firstname": "Nicolai",
          "surname": "Remberg",
          "fullname": "Nicolai Remberg",
          "gender": "male",
          "birthday": "19.06.2000",
          "height": "187",
          "weight": "88",
          "person_detail": {
            "id": "475139",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Rheine",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "849wrp9wm8cjyrbshlaukyz56",
        "firstName": "Nicolai",
        "lastName": "Remberg",
        "shortFirstName": "Nicolai",
        "shortLastName": "Remberg",
        "matchName": "N. Remberg",
        "shirtNumber": 21,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "559967": {
      "optaId": "eg5haueyvosx3euq9e0ogdj6y",
      "heimPlayer": {
        "id": "102140189",
        "team_id": "702",
        "person": {
          "id": "559967",
          "name": "Louis Oppie",
          "firstname": "Louis",
          "surname": "Oppie",
          "fullname": "Louis Oppie",
          "gender": "male",
          "birthday": "17.05.2002",
          "height": "184",
          "weight": "81",
          "person_detail": {
            "id": "475989",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:56",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "eg5haueyvosx3euq9e0ogdj6y",
        "firstName": "Louis",
        "lastName": "Oppie",
        "shortFirstName": "Louis",
        "shortLastName": "Oppie",
        "matchName": "L. Oppie",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "561224": {
      "optaId": "5wengf05apke7rv3kms186j56",
      "heimPlayer": {
        "id": "101855738",
        "team_id": "1355",
        "person": {
          "id": "561224",
          "name": "Anthony Elanga",
          "firstname": "Anthony",
          "surname": "Elanga",
          "fullname": "Anthony David Junior Elanga",
          "gender": "male",
          "birthday": "27.04.2002",
          "height": "178",
          "weight": "65",
          "person_detail": {
            "id": "477230",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Hyllie",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "5wengf05apke7rv3kms186j56",
        "firstName": "Anthony David Junior",
        "lastName": "Elanga",
        "shortFirstName": "Anthony",
        "shortLastName": "Elanga",
        "matchName": "A. Elanga",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "561329": {
      "optaId": "b2e12l3s3dxgyr8d2rk5qb9ey",
      "heimPlayer": {
        "id": "101317760",
        "team_id": "155",
        "person": {
          "id": "561329",
          "name": "Yunus Musah",
          "firstname": "Yunus",
          "surname": "Musah",
          "fullname": "Yunus Dimoara Musah",
          "gender": "male",
          "birthday": "29.11.2002",
          "height": "178",
          "weight": "75",
          "person_detail": {
            "id": "478327",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "New York City, NY",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "10.03.2026 22:12",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "b2e12l3s3dxgyr8d2rk5qb9ey",
        "firstName": "Yunus Dimoara",
        "lastName": "Musah",
        "shortFirstName": "Yunus",
        "shortLastName": "Musah",
        "matchName": "Y. Musah",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "561883": {
      "optaId": "4aqkgskbra4wsoo7a8uw7xl9l",
      "heimPlayer": {
        "id": "101862308",
        "team_id": "155",
        "person": {
          "id": "561883",
          "name": "Éderson",
          "firstname": "",
          "surname": "Éderson",
          "fullname": "Éderson José dos Santos Lourenço da Silva",
          "gender": "male",
          "birthday": "07.07.1999",
          "height": "183",
          "weight": "83",
          "person_detail": {
            "id": "478873",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Campo Grande",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "4aqkgskbra4wsoo7a8uw7xl9l",
        "firstName": "Éderson José",
        "lastName": "dos Santos Lourenço da Silva",
        "shortFirstName": "Éderson José",
        "shortLastName": "dos Santos Lourenço da Silva",
        "knownName": "Éderson",
        "matchName": "Éderson",
        "shirtNumber": 13,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "562071": {
      "optaId": "m2c4lckkcr7yilnqxrrsgh2i",
      "heimPlayer": {
        "id": "101310152",
        "team_id": "209",
        "person": {
          "id": "562071",
          "name": "Michael Olise",
          "firstname": "Michael",
          "surname": "Olise",
          "fullname": "Michael Akpovie Olise",
          "gender": "male",
          "birthday": "12.12.2001",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "479061",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Hammersmith, London",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "10.03.2026 19:57",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "m2c4lckkcr7yilnqxrrsgh2i",
        "firstName": "Michael Akpovie",
        "lastName": "Olise",
        "shortFirstName": "Michael",
        "shortLastName": "Olise",
        "matchName": "M. Olise",
        "shirtNumber": 17,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "562368": {
      "optaId": "1c4nu9s3t3p83pufjf3n3xqay",
      "heimPlayer": {
        "id": "96883768",
        "team_id": "1267",
        "person": {
          "id": "562368",
          "name": "James Trafford",
          "firstname": "James",
          "surname": "Trafford",
          "fullname": "James Harrington Trafford",
          "gender": "male",
          "birthday": "10.10.2002",
          "height": "192",
          "weight": "83",
          "person_detail": {
            "id": "479358",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Carlisle",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "25.11.2025 19:53",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "1c4nu9s3t3p83pufjf3n3xqay",
        "firstName": "James Harrington",
        "lastName": "Trafford",
        "shortFirstName": "James",
        "shortLastName": "Trafford",
        "matchName": "J. Trafford",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "562538": {
      "optaId": "91n9wzn3qq2789zq8vdmfrd62",
      "heimPlayer": {
        "id": "101862233",
        "team_id": "209",
        "person": {
          "id": "562538",
          "name": "Jonas Urbig",
          "firstname": "Jonas",
          "surname": "Urbig",
          "fullname": "Jonas Kurt Urbig",
          "gender": "male",
          "birthday": "08.08.2003",
          "height": "189",
          "weight": "83",
          "person_detail": {
            "id": "479529",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Euskirchen",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "91n9wzn3qq2789zq8vdmfrd62",
        "firstName": "Jonas Kurt",
        "lastName": "Urbig",
        "shortFirstName": "Jonas",
        "shortLastName": "Urbig",
        "matchName": "J. Urbig",
        "shirtNumber": 40,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "562544": {
      "optaId": "5n7vp6g13q7sxkzbygfbz27oq",
      "heimPlayer": {
        "id": "91752626",
        "team_id": "1639",
        "person": {
          "id": "562544",
          "name": "Merlin Röhl",
          "firstname": "Merlin",
          "surname": "Röhl",
          "fullname": "Merlin Röhl",
          "gender": "male",
          "birthday": "05.07.2002",
          "height": "192",
          "weight": "77",
          "person_detail": {
            "id": "479535",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "31.08.2025 20:38",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "5n7vp6g13q7sxkzbygfbz27oq",
        "firstName": "Merlin",
        "lastName": "Röhl",
        "shortFirstName": "Merlin",
        "shortLastName": "Röhl",
        "matchName": "M. Röhl",
        "shirtNumber": 34,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "562689": {
      "optaId": "630sqbiu7utmkg8yw0h4ky8a2",
      "heimPlayer": {
        "id": "101972426",
        "team_id": "5",
        "person": {
          "id": "562689",
          "name": "Eren Dinkçi",
          "firstname": "Eren",
          "surname": "Dinkçi",
          "fullname": "Eren Sami Dinkçi",
          "gender": "male",
          "birthday": "13.12.2001",
          "height": "188",
          "weight": "80",
          "person_detail": {
            "id": "479679",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Bremen",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "630sqbiu7utmkg8yw0h4ky8a2",
        "firstName": "Eren Sami",
        "lastName": "Dinkçi",
        "shortFirstName": "Eren",
        "shortLastName": "Dinkçi",
        "matchName": "E. Dinkçi",
        "shirtNumber": 8,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "562866": {
      "optaId": "5jk0wq14a8emikh2vh53aw0ve",
      "heimPlayer": {
        "id": "101821844",
        "team_id": "373",
        "person": {
          "id": "562866",
          "name": "Liam Delap",
          "firstname": "Liam",
          "surname": "Delap",
          "fullname": "Liam Rory Delap",
          "gender": "male",
          "birthday": "08.02.2003",
          "height": "186",
          "weight": "72",
          "person_detail": {
            "id": "479829",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Winchester",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 22:16",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "5jk0wq14a8emikh2vh53aw0ve",
        "firstName": "Liam Rory",
        "lastName": "Delap",
        "shortFirstName": "Liam",
        "shortLastName": "Delap",
        "matchName": "L. Delap",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "563153": {
      "optaId": "a536nk8ps5vrgextz3k3hcl0q",
      "heimPlayer": {
        "id": "100521607",
        "team_id": "1731",
        "person": {
          "id": "563153",
          "name": "Amar Dedić",
          "firstname": "Amar",
          "surname": "Dedić",
          "fullname": "Amar Dedić",
          "gender": "male",
          "birthday": "18.08.2002",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "480115",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Zell am See",
            "died": "no"
          },
          "country": [
            {
              "id": "31"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "a536nk8ps5vrgextz3k3hcl0q",
        "firstName": "Amar",
        "lastName": "Dedić",
        "shortFirstName": "Amar",
        "shortLastName": "Dedic",
        "matchName": "A. Dedić",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "564529": {
      "optaId": "9fd19beamnr8qmhqdvzr7fcyy",
      "heimPlayer": {
        "id": "101054206",
        "team_id": "21",
        "person": {
          "id": "564529",
          "name": "Silas Katompa Mvumpa",
          "firstname": "Silas",
          "surname": "Katompa Mvumpa",
          "fullname": "Silas Katompa Mvumpa (Wamangituka)",
          "gender": "male",
          "birthday": "06.10.1998",
          "height": "189",
          "weight": "79",
          "person_detail": {
            "id": "481420",
            "position_1": "12",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Kinshasa",
            "died": "no"
          }
        },
        "created": "07.03.2026 17:02",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "9fd19beamnr8qmhqdvzr7fcyy",
        "firstName": "Silas",
        "lastName": "Katompa Mvumpa",
        "shortFirstName": "Silas",
        "shortLastName": "Katompa Mvumpa",
        "matchName": "S. Katompa Mvumpa",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "564683": {
      "optaId": "bh8t0fz0czhgepa3rskdxmt7u",
      "heimPlayer": {
        "id": "101976035",
        "team_id": "253",
        "person": {
          "id": "564683",
          "name": "Jens Castrop",
          "firstname": "Jens",
          "surname": "Castrop",
          "fullname": "Jens Castrop",
          "gender": "male",
          "birthday": "29.07.2003",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "481574",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Düsseldorf",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:27",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "bh8t0fz0czhgepa3rskdxmt7u",
        "firstName": "Jens",
        "lastName": "Castrop",
        "shortFirstName": "Jens",
        "shortLastName": "Castrop",
        "matchName": "J. Castrop",
        "shirtNumber": 17,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "564705": {
      "optaId": "bdmomasg7lrn5pwihecvgpuga",
      "heimPlayer": {
        "id": "101861687",
        "team_id": "1355",
        "person": {
          "id": "564705",
          "name": "Tino Livramento",
          "firstname": "Tino",
          "surname": "Livramento",
          "fullname": "Valentino Francisco Livramento",
          "gender": "male",
          "birthday": "12.11.2002",
          "height": "182",
          "weight": "63",
          "person_detail": {
            "id": "481596",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Croydon, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 19:55",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "bdmomasg7lrn5pwihecvgpuga",
        "firstName": "Valentino Francisco",
        "lastName": "Livramento",
        "shortFirstName": "Tino",
        "shortLastName": "Livramento",
        "matchName": "T. Livramento",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "565111": {
      "optaId": "f2f68n13t1nd3cjwair6jrip6",
      "heimPlayer": {
        "id": "99930676",
        "team_id": "1639",
        "person": {
          "id": "565111",
          "name": "Max Rosenfelder",
          "firstname": "Max",
          "surname": "Rosenfelder",
          "fullname": "Maximilian Rosenfelder",
          "gender": "male",
          "birthday": "10.02.2003",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "481983",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Freiburg im Breisgau",
            "died": "no"
          }
        },
        "created": "14.02.2026 16:35",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "f2f68n13t1nd3cjwair6jrip6",
        "firstName": "Maximilian",
        "lastName": "Rosenfelder",
        "shortFirstName": "Max",
        "shortLastName": "Rosenfelder",
        "matchName": "M. Rosenfelder",
        "shirtNumber": 37,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "566824": {
      "optaId": "9tp35qqu1heburu0g5wa6jv56",
      "heimPlayer": {
        "id": "97683229",
        "team_id": "64",
        "person": {
          "id": "566824",
          "name": "Lucas Rosa",
          "firstname": "",
          "surname": "Lucas Rosa",
          "fullname": "Lucas Oliveira Rosa",
          "gender": "male",
          "birthday": "03.04.2000",
          "height": "177",
          "weight": "68",
          "person_detail": {
            "id": "483581",
            "position_1": "3",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Ribeirão Preto",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "10.12.2025 17:34",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "9tp35qqu1heburu0g5wa6jv56",
        "firstName": "Lucas",
        "lastName": "Oliveira Rosa",
        "shortFirstName": "Lucas",
        "shortLastName": "Oliveira Rosa",
        "knownName": "Lucas Rosa",
        "matchName": "Lucas Rosa",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "567203": {
      "optaId": "6ivap35b2p5rwv8rzigaum6wa",
      "heimPlayer": {
        "id": "101995232",
        "team_id": "19",
        "person": {
          "id": "567203",
          "name": "Andrej Ilić",
          "firstname": "Andrej",
          "surname": "Ilić",
          "fullname": "Andrej Ilić",
          "gender": "male",
          "birthday": "03.04.2000",
          "height": "189",
          "weight": "76",
          "person_detail": {
            "id": "483916",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Beograd",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:34",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "6ivap35b2p5rwv8rzigaum6wa",
        "firstName": "Andrej",
        "lastName": "Ilić",
        "shortFirstName": "Andrej",
        "shortLastName": "Ilic",
        "matchName": "A. Ilić",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "567392": {
      "optaId": "dl10343h8yopcgerzur5samwa",
      "heimPlayer": {
        "id": "101812010",
        "team_id": "373",
        "person": {
          "id": "567392",
          "name": "Cole Palmer",
          "firstname": "Cole",
          "surname": "Palmer",
          "fullname": "Cole Jermaine Palmer",
          "gender": "male",
          "birthday": "06.05.2002",
          "height": "185",
          "weight": "72",
          "person_detail": {
            "id": "484100",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Wythenshawe, Manchester",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "dl10343h8yopcgerzur5samwa",
        "firstName": "Cole Jermaine",
        "lastName": "Palmer",
        "shortFirstName": "Cole",
        "shortLastName": "Palmer",
        "matchName": "C. Palmer",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "567601": {
      "optaId": "1bnn3tokzwvl4vvw34yxsq9gq",
      "heimPlayer": {
        "id": "101823158",
        "team_id": "1267",
        "person": {
          "id": "567601",
          "name": "Nico González",
          "firstname": "",
          "surname": "Nico González",
          "fullname": "Nicolás González Iglesias",
          "gender": "male",
          "birthday": "03.01.2002",
          "height": "188",
          "weight": "90",
          "person_detail": {
            "id": "484306",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "A Coruña",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 22:33",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "1bnn3tokzwvl4vvw34yxsq9gq",
        "firstName": "Nicolás",
        "lastName": "González Iglesias",
        "shortFirstName": "Nico",
        "shortLastName": "González",
        "matchName": "Nico González",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "567631": {
      "optaId": "308krssmz6irpfntht1ka78tm",
      "heimPlayer": {
        "id": "98830261",
        "team_id": "136",
        "person": {
          "id": "567631",
          "name": "Ansu Fati",
          "firstname": "",
          "surname": "Ansu Fati",
          "fullname": "Anssumane Fati Vieira",
          "gender": "male",
          "birthday": "31.10.2002",
          "height": "178",
          "weight": "66",
          "person_detail": {
            "id": "484336",
            "position_1": "6",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bissau",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 20:01",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "308krssmz6irpfntht1ka78tm",
        "firstName": "Anssumane",
        "lastName": "Fati Vieira",
        "shortFirstName": "Ansu",
        "shortLastName": "Fati",
        "matchName": "Ansu Fati",
        "shirtNumber": 31,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "567735": {
      "optaId": "1fsum47fkh62rer9xxe3smctm",
      "heimPlayer": {
        "id": "92675441",
        "team_id": "155",
        "person": {
          "id": "567735",
          "name": "Daniel Maldini",
          "firstname": "Daniel",
          "surname": "Maldini",
          "fullname": "Daniel Maldini",
          "gender": "male",
          "birthday": "11.10.2001",
          "height": "188",
          "weight": "83",
          "person_detail": {
            "id": "484440",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Milano",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "17.09.2025 19:49",
        "shirtnumber": "70"
      },
      "optaPlayer": {
        "playerId": "1fsum47fkh62rer9xxe3smctm",
        "firstName": "Daniel",
        "lastName": "Maldini Fossa",
        "shortFirstName": "Daniel",
        "shortLastName": "Maldini",
        "matchName": "D. Maldini",
        "shirtNumber": 70,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "567769": {
      "optaId": "f2dutxek3uf0yi1ee32a3u2cq",
      "heimPlayer": {
        "id": "100133377",
        "team_id": "1731",
        "person": {
          "id": "567769",
          "name": "Georgiy Sudakov",
          "firstname": "Georgiy",
          "surname": "Sudakov",
          "fullname": "Georgiy Viktorovych Sudakov",
          "gender": "male",
          "birthday": "01.09.2002",
          "height": "177",
          "weight": "68",
          "person_detail": {
            "id": "484473",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "both",
            "birth_place": "Bryanka",
            "died": "no"
          },
          "country": [
            {
              "id": "225"
            }
          ]
        },
        "created": "17.02.2026 22:33",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "f2dutxek3uf0yi1ee32a3u2cq",
        "firstName": "Heorhii",
        "lastName": "Sudakov",
        "shortFirstName": "Heorhii",
        "shortLastName": "Sudakov",
        "matchName": "H. Sudakov",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "567790": {
      "optaId": "1ehcji0j9s8b0qsj8v5zinjvu",
      "heimPlayer": {
        "id": "101812997",
        "team_id": "1267",
        "person": {
          "id": "567790",
          "name": "Rayan Cherki",
          "firstname": "Rayan",
          "surname": "Cherki",
          "fullname": "Mathis Rayan Cherki",
          "gender": "male",
          "birthday": "17.08.2003",
          "height": "180",
          "weight": "71",
          "person_detail": {
            "id": "484494",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Lyon",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "1ehcji0j9s8b0qsj8v5zinjvu",
        "firstName": "Mathis Rayan",
        "lastName": "Cherki",
        "shortFirstName": "Rayan",
        "shortLastName": "Cherki",
        "matchName": "R. Cherki",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "568118": {
      "optaId": "725lp72qyqzvbul0aarhvi99m",
      "heimPlayer": {
        "id": "101925824",
        "team_id": "24",
        "person": {
          "id": "568118",
          "name": "Robin Hranáč",
          "firstname": "Robin",
          "surname": "Hranáč",
          "fullname": "Robin Hranáč",
          "gender": "male",
          "birthday": "29.01.2000",
          "height": "190",
          "weight": "85",
          "person_detail": {
            "id": "484822",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Plzeň",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:18",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "725lp72qyqzvbul0aarhvi99m",
        "firstName": "Robin",
        "lastName": "Hranáč",
        "shortFirstName": "Robin",
        "shortLastName": "Hranác",
        "matchName": "R. Hranáč",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "568613": {
      "optaId": "39yc76urwnda0ze6qb9h00ine",
      "heimPlayer": {
        "id": "101973197",
        "team_id": "2134",
        "person": {
          "id": "568613",
          "name": "Mio Backhaus",
          "firstname": "Mio",
          "surname": "Backhaus",
          "fullname": "Mio Backhaus (Nagata)",
          "gender": "male",
          "birthday": "16.04.2004",
          "height": "194",
          "weight": "82",
          "person_detail": {
            "id": "485309",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Mönchengladbach",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "39yc76urwnda0ze6qb9h00ine",
        "firstName": "Mio",
        "lastName": "Backhaus",
        "shortFirstName": "Mio",
        "shortLastName": "Backhaus",
        "matchName": "M. Backhaus",
        "shirtNumber": 30,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "569016": {
      "optaId": "3krglbuxncb1fvl3p1sezhoq2",
      "heimPlayer": {
        "id": "100753894",
        "team_id": "2076",
        "person": {
          "id": "569016",
          "name": "Ameen Al-Dakhil",
          "firstname": "Ameen",
          "surname": "Al-Dakhil",
          "fullname": "Ameen Al-Dakhil",
          "gender": "male",
          "birthday": "06.03.2002",
          "height": "187",
          "weight": "70",
          "person_detail": {
            "id": "485711",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Baghdad",
            "died": "no"
          }
        },
        "created": "01.03.2026 16:55",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "3krglbuxncb1fvl3p1sezhoq2",
        "firstName": "Ameen",
        "lastName": "Al Dakhil",
        "shortFirstName": "Ameen",
        "shortLastName": "Al Dakhil",
        "matchName": "A. Al Dakhil",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "569624": {
      "optaId": "8jt4vsixxoqp4uvskyfl7k222",
      "heimPlayer": {
        "id": "101359958",
        "team_id": "373",
        "person": {
          "id": "569624",
          "name": "Malo Gusto",
          "firstname": "Malo",
          "surname": "Gusto",
          "fullname": "Malo Gusto",
          "gender": "male",
          "birthday": "19.05.2003",
          "height": "178",
          "weight": "76",
          "person_detail": {
            "id": "486318",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Décines-Charpieu",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "11.03.2026 19:52",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "8jt4vsixxoqp4uvskyfl7k222",
        "firstName": "Malo Arthur",
        "lastName": "Gusto",
        "shortFirstName": "Malo",
        "shortLastName": "Gusto",
        "matchName": "M. Gusto",
        "shirtNumber": 27,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "569675": {
      "optaId": "bhsdzppop8jwjsxwftizot1t6",
      "heimPlayer": {
        "id": "101317481",
        "team_id": "209",
        "person": {
          "id": "569675",
          "name": "Jamal Musiala",
          "firstname": "Jamal",
          "surname": "Musiala",
          "fullname": "Jamal Musiala",
          "gender": "male",
          "birthday": "26.02.2003",
          "height": "184",
          "weight": "72",
          "person_detail": {
            "id": "486369",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Stuttgart",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "10.03.2026 22:02",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "bhsdzppop8jwjsxwftizot1t6",
        "firstName": "Jamal",
        "lastName": "Musiala",
        "shortFirstName": "Jamal",
        "shortLastName": "Musiala",
        "matchName": "J. Musiala",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "569837": {
      "optaId": "bjob8tftnxojnytcj7juo0ga2",
      "heimPlayer": {
        "id": "100528372",
        "team_id": "1094",
        "person": {
          "id": "569837",
          "name": "Fabio Miretti",
          "firstname": "Fabio",
          "surname": "Miretti",
          "fullname": "Fabio Miretti",
          "gender": "male",
          "birthday": "03.08.2003",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "486530",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Pinerolo",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "25.02.2026 23:14",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "bjob8tftnxojnytcj7juo0ga2",
        "firstName": "Fabio",
        "lastName": "Miretti",
        "shortFirstName": "Fabio",
        "shortLastName": "Miretti",
        "matchName": "F. Miretti",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "570069": {
      "optaId": "5wn1xudozb4s78x0m8ch7vn8q",
      "heimPlayer": {
        "id": "101973212",
        "team_id": "2134",
        "person": {
          "id": "570069",
          "name": "Olivier Deman",
          "firstname": "Olivier",
          "surname": "Deman",
          "fullname": "Olivier Deman",
          "gender": "male",
          "birthday": "06.04.2000",
          "height": "181",
          "weight": "74",
          "person_detail": {
            "id": "486762",
            "position_1": "6",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Antwerpen",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "5wn1xudozb4s78x0m8ch7vn8q",
        "firstName": "Olivier",
        "lastName": "Deman",
        "shortFirstName": "Olivier",
        "shortLastName": "Deman",
        "matchName": "O. Deman",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "570350": {
      "optaId": "b7cso5zljdvzfila9zd4fz4ve",
      "heimPlayer": {
        "id": "101975945",
        "team_id": "9",
        "person": {
          "id": "570350",
          "name": "Jakub Kamiński",
          "firstname": "Jakub",
          "surname": "Kamiński",
          "fullname": "Jakub Kamiński",
          "gender": "male",
          "birthday": "05.06.2002",
          "height": "179",
          "weight": "64",
          "person_detail": {
            "id": "487043",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Ruda Śląska",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "b7cso5zljdvzfila9zd4fz4ve",
        "firstName": "Jakub Piotr",
        "lastName": "Kamiński",
        "shortFirstName": "Jakub",
        "shortLastName": "Kaminski",
        "matchName": "J. Kamiński",
        "shirtNumber": 16,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "570397": {
      "optaId": "2u6hj8z2g0r7b5roxpluy4sbu",
      "heimPlayer": {
        "id": "98836285",
        "team_id": "1457",
        "person": {
          "id": "570397",
          "name": "Ilya Zabarnyi",
          "firstname": "Ilya",
          "surname": "Zabarnyi",
          "fullname": "Ilya Borysovych Zabarnyi",
          "gender": "male",
          "birthday": "01.09.2002",
          "height": "189",
          "weight": "80",
          "person_detail": {
            "id": "487090",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Kyiv",
            "died": "no"
          },
          "country": [
            {
              "id": "225"
            }
          ]
        },
        "created": "20.01.2026 22:40",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "2u6hj8z2g0r7b5roxpluy4sbu",
        "firstName": "Illia",
        "lastName": "Zabarnyi",
        "shortFirstName": "Illia",
        "shortLastName": "Zabarnyi",
        "matchName": "I. Zabarnyi",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "571691": {
      "optaId": "btfanvej91yogqzfml4vmsmei",
      "heimPlayer": {
        "id": "100526251",
        "team_id": "136",
        "person": {
          "id": "571691",
          "name": "Mika Biereth",
          "firstname": "Mika",
          "surname": "Biereth",
          "fullname": "Mika Miles Biereth",
          "gender": "male",
          "birthday": "08.02.2003",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "488379",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "25.02.2026 22:32",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "btfanvej91yogqzfml4vmsmei",
        "firstName": "Mika Miles",
        "lastName": "Biereth",
        "shortFirstName": "Mika",
        "shortLastName": "Biereth",
        "matchName": "M. Biereth",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "572066": {
      "optaId": "5neiwdz7rtkhzj0cneic4xcoa",
      "heimPlayer": {
        "id": "101804543",
        "team_id": "1776",
        "person": {
          "id": "572066",
          "name": "Eduardo Quaresma",
          "firstname": "",
          "surname": "Eduardo Quaresma",
          "fullname": "Eduardo Filipe Quaresma Vieira Coimbra Simões",
          "gender": "male",
          "birthday": "02.03.2002",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "488748",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Barreiro",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "72"
      },
      "optaPlayer": {
        "playerId": "5neiwdz7rtkhzj0cneic4xcoa",
        "firstName": "Eduardo Filipe",
        "lastName": "Quaresma Vieira Coimbra Simões",
        "shortFirstName": "Eduardo Filipe",
        "shortLastName": "Quaresma Vieira Coimbra Simões",
        "knownName": "Eduardo Quaresma",
        "matchName": "Eduardo Quaresma",
        "shirtNumber": 72,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "572071": {
      "optaId": "d3dv3vc71981v5oems59892sq",
      "heimPlayer": {
        "id": "101812418",
        "team_id": "1457",
        "person": {
          "id": "572071",
          "name": "Nuno Mendes",
          "firstname": "",
          "surname": "Nuno Mendes",
          "fullname": "Nuno Alexandre Tavares Mendes",
          "gender": "male",
          "birthday": "19.06.2002",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "488753",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Lisboa",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "d3dv3vc71981v5oems59892sq",
        "firstName": "Nuno Alexandre",
        "lastName": "Tavares Mendes",
        "shortFirstName": "Nuno Alexandre",
        "shortLastName": "Tavares Mendes",
        "knownName": "Nuno Mendes",
        "matchName": "Nuno Mendes",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "572073": {
      "optaId": "9ic8hvnkzj9p0ikh6bwaeoqju",
      "heimPlayer": {
        "id": "102134936",
        "team_id": "2076",
        "person": {
          "id": "572073",
          "name": "Tiago Tomás",
          "firstname": "",
          "surname": "Tiago Tomás",
          "fullname": "Tiago Barreiros de Melo Tomás",
          "gender": "male",
          "birthday": "16.06.2002",
          "height": "180",
          "weight": "69",
          "person_detail": {
            "id": "488755",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Cascais",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "9ic8hvnkzj9p0ikh6bwaeoqju",
        "firstName": "Tiago",
        "lastName": "Barreiros de Melo Tomás",
        "shortFirstName": "Tiago",
        "shortLastName": "Barreiros de Melo Tomás",
        "knownName": "Tiago Tomás",
        "matchName": "Tiago Tomás",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "572082": {
      "optaId": "as0t8xi6k6nl4l06g23u3jcru",
      "heimPlayer": {
        "id": "100521601",
        "team_id": "1731",
        "person": {
          "id": "572082",
          "name": "Tomás Araújo",
          "firstname": "",
          "surname": "Tomás Araújo",
          "fullname": "Tomás Lemos Araújo",
          "gender": "male",
          "birthday": "16.05.2002",
          "height": "187",
          "weight": "81",
          "person_detail": {
            "id": "488762",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Famalicão",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "as0t8xi6k6nl4l06g23u3jcru",
        "firstName": "Tomás",
        "lastName": "Lemos Araújo",
        "shortFirstName": "Tomás",
        "shortLastName": "Lemos Araújo",
        "knownName": "Tomás Araújo",
        "matchName": "Tomás Araújo",
        "shirtNumber": 44,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "572190": {
      "optaId": "33rjtcl9kkwdlp34oqn4dkx9m",
      "heimPlayer": {
        "id": "101925851",
        "team_id": "24",
        "person": {
          "id": "572190",
          "name": "Alexander Prass",
          "firstname": "Alexander",
          "surname": "Prass",
          "fullname": "Alexander Prass",
          "gender": "male",
          "birthday": "26.05.2001",
          "height": "180",
          "weight": "72",
          "person_detail": {
            "id": "488870",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Hellmonsödt",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:19",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "33rjtcl9kkwdlp34oqn4dkx9m",
        "firstName": "Alexander",
        "lastName": "Prass",
        "shortFirstName": "Alexander",
        "shortLastName": "Prass",
        "matchName": "A. Prass",
        "shirtNumber": 22,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "572238": {
      "optaId": "2neid4doevn03b281smpp7o16",
      "heimPlayer": {
        "id": "99159265",
        "team_id": "17544",
        "person": {
          "id": "572238",
          "name": "Lev Kurgin",
          "firstname": "Lev",
          "surname": "Kurgin",
          "fullname": "Lev Kurgin",
          "gender": "male",
          "birthday": "06.06.2002",
          "height": "184",
          "weight": "",
          "person_detail": {
            "id": "488918",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Taldykorgan",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 22:29",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "2neid4doevn03b281smpp7o16",
        "firstName": "Lev",
        "lastName": "Kurgin",
        "shortFirstName": "Lev",
        "shortLastName": "Kurgin",
        "matchName": "L. Kurgin",
        "shirtNumber": 5,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "572724": {
      "optaId": "emglxnqrlqskt8krglv7sziwa",
      "heimPlayer": {
        "id": "97648639",
        "team_id": "1502",
        "person": {
          "id": "572724",
          "name": "Ricardo Pepi",
          "firstname": "Ricardo",
          "surname": "Pepi",
          "fullname": "Ricardo Daniel Pepi",
          "gender": "male",
          "birthday": "09.01.2003",
          "height": "185",
          "weight": "73",
          "person_detail": {
            "id": "489393",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "El Paso, TX",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "09.12.2025 22:30",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "emglxnqrlqskt8krglv7sziwa",
        "firstName": "Ricardo Daniel",
        "lastName": "Pepi",
        "shortFirstName": "Ricardo",
        "shortLastName": "Pepi",
        "matchName": "R. Pepi",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "573258": {
      "optaId": "ay89se5rytzay8md0yeadykq2",
      "heimPlayer": {
        "id": "100522060",
        "team_id": "258",
        "person": {
          "id": "573258",
          "name": "Yan Couto",
          "firstname": "",
          "surname": "Yan Couto",
          "fullname": "Yan Bueno Couto",
          "gender": "male",
          "birthday": "03.06.2002",
          "height": "168",
          "weight": "60",
          "person_detail": {
            "id": "489773",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Curitiba",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "25.02.2026 20:13",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "ay89se5rytzay8md0yeadykq2",
        "firstName": "Yan",
        "lastName": "Bueno Couto",
        "shortFirstName": "Yan",
        "shortLastName": "Bueno Couto",
        "knownName": "Yan Couto",
        "matchName": "Yan Couto",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "573428": {
      "optaId": "ev6oj77aergyn1hswvx4cq73e",
      "heimPlayer": {
        "id": "99154642",
        "team_id": "17544",
        "person": {
          "id": "573428",
          "name": "Aleksandr Shirobokov",
          "firstname": "Aleksandr",
          "surname": "Shirobokov",
          "fullname": "Alexander Sergeevich Shirobokov",
          "gender": "male",
          "birthday": "02.01.2003",
          "height": "184",
          "weight": "",
          "person_detail": {
            "id": "489943",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Ust-Kamenogorsk",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "ev6oj77aergyn1hswvx4cq73e",
        "firstName": "Aleksandr",
        "lastName": "Shirobokov",
        "shortFirstName": "Aleksandr",
        "shortLastName": "Shirobokov",
        "matchName": "A. Shirobokov",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "573600": {
      "optaId": "8h5jl1u3p8sr2pwdmyxl14416",
      "heimPlayer": {
        "id": "98831044",
        "team_id": "1457",
        "person": {
          "id": "573600",
          "name": "Lucas Chevalier",
          "firstname": "Lucas",
          "surname": "Chevalier",
          "fullname": "Lucas Chevalier",
          "gender": "male",
          "birthday": "06.11.2001",
          "height": "189",
          "weight": "78",
          "person_detail": {
            "id": "490115",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Calais",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "20.01.2026 20:06",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "8h5jl1u3p8sr2pwdmyxl14416",
        "firstName": "Lucas Eugène",
        "lastName": "Chevalier",
        "shortFirstName": "Lucas",
        "shortLastName": "Chevalier",
        "matchName": "L. Chevalier",
        "shirtNumber": 30,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "574877": {
      "optaId": "du4ciqofpkn3nei5q3huwlnje",
      "heimPlayer": {
        "id": "101311538",
        "team_id": "155",
        "person": {
          "id": "574877",
          "name": "Nicola Zalewski",
          "firstname": "Nicola",
          "surname": "Zalewski",
          "fullname": "Nicola Zalewski",
          "gender": "male",
          "birthday": "23.01.2002",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "491389",
            "position_1": "6",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Tivoli",
            "died": "no"
          },
          "country": [
            {
              "id": "166"
            }
          ]
        },
        "created": "10.03.2026 20:10",
        "shirtnumber": "59"
      },
      "optaPlayer": {
        "playerId": "du4ciqofpkn3nei5q3huwlnje",
        "firstName": "Nicola",
        "lastName": "Zalewski",
        "shortFirstName": "Nicola",
        "shortLastName": "Zalewski",
        "matchName": "N. Zalewski",
        "shirtNumber": 59,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "576599": {
      "optaId": "aaaskdins76bd0368sbpt7wq2",
      "heimPlayer": {
        "id": "101925518",
        "team_id": "29680",
        "person": {
          "id": "576599",
          "name": "Castello Lukeba",
          "firstname": "Castello",
          "surname": "Lukeba",
          "fullname": "Castello Junior Lukeba",
          "gender": "male",
          "birthday": "17.12.2002",
          "height": "184",
          "weight": "73",
          "person_detail": {
            "id": "493024",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Lyon",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "aaaskdins76bd0368sbpt7wq2",
        "firstName": "Castello Junior",
        "lastName": "Lukeba",
        "shortFirstName": "Castello",
        "shortLastName": "Lukeba",
        "matchName": "C. Lukeba",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "577021": {
      "optaId": "47l204bkq2qqjhtazusr0019m",
      "heimPlayer": {
        "id": "99152248",
        "team_id": "64",
        "person": {
          "id": "577021",
          "name": "Youri Baas",
          "firstname": "Youri",
          "surname": "Baas",
          "fullname": "Youri Baas",
          "gender": "male",
          "birthday": "17.03.2003",
          "height": "182",
          "weight": "71",
          "person_detail": {
            "id": "493449",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Dirksland",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "47l204bkq2qqjhtazusr0019m",
        "firstName": "Youri Pieter",
        "lastName": "Baas",
        "shortFirstName": "Youri",
        "shortLastName": "Baas",
        "matchName": "Y. Baas",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "577394": {
      "optaId": "7mvqysbmyf6uj3jny3qpqw2ga",
      "heimPlayer": {
        "id": "99158710",
        "team_id": "162",
        "person": {
          "id": "577394",
          "name": "Matteo Ruggeri",
          "firstname": "Matteo",
          "surname": "Ruggeri",
          "fullname": "Matteo Ruggeri",
          "gender": "male",
          "birthday": "11.07.2002",
          "height": "187",
          "weight": "69",
          "person_detail": {
            "id": "493815",
            "position_1": "3",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "San Giovanni Bianco",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "28.01.2026 22:16",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "7mvqysbmyf6uj3jny3qpqw2ga",
        "firstName": "Matteo",
        "lastName": "Ruggeri",
        "shortFirstName": "Matteo",
        "shortLastName": "Ruggeri",
        "matchName": "M. Ruggeri",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "577464": {
      "optaId": "9prtaifv6stlujgywgq4wd08a",
      "heimPlayer": {
        "id": "95818804",
        "team_id": "1267",
        "person": {
          "id": "577464",
          "name": "Joško Gvardiol",
          "firstname": "Joško",
          "surname": "Gvardiol",
          "fullname": "Joško Gvardiol",
          "gender": "male",
          "birthday": "23.01.2002",
          "height": "185",
          "weight": "80",
          "person_detail": {
            "id": "493885",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Zagreb",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "05.11.2025 19:49",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "9prtaifv6stlujgywgq4wd08a",
        "firstName": "Joško",
        "lastName": "Gvardiol",
        "shortFirstName": "Josko",
        "shortLastName": "Gvardiol",
        "matchName": "J. Gvardiol",
        "shirtNumber": 24,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "577467": {
      "optaId": "9ikkuxd19avliz1khcrm82gyy",
      "heimPlayer": {
        "id": "99152563",
        "team_id": "162",
        "person": {
          "id": "577467",
          "name": "Julián Alvarez",
          "firstname": "Julián",
          "surname": "Alvarez",
          "fullname": "Julián Alvarez",
          "gender": "male",
          "birthday": "31.01.2000",
          "height": "170",
          "weight": "71",
          "person_detail": {
            "id": "493888",
            "position_1": "11",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Calchín",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "9ikkuxd19avliz1khcrm82gyy",
        "firstName": "Julián",
        "lastName": "Alvarez",
        "shortFirstName": "Julián",
        "shortLastName": "Alvarez",
        "matchName": "J. Alvarez",
        "shirtNumber": 19,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "579441": {
      "optaId": "34hf426mfmzrveesligyijmga",
      "heimPlayer": {
        "id": "100502350",
        "team_id": "18670",
        "person": {
          "id": "579441",
          "name": "Toral Bayramov",
          "firstname": "Toral",
          "surname": "Bayramov",
          "fullname": "Toral Mais oglu Bayramov",
          "gender": "male",
          "birthday": "23.02.2001",
          "height": "185",
          "weight": "",
          "person_detail": {
            "id": "495801",
            "position_1": "3",
            "position_2": "5",
            "preferred_side": "left",
            "birth_place": "Baku",
            "died": "no"
          },
          "country": [
            {
              "id": "15"
            }
          ]
        },
        "created": "24.02.2026 22:34",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "34hf426mfmzrveesligyijmga",
        "firstName": "Toral",
        "lastName": "Bayramov",
        "shortFirstName": "Toral",
        "shortLastName": "Bayramov",
        "matchName": "T. Bayramov",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "579445": {
      "optaId": "7s9o8unhgvf00mn7vdxeeeq96",
      "heimPlayer": {
        "id": "100493311",
        "team_id": "18670",
        "person": {
          "id": "579445",
          "name": "Elvin Cəfərquliyev",
          "firstname": "Elvin",
          "surname": "Cəfərquliyev",
          "fullname": "Elvin Eldar Oglu Cəfərquliyev",
          "gender": "male",
          "birthday": "26.10.2000",
          "height": "180",
          "weight": "",
          "person_detail": {
            "id": "495805",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Baku",
            "died": "no"
          },
          "country": [
            {
              "id": "15"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "7s9o8unhgvf00mn7vdxeeeq96",
        "firstName": "Elvin",
        "lastName": "Cəfərquliyev",
        "shortFirstName": "Elvin",
        "shortLastName": "Cafarquliyev",
        "matchName": "E. Cəfərquliyev",
        "shirtNumber": 44,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "582551": {
      "optaId": "5tbz2hexz7vind39ot6govqzu",
      "heimPlayer": {
        "id": "97648696",
        "team_id": "1226",
        "person": {
          "id": "582551",
          "name": "Conor Bradley",
          "firstname": "Conor",
          "surname": "Bradley",
          "fullname": "Conor Bradley",
          "gender": "male",
          "birthday": "09.07.2003",
          "height": "181",
          "weight": "63",
          "person_detail": {
            "id": "498692",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Castlederg",
            "died": "no"
          },
          "country": [
            {
              "id": "154"
            }
          ]
        },
        "created": "09.12.2025 22:31",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "5tbz2hexz7vind39ot6govqzu",
        "firstName": "Conor",
        "lastName": "Bradley",
        "shortFirstName": "Conor",
        "shortLastName": "Bradley",
        "matchName": "C. Bradley",
        "shirtNumber": 12,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "583245": {
      "optaId": "2x44f29a52v8kpkkjsuiiywdm",
      "heimPlayer": {
        "id": "100521760",
        "team_id": "1094",
        "person": {
          "id": "583245",
          "name": "Francisco Conceição",
          "firstname": "",
          "surname": "Francisco Conceição",
          "fullname": "Francisco Fernandes da Conceição",
          "gender": "male",
          "birthday": "14.12.2002",
          "height": "170",
          "weight": "64",
          "person_detail": {
            "id": "499285",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Coimbra",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "2x44f29a52v8kpkkjsuiiywdm",
        "firstName": "Francisco",
        "lastName": "Fernandes da Conceição",
        "shortFirstName": "Francisco",
        "shortLastName": "Fernandes da Conceição",
        "knownName": "Francisco Conceição",
        "matchName": "Francisco Conceição",
        "shirtNumber": 7,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "583669": {
      "optaId": "649anpduq5pwrqbek73wr8n6y",
      "heimPlayer": {
        "id": "100493317",
        "team_id": "18670",
        "person": {
          "id": "583669",
          "name": "Pedro Bicalho",
          "firstname": "",
          "surname": "Pedro Bicalho",
          "fullname": "Pedro Henrique Rodrigues Bicalho",
          "gender": "male",
          "birthday": "23.04.2001",
          "height": "178",
          "weight": "73",
          "person_detail": {
            "id": "499711",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "São Bernardo do Campo",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "35"
      },
      "optaPlayer": {
        "playerId": "649anpduq5pwrqbek73wr8n6y",
        "firstName": "Pedro Henrique",
        "lastName": "Rodrigues Bicalho",
        "shortFirstName": "Pedro Henrique",
        "shortLastName": "Rodrigues Bicalho",
        "knownName": "Pedro Bicalho",
        "matchName": "Pedro Bicalho",
        "shirtNumber": 35,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "585482": {
      "optaId": "gw2711y9bgq4w80ntfqvv88a",
      "heimPlayer": {
        "id": "100492129",
        "team_id": "1418",
        "person": {
          "id": "585482",
          "name": "Konstantinos Tzolakis",
          "firstname": "Konstantinos",
          "surname": "Tzolakis",
          "fullname": "Konstantinos Tzolakis",
          "gender": "male",
          "birthday": "08.11.2002",
          "height": "193",
          "weight": "80",
          "person_detail": {
            "id": "501603",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Chania",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "88"
      },
      "optaPlayer": {
        "playerId": "gw2711y9bgq4w80ntfqvv88a",
        "firstName": "Konstantinos",
        "lastName": "Tzolakis",
        "shortFirstName": "Konstantinos",
        "shortLastName": "Tzolakis",
        "matchName": "K. Tzolakis",
        "shirtNumber": 88,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "586898": {
      "optaId": "acx78ftnm61hm01wpmme77hbe",
      "heimPlayer": {
        "id": "99153025",
        "team_id": "2102",
        "person": {
          "id": "586898",
          "name": "Tajon Buchanan",
          "firstname": "Tajon",
          "surname": "Buchanan",
          "fullname": "Tajon Trevor Buchanan",
          "gender": "male",
          "birthday": "08.02.1999",
          "height": "183",
          "weight": "68",
          "person_detail": {
            "id": "503029",
            "position_1": "12",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Brampton, ON",
            "died": "no"
          },
          "country": [
            {
              "id": "98"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "acx78ftnm61hm01wpmme77hbe",
        "firstName": "Tajon Trevor",
        "lastName": "Buchanan",
        "shortFirstName": "Tajon",
        "shortLastName": "Buchanan",
        "matchName": "T. Buchanan",
        "shirtNumber": 17,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "589188": {
      "optaId": "cis0z72hgahfnfjduk7hdnz3e",
      "heimPlayer": {
        "id": "101862302",
        "team_id": "155",
        "person": {
          "id": "589188",
          "name": "Odilon Kossounou",
          "firstname": "Odilon",
          "surname": "Kossounou",
          "fullname": "Odilon Kossounou Kouakou",
          "gender": "male",
          "birthday": "04.01.2001",
          "height": "191",
          "weight": "79",
          "person_detail": {
            "id": "505270",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Abidjan",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "cis0z72hgahfnfjduk7hdnz3e",
        "firstName": "Kouakou Odilon Dorgeless",
        "lastName": "Kossounou",
        "shortFirstName": "Odilon",
        "shortLastName": "Kossounou",
        "matchName": "O. Kossounou",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "590075": {
      "optaId": "6km3r9cspyz7g6343o9mri63u",
      "heimPlayer": {
        "id": "97683250",
        "team_id": "64",
        "person": {
          "id": "590075",
          "name": "Raúl Moro",
          "firstname": "",
          "surname": "Raúl Moro",
          "fullname": "Raúl Moro Prescoli",
          "gender": "male",
          "birthday": "05.12.2002",
          "height": "169",
          "weight": "68",
          "person_detail": {
            "id": "506128",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Abrera",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "10.12.2025 17:34",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "6km3r9cspyz7g6343o9mri63u",
        "firstName": "Raúl",
        "lastName": "Moro Prescoli",
        "shortFirstName": "Raúl",
        "shortLastName": "Moro",
        "matchName": "Raúl Moro",
        "shirtNumber": 7,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "590838": {
      "optaId": "en2c7z1raqmcwee78297pbnu2",
      "heimPlayer": {
        "id": "101823341",
        "team_id": "1545",
        "person": {
          "id": "590838",
          "name": "Eduardo Camavinga",
          "firstname": "Eduardo",
          "surname": "Camavinga",
          "fullname": "Eduardo Celmi Camavinga",
          "gender": "male",
          "birthday": "10.11.2002",
          "height": "182",
          "weight": "68",
          "person_detail": {
            "id": "506876",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Cabinda",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 22:34",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "en2c7z1raqmcwee78297pbnu2",
        "firstName": "Eduardo Celmi",
        "lastName": "Camavinga",
        "shortFirstName": "Eduardo",
        "shortLastName": "Camavinga",
        "matchName": "E. Camavinga",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "591406": {
      "optaId": "6dtp194pewnyuhwkxcn2xpf8q",
      "heimPlayer": {
        "id": "102100466",
        "team_id": "21",
        "person": {
          "id": "591406",
          "name": "Kaishu Sano",
          "firstname": "Kaishu",
          "surname": "Sano",
          "fullname": "Kaishu Sano",
          "gender": "male",
          "birthday": "30.12.2000",
          "height": "176",
          "weight": "67",
          "person_detail": {
            "id": "507444",
            "position_1": "7",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Tsuyama, Okayama",
            "died": "no"
          }
        },
        "created": "22.03.2026 14:24",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "6dtp194pewnyuhwkxcn2xpf8q",
        "firstName": "Kaishu",
        "lastName": "Sano",
        "shortFirstName": "Kaishu",
        "shortLastName": "Sano",
        "matchName": "K. Sano",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "11"
      }
    },
    "593101": {
      "optaId": "1zxwich342p8fholev7ddkwh6",
      "heimPlayer": {
        "id": "101812007",
        "team_id": "373",
        "person": {
          "id": "593101",
          "name": "Enzo Fernández",
          "firstname": "Enzo",
          "surname": "Fernández",
          "fullname": "Enzo Jeremías Fernández",
          "gender": "male",
          "birthday": "17.01.2001",
          "height": "178",
          "weight": "77",
          "person_detail": {
            "id": "509125",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "San Martín",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "1zxwich342p8fholev7ddkwh6",
        "firstName": "Enzo Jeremías",
        "lastName": "Fernández",
        "shortFirstName": "Enzo",
        "shortLastName": "Fernández",
        "matchName": "E. Fernández",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11",
        "captain": "yes"
      }
    },
    "593900": {
      "optaId": "6o76owze8y78ue9sb49g8kyz8",
      "heimPlayer": {
        "id": "101822612",
        "team_id": "127",
        "person": {
          "id": "593900",
          "name": "Cristhian Mosquera",
          "firstname": "",
          "surname": "Cristhian Mosquera",
          "fullname": "Cristhian Andrey Mosquera Ibargüen",
          "gender": "male",
          "birthday": "27.06.2004",
          "height": "191",
          "weight": "79",
          "person_detail": {
            "id": "509921",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Alicante",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 22:25",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "6o76owze8y78ue9sb49g8kyz8",
        "firstName": "Cristhian Andrey",
        "lastName": "Mosquera Ibargüen",
        "shortFirstName": "Cristhian",
        "shortLastName": "Mosquera",
        "matchName": "Cristhian Mosquera",
        "shirtNumber": 3,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "594144": {
      "optaId": "6rxd6ltpl30qmksb5fkwrl756",
      "heimPlayer": {
        "id": "100764412",
        "team_id": "943",
        "person": {
          "id": "594144",
          "name": "Nicolás Capaldo",
          "firstname": "Nicolás",
          "surname": "Capaldo",
          "fullname": "Nicolás Capaldo Taboas",
          "gender": "male",
          "birthday": "14.09.1998",
          "height": "177",
          "weight": "73",
          "person_detail": {
            "id": "510165",
            "position_1": "13",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Santa Rosa",
            "died": "no"
          }
        },
        "created": "01.03.2026 18:32",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "6rxd6ltpl30qmksb5fkwrl756",
        "firstName": "Nicolás",
        "lastName": "Capaldo Taboas",
        "shortFirstName": "Nicolás",
        "shortLastName": "Capaldo",
        "matchName": "N. Capaldo",
        "shirtNumber": 24,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6",
        "captain": "yes"
      }
    },
    "594979": {
      "optaId": "eaqqezw2ed1u0tt3zc128mr1m",
      "heimPlayer": {
        "id": "101812013",
        "team_id": "373",
        "person": {
          "id": "594979",
          "name": "João Pedro",
          "firstname": "",
          "surname": "João Pedro",
          "fullname": "João Pedro Junqueira de Jesus",
          "gender": "male",
          "birthday": "26.09.2001",
          "height": "182",
          "weight": "80",
          "person_detail": {
            "id": "510990",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Ribeirão Preto",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "eaqqezw2ed1u0tt3zc128mr1m",
        "firstName": "João Pedro",
        "lastName": "Junqueira de Jesus",
        "shortFirstName": "João Pedro",
        "shortLastName": "Junqueira de Jesus",
        "knownName": "João Pedro",
        "matchName": "João Pedro",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "595235": {
      "optaId": "f065kc6qn2cpxjxcm6i08rz3e",
      "heimPlayer": {
        "id": "101861120",
        "team_id": "853",
        "person": {
          "id": "595235",
          "name": "Wilfried Singo",
          "firstname": "Wilfried",
          "surname": "Singo",
          "fullname": "Wilfried Stéphane Singo",
          "gender": "male",
          "birthday": "25.12.2000",
          "height": "190",
          "weight": "79",
          "person_detail": {
            "id": "511215",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Grand-Béréby",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "90"
      },
      "optaPlayer": {
        "playerId": "f065kc6qn2cpxjxcm6i08rz3e",
        "firstName": "Wilfried Stéphane",
        "lastName": "Singo",
        "shortFirstName": "Wilfried",
        "shortLastName": "Singo",
        "matchName": "W. Singo",
        "shirtNumber": 90,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "595245": {
      "optaId": "2p86mzr8qnu9iy01fusvovf56",
      "heimPlayer": {
        "id": "99160267",
        "team_id": "1731",
        "person": {
          "id": "595245",
          "name": "António Silva",
          "firstname": "",
          "surname": "António Silva",
          "fullname": "António João Pereira De Albuquerque Tavares Da Silva",
          "gender": "male",
          "birthday": "30.10.2003",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "511225",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Viseu",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "extra_minute": "3",
        "created": "28.01.2026 22:58",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "2p86mzr8qnu9iy01fusvovf56",
        "firstName": "António João",
        "lastName": "Pereira de Albuquerque Tavares da Silva",
        "shortFirstName": "António João",
        "shortLastName": "Pereira de Albuquerque Tavares da Silva",
        "knownName": "António Silva",
        "matchName": "António Silva",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "595385": {
      "optaId": "e0cy0gwf04lohf0xjef0af8fe",
      "heimPlayer": {
        "id": "98856997",
        "team_id": "1421",
        "person": {
          "id": "595385",
          "name": "Igor Paixão",
          "firstname": "",
          "surname": "Igor Paixão",
          "fullname": "Igor Guilherme Barbosa da Paixão",
          "gender": "male",
          "birthday": "28.06.2000",
          "height": "167",
          "weight": "65",
          "person_detail": {
            "id": "511365",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Macapá",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "21.01.2026 22:28",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "e0cy0gwf04lohf0xjef0af8fe",
        "firstName": "Igor Guilherme",
        "lastName": "Barbosa da Paixão",
        "shortFirstName": "Igor Guilherme",
        "shortLastName": "Barbosa da Paixão",
        "knownName": "Igor Paixão",
        "matchName": "Igor Paixão",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "595413": {
      "optaId": "cayu6id8xmj67n29s2x3bsbxm",
      "heimPlayer": {
        "id": "101804540",
        "team_id": "1776",
        "person": {
          "id": "595413",
          "name": "Gonçalo Inácio",
          "firstname": "",
          "surname": "Gonçalo Inácio",
          "fullname": "Gonçalo Bernardo Inácio",
          "gender": "male",
          "birthday": "25.08.2001",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "511393",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Almada",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "cayu6id8xmj67n29s2x3bsbxm",
        "firstName": "Gonçalo Bernardo",
        "lastName": "Inácio",
        "shortFirstName": "Gonçalo Bernardo",
        "shortLastName": "Inácio",
        "knownName": "Gonçalo Inácio",
        "matchName": "Gonçalo Inácio",
        "shirtNumber": 25,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "595804": {
      "optaId": "7jpasvui43tnyao6ijyuuyuqc",
      "heimPlayer": {
        "id": "101645687",
        "team_id": "2076",
        "person": {
          "id": "595804",
          "name": "Bilal El Khannouss",
          "firstname": "Bilal",
          "surname": "El Khannouss",
          "fullname": "Bilal El Khannouss",
          "gender": "male",
          "birthday": "10.05.2004",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "511726",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Strombeek-Bever",
            "died": "no"
          }
        },
        "created": "15.03.2026 18:09",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "7jpasvui43tnyao6ijyuuyuqc",
        "firstName": "Bilal",
        "lastName": "El Khannouss",
        "shortFirstName": "Bilal",
        "shortLastName": "El Khannouss",
        "matchName": "B. El Khannouss",
        "shirtNumber": 11,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "596237": {
      "optaId": "16idj1wxzcbvuaov5duvpqhyi",
      "heimPlayer": {
        "id": "97648666",
        "team_id": "530",
        "person": {
          "id": "596237",
          "name": "Elye Wahi",
          "firstname": "Elye",
          "surname": "Wahi",
          "fullname": "Sepe Elye Wahi",
          "gender": "male",
          "birthday": "02.01.2003",
          "height": "184",
          "weight": "74",
          "person_detail": {
            "id": "577692",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Courcouronnes",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "09.12.2025 22:31",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "16idj1wxzcbvuaov5duvpqhyi",
        "firstName": "Sepe Elye",
        "lastName": "Delmas Wahi",
        "shortFirstName": "Elye",
        "shortLastName": "Wahi",
        "matchName": "E. Wahi",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "596488": {
      "optaId": "c2mwg1uhug0pbgl72uf9b927e",
      "heimPlayer": {
        "id": "98857003",
        "team_id": "373",
        "person": {
          "id": "596488",
          "name": "Jamie Gittens",
          "firstname": "Jamie",
          "surname": "Gittens",
          "fullname": "Jamie Jermaine Bynoe-Gittens",
          "gender": "male",
          "birthday": "08.08.2004",
          "height": "177",
          "weight": "70",
          "person_detail": {
            "id": "577940",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "21.01.2026 22:28",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "c2mwg1uhug0pbgl72uf9b927e",
        "firstName": "Jamie Jermaine",
        "lastName": "Bynoe-Gittens",
        "shortFirstName": "Jamie",
        "shortLastName": "Gittens",
        "matchName": "J. Gittens",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "596998": {
      "optaId": "8828sbg7wzgjbs1727j0rx84q",
      "heimPlayer": {
        "id": "102154940",
        "team_id": "594",
        "person": {
          "id": "596998",
          "name": "Anton Kade",
          "firstname": "Anton",
          "surname": "Kade",
          "fullname": "Anton Kade",
          "gender": "male",
          "birthday": "17.01.2004",
          "height": "185",
          "weight": "72",
          "person_detail": {
            "id": "578431",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "22.03.2026 20:35",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "8828sbg7wzgjbs1727j0rx84q",
        "firstName": "Anton",
        "lastName": "Kade",
        "shortFirstName": "Anton",
        "shortLastName": "Kade",
        "matchName": "A. Kade",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "597591": {
      "optaId": "c90gk99jn34wxtlad784hpnv8",
      "heimPlayer": {
        "id": "93646612",
        "team_id": "162",
        "person": {
          "id": "597591",
          "name": "Carlos Martín",
          "firstname": "",
          "surname": "Carlos Martín",
          "fullname": "Carlos Martín Domínguez",
          "gender": "male",
          "birthday": "22.04.2002",
          "height": "184",
          "weight": "",
          "person_detail": {
            "id": "579010",
            "position_1": "6",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "30.09.2025 22:47",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "c90gk99jn34wxtlad784hpnv8",
        "firstName": "Carlos",
        "lastName": "Martín Domínguez",
        "shortFirstName": "Carlos",
        "shortLastName": "Martín",
        "matchName": "Carlos Martín",
        "shirtNumber": 12,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "598713": {
      "optaId": "58de7rbubnxjraen49dxpaqne",
      "heimPlayer": {
        "id": "96883717",
        "team_id": "1267",
        "person": {
          "id": "598713",
          "name": "Oscar Bobb",
          "firstname": "Oscar",
          "surname": "Bobb",
          "fullname": "Oscar Bobb",
          "gender": "male",
          "birthday": "12.07.2003",
          "height": "175",
          "weight": "",
          "person_detail": {
            "id": "580102",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Oslo",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "25.11.2025 19:53",
        "shirtnumber": "52"
      },
      "optaPlayer": {
        "playerId": "58de7rbubnxjraen49dxpaqne",
        "firstName": "Oscar",
        "lastName": "Bobb",
        "shortFirstName": "Oscar",
        "shortLastName": "Bobb",
        "matchName": "O. Bobb",
        "shirtNumber": 52,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "598715": {
      "optaId": "8pyq4t68w42u3fgd2w7tjykbu",
      "heimPlayer": {
        "id": "101815916",
        "team_id": "749",
        "person": {
          "id": "598715",
          "name": "Sondre Auklend",
          "firstname": "Sondre",
          "surname": "Auklend",
          "fullname": "Sondre Auklend",
          "gender": "male",
          "birthday": "10.06.2003",
          "height": "172",
          "weight": "67",
          "person_detail": {
            "id": "580104",
            "position_1": "6",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "extra_minute": "1",
        "created": "17.03.2026 20:34",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "8pyq4t68w42u3fgd2w7tjykbu",
        "firstName": "Sondre",
        "lastName": "Auklend",
        "shortFirstName": "Sondre",
        "shortLastName": "Auklend",
        "matchName": "S. Auklend",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "599637": {
      "optaId": "5ql70wwevaoqpxabylew5f696",
      "heimPlayer": {
        "id": "100522009",
        "team_id": "258",
        "person": {
          "id": "599637",
          "name": "Carney Chukwuemeka",
          "firstname": "Carney",
          "surname": "Chukwuemeka",
          "fullname": "Carney Chibueze Chukwuemeka",
          "gender": "male",
          "birthday": "20.10.2003",
          "height": "187",
          "weight": "70",
          "person_detail": {
            "id": "581012",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Eisenstadt",
            "died": "no"
          },
          "country": [
            {
              "id": "158"
            }
          ]
        },
        "created": "25.02.2026 20:03",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "5ql70wwevaoqpxabylew5f696",
        "firstName": "Carney Chibueze",
        "lastName": "Chukwuemeka",
        "shortFirstName": "Carney",
        "shortLastName": "Chukwuemeka",
        "matchName": "C. Chukwuemeka",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "599848": {
      "optaId": "58d87tochcm6hk4n6l7ua7jvu",
      "heimPlayer": {
        "id": "101973230",
        "team_id": "2134",
        "person": {
          "id": "599848",
          "name": "Samuel Mbangula",
          "firstname": "Samuel",
          "surname": "Mbangula",
          "fullname": "Samuel Germain Kinduelu Mbangula Tshifunda",
          "gender": "male",
          "birthday": "16.01.2004",
          "height": "179",
          "weight": "64",
          "person_detail": {
            "id": "581223",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Bruxelles",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:17",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "58d87tochcm6hk4n6l7ua7jvu",
        "firstName": "Samuel-Germain Kinduelu",
        "lastName": "Mbangula Tshifunda",
        "shortFirstName": "Samuel",
        "shortLastName": "Mbangula",
        "matchName": "S. Mbangula",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "600148": {
      "optaId": "amuqk3xvo87ppk7fz39cg0pre",
      "heimPlayer": {
        "id": "100526788",
        "team_id": "1731",
        "person": {
          "id": "600148",
          "name": "Franjo Ivanović",
          "firstname": "Franjo",
          "surname": "Ivanović",
          "fullname": "Franjo Ivanović",
          "gender": "male",
          "birthday": "01.10.2003",
          "height": "185",
          "weight": "82",
          "person_detail": {
            "id": "581518",
            "position_1": "11",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Schwaz",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "25.02.2026 22:45",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "amuqk3xvo87ppk7fz39cg0pre",
        "firstName": "Franjo",
        "lastName": "Ivanović",
        "shortFirstName": "Franjo",
        "shortLastName": "Ivanovic",
        "matchName": "F. Ivanović",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "600556": {
      "optaId": "a6cke0ad2pvuyahweuch772ay",
      "heimPlayer": {
        "id": "97524370",
        "team_id": "2134",
        "person": {
          "id": "600556",
          "name": "Victor Boniface",
          "firstname": "Victor",
          "surname": "Boniface",
          "fullname": "Victor Okoh Boniface",
          "gender": "male",
          "birthday": "23.12.2000",
          "height": "190",
          "weight": "91",
          "person_detail": {
            "id": "581918",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Akure",
            "died": "no"
          }
        },
        "created": "07.12.2025 17:14",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "a6cke0ad2pvuyahweuch772ay",
        "firstName": "Victor",
        "lastName": "Okoh Boniface",
        "shortFirstName": "Victor",
        "shortLastName": "Boniface",
        "matchName": "V. Boniface",
        "shirtNumber": 44,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "600710": {
      "optaId": "74n6zo57y4h14zll0p5ncm3ca",
      "heimPlayer": {
        "id": "91720055",
        "team_id": "21",
        "person": {
          "id": "600710",
          "name": "Ben Bobzien",
          "firstname": "Ben",
          "surname": "Bobzien",
          "fullname": "Ben Justus Bobzien",
          "gender": "male",
          "birthday": "29.04.2003",
          "height": "174",
          "weight": "70",
          "person_detail": {
            "id": "582055",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Gießen",
            "died": "no"
          }
        },
        "created": "31.08.2025 17:12",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "74n6zo57y4h14zll0p5ncm3ca",
        "firstName": "Ben Justus",
        "lastName": "Bobzien",
        "shortFirstName": "Ben",
        "shortLastName": "Bobzien",
        "matchName": "B. Bobzien",
        "shirtNumber": 37,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "601012": {
      "optaId": "4foax2b7unlkev1eq6py86lii",
      "heimPlayer": {
        "id": "101812790",
        "team_id": "127",
        "person": {
          "id": "601012",
          "name": "Piero Hincapié",
          "firstname": "Piero",
          "surname": "Hincapié",
          "fullname": "Piero Martín Hincapié Reyna",
          "gender": "male",
          "birthday": "09.01.2002",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "582349",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Esmeraldas",
            "died": "no"
          },
          "country": [
            {
              "id": "52"
            }
          ]
        },
        "created": "17.03.2026 19:53",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "4foax2b7unlkev1eq6py86lii",
        "firstName": "Piero Martín",
        "lastName": "Hincapié Reyna",
        "shortFirstName": "Piero",
        "shortLastName": "Hincapié",
        "matchName": "P. Hincapié",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "601109": {
      "optaId": "bsdr4bp6qt4qpy303u7l11250",
      "heimPlayer": {
        "id": "98857018",
        "team_id": "1421",
        "person": {
          "id": "601109",
          "name": "Bilal Nadir",
          "firstname": "Bilal",
          "surname": "Nadir",
          "fullname": "Bilal Nadir",
          "gender": "male",
          "birthday": "28.11.2003",
          "height": "172",
          "weight": "65",
          "person_detail": {
            "id": "582445",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Nice",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 22:28",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "bsdr4bp6qt4qpy303u7l11250",
        "firstName": "Bilal",
        "lastName": "Nadir",
        "shortFirstName": "Bilal",
        "shortLastName": "Nadir",
        "matchName": "B. Nadir",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "601975": {
      "optaId": "53nd6a4o02ebb0w2s12prijje",
      "heimPlayer": {
        "id": "102117146",
        "team_id": "1639",
        "person": {
          "id": "601975",
          "name": "Yuito Suzuki",
          "firstname": "Yuito",
          "surname": "Suzuki",
          "fullname": "Yuito Suzuki",
          "gender": "male",
          "birthday": "25.10.2001",
          "height": "175",
          "weight": "66",
          "person_detail": {
            "id": "583283",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Miura (Kanagawa)",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "53nd6a4o02ebb0w2s12prijje",
        "firstName": "Yuito",
        "lastName": "Suzuki",
        "shortFirstName": "Yuito",
        "shortLastName": "Suzuki",
        "matchName": "Y. Suzuki",
        "shirtNumber": 14,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "602069": {
      "optaId": "aplc9mad75h1k90o3qla9c7l6",
      "heimPlayer": {
        "id": "101999810",
        "team_id": "2086",
        "person": {
          "id": "602069",
          "name": "Patrick Wimmer",
          "firstname": "Patrick",
          "surname": "Wimmer",
          "fullname": "Patrick Wimmer",
          "gender": "male",
          "birthday": "30.05.2001",
          "height": "182",
          "weight": "77",
          "person_detail": {
            "id": "583377",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Tulln",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:52",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "aplc9mad75h1k90o3qla9c7l6",
        "firstName": "Patrick",
        "lastName": "Wimmer",
        "shortFirstName": "Patrick",
        "shortLastName": "Wimmer",
        "matchName": "P. Wimmer",
        "shirtNumber": 39,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "602558": {
      "optaId": "c1s9pmfkytw0du5ril4kv9i0a",
      "heimPlayer": {
        "id": "101823590",
        "team_id": "205",
        "person": {
          "id": "602558",
          "name": "Ezequiel Fernández",
          "firstname": "Ezequiel",
          "surname": "Fernández",
          "fullname": "Ignacio Ezequiel Agustín Fernández Carballo",
          "gender": "male",
          "birthday": "25.07.2002",
          "height": "178",
          "weight": "70",
          "person_detail": {
            "id": "583859",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "San Miguel",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "17.03.2026 22:39",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "c1s9pmfkytw0du5ril4kv9i0a",
        "firstName": "Ignacio Ezequiel Agustín",
        "lastName": "Fernández Carballo",
        "shortFirstName": "Ezequiél",
        "shortLastName": "Fernández",
        "matchName": "E. Fernández",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "602666": {
      "optaId": "d27r61wcc9az0shpevisc4iga",
      "heimPlayer": {
        "id": "99153010",
        "team_id": "2102",
        "person": {
          "id": "602666",
          "name": "Rafa Marín",
          "firstname": "",
          "surname": "Rafa Marín",
          "fullname": "Rafael Marín Zamora",
          "gender": "male",
          "birthday": "19.05.2002",
          "height": "191",
          "weight": "83",
          "person_detail": {
            "id": "583950",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Guadajoz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "d27r61wcc9az0shpevisc4iga",
        "firstName": "Rafael",
        "lastName": "Marín Zamora",
        "shortFirstName": "Rafa",
        "shortLastName": "Marín",
        "matchName": "Rafa Marín",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "604533": {
      "optaId": "f577akgydk4t6ui45iyab2a22",
      "heimPlayer": {
        "id": "102002219",
        "team_id": "205",
        "person": {
          "id": "604533",
          "name": "Tim Oermann",
          "firstname": "Tim",
          "surname": "Oermann",
          "fullname": "Tim Oermann",
          "gender": "male",
          "birthday": "06.10.2003",
          "height": "189",
          "weight": "76",
          "person_detail": {
            "id": "585797",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Bochum",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:10",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "f577akgydk4t6ui45iyab2a22",
        "firstName": "Tim",
        "lastName": "Oermann",
        "shortFirstName": "Tim",
        "shortLastName": "Oermann",
        "matchName": "T. Oermann",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "604656": {
      "optaId": "ar7ybu7dordgt2yfx5inux62",
      "heimPlayer": {
        "id": "101815631",
        "team_id": "749",
        "person": {
          "id": "604656",
          "name": "Isak Määttä",
          "firstname": "Isak",
          "surname": "Määttä",
          "fullname": "Isak Dybvik Määttä",
          "gender": "male",
          "birthday": "19.09.2001",
          "height": "189",
          "weight": "76",
          "person_detail": {
            "id": "585919",
            "position_1": "3",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Ålesund",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 20:27",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "ar7ybu7dordgt2yfx5inux62",
        "firstName": "Isak",
        "lastName": "Dybvik Määttä",
        "shortFirstName": "Isak",
        "shortLastName": "Määttä",
        "matchName": "I. Määttä",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "604844": {
      "optaId": "4cejhrr3ji36591xf54jue3ca",
      "heimPlayer": {
        "id": "101862296",
        "team_id": "155",
        "person": {
          "id": "604844",
          "name": "Giorgio Scalvini",
          "firstname": "Giorgio",
          "surname": "Scalvini",
          "fullname": "Giorgio Scalvini",
          "gender": "male",
          "birthday": "11.12.2003",
          "height": "194",
          "weight": "87",
          "person_detail": {
            "id": "586105",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Chiari",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "4cejhrr3ji36591xf54jue3ca",
        "firstName": "Giorgio",
        "lastName": "Scalvini",
        "shortFirstName": "Giorgio",
        "shortLastName": "Scalvini",
        "matchName": "G. Scalvini",
        "shirtNumber": 42,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "605314": {
      "optaId": "26wj6flfqi59vgz6vwjgur2ay",
      "heimPlayer": {
        "id": "99159685",
        "team_id": "156",
        "person": {
          "id": "605314",
          "name": "Nico Serrano",
          "firstname": "",
          "surname": "Nico Serrano",
          "fullname": "Nicolás Serrano Galdeano",
          "gender": "male",
          "birthday": "05.03.2003",
          "height": "176",
          "weight": "72",
          "person_detail": {
            "id": "586573",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Iruñea",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:39",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "26wj6flfqi59vgz6vwjgur2ay",
        "firstName": "Nicolás",
        "lastName": "Serrano Galdeano",
        "shortFirstName": "Nico",
        "shortLastName": "Serrano",
        "matchName": "Nico Serrano",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "605317": {
      "optaId": "bzgh5psb1janz9y3btpswngbu",
      "heimPlayer": {
        "id": "98853787",
        "team_id": "597",
        "person": {
          "id": "605317",
          "name": "Alejandro Balde",
          "firstname": "",
          "surname": "Alejandro Balde",
          "fullname": "Alejandro Alberto Balde Martínez",
          "gender": "male",
          "birthday": "18.10.2003",
          "height": "177",
          "weight": "69",
          "person_detail": {
            "id": "586576",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Barcelona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "21.01.2026 19:56",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "bzgh5psb1janz9y3btpswngbu",
        "firstName": "Alejandro",
        "lastName": "Balde Martínez",
        "shortFirstName": "Alejandro",
        "shortLastName": "Balde",
        "matchName": "Alejandro Balde",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "605363": {
      "optaId": "3hht0os2uzu234yq550i3fbe2",
      "heimPlayer": {
        "id": "101318327",
        "team_id": "597",
        "person": {
          "id": "605363",
          "name": "Marc Casadó",
          "firstname": "",
          "surname": "Marc Casadó",
          "fullname": "Marc Casadó Torras",
          "gender": "male",
          "birthday": "14.09.2003",
          "height": "172",
          "weight": "66",
          "person_detail": {
            "id": "586621",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Sant Pere de Vilamajor",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "10.03.2026 22:29",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "3hht0os2uzu234yq550i3fbe2",
        "firstName": "Marc",
        "lastName": "Casadó Torras",
        "shortFirstName": "Marc",
        "shortLastName": "Casadó",
        "matchName": "Marc Casadó",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "605439": {
      "optaId": "84d0jugdidn3if1iqx4ynuxw4",
      "heimPlayer": {
        "id": "101489441",
        "team_id": "24",
        "person": {
          "id": "605439",
          "name": "Leon Avdullahu",
          "firstname": "Leon",
          "surname": "Avdullahu",
          "fullname": "Leon Avdullahu",
          "gender": "male",
          "birthday": "23.02.2004",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "586697",
            "position_1": "7",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Solothurn",
            "died": "no"
          }
        },
        "created": "14.03.2026 14:24",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "84d0jugdidn3if1iqx4ynuxw4",
        "firstName": "Leon",
        "lastName": "Avdullahu",
        "shortFirstName": "Leon",
        "shortLastName": "Avdullahu",
        "matchName": "L. Avdullahu",
        "shirtNumber": 7,
        "position": "Defensive Midfielder",
        "positionSide": "Centre",
        "formationPlace": "4"
      }
    },
    "606043": {
      "optaId": "a71n80h977h7fu99ftnri5zsa",
      "heimPlayer": {
        "id": "101812442",
        "team_id": "1457",
        "person": {
          "id": "606043",
          "name": "Bradley Barcola",
          "firstname": "Bradley",
          "surname": "Barcola",
          "fullname": "Bradley Jean-Manuel Essolisam Addo Barcola",
          "gender": "male",
          "birthday": "02.09.2002",
          "height": "182",
          "weight": "73",
          "person_detail": {
            "id": "587295",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Lyon",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "a71n80h977h7fu99ftnri5zsa",
        "firstName": "Bradley Jean-Manuel Essolisam Addo",
        "lastName": "Barcola",
        "shortFirstName": "Bradley",
        "shortLastName": "Barcola",
        "matchName": "B. Barcola",
        "shirtNumber": 29,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "606256": {
      "optaId": "5es43b4a7fv0lkmp63dj439ey",
      "heimPlayer": {
        "id": "98850271",
        "team_id": "162",
        "person": {
          "id": "606256",
          "name": "Giuliano Simeone",
          "firstname": "Giuliano",
          "surname": "Simeone",
          "fullname": "Giuliano Simeone Baldini",
          "gender": "male",
          "birthday": "18.12.2002",
          "height": "173",
          "weight": "72",
          "person_detail": {
            "id": "587505",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Roma",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "21.01.2026 17:39",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "5es43b4a7fv0lkmp63dj439ey",
        "firstName": "Giuliano",
        "lastName": "Simeone Baldini",
        "shortFirstName": "Giuliano",
        "shortLastName": "Simeone",
        "matchName": "G. Simeone",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "606812": {
      "optaId": "2dxsntw3djezptdjqzu0oxi7e",
      "heimPlayer": {
        "id": "100266097",
        "team_id": "2086",
        "person": {
          "id": "606812",
          "name": "Kevin Paredes",
          "firstname": "Kevin",
          "surname": "Paredes",
          "fullname": "Kevin Alexander Paredes",
          "gender": "male",
          "birthday": "07.05.2003",
          "height": "175",
          "weight": "61",
          "person_detail": {
            "id": "588054",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "South Riding, VA",
            "died": "no"
          }
        },
        "created": "21.02.2026 16:53",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "2dxsntw3djezptdjqzu0oxi7e",
        "firstName": "Kevin Alexander",
        "lastName": "Paredes",
        "shortFirstName": "Kevin",
        "shortLastName": "Paredes",
        "matchName": "K. Paredes",
        "shirtNumber": 40,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "606889": {
      "optaId": "dgjl6ks0r7lbh09fe8cuwj7ro",
      "heimPlayer": {
        "id": "101821868",
        "team_id": "373",
        "person": {
          "id": "606889",
          "name": "Roméo Lavia",
          "firstname": "Roméo",
          "surname": "Lavia",
          "fullname": "Roméo Lavia",
          "gender": "male",
          "birthday": "06.01.2004",
          "height": "181",
          "weight": "70",
          "person_detail": {
            "id": "588131",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Bruxelles",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "17.03.2026 22:16",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "dgjl6ks0r7lbh09fe8cuwj7ro",
        "firstName": "Roméo",
        "lastName": "Lavia",
        "shortFirstName": "Roméo",
        "shortLastName": "Lavia",
        "matchName": "R. Lavia",
        "shirtNumber": 45,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "606939": {
      "optaId": "7gwm8sjtl2vyfeh6mio8ve9ec",
      "heimPlayer": {
        "id": "101975954",
        "team_id": "9",
        "person": {
          "id": "606939",
          "name": "Rav van den Berg",
          "firstname": "Rav",
          "surname": "van den Berg",
          "fullname": "Rav van den Berg",
          "gender": "male",
          "birthday": "07.07.2004",
          "height": "191",
          "weight": "73",
          "person_detail": {
            "id": "588181",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Zwolle",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "7gwm8sjtl2vyfeh6mio8ve9ec",
        "firstName": "Rav Wiebe",
        "lastName": "van den Berg",
        "shortFirstName": "Rav",
        "shortLastName": "van den Berg",
        "matchName": "R. van den Berg",
        "shirtNumber": 33,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "606979": {
      "optaId": "a15xetizb10ilu9v9inuttqwa",
      "heimPlayer": {
        "id": "101868206",
        "team_id": "853",
        "person": {
          "id": "606979",
          "name": "Eren Elmalı",
          "firstname": "Eren",
          "surname": "Elmalı",
          "fullname": "Evren Eren Elmalı",
          "gender": "male",
          "birthday": "07.07.2000",
          "height": "183",
          "weight": "76",
          "person_detail": {
            "id": "588221",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "İstanbul",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.03.2026 22:33",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "a15xetizb10ilu9v9inuttqwa",
        "firstName": "Evren Eren",
        "lastName": "Elmalı",
        "shortFirstName": "Eren",
        "shortLastName": "Elmali",
        "matchName": "E. Elmalı",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "608000": {
      "optaId": "adi6l78sdvet408eho4fi4xk9",
      "heimPlayer": {
        "id": "101972927",
        "team_id": "2086",
        "person": {
          "id": "608000",
          "name": "Vinicius Souza",
          "firstname": "",
          "surname": "Vinicius Souza",
          "fullname": "Vinicius de Souza Costa",
          "gender": "male",
          "birthday": "17.06.1999",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "589190",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Rio de Janeiro",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "adi6l78sdvet408eho4fi4xk9",
        "firstName": "Vinicius",
        "lastName": "de Souza Costa",
        "shortFirstName": "Vinicius",
        "shortLastName": "de Souza Costa",
        "knownName": "Vinicius Souza",
        "matchName": "Vinicius Souza",
        "shirtNumber": 5,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "608213": {
      "optaId": "929ho421g2zacylfc97m23uac",
      "heimPlayer": {
        "id": "101812430",
        "team_id": "1457",
        "person": {
          "id": "608213",
          "name": "João Neves",
          "firstname": "",
          "surname": "João Neves",
          "fullname": "João Pedro Goncalves Neves",
          "gender": "male",
          "birthday": "27.09.2004",
          "height": "174",
          "weight": "66",
          "person_detail": {
            "id": "589397",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Tavira",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "87"
      },
      "optaPlayer": {
        "playerId": "929ho421g2zacylfc97m23uac",
        "firstName": "João Pedro",
        "lastName": "Gonçalves Neves",
        "shortFirstName": "João Pedro",
        "shortLastName": "Gonçalves Neves",
        "knownName": "João Neves",
        "matchName": "João Neves",
        "shirtNumber": 87,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "608395": {
      "optaId": "f4p22zbcs9l5dwhvqg6wstmcq",
      "heimPlayer": {
        "id": "100521616",
        "team_id": "1731",
        "person": {
          "id": "608395",
          "name": "Andreas Schjelderup",
          "firstname": "Andreas",
          "surname": "Schjelderup",
          "fullname": "Andreas Rædergård Schjelderup",
          "gender": "male",
          "birthday": "01.06.2004",
          "height": "176",
          "weight": "69",
          "person_detail": {
            "id": "589577",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Bodø",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "f4p22zbcs9l5dwhvqg6wstmcq",
        "firstName": "Andreas",
        "lastName": "Rædergård Schjelderup",
        "shortFirstName": "Andreas",
        "shortLastName": "Schjelderup",
        "matchName": "A. Schjelderup",
        "shirtNumber": 21,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "608397": {
      "optaId": "2k8bmlxzt0qi7divtxye0a5ii",
      "heimPlayer": {
        "id": "91177766",
        "team_id": "2134",
        "person": {
          "id": "608397",
          "name": "Isak Hansen-Aarøen",
          "firstname": "Isak",
          "surname": "Hansen-Aarøen",
          "fullname": "Isak Hansen-Aarøen",
          "gender": "male",
          "birthday": "22.08.2004",
          "height": "173",
          "weight": "67",
          "person_detail": {
            "id": "589579",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Tromsø",
            "died": "no"
          }
        },
        "created": "23.08.2025 17:18",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "2k8bmlxzt0qi7divtxye0a5ii",
        "firstName": "Isak",
        "lastName": "Hansen-Aarøen",
        "shortFirstName": "Isak",
        "shortLastName": "Hansen-Aarøen",
        "matchName": "I. Hansen-Aarøen",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "608587": {
      "optaId": "dvic19ojqq6erwene0ijta61g",
      "heimPlayer": {
        "id": "100351048",
        "team_id": "253",
        "person": {
          "id": "608587",
          "name": "Kōta Takai",
          "firstname": "Kōta",
          "surname": "Takai",
          "fullname": "Kōta Takai",
          "gender": "male",
          "birthday": "04.09.2004",
          "height": "192",
          "weight": "90",
          "person_detail": {
            "id": "589766",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Yokohama",
            "died": "no"
          }
        },
        "created": "22.02.2026 14:19",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "dvic19ojqq6erwene0ijta61g",
        "firstName": "Kota",
        "lastName": "Takai",
        "shortFirstName": "Kota",
        "shortLastName": "Takai",
        "matchName": "K. Takai",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "608721": {
      "optaId": "8i46yzejeiwdmz0tywmy42o2y",
      "heimPlayer": {
        "id": "101855711",
        "team_id": "1355",
        "person": {
          "id": "608721",
          "name": "Lewis Hall",
          "firstname": "Lewis",
          "surname": "Hall",
          "fullname": "Lewis Kieran Hall",
          "gender": "male",
          "birthday": "08.09.2004",
          "height": "179",
          "weight": "71",
          "person_detail": {
            "id": "589900",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Slough",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 17:43",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "8i46yzejeiwdmz0tywmy42o2y",
        "firstName": "Lewis Kieran",
        "lastName": "Hall",
        "shortFirstName": "Lewis",
        "shortLastName": "Hall",
        "matchName": "L. Hall",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "610035": {
      "optaId": "90wsjxdc3ibvah5gm9tnsjwbu",
      "heimPlayer": {
        "id": "101925503",
        "team_id": "29680",
        "person": {
          "id": "610035",
          "name": "Brajan Gruda",
          "firstname": "Brajan",
          "surname": "Gruda",
          "fullname": "Brajan Gruda",
          "gender": "male",
          "birthday": "31.05.2004",
          "height": "178",
          "weight": "70",
          "person_detail": {
            "id": "591175",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Speyer",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "90wsjxdc3ibvah5gm9tnsjwbu",
        "firstName": "Brajan",
        "lastName": "Gruda",
        "shortFirstName": "Brajan",
        "shortLastName": "Gruda",
        "matchName": "B. Gruda",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "610044": {
      "optaId": "6teffw7m19t1b3auxy22y4m0a",
      "heimPlayer": {
        "id": "97534282",
        "team_id": "24",
        "person": {
          "id": "610044",
          "name": "Umut Tohumcu",
          "firstname": "Umut",
          "surname": "Tohumcu",
          "fullname": "Umut Deger Tohumcu",
          "gender": "male",
          "birthday": "11.08.2004",
          "height": "175",
          "weight": "71",
          "person_detail": {
            "id": "591184",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Offenburg",
            "died": "no"
          }
        },
        "created": "07.12.2025 19:03",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "6teffw7m19t1b3auxy22y4m0a",
        "firstName": "Umut Deger",
        "lastName": "Tohumcu",
        "shortFirstName": "Umut",
        "shortLastName": "Tohumcu",
        "matchName": "U. Tohumcu",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "610567": {
      "optaId": "5i2tc06romjqx7a7wlu1iye7e",
      "heimPlayer": {
        "id": "100521598",
        "team_id": "1731",
        "person": {
          "id": "610567",
          "name": "Samuel Dahl",
          "firstname": "Samuel",
          "surname": "Dahl",
          "fullname": "Samuel Elias Dahl",
          "gender": "male",
          "birthday": "04.03.2003",
          "height": "174",
          "weight": "68",
          "person_detail": {
            "id": "591695",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Västerås",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "5i2tc06romjqx7a7wlu1iye7e",
        "firstName": "Samuel Elias",
        "lastName": "Dahl",
        "shortFirstName": "Samuel",
        "shortLastName": "Dahl",
        "matchName": "S. Dahl",
        "shirtNumber": 26,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "610580": {
      "optaId": "ekl9e2t93vow1buusgdcs3giy",
      "heimPlayer": {
        "id": "94894738",
        "team_id": "530",
        "person": {
          "id": "610580",
          "name": "Aurèle Amenda",
          "firstname": "Aurèle",
          "surname": "Amenda",
          "fullname": "Aurèle Florian Amenda",
          "gender": "male",
          "birthday": "31.07.2003",
          "height": "197",
          "weight": "90",
          "person_detail": {
            "id": "591708",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Biel/Bienne",
            "died": "no"
          },
          "country": [
            {
              "id": "183"
            }
          ]
        },
        "created": "22.10.2025 19:53",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "ekl9e2t93vow1buusgdcs3giy",
        "firstName": "Aurèle Florian",
        "lastName": "Amenda",
        "shortFirstName": "Aurèle",
        "shortLastName": "Amenda",
        "matchName": "A. Amenda",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "610927": {
      "optaId": "88nmn961vtb3bnt9v9rye1h0q",
      "heimPlayer": {
        "id": "101814734",
        "team_id": "1776",
        "person": {
          "id": "610927",
          "name": "Zeno Debast",
          "firstname": "Zeno",
          "surname": "Debast",
          "fullname": "Zeno Koen Debast",
          "gender": "male",
          "birthday": "24.10.2003",
          "height": "191",
          "weight": "76",
          "person_detail": {
            "id": "592051",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Halle",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "17.03.2026 20:07",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "88nmn961vtb3bnt9v9rye1h0q",
        "firstName": "Zeno Koen",
        "lastName": "Debast",
        "shortFirstName": "Zeno",
        "shortLastName": "Debast",
        "matchName": "Z. Debast",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "612855": {
      "optaId": "eg09wg0vofjk0hqg04d0m1kwk",
      "heimPlayer": {
        "id": "96648955",
        "team_id": "594",
        "person": {
          "id": "612855",
          "name": "Elias Saad",
          "firstname": "Elias",
          "surname": "Saad",
          "fullname": "Elias Saad",
          "gender": "male",
          "birthday": "27.12.1999",
          "height": "185",
          "weight": "72",
          "person_detail": {
            "id": "593929",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "22.11.2025 16:55",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "eg09wg0vofjk0hqg04d0m1kwk",
        "firstName": "Elias",
        "lastName": "Saad",
        "shortFirstName": "Elias",
        "shortLastName": "Saad",
        "matchName": "E. Saad",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "613296": {
      "optaId": "dvqog8r05iw9zqr68l4fcnre2",
      "heimPlayer": {
        "id": "102122996",
        "team_id": "21",
        "person": {
          "id": "613296",
          "name": "Nikolas Veratschnig",
          "firstname": "Nikolas",
          "surname": "Veratschnig",
          "fullname": "Nikolas Konrad Veratschnig",
          "gender": "male",
          "birthday": "24.01.2003",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "594352",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Villach",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:58",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "dvqog8r05iw9zqr68l4fcnre2",
        "firstName": "Nikolas Konrad",
        "lastName": "Veratschnig",
        "shortFirstName": "Nikolas",
        "shortLastName": "Veratschnig",
        "matchName": "N. Veratschnig",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "613740": {
      "optaId": "cr4e64yry1ttwcjxh2klb4ui2",
      "heimPlayer": {
        "id": "98850697",
        "team_id": "530",
        "person": {
          "id": "613740",
          "name": "Nathaniel Brown",
          "firstname": "Nathaniel",
          "surname": "Brown",
          "fullname": "Nathaniel Brown",
          "gender": "male",
          "birthday": "16.06.2003",
          "height": "180",
          "weight": "60",
          "person_detail": {
            "id": "594772",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Amberg",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "cr4e64yry1ttwcjxh2klb4ui2",
        "firstName": "Nathaniel",
        "lastName": "Brown",
        "shortFirstName": "Nathaniel",
        "shortLastName": "Brown",
        "matchName": "N. Brown",
        "shirtNumber": 21,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "614045": {
      "optaId": "7ngbzn51z20j8s1drzdtwiove",
      "heimPlayer": {
        "id": "102029285",
        "team_id": "943",
        "person": {
          "id": "614045",
          "name": "Rayan Philippe",
          "firstname": "Rayan",
          "surname": "Philippe",
          "fullname": "Rayan Philippe",
          "gender": "male",
          "birthday": "23.10.2000",
          "height": "182",
          "weight": "78",
          "person_detail": {
            "id": "595034",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Nice",
            "died": "no"
          }
        },
        "extra_minute": "1",
        "created": "21.03.2026 20:20",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "7ngbzn51z20j8s1drzdtwiove",
        "firstName": "Rayan",
        "lastName": "Philippe",
        "shortFirstName": "Rayan",
        "shortLastName": "Philippe",
        "matchName": "R. Philippe",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "614281": {
      "optaId": "92wxhgs6ts4tl5bv3heso90fe",
      "heimPlayer": {
        "id": "101976566",
        "team_id": "19",
        "person": {
          "id": "614281",
          "name": "Leopold Querfeld",
          "firstname": "Leopold",
          "surname": "Querfeld",
          "fullname": "Leopold Querfeld",
          "gender": "male",
          "birthday": "20.12.2003",
          "height": "190",
          "weight": "83",
          "person_detail": {
            "id": "595256",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Wien",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "92wxhgs6ts4tl5bv3heso90fe",
        "firstName": "Leopold",
        "lastName": "Querfeld",
        "shortFirstName": "Leopold",
        "shortLastName": "Querfeld",
        "matchName": "L. Querfeld",
        "shirtNumber": 14,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "614733": {
      "optaId": "7smbk83rqjkkcqqduw4vyefx0",
      "heimPlayer": {
        "id": "102026537",
        "team_id": "943",
        "person": {
          "id": "614733",
          "name": "Damion Downs",
          "firstname": "Damion",
          "surname": "Downs",
          "fullname": "Damion Lamar Downs",
          "gender": "male",
          "birthday": "06.07.2004",
          "height": "192",
          "weight": "80",
          "person_detail": {
            "id": "595706",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Werneck",
            "died": "no"
          }
        },
        "created": "21.03.2026 19:56",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "7smbk83rqjkkcqqduw4vyefx0",
        "firstName": "Damion Lamar",
        "lastName": "Downs",
        "shortFirstName": "Damion",
        "shortLastName": "Downs",
        "matchName": "D. Downs",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "614767": {
      "optaId": "4a59itr8bwm9auhz9f2dno104",
      "heimPlayer": {
        "id": "98850703",
        "team_id": "530",
        "person": {
          "id": "614767",
          "name": "Can Uzun",
          "firstname": "Can",
          "surname": "Uzun",
          "fullname": "Can Yılmaz Uzun",
          "gender": "male",
          "birthday": "11.11.2005",
          "height": "186",
          "weight": "67",
          "person_detail": {
            "id": "595740",
            "position_1": "8",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Regensburg",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "4a59itr8bwm9auhz9f2dno104",
        "firstName": "Can Yılmaz",
        "lastName": "Uzun",
        "shortFirstName": "Can",
        "shortLastName": "Uzun",
        "matchName": "C. Uzun",
        "shirtNumber": 42,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "615546": {
      "optaId": "6n54br4iwdggqvid7oirzfn8q",
      "heimPlayer": {
        "id": "102134945",
        "team_id": "2076",
        "person": {
          "id": "615546",
          "name": "Lorenz Assignon",
          "firstname": "Lorenz",
          "surname": "Assignon",
          "fullname": "Lorenz Assignon",
          "gender": "male",
          "birthday": "22.06.2000",
          "height": "181",
          "weight": "78",
          "person_detail": {
            "id": "596513",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Grasse",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "6n54br4iwdggqvid7oirzfn8q",
        "firstName": "Lorenz",
        "lastName": "Assignon",
        "shortFirstName": "Lorenz",
        "shortLastName": "Assignon",
        "matchName": "L. Assignon",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "615548": {
      "optaId": "bamobogg0wjnxd43nxunt3h4a",
      "heimPlayer": {
        "id": "102006212",
        "team_id": "943",
        "person": {
          "id": "615548",
          "name": "Warmed Omari",
          "firstname": "Warmed",
          "surname": "Omari",
          "fullname": "Warmed Omari",
          "gender": "male",
          "birthday": "23.04.2000",
          "height": "188",
          "weight": "74",
          "person_detail": {
            "id": "596515",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bandraboua",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "bamobogg0wjnxd43nxunt3h4a",
        "firstName": "Warmed",
        "lastName": "Omari",
        "shortFirstName": "Warmed",
        "shortLastName": "Omari",
        "matchName": "W. Omari",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "616003": {
      "optaId": "89s9fm31pcfq7l28kc2kad4kq",
      "heimPlayer": {
        "id": "99954523",
        "team_id": "9",
        "person": {
          "id": "616003",
          "name": "Denis Huseinbašić",
          "firstname": "Denis",
          "surname": "Huseinbašić",
          "fullname": "Denis Huseinbašić",
          "gender": "male",
          "birthday": "03.07.2001",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "596964",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Erbach",
            "died": "no"
          }
        },
        "created": "14.02.2026 20:12",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "89s9fm31pcfq7l28kc2kad4kq",
        "firstName": "Denis",
        "lastName": "Huseinbašić",
        "shortFirstName": "Denis",
        "shortLastName": "Huseinbasic",
        "matchName": "D. Huseinbašić",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "616880": {
      "optaId": "6go1e6kiezmwexizbpo7pp0yc",
      "heimPlayer": {
        "id": "101976563",
        "team_id": "19",
        "person": {
          "id": "616880",
          "name": "Livan Burcu",
          "firstname": "Livan",
          "surname": "Burcu",
          "fullname": "Livan Baha Burcu",
          "gender": "male",
          "birthday": "28.09.2004",
          "height": "178",
          "weight": "68",
          "person_detail": {
            "id": "597817",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "6go1e6kiezmwexizbpo7pp0yc",
        "firstName": "Livan Baha",
        "lastName": "Burcu",
        "shortFirstName": "Livan",
        "shortLastName": "Burcu",
        "matchName": "L. Burcu",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "617191": {
      "optaId": "adcmwodw7raphk57z8m46f97u",
      "heimPlayer": {
        "id": "98575729",
        "team_id": "530",
        "person": {
          "id": "617191",
          "name": "Younes Ebnoutalib",
          "firstname": "Younes",
          "surname": "Ebnoutalib",
          "fullname": "Younes Ebnoutalib",
          "gender": "male",
          "birthday": "13.09.2003",
          "height": "191",
          "weight": "82",
          "person_detail": {
            "id": "598115",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          }
        },
        "created": "13.01.2026 17:16",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "adcmwodw7raphk57z8m46f97u",
        "firstName": "Younes",
        "lastName": "Ebnoutalib",
        "shortFirstName": "Younes",
        "shortLastName": "Ebnoutalib",
        "matchName": "Y. Ebnoutalib",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "617320": {
      "optaId": "9itdoft61idx19f23g7xzxpm",
      "heimPlayer": {
        "id": "99659941",
        "team_id": "24",
        "person": {
          "id": "617320",
          "name": "Luka Đurić",
          "firstname": "Luka",
          "surname": "Đurić",
          "fullname": "Luka Đurić",
          "gender": "male",
          "birthday": "18.06.2003",
          "height": "180",
          "weight": "74",
          "person_detail": {
            "id": "598243",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Sinsheim",
            "died": "no"
          }
        },
        "created": "08.02.2026 19:11",
        "shirtnumber": "48"
      },
      "optaPlayer": {
        "playerId": "9itdoft61idx19f23g7xzxpm",
        "firstName": "Luka",
        "lastName": "Đurić",
        "shortFirstName": "Luka",
        "shortLastName": "Duric",
        "matchName": "L. Đurić",
        "shirtNumber": 48,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "617427": {
      "optaId": "atj6u4qul0o2ca57etbmes07o",
      "heimPlayer": {
        "id": "100521532",
        "team_id": "1545",
        "person": {
          "id": "617427",
          "name": "Raúl Asencio",
          "firstname": "",
          "surname": "Raúl Asencio",
          "fullname": "Raúl Asencio del Rosario",
          "gender": "male",
          "birthday": "13.02.2003",
          "height": "184",
          "weight": "72",
          "person_detail": {
            "id": "598342",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Las Palmas de Gran Canaria",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "atj6u4qul0o2ca57etbmes07o",
        "firstName": "Raúl",
        "lastName": "Asencio del Rosario",
        "shortFirstName": "Raúl",
        "shortLastName": "Asencio",
        "matchName": "Raúl Asencio",
        "shirtNumber": 17,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "617437": {
      "optaId": "a4kw8u4dqsslfwe1ux08lbmc",
      "heimPlayer": {
        "id": "100521526",
        "team_id": "1545",
        "person": {
          "id": "617437",
          "name": "Álvaro Carreras",
          "firstname": "",
          "surname": "Álvaro Carreras",
          "fullname": "Álvaro Fernández Carreras",
          "gender": "male",
          "birthday": "23.03.2003",
          "height": "186",
          "weight": "78",
          "person_detail": {
            "id": "598352",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Ferrol",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "a4kw8u4dqsslfwe1ux08lbmc",
        "firstName": "Álvaro",
        "lastName": "Fernández Carreras",
        "shortFirstName": "Álvaro",
        "shortLastName": "Carreras",
        "matchName": "Álvaro Carreras",
        "shirtNumber": 18,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "617545": {
      "optaId": "4x854vpovag131b2kdutv4qju",
      "heimPlayer": {
        "id": "99153004",
        "team_id": "2102",
        "person": {
          "id": "617545",
          "name": "Sergi Cardona",
          "firstname": "",
          "surname": "Sergi Cardona",
          "fullname": "Sergi Cardona Bermúdez",
          "gender": "male",
          "birthday": "08.07.1999",
          "height": "186",
          "weight": "75",
          "person_detail": {
            "id": "598460",
            "position_1": "3",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Lloret de Mar",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "4x854vpovag131b2kdutv4qju",
        "firstName": "Sergi",
        "lastName": "Cardona Bermúdez",
        "shortFirstName": "Sergi",
        "shortLastName": "Cardona",
        "matchName": "Sergi Cardona",
        "shirtNumber": 23,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "618992": {
      "optaId": "6tzrulqvl1ytj9907ueeanskq",
      "heimPlayer": {
        "id": "102006224",
        "team_id": "943",
        "person": {
          "id": "618992",
          "name": "Philip Otele",
          "firstname": "Philip",
          "surname": "Otele",
          "fullname": "Philip Porwei Otele",
          "gender": "male",
          "birthday": "15.04.1999",
          "height": "178",
          "weight": "80",
          "person_detail": {
            "id": "599892",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Port Harcourt",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "6tzrulqvl1ytj9907ueeanskq",
        "firstName": "Philip Porwei",
        "lastName": "Otele",
        "shortFirstName": "Philip",
        "shortLastName": "Otele",
        "matchName": "P. Otele",
        "shirtNumber": 27,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "619933": {
      "optaId": "64vve6gzn5mwodos6ynufwa5m",
      "heimPlayer": {
        "id": "101976557",
        "team_id": "19",
        "person": {
          "id": "619933",
          "name": "Aljoscha Kemlein",
          "firstname": "Aljoscha",
          "surname": "Kemlein",
          "fullname": "Aljoscha Kemlein",
          "gender": "male",
          "birthday": "02.08.2004",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "600739",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:29",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "64vve6gzn5mwodos6ynufwa5m",
        "firstName": "Aljoscha",
        "lastName": "Kemlein",
        "shortFirstName": "Aljoscha",
        "shortLastName": "Kemlein",
        "matchName": "A. Kemlein",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "11"
      }
    },
    "620292": {
      "optaId": "bytrobr8rfp9zwbxzopr4vgno",
      "heimPlayer": {
        "id": "102140417",
        "team_id": "1639",
        "person": {
          "id": "620292",
          "name": "Derry Scherhant",
          "firstname": "Derry",
          "surname": "Scherhant",
          "fullname": "Derry Lionel Scherhant",
          "gender": "male",
          "birthday": "10.11.2002",
          "height": "185",
          "weight": "78",
          "person_detail": {
            "id": "601096",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:56",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "bytrobr8rfp9zwbxzopr4vgno",
        "firstName": "Derry Lionel",
        "lastName": "Scherhant",
        "shortFirstName": "Derry",
        "shortLastName": "Scherhant",
        "matchName": "D. Scherhant",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "620412": {
      "optaId": "65v1s740zfmpwkc0z1v3aisd0",
      "heimPlayer": {
        "id": "101936519",
        "team_id": "24",
        "person": {
          "id": "620412",
          "name": "Muhammed Damar",
          "firstname": "Muhammed",
          "surname": "Damar",
          "fullname": "Muhammed Mehmet Damar",
          "gender": "male",
          "birthday": "09.04.2004",
          "height": "185",
          "weight": "73",
          "person_detail": {
            "id": "601216",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "both",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:11",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "65v1s740zfmpwkc0z1v3aisd0",
        "firstName": "Muhammed Mehmet",
        "lastName": "Damar",
        "shortFirstName": "Muhammed",
        "shortLastName": "Damar",
        "matchName": "M. Damar",
        "shirtNumber": 10,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "620446": {
      "optaId": "b5ovydnz8s9gf0nkwofutr7ys",
      "heimPlayer": {
        "id": "102003167",
        "team_id": "253",
        "person": {
          "id": "620446",
          "name": "Lukas Ullrich",
          "firstname": "Lukas",
          "surname": "Ullrich",
          "fullname": "Lukas Ullrich",
          "gender": "male",
          "birthday": "16.03.2004",
          "height": "180",
          "weight": "73",
          "person_detail": {
            "id": "601250",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:14",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "b5ovydnz8s9gf0nkwofutr7ys",
        "firstName": "Lukas",
        "lastName": "Ullrich",
        "shortFirstName": "Lukas",
        "shortLastName": "Ullrich",
        "matchName": "L. Ullrich",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "620671": {
      "optaId": "adb8skc3qbvgunhzd9651lij8",
      "heimPlayer": {
        "id": "100521949",
        "team_id": "136",
        "person": {
          "id": "620671",
          "name": "Vanderson",
          "firstname": "",
          "surname": "Vanderson",
          "fullname": "Vanderson de Oliveira Campos",
          "gender": "male",
          "birthday": "21.06.2001",
          "height": "173",
          "weight": "74",
          "person_detail": {
            "id": "601475",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Rondonópolis",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "adb8skc3qbvgunhzd9651lij8",
        "firstName": "Vanderson",
        "lastName": "de Oliveira Campos",
        "shortFirstName": "Vanderson",
        "shortLastName": "de Oliveira Campos",
        "knownName": "Vanderson",
        "matchName": "Vanderson",
        "shirtNumber": 2,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "620719": {
      "optaId": "3ub05nnpt9o7s387z6oj8vf56",
      "heimPlayer": {
        "id": "99159031",
        "team_id": "162",
        "person": {
          "id": "620719",
          "name": "Johnny Cardoso",
          "firstname": "Johnny",
          "surname": "Cardoso",
          "fullname": "João Lucas de Souza Cardoso",
          "gender": "male",
          "birthday": "20.09.2001",
          "height": "186",
          "weight": "78",
          "person_detail": {
            "id": "601523",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Denville, NY",
            "died": "no"
          },
          "country": [
            {
              "id": "229"
            }
          ]
        },
        "created": "28.01.2026 22:23",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "3ub05nnpt9o7s387z6oj8vf56",
        "firstName": "João Lucas",
        "lastName": "de Souza Cardoso",
        "shortFirstName": "Johnny",
        "shortLastName": "Cardoso",
        "matchName": "J. Cardoso",
        "shirtNumber": 5,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "620830": {
      "optaId": "7rfw6pyjslb3p5q7gmoj1ysmi",
      "heimPlayer": {
        "id": "100492462",
        "team_id": "1052",
        "person": {
          "id": "620830",
          "name": "Luis Henrique",
          "firstname": "",
          "surname": "Luis Henrique",
          "fullname": "Luis Henrique Tomaz de Lima",
          "gender": "male",
          "birthday": "14.12.2001",
          "height": "181",
          "weight": "78",
          "person_detail": {
            "id": "601633",
            "position_1": "9",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "João Pessoa",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "7rfw6pyjslb3p5q7gmoj1ysmi",
        "firstName": "Luis Henrique Tomaz",
        "lastName": "de Lima",
        "shortFirstName": "Luis Henrique Tomaz",
        "shortLastName": "de Lima",
        "knownName": "Luis Henrique",
        "matchName": "Luis Henrique",
        "shirtNumber": 11,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "620909": {
      "optaId": "9rsb1aobamti72d8wm5y6qz56",
      "heimPlayer": {
        "id": "99154456",
        "team_id": "13914",
        "person": {
          "id": "620909",
          "name": "Jajá",
          "firstname": "",
          "surname": "Jajá",
          "fullname": "Jair Diego Alves de Brito",
          "gender": "male",
          "birthday": "15.04.2001",
          "height": "180",
          "weight": "71",
          "person_detail": {
            "id": "601712",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Catanduva",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "9rsb1aobamti72d8wm5y6qz56",
        "firstName": "Jair Diego",
        "lastName": "Alves de Brito",
        "shortFirstName": "Jair Diego",
        "shortLastName": "Alves de Brito",
        "knownName": "Jajá",
        "matchName": "Jajá",
        "shirtNumber": 11,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "621016": {
      "optaId": "6wpahdttyk7458xipbx7lk1lg",
      "heimPlayer": {
        "id": "101972435",
        "team_id": "5",
        "person": {
          "id": "621016",
          "name": "Luca Kerber",
          "firstname": "Luca",
          "surname": "Kerber",
          "fullname": "Luca Kerber",
          "gender": "male",
          "birthday": "10.03.2002",
          "height": "184",
          "weight": "77",
          "person_detail": {
            "id": "601819",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Dillingen",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "6wpahdttyk7458xipbx7lk1lg",
        "firstName": "Luca",
        "lastName": "Kerber",
        "shortFirstName": "Luca",
        "shortLastName": "Kerber",
        "matchName": "L. Kerber",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "621314": {
      "optaId": "603w7gqz9xm0ines0oq74qwb8",
      "heimPlayer": {
        "id": "99158728",
        "team_id": "17544",
        "person": {
          "id": "621314",
          "name": "Ricardinho",
          "firstname": "",
          "surname": "Ricardinho",
          "fullname": "Ricardo Viana Filho",
          "gender": "male",
          "birthday": "23.04.2001",
          "height": "181",
          "weight": "74",
          "person_detail": {
            "id": "602093",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Guarulhos",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 22:17",
        "shirtnumber": "99"
      },
      "optaPlayer": {
        "playerId": "603w7gqz9xm0ines0oq74qwb8",
        "firstName": "Ricardo",
        "lastName": "Viana Filho",
        "shortFirstName": "Ricardo",
        "shortLastName": "Viana Filho",
        "knownName": "Ricardinho",
        "matchName": "Ricardinho",
        "shirtNumber": 99,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "621385": {
      "optaId": "2945m6rjmwj1viq0a4k1sd0yc",
      "heimPlayer": {
        "id": "100493320",
        "team_id": "18670",
        "person": {
          "id": "621385",
          "name": "Dani Bolt",
          "firstname": "",
          "surname": "Dani Bolt",
          "fullname": "Daniel Lima de Castro",
          "gender": "male",
          "birthday": "18.06.1999",
          "height": "183",
          "weight": "73",
          "person_detail": {
            "id": "602163",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Rio de Janeiro - RJ",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "2945m6rjmwj1viq0a4k1sd0yc",
        "firstName": "Daniel",
        "lastName": "Lima de Castro",
        "shortFirstName": "Daniel",
        "shortLastName": "Lima de Castro",
        "knownName": "Dani Bolt",
        "matchName": "Dani Bolt",
        "shirtNumber": 18,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "621668": {
      "optaId": "7ocm7nugzwos59il1pm4eub8q",
      "heimPlayer": {
        "id": "101822621",
        "team_id": "127",
        "person": {
          "id": "621668",
          "name": "Gabriel Martinelli",
          "firstname": "",
          "surname": "Gabriel Martinelli",
          "fullname": "Gabriel Teodoro Martinelli Silva",
          "gender": "male",
          "birthday": "18.06.2001",
          "height": "178",
          "weight": "75",
          "person_detail": {
            "id": "602446",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Guarulhos",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.03.2026 22:25",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "7ocm7nugzwos59il1pm4eub8q",
        "firstName": "Gabriel Teodoro",
        "lastName": "Martinelli Silva",
        "shortFirstName": "Gabriel Teodoro",
        "shortLastName": "Martinelli Silva",
        "knownName": "Gabriel Martinelli",
        "matchName": "Gabriel Martinelli",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "621826": {
      "optaId": "cgsmk5437f466uoqvol7devze",
      "heimPlayer": {
        "id": "98857363",
        "team_id": "1502",
        "person": {
          "id": "621826",
          "name": "Ryan Flamingo",
          "firstname": "Ryan",
          "surname": "Flamingo",
          "fullname": "Ryan Flamingo",
          "gender": "male",
          "birthday": "31.12.2002",
          "height": "186",
          "weight": "71",
          "person_detail": {
            "id": "602601",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Blaricum",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "21.01.2026 22:35",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "cgsmk5437f466uoqvol7devze",
        "firstName": "Ryan",
        "lastName": "Flamingo",
        "shortFirstName": "Ryan",
        "shortLastName": "Flamingo",
        "matchName": "R. Flamingo",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "622075": {
      "optaId": "3uc9z96xvain84leorf4ls962",
      "heimPlayer": {
        "id": "101812001",
        "team_id": "373",
        "person": {
          "id": "622075",
          "name": "Moisés Caicedo",
          "firstname": "Moisés",
          "surname": "Caicedo",
          "fullname": "Moisés Isaac Caicedo Corozo",
          "gender": "male",
          "birthday": "02.11.2001",
          "height": "178",
          "weight": "73",
          "person_detail": {
            "id": "602842",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Santo Domingo",
            "died": "no"
          },
          "country": [
            {
              "id": "52"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "3uc9z96xvain84leorf4ls962",
        "firstName": "Moisés Isaac",
        "lastName": "Caicedo Corozo",
        "shortFirstName": "Moisés",
        "shortLastName": "Caicedo",
        "matchName": "M. Caicedo",
        "shirtNumber": 25,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "623967": {
      "optaId": "5054kfjkrimomrhilbe5j3xbe",
      "heimPlayer": {
        "id": "100125784",
        "team_id": "1094",
        "person": {
          "id": "623967",
          "name": "Juan Cabal",
          "firstname": "Juan",
          "surname": "Cabal",
          "fullname": "Juan David Cabal Murillo",
          "gender": "male",
          "birthday": "08.01.2001",
          "height": "186",
          "weight": "79",
          "person_detail": {
            "id": "604619",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Cali",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "17.02.2026 19:49",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "5054kfjkrimomrhilbe5j3xbe",
        "firstName": "Juan David",
        "lastName": "Cabal Murillo",
        "shortFirstName": "Juan",
        "shortLastName": "Cabal",
        "matchName": "J. Cabal",
        "shirtNumber": 32,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "629309": {
      "optaId": "cx3hbvqw7lw1j4r5k33l63dre",
      "heimPlayer": {
        "id": "96884536",
        "team_id": "1736",
        "person": {
          "id": "629309",
          "name": "Christos Zafeiris",
          "firstname": "Christos",
          "surname": "Zafeiris",
          "fullname": "Christos Zafeiris",
          "gender": "male",
          "birthday": "23.02.2003",
          "height": "173",
          "weight": "75",
          "person_detail": {
            "id": "609877",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Athina",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "25.11.2025 20:00",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "cx3hbvqw7lw1j4r5k33l63dre",
        "firstName": "Christos",
        "lastName": "Zafeiris",
        "shortFirstName": "Christos",
        "shortLastName": "Zafeiris",
        "matchName": "C. Zafeiris",
        "shirtNumber": 10,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "630981": {
      "optaId": "csqsdjsa4leo6z86qphjuectm",
      "heimPlayer": {
        "id": "101975960",
        "team_id": "9",
        "person": {
          "id": "630981",
          "name": "Cenk Özkaçar",
          "firstname": "Cenk",
          "surname": "Özkaçar",
          "fullname": "Cenk Özkaçar",
          "gender": "male",
          "birthday": "06.10.2000",
          "height": "190",
          "weight": "90",
          "person_detail": {
            "id": "611542",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "İzmir",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "csqsdjsa4leo6z86qphjuectm",
        "firstName": "Cenk",
        "lastName": "Özkacar",
        "shortFirstName": "Cenk",
        "shortLastName": "Özkacar",
        "matchName": "C. Özkacar",
        "shirtNumber": 39,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "631895": {
      "optaId": "4n18t6bixl6ba3bx76hym51qs",
      "heimPlayer": {
        "id": "99152254",
        "team_id": "64",
        "person": {
          "id": "631895",
          "name": "Anton Gaaei",
          "firstname": "Anton",
          "surname": "Gaaei",
          "fullname": "Anton Gaaei",
          "gender": "male",
          "birthday": "19.11.2002",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "612452",
            "position_1": "5",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Viborg",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "4n18t6bixl6ba3bx76hym51qs",
        "firstName": "Anton",
        "lastName": "Gaaei",
        "shortFirstName": "Anton",
        "shortLastName": "Gaaei",
        "matchName": "A. Gaaei",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "631984": {
      "optaId": "c4hif6j7tldh0w7oeq8v9pcve",
      "heimPlayer": {
        "id": "101812526",
        "team_id": "205",
        "person": {
          "id": "631984",
          "name": "Jarell Quansah",
          "firstname": "Jarell",
          "surname": "Quansah",
          "fullname": "Jarell Amorin Quansah",
          "gender": "male",
          "birthday": "29.01.2003",
          "height": "190",
          "weight": "80",
          "person_detail": {
            "id": "612540",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Warrington",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "c4hif6j7tldh0w7oeq8v9pcve",
        "firstName": "Jarell Amorin",
        "lastName": "Quansah",
        "shortFirstName": "Jarell",
        "shortLastName": "Quansah",
        "matchName": "J. Quansah",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "632094": {
      "optaId": "7ohgxs03szerp6mwiiv58ryay",
      "heimPlayer": {
        "id": "100120786",
        "team_id": "1094",
        "person": {
          "id": "632094",
          "name": "Andrea Cambiaso",
          "firstname": "Andrea",
          "surname": "Cambiaso",
          "fullname": "Andrea Cambiaso",
          "gender": "male",
          "birthday": "20.02.2000",
          "height": "182",
          "weight": "77",
          "person_detail": {
            "id": "612650",
            "position_1": "6",
            "position_2": "5",
            "preferred_side": "both",
            "birth_place": "Genoa",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "17.02.2026 17:43",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "7ohgxs03szerp6mwiiv58ryay",
        "firstName": "Andrea",
        "lastName": "Cambiaso",
        "shortFirstName": "Andrea",
        "shortLastName": "Cambiaso",
        "matchName": "A. Cambiaso",
        "shirtNumber": 27,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "632334": {
      "optaId": "9e7ybe0nsu3byq2tteey3zuy2",
      "heimPlayer": {
        "id": "99152557",
        "team_id": "162",
        "person": {
          "id": "632334",
          "name": "Pablo Barrios",
          "firstname": "",
          "surname": "Pablo Barrios",
          "fullname": "Pablo Barrios Rivas",
          "gender": "male",
          "birthday": "15.06.2003",
          "height": "181",
          "weight": "64",
          "person_detail": {
            "id": "612889",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "9e7ybe0nsu3byq2tteey3zuy2",
        "firstName": "Pablo",
        "lastName": "Barrios Rivas",
        "shortFirstName": "Pablo",
        "shortLastName": "Barrios",
        "matchName": "Pablo Barrios",
        "shirtNumber": 8,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "632338": {
      "optaId": "e5eiuko5p1yms97xndrvcr0bu",
      "heimPlayer": {
        "id": "101821859",
        "team_id": "373",
        "person": {
          "id": "632338",
          "name": "Alejandro Garnacho",
          "firstname": "Alejandro",
          "surname": "Garnacho",
          "fullname": "Alejandro Garnacho Ferreyra",
          "gender": "male",
          "birthday": "01.07.2004",
          "height": "180",
          "weight": "80",
          "person_detail": {
            "id": "612893",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "17.03.2026 22:15",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "e5eiuko5p1yms97xndrvcr0bu",
        "firstName": "Alejandro",
        "lastName": "Garnacho Ferreyra",
        "shortFirstName": "Alejandro",
        "shortLastName": "Garnacho",
        "matchName": "A. Garnacho",
        "shirtNumber": 49,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "633899": {
      "optaId": "4ftlhtels58lyzfluwofzwxuy",
      "heimPlayer": {
        "id": "101855585",
        "team_id": "597",
        "person": {
          "id": "633899",
          "name": "Pedri",
          "firstname": "",
          "surname": "Pedri",
          "fullname": "Pedro González López",
          "gender": "male",
          "birthday": "25.11.2002",
          "height": "174",
          "weight": "60",
          "person_detail": {
            "id": "614449",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Tegueste",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "4ftlhtels58lyzfluwofzwxuy",
        "firstName": "Pedro",
        "lastName": "González López",
        "shortFirstName": "Pedro",
        "shortLastName": "González López",
        "knownName": "Pedri",
        "matchName": "Pedri",
        "shirtNumber": 8,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "635303": {
      "optaId": "5f5e6wufz0x041bvqzor10k16",
      "heimPlayer": {
        "id": "100526782",
        "team_id": "1731",
        "person": {
          "id": "635303",
          "name": "Enzo Barrenechea",
          "firstname": "Enzo",
          "surname": "Barrenechea",
          "fullname": "Enzo Alan Tomás Barrenechea",
          "gender": "male",
          "birthday": "22.05.2001",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "615847",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Villa María",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "25.02.2026 22:45",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "5f5e6wufz0x041bvqzor10k16",
        "firstName": "Enzo Alan Tomás",
        "lastName": "Barrenechea",
        "shortFirstName": "Enzo",
        "shortLastName": "Barrenechea",
        "matchName": "E. Barrenechea",
        "shirtNumber": 5,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "637209": {
      "optaId": "cmbd33qb8zs7wi7ryhy28yycq",
      "heimPlayer": {
        "id": "101607641",
        "team_id": "2134",
        "person": {
          "id": "637209",
          "name": "Keke Topp",
          "firstname": "Keke",
          "surname": "Topp",
          "fullname": "Keke Maximilian Topp",
          "gender": "male",
          "birthday": "25.03.2004",
          "height": "192",
          "weight": "81",
          "person_detail": {
            "id": "617728",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bremervörde",
            "died": "no"
          }
        },
        "created": "15.03.2026 14:15",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "cmbd33qb8zs7wi7ryhy28yycq",
        "firstName": "Keke Maximilian",
        "lastName": "Topp",
        "shortFirstName": "Keke",
        "shortLastName": "Topp",
        "matchName": "K. Topp",
        "shirtNumber": 9,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "637219": {
      "optaId": "7de0uy8a51bjehkrlq6iuioh6",
      "heimPlayer": {
        "id": "95785105",
        "team_id": "1418",
        "person": {
          "id": "637219",
          "name": "Diogo Nascimento",
          "firstname": "",
          "surname": "Diogo Nascimento",
          "fullname": "Diogo André Santos Nascimento",
          "gender": "male",
          "birthday": "02.11.2002",
          "height": "166",
          "weight": "66",
          "person_detail": {
            "id": "617738",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Leiria",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "04.11.2025 22:21",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "7de0uy8a51bjehkrlq6iuioh6",
        "firstName": "Diogo André",
        "lastName": "Santos Nascimento",
        "shortFirstName": "Diogo André",
        "shortLastName": "Santos Nascimento",
        "knownName": "Diogo Nascimento",
        "matchName": "Diogo Nascimento",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "637711": {
      "optaId": "d078o2hgm2fkdjz5vagzx9oq2",
      "heimPlayer": {
        "id": "100527247",
        "team_id": "1731",
        "person": {
          "id": "637711",
          "name": "Sidny Lopes Cabral",
          "firstname": "Sidny",
          "surname": "Lopes Cabral",
          "fullname": "Sidny Lopes Cabral",
          "gender": "male",
          "birthday": "18.09.2002",
          "height": "176",
          "weight": "76",
          "person_detail": {
            "id": "618222",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "both",
            "birth_place": "Rotterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "99"
            }
          ]
        },
        "extra_minute": "1",
        "created": "25.02.2026 22:51",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "d078o2hgm2fkdjz5vagzx9oq2",
        "firstName": "Sidny",
        "lastName": "Lopes Cabral",
        "shortFirstName": "Sidny",
        "shortLastName": "Lopes Cabral",
        "knownName": "Sidny Cabral",
        "matchName": "Sidny Cabral",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "638020": {
      "optaId": "8uj1pf52hctbd2uxjz4s4tnxm",
      "heimPlayer": {
        "id": "93646621",
        "team_id": "1731",
        "person": {
          "id": "638020",
          "name": "Henrique Araújo",
          "firstname": "",
          "surname": "Henrique Araújo",
          "fullname": "Henrique Pereira Araújo",
          "gender": "male",
          "birthday": "19.01.2002",
          "height": "182",
          "weight": "78",
          "person_detail": {
            "id": "618530",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Funchal",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "30.09.2025 22:47",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "8uj1pf52hctbd2uxjz4s4tnxm",
        "firstName": "Henrique",
        "lastName": "Pereira Araújo",
        "shortFirstName": "Henrique",
        "shortLastName": "Pereira Araújo",
        "knownName": "Henrique Araújo",
        "matchName": "Henrique Araújo",
        "shirtNumber": 39,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "638137": {
      "optaId": "1kmvf5y1wi6jysfkoqet28xnu",
      "heimPlayer": {
        "id": "100521610",
        "team_id": "1731",
        "person": {
          "id": "638137",
          "name": "Richard Ríos",
          "firstname": "Richard",
          "surname": "Ríos",
          "fullname": "Richard Ríos Montoya",
          "gender": "male",
          "birthday": "02.06.2000",
          "height": "187",
          "weight": "77",
          "person_detail": {
            "id": "618646",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Vegachí",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "1kmvf5y1wi6jysfkoqet28xnu",
        "firstName": "Richard",
        "lastName": "Ríos Montoya",
        "shortFirstName": "Richard",
        "shortLastName": "Ríos",
        "matchName": "R. Ríos",
        "shirtNumber": 20,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "638524": {
      "optaId": "aw83l7afhw2lhkg8qm7mbnms4",
      "heimPlayer": {
        "id": "95500426",
        "team_id": "253",
        "person": {
          "id": "638524",
          "name": "Jan Urbich",
          "firstname": "Jan",
          "surname": "Urbich",
          "fullname": "Jan Urbich",
          "gender": "male",
          "birthday": "23.06.2004",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "619033",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Wiesbaden",
            "died": "no"
          }
        },
        "created": "01.11.2025 17:15",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "aw83l7afhw2lhkg8qm7mbnms4",
        "firstName": "Jan",
        "lastName": "Urbich",
        "shortFirstName": "Jan",
        "shortLastName": "Urbich",
        "matchName": "J. Urbich",
        "shirtNumber": 40,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "638753": {
      "optaId": "9ocaoc4rmct3neemzpth5c6qc",
      "heimPlayer": {
        "id": "101817596",
        "team_id": "1776",
        "person": {
          "id": "638753",
          "name": "Souleymane Faye",
          "firstname": "Souleymane",
          "surname": "Faye",
          "fullname": "Souleymane Faye",
          "gender": "male",
          "birthday": "08.02.2003",
          "height": "179",
          "weight": "70",
          "person_detail": {
            "id": "619262",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Dakar",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "17.03.2026 21:09",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "9ocaoc4rmct3neemzpth5c6qc",
        "firstName": "Souleymane Mame",
        "lastName": "Faye",
        "shortFirstName": "Souleymane",
        "shortLastName": "Faye",
        "matchName": "S. Faye",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "638881": {
      "optaId": "8fzbg2qdd8d00nwn1kinqr71m",
      "heimPlayer": {
        "id": "101804561",
        "team_id": "1776",
        "person": {
          "id": "638881",
          "name": "Geny Catamo",
          "firstname": "Geny",
          "surname": "Catamo",
          "fullname": "Geny Cipriano Catamo",
          "gender": "male",
          "birthday": "26.01.2001",
          "height": "173",
          "weight": "71",
          "person_detail": {
            "id": "619390",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Maputo",
            "died": "no"
          },
          "country": [
            {
              "id": "139"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "8fzbg2qdd8d00nwn1kinqr71m",
        "firstName": "Geny",
        "lastName": "Cipriano Catamo",
        "shortFirstName": "Geny",
        "shortLastName": "Cipriano Catamo",
        "knownName": "Geny Catamo",
        "matchName": "Geny Catamo",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "639085": {
      "optaId": "d1e8em0pe47h68uq73h8aq1w4",
      "heimPlayer": {
        "id": "102122744",
        "team_id": "530",
        "person": {
          "id": "639085",
          "name": "Elias Baum",
          "firstname": "Elias",
          "surname": "Baum",
          "fullname": "Elias Niklas Baum",
          "gender": "male",
          "birthday": "26.10.2005",
          "height": "180",
          "weight": "77",
          "person_detail": {
            "id": "619590",
            "position_1": "5",
            "position_2": "3",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:54",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "d1e8em0pe47h68uq73h8aq1w4",
        "firstName": "Elias Niklas",
        "lastName": "Baum",
        "shortFirstName": "Elias",
        "shortLastName": "Baum",
        "matchName": "E. Baum",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "639844": {
      "optaId": "44i5i1fr0mw3mymdbepzkj9ck",
      "heimPlayer": {
        "id": "101937035",
        "team_id": "29680",
        "person": {
          "id": "639844",
          "name": "Max Finkgräfe",
          "firstname": "Max",
          "surname": "Finkgräfe",
          "fullname": "Max Finkgräfe",
          "gender": "male",
          "birthday": "27.03.2004",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "620346",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Mönchengladbach",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:16",
        "shirtnumber": "35"
      },
      "optaPlayer": {
        "playerId": "44i5i1fr0mw3mymdbepzkj9ck",
        "firstName": "Max",
        "lastName": "Finkgräfe",
        "shortFirstName": "Max",
        "shortLastName": "Finkgräfe",
        "matchName": "M. Finkgräfe",
        "shirtNumber": 35,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "641184": {
      "optaId": "9u0jnvttp25l5bp2pvx7pces",
      "heimPlayer": {
        "id": "101862248",
        "team_id": "209",
        "person": {
          "id": "641184",
          "name": "Aleksandar Pavlović",
          "firstname": "Aleksandar",
          "surname": "Pavlović",
          "fullname": "Aleksandar Pavlović",
          "gender": "male",
          "birthday": "03.05.2004",
          "height": "188",
          "weight": "75",
          "person_detail": {
            "id": "621682",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "both",
            "birth_place": "München",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "9u0jnvttp25l5bp2pvx7pces",
        "firstName": "Aleksandar",
        "lastName": "Pavlović",
        "shortFirstName": "Aleksandar",
        "shortLastName": "Pavlovic",
        "matchName": "A. Pavlović",
        "shirtNumber": 45,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "641197": {
      "optaId": "2yc1t7u26zctwjizi283g6q6s",
      "heimPlayer": {
        "id": "99153898",
        "team_id": "1502",
        "person": {
          "id": "641197",
          "name": "Paul Wanner",
          "firstname": "Paul",
          "surname": "Wanner",
          "fullname": "Paul Wanner",
          "gender": "male",
          "birthday": "23.12.2005",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "621695",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Dornbirn",
            "died": "no"
          },
          "country": [
            {
              "id": "158"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "2yc1t7u26zctwjizi283g6q6s",
        "firstName": "Paul",
        "lastName": "Wanner",
        "shortFirstName": "Paul",
        "shortLastName": "Wanner",
        "matchName": "P. Wanner",
        "shirtNumber": 10,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "641200": {
      "optaId": "6kvtqep8korw8d75n5me0lbmc",
      "heimPlayer": {
        "id": "100521754",
        "team_id": "1094",
        "person": {
          "id": "641200",
          "name": "Kenan Yıldız",
          "firstname": "Kenan",
          "surname": "Yıldız",
          "fullname": "Kenan Yıldız",
          "gender": "male",
          "birthday": "04.05.2005",
          "height": "187",
          "weight": "77",
          "person_detail": {
            "id": "621698",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "both",
            "birth_place": "Regensburg",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "6kvtqep8korw8d75n5me0lbmc",
        "firstName": "Kenan",
        "lastName": "Yıldız",
        "shortFirstName": "Kenan",
        "shortLastName": "Yildiz",
        "matchName": "K. Yıldız",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "641222": {
      "optaId": "diyzb2gwf1zkvqyjc63085eui",
      "heimPlayer": {
        "id": "100755682",
        "team_id": "2086",
        "person": {
          "id": "641222",
          "name": "Aaron Zehnter",
          "firstname": "Aaron",
          "surname": "Zehnter",
          "fullname": "Aaron Zehnter",
          "gender": "male",
          "birthday": "31.10.2004",
          "height": "180",
          "weight": "69",
          "person_detail": {
            "id": "621720",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Sonderhofen",
            "died": "no"
          }
        },
        "created": "01.03.2026 17:12",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "diyzb2gwf1zkvqyjc63085eui",
        "firstName": "Aaron",
        "lastName": "Zehnter",
        "shortFirstName": "Aaron",
        "shortLastName": "Zehnter",
        "matchName": "A. Zehnter",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "641833": {
      "optaId": "9vf02r3geinhsy732oxyrcacq",
      "heimPlayer": {
        "id": "99153904",
        "team_id": "1502",
        "person": {
          "id": "641833",
          "name": "Ismael Saibari",
          "firstname": "Ismael",
          "surname": "Saibari",
          "fullname": "Ismael Saibari Ben El Basra",
          "gender": "male",
          "birthday": "28.01.2001",
          "height": "185",
          "weight": "83",
          "person_detail": {
            "id": "622328",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Las Palmas",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "9vf02r3geinhsy732oxyrcacq",
        "firstName": "Ismael",
        "lastName": "Saibari Ben El Basra",
        "shortFirstName": "Ismael",
        "shortLastName": "Saibari",
        "matchName": "I. Saibari",
        "shirtNumber": 34,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "642083": {
      "optaId": "7dkhv2l8y6jq20l1dc2ye17je",
      "heimPlayer": {
        "id": "99159232",
        "team_id": "64",
        "person": {
          "id": "642083",
          "name": "Oliver Edvardsen",
          "firstname": "Oliver",
          "surname": "Edvardsen",
          "fullname": "Oliver Valaker Edvardsen",
          "gender": "male",
          "birthday": "19.03.1999",
          "height": "175",
          "weight": "",
          "person_detail": {
            "id": "622570",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Bærum",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "28.01.2026 22:28",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "7dkhv2l8y6jq20l1dc2ye17je",
        "firstName": "Oliver Valaker",
        "lastName": "Edvardsen",
        "shortFirstName": "Oliver",
        "shortLastName": "Edvardsen",
        "matchName": "O. Edvardsen",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "642200": {
      "optaId": "alp8twr3g2rmfmnguffsfovtg",
      "heimPlayer": {
        "id": "102123008",
        "team_id": "21",
        "person": {
          "id": "642200",
          "name": "Nelson Weiper",
          "firstname": "Nelson",
          "surname": "Weiper",
          "fullname": "Nelson Felix Patrick Weiper",
          "gender": "male",
          "birthday": "17.03.2005",
          "height": "191",
          "weight": "82",
          "person_detail": {
            "id": "622687",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Mainz",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:58",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "alp8twr3g2rmfmnguffsfovtg",
        "firstName": "Nelson Felix Patrick",
        "lastName": "Weiper",
        "shortFirstName": "Nelson",
        "shortLastName": "Weiper",
        "matchName": "N. Weiper",
        "shirtNumber": 44,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "642265": {
      "optaId": "c0dvcjq2rfqs3jj5g5v2m5zsa",
      "heimPlayer": {
        "id": "99564154",
        "team_id": "2076",
        "person": {
          "id": "642265",
          "name": "Badredine Bouanani",
          "firstname": "Badredine",
          "surname": "Bouanani",
          "fullname": "Badredine Bouanani",
          "gender": "male",
          "birthday": "08.12.2004",
          "height": "177",
          "weight": "68",
          "person_detail": {
            "id": "622752",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Lille",
            "died": "no"
          }
        },
        "created": "07.02.2026 16:58",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "c0dvcjq2rfqs3jj5g5v2m5zsa",
        "firstName": "Badredine",
        "lastName": "Bouanani",
        "shortFirstName": "Badredine",
        "shortLastName": "Bouanani",
        "matchName": "B. Bouanani",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "642888": {
      "optaId": "9x0s8mzjc9ey0q812sn3poums",
      "heimPlayer": {
        "id": "101812544",
        "team_id": "205",
        "person": {
          "id": "642888",
          "name": "Ibrahim Maza",
          "firstname": "Ibrahim",
          "surname": "Maza",
          "fullname": "Ibrahim Maza",
          "gender": "male",
          "birthday": "24.11.2005",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "623374",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          },
          "country": [
            {
              "id": "4"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "9x0s8mzjc9ey0q812sn3poums",
        "firstName": "Ibrahim",
        "lastName": "Maza",
        "shortFirstName": "Ibrahim",
        "shortLastName": "Maza",
        "matchName": "I. Maza",
        "shirtNumber": 30,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "643558": {
      "optaId": "5bnq6c53ofgo9msqn3vlobpm2",
      "heimPlayer": {
        "id": "101491145",
        "team_id": "5",
        "person": {
          "id": "643558",
          "name": "Arijon Ibrahimović",
          "firstname": "Arijon",
          "surname": "Ibrahimović",
          "fullname": "Arijon Ibrahimović",
          "gender": "male",
          "birthday": "11.12.2005",
          "height": "176",
          "weight": "69",
          "person_detail": {
            "id": "624042",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Nürnberg",
            "died": "no"
          }
        },
        "created": "14.03.2026 14:31",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "5bnq6c53ofgo9msqn3vlobpm2",
        "firstName": "Arijon",
        "lastName": "Ibrahimović",
        "shortFirstName": "Arijon",
        "shortLastName": "Ibrahimovic",
        "matchName": "A. Ibrahimović",
        "shirtNumber": 22,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "643742": {
      "optaId": "6sj31v61vtwwxe5hhwkj80g7o",
      "heimPlayer": {
        "id": "101862236",
        "team_id": "209",
        "person": {
          "id": "643742",
          "name": "Tom Bischof",
          "firstname": "Tom",
          "surname": "Bischof",
          "fullname": "Tom Bischof",
          "gender": "male",
          "birthday": "28.06.2005",
          "height": "176",
          "weight": "66",
          "person_detail": {
            "id": "624225",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Aschaffenburg",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "6sj31v61vtwwxe5hhwkj80g7o",
        "firstName": "Tom",
        "lastName": "Bischof",
        "shortFirstName": "Tom",
        "shortLastName": "Bischof",
        "matchName": "T. Bischof",
        "shirtNumber": 20,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "644136": {
      "optaId": "9t5pmugcj12kr6kju47w4ehw4",
      "heimPlayer": {
        "id": "92961623",
        "team_id": "253",
        "person": {
          "id": "644136",
          "name": "Charles Herrmann",
          "firstname": "Charles",
          "surname": "Herrmann",
          "fullname": "Charles Kwablan Herrmann",
          "gender": "male",
          "birthday": "21.01.2006",
          "height": "180",
          "weight": "70",
          "person_detail": {
            "id": "624614",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Hannover",
            "died": "no"
          }
        },
        "created": "21.09.2025 19:13",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "9t5pmugcj12kr6kju47w4ehw4",
        "firstName": "Charles Kwablan",
        "lastName": "Herrmann",
        "shortFirstName": "Charles",
        "shortLastName": "Herrmann",
        "matchName": "C. Herrmann",
        "shirtNumber": 34,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "644459": {
      "optaId": "4j8y1bwt6z8iu98077xqzmvx0",
      "heimPlayer": {
        "id": "101524355",
        "team_id": "594",
        "person": {
          "id": "644459",
          "name": "Mert Kömür",
          "firstname": "Mert",
          "surname": "Kömür",
          "fullname": "Mert Kömür",
          "gender": "male",
          "birthday": "17.07.2005",
          "height": "183",
          "weight": "80",
          "person_detail": {
            "id": "624935",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "both",
            "birth_place": "Dachau",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:07",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "4j8y1bwt6z8iu98077xqzmvx0",
        "firstName": "Mert",
        "lastName": "Kömür",
        "shortFirstName": "Mert",
        "shortLastName": "Kömür",
        "matchName": "M. Kömür",
        "shirtNumber": 36,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "644463": {
      "optaId": "8ri0md3tr27a1bn10xmfkgsus",
      "heimPlayer": {
        "id": "101490275",
        "team_id": "2086",
        "person": {
          "id": "644463",
          "name": "Dženan Pejčinović",
          "firstname": "Dženan",
          "surname": "Pejčinović",
          "fullname": "Dženan Pejčinović",
          "gender": "male",
          "birthday": "15.02.2005",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "624939",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "München",
            "died": "no"
          }
        },
        "created": "14.03.2026 14:26",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "8ri0md3tr27a1bn10xmfkgsus",
        "firstName": "Dženan",
        "lastName": "Pejčinović",
        "shortFirstName": "Dzenan",
        "shortLastName": "Pejcinovic",
        "matchName": "D. Pejčinović",
        "shirtNumber": 17,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "644944": {
      "optaId": "8vhjmcgjbzpzd4vv3zb945p1w",
      "heimPlayer": {
        "id": "100521955",
        "team_id": "136",
        "person": {
          "id": "644944",
          "name": "Maghnes Akliouche",
          "firstname": "Maghnes",
          "surname": "Akliouche",
          "fullname": "Maghnes Akliouche",
          "gender": "male",
          "birthday": "25.02.2002",
          "height": "183",
          "weight": "72",
          "person_detail": {
            "id": "625417",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Tremblay-en-France",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "8vhjmcgjbzpzd4vv3zb945p1w",
        "firstName": "Maghnes",
        "lastName": "Akliouche",
        "shortFirstName": "Maghnes",
        "shortLastName": "Akliouche",
        "matchName": "M. Akliouche",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "645048": {
      "optaId": "spjwukiya1mdmpbk7f4baolw",
      "heimPlayer": {
        "id": "101936009",
        "team_id": "24",
        "person": {
          "id": "645048",
          "name": "Max Moerstedt",
          "firstname": "Max",
          "surname": "Moerstedt",
          "fullname": "Max Moerstedt",
          "gender": "male",
          "birthday": "15.01.2006",
          "height": "194",
          "weight": "77",
          "person_detail": {
            "id": "625521",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Mannheim",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:04",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "spjwukiya1mdmpbk7f4baolw",
        "firstName": "Max",
        "lastName": "Moerstedt",
        "shortFirstName": "Max",
        "shortLastName": "Moerstedt",
        "matchName": "M. Moerstedt",
        "shirtNumber": 33,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "645249": {
      "optaId": "bntg1x82gm63kbo7ijai64gk",
      "heimPlayer": {
        "id": "102006203",
        "team_id": "943",
        "person": {
          "id": "645249",
          "name": "William Mikelbrencis",
          "firstname": "William",
          "surname": "Mikelbrencis",
          "fullname": "William Mikelbrencis",
          "gender": "male",
          "birthday": "25.02.2004",
          "height": "176",
          "weight": "64",
          "person_detail": {
            "id": "625722",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Forbach",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "bntg1x82gm63kbo7ijai64gk",
        "firstName": "William",
        "lastName": "Mikelbrencis",
        "shortFirstName": "William",
        "shortLastName": "Mikelbrencis",
        "matchName": "W. Mikelbrencis",
        "shirtNumber": 2,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "645504": {
      "optaId": "6u7iuum6kqfwb4pbw5lsoff56",
      "heimPlayer": {
        "id": "100501615",
        "team_id": "1052",
        "person": {
          "id": "645504",
          "name": "Petar Sučić",
          "firstname": "Petar",
          "surname": "Sučić",
          "fullname": "Petar Sučić",
          "gender": "male",
          "birthday": "25.10.2003",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "625975",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Livno",
            "died": "no"
          },
          "country": [
            {
              "id": "109"
            }
          ]
        },
        "created": "24.02.2026 22:20",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "6u7iuum6kqfwb4pbw5lsoff56",
        "firstName": "Petar",
        "lastName": "Sučić",
        "shortFirstName": "Petar",
        "shortLastName": "Sucic",
        "matchName": "P. Sučić",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "646379": {
      "optaId": "e0ywbn79yd3cd9kfngcgffxg4",
      "heimPlayer": {
        "id": "101972438",
        "team_id": "5",
        "person": {
          "id": "646379",
          "name": "Hennes Behrens",
          "firstname": "Hennes",
          "surname": "Behrens",
          "fullname": "Hennes Behrens",
          "gender": "male",
          "birthday": "19.01.2005",
          "height": "174",
          "weight": "69",
          "person_detail": {
            "id": "626846",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Frankfurt am Main",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:14",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "e0ywbn79yd3cd9kfngcgffxg4",
        "firstName": "Hennes",
        "lastName": "Behrens",
        "shortFirstName": "Hennes",
        "shortLastName": "Behrens",
        "matchName": "H. Behrens",
        "shirtNumber": 26,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "646693": {
      "optaId": "66jotyvbhtz5cjvhbby6luelm",
      "heimPlayer": {
        "id": "97686820",
        "team_id": "156",
        "person": {
          "id": "646693",
          "name": "Nico Williams",
          "firstname": "",
          "surname": "Nico Williams",
          "fullname": "Nicholas Williams Arthuer",
          "gender": "male",
          "birthday": "12.07.2002",
          "height": "181",
          "weight": "68",
          "person_detail": {
            "id": "627158",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Pamplona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "10.12.2025 19:56",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "66jotyvbhtz5cjvhbby6luelm",
        "firstName": "Nicholas",
        "lastName": "Williams Arthuer",
        "shortFirstName": "Nico",
        "shortLastName": "Williams",
        "knownName": "Nico Williams",
        "matchName": "Nico Williams",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "646944": {
      "optaId": "4rtps64cca8vrscv80bgyvjf8",
      "heimPlayer": {
        "id": "101995241",
        "team_id": "19",
        "person": {
          "id": "646944",
          "name": "Tom Rothe",
          "firstname": "Tom",
          "surname": "Rothe",
          "fullname": "Tom Alexander Rothe",
          "gender": "male",
          "birthday": "29.10.2004",
          "height": "193",
          "weight": "88",
          "person_detail": {
            "id": "627403",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Rendsburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:34",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "4rtps64cca8vrscv80bgyvjf8",
        "firstName": "Tom Alexander",
        "lastName": "Rothe",
        "shortFirstName": "Tom",
        "shortLastName": "Rothe",
        "matchName": "T. Rothe",
        "shirtNumber": 15,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "647150": {
      "optaId": "3hpaoy4qzn5xp7qnzdrj1yvsa",
      "heimPlayer": {
        "id": "100501621",
        "team_id": "1052",
        "person": {
          "id": "647150",
          "name": "Andy Diouf",
          "firstname": "Andy",
          "surname": "Diouf",
          "fullname": "Andy Alune Diouf",
          "gender": "male",
          "birthday": "17.05.2003",
          "height": "187",
          "weight": "81",
          "person_detail": {
            "id": "627609",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Neuilly-Sur-Seine",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "24.02.2026 22:20",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "3hpaoy4qzn5xp7qnzdrj1yvsa",
        "firstName": "Andy Alune",
        "lastName": "Diouf",
        "shortFirstName": "Andy",
        "shortLastName": "Diouf",
        "matchName": "A. Diouf",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "647301": {
      "optaId": "5d3stmq3pgka4qhdfoff35t9m",
      "heimPlayer": {
        "id": "101972924",
        "team_id": "2086",
        "person": {
          "id": "647301",
          "name": "Konstantinos Koulierakis",
          "firstname": "Konstantinos",
          "surname": "Koulierakis",
          "fullname": "Konstantinos Koulierakis",
          "gender": "male",
          "birthday": "28.11.2003",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "627760",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Chania",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "5d3stmq3pgka4qhdfoff35t9m",
        "firstName": "Konstantinos",
        "lastName": "Koulierakis",
        "shortFirstName": "Konstantinos",
        "shortLastName": "Koulierakis",
        "matchName": "K. Koulierakis",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "647491": {
      "optaId": "3h6q9lkwovcu4pynltgnzhy50",
      "heimPlayer": {
        "id": "101456963",
        "team_id": "253",
        "person": {
          "id": "647491",
          "name": "Fabio Chiarodia",
          "firstname": "Fabio",
          "surname": "Chiarodia",
          "fullname": "Fabio Cristian Chiarodia",
          "gender": "male",
          "birthday": "05.06.2005",
          "height": "186",
          "weight": "78",
          "person_detail": {
            "id": "627949",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Oldenburg",
            "died": "no"
          }
        },
        "created": "13.03.2026 22:16",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "3h6q9lkwovcu4pynltgnzhy50",
        "firstName": "Fabio Christian",
        "lastName": "Chiarodia",
        "shortFirstName": "Fabio",
        "shortLastName": "Chiarodia",
        "matchName": "F. Chiarodia",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "648263": {
      "optaId": "1g69rnx39ak976l3yjbg2p1jo",
      "heimPlayer": {
        "id": "101530643",
        "team_id": "9",
        "person": {
          "id": "648263",
          "name": "Youssoupha Niang",
          "firstname": "Youssoupha",
          "surname": "Niang",
          "fullname": "Youssoupha Niang",
          "gender": "male",
          "birthday": "25.03.2006",
          "height": "185",
          "weight": "",
          "person_detail": {
            "id": "628696",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:32",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "1g69rnx39ak976l3yjbg2p1jo",
        "firstName": "Youssoupha",
        "lastName": "Niang",
        "shortFirstName": "Youssoupha",
        "shortLastName": "Niang",
        "matchName": "Y. Niang",
        "shirtNumber": 38,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "648988": {
      "optaId": "4rhyl8q31wceeq2dnaep9t3x0",
      "heimPlayer": {
        "id": "98598025",
        "team_id": "29680",
        "person": {
          "id": "648988",
          "name": "Assan Ouédraogo",
          "firstname": "Assan",
          "surname": "Ouédraogo",
          "fullname": "Forzan Assan Ouédraogo",
          "gender": "male",
          "birthday": "09.05.2006",
          "height": "191",
          "weight": "84",
          "person_detail": {
            "id": "629417",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Mülheim an der Ruhr",
            "died": "no"
          }
        },
        "created": "14.01.2026 19:12",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "4rhyl8q31wceeq2dnaep9t3x0",
        "firstName": "Forzan Assan",
        "lastName": "Ouédraogo",
        "shortFirstName": "Assan",
        "shortLastName": "Ouédraogo",
        "matchName": "A. Ouédraogo",
        "shirtNumber": 20,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "650465": {
      "optaId": "6mxpnfdozs8iqod835jw9jwus",
      "heimPlayer": {
        "id": "95042443",
        "team_id": "2086",
        "person": {
          "id": "650465",
          "name": "Bence Dárdai",
          "firstname": "Bence",
          "surname": "Dárdai",
          "fullname": "Bence Dárdai",
          "gender": "male",
          "birthday": "24.01.2006",
          "height": "189",
          "weight": "71",
          "person_detail": {
            "id": "630871",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "25.10.2025 16:45",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "6mxpnfdozs8iqod835jw9jwus",
        "firstName": "Bence",
        "lastName": "Dárdai",
        "shortFirstName": "Bence",
        "shortLastName": "Dárdai",
        "matchName": "B. Dárdai",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "650729": {
      "optaId": "1e2hez2ipfx9aqg6h18aao222",
      "heimPlayer": {
        "id": "92467922",
        "team_id": "2134",
        "person": {
          "id": "650729",
          "name": "Skelly Alvero",
          "firstname": "Skelly",
          "surname": "Alvero",
          "fullname": "Skelly Alvero",
          "gender": "male",
          "birthday": "04.05.2002",
          "height": "202",
          "weight": "93",
          "person_detail": {
            "id": "631134",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Stains",
            "died": "no"
          }
        },
        "created": "14.09.2025 19:11",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "1e2hez2ipfx9aqg6h18aao222",
        "firstName": "Skelly",
        "lastName": "Alvero",
        "shortFirstName": "Skelly",
        "shortLastName": "Alvero",
        "matchName": "S. Alvero",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "651049": {
      "optaId": "5tg6w4wmwtiwvdvsmju5svdhw",
      "heimPlayer": {
        "id": "102026606",
        "team_id": "943",
        "person": {
          "id": "651049",
          "name": "Fabio Baldé",
          "firstname": "Fabio",
          "surname": "Baldé",
          "fullname": "Fabio Amado Uri Baldé",
          "gender": "male",
          "birthday": "20.07.2005",
          "height": "182",
          "weight": "75",
          "person_detail": {
            "id": "631451",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 19:56",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "5tg6w4wmwtiwvdvsmju5svdhw",
        "firstName": "Fabio Amado Uri",
        "lastName": "Baldé",
        "shortFirstName": "Fabio",
        "shortLastName": "Baldé",
        "matchName": "Fabio Baldé",
        "shirtNumber": 45,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "651307": {
      "optaId": "bwrtljwa3px624mxp49xa6psk",
      "heimPlayer": {
        "id": "102003098",
        "team_id": "2134",
        "person": {
          "id": "651307",
          "name": "Salim Musah",
          "firstname": "Salim",
          "surname": "Musah",
          "fullname": "Salim Amani Musah",
          "gender": "male",
          "birthday": "22.02.2006",
          "height": "198",
          "weight": "83",
          "person_detail": {
            "id": "631711",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Oldenburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:13",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "bwrtljwa3px624mxp49xa6psk",
        "firstName": "Salim Amani",
        "lastName": "Musah",
        "shortFirstName": "Salim",
        "shortLastName": "Musah",
        "matchName": "S. Musah",
        "shirtNumber": 29,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "651790": {
      "optaId": "ekz97oo88fcqhay2w2hrhecyc",
      "heimPlayer": {
        "id": "101975942",
        "team_id": "9",
        "person": {
          "id": "651790",
          "name": "Saïd El Mala",
          "firstname": "Saïd",
          "surname": "El Mala",
          "fullname": "Saïd El Mala",
          "gender": "male",
          "birthday": "26.08.2006",
          "height": "187",
          "weight": "72",
          "person_detail": {
            "id": "632196",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Krefeld",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "ekz97oo88fcqhay2w2hrhecyc",
        "firstName": "Saïd",
        "lastName": "El Mala",
        "shortFirstName": "Saïd",
        "shortLastName": "El Mala",
        "matchName": "S. El Mala",
        "shirtNumber": 13,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "651895": {
      "optaId": "3v695dpbm6bdgifkyhlie6kbu",
      "heimPlayer": {
        "id": "102116828",
        "team_id": "702",
        "person": {
          "id": "651895",
          "name": "Joel Chima Fujita",
          "firstname": "Joel Chima",
          "surname": "Fujita",
          "fullname": "Joel Chima Fujita",
          "gender": "male",
          "birthday": "16.02.2002",
          "height": "175",
          "weight": "76",
          "person_detail": {
            "id": "632300",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Machida, Tokyo",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "3v695dpbm6bdgifkyhlie6kbu",
        "firstName": "Joel Chima",
        "lastName": "Fujita",
        "shortFirstName": "Joel Chima",
        "shortLastName": "Fujita",
        "matchName": "J. Fujita",
        "shirtNumber": 16,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "653277": {
      "optaId": "63tj5b59b7en3tnd4sjff8woa",
      "heimPlayer": {
        "id": "101862305",
        "team_id": "155",
        "person": {
          "id": "653277",
          "name": "Lorenzo Bernasconi",
          "firstname": "Lorenzo",
          "surname": "Bernasconi",
          "fullname": "Lorenzo Bernasconi",
          "gender": "male",
          "birthday": "16.11.2003",
          "height": "190",
          "weight": "84",
          "person_detail": {
            "id": "633679",
            "position_1": "6",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Crema",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "47"
      },
      "optaPlayer": {
        "playerId": "63tj5b59b7en3tnd4sjff8woa",
        "firstName": "Lorenzo",
        "lastName": "Bernasconi",
        "shortFirstName": "Lorenzo",
        "shortLastName": "Bernasconi",
        "matchName": "L. Bernasconi",
        "shirtNumber": 47,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "654403": {
      "optaId": "3akb6xex1efr9ypj8yxr2uf4k",
      "heimPlayer": {
        "id": "102134477",
        "team_id": "594",
        "person": {
          "id": "654403",
          "name": "Noahkai Banks",
          "firstname": "Noahkai",
          "surname": "Banks",
          "fullname": "Noahkai Dominic Banks",
          "gender": "male",
          "birthday": "01.12.2006",
          "height": "192",
          "weight": "93",
          "person_detail": {
            "id": "634795",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Honolulu, Hawaii",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "3akb6xex1efr9ypj8yxr2uf4k",
        "firstName": "Noahkai Dominic",
        "lastName": "Banks",
        "shortFirstName": "Noahkai",
        "shortLastName": "Banks",
        "matchName": "N. Banks",
        "shirtNumber": 40,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "655389": {
      "optaId": "3vx94h32ahujciraspdayj9t6",
      "heimPlayer": {
        "id": "101861369",
        "team_id": "1226",
        "person": {
          "id": "655389",
          "name": "Hugo Ekitiké",
          "firstname": "Hugo",
          "surname": "Ekitiké",
          "fullname": "Hugo Ekitiké",
          "gender": "male",
          "birthday": "20.06.2002",
          "height": "189",
          "weight": "75",
          "person_detail": {
            "id": "635780",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Reims",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "3vx94h32ahujciraspdayj9t6",
        "firstName": "Hugo Timothée",
        "lastName": "Ekitiké",
        "shortFirstName": "Hugo",
        "shortLastName": "Ekitiké",
        "matchName": "H. Ekitiké",
        "shirtNumber": 22,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "656515": {
      "optaId": "5ayo0fp6wod7cqg71e38zdz4k",
      "heimPlayer": {
        "id": "99154822",
        "team_id": "156",
        "person": {
          "id": "656515",
          "name": "Adama Boiro",
          "firstname": "",
          "surname": "Adama Boiro",
          "fullname": "Adama Boiro Boiro",
          "gender": "male",
          "birthday": "22.06.2002",
          "height": "183",
          "weight": "74",
          "person_detail": {
            "id": "636897",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Dakar",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "5ayo0fp6wod7cqg71e38zdz4k",
        "firstName": "Adama",
        "lastName": "Boiro Boiro",
        "shortFirstName": "Adama",
        "shortLastName": "Boiro",
        "matchName": "Adama Boiro",
        "shirtNumber": 19,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "656855": {
      "optaId": "39ccv9t7ydrrcwd1es1xu2e50",
      "heimPlayer": {
        "id": "101811998",
        "team_id": "373",
        "person": {
          "id": "656855",
          "name": "Andrey Santos",
          "firstname": "",
          "surname": "Andrey Santos",
          "fullname": "Andrey Nascimento dos Santos",
          "gender": "male",
          "birthday": "03.05.2004",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "637237",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Rio de Janeiro",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "39ccv9t7ydrrcwd1es1xu2e50",
        "firstName": "Andrey",
        "lastName": "Nascimento dos Santos",
        "shortFirstName": "Andrey",
        "shortLastName": "Nascimento dos Santos",
        "knownName": "Andrey Santos",
        "matchName": "Andrey Santos",
        "shirtNumber": 17,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "656892": {
      "optaId": "6nwn2522yescgrx57wkcxjhwq",
      "heimPlayer": {
        "id": "101360456",
        "team_id": "1267",
        "person": {
          "id": "656892",
          "name": "Sávinho",
          "firstname": "",
          "surname": "Sávinho",
          "fullname": "Sávio Moreira de Oliveira",
          "gender": "male",
          "birthday": "10.04.2004",
          "height": "176",
          "weight": "66",
          "person_detail": {
            "id": "637274",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "São Mateus",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "11.03.2026 19:56",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "6nwn2522yescgrx57wkcxjhwq",
        "firstName": "Sávio",
        "lastName": "Moreira de Oliveira",
        "shortFirstName": "Sávio",
        "shortLastName": "Moreira de Oliveira",
        "knownName": "Savinho",
        "matchName": "Savinho",
        "shirtNumber": 26,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "657188": {
      "optaId": "2zny241yb0xio4i7k9a5k76s4",
      "heimPlayer": {
        "id": "102121583",
        "team_id": "530",
        "person": {
          "id": "657188",
          "name": "Ayoube Amaimouni-Echghouyab",
          "firstname": "Ayoube",
          "surname": "Amaimouni-Echghouyab",
          "fullname": "Ayoube Amaimouni-Echghouyab",
          "gender": "male",
          "birthday": "30.11.2004",
          "height": "178",
          "weight": "69",
          "person_detail": {
            "id": "637570",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Vic",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:47",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "2zny241yb0xio4i7k9a5k76s4",
        "firstName": "Ayoube",
        "lastName": "Amaimouni-Echghouyab",
        "shortFirstName": "Ayoube",
        "shortLastName": "Amaimouni-Echghouyab",
        "matchName": "A. Amaimouni-Echghouyab",
        "shirtNumber": 29,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "657963": {
      "optaId": "6l1y87tlepsvr83d8y2qifeqy",
      "heimPlayer": {
        "id": "101855576",
        "team_id": "597",
        "person": {
          "id": "657963",
          "name": "Gerard Martín",
          "firstname": "",
          "surname": "Gerard Martín",
          "fullname": "Gerard Martín Langreo",
          "gender": "male",
          "birthday": "26.02.2002",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "638341",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Esplugues de Llobregat",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "6l1y87tlepsvr83d8y2qifeqy",
        "firstName": "Gerard",
        "lastName": "Martín Langreo",
        "shortFirstName": "Gerard",
        "shortLastName": "Martín",
        "matchName": "Gerard Martín",
        "shirtNumber": 18,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "658883": {
      "optaId": "8onx3qmoe50w7j40xsvnsvb6y",
      "heimPlayer": {
        "id": "99154633",
        "team_id": "17544",
        "person": {
          "id": "658883",
          "name": "Temirlan Anarbekov",
          "firstname": "Temirlan",
          "surname": "Anarbekov",
          "fullname": "Temirlan Anarbekuly Anarbekov",
          "gender": "male",
          "birthday": "14.10.2003",
          "height": "189",
          "weight": "",
          "person_detail": {
            "id": "639260",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Atyrau",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "77"
      },
      "optaPlayer": {
        "playerId": "8onx3qmoe50w7j40xsvnsvb6y",
        "firstName": "Temirlan",
        "lastName": "Anarbekov",
        "shortFirstName": "Temirlan",
        "shortLastName": "Anarbekov",
        "matchName": "T. Anarbekov",
        "shirtNumber": 77,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "660054": {
      "optaId": "3x1y10rgm8bbu3zgef74b05ck",
      "heimPlayer": {
        "id": "96886702",
        "team_id": "1731",
        "person": {
          "id": "660054",
          "name": "Manuel Silva",
          "firstname": "",
          "surname": "Manuel Silva",
          "fullname": "Manuel Jorge Silva",
          "gender": "male",
          "birthday": "12.06.2001",
          "height": "190",
          "weight": "83",
          "person_detail": {
            "id": "640401",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Santa Maria da Feira",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "extra_minute": "2",
        "created": "25.11.2025 20:37",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "3x1y10rgm8bbu3zgef74b05ck",
        "firstName": "Manuel Jorge",
        "lastName": "Silva",
        "shortFirstName": "Manuel Jorge",
        "shortLastName": "Silva",
        "knownName": "Manu Silva",
        "matchName": "Manu Silva",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "660207": {
      "optaId": "3e79d5436l57bfj3ywbjvfr6y",
      "heimPlayer": {
        "id": "99237784",
        "team_id": "702",
        "person": {
          "id": "660207",
          "name": "Ricky Jade-Jones",
          "firstname": "Ricky",
          "surname": "Jade-Jones",
          "fullname": "Ricky Jade-Jones",
          "gender": "male",
          "birthday": "08.11.2002",
          "height": "183",
          "weight": "69",
          "person_detail": {
            "id": "640549",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Peterborough",
            "died": "no"
          }
        },
        "created": "31.01.2026 14:30",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "3e79d5436l57bfj3ywbjvfr6y",
        "firstName": "Ricky-Jade",
        "lastName": "Jones",
        "shortFirstName": "Ricky-Jade",
        "shortLastName": "Jones",
        "matchName": "R. Jones",
        "shirtNumber": 26,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "660243": {
      "optaId": "7aak50ydu8nrfxd9qndeygnpw",
      "heimPlayer": {
        "id": "100502788",
        "team_id": "1418",
        "person": {
          "id": "660243",
          "name": "Bruno Onyemaechi",
          "firstname": "Bruno",
          "surname": "Onyemaechi",
          "fullname": "Sopuruchukwu Bruno Onyemaechi",
          "gender": "male",
          "birthday": "03.04.1999",
          "height": "184",
          "weight": "82",
          "person_detail": {
            "id": "640585",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Owerri",
            "died": "no"
          },
          "country": [
            {
              "id": "151"
            }
          ]
        },
        "created": "24.02.2026 22:45",
        "shirtnumber": "70"
      },
      "optaPlayer": {
        "playerId": "7aak50ydu8nrfxd9qndeygnpw",
        "firstName": "Sopuruchukwu Bruno",
        "lastName": "Onyemaechi",
        "shortFirstName": "Bruno",
        "shortLastName": "Onyemaechi",
        "matchName": "B. Onyemaechi",
        "shirtNumber": 70,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "660542": {
      "optaId": "6ddxujeb3873j5evwiz8n4wt0",
      "heimPlayer": {
        "id": "96885079",
        "team_id": "2102",
        "person": {
          "id": "660542",
          "name": "Júnior Reis",
          "firstname": "",
          "surname": "Júnior Reis",
          "fullname": "Luiz Lúcio Reis Júnior",
          "gender": "male",
          "birthday": "14.01.2001",
          "height": "192",
          "weight": "90",
          "person_detail": {
            "id": "640867",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Picos (PI)",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "25.11.2025 20:07",
        "shirtnumber": "1"
      },
      "optaPlayer": {
        "playerId": "6ddxujeb3873j5evwiz8n4wt0",
        "firstName": "Luíz Lúcio",
        "lastName": "Reis Júnior",
        "shortFirstName": "Luiz Lúcio",
        "shortLastName": "Reis Júnior",
        "knownName": "Luiz Júnior",
        "matchName": "Luíz Júnior",
        "shirtNumber": 1,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "661699": {
      "optaId": "edgnkgpt7a6rzffcd012sqfpw",
      "heimPlayer": {
        "id": "102134468",
        "team_id": "594",
        "person": {
          "id": "661699",
          "name": "Rodrigo Ribeiro",
          "firstname": "",
          "surname": "Rodrigo Ribeiro",
          "fullname": "Rodrigo Duarte Ribeiro",
          "gender": "male",
          "birthday": "28.04.2005",
          "height": "186",
          "weight": "79",
          "person_detail": {
            "id": "642013",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Viana do Castelo",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:21",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "edgnkgpt7a6rzffcd012sqfpw",
        "firstName": "Rodrigo",
        "lastName": "Duarte Ribeiro",
        "shortFirstName": "Rodrigo",
        "shortLastName": "Duarte Ribeiro",
        "knownName": "Rodrigo Ribeiro",
        "matchName": "Rodrigo Ribeiro",
        "shirtNumber": 21,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "662827": {
      "optaId": "73jvx4opw9wvawwpg0bnt8ay2",
      "heimPlayer": {
        "id": "96893254",
        "team_id": "2102",
        "person": {
          "id": "662827",
          "name": "Ilias Akhomach",
          "firstname": "",
          "surname": "Ilias Akhomach",
          "fullname": "Ilias Akhomach Chakkour",
          "gender": "male",
          "birthday": "16.04.2004",
          "height": "175",
          "weight": "70",
          "person_detail": {
            "id": "643135",
            "position_1": "9",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Hostalets de Pierola",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "25.11.2025 22:49",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "73jvx4opw9wvawwpg0bnt8ay2",
        "firstName": "Ilias",
        "lastName": "Akhomach Chakkour",
        "shortFirstName": "Ilias",
        "shortLastName": "Akhomach",
        "matchName": "I. Akhomach",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "662835": {
      "optaId": "2spn42sn73gxwyt6ucobiknl6",
      "heimPlayer": {
        "id": "101823356",
        "team_id": "1545",
        "person": {
          "id": "662835",
          "name": "Manuel Ángel",
          "firstname": "",
          "surname": "Manuel Ángel",
          "fullname": "Manuel Ángel Morán Ibáñez",
          "gender": "male",
          "birthday": "15.03.2004",
          "height": "170",
          "weight": "60",
          "person_detail": {
            "id": "643143",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Albaida del Aljarafe",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 22:34",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "2spn42sn73gxwyt6ucobiknl6",
        "firstName": "Manuel Ángel",
        "lastName": "Morán Ibáñez",
        "shortFirstName": "Manuel",
        "shortLastName": "Ángel",
        "matchName": "Manuel Ángel",
        "shirtNumber": 37,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "663082": {
      "optaId": "8bvn7mn5tjfj3l2bnpvm75gmi",
      "heimPlayer": {
        "id": "99158149",
        "team_id": "2102",
        "person": {
          "id": "663082",
          "name": "Georges Mikautadze",
          "firstname": "Georges",
          "surname": "Mikautadze",
          "fullname": "Georges Mikautadze",
          "gender": "male",
          "birthday": "31.10.2000",
          "height": "176",
          "weight": "71",
          "person_detail": {
            "id": "643388",
            "position_1": "11",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Lyon",
            "died": "no"
          },
          "country": [
            {
              "id": "65"
            }
          ]
        },
        "created": "28.01.2026 22:05",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "8bvn7mn5tjfj3l2bnpvm75gmi",
        "firstName": "Georges",
        "lastName": "Mikautadze",
        "shortFirstName": "Georges",
        "shortLastName": "Mikautadze",
        "matchName": "G. Mikautadze",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "664604": {
      "optaId": "rlgrvvibryod2g92hqc97ii2",
      "heimPlayer": {
        "id": "99152791",
        "team_id": "205",
        "person": {
          "id": "664604",
          "name": "Loïc Badé",
          "firstname": "Loïc",
          "surname": "Badé",
          "fullname": "Loïc Badé",
          "gender": "male",
          "birthday": "11.04.2000",
          "height": "191",
          "weight": "89",
          "person_detail": {
            "id": "644902",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Sèvres",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "28.01.2026 19:54",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "rlgrvvibryod2g92hqc97ii2",
        "firstName": "Loïc Séri",
        "lastName": "Badé",
        "shortFirstName": "Loïc",
        "shortLastName": "Badé",
        "matchName": "L. Badé",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "664703": {
      "optaId": "1qkneebzln8byl9td2aswznmy",
      "heimPlayer": {
        "id": "98830702",
        "team_id": "2102",
        "person": {
          "id": "664703",
          "name": "Alberto Moleiro",
          "firstname": "",
          "surname": "Alberto Moleiro",
          "fullname": "Alberto Moleiro González",
          "gender": "male",
          "birthday": "30.09.2003",
          "height": "171",
          "weight": "67",
          "person_detail": {
            "id": "645001",
            "position_1": "6",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Santa Cruz de Tenerife",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 20:04",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "1qkneebzln8byl9td2aswznmy",
        "firstName": "Alberto",
        "lastName": "Moleiro González",
        "shortFirstName": "Alberto",
        "shortLastName": "Moleiro",
        "matchName": "Alberto Moleiro",
        "shirtNumber": 20,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "668800": {
      "optaId": "hsobzlp177f9755mpsi7szmy",
      "heimPlayer": {
        "id": "101550821",
        "team_id": "9",
        "person": {
          "id": "668800",
          "name": "Sebastian Sebulonsen",
          "firstname": "Sebastian",
          "surname": "Sebulonsen",
          "fullname": "Sebastian Søraas Sebulonsen",
          "gender": "male",
          "birthday": "27.01.2000",
          "height": "187",
          "weight": "78",
          "person_detail": {
            "id": "649053",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Stavanger",
            "died": "no"
          }
        },
        "created": "14.03.2026 20:02",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "hsobzlp177f9755mpsi7szmy",
        "firstName": "Sebastian",
        "lastName": "Søraas Sebulonsen",
        "shortFirstName": "Sebastian",
        "shortLastName": "Sebulonsen",
        "matchName": "S. Sebulonsen",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "668802": {
      "optaId": "d5jihfuxjuw51jgt6k4zhmrmy",
      "heimPlayer": {
        "id": "92676878",
        "team_id": "749",
        "person": {
          "id": "668802",
          "name": "Magnus Riisnæs",
          "firstname": "Magnus",
          "surname": "Riisnæs",
          "fullname": "Magnus Bech Riisnæs",
          "gender": "male",
          "birthday": "04.11.2004",
          "height": "182",
          "weight": "73",
          "person_detail": {
            "id": "649055",
            "position_1": "9",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Lørenskog",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.09.2025 20:12",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "d5jihfuxjuw51jgt6k4zhmrmy",
        "firstName": "Magnus Bech",
        "lastName": "Riisnæs",
        "shortFirstName": "Magnus",
        "shortLastName": "Riisnæs",
        "matchName": "M. Riisnæs",
        "shirtNumber": 23,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "670390": {
      "optaId": "drh7wx5zz8c4dwa9o8mrigjro",
      "heimPlayer": {
        "id": "101360432",
        "team_id": "1267",
        "person": {
          "id": "670390",
          "name": "Nico O'Reilly",
          "firstname": "Nico",
          "surname": "O'Reilly",
          "fullname": "Nico O'Reilly",
          "gender": "male",
          "birthday": "21.03.2005",
          "height": "193",
          "weight": "78",
          "person_detail": {
            "id": "650590",
            "position_1": "3",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Manchester",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "11.03.2026 19:56",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "drh7wx5zz8c4dwa9o8mrigjro",
        "firstName": "Nico",
        "lastName": "O'Reilly",
        "shortFirstName": "Nico",
        "shortLastName": "O'Reilly",
        "matchName": "N. O'Reilly",
        "shirtNumber": 33,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "670393": {
      "optaId": "dw8cxbn8i288w0rqiemop6qs4",
      "heimPlayer": {
        "id": "100518826",
        "team_id": "258",
        "person": {
          "id": "670393",
          "name": "Jobe Bellingham",
          "firstname": "Jobe",
          "surname": "Bellingham",
          "fullname": "Jobe Bellingham",
          "gender": "male",
          "birthday": "23.09.2005",
          "height": "191",
          "weight": "73",
          "person_detail": {
            "id": "650593",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Stourbridge",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "dw8cxbn8i288w0rqiemop6qs4",
        "firstName": "Jobe Samuel Patrick",
        "lastName": "Bellingham",
        "shortFirstName": "Jobe",
        "shortLastName": "Bellingham",
        "matchName": "J. Bellingham",
        "shirtNumber": 7,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "671741": {
      "optaId": "edk9jemtelz51uoob4quyd4kq",
      "heimPlayer": {
        "id": "100502794",
        "team_id": "1418",
        "person": {
          "id": "671741",
          "name": "Clayton",
          "firstname": "",
          "surname": "Clayton",
          "fullname": "Clayton Fernandes Silva",
          "gender": "male",
          "birthday": "11.01.1999",
          "height": "184",
          "weight": "88",
          "person_detail": {
            "id": "651930",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Belo Horizonte - MG",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 22:44",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "edk9jemtelz51uoob4quyd4kq",
        "firstName": "Clayton",
        "lastName": "Fernandes Silva",
        "shortFirstName": "Clayton",
        "shortLastName": "Fernandes Silva",
        "knownName": "Clayton",
        "matchName": "Clayton",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "672582": {
      "optaId": "370bp4zp3mxe27rtx3gwhcems",
      "heimPlayer": {
        "id": "93682618",
        "team_id": "136",
        "person": {
          "id": "672582",
          "name": "Stanis Idumbo",
          "firstname": "Stanis",
          "surname": "Idumbo",
          "fullname": "Stanis Idumbo Muzambo",
          "gender": "male",
          "birthday": "29.06.2005",
          "height": "170",
          "weight": "",
          "person_detail": {
            "id": "652766",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Melun",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "01.10.2025 22:24",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "370bp4zp3mxe27rtx3gwhcems",
        "firstName": "Stanis",
        "lastName": "Idumbo Muzambo",
        "shortFirstName": "Stanis",
        "shortLastName": "Idumbo",
        "matchName": "S. Idumbo",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "672832": {
      "optaId": "a2zavv31d2aadyddk0kjttdgq",
      "heimPlayer": {
        "id": "101861342",
        "team_id": "1226",
        "person": {
          "id": "672832",
          "name": "Milos Kerkez",
          "firstname": "Milos",
          "surname": "Kerkez",
          "fullname": "Milos Kerkez",
          "gender": "male",
          "birthday": "07.11.2003",
          "height": "180",
          "weight": "71",
          "person_detail": {
            "id": "653016",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Vrbas",
            "died": "no"
          },
          "country": [
            {
              "id": "226"
            }
          ]
        },
        "created": "18.03.2026 19:49",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "a2zavv31d2aadyddk0kjttdgq",
        "firstName": "Miloš",
        "lastName": "Kerkez",
        "shortFirstName": "Milos",
        "shortLastName": "Kerkez",
        "matchName": "M. Kerkez",
        "shirtNumber": 6,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "673203": {
      "optaId": "8ndcu9m0952u79qfvnmhux9wq",
      "heimPlayer": {
        "id": "100492147",
        "team_id": "1418",
        "person": {
          "id": "673203",
          "name": "Santiago Hezze",
          "firstname": "Santiago",
          "surname": "Hezze",
          "fullname": "Santiago Hezze",
          "gender": "male",
          "birthday": "22.10.2001",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "653384",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "8ndcu9m0952u79qfvnmhux9wq",
        "firstName": "Santiago",
        "lastName": "Hezze",
        "shortFirstName": "Santiago",
        "shortLastName": "Hezze",
        "matchName": "S. Hezze",
        "shirtNumber": 32,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "673874": {
      "optaId": "cdlnfuy9piyga0wud4nrucvtg",
      "heimPlayer": {
        "id": "101812541",
        "team_id": "205",
        "person": {
          "id": "673874",
          "name": "Ernest Poku",
          "firstname": "Ernest",
          "surname": "Poku",
          "fullname": "Ernest Poku",
          "gender": "male",
          "birthday": "28.01.2004",
          "height": "174",
          "weight": "64",
          "person_detail": {
            "id": "654055",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "cdlnfuy9piyga0wud4nrucvtg",
        "firstName": "Ernest",
        "lastName": "Poku",
        "shortFirstName": "Ernest",
        "shortLastName": "Poku",
        "matchName": "E. Poku",
        "shirtNumber": 19,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "675463": {
      "optaId": "4whvqapvco3c56audz34s6jv8",
      "heimPlayer": {
        "id": "102134957",
        "team_id": "2076",
        "person": {
          "id": "675463",
          "name": "Finn Jeltsch",
          "firstname": "Finn",
          "surname": "Jeltsch",
          "fullname": "Finn Jeltsch",
          "gender": "male",
          "birthday": "17.07.2006",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "655619",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Neuendettelsau",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "4whvqapvco3c56audz34s6jv8",
        "firstName": "Finn",
        "lastName": "Jeltsch",
        "shortFirstName": "Finn",
        "shortLastName": "Jeltsch",
        "matchName": "F. Jeltsch",
        "shirtNumber": 29,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "675867": {
      "optaId": "8855nyl8htw15u4y4apom7fxm",
      "heimPlayer": {
        "id": "101972933",
        "team_id": "2086",
        "person": {
          "id": "675867",
          "name": "Mohamed Amoura",
          "firstname": "Mohamed",
          "surname": "Amoura",
          "fullname": "Mohamed El Amine Amoura",
          "gender": "male",
          "birthday": "09.05.2000",
          "height": "170",
          "weight": "61",
          "person_detail": {
            "id": "656014",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Tahir",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "8855nyl8htw15u4y4apom7fxm",
        "firstName": "Mohammed El Amine",
        "lastName": "Amoura",
        "shortFirstName": "Mohammed",
        "shortLastName": "Amoura",
        "matchName": "M. Amoura",
        "shirtNumber": 9,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "676363": {
      "optaId": "d0azo0spzov2hg6ul40l58e3u",
      "heimPlayer": {
        "id": "98824732",
        "team_id": "1267",
        "person": {
          "id": "676363",
          "name": "Rico Lewis",
          "firstname": "Rico",
          "surname": "Lewis",
          "fullname": "Rico Henry Mark Lewis",
          "gender": "male",
          "birthday": "21.11.2004",
          "height": "170",
          "weight": "70",
          "person_detail": {
            "id": "656509",
            "position_1": "5",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Bury",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "20.01.2026 17:48",
        "shirtnumber": "82"
      },
      "optaPlayer": {
        "playerId": "d0azo0spzov2hg6ul40l58e3u",
        "firstName": "Rico Henry Mark",
        "lastName": "Lewis",
        "shortFirstName": "Rico",
        "shortLastName": "Lewis",
        "matchName": "R. Lewis",
        "shirtNumber": 82,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "676380": {
      "optaId": "6vkppmpdrvrujfp035ucpib8q",
      "heimPlayer": {
        "id": "102125072",
        "team_id": "21",
        "person": {
          "id": "676380",
          "name": "Sota Kawasaki",
          "firstname": "Sota",
          "surname": "Kawasaki",
          "fullname": "Sota Kawasaki",
          "gender": "male",
          "birthday": "30.07.2001",
          "height": "172",
          "weight": "70",
          "person_detail": {
            "id": "656526",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Kofu, Yamanashi",
            "died": "no"
          }
        },
        "created": "22.03.2026 17:10",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "6vkppmpdrvrujfp035ucpib8q",
        "firstName": "Sota",
        "lastName": "Kawasaki",
        "shortFirstName": "Sota",
        "shortLastName": "Kawasaki",
        "matchName": "S. Kawasaki",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "676877": {
      "optaId": "448wxnlqhqqf2hcecwut90n6y",
      "heimPlayer": {
        "id": "101862317",
        "team_id": "155",
        "person": {
          "id": "676877",
          "name": "Kamaldeen Sulemana",
          "firstname": "Kamaldeen",
          "surname": "Sulemana",
          "fullname": "Kamaldeen Sulemana",
          "gender": "male",
          "birthday": "15.02.2002",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "657028",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Techiman",
            "died": "no"
          },
          "country": [
            {
              "id": "66"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "448wxnlqhqqf2hcecwut90n6y",
        "firstName": "Kamaldeen",
        "lastName": "Sulemana",
        "shortFirstName": "Kamaldeen",
        "shortLastName": "Sulemana",
        "matchName": "K. Sulemana",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "677537": {
      "optaId": "cx6fxszjvjam6zb3c3p0dd1jo",
      "heimPlayer": {
        "id": "99152266",
        "team_id": "64",
        "person": {
          "id": "677537",
          "name": "Mika Godts",
          "firstname": "Mika",
          "surname": "Godts",
          "fullname": "Mika Marcel Godts",
          "gender": "male",
          "birthday": "07.06.2005",
          "height": "176",
          "weight": "",
          "person_detail": {
            "id": "657680",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Tienen",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "cx6fxszjvjam6zb3c3p0dd1jo",
        "firstName": "Mika Marcel",
        "lastName": "Godts",
        "shortFirstName": "Mika",
        "shortLastName": "Godts",
        "matchName": "M. Godts",
        "shirtNumber": 11,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "677614": {
      "optaId": "ai5p5wgft6c09bjbldz9sfeac",
      "heimPlayer": {
        "id": "100526263",
        "team_id": "136",
        "person": {
          "id": "677614",
          "name": "Simon Adingra",
          "firstname": "Simon",
          "surname": "Adingra",
          "fullname": "Simon Adingra",
          "gender": "male",
          "birthday": "01.01.2002",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "657757",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Abobo",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "25.02.2026 22:32",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "ai5p5wgft6c09bjbldz9sfeac",
        "firstName": "Simon Kofi",
        "lastName": "Adingra",
        "shortFirstName": "Simon",
        "shortLastName": "Adingra",
        "matchName": "S. Adingra",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "678955": {
      "optaId": "ijttr9nlo90ugxg03kyv7pxw",
      "heimPlayer": {
        "id": "100632544",
        "team_id": "5",
        "person": {
          "id": "678955",
          "name": "Frank Feller",
          "firstname": "Frank",
          "surname": "Feller",
          "fullname": "Frank Feller",
          "gender": "male",
          "birthday": "07.01.2004",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "659071",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Leonberg",
            "died": "no"
          }
        },
        "created": "28.02.2026 14:21",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "ijttr9nlo90ugxg03kyv7pxw",
        "firstName": "Frank",
        "lastName": "Feller",
        "shortFirstName": "Frank",
        "shortLastName": "Feller",
        "matchName": "F. Feller",
        "shirtNumber": 40,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "679992": {
      "optaId": "atlhc604ri3rr4w012otutyj8",
      "heimPlayer": {
        "id": "99235417",
        "team_id": "29680",
        "person": {
          "id": "679992",
          "name": "El Chadaïlle Bitshiabu",
          "firstname": "El Chadaïlle",
          "surname": "Bitshiabu",
          "fullname": "El Chadaïlle Bitshiabu",
          "gender": "male",
          "birthday": "16.05.2005",
          "height": "196",
          "weight": "95",
          "person_detail": {
            "id": "660083",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Villeneuve-Saint-Georges",
            "died": "no"
          }
        },
        "created": "31.01.2026 14:09",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "atlhc604ri3rr4w012otutyj8",
        "firstName": "El Chadaille",
        "lastName": "Bitshiabu",
        "shortFirstName": "El Chadaille",
        "shortLastName": "Bitshiabu",
        "matchName": "E. Bitshiabu",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "680054": {
      "optaId": "34z1r2585ifo6zdcfuu6xumfo",
      "heimPlayer": {
        "id": "98509654",
        "team_id": "594",
        "person": {
          "id": "680054",
          "name": "Ismaël Gharbi",
          "firstname": "Ismaël",
          "surname": "Gharbi",
          "fullname": "Ismaël Seifallah Gharbi Álvarez",
          "gender": "male",
          "birthday": "10.04.2004",
          "height": "173",
          "weight": "66",
          "person_detail": {
            "id": "660145",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Paris",
            "died": "no"
          }
        },
        "created": "11.01.2026 16:50",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "34z1r2585ifo6zdcfuu6xumfo",
        "firstName": "Ismaël Seifallah",
        "lastName": "Gharbi Álvarez",
        "shortFirstName": "Ismaël",
        "shortLastName": "Gharbi",
        "matchName": "I. Gharbi",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "681415": {
      "optaId": "3tpfqju821lze7myekb40kefo",
      "heimPlayer": {
        "id": "101607884",
        "team_id": "2134",
        "person": {
          "id": "681415",
          "name": "Julián Malatini",
          "firstname": "Julián",
          "surname": "Malatini",
          "fullname": "Julián Malatini",
          "gender": "male",
          "birthday": "31.05.2001",
          "height": "191",
          "weight": "84",
          "person_detail": {
            "id": "661480",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "General Cabrera, Cordoba",
            "died": "no"
          }
        },
        "created": "15.03.2026 14:16",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "3tpfqju821lze7myekb40kefo",
        "firstName": "Julián",
        "lastName": "Malatini",
        "shortFirstName": "Julián",
        "shortLastName": "Malatini",
        "matchName": "J. Malatini",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "682391": {
      "optaId": "cegoeac3l2owi83zdvu30tj6y",
      "heimPlayer": {
        "id": "101804831",
        "team_id": "749",
        "person": {
          "id": "682391",
          "name": "Ole Blomberg",
          "firstname": "Ole",
          "surname": "Blomberg",
          "fullname": "Ole Didrik Blomberg",
          "gender": "male",
          "birthday": "12.06.2000",
          "height": "177",
          "weight": "71",
          "person_detail": {
            "id": "662452",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Bergen",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "cegoeac3l2owi83zdvu30tj6y",
        "firstName": "Ole Didrik",
        "lastName": "Blomberg",
        "shortFirstName": "Ole Didrik",
        "shortLastName": "Blomberg",
        "matchName": "O. Blomberg",
        "shirtNumber": 11,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "684338": {
      "optaId": "bf7ph89zhr5y6rtct5k9bvqc4",
      "heimPlayer": {
        "id": "101864393",
        "team_id": "1355",
        "person": {
          "id": "684338",
          "name": "William Osula",
          "firstname": "William",
          "surname": "Osula",
          "fullname": "William Idamudia Daugaard Osula",
          "gender": "male",
          "birthday": "04.08.2003",
          "height": "191",
          "weight": "81",
          "person_detail": {
            "id": "664375",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Aarhus",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "18.03.2026 20:31",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "bf7ph89zhr5y6rtct5k9bvqc4",
        "firstName": "William Idamudia Daugaard",
        "lastName": "Osula",
        "shortFirstName": "William",
        "shortLastName": "Osula",
        "matchName": "W. Osula",
        "shirtNumber": 18,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "688430": {
      "optaId": "3gylv681hddh1qhi0p07esf84",
      "heimPlayer": {
        "id": "101975984",
        "team_id": "9",
        "person": {
          "id": "688430",
          "name": "Cenny Neumann",
          "firstname": "Cenny",
          "surname": "Neumann",
          "fullname": "Cenny Neumann",
          "gender": "male",
          "birthday": "12.01.2007",
          "height": "178",
          "weight": "",
          "person_detail": {
            "id": "668445",
            "position_1": "5",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Chemnitz",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:26",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "3gylv681hddh1qhi0p07esf84",
        "firstName": "Cenny",
        "lastName": "Neumann",
        "shortFirstName": "Cenny",
        "shortLastName": "Neumann",
        "matchName": "C. Neumann",
        "shirtNumber": 36,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "689894": {
      "optaId": "7a12t0i88yxasiu0cj0sgqpzo",
      "heimPlayer": {
        "id": "101627777",
        "team_id": "19",
        "person": {
          "id": "689894",
          "name": "Ilyas Ansah",
          "firstname": "Ilyas",
          "surname": "Ansah",
          "fullname": "Ilyas Ansah",
          "gender": "male",
          "birthday": "08.11.2004",
          "height": "194",
          "weight": "84",
          "person_detail": {
            "id": "669901",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Lüdenscheid",
            "died": "no"
          }
        },
        "created": "15.03.2026 16:17",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "7a12t0i88yxasiu0cj0sgqpzo",
        "firstName": "Ilyas",
        "lastName": "Ansah",
        "shortFirstName": "Ilyas",
        "shortLastName": "Ansah",
        "matchName": "I. Ansah",
        "shirtNumber": 10,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "9"
      }
    },
    "690075": {
      "optaId": "chxqf35ulanj3zcino8zrufsa",
      "heimPlayer": {
        "id": "100150156",
        "team_id": "18670",
        "person": {
          "id": "690075",
          "name": "Leandro Andrade",
          "firstname": "",
          "surname": "Leandro Andrade",
          "fullname": "Leandro Livramento Andrade",
          "gender": "male",
          "birthday": "24.09.1999",
          "height": "177",
          "weight": "75",
          "person_detail": {
            "id": "670074",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Tavira",
            "died": "no"
          },
          "country": [
            {
              "id": "99"
            }
          ]
        },
        "created": "18.02.2026 17:36",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "chxqf35ulanj3zcino8zrufsa",
        "firstName": "Leandro",
        "lastName": "Livramento Andrade",
        "shortFirstName": "Leandro",
        "shortLastName": "Livramento Andrade",
        "knownName": "Leandro Andrade",
        "matchName": "Leandro Andrade",
        "shirtNumber": 15,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "690635": {
      "optaId": "rvqiq9rz1ur11jb8skb7419m",
      "heimPlayer": {
        "id": "102116822",
        "team_id": "702",
        "person": {
          "id": "690635",
          "name": "Arkadiusz Pyrka",
          "firstname": "Arkadiusz",
          "surname": "Pyrka",
          "fullname": "Arkadiusz Pyrka",
          "gender": "male",
          "birthday": "20.09.2002",
          "height": "177",
          "weight": "70",
          "person_detail": {
            "id": "670611",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Radom",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "rvqiq9rz1ur11jb8skb7419m",
        "firstName": "Arkadiusz",
        "lastName": "Pyrka",
        "shortFirstName": "Arkadiusz",
        "shortLastName": "Pyrka",
        "matchName": "A. Pyrka",
        "shirtNumber": 11,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "691025": {
      "optaId": "66psa7xh8odnlp39ue5vzpes4",
      "heimPlayer": {
        "id": "98853811",
        "team_id": "597",
        "person": {
          "id": "691025",
          "name": "Roony Bardghji",
          "firstname": "Roony",
          "surname": "Bardghji",
          "fullname": "Roony Bardghji",
          "gender": "male",
          "birthday": "15.11.2005",
          "height": "173",
          "weight": "70",
          "person_detail": {
            "id": "670996",
            "position_1": "9",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Kuwait City",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "21.01.2026 19:56",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "66psa7xh8odnlp39ue5vzpes4",
        "firstName": "Roony",
        "lastName": "Bardghji",
        "shortFirstName": "Roony",
        "shortLastName": "Bardghji",
        "matchName": "R. Bardghji",
        "shirtNumber": 28,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "692094": {
      "optaId": "xeybxsihh2ggg35oz4ws6jv8",
      "heimPlayer": {
        "id": "102117167",
        "team_id": "1639",
        "person": {
          "id": "692094",
          "name": "Bruno Ogbus",
          "firstname": "Bruno",
          "surname": "Ogbus",
          "fullname": "Bruno Ifechukwu Ogbus",
          "gender": "male",
          "birthday": "17.12.2005",
          "height": "185",
          "weight": "86",
          "person_detail": {
            "id": "672034",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Neunkirch",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "43"
      },
      "optaPlayer": {
        "playerId": "xeybxsihh2ggg35oz4ws6jv8",
        "firstName": "Bruno Ifechukwu",
        "lastName": "Ogbus",
        "shortFirstName": "Bruno",
        "shortLastName": "Ogbus",
        "matchName": "B. Ogbus",
        "shirtNumber": 43,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "692127": {
      "optaId": "6g4cnzr3dh0veul5svzkhmxw4",
      "heimPlayer": {
        "id": "102117170",
        "team_id": "1639",
        "person": {
          "id": "692127",
          "name": "Johan Manzambi",
          "firstname": "Johan",
          "surname": "Manzambi",
          "fullname": "Johan Manzambi",
          "gender": "male",
          "birthday": "14.10.2005",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "672067",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Genève",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "6g4cnzr3dh0veul5svzkhmxw4",
        "firstName": "Johan",
        "lastName": "Manzambi",
        "shortFirstName": "Johan",
        "shortLastName": "Manzambi",
        "matchName": "J. Manzambi",
        "shirtNumber": 44,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "692915": {
      "optaId": "3nok8qxxj2zl831wgvc7abxuc",
      "heimPlayer": {
        "id": "101936504",
        "team_id": "29680",
        "person": {
          "id": "692915",
          "name": "Conrad Harder",
          "firstname": "Conrad",
          "surname": "Harder",
          "fullname": "Conrad Harder Weibel Schandorf",
          "gender": "male",
          "birthday": "07.04.2005",
          "height": "185",
          "weight": "82",
          "person_detail": {
            "id": "672847",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Holte",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:11",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "3nok8qxxj2zl831wgvc7abxuc",
        "firstName": "Conrad",
        "lastName": "Harder Weibel Schandorf",
        "shortFirstName": "Conrad",
        "shortLastName": "Harder",
        "matchName": "C. Harder",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "693594": {
      "optaId": "anycrq4ug1ee012dw68tpsh2i",
      "heimPlayer": {
        "id": "102142997",
        "team_id": "702",
        "person": {
          "id": "693594",
          "name": "Andréas Hountondji",
          "firstname": "Andréas",
          "surname": "Hountondji",
          "fullname": "Andréas Hountondji",
          "gender": "male",
          "birthday": "11.07.2002",
          "height": "190",
          "weight": "86",
          "person_detail": {
            "id": "673524",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Montry",
            "died": "no"
          }
        },
        "created": "22.03.2026 19:13",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "anycrq4ug1ee012dw68tpsh2i",
        "firstName": "Andréas William Edwin",
        "lastName": "Hountondji",
        "shortFirstName": "Andréas",
        "shortLastName": "Hountondji",
        "matchName": "A. Hountondji",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "694397": {
      "optaId": "c9e54hwefvwos94ri459uylbe",
      "heimPlayer": {
        "id": "100518820",
        "team_id": "258",
        "person": {
          "id": "694397",
          "name": "Daniel Svensson",
          "firstname": "Daniel",
          "surname": "Svensson",
          "fullname": "Daniel Jonathan Svensson",
          "gender": "male",
          "birthday": "12.02.2002",
          "height": "183",
          "weight": "72",
          "person_detail": {
            "id": "674318",
            "position_1": "3",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Stockholm",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "25.02.2026 17:39",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "c9e54hwefvwos94ri459uylbe",
        "firstName": "Daniel Jonathan",
        "lastName": "Svensson",
        "shortFirstName": "Daniel",
        "shortLastName": "Svensson",
        "matchName": "D. Svensson",
        "shirtNumber": 24,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "695046": {
      "optaId": "9ic9msq3tj4gx8wqa6wfwk50q",
      "heimPlayer": {
        "id": "101057581",
        "team_id": "943",
        "person": {
          "id": "695046",
          "name": "Giorgi Gocholeishvili",
          "firstname": "Giorgi",
          "surname": "Gocholeishvili",
          "fullname": "Giorgi Gocholeishvili",
          "gender": "male",
          "birthday": "14.02.2001",
          "height": "178",
          "weight": "70",
          "person_detail": {
            "id": "674959",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Kutaisi",
            "died": "no"
          }
        },
        "created": "07.03.2026 17:18",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "9ic9msq3tj4gx8wqa6wfwk50q",
        "firstName": "Giorgi",
        "lastName": "Gocholeishvili",
        "shortFirstName": "Giorgi",
        "shortLastName": "Gocholeishvili",
        "matchName": "G. Gocholeishvili",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "695355": {
      "optaId": "52bg33ueyjgfvlh0x4n4rks2c",
      "heimPlayer": {
        "id": "100521952",
        "team_id": "136",
        "person": {
          "id": "695355",
          "name": "Mamadou Coulibaly",
          "firstname": "Mamadou",
          "surname": "Coulibaly",
          "fullname": "Mamadou Coulibaly",
          "gender": "male",
          "birthday": "21.04.2004",
          "height": "183",
          "weight": "75",
          "person_detail": {
            "id": "675267",
            "position_1": "0",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Paris",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "52bg33ueyjgfvlh0x4n4rks2c",
        "firstName": "Mamadou",
        "lastName": "Coulibaly",
        "shortFirstName": "Mamadou",
        "shortLastName": "Coulibaly",
        "matchName": "M. Coulibaly",
        "shirtNumber": 28,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "697124": {
      "optaId": "bc32mchq3v7fci4vy04e37yms",
      "heimPlayer": {
        "id": "100598974",
        "team_id": "9",
        "person": {
          "id": "697124",
          "name": "Fynn Schenten",
          "firstname": "Fynn",
          "surname": "Schenten",
          "fullname": "Fynn Schenten",
          "gender": "male",
          "birthday": "14.09.2007",
          "height": "187",
          "weight": "",
          "person_detail": {
            "id": "677023",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "27.02.2026 22:11",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "bc32mchq3v7fci4vy04e37yms",
        "firstName": "Fynn",
        "lastName": "Schenten",
        "shortFirstName": "Fynn",
        "shortLastName": "Schenten",
        "matchName": "F. Schenten",
        "shirtNumber": 40,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "697214": {
      "optaId": "cp5t077hogyhom0scrziguyju",
      "heimPlayer": {
        "id": "102117164",
        "team_id": "1639",
        "person": {
          "id": "697214",
          "name": "Jordy Makengo",
          "firstname": "Jordy",
          "surname": "Makengo",
          "fullname": "Jordy Makengo Basambundu",
          "gender": "male",
          "birthday": "03.08.2001",
          "height": "191",
          "weight": "78",
          "person_detail": {
            "id": "677113",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Saint-Denis",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:20",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "cp5t077hogyhom0scrziguyju",
        "firstName": "Jordy",
        "lastName": "Makengo Basambundu",
        "shortFirstName": "Jordy",
        "shortLastName": "Makengo",
        "matchName": "J. Makengo",
        "shirtNumber": 33,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "697301": {
      "optaId": "9cbp20wyy4ldod06myqbmkqok",
      "heimPlayer": {
        "id": "98854798",
        "team_id": "530",
        "person": {
          "id": "697301",
          "name": "Oscar Højlund",
          "firstname": "Oscar",
          "surname": "Højlund",
          "fullname": "Oscar Winther Højlund",
          "gender": "male",
          "birthday": "04.01.2005",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "677200",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "København",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "21.01.2026 20:29",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "9cbp20wyy4ldod06myqbmkqok",
        "firstName": "Oscar",
        "lastName": "Winther Højlund",
        "shortFirstName": "Oscar",
        "shortLastName": "Højlund",
        "matchName": "O. Højlund",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "697303": {
      "optaId": "17iz3i6kzdxc115bdlgcgqdck",
      "heimPlayer": {
        "id": "102001958",
        "team_id": "2086",
        "person": {
          "id": "697303",
          "name": "Adam Daghim",
          "firstname": "Adam",
          "surname": "Daghim",
          "fullname": "Adam Daghim",
          "gender": "male",
          "birthday": "28.09.2005",
          "height": "185",
          "weight": "75",
          "person_detail": {
            "id": "677202",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Vanløse",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:07",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "17iz3i6kzdxc115bdlgcgqdck",
        "firstName": "Adam",
        "lastName": "Daghim",
        "shortFirstName": "Adam",
        "shortLastName": "Daghim",
        "matchName": "A. Daghim",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "697308": {
      "optaId": "bqh87676f46jsdfftw2gt1mok",
      "heimPlayer": {
        "id": "97691767",
        "team_id": "749",
        "person": {
          "id": "697308",
          "name": "Villads Nielsen",
          "firstname": "Villads",
          "surname": "Nielsen",
          "fullname": "Villads Schmidt Nielsen",
          "gender": "male",
          "birthday": "29.01.2005",
          "height": "192",
          "weight": "80",
          "person_detail": {
            "id": "677207",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "45"
            }
          ]
        },
        "created": "10.12.2025 22:26",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "bqh87676f46jsdfftw2gt1mok",
        "firstName": "Villads",
        "lastName": "Schmidt Nielsen",
        "shortFirstName": "Villads",
        "shortLastName": "Nielsen",
        "matchName": "V. Nielsen",
        "shirtNumber": 2,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "699372": {
      "optaId": "enpkvxwcyv4sqfzulxwmvxmac",
      "heimPlayer": {
        "id": "101867927",
        "team_id": "209",
        "person": {
          "id": "699372",
          "name": "Deniz Ofli",
          "firstname": "Deniz",
          "surname": "Ofli",
          "fullname": "Deniz Emre Ofli",
          "gender": "male",
          "birthday": "29.03.2007",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "679263",
            "position_1": "3",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "München",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.03.2026 22:15",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "enpkvxwcyv4sqfzulxwmvxmac",
        "firstName": "Deniz Emre",
        "lastName": "Ofli",
        "shortFirstName": "Deniz",
        "shortLastName": "Ofli",
        "matchName": "D. Ofli",
        "shirtNumber": 34,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "699378": {
      "optaId": "qt1wbjej8amtydluzvfudhxw",
      "heimPlayer": {
        "id": "101003197",
        "team_id": "209",
        "person": {
          "id": "699378",
          "name": "David Daiber",
          "firstname": "",
          "surname": "David Daiber",
          "fullname": "David Michael Santos Daiber",
          "gender": "male",
          "birthday": "10.01.2007",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "679269",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "06.03.2026 22:10",
        "shirtnumber": "47"
      },
      "optaPlayer": {
        "playerId": "qt1wbjej8amtydluzvfudhxw",
        "firstName": "David Michael",
        "lastName": "Santos Daiber",
        "shortFirstName": "David Michael",
        "shortLastName": "Santos Daiber",
        "knownName": "David Santos",
        "matchName": "David Santos",
        "shirtNumber": 47,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "699379": {
      "optaId": "4r3am2657ubdk372od3oqm1g",
      "heimPlayer": {
        "id": "102000494",
        "team_id": "9",
        "person": {
          "id": "699379",
          "name": "Felipe Chávez",
          "firstname": "Felipe",
          "surname": "Chávez",
          "fullname": "Felipe Marlon Chávez Somocursio",
          "gender": "male",
          "birthday": "10.04.2007",
          "height": "177",
          "weight": "",
          "person_detail": {
            "id": "679270",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Aichach",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:59",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "4r3am2657ubdk372od3oqm1g",
        "firstName": "Felipe Marlon",
        "lastName": "Chávez Somocursio",
        "shortFirstName": "Felipe",
        "shortLastName": "Chávez",
        "matchName": "F. Chávez",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "699604": {
      "optaId": "1hpivlohlnwpw0hyr9gxv5gk4",
      "heimPlayer": {
        "id": "101634068",
        "team_id": "2134",
        "person": {
          "id": "699604",
          "name": "Patrice Čović",
          "firstname": "Patrice",
          "surname": "Čović",
          "fullname": "Patrice Čović",
          "gender": "male",
          "birthday": "25.06.2007",
          "height": "176",
          "weight": "68",
          "person_detail": {
            "id": "679493",
            "position_1": "8",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Berlin",
            "died": "no"
          }
        },
        "created": "15.03.2026 16:57",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "1hpivlohlnwpw0hyr9gxv5gk4",
        "firstName": "Patrice",
        "lastName": "Čović",
        "shortFirstName": "Patrice",
        "shortLastName": "Covic",
        "matchName": "P. Čović",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "700531": {
      "optaId": "2ofcow1hf3b245myztjgvvqc4",
      "heimPlayer": {
        "id": "101925524",
        "team_id": "29680",
        "person": {
          "id": "700531",
          "name": "Rômulo",
          "firstname": "",
          "surname": "Rômulo",
          "fullname": "Rômulo José Cardoso da Cruz",
          "gender": "male",
          "birthday": "08.02.2002",
          "height": "193",
          "weight": "85",
          "person_detail": {
            "id": "680419",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Marialva",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "2ofcow1hf3b245myztjgvvqc4",
        "firstName": "Rômulo José",
        "lastName": "Cardoso da Cruz",
        "shortFirstName": "Rômulo José",
        "shortLastName": "Cardoso da Cruz",
        "knownName": "Rômulo",
        "matchName": "Rômulo",
        "shirtNumber": 40,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "701180": {
      "optaId": "cxjhkrssym30glew7p7in04k4",
      "heimPlayer": {
        "id": "100394365",
        "team_id": "5",
        "person": {
          "id": "701180",
          "name": "Adam Kölle",
          "firstname": "Adam",
          "surname": "Kölle",
          "fullname": "Adam Kölle",
          "gender": "male",
          "birthday": "28.04.2006",
          "height": "195",
          "weight": "91",
          "person_detail": {
            "id": "681068",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Tübingen",
            "died": "no"
          }
        },
        "created": "22.02.2026 21:08",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "cxjhkrssym30glew7p7in04k4",
        "firstName": "Adam",
        "lastName": "Kölle",
        "shortFirstName": "Adam",
        "shortLastName": "Kölle",
        "matchName": "A. Kölle",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "701238": {
      "optaId": "5rnmjho9ntzolo7ogkhyaey38",
      "heimPlayer": {
        "id": "98850676",
        "team_id": "530",
        "person": {
          "id": "701238",
          "name": "Kauã Santos",
          "firstname": "",
          "surname": "Kauã Santos",
          "fullname": "Kauã Morais Vieira dos Santos",
          "gender": "male",
          "birthday": "11.04.2003",
          "height": "196",
          "weight": "85",
          "person_detail": {
            "id": "681126",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Vassouras",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "5rnmjho9ntzolo7ogkhyaey38",
        "firstName": "Kauã",
        "lastName": "Morais Vieira dos Santos",
        "shortFirstName": "Kauã",
        "shortLastName": "Morais Vieira dos Santos",
        "knownName": "Kauã Santos",
        "matchName": "Kauã Santos",
        "shirtNumber": 40,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "701239": {
      "optaId": "9rglo47kroo6ob6gy7i4poqok",
      "heimPlayer": {
        "id": "100502290",
        "team_id": "205",
        "person": {
          "id": "701239",
          "name": "Arthur",
          "firstname": "",
          "surname": "Arthur",
          "fullname": "Arthur Augusto de Matos Soares",
          "gender": "male",
          "birthday": "17.03.2003",
          "height": "173",
          "weight": "69",
          "person_detail": {
            "id": "681127",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Belo Horizonte - MG",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 22:32",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "9rglo47kroo6ob6gy7i4poqok",
        "firstName": "Arthur Augusto",
        "lastName": "de Matos Soares",
        "shortFirstName": "Arthur Augusto",
        "shortLastName": "de Matos Soares",
        "knownName": "Arthur",
        "matchName": "Arthur",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "701658": {
      "optaId": "6q0iuwoa8olkezlg4vo04je5m",
      "heimPlayer": {
        "id": "101861132",
        "team_id": "853",
        "person": {
          "id": "701658",
          "name": "Barış Yılmaz",
          "firstname": "Barış",
          "surname": "Yılmaz",
          "fullname": "Barış Alper Yılmaz",
          "gender": "male",
          "birthday": "23.05.2000",
          "height": "186",
          "weight": "80",
          "person_detail": {
            "id": "681546",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Rize",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "18.03.2026 19:47",
        "shirtnumber": "53"
      },
      "optaPlayer": {
        "playerId": "6q0iuwoa8olkezlg4vo04je5m",
        "firstName": "Barış Alper",
        "lastName": "Yılmaz",
        "shortFirstName": "Baris Alper",
        "shortLastName": "Yilmaz",
        "matchName": "B. Yılmaz",
        "shirtNumber": 53,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "702445": {
      "optaId": "743i0lyudasctc2cmxz851hxw",
      "heimPlayer": {
        "id": "101821835",
        "team_id": "205",
        "person": {
          "id": "702445",
          "name": "Montrell Culbreath",
          "firstname": "Montrell",
          "surname": "Culbreath",
          "fullname": "Montrell Amare Culbreath",
          "gender": "male",
          "birthday": "29.08.2007",
          "height": "172",
          "weight": "",
          "person_detail": {
            "id": "682326",
            "position_1": "12",
            "position_2": "9",
            "preferred_side": "unknown",
            "birth_place": "Landstuhl",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "17.03.2026 22:16",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "743i0lyudasctc2cmxz851hxw",
        "firstName": "Montrell",
        "lastName": "Amare Culbreath",
        "shortFirstName": "Montrell",
        "shortLastName": "Culbreath",
        "matchName": "M. Culbreath",
        "shirtNumber": 42,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "702970": {
      "optaId": "bfdtduknquzhr2br7ahlgvvo4",
      "heimPlayer": {
        "id": "99153007",
        "team_id": "2102",
        "person": {
          "id": "702970",
          "name": "Renato Veiga",
          "firstname": "",
          "surname": "Renato Veiga",
          "fullname": "Renato Palma Veiga",
          "gender": "male",
          "birthday": "29.07.2003",
          "height": "190",
          "weight": "83",
          "person_detail": {
            "id": "682850",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Lisboa",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "bfdtduknquzhr2br7ahlgvvo4",
        "firstName": "Renato",
        "lastName": "Palma Veiga",
        "shortFirstName": "Renato",
        "shortLastName": "Palma Veiga",
        "knownName": "Renato Veiga",
        "matchName": "Renato Veiga",
        "shirtNumber": 12,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "704122": {
      "optaId": "cv46mxj5i98p4hgtbomxlxs7o",
      "heimPlayer": {
        "id": "100521739",
        "team_id": "1094",
        "person": {
          "id": "704122",
          "name": "Federico Gatti",
          "firstname": "Federico",
          "surname": "Gatti",
          "fullname": "Federico Gatti",
          "gender": "male",
          "birthday": "24.06.1998",
          "height": "190",
          "weight": "84",
          "person_detail": {
            "id": "683961",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Rivoli",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "25.02.2026 19:55",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "cv46mxj5i98p4hgtbomxlxs7o",
        "firstName": "Federico",
        "lastName": "Gatti",
        "shortFirstName": "Federico",
        "shortLastName": "Gatti",
        "matchName": "F. Gatti",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "707309": {
      "optaId": "8vhqai1dxnmk0pjqt32tyb5ec",
      "heimPlayer": {
        "id": "93953894",
        "team_id": "5",
        "person": {
          "id": "707309",
          "name": "Tobias Weigel",
          "firstname": "Tobias",
          "surname": "Weigel",
          "fullname": "Tobias Weigel",
          "gender": "male",
          "birthday": "26.04.2007",
          "height": "175",
          "weight": "",
          "person_detail": {
            "id": "687139",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Heidenheim an der Brenz",
            "died": "no"
          }
        },
        "created": "05.10.2025 17:17",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "8vhqai1dxnmk0pjqt32tyb5ec",
        "firstName": "Tobias",
        "lastName": "Weigel",
        "shortFirstName": "Tobias",
        "shortLastName": "Weigel",
        "matchName": "T. Weigel",
        "shirtNumber": 37,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "709588": {
      "optaId": "1qva22ouiudjynfrfoeduq9sk",
      "heimPlayer": {
        "id": "100501666",
        "team_id": "1418",
        "person": {
          "id": "709588",
          "name": "André Luiz",
          "firstname": "",
          "surname": "André Luiz",
          "fullname": "André Luiz Inácio da Silva",
          "gender": "male",
          "birthday": "23.02.2002",
          "height": "187",
          "weight": "79",
          "person_detail": {
            "id": "689402",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Rio De Janeiro",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "24.02.2026 22:21",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "1qva22ouiudjynfrfoeduq9sk",
        "firstName": "André Luiz",
        "lastName": "Inácio da Silva",
        "shortFirstName": "André Luiz",
        "shortLastName": "Inácio da Silva",
        "knownName": "André Luiz",
        "matchName": "André Luiz",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "709996": {
      "optaId": "7ax7vrumfwlxb8a4tchkho650",
      "heimPlayer": {
        "id": "99159901",
        "team_id": "1776",
        "person": {
          "id": "709996",
          "name": "Alisson Santos",
          "firstname": "",
          "surname": "Alisson Santos",
          "fullname": "Alisson de Almeida Santos",
          "gender": "male",
          "birthday": "27.09.2002",
          "height": "177",
          "weight": "70",
          "person_detail": {
            "id": "689803",
            "position_1": "10",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Itapetinga - BA",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 22:45",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "7ax7vrumfwlxb8a4tchkho650",
        "firstName": "Alisson",
        "lastName": "de Almeida Santos",
        "shortFirstName": "Alisson",
        "shortLastName": "de Almeida Santos",
        "knownName": "Alisson Santos",
        "matchName": "Alisson Santos",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "710180": {
      "optaId": "amcwh6w0brmkttg4uc5qm6z9w",
      "heimPlayer": {
        "id": "101868167",
        "team_id": "209",
        "person": {
          "id": "710180",
          "name": "Nicolas Jackson",
          "firstname": "Nicolas",
          "surname": "Jackson",
          "fullname": "Nicolas Jackson",
          "gender": "male",
          "birthday": "20.06.2001",
          "height": "187",
          "weight": "80",
          "person_detail": {
            "id": "689987",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Banjul",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "18.03.2026 22:31",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "amcwh6w0brmkttg4uc5qm6z9w",
        "firstName": "Nicolas",
        "lastName": "Jackson",
        "shortFirstName": "Nicolas",
        "shortLastName": "Jackson",
        "matchName": "N. Jackson",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "710365": {
      "optaId": "f46s4bfeipn0k33s0brsu4yl0",
      "heimPlayer": {
        "id": "91567814",
        "team_id": "5",
        "person": {
          "id": "710365",
          "name": "Léo Scienza",
          "firstname": "",
          "surname": "Léo Scienza",
          "fullname": "Leonardo Weschenfelder Scienza",
          "gender": "male",
          "birthday": "13.09.1998",
          "height": "175",
          "weight": "69",
          "person_detail": {
            "id": "690172",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Venancio Aires",
            "died": "no"
          }
        },
        "created": "30.08.2025 14:26",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "f46s4bfeipn0k33s0brsu4yl0",
        "firstName": "Leonardo",
        "lastName": "Weschenfelder Scienza",
        "shortFirstName": "Leonardo",
        "shortLastName": "Weschenfelder Scienza",
        "knownName": "Léo Scienza",
        "matchName": "Léo Scienza",
        "shirtNumber": 8,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "710685": {
      "optaId": "d2djen6mte9953h6n4y79by1g",
      "heimPlayer": {
        "id": "102154934",
        "team_id": "594",
        "person": {
          "id": "710685",
          "name": "Arthur Chaves",
          "firstname": "",
          "surname": "Arthur Chaves",
          "fullname": "Arthur Largura Chaves",
          "gender": "male",
          "birthday": "29.01.2001",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "690492",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Florianópolis",
            "died": "no"
          }
        },
        "created": "22.03.2026 20:35",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "d2djen6mte9953h6n4y79by1g",
        "firstName": "Arthur",
        "lastName": "Largura Chaves",
        "shortFirstName": "Arthur",
        "shortLastName": "Largura Chaves",
        "knownName": "Arthur Chaves",
        "matchName": "Arthur Chaves",
        "shirtNumber": 34,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "712130": {
      "optaId": "8wcpxluqhub8yqrgi1jcvzbx0",
      "heimPlayer": {
        "id": "101359598",
        "team_id": "1776",
        "person": {
          "id": "712130",
          "name": "Luis Guilherme",
          "firstname": "",
          "surname": "Luis Guilherme",
          "fullname": "Luis Guilherme Lira dos Santos",
          "gender": "male",
          "birthday": "09.02.2006",
          "height": "175",
          "weight": "74",
          "person_detail": {
            "id": "691930",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Aracaju",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "11.03.2026 19:49",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "8wcpxluqhub8yqrgi1jcvzbx0",
        "firstName": "Luis Guilherme",
        "lastName": "Lira dos Santos",
        "shortFirstName": "Luis Guilherme",
        "shortLastName": "Lira dos Santos",
        "knownName": "Luis Guilherme",
        "matchName": "Luis Guilherme",
        "shirtNumber": 31,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "713699": {
      "optaId": "7wz2sc3d07aaduyhmihffa2hg",
      "heimPlayer": {
        "id": "95825563",
        "team_id": "64",
        "person": {
          "id": "713699",
          "name": "James McConnell",
          "firstname": "James",
          "surname": "McConnell",
          "fullname": "James McConnell",
          "gender": "male",
          "birthday": "13.09.2004",
          "height": "188",
          "weight": "",
          "person_detail": {
            "id": "693483",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Morpeth",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "05.11.2025 22:39",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "7wz2sc3d07aaduyhmihffa2hg",
        "firstName": "James William",
        "lastName": "McConnell",
        "shortFirstName": "James",
        "shortLastName": "McConnell",
        "matchName": "J. McConnell",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "714232": {
      "optaId": "ejbp3sxls7lgrg6y3a9q4u978",
      "heimPlayer": {
        "id": "100501597",
        "team_id": "1052",
        "person": {
          "id": "714232",
          "name": "Ange-Yoan Bonny",
          "firstname": "Ange-Yoan",
          "surname": "Bonny",
          "fullname": "Ange-Yoan Bonny",
          "gender": "male",
          "birthday": "25.10.2003",
          "height": "189",
          "weight": "86",
          "person_detail": {
            "id": "694016",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Aubervilliers",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "24.02.2026 22:19",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "ejbp3sxls7lgrg6y3a9q4u978",
        "firstName": "Ange-Yoan",
        "lastName": "Bonny",
        "shortFirstName": "Ange-Yoan",
        "shortLastName": "Bonny",
        "matchName": "A. Bonny",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "718635": {
      "optaId": "avg54tzd7cxjld09569czfgus",
      "heimPlayer": {
        "id": "98625787",
        "team_id": "19",
        "person": {
          "id": "718635",
          "name": "Marin Ljubičić",
          "firstname": "Marin",
          "surname": "Ljubičić",
          "fullname": "Marin Ljubičić",
          "gender": "male",
          "birthday": "28.02.2002",
          "height": "183",
          "weight": "77",
          "person_detail": {
            "id": "698386",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Split",
            "died": "no"
          }
        },
        "created": "15.01.2026 22:15",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "avg54tzd7cxjld09569czfgus",
        "firstName": "Marin",
        "lastName": "Ljubičić",
        "shortFirstName": "Marin",
        "shortLastName": "Ljubicic",
        "matchName": "M. Ljubičić",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "719674": {
      "optaId": "43n6lws8fguddvg3e4ukfrpw",
      "heimPlayer": {
        "id": "98824726",
        "team_id": "1267",
        "person": {
          "id": "719674",
          "name": "Max Alleyne",
          "firstname": "Max",
          "surname": "Alleyne",
          "fullname": "Max Lewis Rowe Alleyne",
          "gender": "male",
          "birthday": "21.07.2005",
          "height": "185",
          "weight": "71",
          "person_detail": {
            "id": "699416",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Bristol",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "20.01.2026 17:48",
        "shirtnumber": "68"
      },
      "optaPlayer": {
        "playerId": "43n6lws8fguddvg3e4ukfrpw",
        "firstName": "Max",
        "lastName": "Lewis Rowe Alleyne",
        "shortFirstName": "Max",
        "shortLastName": "Alleyne",
        "matchName": "M. Alleyne",
        "shirtNumber": 68,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "720379": {
      "optaId": "dlcwv2hk2e20j76xcq7bdiu7e",
      "heimPlayer": {
        "id": "99154657",
        "team_id": "17544",
        "person": {
          "id": "720379",
          "name": "Jorginho",
          "firstname": "",
          "surname": "Jorginho",
          "fullname": "Jorge Gabriel Costa Monteiro",
          "gender": "male",
          "birthday": "09.11.1997",
          "height": "169",
          "weight": "65",
          "person_detail": {
            "id": "700120",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Braga",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "dlcwv2hk2e20j76xcq7bdiu7e",
        "firstName": "Jorge Gabriel",
        "lastName": "Costa Monteiro",
        "shortFirstName": "Jorge Gabriel",
        "shortLastName": "Costa Monteiro",
        "knownName": "Jorginho",
        "matchName": "Jorginho",
        "shirtNumber": 7,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "722064": {
      "optaId": "d0kzduhj90areaill2gvvw6xg",
      "heimPlayer": {
        "id": "99152545",
        "team_id": "162",
        "person": {
          "id": "722064",
          "name": "Marc Pubill",
          "firstname": "",
          "surname": "Marc Pubill",
          "fullname": "Marc Pubill Pagés",
          "gender": "male",
          "birthday": "20.06.2003",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "701799",
            "position_1": "5",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Manresa",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "d0kzduhj90areaill2gvvw6xg",
        "firstName": "Marc",
        "lastName": "Pubill Pagès",
        "shortFirstName": "Marc",
        "shortLastName": "Pubill",
        "matchName": "Marc Pubill",
        "shirtNumber": 18,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "729362": {
      "optaId": "130pg17ru5fzq4igokx0k73e1",
      "heimPlayer": {
        "id": "101862299",
        "team_id": "155",
        "person": {
          "id": "729362",
          "name": "Isak Hien",
          "firstname": "Isak",
          "surname": "Hien",
          "fullname": "Isak Malcolm Kwaku Hien",
          "gender": "male",
          "birthday": "13.01.1999",
          "height": "191",
          "weight": "88",
          "person_detail": {
            "id": "709020",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Kista",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "130pg17ru5fzq4igokx0k73e1",
        "firstName": "Isak Malcolm Kwaku",
        "lastName": "Hien",
        "shortFirstName": "Isak",
        "shortLastName": "Hien",
        "matchName": "I. Hien",
        "shirtNumber": 4,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "730850": {
      "optaId": "9drh3w3emxjf6aah8pstsdgr8",
      "heimPlayer": {
        "id": "95821384",
        "team_id": "373",
        "person": {
          "id": "730850",
          "name": "Facundo Buonanotte",
          "firstname": "Facundo",
          "surname": "Buonanotte",
          "fullname": "Facundo Valentín Buonanotte",
          "gender": "male",
          "birthday": "23.12.2004",
          "height": "174",
          "weight": "66",
          "person_detail": {
            "id": "710461",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Pérez",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "05.11.2025 20:16",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "9drh3w3emxjf6aah8pstsdgr8",
        "firstName": "Facundo Valentín",
        "lastName": "Buonanotte",
        "shortFirstName": "Facundo",
        "shortLastName": "Buonanotte",
        "matchName": "F. Buonanotte",
        "shirtNumber": 40,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "734727": {
      "optaId": "1xsrdgt40nb6p9qvt6mf272fo",
      "heimPlayer": {
        "id": "99154834",
        "team_id": "156",
        "person": {
          "id": "734727",
          "name": "Alejandro Rego",
          "firstname": "",
          "surname": "Alejandro Rego",
          "fullname": "Alejandro Rego Mora",
          "gender": "male",
          "birthday": "11.06.2003",
          "height": "192",
          "weight": "79",
          "person_detail": {
            "id": "714170",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Bilbao",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "1xsrdgt40nb6p9qvt6mf272fo",
        "firstName": "Alejandro",
        "lastName": "Rego Mora",
        "shortFirstName": "Alejandro",
        "shortLastName": "Rego",
        "matchName": "Alejandro Rego",
        "shirtNumber": 30,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "734730": {
      "optaId": "b2rqgjegzeyq6wy6qu63zz2fo",
      "heimPlayer": {
        "id": "99154846",
        "team_id": "156",
        "person": {
          "id": "734730",
          "name": "Unai Gómez",
          "firstname": "",
          "surname": "Unai Gómez",
          "fullname": "Unai Gómez Etxebarria",
          "gender": "male",
          "birthday": "25.05.2003",
          "height": "183",
          "weight": "",
          "person_detail": {
            "id": "714173",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Bermeo",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 20:16",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "b2rqgjegzeyq6wy6qu63zz2fo",
        "firstName": "Unai",
        "lastName": "Gómez Etxebarria",
        "shortFirstName": "Unai",
        "shortLastName": "Gómez",
        "matchName": "Unai Gómez",
        "shirtNumber": 20,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "734743": {
      "optaId": "bpbz94ux2g6awkward9cjwrh0",
      "heimPlayer": {
        "id": "93683305",
        "team_id": "156",
        "person": {
          "id": "734743",
          "name": "Ibon Sánchez",
          "firstname": "",
          "surname": "Ibon Sánchez",
          "fullname": "Ibon Ignacio Sánchez Océn",
          "gender": "male",
          "birthday": "08.03.2004",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "714186",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Getxo",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "01.10.2025 22:37",
        "shirtnumber": "35"
      },
      "optaPlayer": {
        "playerId": "bpbz94ux2g6awkward9cjwrh0",
        "firstName": "Ibon Ignacio",
        "lastName": "Sánchez Océn",
        "shortFirstName": "Ibon",
        "shortLastName": "Sánchez",
        "knownName": "Ibon Sánchez",
        "matchName": "Ibon Sánchez",
        "shirtNumber": 35,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "737180": {
      "optaId": "7hugqbtot3c8fmxtfqld9l15g",
      "heimPlayer": {
        "id": "102003173",
        "team_id": "253",
        "person": {
          "id": "737180",
          "name": "Hugo Bolin",
          "firstname": "Hugo",
          "surname": "Bolin",
          "fullname": "Axel Hugo Bolin",
          "gender": "male",
          "birthday": "24.07.2003",
          "height": "179",
          "weight": "64",
          "person_detail": {
            "id": "716615",
            "position_1": "6",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Borås",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:14",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "7hugqbtot3c8fmxtfqld9l15g",
        "firstName": "Axel Hugo",
        "lastName": "Bolin",
        "shortFirstName": "Hugo",
        "shortLastName": "Bolin",
        "matchName": "H. Bolin",
        "shirtNumber": 38,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "737199": {
      "optaId": "elwm97xvha0y0t8yqx5sur9ck",
      "heimPlayer": {
        "id": "98850694",
        "team_id": "530",
        "person": {
          "id": "737199",
          "name": "Hugo Larsson",
          "firstname": "Hugo",
          "surname": "Larsson",
          "fullname": "Hugo Emanuel Larsson",
          "gender": "male",
          "birthday": "27.06.2004",
          "height": "187",
          "weight": "79",
          "person_detail": {
            "id": "716634",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Svarte",
            "died": "no"
          },
          "country": [
            {
              "id": "182"
            }
          ]
        },
        "created": "21.01.2026 17:43",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "elwm97xvha0y0t8yqx5sur9ck",
        "firstName": "Hugo Emanuel",
        "lastName": "Larsson",
        "shortFirstName": "Hugo",
        "shortLastName": "Larsson",
        "matchName": "H. Larsson",
        "shirtNumber": 16,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "739042": {
      "optaId": "dka9aakcyyvh98m2uhkvs6qz8",
      "heimPlayer": {
        "id": "101804546",
        "team_id": "1776",
        "person": {
          "id": "739042",
          "name": "Iván Fresneda",
          "firstname": "",
          "surname": "Iván Fresneda",
          "fullname": "Iván Fresneda Corraliza",
          "gender": "male",
          "birthday": "28.09.2004",
          "height": "183",
          "weight": "78",
          "person_detail": {
            "id": "718463",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 17:34",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "dka9aakcyyvh98m2uhkvs6qz8",
        "firstName": "Iván",
        "lastName": "Fresneda Corraliza",
        "shortFirstName": "Iván",
        "shortLastName": "Fresneda",
        "matchName": "Iván Fresneda",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "751264": {
      "optaId": "3rve12v22lh39aaqgjlwlmhas",
      "heimPlayer": {
        "id": "97687828",
        "team_id": "64",
        "person": {
          "id": "751264",
          "name": "Don-Angelo Konadu",
          "firstname": "Don-Angelo",
          "surname": "Konadu",
          "fullname": "Don-Angelo Christoffel Annum-Assamoah Konadu",
          "gender": "male",
          "birthday": "03.05.2006",
          "height": "173",
          "weight": "",
          "person_detail": {
            "id": "730497",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "10.12.2025 20:05",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "3rve12v22lh39aaqgjlwlmhas",
        "firstName": "Don-Angelo Christoffel",
        "lastName": "Annum-Assamoah Konadu",
        "shortFirstName": "Don-Angelo",
        "shortLastName": "Konadu",
        "matchName": "D. Konadu",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "757428": {
      "optaId": "2lt2tw1qypl9hmlz529bo0sus",
      "heimPlayer": {
        "id": "95771332",
        "team_id": "127",
        "person": {
          "id": "757428",
          "name": "Ethan Nwaneri",
          "firstname": "Ethan",
          "surname": "Nwaneri",
          "fullname": "Ethan Chidiebere Nwaneri",
          "gender": "male",
          "birthday": "21.03.2007",
          "height": "176",
          "weight": "",
          "person_detail": {
            "id": "736612",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "04.11.2025 17:58",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "2lt2tw1qypl9hmlz529bo0sus",
        "firstName": "Ethan Chidiebere",
        "lastName": "Nwaneri",
        "shortFirstName": "Ethan",
        "shortLastName": "Nwaneri",
        "matchName": "E. Nwaneri",
        "shirtNumber": 22,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "757431": {
      "optaId": "azt1lhru9cgyb64h4h4fffrx0",
      "heimPlayer": {
        "id": "101824316",
        "team_id": "127",
        "person": {
          "id": "757431",
          "name": "Myles Lewis-Skelly",
          "firstname": "Myles",
          "surname": "Lewis-Skelly",
          "fullname": "Myles Anthony Lewis-Skelly",
          "gender": "male",
          "birthday": "26.09.2006",
          "height": "178",
          "weight": "",
          "person_detail": {
            "id": "736615",
            "position_1": "3",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Denmark Hill, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 22:46",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "azt1lhru9cgyb64h4h4fffrx0",
        "firstName": "Myles Anthony",
        "lastName": "Lewis-Skelly",
        "shortFirstName": "Myles",
        "shortLastName": "Lewis-Skelly",
        "matchName": "M. Lewis-Skelly",
        "shirtNumber": 49,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "758335": {
      "optaId": "39gif4xfy8xddarasbsad56ok",
      "heimPlayer": {
        "id": "101813054",
        "team_id": "1545",
        "person": {
          "id": "758335",
          "name": "Arda Güler",
          "firstname": "Arda",
          "surname": "Güler",
          "fullname": "Arda Güler",
          "gender": "male",
          "birthday": "25.02.2005",
          "height": "176",
          "weight": "62",
          "person_detail": {
            "id": "737518",
            "position_1": "9",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Ankara",
            "died": "no"
          },
          "country": [
            {
              "id": "219"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "39gif4xfy8xddarasbsad56ok",
        "firstName": "Arda",
        "lastName": "Güler",
        "shortFirstName": "Arda",
        "shortLastName": "Güler",
        "matchName": "A. Güler",
        "shirtNumber": 15,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "760594": {
      "optaId": "81qmlg0ttijhkywm55ejdr40k",
      "heimPlayer": {
        "id": "102006230",
        "team_id": "943",
        "person": {
          "id": "760594",
          "name": "Luka Vušković",
          "firstname": "Luka",
          "surname": "Vušković",
          "fullname": "Luka Vušković",
          "gender": "male",
          "birthday": "24.02.2007",
          "height": "193",
          "weight": "86",
          "person_detail": {
            "id": "739772",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Split",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:28",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "81qmlg0ttijhkywm55ejdr40k",
        "firstName": "Luka",
        "lastName": "Vušković",
        "shortFirstName": "Luka",
        "shortLastName": "Vuskovic",
        "matchName": "L. Vušković",
        "shirtNumber": 44,
        "position": "Defender",
        "positionSide": "Centre",
        "formationPlace": "5"
      }
    },
    "764313": {
      "optaId": "8mkkchf0ysdf78r0lncd73klw",
      "heimPlayer": {
        "id": "101935913",
        "team_id": "29680",
        "person": {
          "id": "764313",
          "name": "Antonio Nusa",
          "firstname": "Antonio",
          "surname": "Nusa",
          "fullname": "Antonio Eremonsele Nordby Nusa",
          "gender": "male",
          "birthday": "17.04.2005",
          "height": "183",
          "weight": "73",
          "person_detail": {
            "id": "743450",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Langhus",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:01",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "8mkkchf0ysdf78r0lncd73klw",
        "firstName": "Antonio",
        "lastName": "Eromonsele Nordby Nusa",
        "shortFirstName": "Antonio",
        "shortLastName": "Nusa",
        "matchName": "A. Nusa",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "771848": {
      "optaId": "4o9d3hpjlicgce9gtbewyzhn8",
      "heimPlayer": {
        "id": "100521553",
        "team_id": "1545",
        "person": {
          "id": "771848",
          "name": "Gonzalo García",
          "firstname": "",
          "surname": "Gonzalo García",
          "fullname": "Gonzalo García Torres",
          "gender": "male",
          "birthday": "24.03.2004",
          "height": "182",
          "weight": "82",
          "person_detail": {
            "id": "750689",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "25.02.2026 19:49",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "4o9d3hpjlicgce9gtbewyzhn8",
        "firstName": "Gonzalo",
        "lastName": "García Torres",
        "shortFirstName": "Gonzalo",
        "shortLastName": "García",
        "knownName": "Gonzalo García",
        "matchName": "Gonzalo García",
        "shirtNumber": 16,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "776426": {
      "optaId": "7lm0xrh4646e81mr0oqdtvpxw",
      "heimPlayer": {
        "id": "99154648",
        "team_id": "17544",
        "person": {
          "id": "776426",
          "name": "Adilet Sadybekov",
          "firstname": "Adilet",
          "surname": "Sadybekov",
          "fullname": "Adilet Nurkenuly Sadybekov",
          "gender": "male",
          "birthday": "26.05.2002",
          "height": "186",
          "weight": "",
          "person_detail": {
            "id": "754972",
            "position_1": "7",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Aktobe",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "7lm0xrh4646e81mr0oqdtvpxw",
        "firstName": "Adilet",
        "lastName": "Sadybekov",
        "shortFirstName": "Adilet",
        "shortLastName": "Sadybekov",
        "matchName": "A. Sadybekov",
        "shirtNumber": 6,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "783119": {
      "optaId": "asxjrv3xorpe30y78qqd5cw0k",
      "heimPlayer": {
        "id": "99581806",
        "team_id": "253",
        "person": {
          "id": "783119",
          "name": "Alejo Sarco",
          "firstname": "Alejo",
          "surname": "Sarco",
          "fullname": "Alejo Uriel Sarco Castro",
          "gender": "male",
          "birthday": "06.01.2006",
          "height": "179",
          "weight": "76",
          "person_detail": {
            "id": "761578",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Alberti, Buenos Aires",
            "died": "no"
          }
        },
        "created": "07.02.2026 19:57",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "asxjrv3xorpe30y78qqd5cw0k",
        "firstName": "Alejo Uriel",
        "lastName": "Sarco Castro",
        "shortFirstName": "Alejo",
        "shortLastName": "Sarco",
        "matchName": "A. Sarco",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "783633": {
      "optaId": "8ptmy8v6u26pzkzn3doncavis",
      "heimPlayer": {
        "id": "94857814",
        "team_id": "205",
        "person": {
          "id": "783633",
          "name": "Jeremiah Mensah",
          "firstname": "Jeremiah",
          "surname": "Mensah",
          "fullname": "Jeremiah Dennit Mensah",
          "gender": "male",
          "birthday": "21.02.2008",
          "height": "177",
          "weight": "",
          "person_detail": {
            "id": "762063",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.10.2025 22:42",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "8ptmy8v6u26pzkzn3doncavis",
        "firstName": "Jeremiah",
        "lastName": "Dennit Mensah",
        "shortFirstName": "Jeremiah",
        "shortLastName": "Mensah",
        "matchName": "J. Mensah",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "783683": {
      "optaId": "clrnb4f1yk8z6fbcwyv9vmkus",
      "heimPlayer": {
        "id": "98514529",
        "team_id": "209",
        "person": {
          "id": "783683",
          "name": "Wisdom Mike",
          "firstname": "Wisdom",
          "surname": "Mike",
          "fullname": "Wisdom Okpako Mike Ebohon",
          "gender": "male",
          "birthday": "24.09.2008",
          "height": "175",
          "weight": "65",
          "person_detail": {
            "id": "762101",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "both",
            "birth_place": "München",
            "died": "no"
          }
        },
        "created": "11.01.2026 19:06",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "clrnb4f1yk8z6fbcwyv9vmkus",
        "firstName": "Wisdom",
        "lastName": "Okpako Mike",
        "shortFirstName": "Wisdom",
        "shortLastName": "Mike",
        "matchName": "W. Mike",
        "shirtNumber": 36,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "783686": {
      "optaId": "2t9287y4uvo424uhvwjpn1jx0",
      "heimPlayer": {
        "id": "101440784",
        "team_id": "253",
        "person": {
          "id": "783686",
          "name": "Wael Mohya",
          "firstname": "Wael",
          "surname": "Mohya",
          "fullname": "Wael Mohya",
          "gender": "male",
          "birthday": "31.12.2008",
          "height": "179",
          "weight": "",
          "person_detail": {
            "id": "762102",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Mettmann",
            "died": "no"
          }
        },
        "created": "13.03.2026 19:20",
        "shirtnumber": "36"
      },
      "optaPlayer": {
        "playerId": "2t9287y4uvo424uhvwjpn1jx0",
        "firstName": "Wael",
        "lastName": "Mohya",
        "shortFirstName": "Wael",
        "shortLastName": "Mohya",
        "matchName": "W. Mohya",
        "shirtNumber": 36,
        "position": "Attacking Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "786971": {
      "optaId": "6pavdf2072176dag5nt8qni8k",
      "heimPlayer": {
        "id": "100125667",
        "team_id": "1731",
        "person": {
          "id": "786971",
          "name": "Gianluca Prestianni",
          "firstname": "Gianluca",
          "surname": "Prestianni",
          "fullname": "Gianluca Prestianni Gross",
          "gender": "male",
          "birthday": "31.01.2006",
          "height": "166",
          "weight": "63",
          "person_detail": {
            "id": "764937",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Ciudadela, Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "17.02.2026 19:48",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "6pavdf2072176dag5nt8qni8k",
        "firstName": "Gianluca",
        "lastName": "Prestianni Gross",
        "shortFirstName": "Gianluca",
        "shortLastName": "Prestianni",
        "matchName": "G. Prestianni",
        "shirtNumber": 25,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "788058": {
      "optaId": "ec6zx0pyq0bggng1m3k6iq51w",
      "heimPlayer": {
        "id": "99152602",
        "team_id": "258",
        "person": {
          "id": "788058",
          "name": "Filippo Mané",
          "firstname": "Filippo",
          "surname": "Mané",
          "fullname": "Filippo Calixte Mané",
          "gender": "male",
          "birthday": "08.03.2005",
          "height": "188",
          "weight": "77",
          "person_detail": {
            "id": "766021",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Magenta",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "28.01.2026 19:53",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "ec6zx0pyq0bggng1m3k6iq51w",
        "firstName": "Filippo Calixte",
        "lastName": "Mané",
        "shortFirstName": "Filippo",
        "shortLastName": "Mané",
        "matchName": "F. Mané",
        "shirtNumber": 39,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "789154": {
      "optaId": "cfg7sawvthk1g1zk06wgyym1g",
      "heimPlayer": {
        "id": "98044777",
        "team_id": "594",
        "person": {
          "id": "789154",
          "name": "Aiman Dardari",
          "firstname": "Aiman",
          "surname": "Dardari",
          "fullname": "Aiman Dardari",
          "gender": "male",
          "birthday": "21.03.2005",
          "height": "178",
          "weight": "71",
          "person_detail": {
            "id": "767108",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "both",
            "birth_place": "Luxemburg",
            "died": "no"
          }
        },
        "created": "20.12.2025 17:06",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "cfg7sawvthk1g1zk06wgyym1g",
        "firstName": "Aiman",
        "lastName": "Dardari",
        "shortFirstName": "Aiman",
        "shortLastName": "Dardari",
        "matchName": "A. Dardari",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "789519": {
      "optaId": "552xyc766gp97a5zu8tcx4xzo",
      "heimPlayer": {
        "id": "99153829",
        "team_id": "1355",
        "person": {
          "id": "789519",
          "name": "Lewis Miley",
          "firstname": "Lewis",
          "surname": "Miley",
          "fullname": "Lewis Miley",
          "gender": "male",
          "birthday": "01.05.2006",
          "height": "189",
          "weight": "70",
          "person_detail": {
            "id": "767474",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Stanley",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "28.01.2026 19:59",
        "shirtnumber": "67"
      },
      "optaPlayer": {
        "playerId": "552xyc766gp97a5zu8tcx4xzo",
        "firstName": "Lewis",
        "lastName": "Miley",
        "shortFirstName": "Lewis",
        "shortLastName": "Miley",
        "matchName": "L. Miley",
        "shirtNumber": 67,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "789685": {
      "optaId": "3inva12wuqo70czviv1b0us5w",
      "heimPlayer": {
        "id": "101936018",
        "team_id": "24",
        "person": {
          "id": "789685",
          "name": "Cole Campbell",
          "firstname": "Cole",
          "surname": "Campbell",
          "fullname": "William Cole Campbell",
          "gender": "male",
          "birthday": "20.02.2006",
          "height": "170",
          "weight": "68",
          "person_detail": {
            "id": "767640",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Houston, Texas",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:04",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "3inva12wuqo70czviv1b0us5w",
        "firstName": "William Cole",
        "lastName": "Campbell",
        "shortFirstName": "Cole",
        "shortLastName": "Campbell",
        "matchName": "C. Campbell",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "789894": {
      "optaId": "82o91md3nn11eckmgy749ewpg",
      "heimPlayer": {
        "id": "98857354",
        "team_id": "1731",
        "person": {
          "id": "789894",
          "name": "João Rêgo",
          "firstname": "",
          "surname": "João Rêgo",
          "fullname": "João Pedro Seno Luís Rêgo",
          "gender": "male",
          "birthday": "20.06.2005",
          "height": "182",
          "weight": "64",
          "person_detail": {
            "id": "767849",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Ourique",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "21.01.2026 22:34",
        "shirtnumber": "84"
      },
      "optaPlayer": {
        "playerId": "82o91md3nn11eckmgy749ewpg",
        "firstName": "João Pedro",
        "lastName": "Seno Luís Rego",
        "shortFirstName": "João Pedro",
        "shortLastName": "Seno Luís Rego",
        "knownName": "João Rego",
        "matchName": "João Rego",
        "shirtNumber": 84,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "792181": {
      "optaId": "47bjfjrtjv3uv5lnguc2ycg0k",
      "heimPlayer": {
        "id": "96883780",
        "team_id": "205",
        "person": {
          "id": "792181",
          "name": "Jeanuël Belocian",
          "firstname": "Jeanuël",
          "surname": "Belocian",
          "fullname": "Jeanuël Belocian",
          "gender": "male",
          "birthday": "17.02.2005",
          "height": "186",
          "weight": "73",
          "person_detail": {
            "id": "770134",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Les Abymes",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.11.2025 19:53",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "47bjfjrtjv3uv5lnguc2ycg0k",
        "firstName": "Jeanuël Merick",
        "lastName": "Belocian",
        "shortFirstName": "Jeanuël",
        "shortLastName": "Belocian",
        "matchName": "J. Belocian",
        "shirtNumber": 44,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "792184": {
      "optaId": "2bfs1dfmyao4e3gzha29t1lw4",
      "heimPlayer": {
        "id": "101811992",
        "team_id": "373",
        "person": {
          "id": "792184",
          "name": "Mamadou Sarr",
          "firstname": "Mamadou",
          "surname": "Sarr",
          "fullname": "Mamadou Sarr",
          "gender": "male",
          "birthday": "29.08.2005",
          "height": "194",
          "weight": "77",
          "person_detail": {
            "id": "770137",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Martigues",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "2bfs1dfmyao4e3gzha29t1lw4",
        "firstName": "Mamadou",
        "lastName": "Sarr",
        "shortFirstName": "Mamadou",
        "shortLastName": "Sarr",
        "matchName": "M. Sarr",
        "shirtNumber": 19,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "792218": {
      "optaId": "dzv5f93w5fsnfzohaev6e3rx0",
      "heimPlayer": {
        "id": "101821820",
        "team_id": "1457",
        "person": {
          "id": "792218",
          "name": "Désiré Doué",
          "firstname": "Désiré",
          "surname": "Doué",
          "fullname": "Désiré Doué",
          "gender": "male",
          "birthday": "03.06.2005",
          "height": "181",
          "weight": "79",
          "person_detail": {
            "id": "770171",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "both",
            "birth_place": "Angers",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 22:15",
        "shirtnumber": "14"
      },
      "optaPlayer": {
        "playerId": "dzv5f93w5fsnfzohaev6e3rx0",
        "firstName": "Désiré Nonka-Maho",
        "lastName": "Doué",
        "shortFirstName": "Désiré",
        "shortLastName": "Doué",
        "matchName": "D. Doué",
        "shirtNumber": 14,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "792221": {
      "optaId": "6tezw22m241iukjha6vyz0rh0",
      "heimPlayer": {
        "id": "98836363",
        "team_id": "136",
        "person": {
          "id": "792221",
          "name": "Lucas Michal",
          "firstname": "Lucas",
          "surname": "Michal",
          "fullname": "Lucas Michal",
          "gender": "male",
          "birthday": "22.06.2005",
          "height": "172",
          "weight": "61",
          "person_detail": {
            "id": "770174",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Ivry-sur-Seine",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "20.01.2026 22:44",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "6tezw22m241iukjha6vyz0rh0",
        "firstName": "Lucas Paulin",
        "lastName": "Michal",
        "shortFirstName": "Lucas",
        "shortLastName": "Michal",
        "matchName": "L. Michal",
        "shirtNumber": 21,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "792233": {
      "optaId": "cmdeqxibr6holfqg17ap9uihg",
      "heimPlayer": {
        "id": "98853406",
        "team_id": "1502",
        "person": {
          "id": "792233",
          "name": "Yarek Gąsiorowski",
          "firstname": "",
          "surname": "Yarek Gąsiorowski",
          "fullname": "Yarek Gąsiorowski Hernandis",
          "gender": "male",
          "birthday": "12.01.2005",
          "height": "192",
          "weight": "",
          "person_detail": {
            "id": "770186",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Polinyà del Xúquer",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "21.01.2026 19:52",
        "shirtnumber": "3"
      },
      "optaPlayer": {
        "playerId": "cmdeqxibr6holfqg17ap9uihg",
        "firstName": "Yarek",
        "lastName": "Gąsiorowski Hernandis",
        "shortFirstName": "Yarek",
        "shortLastName": "Gasiorowski",
        "matchName": "Yarek Gąsiorowski",
        "shirtNumber": 3,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "792472": {
      "optaId": "m2nkidcdrspnmeq177yv7kk",
      "heimPlayer": {
        "id": "102005162",
        "team_id": "2134",
        "person": {
          "id": "792472",
          "name": "Mick Schmetgens",
          "firstname": "Mick",
          "surname": "Schmetgens",
          "fullname": "Mick Schmetgens",
          "gender": "male",
          "birthday": "09.09.2007",
          "height": "190",
          "weight": "85",
          "person_detail": {
            "id": "770425",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Buxtehude",
            "died": "no"
          }
        },
        "extra_minute": "6",
        "created": "21.03.2026 17:24",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "m2nkidcdrspnmeq177yv7kk",
        "firstName": "Mick",
        "lastName": "Schmetgens",
        "shortFirstName": "Mick",
        "shortLastName": "Schmetgens",
        "matchName": "M. Schmetgens",
        "shirtNumber": 33,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "793664": {
      "optaId": "8w9qk5a1mf1ecrm9pfncnafx0",
      "heimPlayer": {
        "id": "101999099",
        "team_id": "2134",
        "person": {
          "id": "793664",
          "name": "Karim Coulibaly",
          "firstname": "Karim",
          "surname": "Coulibaly",
          "fullname": "Abdoul Karim Coulibaly",
          "gender": "male",
          "birthday": "23.05.2007",
          "height": "191",
          "weight": "75",
          "person_detail": {
            "id": "771612",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "left",
            "birth_place": "Oldenburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 16:49",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "8w9qk5a1mf1ecrm9pfncnafx0",
        "firstName": "Abdoul Karim",
        "lastName": "Coulibaly",
        "shortFirstName": "Karim",
        "shortLastName": "Coulibaly",
        "matchName": "K. Coulibaly",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "794205": {
      "optaId": "2bsmlmrjtknurmuzuckyr2h3o",
      "heimPlayer": {
        "id": "101032591",
        "team_id": "2086",
        "person": {
          "id": "794205",
          "name": "Jan Bürger",
          "firstname": "Jan",
          "surname": "Bürger",
          "fullname": "Jan Bürger",
          "gender": "male",
          "birthday": "10.03.2007",
          "height": "180",
          "weight": "",
          "person_detail": {
            "id": "772152",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "07.03.2026 14:31",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "2bsmlmrjtknurmuzuckyr2h3o",
        "firstName": "Jan",
        "lastName": "Bürger",
        "shortFirstName": "Jan",
        "shortLastName": "Bürger",
        "matchName": "J. Bürger",
        "shirtNumber": 41,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "795202": {
      "optaId": "en2qiiaubgikr1aeklrzkku8k",
      "heimPlayer": {
        "id": "100492717",
        "team_id": "1355",
        "person": {
          "id": "795202",
          "name": "Alex Murphy",
          "firstname": "Alex",
          "surname": "Murphy",
          "fullname": "Alex Murphy",
          "gender": "male",
          "birthday": "25.06.2004",
          "height": "188",
          "weight": "",
          "person_detail": {
            "id": "773127",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Annaghdown",
            "died": "no"
          },
          "country": [
            {
              "id": "86"
            }
          ]
        },
        "created": "24.02.2026 19:56",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "en2qiiaubgikr1aeklrzkku8k",
        "firstName": "Alex",
        "lastName": "Murphy",
        "shortFirstName": "Alex",
        "shortLastName": "Murphy",
        "knownName": "Alex Murphy",
        "matchName": "A. Murphy",
        "shirtNumber": 37,
        "position": "Defender",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    },
    "800529": {
      "optaId": "46vqjnait1zb6tiaverz42bdg",
      "heimPlayer": {
        "id": "98584360",
        "team_id": "5",
        "person": {
          "id": "800529",
          "name": "Yannik Wagner",
          "firstname": "Yannik",
          "surname": "Wagner",
          "fullname": "Yannik Wagner",
          "gender": "male",
          "birthday": "09.05.2007",
          "height": "182",
          "weight": "73",
          "person_detail": {
            "id": "778396",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Ettenheimmünster",
            "died": "no"
          }
        },
        "created": "13.01.2026 22:11",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "46vqjnait1zb6tiaverz42bdg",
        "firstName": "Yannik",
        "lastName": "Wagner",
        "shortFirstName": "Yannik",
        "shortLastName": "Wagner",
        "matchName": "Y. Wagner",
        "shirtNumber": 38,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "801244": {
      "optaId": "cjll1xrw3xulnl23c9tlf6rys",
      "heimPlayer": {
        "id": "101855594",
        "team_id": "597",
        "person": {
          "id": "801244",
          "name": "Fermín López",
          "firstname": "",
          "surname": "Fermín López",
          "fullname": "Fermín López Marín",
          "gender": "male",
          "birthday": "11.05.2003",
          "height": "174",
          "weight": "64",
          "person_detail": {
            "id": "779107",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "El Campillo",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "cjll1xrw3xulnl23c9tlf6rys",
        "firstName": "Fermín",
        "lastName": "López Marín",
        "shortFirstName": "Fermín",
        "shortLastName": "López",
        "matchName": "Fermín López",
        "shirtNumber": 16,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "802037": {
      "optaId": "es8orzwchom47yjt6nwwuc5qs",
      "heimPlayer": {
        "id": "96893107",
        "team_id": "373",
        "person": {
          "id": "802037",
          "name": "Tyrique George",
          "firstname": "Tyrique",
          "surname": "George",
          "fullname": "Tyrique Aaron Delali Yusuff George",
          "gender": "male",
          "birthday": "04.02.2006",
          "height": "181",
          "weight": "",
          "person_detail": {
            "id": "779890",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "25.11.2025 22:42",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "es8orzwchom47yjt6nwwuc5qs",
        "firstName": "Tyrique Aaron Delali Yusuff",
        "lastName": "George",
        "shortFirstName": "Tyrique",
        "shortLastName": "George",
        "matchName": "T. George",
        "shirtNumber": 32,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "804915": {
      "optaId": "al6dgtinz0ki8uj8wrvc7fg2c",
      "heimPlayer": {
        "id": "101972951",
        "team_id": "2086",
        "person": {
          "id": "804915",
          "name": "Saël Kumbedi",
          "firstname": "Saël",
          "surname": "Kumbedi",
          "fullname": "Saël Kumbedi Nseke",
          "gender": "male",
          "birthday": "26.03.2005",
          "height": "175",
          "weight": "67",
          "person_detail": {
            "id": "782754",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Stains",
            "died": "no"
          }
        },
        "created": "21.03.2026 14:16",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "al6dgtinz0ki8uj8wrvc7fg2c",
        "firstName": "Saël",
        "lastName": "Kumbedi Nseke",
        "shortFirstName": "Saël",
        "shortLastName": "Kumbedi",
        "matchName": "S. Kumbedi",
        "shirtNumber": 26,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "804918": {
      "optaId": "4r5mejvmxk423kx5j3w4u3n6c",
      "heimPlayer": {
        "id": "100526257",
        "team_id": "136",
        "person": {
          "id": "804918",
          "name": "Christian Mawissa",
          "firstname": "Christian",
          "surname": "Mawissa",
          "fullname": "Christian Mawissa Elebi",
          "gender": "male",
          "birthday": "18.04.2005",
          "height": "184",
          "weight": "77",
          "person_detail": {
            "id": "782757",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Saint-Jean-de-Verges",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.02.2026 22:32",
        "shirtnumber": "13"
      },
      "optaPlayer": {
        "playerId": "4r5mejvmxk423kx5j3w4u3n6c",
        "firstName": "Christian",
        "lastName": "Mawissa Elebi",
        "shortFirstName": "Christian",
        "shortLastName": "Mawissa",
        "matchName": "C. Mawissa",
        "shirtNumber": 13,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "805251": {
      "optaId": "abr79wsl0folgkyvl821ggs2c",
      "heimPlayer": {
        "id": "101855597",
        "team_id": "597",
        "person": {
          "id": "805251",
          "name": "Lamine Yamal",
          "firstname": "",
          "surname": "Lamine Yamal",
          "fullname": "Lamine Yamal Nasraoui Ebana",
          "gender": "male",
          "birthday": "13.07.2007",
          "height": "180",
          "weight": "72",
          "person_detail": {
            "id": "783088",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Esplugues de Llobregat",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "abr79wsl0folgkyvl821ggs2c",
        "firstName": "Lamine Yamal",
        "lastName": "Nasraoui Ebana",
        "shortFirstName": "Lamine Yamal",
        "shortLastName": "Nasraoui Ebana",
        "knownName": "Lamine Yamal",
        "matchName": "Lamine Yamal",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "805259": {
      "optaId": "9wgavu943u5yn0qu6go17bk7o",
      "heimPlayer": {
        "id": "99159295",
        "team_id": "2102",
        "person": {
          "id": "805259",
          "name": "Dani Budesca",
          "firstname": "",
          "surname": "Dani Budesca",
          "fullname": "Daniel Budesca López",
          "gender": "male",
          "birthday": "27.05.2006",
          "height": "185",
          "weight": "71",
          "person_detail": {
            "id": "783096",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Murcia",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:29",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "9wgavu943u5yn0qu6go17bk7o",
        "firstName": "Daniel",
        "lastName": "Budesca López",
        "shortFirstName": "Daniel",
        "shortLastName": "Budesca",
        "matchName": "Daniel Budesca",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "805508": {
      "optaId": "264gu641hrd38wqf28xolwhlg",
      "heimPlayer": {
        "id": "99159238",
        "team_id": "64",
        "person": {
          "id": "805508",
          "name": "Rayane Bounida",
          "firstname": "Rayane",
          "surname": "Bounida",
          "fullname": "Rayane Bounida",
          "gender": "male",
          "birthday": "03.03.2006",
          "height": "179",
          "weight": "",
          "person_detail": {
            "id": "783345",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Vilvoorde",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "28.01.2026 22:28",
        "shirtnumber": "43"
      },
      "optaPlayer": {
        "playerId": "264gu641hrd38wqf28xolwhlg",
        "firstName": "Rayane",
        "lastName": "Bounida",
        "shortFirstName": "Rayane",
        "shortLastName": "Bounida",
        "matchName": "R. Bounida",
        "shirtNumber": 43,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "805596": {
      "optaId": "2s2fzli5c7h9dfcertq2dwxec",
      "heimPlayer": {
        "id": "101812436",
        "team_id": "1457",
        "person": {
          "id": "805596",
          "name": "Warren Zaïre-Emery",
          "firstname": "Warren",
          "surname": "Zaïre-Emery",
          "fullname": "Warren Zaïre-Emery",
          "gender": "male",
          "birthday": "08.03.2006",
          "height": "178",
          "weight": "68",
          "person_detail": {
            "id": "783433",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Montreuil",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 19:51",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "2s2fzli5c7h9dfcertq2dwxec",
        "firstName": "Warren Marie Jean-Pierre",
        "lastName": "Zaïre-Emery",
        "shortFirstName": "Warren",
        "shortLastName": "Zaïre-Emery",
        "matchName": "W. Zaïre-Emery",
        "shirtNumber": 33,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "7"
      }
    },
    "805599": {
      "optaId": "3e4s03gec7n4fe7llngv6hel0",
      "heimPlayer": {
        "id": "101058964",
        "team_id": "29680",
        "person": {
          "id": "805599",
          "name": "Tidiam Gomis",
          "firstname": "Tidiam",
          "surname": "Gomis",
          "fullname": "Tidiam Diadie Stephan Gomis",
          "gender": "male",
          "birthday": "08.08.2006",
          "height": "183",
          "weight": "73",
          "person_detail": {
            "id": "783436",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Meulan",
            "died": "no"
          }
        },
        "extra_minute": "5",
        "created": "07.03.2026 17:25",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "3e4s03gec7n4fe7llngv6hel0",
        "firstName": "Tidiam Diadie Stephan",
        "lastName": "Gomis",
        "shortFirstName": "Tidiam",
        "shortLastName": "Gomis",
        "matchName": "T. Gomis",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "805814": {
      "optaId": "4lg41m643jf18dgax298bufpw",
      "heimPlayer": {
        "id": "98854723",
        "team_id": "530",
        "person": {
          "id": "805814",
          "name": "Jean Bahoya",
          "firstname": "Jean",
          "surname": "Bahoya",
          "fullname": "Jean-Mattéo Bruno Bahoya Négoce",
          "gender": "male",
          "birthday": "07.05.2005",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "783649",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Montfermeil",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.01.2026 20:23",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "4lg41m643jf18dgax298bufpw",
        "firstName": "Jean-Mattéo",
        "lastName": "Bahoya Négoce",
        "shortFirstName": "Jean-Mattéo",
        "shortLastName": "Bahoya",
        "matchName": "J. Bahoya",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "806058": {
      "optaId": "driu8wojk2aig2t9yesy71vro",
      "heimPlayer": {
        "id": "99154504",
        "team_id": "1736",
        "person": {
          "id": "806058",
          "name": "Štěpán Chaloupek",
          "firstname": "Štěpán",
          "surname": "Chaloupek",
          "fullname": "Štěpán Chaloupek",
          "gender": "male",
          "birthday": "08.03.2003",
          "height": "188",
          "weight": "68",
          "person_detail": {
            "id": "783886",
            "position_1": "4",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Meziboří",
            "died": "no"
          },
          "country": [
            {
              "id": "217"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "2"
      },
      "optaPlayer": {
        "playerId": "driu8wojk2aig2t9yesy71vro",
        "firstName": "Štěpán",
        "lastName": "Chaloupek",
        "shortFirstName": "Stepán",
        "shortLastName": "Chaloupek",
        "matchName": "Š. Chaloupek",
        "shirtNumber": 2,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "806675": {
      "optaId": "5huvpvvrccp5qq5a11vz8v384",
      "heimPlayer": {
        "id": "100502689",
        "team_id": "1355",
        "person": {
          "id": "806675",
          "name": "Leo Shahar",
          "firstname": "Leo",
          "surname": "Shahar",
          "fullname": "Leo Shahar",
          "gender": "male",
          "birthday": "18.03.2007",
          "height": "178",
          "weight": "",
          "person_detail": {
            "id": "784502",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "24.02.2026 22:42",
        "shirtnumber": "61"
      },
      "optaPlayer": {
        "playerId": "5huvpvvrccp5qq5a11vz8v384",
        "firstName": "Leo",
        "lastName": "Shahar",
        "shortFirstName": "Leo",
        "shortLastName": "Shahar",
        "matchName": "L. Shahar",
        "shirtNumber": 61,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "807473": {
      "optaId": "akw8xefrrg5q78q74h4kuj3f8",
      "heimPlayer": {
        "id": "98045896",
        "team_id": "29680",
        "person": {
          "id": "807473",
          "name": "Kosta Nedeljković",
          "firstname": "Kosta",
          "surname": "Nedeljković",
          "fullname": "Kosta Nedeljković",
          "gender": "male",
          "birthday": "16.12.2005",
          "height": "184",
          "weight": "72",
          "person_detail": {
            "id": "785298",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Smederevo",
            "died": "no"
          }
        },
        "created": "20.12.2025 17:19",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "akw8xefrrg5q78q74h4kuj3f8",
        "firstName": "Kosta",
        "lastName": "Nedeljković",
        "shortFirstName": "Kosta",
        "shortLastName": "Nedeljkovic",
        "matchName": "K. Nedeljković",
        "shirtNumber": 19,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "808262": {
      "optaId": "8nltgz63ge48r3awx5ogybi3u",
      "heimPlayer": {
        "id": "99154663",
        "team_id": "17544",
        "person": {
          "id": "808262",
          "name": "Aleksandr Mrynskiy",
          "firstname": "Aleksandr",
          "surname": "Mrynskiy",
          "fullname": "Aleksandr Mrynskiy",
          "gender": "male",
          "birthday": "15.07.2004",
          "height": "177",
          "weight": "",
          "person_detail": {
            "id": "786079",
            "position_1": "5",
            "position_2": "9",
            "preferred_side": "right",
            "birth_place": "Aktobe",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "8nltgz63ge48r3awx5ogybi3u",
        "firstName": "Aleksandr",
        "lastName": "Mrynskiy",
        "shortFirstName": "Aleksandr",
        "shortLastName": "Mrynskiy",
        "matchName": "A. Mrynskiy",
        "shirtNumber": 24,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "808590": {
      "optaId": "7pirs3v9u80j5qy71cmhzbxn8",
      "heimPlayer": {
        "id": "100526518",
        "team_id": "1094",
        "person": {
          "id": "808590",
          "name": "Vasilije Adžić",
          "firstname": "Vasilije",
          "surname": "Adžić",
          "fullname": "Vasilije Adžić",
          "gender": "male",
          "birthday": "12.05.2006",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "786407",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Nikšić",
            "died": "no"
          },
          "country": [
            {
              "id": "137"
            }
          ]
        },
        "created": "25.02.2026 22:38",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "7pirs3v9u80j5qy71cmhzbxn8",
        "firstName": "Vasilije",
        "lastName": "Adžić",
        "shortFirstName": "Vasilije",
        "shortLastName": "Adzic",
        "matchName": "V. Adžić",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "808604": {
      "optaId": "a7ip51ik4rkqcvgdsh64ln09g",
      "heimPlayer": {
        "id": "96884350",
        "team_id": "1421",
        "person": {
          "id": "808604",
          "name": "Arthur Vermeeren",
          "firstname": "Arthur",
          "surname": "Vermeeren",
          "fullname": "Arthur Denis Vermeeren",
          "gender": "male",
          "birthday": "07.02.2005",
          "height": "178",
          "weight": "69",
          "person_detail": {
            "id": "786421",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Lier",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "25.11.2025 20:00",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "a7ip51ik4rkqcvgdsh64ln09g",
        "firstName": "Arthur Denis",
        "lastName": "Vermeeren",
        "shortFirstName": "Arthur",
        "shortLastName": "Vermeeren",
        "matchName": "A. Vermeeren",
        "shirtNumber": 18,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "808752": {
      "optaId": "d2hnxi1yi5rgqj1tvxh1813x0",
      "heimPlayer": {
        "id": "101813045",
        "team_id": "1545",
        "person": {
          "id": "808752",
          "name": "Dean Huijsen",
          "firstname": "Dean",
          "surname": "Huijsen",
          "fullname": "Dean Donny Huijsen",
          "gender": "male",
          "birthday": "14.04.2005",
          "height": "197",
          "weight": "87",
          "person_detail": {
            "id": "786569",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "d2hnxi1yi5rgqj1tvxh1813x0",
        "firstName": "Dean Donny",
        "lastName": "Huijsen Wijsmuller",
        "shortFirstName": "Dean",
        "shortLastName": "Huijsen",
        "matchName": "Dean Huijsen",
        "shirtNumber": 24,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "809715": {
      "optaId": "3l8qmtatt3cr27g2lbsy1kvmc",
      "heimPlayer": {
        "id": "100502335",
        "team_id": "18670",
        "person": {
          "id": "809715",
          "name": "Emmanuel Addai",
          "firstname": "Emmanuel",
          "surname": "Addai",
          "fullname": "Emmanuel Addai",
          "gender": "male",
          "birthday": "01.08.2001",
          "height": "173",
          "weight": "65",
          "person_detail": {
            "id": "787529",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "unknown",
            "birth_place": "Kumasi",
            "died": "no"
          },
          "country": [
            {
              "id": "66"
            }
          ]
        },
        "created": "24.02.2026 22:33",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "3l8qmtatt3cr27g2lbsy1kvmc",
        "firstName": "Emmanuel",
        "lastName": "Addai",
        "shortFirstName": "Emmanuel",
        "shortLastName": "Addai",
        "matchName": "E. Addai",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "811431": {
      "optaId": "bwhn9ve3o3jh21a4vuyjmzbbo",
      "heimPlayer": {
        "id": "101058592",
        "team_id": "9",
        "person": {
          "id": "811431",
          "name": "Jahmai Simpson-Pusey",
          "firstname": "Jahmai",
          "surname": "Simpson-Pusey",
          "fullname": "Jahmai Simpson-Pusey",
          "gender": "male",
          "birthday": "04.11.2005",
          "height": "187",
          "weight": "70",
          "person_detail": {
            "id": "789230",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Manchester",
            "died": "no"
          }
        },
        "created": "07.03.2026 17:23",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "bwhn9ve3o3jh21a4vuyjmzbbo",
        "firstName": "Jahmai",
        "lastName": "Simpson-Pusey",
        "shortFirstName": "Jahmai",
        "shortLastName": "Simpson-Pusey",
        "matchName": "J. Simpson-Pusey",
        "shirtNumber": 22,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "811671": {
      "optaId": "bgydmtsi0ngn9k56apo29v0no",
      "heimPlayer": {
        "id": "101811995",
        "team_id": "373",
        "person": {
          "id": "811671",
          "name": "Jorrel Hato",
          "firstname": "Jorrel",
          "surname": "Hato",
          "fullname": "Jorrel Hato",
          "gender": "male",
          "birthday": "07.03.2006",
          "height": "182",
          "weight": "75",
          "person_detail": {
            "id": "789470",
            "position_1": "3",
            "position_2": "4",
            "preferred_side": "left",
            "birth_place": "Rotterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "17.03.2026 19:49",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "bgydmtsi0ngn9k56apo29v0no",
        "firstName": "Jorrel Evan",
        "lastName": "Hato",
        "shortFirstName": "Jorrel",
        "shortLastName": "Hato",
        "matchName": "J. Hato",
        "shirtNumber": 21,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "6"
      }
    },
    "811739": {
      "optaId": "4j9ug0ng9dhx6xwhdwx6fafx0",
      "heimPlayer": {
        "id": "101935895",
        "team_id": "29680",
        "person": {
          "id": "811739",
          "name": "Ezechiel Banzuzi",
          "firstname": "Ezechiel",
          "surname": "Banzuzi",
          "fullname": "Ezechiel Banzuzi",
          "gender": "male",
          "birthday": "16.02.2005",
          "height": "191",
          "weight": "80",
          "person_detail": {
            "id": "789538",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Zwijndrecht",
            "died": "no"
          }
        },
        "created": "20.03.2026 22:00",
        "shirtnumber": "6"
      },
      "optaPlayer": {
        "playerId": "4j9ug0ng9dhx6xwhdwx6fafx0",
        "firstName": "Ezechiel",
        "lastName": "Banzuzi",
        "shortFirstName": "Ezechiel",
        "shortLastName": "Banzuzi",
        "matchName": "E. Banzuzi",
        "shirtNumber": 6,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "814612": {
      "optaId": "8hgpvnzy2mra3ps209tniq7f8",
      "heimPlayer": {
        "id": "99152272",
        "team_id": "64",
        "person": {
          "id": "814612",
          "name": "Oscar Gloukh",
          "firstname": "Oscar",
          "surname": "Gloukh",
          "fullname": "Oscar Gloukh",
          "gender": "male",
          "birthday": "01.04.2004",
          "height": "170",
          "weight": "68",
          "person_detail": {
            "id": "792410",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "both",
            "birth_place": "Rehovot",
            "died": "no"
          },
          "country": [
            {
              "id": "88"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "10"
      },
      "optaPlayer": {
        "playerId": "8hgpvnzy2mra3ps209tniq7f8",
        "firstName": "Oscar",
        "lastName": "Gloukh",
        "shortFirstName": "Oscar",
        "shortLastName": "Gloukh",
        "matchName": "O. Gloukh",
        "shirtNumber": 10,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "814907": {
      "optaId": "1v6nfd46wx11jbfertslccbo4",
      "heimPlayer": {
        "id": "100492468",
        "team_id": "1052",
        "person": {
          "id": "814907",
          "name": "Francesco Esposito",
          "firstname": "Francesco",
          "surname": "Esposito",
          "fullname": "Francesco Pio Esposito",
          "gender": "male",
          "birthday": "28.06.2005",
          "height": "191",
          "weight": "83",
          "person_detail": {
            "id": "792704",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Castellammare di Stabia",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "24.02.2026 19:54",
        "shirtnumber": "94"
      },
      "optaPlayer": {
        "playerId": "1v6nfd46wx11jbfertslccbo4",
        "firstName": "Francesco Pio",
        "lastName": "Esposito",
        "shortFirstName": "Francesco Pio",
        "shortLastName": "Esposito",
        "matchName": "F. Esposito",
        "shirtNumber": 94,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "816876": {
      "optaId": "6g0yegi9hjhxws7obd46a1lp0",
      "heimPlayer": {
        "id": "97634614",
        "team_id": "17544",
        "person": {
          "id": "816876",
          "name": "Olzhas Baybek",
          "firstname": "Olzhas",
          "surname": "Baybek",
          "fullname": "Olzhas Baybek",
          "gender": "male",
          "birthday": "11.02.2005",
          "height": "180",
          "weight": "71",
          "person_detail": {
            "id": "794680",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Shardara",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "09.12.2025 15:26",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "6g0yegi9hjhxws7obd46a1lp0",
        "firstName": "Olzhas",
        "lastName": "Baybek",
        "shortFirstName": "Olzhas",
        "shortLastName": "Baybek",
        "matchName": "O. Baybek",
        "shirtNumber": 17,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "817036": {
      "optaId": "clj0vy9st6zmjavz5yf8dbac4",
      "heimPlayer": {
        "id": "100493329",
        "team_id": "18670",
        "person": {
          "id": "817036",
          "name": "Camilo Durán",
          "firstname": "Camilo",
          "surname": "Durán",
          "fullname": "Camilo Andrés Durán Márquez",
          "gender": "male",
          "birthday": "10.02.2002",
          "height": "178",
          "weight": "",
          "person_detail": {
            "id": "794839",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Santa Marta",
            "died": "no"
          },
          "country": [
            {
              "id": "105"
            }
          ]
        },
        "created": "24.02.2026 20:01",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "clj0vy9st6zmjavz5yf8dbac4",
        "firstName": "Camilo Andres",
        "lastName": "Durán Marquez",
        "shortFirstName": "Camilo",
        "shortLastName": "Durán",
        "matchName": "C. Durán",
        "shirtNumber": 17,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "819078": {
      "optaId": "1e7d2d9kcstlfayi0wlg2b66s",
      "heimPlayer": {
        "id": "101359592",
        "team_id": "1776",
        "person": {
          "id": "819078",
          "name": "João Simões",
          "firstname": "",
          "surname": "João Simões",
          "fullname": "João Pedro Arnauth Barrocas Simões",
          "gender": "male",
          "birthday": "06.01.2007",
          "height": "178",
          "weight": "71",
          "person_detail": {
            "id": "796880",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Portimão",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "11.03.2026 19:49",
        "shirtnumber": "52"
      },
      "optaPlayer": {
        "playerId": "1e7d2d9kcstlfayi0wlg2b66s",
        "firstName": "João Pedro",
        "lastName": "Arnauth Barrocas Simões",
        "shortFirstName": "João Pedro",
        "shortLastName": "Arnauth Barrocas Simões",
        "knownName": "João Simões",
        "matchName": "João Simões",
        "shirtNumber": 52,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "822233": {
      "optaId": "cgnl3msfddxlw37gu1jtiu42c",
      "heimPlayer": {
        "id": "100269358",
        "team_id": "24",
        "person": {
          "id": "822233",
          "name": "Yannick Eduardo",
          "firstname": "Yannick",
          "surname": "Eduardo",
          "fullname": "Yannick Fereira Eduardo",
          "gender": "male",
          "birthday": "23.01.2006",
          "height": "193",
          "weight": "78",
          "person_detail": {
            "id": "800034",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Kadaň",
            "died": "no"
          }
        },
        "extra_minute": "2",
        "created": "21.02.2026 17:21",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "cgnl3msfddxlw37gu1jtiu42c",
        "firstName": "Yannick",
        "lastName": "Ferreira Eduardo",
        "shortFirstName": "Yannick",
        "shortLastName": "Eduardo",
        "matchName": "Y. Eduardo",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "822263": {
      "optaId": "4fu2agdclsyxx1boxxibauzo4",
      "heimPlayer": {
        "id": "95823832",
        "team_id": "64",
        "person": {
          "id": "822263",
          "name": "Gerald Alders",
          "firstname": "Gerald",
          "surname": "Alders",
          "fullname": "Gerald Alders",
          "gender": "male",
          "birthday": "07.05.2005",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "800062",
            "position_1": "5",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "05.11.2025 22:05",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "4fu2agdclsyxx1boxxibauzo4",
        "firstName": "Gerald",
        "lastName": "Alders",
        "shortFirstName": "Gerald",
        "shortLastName": "Alders",
        "matchName": "G. Alders",
        "shirtNumber": 41,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "823176": {
      "optaId": "c39dl0vqbe8p3o6lvzvlvz0x6",
      "heimPlayer": {
        "id": "99159244",
        "team_id": "17544",
        "person": {
          "id": "823176",
          "name": "Damir Kasabulat",
          "firstname": "Damir",
          "surname": "Kasabulat",
          "fullname": "Damir Kasabulat",
          "gender": "male",
          "birthday": "29.08.2002",
          "height": "182",
          "weight": "67",
          "person_detail": {
            "id": "800871",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Almaty",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 22:28",
        "shirtnumber": "4"
      },
      "optaPlayer": {
        "playerId": "c39dl0vqbe8p3o6lvzvlvz0x6",
        "firstName": "Damir",
        "lastName": "Kasabulat",
        "shortFirstName": "Damir",
        "shortLastName": "Kasabulat",
        "matchName": "D. Kasabulat",
        "shirtNumber": 4,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "823368": {
      "optaId": "2i8mia6uantvhtmpewgs1qz9w",
      "heimPlayer": {
        "id": "91122170",
        "team_id": "209",
        "person": {
          "id": "823368",
          "name": "Jonah Kusi-Asare",
          "firstname": "Jonah",
          "surname": "Kusi-Asare",
          "fullname": "Jonah Daniel Kusi-Asare",
          "gender": "male",
          "birthday": "04.07.2007",
          "height": "196",
          "weight": "84",
          "person_detail": {
            "id": "801062",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Solna",
            "died": "no"
          }
        },
        "created": "22.08.2025 22:18",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "2i8mia6uantvhtmpewgs1qz9w",
        "firstName": "Jonah Daniel",
        "lastName": "Kusi-Asare",
        "shortFirstName": "Jonah",
        "shortLastName": "Kusi-Asare",
        "matchName": "J. Kusi-Asare",
        "shirtNumber": 41,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "826168": {
      "optaId": "ej3r3h5sda64akl1oh2n853pw",
      "heimPlayer": {
        "id": "101817797",
        "team_id": "1776",
        "person": {
          "id": "826168",
          "name": "Rafael Nel",
          "firstname": "",
          "surname": "Rafael Nel",
          "fullname": "Rafael Ferreira Nel",
          "gender": "male",
          "birthday": "03.04.2005",
          "height": "182",
          "weight": "73",
          "person_detail": {
            "id": "803895",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Amadora",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "17.03.2026 21:14",
        "shirtnumber": "90"
      },
      "optaPlayer": {
        "playerId": "ej3r3h5sda64akl1oh2n853pw",
        "firstName": "Rafael",
        "lastName": "Ferreira Nel",
        "shortFirstName": "Rafael",
        "shortLastName": "Ferreira Nel",
        "knownName": "Rafael Nel",
        "matchName": "Rafael Nel",
        "shirtNumber": 90,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "826338": {
      "optaId": "rn17zrbsh1g9r1tj4xyvhgr8",
      "heimPlayer": {
        "id": "95825992",
        "team_id": "205",
        "person": {
          "id": "826338",
          "name": "Eliesse Ben Seghir",
          "firstname": "Eliesse",
          "surname": "Ben Seghir",
          "fullname": "Eliesse Ben Seghir",
          "gender": "male",
          "birthday": "16.02.2005",
          "height": "178",
          "weight": "72",
          "person_detail": {
            "id": "804112",
            "position_1": "10",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Saint-Tropez",
            "died": "no"
          },
          "country": [
            {
              "id": "128"
            }
          ]
        },
        "created": "05.11.2025 22:46",
        "shirtnumber": "17"
      },
      "optaPlayer": {
        "playerId": "rn17zrbsh1g9r1tj4xyvhgr8",
        "firstName": "Eliesse",
        "lastName": "Ben Seghir",
        "shortFirstName": "Eliesse",
        "shortLastName": "Ben Seghir",
        "matchName": "E. Ben Seghir",
        "shirtNumber": 17,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "826602": {
      "optaId": "7zru7o3jrzx66f5aa6kggyplg",
      "heimPlayer": {
        "id": "99160024",
        "team_id": "136",
        "person": {
          "id": "826602",
          "name": "Kassoum Ouattara",
          "firstname": "Kassoum",
          "surname": "Ouattara",
          "fullname": "Kassoum Ouattara",
          "gender": "male",
          "birthday": "14.10.2004",
          "height": "176",
          "weight": "73",
          "person_detail": {
            "id": "804399",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "Paris",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "28.01.2026 22:48",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "7zru7o3jrzx66f5aa6kggyplg",
        "firstName": "Kassoum",
        "lastName": "Ouattara",
        "shortFirstName": "Kassoum",
        "shortLastName": "Ouattara",
        "matchName": "K. Ouattara",
        "shirtNumber": 20,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "827147": {
      "optaId": "dgki9si023s93nymhod74jlzo",
      "heimPlayer": {
        "id": "101804813",
        "team_id": "749",
        "person": {
          "id": "827147",
          "name": "Fredrik Sjøvold",
          "firstname": "Fredrik",
          "surname": "Sjøvold",
          "fullname": "Fredrik Sjøvold",
          "gender": "male",
          "birthday": "17.08.2003",
          "height": "168",
          "weight": "62",
          "person_detail": {
            "id": "804943",
            "position_1": "5",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Trondheim",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 17:37",
        "shirtnumber": "20"
      },
      "optaPlayer": {
        "playerId": "dgki9si023s93nymhod74jlzo",
        "firstName": "Fredrik",
        "lastName": "Sjøvold",
        "shortFirstName": "Fredrik",
        "shortLastName": "Sjøvold",
        "matchName": "F. Sjøvold",
        "shirtNumber": 20,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "827162": {
      "optaId": "b9xr5ekjfzw6jk25b4vo7s6c4",
      "heimPlayer": {
        "id": "102158672",
        "team_id": "2076",
        "person": {
          "id": "827162",
          "name": "Jeremy Arévalo",
          "firstname": "Jeremy",
          "surname": "Arévalo",
          "fullname": "Jeremy Alberto Arévalo Mera",
          "gender": "male",
          "birthday": "19.03.2005",
          "height": "182",
          "weight": "84",
          "person_detail": {
            "id": "804958",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Maliaño",
            "died": "no"
          }
        },
        "created": "22.03.2026 21:15",
        "shirtnumber": "25"
      },
      "optaPlayer": {
        "playerId": "b9xr5ekjfzw6jk25b4vo7s6c4",
        "firstName": "Jeremy Alberto",
        "lastName": "Arévalo Mera",
        "shortFirstName": "Jeremy",
        "shortLastName": "Arévalo",
        "matchName": "J. Arévalo",
        "shirtNumber": 25,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "828588": {
      "optaId": "6j5giieogscravfi7ov556az8",
      "heimPlayer": {
        "id": "100527268",
        "team_id": "136",
        "person": {
          "id": "828588",
          "name": "Samuel Nibombe",
          "firstname": "Samuel",
          "surname": "Nibombe",
          "fullname": "Samuel Kondi Nibombe",
          "gender": "male",
          "birthday": "15.08.2007",
          "height": "198",
          "weight": "83",
          "person_detail": {
            "id": "806346",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "Mons",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "extra_minute": "4",
        "created": "25.02.2026 22:52",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "6j5giieogscravfi7ov556az8",
        "firstName": "Samuel Kondi",
        "lastName": "Nibombé",
        "shortFirstName": "Samuel",
        "shortLastName": "Nibombé",
        "matchName": "S. Nibombé",
        "shirtNumber": 44,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "829877": {
      "optaId": "2mhvgtcem9qn2yzobtkqiegpg",
      "heimPlayer": {
        "id": "99153031",
        "team_id": "2102",
        "person": {
          "id": "829877",
          "name": "Tani Oluwaseyi",
          "firstname": "Tani",
          "surname": "Oluwaseyi",
          "fullname": "Tanitoluwa Oluwatimikhin Oluwaseyi",
          "gender": "male",
          "birthday": "15.05.2000",
          "height": "188",
          "weight": "",
          "person_detail": {
            "id": "807633",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "Abuja",
            "died": "no"
          },
          "country": [
            {
              "id": "98"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "2mhvgtcem9qn2yzobtkqiegpg",
        "firstName": "Tanitoluwa Oluwatimikhin",
        "lastName": "Oluwaseyi",
        "shortFirstName": "Tani",
        "shortLastName": "Oluwaseyi",
        "matchName": "T. Oluwaseyi",
        "shirtNumber": 21,
        "position": "Striker",
        "positionSide": "Centre/Right",
        "formationPlace": "10"
      }
    },
    "833715": {
      "optaId": "bkwxem45cf48k14euwqe7rs44",
      "heimPlayer": {
        "id": "101855579",
        "team_id": "597",
        "person": {
          "id": "833715",
          "name": "Pau Cubarsí",
          "firstname": "",
          "surname": "Pau Cubarsí",
          "fullname": "Pau Cubarsí Paredes",
          "gender": "male",
          "birthday": "22.01.2007",
          "height": "184",
          "weight": "",
          "person_detail": {
            "id": "811471",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Estanyol",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "5"
      },
      "optaPlayer": {
        "playerId": "bkwxem45cf48k14euwqe7rs44",
        "firstName": "Pau",
        "lastName": "Cubarsí Paredes",
        "shortFirstName": "Pau",
        "shortLastName": "Cubarsí",
        "matchName": "Pau Cubarsí",
        "shirtNumber": 5,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "833791": {
      "optaId": "b4x911h58r8i9b2vvsnydvfo4",
      "heimPlayer": {
        "id": "101862260",
        "team_id": "209",
        "person": {
          "id": "833791",
          "name": "Lennart Karl",
          "firstname": "Lennart",
          "surname": "Karl",
          "fullname": "Lennart Karl",
          "gender": "male",
          "birthday": "22.02.2008",
          "height": "168",
          "weight": "67",
          "person_detail": {
            "id": "811547",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Frammersbach",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 20:01",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "b4x911h58r8i9b2vvsnydvfo4",
        "firstName": "Lennart",
        "lastName": "Karl",
        "shortFirstName": "Lennart",
        "shortLastName": "Karl",
        "matchName": "L. Karl",
        "shirtNumber": 42,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "833890": {
      "optaId": "bs71ipy5lx696fixg10eq0aac",
      "heimPlayer": {
        "id": "101056864",
        "team_id": "594",
        "person": {
          "id": "833890",
          "name": "Tim Schnitzer",
          "firstname": "Tim",
          "surname": "Schnitzer",
          "fullname": "Tim Schnitzer",
          "gender": "male",
          "birthday": "07.02.2008",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "811646",
            "position_1": "7",
            "position_2": "4",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "07.03.2026 17:15",
        "shirtnumber": "37"
      },
      "optaPlayer": {
        "playerId": "bs71ipy5lx696fixg10eq0aac",
        "firstName": "Tim",
        "lastName": "Schnitzer",
        "shortFirstName": "Tim",
        "shortLastName": "Schnitzer",
        "matchName": "T. Schnitzer",
        "shirtNumber": 37,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "835613": {
      "optaId": "863y1lnf6rxq7xc478ld6y7tg",
      "heimPlayer": {
        "id": "96886711",
        "team_id": "1731",
        "person": {
          "id": "835613",
          "name": "Rodrigo Rêgo",
          "firstname": "",
          "surname": "Rodrigo Rêgo",
          "fullname": "Rodrigo Miguel Ferreira Rêgo",
          "gender": "male",
          "birthday": "03.01.2005",
          "height": "173",
          "weight": "65",
          "person_detail": {
            "id": "813352",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Aveiro",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "extra_minute": "3",
        "created": "25.11.2025 20:37",
        "shirtnumber": "67"
      },
      "optaPlayer": {
        "playerId": "863y1lnf6rxq7xc478ld6y7tg",
        "firstName": "Rodrigo Miguel",
        "lastName": "Ferreira Rêgo",
        "shortFirstName": "Rodrigo Miguel",
        "shortLastName": "Ferreira Rêgo",
        "knownName": "Rodrigo Rêgo",
        "matchName": "Rodrigo Rêgo",
        "shirtNumber": 67,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "835751": {
      "optaId": "af5ppqx0gs7ym0to0o3vp5mhg",
      "heimPlayer": {
        "id": "100502404",
        "team_id": "1418",
        "person": {
          "id": "835751",
          "name": "Lorenzo Scipioni",
          "firstname": "Lorenzo",
          "surname": "Scipioni",
          "fullname": "Lorenzo Scipioni",
          "gender": "male",
          "birthday": "24.11.2004",
          "height": "181",
          "weight": "",
          "person_detail": {
            "id": "813490",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Martínez, Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "24.02.2026 22:35",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "af5ppqx0gs7ym0to0o3vp5mhg",
        "firstName": "Lorenzo",
        "lastName": "Scipioni",
        "shortFirstName": "Lorenzo",
        "shortLastName": "Scipioni",
        "matchName": "L. Scipioni",
        "shirtNumber": 16,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "838458": {
      "optaId": "2wesmq2wuhnuwh2yhgkuaxqfo",
      "heimPlayer": {
        "id": "98831104",
        "team_id": "64",
        "person": {
          "id": "838458",
          "name": "Aaron Bouwman",
          "firstname": "Aaron",
          "surname": "Bouwman",
          "fullname": "Aaron Bouwman",
          "gender": "male",
          "birthday": "28.08.2007",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "816184",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Haarlem",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "20.01.2026 20:06",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "2wesmq2wuhnuwh2yhgkuaxqfo",
        "firstName": "Aaron",
        "lastName": "Bouwman",
        "shortFirstName": "Aaron",
        "shortLastName": "Bouwman",
        "matchName": "A. Bouwman",
        "shirtNumber": 30,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "839331": {
      "optaId": "b3sexumsdp9m96rkp5da0r47o",
      "heimPlayer": {
        "id": "97692274",
        "team_id": "205",
        "person": {
          "id": "839331",
          "name": "Claudio Echeverri",
          "firstname": "Claudio",
          "surname": "Echeverri",
          "fullname": "Claudio Jeremías Echeverri",
          "gender": "male",
          "birthday": "02.01.2006",
          "height": "170",
          "weight": "62",
          "person_detail": {
            "id": "817055",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Resistencia",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "10.12.2025 22:43",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "b3sexumsdp9m96rkp5da0r47o",
        "firstName": "Claudio Candelmo Jeremías",
        "lastName": "Echeverri",
        "shortFirstName": "Claudio",
        "shortLastName": "Echeverri",
        "matchName": "C. Echeverri",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "839973": {
      "optaId": "47zfdb0zeb03nvtjpom42j2ms",
      "heimPlayer": {
        "id": "98836033",
        "team_id": "136",
        "person": {
          "id": "839973",
          "name": "George Ilenikhena",
          "firstname": "George",
          "surname": "Ilenikhena",
          "fullname": "George Osrzehmen Ilenikhena",
          "gender": "male",
          "birthday": "16.08.2006",
          "height": "185",
          "weight": "76",
          "person_detail": {
            "id": "817693",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Lagos",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "20.01.2026 22:33",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "47zfdb0zeb03nvtjpom42j2ms",
        "firstName": "George Osrzehmen",
        "lastName": "Ilenikhena",
        "shortFirstName": "George",
        "shortLastName": "Ilenikhena",
        "matchName": "G. Ilenikhena",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "840534": {
      "optaId": "ap0l05cfp7i1ifxptxjusls7o",
      "heimPlayer": {
        "id": "98854804",
        "team_id": "530",
        "person": {
          "id": "840534",
          "name": "Alexander Staff",
          "firstname": "Alexander",
          "surname": "Staff",
          "fullname": "Alexander Staff",
          "gender": "male",
          "birthday": "12.06.2008",
          "height": "182",
          "weight": "",
          "person_detail": {
            "id": "818251",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Dieburg",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "21.01.2026 20:29",
        "shirtnumber": "53"
      },
      "optaPlayer": {
        "playerId": "ap0l05cfp7i1ifxptxjusls7o",
        "firstName": "Alexander",
        "lastName": "Staff",
        "shortFirstName": "Alexander",
        "shortLastName": "Staff",
        "matchName": "A. Staff",
        "shirtNumber": 53,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "843170": {
      "optaId": "684cguhktvth28ql6qgvvmcyc",
      "heimPlayer": {
        "id": "98854453",
        "team_id": "530",
        "person": {
          "id": "843170",
          "name": "Farès Chaïbi",
          "firstname": "Farès",
          "surname": "Chaïbi",
          "fullname": "Farès Chaïbi",
          "gender": "male",
          "birthday": "28.11.2002",
          "height": "183",
          "weight": "79",
          "person_detail": {
            "id": "820874",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Lyon",
            "died": "no"
          },
          "country": [
            {
              "id": "4"
            }
          ]
        },
        "created": "21.01.2026 20:15",
        "shirtnumber": "8"
      },
      "optaPlayer": {
        "playerId": "684cguhktvth28ql6qgvvmcyc",
        "firstName": "Farès",
        "lastName": "Chaïbi",
        "shortFirstName": "Farès",
        "shortLastName": "Chaïbi",
        "matchName": "F. Chaïbi",
        "shirtNumber": 8,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "844307": {
      "optaId": "d7ofv9d9sbp263uo76cm2qxhw",
      "heimPlayer": {
        "id": "101812979",
        "team_id": "1267",
        "person": {
          "id": "844307",
          "name": "Abduqodir Khusanov",
          "firstname": "Abduqodir",
          "surname": "Khusanov",
          "fullname": "Abdukodir Khikmatovich Khusanov",
          "gender": "male",
          "birthday": "29.02.2004",
          "height": "186",
          "weight": "84",
          "person_detail": {
            "id": "821993",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Tashkent",
            "died": "no"
          },
          "country": [
            {
              "id": "230"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "d7ofv9d9sbp263uo76cm2qxhw",
        "firstName": "Abdukodir",
        "lastName": "Khusanov",
        "shortFirstName": "Abdukodir",
        "shortLastName": "Khusanov",
        "matchName": "A. Khusanov",
        "shirtNumber": 45,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "5"
      }
    },
    "849576": {
      "optaId": "albt55j4oir1veynmos532psk",
      "heimPlayer": {
        "id": "98830699",
        "team_id": "2102",
        "person": {
          "id": "849576",
          "name": "Santiago Mouriño",
          "firstname": "Santiago",
          "surname": "Mouriño",
          "fullname": "Álvaro Santiago Mouriño González",
          "gender": "male",
          "birthday": "13.02.2002",
          "height": "186",
          "weight": "76",
          "person_detail": {
            "id": "827224",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Montevideo",
            "died": "no"
          },
          "country": [
            {
              "id": "227"
            }
          ]
        },
        "created": "20.01.2026 20:04",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "albt55j4oir1veynmos532psk",
        "firstName": "Álvaro Santiago",
        "lastName": "Mouriño González",
        "shortFirstName": "Santiago",
        "shortLastName": "Mouriño",
        "matchName": "S. Mouriño",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "849668": {
      "optaId": "ek4oa7zejocbbgu1l2vdebitw",
      "heimPlayer": {
        "id": "101820857",
        "team_id": "373",
        "person": {
          "id": "849668",
          "name": "Josh Acheampong",
          "firstname": "Josh",
          "surname": "Acheampong",
          "fullname": "Joshua Kofi Acheampong",
          "gender": "male",
          "birthday": "05.05.2006",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "827317",
            "position_1": "5",
            "position_2": "4",
            "preferred_side": "right",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "17.03.2026 22:01",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "ek4oa7zejocbbgu1l2vdebitw",
        "firstName": "Joshua Kofi",
        "lastName": "Acheampong",
        "shortFirstName": "Josh",
        "shortLastName": "Acheampong",
        "matchName": "J. Acheampong",
        "shirtNumber": 34,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "852822": {
      "optaId": "d95uicftg11gdyf5yk2ntt1jo",
      "heimPlayer": {
        "id": "101815622",
        "team_id": "749",
        "person": {
          "id": "852822",
          "name": "Daniel Bassi",
          "firstname": "Daniel",
          "surname": "Bassi",
          "fullname": "Daniel Joshua Bassi Jakobsen",
          "gender": "male",
          "birthday": "31.10.2004",
          "height": "178",
          "weight": "70",
          "person_detail": {
            "id": "830421",
            "position_1": "6",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Oslo",
            "died": "no"
          },
          "country": [
            {
              "id": "156"
            }
          ]
        },
        "created": "17.03.2026 20:27",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "d95uicftg11gdyf5yk2ntt1jo",
        "firstName": "Daniel Joshua",
        "lastName": "Bassi Jakobsen",
        "shortFirstName": "Daniel",
        "shortLastName": "Bassi",
        "matchName": "D. Bassi",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "854734": {
      "optaId": "eyx98nfx3ecgzvrh76wb1nbbo",
      "heimPlayer": {
        "id": "100492150",
        "team_id": "1418",
        "person": {
          "id": "854734",
          "name": "Christos Mouzakitis",
          "firstname": "Christos",
          "surname": "Mouzakitis",
          "fullname": "Christos Mouzakitis",
          "gender": "male",
          "birthday": "25.12.2006",
          "height": "178",
          "weight": "",
          "person_detail": {
            "id": "832329",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "24.02.2026 19:52",
        "shirtnumber": "96"
      },
      "optaPlayer": {
        "playerId": "eyx98nfx3ecgzvrh76wb1nbbo",
        "firstName": "Christos",
        "lastName": "Mouzakitis",
        "shortFirstName": "Christos",
        "shortLastName": "Mouzakitis",
        "matchName": "C. Mouzakitis",
        "shirtNumber": 96,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "855484": {
      "optaId": "8ezfdv6lgv4gz8kogxvvn1rtg",
      "heimPlayer": {
        "id": "98856250",
        "team_id": "373",
        "person": {
          "id": "855484",
          "name": "Estêvão",
          "firstname": "",
          "surname": "Estêvão",
          "fullname": "Estêvão Willian Almeida de Oliveira Gonçalves",
          "gender": "male",
          "birthday": "24.04.2007",
          "height": "176",
          "weight": "62",
          "person_detail": {
            "id": "833079",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Franca",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "21.01.2026 22:03",
        "shirtnumber": "41"
      },
      "optaPlayer": {
        "playerId": "8ezfdv6lgv4gz8kogxvvn1rtg",
        "firstName": "Estêvão Willian",
        "lastName": "Almeida de Oliveira Gonçalves",
        "shortFirstName": "Estêvão Willian",
        "shortLastName": "Almeida de Oliveira Gonçalves",
        "knownName": "Estêvão",
        "matchName": "Estêvão",
        "shirtNumber": 41,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "855762": {
      "optaId": "1ghyb2ozmwm2o9bxzuxzw7yfo",
      "heimPlayer": {
        "id": "98951053",
        "team_id": "29680",
        "person": {
          "id": "855762",
          "name": "Andrija Maksimović",
          "firstname": "Andrija",
          "surname": "Maksimović",
          "fullname": "Andrija Maksimović",
          "gender": "male",
          "birthday": "05.06.2007",
          "height": "182",
          "weight": "70",
          "person_detail": {
            "id": "833353",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Novi Pazar",
            "died": "no"
          }
        },
        "created": "24.01.2026 17:05",
        "shirtnumber": "33"
      },
      "optaPlayer": {
        "playerId": "1ghyb2ozmwm2o9bxzuxzw7yfo",
        "firstName": "Andrija",
        "lastName": "Maksimović",
        "shortFirstName": "Andrija",
        "shortLastName": "Maksimovic",
        "matchName": "A. Maksimović",
        "shirtNumber": 33,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "855771": {
      "optaId": "boquhcwmad8a9gcq3jcv1m68k",
      "heimPlayer": {
        "id": "97147285",
        "team_id": "2076",
        "person": {
          "id": "855771",
          "name": "Lazar Jovanović",
          "firstname": "Lazar",
          "surname": "Jovanović",
          "fullname": "Lazar Jovanović",
          "gender": "male",
          "birthday": "30.11.2006",
          "height": "184",
          "weight": "76",
          "person_detail": {
            "id": "833362",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Novi Sad",
            "died": "no"
          }
        },
        "created": "30.11.2025 17:16",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "boquhcwmad8a9gcq3jcv1m68k",
        "firstName": "Lazar",
        "lastName": "Jovanović",
        "shortFirstName": "Lazar",
        "shortLastName": "Jovanovic",
        "matchName": "L. Jovanović",
        "shirtNumber": 45,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "856320": {
      "optaId": "acrwmucmu5zajj159f30of384",
      "heimPlayer": {
        "id": "100632094",
        "team_id": "2134",
        "person": {
          "id": "856320",
          "name": "Jovan Milošević",
          "firstname": "Jovan",
          "surname": "Milošević",
          "fullname": "Jovan Milošević",
          "gender": "male",
          "birthday": "31.07.2005",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "833910",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Čačak",
            "died": "no"
          }
        },
        "created": "28.02.2026 14:19",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "acrwmucmu5zajj159f30of384",
        "firstName": "Jovan",
        "lastName": "Milošević",
        "shortFirstName": "Jovan",
        "shortLastName": "Milosevic",
        "matchName": "J. Milošević",
        "shirtNumber": 19,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "859758": {
      "optaId": "24sgu58uugxgy49el075dz21g",
      "heimPlayer": {
        "id": "98856817",
        "team_id": "1502",
        "person": {
          "id": "859758",
          "name": "Esmir Bajraktarević",
          "firstname": "Esmir",
          "surname": "Bajraktarević",
          "fullname": "Esmir Bajraktarević",
          "gender": "male",
          "birthday": "10.03.2005",
          "height": "175",
          "weight": "64",
          "person_detail": {
            "id": "837340",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Appleton, WI",
            "died": "no"
          },
          "country": [
            {
              "id": "31"
            }
          ]
        },
        "created": "21.01.2026 22:24",
        "shirtnumber": "19"
      },
      "optaPlayer": {
        "playerId": "24sgu58uugxgy49el075dz21g",
        "firstName": "Esmir",
        "lastName": "Bajraktarević",
        "shortFirstName": "Esmir",
        "shortLastName": "Bajraktarevic",
        "matchName": "E. Bajraktarević",
        "shirtNumber": 19,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "861539": {
      "optaId": "ck7lu09geq8mi6vkf2llyi5ii",
      "heimPlayer": {
        "id": "98853214",
        "team_id": "156",
        "person": {
          "id": "861539",
          "name": "Mikel Jauregizar",
          "firstname": "",
          "surname": "Mikel Jauregizar",
          "fullname": "Mikel Jauregizar Alboniga",
          "gender": "male",
          "birthday": "13.11.2003",
          "height": "177",
          "weight": "",
          "person_detail": {
            "id": "839121",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bermeo",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "21.01.2026 19:50",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "ck7lu09geq8mi6vkf2llyi5ii",
        "firstName": "Mikel",
        "lastName": "Jauregizar Alboniga",
        "shortFirstName": "Mikel",
        "shortLastName": "Jauregizar",
        "matchName": "Mikel Jauregizar",
        "shirtNumber": 18,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "861677": {
      "optaId": "aku4u63qd4l6k1pmp3u8y7x90",
      "heimPlayer": {
        "id": "101032579",
        "team_id": "2086",
        "person": {
          "id": "861677",
          "name": "Jonas Adjetey",
          "firstname": "Jonas",
          "surname": "Adjetey",
          "fullname": "Jonas Adjei Adjetey",
          "gender": "male",
          "birthday": "13.12.2003",
          "height": "188",
          "weight": "82",
          "person_detail": {
            "id": "839259",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Accra",
            "died": "no"
          }
        },
        "created": "07.03.2026 14:31",
        "shirtnumber": "18"
      },
      "optaPlayer": {
        "playerId": "aku4u63qd4l6k1pmp3u8y7x90",
        "firstName": "Jonas Adjei",
        "lastName": "Adjetey",
        "shortFirstName": "Jonas",
        "shortLastName": "Adjetey",
        "matchName": "J. Adjetey",
        "shirtNumber": 18,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "881033": {
      "optaId": "8eq4c5cotvem9ae9uzb2yezo4",
      "heimPlayer": {
        "id": "100521946",
        "team_id": "136",
        "person": {
          "id": "881033",
          "name": "Lamine Camara",
          "firstname": "Lamine",
          "surname": "Camara",
          "fullname": "Mamadou Lamine Camara",
          "gender": "male",
          "birthday": "01.01.2004",
          "height": "173",
          "weight": "65",
          "person_detail": {
            "id": "858596",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Diouloulou",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "8eq4c5cotvem9ae9uzb2yezo4",
        "firstName": "Lamine",
        "lastName": "Camara",
        "shortFirstName": "Lamine",
        "shortLastName": "Camara",
        "matchName": "L. Camara",
        "shirtNumber": 15,
        "position": "Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "8"
      }
    },
    "884681": {
      "optaId": "5rwicl82hq48g9t0qgthucxec",
      "heimPlayer": {
        "id": "99159133",
        "team_id": "18670",
        "person": {
          "id": "884681",
          "name": "Nəriman Axundzadə",
          "firstname": "Nəriman",
          "surname": "Axundzadə",
          "fullname": "Nariman Akhundzade",
          "gender": "male",
          "birthday": "23.04.2004",
          "height": "185",
          "weight": "",
          "person_detail": {
            "id": "862133",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "15"
            }
          ]
        },
        "created": "28.01.2026 22:25",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "5rwicl82hq48g9t0qgthucxec",
        "firstName": "Nəriman",
        "lastName": "Axundzadə",
        "shortFirstName": "Nariman",
        "shortLastName": "Akhundzada",
        "matchName": "N. Axundzadə",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "885504": {
      "optaId": "38339rg6eqprxc0w976gozjmc",
      "heimPlayer": {
        "id": "101817590",
        "team_id": "1776",
        "person": {
          "id": "885504",
          "name": "Ousmane Diomande",
          "firstname": "Ousmane",
          "surname": "Diomande",
          "fullname": "Ousmane Diomande",
          "gender": "male",
          "birthday": "04.12.2003",
          "height": "190",
          "weight": "88",
          "person_detail": {
            "id": "862932",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Abidjan",
            "died": "no"
          },
          "country": [
            {
              "id": "54"
            }
          ]
        },
        "created": "17.03.2026 21:08",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "38339rg6eqprxc0w976gozjmc",
        "firstName": "Ousmane",
        "lastName": "Diomande",
        "shortFirstName": "Ousmane",
        "shortLastName": "Diomande",
        "matchName": "O. Diomande",
        "shirtNumber": 26,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "888726": {
      "optaId": "42ounta8vuqzh8xy2g6ymgjro",
      "heimPlayer": {
        "id": "100664806",
        "team_id": "19",
        "person": {
          "id": "888726",
          "name": "Dmytro Bohdanov",
          "firstname": "Dmytro",
          "surname": "Bohdanov",
          "fullname": "Dmytro Bohdanov",
          "gender": "male",
          "birthday": "06.03.2007",
          "height": "188",
          "weight": "78",
          "person_detail": {
            "id": "866158",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Kiev",
            "died": "no"
          }
        },
        "extra_minute": "5",
        "created": "28.02.2026 17:25",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "42ounta8vuqzh8xy2g6ymgjro",
        "firstName": "Dmytro",
        "lastName": "Bogdanov",
        "shortFirstName": "Dmytro",
        "shortLastName": "Bogdanov",
        "matchName": "D. Bogdanov",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "893034": {
      "optaId": "3ctafpdiixwdyfrx677kp73f8",
      "heimPlayer": {
        "id": "98043475",
        "team_id": "943",
        "person": {
          "id": "893034",
          "name": "Aboubaka Soumahoro",
          "firstname": "Aboubaka",
          "surname": "Soumahoro",
          "fullname": "Aboubaka Soumahoro",
          "gender": "male",
          "birthday": "04.02.2005",
          "height": "184",
          "weight": "71",
          "person_detail": {
            "id": "870528",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Paris",
            "died": "no"
          }
        },
        "created": "20.12.2025 16:50",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "3ctafpdiixwdyfrx677kp73f8",
        "firstName": "Aboubaka",
        "lastName": "Soumahoro",
        "shortFirstName": "Aboubaka",
        "shortLastName": "Soumahoro",
        "matchName": "A. Soumahoro",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "893524": {
      "optaId": "e51jmlxup2pdr8ikl98etxgd0",
      "heimPlayer": {
        "id": "101868575",
        "team_id": "1226",
        "person": {
          "id": "893524",
          "name": "Trey Nyoni",
          "firstname": "Trey",
          "surname": "Nyoni",
          "fullname": "Treymaurice Nyoni",
          "gender": "male",
          "birthday": "30.06.2007",
          "height": "180",
          "weight": "75",
          "person_detail": {
            "id": "871018",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Leicester",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 22:48",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "e51jmlxup2pdr8ikl98etxgd0",
        "firstName": "Treymaurice",
        "lastName": "Nyoni",
        "shortFirstName": "Trey",
        "shortLastName": "Nyoni",
        "matchName": "T. Nyoni",
        "shirtNumber": 42,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "896453": {
      "optaId": "e4c4tmuny1mrnofany1sbfy8k",
      "heimPlayer": {
        "id": "102028043",
        "team_id": "943",
        "person": {
          "id": "896453",
          "name": "Otto Stange",
          "firstname": "Otto",
          "surname": "Stange",
          "fullname": "Otto Emerson Stange",
          "gender": "male",
          "birthday": "09.02.2007",
          "height": "187",
          "weight": "82",
          "person_detail": {
            "id": "873930",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Hamburg",
            "died": "no"
          }
        },
        "created": "21.03.2026 20:08",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "e4c4tmuny1mrnofany1sbfy8k",
        "firstName": "Otto Emerson",
        "lastName": "Stange",
        "shortFirstName": "Otto",
        "shortLastName": "Stange",
        "matchName": "O. Stange",
        "shirtNumber": 49,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "900116": {
      "optaId": "3r4r3w44ski0d4175zfe1iy38",
      "heimPlayer": {
        "id": "100526758",
        "team_id": "1545",
        "person": {
          "id": "900116",
          "name": "César Palacios",
          "firstname": "",
          "surname": "César Palacios",
          "fullname": "César Palacios Pérez",
          "gender": "male",
          "birthday": "11.11.2004",
          "height": "182",
          "weight": "68",
          "person_detail": {
            "id": "877592",
            "position_1": "8",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Soria",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "25.02.2026 22:43",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "3r4r3w44ski0d4175zfe1iy38",
        "firstName": "César",
        "lastName": "Palacios Pérez",
        "shortFirstName": "César",
        "shortLastName": "Palacios",
        "matchName": "César Palacios",
        "shirtNumber": 38,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "900125": {
      "optaId": "e30x514qvzadcryj2zhoss26s",
      "heimPlayer": {
        "id": "102134960",
        "team_id": "2076",
        "person": {
          "id": "900125",
          "name": "Chema Andrés",
          "firstname": "",
          "surname": "Chema Andrés",
          "fullname": "José María Andrés Baixauli",
          "gender": "male",
          "birthday": "25.04.2005",
          "height": "190",
          "weight": "82",
          "person_detail": {
            "id": "877601",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Valencia",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:23",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "e30x514qvzadcryj2zhoss26s",
        "firstName": "José María",
        "lastName": "Andrés Baixauli",
        "shortFirstName": "José María",
        "shortLastName": "Andres Baixauli",
        "knownName": "Chema Andres",
        "matchName": "Chema Andrés",
        "shirtNumber": 30,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "900608": {
      "optaId": "1fkntyd2z8e169yh98k0zst90",
      "heimPlayer": {
        "id": "101369615",
        "team_id": "1545",
        "person": {
          "id": "900608",
          "name": "Franco Mastantuono",
          "firstname": "Franco",
          "surname": "Mastantuono",
          "fullname": "Franco Mastantuono",
          "gender": "male",
          "birthday": "14.08.2007",
          "height": "177",
          "weight": "71",
          "person_detail": {
            "id": "878084",
            "position_1": "8",
            "position_2": "9",
            "preferred_side": "left",
            "birth_place": "Azul, Buenos Aires",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "11.03.2026 22:34",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "1fkntyd2z8e169yh98k0zst90",
        "firstName": "Franco Martín",
        "lastName": "Mastantuono",
        "shortFirstName": "Franco",
        "shortLastName": "Mastantuono",
        "matchName": "F. Mastantuono",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "903430": {
      "optaId": "bhrfr8rtpsm889f93erdlbb4k",
      "heimPlayer": {
        "id": "98106103",
        "team_id": "209",
        "person": {
          "id": "903430",
          "name": "Cassiano Kiala",
          "firstname": "Cassiano",
          "surname": "Kiala",
          "fullname": "Cassiano Tomas Kiala",
          "gender": "male",
          "birthday": "11.01.2009",
          "height": "174",
          "weight": "",
          "person_detail": {
            "id": "880899",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          }
        },
        "extra_minute": "1",
        "created": "21.12.2025 19:19",
        "shirtnumber": "30"
      },
      "optaPlayer": {
        "playerId": "bhrfr8rtpsm889f93erdlbb4k",
        "firstName": "Cassiano",
        "lastName": "Tomas Kiala",
        "shortFirstName": "Cassiano",
        "shortLastName": "Kiala",
        "matchName": "C. Kiala",
        "shirtNumber": 30,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "904642": {
      "optaId": "c2p36c1bs0hddw58lf48iy68k",
      "heimPlayer": {
        "id": "101925854",
        "team_id": "24",
        "person": {
          "id": "904642",
          "name": "Bazoumana Touré",
          "firstname": "Bazoumana",
          "surname": "Touré",
          "fullname": "Bazoumana Touré",
          "gender": "male",
          "birthday": "02.03.2006",
          "height": "175",
          "weight": "70",
          "person_detail": {
            "id": "882111",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Bouaké",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:19",
        "shirtnumber": "29"
      },
      "optaPlayer": {
        "playerId": "c2p36c1bs0hddw58lf48iy68k",
        "firstName": "Bazoumana",
        "lastName": "Touré",
        "shortFirstName": "Bazoumana",
        "shortLastName": "Touré",
        "matchName": "B. Touré",
        "shirtNumber": 29,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "904771": {
      "optaId": "cjznkoq68kxguutsoysecwbh0",
      "heimPlayer": {
        "id": "100688593",
        "team_id": "258",
        "person": {
          "id": "904771",
          "name": "Samuele Inácio",
          "firstname": "Samuele",
          "surname": "Inácio",
          "fullname": "Samuele Inácio Piá",
          "gender": "male",
          "birthday": "02.04.2008",
          "height": "170",
          "weight": "64",
          "person_detail": {
            "id": "882240",
            "position_1": "11",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "Bergamo",
            "died": "no"
          }
        },
        "created": "28.02.2026 20:07",
        "shirtnumber": "40"
      },
      "optaPlayer": {
        "playerId": "cjznkoq68kxguutsoysecwbh0",
        "firstName": "Samuele",
        "lastName": "Inácio Piá",
        "shortFirstName": "Samuele",
        "shortLastName": "Inácio",
        "matchName": "S. Inácio",
        "shirtNumber": 40,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "906129": {
      "optaId": "aykbbz6l05b9t5n8uaxp6n2fo",
      "heimPlayer": {
        "id": "101526398",
        "team_id": "530",
        "person": {
          "id": "906129",
          "name": "Love Arrhov",
          "firstname": "Love",
          "surname": "Arrhov",
          "fullname": "Paul Love Arrhov",
          "gender": "male",
          "birthday": "17.05.2008",
          "height": "178",
          "weight": "70",
          "person_detail": {
            "id": "883598",
            "position_1": "8",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Stockholm",
            "died": "no"
          }
        },
        "created": "14.03.2026 17:16",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "aykbbz6l05b9t5n8uaxp6n2fo",
        "firstName": "Paul",
        "lastName": "Love Arrhov",
        "shortFirstName": "Love",
        "shortLastName": "Arrhov",
        "matchName": "L. Arrhov",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "909306": {
      "optaId": "srzdmbirhvpjuok4mf7lj5zo",
      "heimPlayer": {
        "id": "100521943",
        "team_id": "136",
        "person": {
          "id": "909306",
          "name": "Aladji Bamba",
          "firstname": "Aladji",
          "surname": "Bamba",
          "fullname": "Aladji Kaïraba Bamba",
          "gender": "male",
          "birthday": "14.07.2006",
          "height": "181",
          "weight": "67",
          "person_detail": {
            "id": "886788",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Blois",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.02.2026 19:58",
        "shirtnumber": "23"
      },
      "optaPlayer": {
        "playerId": "srzdmbirhvpjuok4mf7lj5zo",
        "firstName": "Aladji",
        "lastName": "Bamba",
        "shortFirstName": "Aladji",
        "shortLastName": "Bamba",
        "matchName": "A. Bamba",
        "shirtNumber": 23,
        "position": "Midfielder",
        "positionSide": "Centre",
        "formationPlace": "11"
      }
    },
    "912078": {
      "optaId": "9vk04uj215dfan7wak7j25hjo",
      "heimPlayer": {
        "id": "94894375",
        "team_id": "373",
        "person": {
          "id": "912078",
          "name": "Marc Guiu",
          "firstname": "",
          "surname": "Marc Guiu",
          "fullname": "Marc Guiu Paz",
          "gender": "male",
          "birthday": "04.01.2006",
          "height": "187",
          "weight": "",
          "person_detail": {
            "id": "889511",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Granollers",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "22.10.2025 19:49",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "9vk04uj215dfan7wak7j25hjo",
        "firstName": "Marc",
        "lastName": "Guiu Paz",
        "shortFirstName": "Marc",
        "shortLastName": "Guiu",
        "matchName": "Marc Guiu",
        "shirtNumber": 38,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "913068": {
      "optaId": "d3wwlyd3dy9ius9b2hza9o9as",
      "heimPlayer": {
        "id": "94857232",
        "team_id": "1457",
        "person": {
          "id": "913068",
          "name": "Quentin Ndjantou",
          "firstname": "Quentin",
          "surname": "Ndjantou",
          "fullname": "Quentin Enzo Léo Ndjantou Mbitcha",
          "gender": "male",
          "birthday": "23.07.2007",
          "height": "182",
          "weight": "84",
          "person_detail": {
            "id": "890497",
            "position_1": "10",
            "position_2": "11",
            "preferred_side": "right",
            "birth_place": "Arpajon",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "21.10.2025 22:37",
        "shirtnumber": "47"
      },
      "optaPlayer": {
        "playerId": "d3wwlyd3dy9ius9b2hza9o9as",
        "firstName": "Quentin Enzo Leo",
        "lastName": "Ndjantou Mbitcha",
        "shortFirstName": "Quentin",
        "shortLastName": "Ndjantou",
        "matchName": "Q. Ndjantou",
        "shirtNumber": 47,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "914321": {
      "optaId": "54mv7lufwxcy2gih8owyr00lw",
      "heimPlayer": {
        "id": "101820827",
        "team_id": "1457",
        "person": {
          "id": "914321",
          "name": "Senny Mayulu",
          "firstname": "Senny",
          "surname": "Mayulu",
          "fullname": "Senny Nsona Mayulu",
          "gender": "male",
          "birthday": "17.05.2006",
          "height": "183",
          "weight": "67",
          "person_detail": {
            "id": "891751",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Le Blanc-Mesnil",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "17.03.2026 22:01",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "54mv7lufwxcy2gih8owyr00lw",
        "firstName": "Senny Nsona",
        "lastName": "Mayulu",
        "shortFirstName": "Senny",
        "shortLastName": "Mayulu",
        "matchName": "S. Mayulu",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "915304": {
      "optaId": "by8xbw0rb239l1x4b0t33tpn8",
      "heimPlayer": {
        "id": "93676504",
        "team_id": "156",
        "person": {
          "id": "915304",
          "name": "Sannadi",
          "firstname": "",
          "surname": "Sannadi",
          "fullname": "Maroan Sannadi Harrouch",
          "gender": "male",
          "birthday": "01.02.2001",
          "height": "192",
          "weight": "",
          "person_detail": {
            "id": "892734",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Vitoria-Gasteiz",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "01.10.2025 19:58",
        "shirtnumber": "21"
      },
      "optaPlayer": {
        "playerId": "by8xbw0rb239l1x4b0t33tpn8",
        "firstName": "Maroan",
        "lastName": "Sannadi Harrouch",
        "shortFirstName": "Maroan",
        "shortLastName": "Sannadi",
        "matchName": "M. Sannadi",
        "shirtNumber": 21,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "915669": {
      "optaId": "5w7ztsau360j3zd1aai33d4b8",
      "heimPlayer": {
        "id": "101635673",
        "team_id": "21",
        "person": {
          "id": "915669",
          "name": "Kacper Potulski",
          "firstname": "Kacper",
          "surname": "Potulski",
          "fullname": "Kacper Potulski",
          "gender": "male",
          "birthday": "19.10.2007",
          "height": "195",
          "weight": "85",
          "person_detail": {
            "id": "893105",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "15.03.2026 17:10",
        "shirtnumber": "48"
      },
      "optaPlayer": {
        "playerId": "5w7ztsau360j3zd1aai33d4b8",
        "firstName": "Kacper",
        "lastName": "Potulski",
        "shortFirstName": "Kacper",
        "shortLastName": "Potulski",
        "matchName": "K. Potulski",
        "shirtNumber": 48,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "916344": {
      "optaId": "9qh33yv2m4youfw1q2xf6vs6i",
      "heimPlayer": {
        "id": "99154660",
        "team_id": "17544",
        "person": {
          "id": "916344",
          "name": "Edmilson",
          "firstname": "",
          "surname": "Edmilson",
          "fullname": "Edmilson de Paula Santos Filho",
          "gender": "male",
          "birthday": "19.04.1997",
          "height": "190",
          "weight": "80",
          "person_detail": {
            "id": "893781",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Mogi das Cruzes",
            "died": "no"
          },
          "country": [
            {
              "id": "34"
            }
          ]
        },
        "created": "28.01.2026 20:07",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "9qh33yv2m4youfw1q2xf6vs6i",
        "firstName": "Edmilson",
        "lastName": "de Paula Santos Filho",
        "shortFirstName": "Edmilson",
        "shortLastName": "de Paula Santos Filho",
        "knownName": "Edmilson",
        "matchName": "Edmilson",
        "shirtNumber": 26,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "916414": {
      "optaId": "5chuil758xa9c7096hbjp6xw4",
      "heimPlayer": {
        "id": "100155286",
        "team_id": "1355",
        "person": {
          "id": "916414",
          "name": "Sean Neave",
          "firstname": "Sean",
          "surname": "Neave",
          "fullname": "Sean Thoms Neave",
          "gender": "male",
          "birthday": "27.05.2007",
          "height": "184",
          "weight": "",
          "person_detail": {
            "id": "893851",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "Newcastle",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.02.2026 20:31",
        "shirtnumber": "62"
      },
      "optaPlayer": {
        "playerId": "5chuil758xa9c7096hbjp6xw4",
        "firstName": "Sean Thomas",
        "lastName": "Neave",
        "shortFirstName": "Sean",
        "shortLastName": "Neave",
        "matchName": "S. Neave",
        "shirtNumber": 62,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "916799": {
      "optaId": "et72bvivn2sh4gq9lb2fbsm50",
      "heimPlayer": {
        "id": "100526794",
        "team_id": "1457",
        "person": {
          "id": "916799",
          "name": "Dro Fernández",
          "firstname": "",
          "surname": "Dro Fernández",
          "fullname": "Pedro Fernández Sarmiento",
          "gender": "male",
          "birthday": "12.01.2008",
          "height": "180",
          "weight": "",
          "person_detail": {
            "id": "894236",
            "position_1": "8",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Nigrán",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "25.02.2026 22:45",
        "shirtnumber": "27"
      },
      "optaPlayer": {
        "playerId": "et72bvivn2sh4gq9lb2fbsm50",
        "firstName": "Pedro",
        "lastName": "Fernández Sarmiento",
        "shortFirstName": "Dro",
        "shortLastName": "Fernández",
        "knownName": "Dro Fernández",
        "matchName": "Dro Fernández",
        "shirtNumber": 27,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "918794": {
      "optaId": "e6zf0qj614z50i0bsd4l3xmac",
      "heimPlayer": {
        "id": "95785147",
        "team_id": "136",
        "person": {
          "id": "918794",
          "name": "Pape Cabral",
          "firstname": "Pape",
          "surname": "Cabral",
          "fullname": "Pape Cabral",
          "gender": "male",
          "birthday": "20.01.2007",
          "height": "181",
          "weight": "",
          "person_detail": {
            "id": "896228",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Keur Massar (Pikine)",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "04.11.2025 22:24",
        "shirtnumber": "43"
      },
      "optaPlayer": {
        "playerId": "e6zf0qj614z50i0bsd4l3xmac",
        "firstName": "Pape",
        "lastName": "Cabral",
        "shortFirstName": "Pape",
        "shortLastName": "Cabral",
        "matchName": "P. Cabral",
        "shirtNumber": 43,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "921461": {
      "optaId": "3e7h2fmxpv8wjyj8tkki1oe1g",
      "heimPlayer": {
        "id": "100126462",
        "team_id": "258",
        "person": {
          "id": "921461",
          "name": "Luca Reggiani",
          "firstname": "Luca",
          "surname": "Reggiani",
          "fullname": "Luca Reggiani",
          "gender": "male",
          "birthday": "09.01.2008",
          "height": "194",
          "weight": "",
          "person_detail": {
            "id": "898896",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "Modena",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "17.02.2026 19:58",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "3e7h2fmxpv8wjyj8tkki1oe1g",
        "firstName": "Luca",
        "lastName": "Reggiani",
        "shortFirstName": "Luca",
        "shortLastName": "Reggiani",
        "matchName": "L. Reggiani",
        "shirtNumber": 49,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "924787": {
      "optaId": "brfa9yhy2llgt9l75unddogk",
      "heimPlayer": {
        "id": "99159679",
        "team_id": "64",
        "person": {
          "id": "924787",
          "name": "Jorthy Mokio",
          "firstname": "Jorthy",
          "surname": "Mokio",
          "fullname": "Jorthy Mokio",
          "gender": "male",
          "birthday": "29.02.2008",
          "height": "182",
          "weight": "77",
          "person_detail": {
            "id": "902155",
            "position_1": "7",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Gent",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "28.01.2026 22:39",
        "shirtnumber": "24"
      },
      "optaPlayer": {
        "playerId": "brfa9yhy2llgt9l75unddogk",
        "firstName": "Jorthy",
        "lastName": "Mokio",
        "shortFirstName": "Jorthy",
        "shortLastName": "Mokio",
        "matchName": "J. Mokio",
        "shirtNumber": 24,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "933072": {
      "optaId": "8y0fi184nbaewtg4t9klt0tg4",
      "heimPlayer": {
        "id": "93675754",
        "team_id": "205",
        "person": {
          "id": "933072",
          "name": "Axel Tape",
          "firstname": "Axel",
          "surname": "Tape",
          "fullname": "Axel Tape Kobrissa",
          "gender": "male",
          "birthday": "10.08.2007",
          "height": "182",
          "weight": "75",
          "person_detail": {
            "id": "910442",
            "position_1": "4",
            "position_2": "13",
            "preferred_side": "right",
            "birth_place": "Bondy",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "01.10.2025 19:48",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "8y0fi184nbaewtg4t9klt0tg4",
        "firstName": "Axel",
        "lastName": "Tape-Kobrissa",
        "shortFirstName": "Axel",
        "shortLastName": "Tape",
        "matchName": "A. Tape",
        "shirtNumber": 16,
        "position": "Midfielder",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "935130": {
      "optaId": "exqldi3zpsfhvhhvphmpw1ez8",
      "heimPlayer": {
        "id": "96884296",
        "team_id": "1421",
        "person": {
          "id": "935130",
          "name": "Darryl Bakola",
          "firstname": "Darryl",
          "surname": "Bakola",
          "fullname": "Darryl Bakola",
          "gender": "male",
          "birthday": "30.11.2007",
          "height": "178",
          "weight": "",
          "person_detail": {
            "id": "912428",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Clichy",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "created": "25.11.2025 20:00",
        "shirtnumber": "50"
      },
      "optaPlayer": {
        "playerId": "exqldi3zpsfhvhhvphmpw1ez8",
        "firstName": "Darryl",
        "lastName": "Bakola",
        "shortFirstName": "Darryl",
        "shortLastName": "Bakola",
        "matchName": "D. Bakola",
        "shirtNumber": 50,
        "position": "Attacking Midfielder",
        "positionSide": "Centre",
        "formationPlace": "10"
      }
    },
    "935133": {
      "optaId": "6ma3oewkllhcu66tbb6d8shzo",
      "heimPlayer": {
        "id": "95826274",
        "team_id": "1421",
        "person": {
          "id": "935133",
          "name": "Tadjidine M'Madi",
          "firstname": "Tadjidine",
          "surname": "M'Madi",
          "fullname": "Tadjidine M'Madi",
          "gender": "male",
          "birthday": "03.03.2007",
          "height": "180",
          "weight": "",
          "person_detail": {
            "id": "912431",
            "position_1": "0",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "Marseille",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "extra_minute": "5",
        "created": "05.11.2025 22:53",
        "shirtnumber": "75"
      },
      "optaPlayer": {
        "playerId": "6ma3oewkllhcu66tbb6d8shzo",
        "firstName": "Tadjidine",
        "lastName": "Mmadi",
        "shortFirstName": "Tadjidine",
        "shortLastName": "Mmadi",
        "matchName": "T. Mmadi",
        "shirtNumber": 76,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "936406": {
      "optaId": "oi8kw43rorvqooiencbnhxck",
      "heimPlayer": {
        "id": "99157948",
        "team_id": "1502",
        "person": {
          "id": "936406",
          "name": "Noah Fernandez",
          "firstname": "Noah",
          "surname": "Fernandez",
          "fullname": "Noah Fernandez",
          "gender": "male",
          "birthday": "09.01.2008",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "913745",
            "position_1": "8",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Lier",
            "died": "no"
          },
          "country": [
            {
              "id": "23"
            }
          ]
        },
        "created": "28.01.2026 22:02",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "oi8kw43rorvqooiencbnhxck",
        "firstName": "Noah",
        "lastName": "Fernandez",
        "shortFirstName": "Noah",
        "shortLastName": "Fernandez",
        "knownName": "Noah Fernandez",
        "matchName": "N. Fernandez",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "936753": {
      "optaId": "32avhormhc1dbawwzztesqac",
      "heimPlayer": {
        "id": "96893452",
        "team_id": "1421",
        "person": {
          "id": "936753",
          "name": "Robinio Vaz",
          "firstname": "Robinio",
          "surname": "Vaz",
          "fullname": "Robinio Vaz",
          "gender": "male",
          "birthday": "17.02.2007",
          "height": "185",
          "weight": "",
          "person_detail": {
            "id": "914092",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Mantes-la-Jolie",
            "died": "no"
          },
          "country": [
            {
              "id": "61"
            }
          ]
        },
        "extra_minute": "2",
        "created": "25.11.2025 22:54",
        "shirtnumber": "34"
      },
      "optaPlayer": {
        "playerId": "32avhormhc1dbawwzztesqac",
        "firstName": "Robinio",
        "lastName": "Vaz",
        "shortFirstName": "Robinio",
        "shortLastName": "Vaz",
        "matchName": "R. Vaz",
        "shirtNumber": 34,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "937265": {
      "optaId": "7wsv4h6o1ps1vxxvs6dnt6az8",
      "heimPlayer": {
        "id": "102116825",
        "team_id": "702",
        "person": {
          "id": "937265",
          "name": "Tomoya Ando",
          "firstname": "Tomoya",
          "surname": "Ando",
          "fullname": "Tomoya Ando",
          "gender": "male",
          "birthday": "10.01.1999",
          "height": "190",
          "weight": "84",
          "person_detail": {
            "id": "914603",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Aichi",
            "died": "no"
          }
        },
        "created": "22.03.2026 16:19",
        "shirtnumber": "15"
      },
      "optaPlayer": {
        "playerId": "7wsv4h6o1ps1vxxvs6dnt6az8",
        "firstName": "Tomoya",
        "lastName": "Ando",
        "shortFirstName": "Tomoya",
        "shortLastName": "Ando",
        "matchName": "T. Ando",
        "shirtNumber": 15,
        "position": "Defender",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "942795": {
      "optaId": "ay8tikc1j1r2luqovxrmuf9xw",
      "heimPlayer": {
        "id": "97687459",
        "team_id": "258",
        "person": {
          "id": "942795",
          "name": "Aaron Anselmino",
          "firstname": "Aaron",
          "surname": "Anselmino",
          "fullname": "Aaron Anselmino",
          "gender": "male",
          "birthday": "29.04.2005",
          "height": "186",
          "weight": "81",
          "person_detail": {
            "id": "920120",
            "position_1": "4",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Bernardo Larroudé",
            "died": "no"
          },
          "country": [
            {
              "id": "12"
            }
          ]
        },
        "created": "10.12.2025 20:00",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "ay8tikc1j1r2luqovxrmuf9xw",
        "firstName": "Aaron",
        "lastName": "Anselmino",
        "shortFirstName": "Aaron",
        "shortLastName": "Anselmino",
        "matchName": "A. Anselmino",
        "shirtNumber": 28,
        "position": "Defender",
        "positionSide": "Centre/Right",
        "formationPlace": "6"
      }
    },
    "946606": {
      "optaId": "9jmh0pjjecyisiovvqfr1zoyc",
      "heimPlayer": {
        "id": "99159391",
        "team_id": "1226",
        "person": {
          "id": "946606",
          "name": "Amara Nallo",
          "firstname": "Amara",
          "surname": "Nallo",
          "fullname": "Amara Nallo",
          "gender": "male",
          "birthday": "18.11.2006",
          "height": "186",
          "weight": "72",
          "person_detail": {
            "id": "923932",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "both",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "28.01.2026 22:32",
        "shirtnumber": "65"
      },
      "optaPlayer": {
        "playerId": "9jmh0pjjecyisiovvqfr1zoyc",
        "firstName": "Amara",
        "lastName": "Nallo",
        "shortFirstName": "Amara",
        "shortLastName": "Nallo",
        "matchName": "A. Nallo",
        "shirtNumber": 65,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "947674": {
      "optaId": "el8asgbjqbtvu9dcpyv9d668k",
      "heimPlayer": {
        "id": "94902388",
        "team_id": "373",
        "person": {
          "id": "947674",
          "name": "Reggie Walsh",
          "firstname": "Reggie",
          "surname": "Walsh",
          "fullname": "Reggie Spencer Walsh",
          "gender": "male",
          "birthday": "20.10.2008",
          "height": "176",
          "weight": "",
          "person_detail": {
            "id": "925005",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Chertsey",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "22.10.2025 22:29",
        "shirtnumber": "46"
      },
      "optaPlayer": {
        "playerId": "el8asgbjqbtvu9dcpyv9d668k",
        "firstName": "Reggie Spencer",
        "lastName": "Walsh",
        "shortFirstName": "Reggie",
        "shortLastName": "Walsh",
        "matchName": "R. Walsh",
        "shirtNumber": 46,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "947677": {
      "optaId": "154gonr6x9vuraxmzd9zi5xck",
      "heimPlayer": {
        "id": "101868569",
        "team_id": "1226",
        "person": {
          "id": "947677",
          "name": "Rio Ngumoha",
          "firstname": "Rio",
          "surname": "Ngumoha",
          "fullname": "Rio Bass Ray Ngumoha Adigun",
          "gender": "male",
          "birthday": "29.08.2008",
          "height": "170",
          "weight": "",
          "person_detail": {
            "id": "925008",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Newham, London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "18.03.2026 22:49",
        "shirtnumber": "73"
      },
      "optaPlayer": {
        "playerId": "154gonr6x9vuraxmzd9zi5xck",
        "firstName": "Rio Bass Ray",
        "lastName": "Ngumoha Adigun",
        "shortFirstName": "Rio",
        "shortLastName": "Ngumoha",
        "matchName": "R. Ngumoha",
        "shirtNumber": 73,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "952170": {
      "optaId": "dqdu0arww7z83y4of1nvi42z8",
      "heimPlayer": {
        "id": "99159985",
        "team_id": "64",
        "person": {
          "id": "952170",
          "name": "Pharell Nash",
          "firstname": "Pharell",
          "surname": "Nash",
          "fullname": "Pharell Nash",
          "gender": "male",
          "birthday": "07.02.2008",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "929505",
            "position_1": "10",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Amsterdam",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 22:46",
        "shirtnumber": "66"
      },
      "optaPlayer": {
        "playerId": "dqdu0arww7z83y4of1nvi42z8",
        "firstName": "Pharell",
        "lastName": "Nash",
        "shortFirstName": "Pharell",
        "shortLastName": "Nash",
        "matchName": "P. Nash",
        "shirtNumber": 66,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "952173": {
      "optaId": "56nbghr9snc79dt8h99wleej8",
      "heimPlayer": {
        "id": "99152257",
        "team_id": "64",
        "person": {
          "id": "952173",
          "name": "Sean Steur",
          "firstname": "Sean",
          "surname": "Steur",
          "fullname": "Sean Steur",
          "gender": "male",
          "birthday": "11.01.2008",
          "height": "183",
          "weight": "",
          "person_detail": {
            "id": "929508",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "both",
            "birth_place": "Purmerend",
            "died": "no"
          },
          "country": [
            {
              "id": "149"
            }
          ]
        },
        "created": "28.01.2026 19:51",
        "shirtnumber": "48"
      },
      "optaPlayer": {
        "playerId": "56nbghr9snc79dt8h99wleej8",
        "firstName": "Sean",
        "lastName": "Steur",
        "shortFirstName": "Sean",
        "shortLastName": "Steur",
        "matchName": "S. Steur",
        "shirtNumber": 48,
        "position": "Defensive Midfielder",
        "positionSide": "Left/Centre",
        "formationPlace": "4"
      }
    },
    "952418": {
      "optaId": "buzh1oolanqmxdm3bqt1sfqxg",
      "heimPlayer": {
        "id": "98836351",
        "team_id": "1545",
        "person": {
          "id": "952418",
          "name": "Dani Meso",
          "firstname": "",
          "surname": "Dani Meso",
          "fullname": "Daniel Mesonero Miguel",
          "gender": "male",
          "birthday": "03.09.2005",
          "height": "173",
          "weight": "",
          "person_detail": {
            "id": "929755",
            "position_1": "13",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Madrid",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "20.01.2026 22:44",
        "shirtnumber": "47"
      },
      "optaPlayer": {
        "playerId": "buzh1oolanqmxdm3bqt1sfqxg",
        "firstName": "Daniel",
        "lastName": "Mesonero Miguel",
        "shortFirstName": "Daniel",
        "shortLastName": "Mesonero Miguel",
        "knownName": "Dani Meso",
        "matchName": "Dani Meso",
        "shirtNumber": 47,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "953665": {
      "optaId": "cxajw64g1elff3fq3lkzkzi1g",
      "heimPlayer": {
        "id": "98853484",
        "team_id": "1736",
        "person": {
          "id": "953665",
          "name": "David Moses",
          "firstname": "David",
          "surname": "Moses",
          "fullname": "David Moses",
          "gender": "male",
          "birthday": "20.01.2004",
          "height": "171",
          "weight": "71",
          "person_detail": {
            "id": "931007",
            "position_1": "13",
            "position_2": "5",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "151"
            }
          ]
        },
        "created": "21.01.2026 19:52",
        "shirtnumber": "16"
      },
      "optaPlayer": {
        "playerId": "cxajw64g1elff3fq3lkzkzi1g",
        "firstName": "David",
        "lastName": "Moses",
        "shortFirstName": "David",
        "shortLastName": "Moses",
        "matchName": "D. Moses",
        "shirtNumber": 16,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "967254": {
      "optaId": "7dpac4vuxwmu25eh9u9cqx91w",
      "heimPlayer": {
        "id": "99160018",
        "team_id": "127",
        "person": {
          "id": "967254",
          "name": "Ifeoluwa Ibrahim",
          "firstname": "Ifeoluwa",
          "surname": "Ibrahim",
          "fullname": "Ifeoluwa David Ibrahim",
          "gender": "male",
          "birthday": "20.01.2008",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "944553",
            "position_1": "7",
            "position_2": "5",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "28.01.2026 22:47",
        "shirtnumber": "72"
      },
      "optaPlayer": {
        "playerId": "7dpac4vuxwmu25eh9u9cqx91w",
        "firstName": "Ifeoluwa David",
        "lastName": "Ibrahim",
        "shortFirstName": "Ife",
        "shortLastName": "Ibrahim",
        "matchName": "I. Ibrahim",
        "shirtNumber": 72,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "971613": {
      "optaId": "20eqyvyrgtafzssdh0zaehdsk",
      "heimPlayer": {
        "id": "99159916",
        "team_id": "1457",
        "person": {
          "id": "971613",
          "name": "Ibrahim M'Baye",
          "firstname": "Ibrahim",
          "surname": "M'Baye",
          "fullname": "Ibrahim M'Baye",
          "gender": "male",
          "birthday": "24.01.2008",
          "height": "185",
          "weight": "65",
          "person_detail": {
            "id": "948907",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Trappes",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "28.01.2026 22:45",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "20eqyvyrgtafzssdh0zaehdsk",
        "firstName": "Ibrahim",
        "lastName": "Mbaye",
        "shortFirstName": "Ibrahim",
        "shortLastName": "Mbaye",
        "matchName": "I. Mbaye",
        "shirtNumber": 49,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "971878": {
      "optaId": "a2k7c99py1zab3qa0i0pjy590",
      "heimPlayer": {
        "id": "99159691",
        "team_id": "156",
        "person": {
          "id": "971878",
          "name": "Asier Hierro",
          "firstname": "",
          "surname": "Asier Hierro",
          "fullname": "Asier Hierro Campo",
          "gender": "male",
          "birthday": "06.05.2005",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "949172",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Basauri",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:39",
        "shirtnumber": "31"
      },
      "optaPlayer": {
        "playerId": "a2k7c99py1zab3qa0i0pjy590",
        "firstName": "Asier",
        "lastName": "Hierro Campo",
        "shortFirstName": "Asier",
        "shortLastName": "Hierro",
        "matchName": "Asier Hierro",
        "shirtNumber": 31,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "973400": {
      "optaId": "9c82id3h8v3cahh5fpwtzqlg4",
      "heimPlayer": {
        "id": "95781109",
        "team_id": "1776",
        "person": {
          "id": "973400",
          "name": "Geovany Quenda",
          "firstname": "",
          "surname": "Geovany Quenda",
          "fullname": "Geovany Tchermo Quenda",
          "gender": "male",
          "birthday": "30.04.2007",
          "height": "172",
          "weight": "66",
          "person_detail": {
            "id": "950666",
            "position_1": "12",
            "position_2": "10",
            "preferred_side": "left",
            "birth_place": "Bissau",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "created": "04.11.2025 20:12",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "9c82id3h8v3cahh5fpwtzqlg4",
        "firstName": "Geovany",
        "lastName": "Tcherno Quenda",
        "shortFirstName": "Geovany",
        "shortLastName": "Tcherno Quenda",
        "knownName": "Geovany Quenda",
        "matchName": "Geovany Quenda",
        "shirtNumber": 7,
        "position": "Attacking Midfielder",
        "positionSide": "Right",
        "formationPlace": "7"
      }
    },
    "979911": {
      "optaId": "32ko5zzk7805mp4q4n3iwiihg",
      "heimPlayer": {
        "id": "102000977",
        "team_id": "2086",
        "person": {
          "id": "979911",
          "name": "Kento Shiogai",
          "firstname": "Kento",
          "surname": "Shiogai",
          "fullname": "Kento Shiogai",
          "gender": "male",
          "birthday": "26.03.2005",
          "height": "180",
          "weight": "77",
          "person_detail": {
            "id": "957213",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "Tokyo",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:01",
        "shirtnumber": "7"
      },
      "optaPlayer": {
        "playerId": "32ko5zzk7805mp4q4n3iwiihg",
        "firstName": "Kento",
        "lastName": "Shiogai",
        "shortFirstName": "Kento",
        "shortLastName": "Shiogai",
        "matchName": "K. Shiogai",
        "shirtNumber": 7,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1008590": {
      "optaId": "cc3j4hx9guihwjcb3l2toja50",
      "heimPlayer": {
        "id": "102136100",
        "team_id": "1639",
        "person": {
          "id": "1008590",
          "name": "Cyriaque Irié",
          "firstname": "Cyriaque",
          "surname": "Irié",
          "fullname": "Cyriaque Kalou Bi Irié",
          "gender": "male",
          "birthday": "20.06.2005",
          "height": "186",
          "weight": "87",
          "person_detail": {
            "id": "985850",
            "position_1": "12",
            "position_2": "11",
            "preferred_side": "left",
            "birth_place": "Vavoua",
            "died": "no"
          }
        },
        "created": "22.03.2026 18:34",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "cc3j4hx9guihwjcb3l2toja50",
        "firstName": "Cyriaque",
        "lastName": "Kalou Bi Irié",
        "shortFirstName": "Cyriaque",
        "shortLastName": "Irié",
        "matchName": "C. Irié",
        "shirtNumber": 22,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1050905": {
      "optaId": "9orn6va4xvbfp1zdqb8ri2oes",
      "heimPlayer": {
        "id": "102004112",
        "team_id": "209",
        "person": {
          "id": "1050905",
          "name": "Erblin Osmani",
          "firstname": "Erblin",
          "surname": "Osmani",
          "fullname": "Erblin Osmani",
          "gender": "male",
          "birthday": "19.05.2009",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1027997",
            "position_1": "7",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:15",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "9orn6va4xvbfp1zdqb8ri2oes",
        "firstName": "Erblin",
        "lastName": "Osmani",
        "shortFirstName": "Erblin",
        "shortLastName": "Osmani",
        "matchName": "E. Osmani",
        "shirtNumber": 38,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1050908": {
      "optaId": "5m35ycmsvj7ftub65tjmfksus",
      "heimPlayer": {
        "id": "101868230",
        "team_id": "209",
        "person": {
          "id": "1050908",
          "name": "Filip Pavić",
          "firstname": "Filip",
          "surname": "Pavić",
          "fullname": "Filip Pavić",
          "gender": "male",
          "birthday": "19.01.2010",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1028000",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "47"
            }
          ]
        },
        "created": "18.03.2026 22:31",
        "shirtnumber": "43"
      },
      "optaPlayer": {
        "playerId": "5m35ycmsvj7ftub65tjmfksus",
        "firstName": "Filip",
        "lastName": "Pavic",
        "shortFirstName": "Filip",
        "shortLastName": "Pavic",
        "matchName": "F. Pavic",
        "shirtNumber": 43,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1080479": {
      "optaId": "9rtfwu0z7qtk1kglenp2vm13o",
      "heimPlayer": {
        "id": "99153013",
        "team_id": "2102",
        "person": {
          "id": "1080479",
          "name": "Pau Navarro",
          "firstname": "",
          "surname": "Pau Navarro",
          "fullname": "Pau Navarro Badenes",
          "gender": "male",
          "birthday": "25.04.2005",
          "height": "185",
          "weight": "",
          "person_detail": {
            "id": "1057613",
            "position_1": "4",
            "position_2": "5",
            "preferred_side": "right",
            "birth_place": "La Vilavella",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "26"
      },
      "optaPlayer": {
        "playerId": "9rtfwu0z7qtk1kglenp2vm13o",
        "firstName": "Pau",
        "lastName": "Navarro Badenes",
        "shortFirstName": "Pau",
        "shortLastName": "Navarro",
        "matchName": "Pau Navarro",
        "shirtNumber": 26,
        "position": "Defender",
        "positionSide": "Right",
        "formationPlace": "2"
      }
    },
    "1083785": {
      "optaId": "4et6r42e7q2ojgaumwnua2kgk",
      "heimPlayer": {
        "id": "101855588",
        "team_id": "597",
        "person": {
          "id": "1083785",
          "name": "Marc Bernal",
          "firstname": "",
          "surname": "Marc Bernal",
          "fullname": "Marc Bernal Casas",
          "gender": "male",
          "birthday": "26.05.2007",
          "height": "193",
          "weight": "",
          "person_detail": {
            "id": "1060916",
            "position_1": "7",
            "position_2": "13",
            "preferred_side": "left",
            "birth_place": "Berga",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 17:40",
        "shirtnumber": "22"
      },
      "optaPlayer": {
        "playerId": "4et6r42e7q2ojgaumwnua2kgk",
        "firstName": "Marc",
        "lastName": "Bernal Casas",
        "shortFirstName": "Marc",
        "shortLastName": "Bernal",
        "matchName": "Marc Bernal",
        "shirtNumber": 22,
        "position": "Defensive Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "8"
      }
    },
    "1114991": {
      "optaId": "1jpq7xvsg1xh51ff03qukrj84",
      "heimPlayer": {
        "id": "101863505",
        "team_id": "597",
        "person": {
          "id": "1114991",
          "name": "Xavi Espart",
          "firstname": "",
          "surname": "Xavi Espart",
          "fullname": "Xavi Espart Font",
          "gender": "male",
          "birthday": "21.05.2007",
          "height": "175",
          "weight": "",
          "person_detail": {
            "id": "1092053",
            "position_1": "5",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Barcelona",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "18.03.2026 20:15",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "1jpq7xvsg1xh51ff03qukrj84",
        "firstName": "Xavi",
        "lastName": "Espart Font",
        "shortFirstName": "Xavi",
        "shortLastName": "Espart",
        "matchName": "Xavi Espart",
        "shirtNumber": 42,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "1119803": {
      "optaId": "61psw0tgtithfb7knevi50xec",
      "heimPlayer": {
        "id": "95781733",
        "team_id": "127",
        "person": {
          "id": "1119803",
          "name": "Max Dowman",
          "firstname": "Max",
          "surname": "Dowman",
          "fullname": "Max Robert Dowman",
          "gender": "male",
          "birthday": "31.12.2009",
          "height": "183",
          "weight": "70",
          "person_detail": {
            "id": "1096877",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "left",
            "birth_place": "Chelmsford",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "04.11.2025 20:22",
        "shirtnumber": "56"
      },
      "optaPlayer": {
        "playerId": "61psw0tgtithfb7knevi50xec",
        "firstName": "Max Robert",
        "lastName": "Dowman",
        "shortFirstName": "Max",
        "shortLastName": "Dowman",
        "matchName": "M. Dowman",
        "shirtNumber": 56,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1128443": {
      "optaId": "1rqac77f4ll6u3yseozxcgpp0",
      "heimPlayer": {
        "id": "98857735",
        "team_id": "13914",
        "person": {
          "id": "1128443",
          "name": "Georgios Michail",
          "firstname": "Georgios",
          "surname": "Michail",
          "fullname": "Georgios Michael",
          "gender": "male",
          "birthday": "24.11.2008",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1105511",
            "position_1": "0",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "Paphos",
            "died": "no"
          },
          "country": [
            {
              "id": "239"
            }
          ]
        },
        "created": "21.01.2026 22:46",
        "shirtnumber": "42"
      },
      "optaPlayer": {
        "playerId": "1rqac77f4ll6u3yseozxcgpp0",
        "firstName": "Georgios",
        "lastName": "Michael",
        "shortFirstName": "Georgios",
        "shortLastName": "Michael",
        "knownName": "Georgios Michael",
        "matchName": "G. Michael",
        "shirtNumber": 42,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1128566": {
      "optaId": "7y27gzw2djj8q6tx0i8vw9jbo",
      "heimPlayer": {
        "id": "92677634",
        "team_id": "1418",
        "person": {
          "id": "1128566",
          "name": "Stavros Pnevmonidis",
          "firstname": "Stavros",
          "surname": "Pnevmonidis",
          "fullname": "Stavros Pnevmonidis",
          "gender": "male",
          "birthday": "07.08.2006",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1105634",
            "position_1": "8",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Kastoria",
            "died": "no"
          },
          "country": [
            {
              "id": "69"
            }
          ]
        },
        "created": "17.09.2025 20:23",
        "shirtnumber": "80"
      },
      "optaPlayer": {
        "playerId": "7y27gzw2djj8q6tx0i8vw9jbo",
        "firstName": "Stavros",
        "lastName": "Pnevmonidis",
        "shortFirstName": "Stavros",
        "shortLastName": "Pnevmonidis",
        "matchName": "S. Pnevmonidis",
        "shirtNumber": 80,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1128863": {
      "optaId": "b1dfdzazfrr1hqf8xanoc6wic",
      "heimPlayer": {
        "id": "99159571",
        "team_id": "17544",
        "person": {
          "id": "1128863",
          "name": "Ramazan Bagdat",
          "firstname": "Ramazan",
          "surname": "Bagdat",
          "fullname": "Ramazan Bagdat",
          "gender": "male",
          "birthday": "09.10.2006",
          "height": "184",
          "weight": "75",
          "person_detail": {
            "id": "1105931",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "right",
            "birth_place": "Almaty",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "28.01.2026 22:38",
        "shirtnumber": "89"
      },
      "optaPlayer": {
        "playerId": "b1dfdzazfrr1hqf8xanoc6wic",
        "firstName": "Ramazan",
        "lastName": "Bagdat",
        "shortFirstName": "Ramazan",
        "shortLastName": "Bagdat",
        "matchName": "R. Bagdat",
        "shirtNumber": 89,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1144070": {
      "optaId": "cz1ls8n68toyvln5xduvxbac4",
      "heimPlayer": {
        "id": "93631363",
        "team_id": "17544",
        "person": {
          "id": "1144070",
          "name": "Sherkhan Kalmurza",
          "firstname": "Sherkhan",
          "surname": "Kalmurza",
          "fullname": "Sherkhan Kalmurza",
          "gender": "male",
          "birthday": "15.06.2007",
          "height": "187",
          "weight": "",
          "person_detail": {
            "id": "1121177",
            "position_1": "1",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "30.09.2025 17:49",
        "shirtnumber": "82"
      },
      "optaPlayer": {
        "playerId": "cz1ls8n68toyvln5xduvxbac4",
        "firstName": "Sherhan",
        "lastName": "Kalmurza",
        "shortFirstName": "Sherhan",
        "shortLastName": "Kalmurza",
        "matchName": "S. Kalmurza",
        "shirtNumber": 82,
        "position": "Goalkeeper",
        "positionSide": "Centre",
        "formationPlace": "1"
      }
    },
    "1144121": {
      "optaId": "5qoh25z4i5vrunve7yxl2eqz8",
      "heimPlayer": {
        "id": "95820532",
        "team_id": "17544",
        "person": {
          "id": "1144121",
          "name": "Dastan Satpayev",
          "firstname": "Dastan",
          "surname": "Satpayev",
          "fullname": "Dastan Talgatuly Satpayev",
          "gender": "male",
          "birthday": "12.08.2008",
          "height": "176",
          "weight": "73",
          "person_detail": {
            "id": "1121228",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "both",
            "birth_place": "Almaty",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "05.11.2025 20:06",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "5qoh25z4i5vrunve7yxl2eqz8",
        "firstName": "Dastan",
        "lastName": "Satpaev",
        "shortFirstName": "Dastan",
        "shortLastName": "Satpaev",
        "matchName": "D. Satpaev",
        "shirtNumber": 9,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "1146341": {
      "optaId": "ecmpznived7xp45o7bm96csno",
      "heimPlayer": {
        "id": "99159865",
        "team_id": "1545",
        "person": {
          "id": "1146341",
          "name": "Jorge Cestero",
          "firstname": "",
          "surname": "Jorge Cestero",
          "fullname": "Jorge Cestero Sancho",
          "gender": "male",
          "birthday": "24.03.2006",
          "height": "181",
          "weight": "76",
          "person_detail": {
            "id": "1123451",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Zaragoza",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:43",
        "shirtnumber": "28"
      },
      "optaPlayer": {
        "playerId": "ecmpznived7xp45o7bm96csno",
        "firstName": "Jorge",
        "lastName": "Cestero Sancho",
        "shortFirstName": "Jorge",
        "shortLastName": "Cestero",
        "matchName": "Cestero",
        "shirtNumber": 28,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1201424": {
      "optaId": "70zr0nhl2tgyor1oajhcxg6j8",
      "heimPlayer": {
        "id": "101868473",
        "team_id": "155",
        "person": {
          "id": "1201424",
          "name": "Honest Ahanor",
          "firstname": "Honest",
          "surname": "Ahanor",
          "fullname": "Honest Ahanor",
          "gender": "male",
          "birthday": "23.02.2008",
          "height": "184",
          "weight": "79",
          "person_detail": {
            "id": "1178420",
            "position_1": "4",
            "position_2": "3",
            "preferred_side": "left",
            "birth_place": "Aversa",
            "died": "no"
          },
          "country": [
            {
              "id": "89"
            }
          ]
        },
        "created": "18.03.2026 22:42",
        "shirtnumber": "69"
      },
      "optaPlayer": {
        "playerId": "70zr0nhl2tgyor1oajhcxg6j8",
        "firstName": "Honest",
        "lastName": "Ahanor",
        "shortFirstName": "Honest",
        "shortLastName": "Ahanor",
        "matchName": "H. Ahanor",
        "shirtNumber": 69,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "1235495": {
      "optaId": "nn4nw9jga8f9a3dpq7wz4o44",
      "heimPlayer": {
        "id": "95782375",
        "team_id": "127",
        "person": {
          "id": "1235495",
          "name": "Andre Harriman-Annous",
          "firstname": "Andre",
          "surname": "Harriman-Annous",
          "fullname": "Andre Ryan Harriman-Annous",
          "gender": "male",
          "birthday": "28.12.2007",
          "height": "181",
          "weight": "",
          "person_detail": {
            "id": "1212341",
            "position_1": "11",
            "position_2": "10",
            "preferred_side": "unknown",
            "birth_place": "London",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "04.11.2025 20:29",
        "shirtnumber": "71"
      },
      "optaPlayer": {
        "playerId": "nn4nw9jga8f9a3dpq7wz4o44",
        "firstName": "Andre Ryan",
        "lastName": "Harriman-Annous",
        "shortFirstName": "Andre",
        "shortLastName": "Harriman-Annous",
        "matchName": "A. Harriman-Annous",
        "shirtNumber": 71,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1239917": {
      "optaId": "e07b6h22s8ve5yxj4dk3mak2c",
      "heimPlayer": {
        "id": "97473976",
        "team_id": "29680",
        "person": {
          "id": "1239917",
          "name": "Samba Konaté",
          "firstname": "Samba",
          "surname": "Konaté",
          "fullname": "Samba Moodee Gérard Konaté",
          "gender": "male",
          "birthday": "27.02.2009",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "1216757",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Le Havre",
            "died": "no"
          }
        },
        "created": "06.12.2025 20:18",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "e07b6h22s8ve5yxj4dk3mak2c",
        "firstName": "Samba",
        "lastName": "Konaté",
        "shortFirstName": "Samba",
        "shortLastName": "Konate",
        "matchName": "S. Konaté",
        "shirtNumber": 45,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1251212": {
      "optaId": "9ksawmk9ligul6vfjihf50r8",
      "heimPlayer": {
        "id": "101813060",
        "team_id": "1545",
        "person": {
          "id": "1251212",
          "name": "Thiago Pitarch",
          "firstname": "",
          "surname": "Thiago Pitarch",
          "fullname": "Thiago Pitarch Pinar",
          "gender": "male",
          "birthday": "03.08.2007",
          "height": "179",
          "weight": "",
          "person_detail": {
            "id": "1228055",
            "position_1": "13",
            "position_2": "7",
            "preferred_side": "right",
            "birth_place": "Fuenlabrada",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "17.03.2026 19:56",
        "shirtnumber": "45"
      },
      "optaPlayer": {
        "playerId": "9ksawmk9ligul6vfjihf50r8",
        "firstName": "Thiago",
        "lastName": "Pitarch Pinar",
        "shortFirstName": "Thiago",
        "shortLastName": "Pitarch",
        "matchName": "Thiago Pitarch",
        "shirtNumber": 45,
        "position": "Midfielder",
        "positionSide": "Centre/Right",
        "formationPlace": "4"
      }
    },
    "1286705": {
      "optaId": "asy2ytqb8svtkaqlxwkmaigic",
      "heimPlayer": {
        "id": "99159439",
        "team_id": "127",
        "person": {
          "id": "1286705",
          "name": "Brando Bailey-Joseph",
          "firstname": "Brando",
          "surname": "Bailey-Joseph",
          "fullname": "Brando Bailey-Joseph",
          "gender": "male",
          "birthday": "02.10.2008",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1263539",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "55"
            }
          ]
        },
        "created": "28.01.2026 22:35",
        "shirtnumber": "81"
      },
      "optaPlayer": {
        "playerId": "asy2ytqb8svtkaqlxwkmaigic",
        "firstName": "Brando Nyle",
        "lastName": "Bailey-Joseph",
        "shortFirstName": "Brando",
        "shortLastName": "Bailey-Joseph",
        "matchName": "B. Bailey-Joseph",
        "shirtNumber": 81,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1317608": {
      "optaId": "esru3us4k7xaj6hjycz78pdsk",
      "heimPlayer": {
        "id": "99159061",
        "team_id": "156",
        "person": {
          "id": "1317608",
          "name": "Selton Sánchez",
          "firstname": "",
          "surname": "Selton Sánchez",
          "fullname": "Selton Sued Sánchez Camilo",
          "gender": "male",
          "birthday": "20.02.2007",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1294457",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "Durango",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:25",
        "shirtnumber": "44"
      },
      "optaPlayer": {
        "playerId": "esru3us4k7xaj6hjycz78pdsk",
        "firstName": "Selton Sued",
        "lastName": "Sánchez Camilo",
        "shortFirstName": "Selton",
        "shortLastName": "Sánchez",
        "knownName": "Selton Sánchez",
        "matchName": "Selton Sánchez",
        "shirtNumber": 44,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1319924": {
      "optaId": "elvudk6nh32u82voy48c3ov10",
      "heimPlayer": {
        "id": "98908111",
        "team_id": "943",
        "person": {
          "id": "1319924",
          "name": "Alexander Røssing-Lelesiit",
          "firstname": "Alexander",
          "surname": "Røssing-Lelesiit",
          "fullname": "Alexander Røssing-Lelesiit",
          "gender": "male",
          "birthday": "20.01.2007",
          "height": "184",
          "weight": "69",
          "person_detail": {
            "id": "1296773",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Nittedal",
            "died": "no"
          }
        },
        "created": "23.01.2026 19:29",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "elvudk6nh32u82voy48c3ov10",
        "firstName": "Alexander",
        "lastName": "Røssing-Lelesiit",
        "shortFirstName": "Alexander",
        "shortLastName": "Røssing-Lelesiit",
        "matchName": "A. Røssing-Lelesiit",
        "shirtNumber": 38,
        "position": "Attacking Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "1365953": {
      "optaId": "3pzwmymhpa20k8i6760xg5puc",
      "heimPlayer": {
        "id": "100663939",
        "team_id": "702",
        "person": {
          "id": "1365953",
          "name": "Abdoulie Ceesay",
          "firstname": "Abdoulie",
          "surname": "Ceesay",
          "fullname": "Abdoulie Ceesay",
          "gender": "male",
          "birthday": "05.01.2004",
          "height": "185",
          "weight": "79",
          "person_detail": {
            "id": "1342997",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Banjul",
            "died": "no"
          }
        },
        "created": "28.02.2026 17:18",
        "shirtnumber": "9"
      },
      "optaPlayer": {
        "playerId": "3pzwmymhpa20k8i6760xg5puc",
        "firstName": "Abdoulie",
        "lastName": "Ceesay",
        "shortFirstName": "Abdoulie",
        "shortLastName": "Ceesay",
        "matchName": "A. Ceesay",
        "shirtNumber": 9,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1393844": {
      "optaId": "bcrlwj3yqeuqkhg7ta31dtvkk",
      "heimPlayer": {
        "id": "97644619",
        "team_id": "1776",
        "person": {
          "id": "1393844",
          "name": "Salvador Blopa",
          "firstname": "",
          "surname": "Salvador Blopa",
          "fullname": "Salvador Uco Blopa",
          "gender": "male",
          "birthday": "13.06.2007",
          "height": "188",
          "weight": "70",
          "person_detail": {
            "id": "1370918",
            "position_1": "9",
            "position_2": "6",
            "preferred_side": "right",
            "birth_place": "Cascais",
            "died": "no"
          },
          "country": [
            {
              "id": "167"
            }
          ]
        },
        "extra_minute": "2",
        "created": "09.12.2025 20:35",
        "shirtnumber": "70"
      },
      "optaPlayer": {
        "playerId": "bcrlwj3yqeuqkhg7ta31dtvkk",
        "firstName": "Salvador",
        "lastName": "Blopa",
        "shortFirstName": "Salvador",
        "shortLastName": "Blopa",
        "knownName": "Salvador Blopa",
        "matchName": "Salvador Blopa",
        "shirtNumber": 70,
        "position": "Substitute",
        "subPosition": "Defender"
      }
    },
    "1395131": {
      "optaId": "ebsb7romjjaopsxjtn2ty9qtw",
      "heimPlayer": {
        "id": "97639171",
        "team_id": "17544",
        "person": {
          "id": "1395131",
          "name": "Azamat Tuyakbaev",
          "firstname": "Azamat",
          "surname": "Tuyakbaev",
          "fullname": "Azamat Tuyakbaev",
          "gender": "male",
          "birthday": "13.07.2007",
          "height": "168",
          "weight": "65",
          "person_detail": {
            "id": "1372235",
            "position_1": "8",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "Taraz",
            "died": "no"
          },
          "country": [
            {
              "id": "100"
            }
          ]
        },
        "created": "09.12.2025 17:49",
        "shirtnumber": "87"
      },
      "optaPlayer": {
        "playerId": "ebsb7romjjaopsxjtn2ty9qtw",
        "firstName": "Azamat",
        "lastName": "Tuyakbayev",
        "shortFirstName": "Azamat",
        "shortLastName": "Tuyakbayev",
        "matchName": "A. Tuyakbayev",
        "shirtNumber": 87,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1420133": {
      "optaId": "5r3h17uip2r1dlw1tde1e4hzo",
      "heimPlayer": {
        "id": "99158014",
        "team_id": "1736",
        "person": {
          "id": "1420133",
          "name": "Youssoupha Sanyang",
          "firstname": "Youssoupha",
          "surname": "Sanyang",
          "fullname": "Youssoupha Sanyang",
          "gender": "male",
          "birthday": "31.08.2005",
          "height": "175",
          "weight": "68",
          "person_detail": {
            "id": "1397234",
            "position_1": "10",
            "position_2": "12",
            "preferred_side": "left",
            "birth_place": "Kunkujang",
            "died": "no"
          },
          "country": [
            {
              "id": "64"
            }
          ]
        },
        "created": "28.01.2026 22:03",
        "shirtnumber": "11"
      },
      "optaPlayer": {
        "playerId": "5r3h17uip2r1dlw1tde1e4hzo",
        "firstName": "Youssoupha",
        "lastName": "Sanyang",
        "shortFirstName": "Youssoupha",
        "shortLastName": "Sanyang",
        "matchName": "Y. Sanyang",
        "shirtNumber": 11,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1464305": {
      "optaId": "a8pnwy8wy8ytwek1ovtxkaivo",
      "heimPlayer": {
        "id": "99153016",
        "team_id": "2102",
        "person": {
          "id": "1464305",
          "name": "Alassane Diatta",
          "firstname": "Alassane",
          "surname": "Diatta",
          "fullname": "Alassane Diatta",
          "gender": "male",
          "birthday": "14.05.2005",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "1432313",
            "position_1": "13",
            "position_2": "0",
            "preferred_side": "left",
            "birth_place": "Diouloulou",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "28.01.2026 19:56",
        "shirtnumber": "38"
      },
      "optaPlayer": {
        "playerId": "a8pnwy8wy8ytwek1ovtxkaivo",
        "firstName": "Alassane",
        "lastName": "Diatta",
        "shortFirstName": "Alassane",
        "shortLastName": "Diatta",
        "matchName": "A. Diatta",
        "shirtNumber": 38,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "11"
      }
    },
    "1564328": {
      "optaId": "8nlw9h93ry3f4p5ci7f8zs0t0",
      "heimPlayer": {
        "id": "102003581",
        "team_id": "209",
        "person": {
          "id": "1564328",
          "name": "Maycon Cardozo",
          "firstname": "",
          "surname": "Maycon Cardozo",
          "fullname": "Maycon Douglas Normanha Cardozo",
          "gender": "male",
          "birthday": "10.10.2008",
          "height": "165",
          "weight": "",
          "person_detail": {
            "id": "1523408",
            "position_1": "12",
            "position_2": "8",
            "preferred_side": "right",
            "birth_place": "São Paulo",
            "died": "no"
          }
        },
        "created": "21.03.2026 17:15",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "8nlw9h93ry3f4p5ci7f8zs0t0",
        "firstName": "Maycon Douglas",
        "lastName": "Normanha Cardozo",
        "shortFirstName": "Maycon Douglas",
        "shortLastName": "Normanha Cardozo",
        "knownName": "Maycon Douglas Cardozo",
        "matchName": "Maycon Douglas Cardozo",
        "shirtNumber": 49,
        "position": "Substitute",
        "subPosition": "Midfielder"
      }
    },
    "1567877": {
      "optaId": "7amefftr5evwcnzm718rfh9n8",
      "heimPlayer": {
        "id": "101812547",
        "team_id": "205",
        "person": {
          "id": "1567877",
          "name": "Christian Kofane",
          "firstname": "Christian",
          "surname": "Kofane",
          "fullname": "Christian Michel Kofane",
          "gender": "male",
          "birthday": "26.07.2006",
          "height": "189",
          "weight": "",
          "person_detail": {
            "id": "1526975",
            "position_1": "11",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Douala",
            "died": "no"
          },
          "country": [
            {
              "id": "97"
            }
          ]
        },
        "created": "17.03.2026 19:52",
        "shirtnumber": "35"
      },
      "optaPlayer": {
        "playerId": "7amefftr5evwcnzm718rfh9n8",
        "firstName": "Christian Michel",
        "lastName": "Kofane",
        "shortFirstName": "Christian",
        "shortLastName": "Kofane",
        "matchName": "C. Kofane",
        "shirtNumber": 35,
        "position": "Striker",
        "positionSide": "Centre",
        "formationPlace": "9"
      }
    },
    "1574171": {
      "optaId": "em2wgioc2kw4uqxkhey5cn190",
      "heimPlayer": {
        "id": "102158849",
        "team_id": "594",
        "person": {
          "id": "1574171",
          "name": "Uchenna Ogundu",
          "firstname": "Uchenna",
          "surname": "Ogundu",
          "fullname": "Uchenna Ogundu",
          "gender": "male",
          "birthday": "12.05.2006",
          "height": "188",
          "weight": "76",
          "person_detail": {
            "id": "1533287",
            "position_1": "11",
            "position_2": "12",
            "preferred_side": "right",
            "birth_place": "",
            "died": "no"
          }
        },
        "created": "22.03.2026 21:16",
        "shirtnumber": "39"
      },
      "optaPlayer": {
        "playerId": "em2wgioc2kw4uqxkhey5cn190",
        "firstName": "Uchenna",
        "lastName": "Ogundu",
        "shortFirstName": "Uchenna",
        "shortLastName": "Ogundu",
        "matchName": "U. Ogundu",
        "shirtNumber": 39,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1642061": {
      "optaId": "8e6qzf8dp3c9lch7tu5r03qqc",
      "heimPlayer": {
        "id": "101925527",
        "team_id": "29680",
        "person": {
          "id": "1642061",
          "name": "Yan Diomande",
          "firstname": "Yan",
          "surname": "Diomande",
          "fullname": "Yan Diomande",
          "gender": "male",
          "birthday": "14.11.2006",
          "height": "181",
          "weight": "77",
          "person_detail": {
            "id": "1600697",
            "position_1": "10",
            "position_2": "0",
            "preferred_side": "right",
            "birth_place": "Abidjan",
            "died": "no"
          }
        },
        "created": "20.03.2026 19:16",
        "shirtnumber": "49"
      },
      "optaPlayer": {
        "playerId": "8e6qzf8dp3c9lch7tu5r03qqc",
        "firstName": "Yan",
        "lastName": "Diomande",
        "shortFirstName": "Yan",
        "shortLastName": "Diomande",
        "matchName": "Y. Diomande",
        "shirtNumber": 49,
        "position": "Striker",
        "positionSide": "Left/Centre",
        "formationPlace": "11"
      }
    },
    "1695737": {
      "optaId": "63i6o2zienvxlanzwc6pf8cus",
      "heimPlayer": {
        "id": "99158143",
        "team_id": "2102",
        "person": {
          "id": "1695737",
          "name": "Hugo López",
          "firstname": "",
          "surname": "Hugo López",
          "fullname": "Hugo López Cortés",
          "gender": "male",
          "birthday": "04.03.2007",
          "height": "",
          "weight": "",
          "person_detail": {
            "id": "1644254",
            "position_1": "8",
            "position_2": "0",
            "preferred_side": "unknown",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "193"
            }
          ]
        },
        "created": "28.01.2026 22:05",
        "shirtnumber": "32"
      },
      "optaPlayer": {
        "playerId": "63i6o2zienvxlanzwc6pf8cus",
        "firstName": "Hugo",
        "lastName": "López Cortés",
        "shortFirstName": "Hugo",
        "shortLastName": "Lopez",
        "matchName": "Hugo López",
        "shirtNumber": 32,
        "position": "Substitute",
        "subPosition": "Attacker"
      }
    },
    "1743458": {
      "optaId": "76ho81gsz5jv1x5mq8wjtek2c",
      "heimPlayer": {
        "id": "99154507",
        "team_id": "1736",
        "person": {
          "id": "1743458",
          "name": "Youssoupha Mbodji",
          "firstname": "Youssoupha",
          "surname": "Mbodji",
          "fullname": "El Hadji Youssoupha Mbodji",
          "gender": "male",
          "birthday": "09.01.2004",
          "height": "190",
          "weight": "",
          "person_detail": {
            "id": "1681088",
            "position_1": "3",
            "position_2": "6",
            "preferred_side": "left",
            "birth_place": "",
            "died": "no"
          },
          "country": [
            {
              "id": "184"
            }
          ]
        },
        "created": "28.01.2026 20:05",
        "shirtnumber": "12"
      },
      "optaPlayer": {
        "playerId": "76ho81gsz5jv1x5mq8wjtek2c",
        "firstName": "El Hadji Youssoupha",
        "lastName": "Mbodji",
        "shortFirstName": "Youssoupha",
        "shortLastName": "Mbodji",
        "matchName": "Y. Mbodji",
        "shirtNumber": 12,
        "position": "Midfielder",
        "positionSide": "Left",
        "formationPlace": "3"
      }
    }
  },
  "reversePlayerMapping": {
    "64pzn3jdqo6y2izlpm8n3tvpx": "10435",
    "b9g4qurpll4wizajo95c406hh": "236781",
    "4w4ldzomkj7fhrc51iimz8no5": "231656",
    "4ysxvym6ww4f9d3hflkqsbf11": "234287",
    "5ec2ede9uwbft3wby33mwowyd": "263584",
    "97nv3y9z2ajz6b4ynoo0jn3kl": "234281",
    "1qthvf5krys0pzk24h8wtr9at": "319011",
    "x4qyxhfr2vi007sazoqe5vit": "399317",
    "4skrm2y64va3y5jk70gz4ylpm": "503489",
    "5ch0r2awkzjfd4hv6kbw6c9gp": "482718",
    "m2c4lckkcr7yilnqxrrsgh2i": "562071",
    "3tb27261f8mpzpq3prpv8ng0l": "110264",
    "eapihgte8ydc4g6hzygsx2e39": "229558",
    "1s1v1tweyx8wxc9hj2jrnaggl": "347498",
    "2uz1cmslnjjzsgfcgji26kqg9": "350658",
    "23l48u4w5nj4036whjm3s49gp": "356660",
    "64ubq0xra74xaunooi8knyajt": "437301",
    "aaaskdins76bd0368sbpt7wq2": "576599",
    "307whzq643o50rd4g8niobyay": "518830",
    "exhxdmdq49xj4dnguq03qnlgq": "542721",
    "bx6j2y1hnu63lawn3rdoep1m2": "543466",
    "8e6qzf8dp3c9lch7tu5r03qqc": "1642061",
    "8mkkchf0ysdf78r0lncd73klw": "764313",
    "2ofcow1hf3b245myztjgvvqc4": "700531",
    "9u0jnvttp25l5bp2pvx7pces": "641184",
    "2p1pns6j6id4nx3nbi7fv0wrt": "530777",
    "70esd7csbds20h5uazwktcbje": "537044",
    "b4x911h58r8i9b2vvsnydvfo4": "833791",
    "5pousbiuqbus68yekd0mhc5pl": "403139",
    "4j9ug0ng9dhx6xwhdwx6fafx0": "811739",
    "2i8mia6uantvhtmpewgs1qz9w": "823368",
    "4rhyl8q31wceeq2dnaep9t3x0": "648988",
    "7llxni56g8q0yt33vhp1pt3o5": "263720",
    "1zumt9vkrqd8d3p3eqtwezi6t": "359856",
    "dn3llv8xjdbbndltfym5ar561": "423541",
    "d3tfdqfnab7bqxfdh3399y06i": "414344",
    "7o11dzx2cccrslutrjl16ik89": "387975",
    "8qlz4omhgfnzyb2cgeou7xn56": "437308",
    "dchp4ud6043gahy06jrm7q6i2": "547634",
    "4a59itr8bwm9auhz9f2dno104": "614767",
    "4lg41m643jf18dgax298bufpw": "805814",
    "elwm97xvha0y0t8yqx5sur9ck": "737199",
    "684cguhktvth28ql6qgvvmcyc": "843170",
    "26nfmfc8p2doisd9p8vtd33dh": "231272",
    "2p48525x4ap9m81g6ode51cyd": "233151",
    "aaoycxwi9jny6flm4apz8a2uh": "347862",
    "b4q9q0qgmtz959rygieg9ln1l": "426867",
    "f14n6d52p37nkvoo5n3i52x2h": "415089",
    "68rs7juin2mmdok00hw6uvre2": "549064",
    "39yc76urwnda0ze6qb9h00ine": "568613",
    "58d87tochcm6hk4n6l7ua7jvu": "599848",
    "39tod1iad3ztq17qveh8pwp9l": "427502",
    "3tpfqju821lze7myekb40kefo": "681415",
    "6qj9kdcrum9mqla72ytoojje1": "418685",
    "1hpivlohlnwpw0hyr9gxv5gk4": "699604",
    "byn8dfwg5zdefrca7wgn32qne": "480630",
    "16idj1wxzcbvuaov5duvpqhyi": "596237",
    "eqtsanns36za56h4pfqhbnh05": "167830",
    "cmbd33qb8zs7wi7ryhy28yycq": "637209",
    "8w9qk5a1mf1ecrm9pfncnafx0": "793664",
    "cr4e64yry1ttwcjxh2klb4ui2": "613740",
    "9cbp20wyy4ldod06myqbmkqok": "697301",
    "2k8bmlxzt0qi7divtxye0a5ii": "608397",
    "920yurg08gqayxwc80q9f8ixh": "259105",
    "4tev0kk0om8cr1xbwpt8bozit": "232662",
    "c0ewvrtk657uw4t5rlv87mq51": "336883",
    "12f4mz064elnxecq2srl7r6j9": "262601",
    "2udtmz4lvh4vil16mxvo0j4l": "354850",
    "djha3ac2mfhyb7oia64hq2nd": "469321",
    "4foax2b7unlkev1eq6py86lii": "601012",
    "c4hif6j7tldh0w7oeq8v9pcve": "631984",
    "9rglo47kroo6ob6gy7i4poqok": "701239",
    "dt8k9pwcj3zktd8xk3ai98vyt": "494077",
    "9x0s8mzjc9ey0q812sn3poums": "642888",
    "cm8po8ez5w9ms01gid6w3kwk5": "131946",
    "725lp72qyqzvbul0aarhvi99m": "568118",
    "84d0jugdidn3if1iqx4ynuxw4": "605439",
    "ew18qvvupaejxubhqmxmbd39x": "152915",
    "4ryipy52oscxkv71ws0os5w5": "301854",
    "55la79k6l8zifz8o9vbp20991": "397210",
    "pjbuqt8wiwm2ql2tfvvcn59m": "524669",
    "ag6hkplnlodzxqrs9fh7mka5m": "450810",
    "1yjv2fht4kuph088zlgwfwup6": "506636",
    "4rh8xwozidxiwvl4wi2rn0fe1": "442424",
    "c2p36c1bs0hddw58lf48iy68k": "904642",
    "d2djen6mte9953h6n4y79by1g": "710685",
    "6teffw7m19t1b3auxy22y4m0a": "610044",
    "cdlnfuy9piyga0wud4nrucvtg": "673874",
    "33rjtcl9kkwdlp34oqn4dkx9m": "572190",
    "6yhylu5q0y924amgv7vlodkgl": "234080",
    "b3sexumsdp9m96rkp5da0r47o": "839331",
    "7amefftr5evwcnzm718rfh9n8": "1567877",
    "57c808184l80uuuv7z3flcu6t": "291093",
    "84mp3eqt1ckw107hwxpby9cd1": "229806",
    "2jk8zu0m0tf7if0pyrkbo82xh": "215744",
    "b7ve7k983eaewnupejiow3jdh": "229795",
    "2az0f39bhz2kvxhopalzi0h5h": "259336",
    "bsyv3fmihshve4jcr11qmtmfp": "323712",
    "6o2v57d92t1mejod24gmufcut": "309036",
    "f5ln82l8q7gvouj3zhsp5t4gl": "295922",
    "6gjlcd7rzi3p74qwvj7ia6esq": "506246",
    "630sqbiu7utmkg8yw0h4ky8a2": "562689",
    "53nd6a4o02ebb0w2s12prijje": "601975",
    "6g4cnzr3dh0veul5svzkhmxw4": "692127",
    "tedxo29s8xx0a71z6sidw7v9": "239680",
    "5irixhhyayq9yl7sb2kohjrv9": "262786",
    "8sms9gmdoqxv60nckpyqxflqt": "415615",
    "oivi495h0xuu6sw8i1ra6dpl": "349125",
    "6qujoqysad60h70f3ac5n9ch6": "500797",
    "d2gbcc336c4zatpiif4cvm2fp": "340729",
    "46vm60m1v8o9t0aesa0bpr42y": "513295",
    "a3ib09ji7qsz6cgj3vmz5qort": "402171",
    "eg09wg0vofjk0hqg04d0m1kwk": "612855",
    "4j8y1bwt6z8iu98077xqzmvx0": "644459",
    "cyz9jisw86vjjf85xxgbae0yy": "543562",
    "dg6vrx8k026l7f8ytbu1xxj9x": "337345",
    "cc3j4hx9guihwjcb3l2toja50": "1008590",
    "5n7vp6g13q7sxkzbygfbz27oq": "562544",
    "4kolmisdpprx0wrahisadl5n9": "336538",
    "cp5t077hogyhom0scrziguyju": "697214",
    "bytrobr8rfp9zwbxzopr4vgno": "620292",
    "afk5qdami9yzapywig6ds4quh": "409838",
    "3er9krmf0k6dhv6f9ltztfend": "367915",
    "52t6t7cdsr0fjs9ukmwo9y7rp": "144110",
    "24vavcwn4hco5je9kdu9ciwgl": "259965",
    "1vv29mash2uijx542ssjk666t": "234295",
    "8l1mv5qd9vwade754v3l8epjp": "254772",
    "arwidogdfccsjv8fxa1veezf9": "315269",
    "1ywfkwrcysdlvkt859q00kt7t": "430005",
    "f0x3pa532agezdjdzcsp94l49": "491170",
    "4rtps64cca8vrscv80bgyvjf8": "646944",
    "7a12t0i88yxasiu0cj0sgqpzo": "689894",
    "92wxhgs6ts4tl5bv3heso90fe": "614281",
    "6ivap35b2p5rwv8rzigaum6wa": "567203",
    "d3xdl3p9vd1c0m316oq2pblxx": "263670",
    "6q2mf0qrkt51z28b46wltxal1": "336676",
    "a4p1m3cqm6z2p1bw97s6k46ad": "298723",
    "6rutvrgco8li4nyz7tfayxb6x": "398306",
    "bibz1qxakmbflq73marmo4nop": "460405",
    "7hnmtyfmurizitwz1whecjnmy": "504777",
    "bt35y17wl42b5t5tw6z68uwyy": "504793",
    "mgwgcv336wb93xvv0pfr6dih": "341022",
    "2kd2kqh0ykd5iuziic6590gve": "483954",
    "avk9yje6h4nndg3cufnbu2imt": "360829",
    "dedho18swt010xrsviuryauc4": "530903",
    "9ic8hvnkzj9p0ikh6bwaeoqju": "572073",
    "9taxidttdt94nmvc3mqhqq0ut": "399995",
    "2znc8bmjc183pmz1xe1j8z0fd": "362189",
    "3havaatbnk8p6gc9srgajc25l": "322749",
    "8kar47kxxc8f20vc9ul2ez3yt": "377193",
    "c3mpk7pjhma4lwkjl8v5mhox6": "499857",
    "boquhcwmad8a9gcq3jcv1m68k": "855771",
    "9kxuwgequrilkom3ru6sdxall": "388404",
    "9heh3f6hvyp4sgbu0ft4xfh05": "290399",
    "98glpci54ztzmd3yn1kttlvpx": "233079",
    "2hrvu72syd3vyic6ylygxbyl1": "336777",
    "f2ibn3ej2doay3b4u8ezeix62": "465722",
    "bqjrib66m08p1qw8315ljc38q": "541760",
    "2o570lgb5c364c395zp1ccqqy": "414043",
    "f46s4bfeipn0k33s0brsu4yl0": "710365",
    "6hotzhpidcjljm3u0ud1uqsid": "316447",
    "5dcemmjwbguvnz7sz0m8uomad": "263750",
    "5q3ft0wiy6lsy937j7nw6msq1": "362020",
    "5bnq6c53ofgo9msqn3vlobpm2": "643558",
    "acxwc7xxrtyssiy390t859kgl": "233062",
    "a79ojcztkvgui9sw4zbkmvr3d": "447799",
    "3hd9nxdb54zn4fhbf7qa7x0q1": "454658",
    "5asv6uc3a4xxsr9u30kdfc0ve": "449453",
    "2mwe6l0eu1tisri3eu26fx8x6": "472183",
    "5d3stmq3pgka4qhdfoff35t9m": "647301",
    "aplc9mad75h1k90o3qla9c7l6": "602069",
    "diyzb2gwf1zkvqyjc63085eui": "641222",
    "8ri0md3tr27a1bn10xmfkgsus": "644463",
    "bm5w5xsbbflm26pdhmejwgvs9": "470298",
    "adi6l78sdvet408eho4fi4xk9": "608000",
    "6dg2ztkkig9alktiq5zakbm5l": "414117",
    "6wpahdttyk7458xipbx7lk1lg": "621016",
    "8855nyl8htw15u4y4apom7fxm": "675867",
    "4sd2zs6d5cd4d9n3oo54lglat": "368828",
    "etfmz143p0d2yowiiijd8g6sq": "518748",
    "euywniqwcq40dqoo55xni961h": "356698",
    "6x4ywqmispidw0tznzpjwd1hx": "336779",
    "d2ykrr75737c8bzlwhjj90vkl": "231374",
    "c1yctqdku2vzho2azsgcy5dcl": "364088",
    "effmy99qczj7w9kb28u5y7mqd": "231979",
    "6govmi3dn4cxa3m0lyeqc1uj9": "319421",
    "8k5rritl3k05hubghapadgx61": "430170",
    "8yiq2pl6mno23dgg2h7p2fcut": "351377",
    "aw10uq1kb2kgr79s8zbipts5x": "291411",
    "rvqiq9rz1ur11jb8skb7419m": "690635",
    "7ush9a10cc79gudlog12crt9l": "499332",
    "3v695dpbm6bdgifkyhlie6kbu": "651895",
    "eg5haueyvosx3euq9e0ogdj6y": "559967",
    "3ynh418z6f6bfjz674vs40f6x": "441514",
    "anycrq4ug1ee012dw68tpsh2i": "693594",
    "3k6znit6fd9mbfcnphlwyvj6d": "151555",
    "8cho2d1nz18i5o0zt6aysd68l": "173389",
    "3uqn1adw8rarez1gpen9vng7p": "263614",
    "9rjd95oqotnalxmv56v7p1r6d": "354529",
    "bmrdtenqr84jt4gmw6i7wez11": "335762",
    "dqrzogrwznyks6whhfhq748ut": "358208",
    "ebj6t5jqzixrnww1z7qofznu2": "488528",
    "ec6zx0pyq0bggng1m3k6iq51w": "788058",
    "dw8cxbn8i288w0rqiemop6qs4": "670393",
    "ay89se5rytzay8md0yeadykq2": "573258",
    "c9e54hwefvwos94ri459uylbe": "694397",
    "f4qcgzveslklfi8601tep77x1": "264078",
    "6384gzzxuxs6pvmrn8qx4d7u1": "513358",
    "3pzwmymhpa20k8i6760xg5puc": "1365953",
    "curznlsytjm07efqlmyp3br2t": "331449",
    "1igjz2w9dr9mj5f4ade5plsve": "502117",
    "emvi36y613e4lqlat3wfdih9l": "336358",
    "16rur8pbshrs9xypsq7mnxzhl": "520205",
    "amd4rodp6senk2c1mmlsqozpx": "230342",
    "d608s0948uh3owqee7t0en7px": "231490",
    "7c8ms7bw3fva4xeubax4ep8et": "234282",
    "ci1nu5z8aiiikco8af0zk1lud": "233382",
    "7w63iqek6hmnizlirurla1cr9": "297145",
    "dnt7ahwfj8endqngxwfll1tjp": "397535",
    "bwqqecmqm76v5b83v1cz891p1": "348360",
    "6u47fsriz3ejlf72hxtsew5bd": "464492",
    "ftm7a5ulllwzj3n6oqa6awru": "497476",
    "280u0x6o94auqt5e8ff89xune": "480535",
    "6dtp194pewnyuhwkxcn2xpf8q": "591406",
    "4zfgh6wq7svx418tzwf0gfavp": "233619",
    "3tdsezcgdlm4laybvh4u49cr9": "295870",
    "8bvhibfn0481ckmmutiv1uhre": "101884",
    "7rltyxkrvvfg7q1hppl631soa": "483953",
    "dgysidzshgxqm3jegaihwi5wq": "450744",
    "3saz8njlttx2i4ospcwmmaqga": "552982",
    "b7cso5zljdvzfila9zd4fz4ve": "570350",
    "ej8pxizgwjx9qjacvc136yusq": "543578",
    "hsobzlp177f9755mpsi7szmy": "668800",
    "6b7p3ncup75mpop91n0u1mw2d": "359012",
    "15nsr315qb7jhyeik47x9wrxm": "542920",
    "alp8twr3g2rmfmnguffsfovtg": "642200",
    "4baqlwfu312pctopy1cx6s2c5": "256265",
    "ay6pvdyj5pjgwvjsqdfsrbw4q": "415039",
    "bvifdvoxv9e8nq8qe37c0gvrp": "173280",
    "csqsdjsa4leo6z86qphjuectm": "630981",
    "ekz97oo88fcqhay2w2hrhecyc": "651790",
    "10fuwkejg59w68jmx1ae0cfe1": "437235",
    "3es8fg7y59lckypu11i68q6s5": "263715",
    "55z0yap5tml66nes2cchg7ahh": "153414",
    "8h7u0a26g2yckx955e1g2kdbe": "551681",
    "f2o5hj0e2k3kw0fj1xzom0cet": "229855",
    "24vsicnsc44o2mr9jk0qjvb2t": "294407",
    "8k5c8po5gx3vnxx36viq08xqt": "314055",
    "5nbk2xeyrs7pxdye1jtqudhpl": "340226",
    "7zbu2y3nlj4dyhe1qdj15g3xl": "413947",
    "e0hk5aepnpo7cne006zwahfx1": "337489",
    "bc5vmdnoyshdi5hcgu8dgqxyi": "503593",
    "43eq31reskwn9veb3vickralm": "538284",
    "3h6q9lkwovcu4pynltgnzhy50": "647491",
    "b5ovydnz8s9gf0nkwofutr7ys": "620446",
    "1ljgis575ujto4361ed15w0r9": "337062",
    "8b60vtt1stnmt2uoj0f4lh49h": "230399",
    "fs5utga62tud5s06xj27qdat": "295669",
    "9nrt6uh2zw65jd7u2axlvxsoa": "476044",
    "bamobogg0wjnxd43nxunt3h4a": "615548",
    "6rxd6ltpl30qmksb5fkwrl756": "594144",
    "1px9whllb1pnprmgq4fjw3qhh": "366271",
    "849wrp9wm8cjyrbshlaukyz56": "558946",
    "6d88lw0gtv7ay0hk0p51fwhzo": "554000",
    "9ic9msq3tj4gx8wqa6wfwk50q": "695046",
    "8sp01319vyxst4lfxjjp91ii1": "427662",
    "elvudk6nh32u82voy48c3ov10": "1319924",
    "514es9hzl2skv9dl5cofgkogl": "337038",
    "7ngbzn51z20j8s1drzdtwiove": "614045",
    "8l0am8k4pg2s9g9qbkhwte6dx": "253324",
    "5g5ml1wwa9dfhsh55hv7br45x": "384958",
    "7xc0qldxpidl07vij2wgu1sk5": "361297",
    "22zaq3o78o5feeogqdsvig02y": "511596",
    "4o71xxq6qdkhug58a073fxega": "532203",
    "bh8t0fz0czhgepa3rskdxmt7u": "564683",
    "bntg1x82gm63kbo7ijai64gk": "645249",
    "apdrig6xt1hxub1986s3uh1x": "231497",
    "8im7pgnph2au11blma5pewe09": "450033",
    "e4c4tmuny1mrnofany1sbfy8k": "896453",
    "943lx505f9ple1gtxx9m178q1": "361425",
    "25rjy5k2ogin7zcxqhwflls2y": "507546",
    "1sun9nitagc7ikkpwzrdkj179": "346934",
    "akw8xefrrg5q78q74h4kuj3f8": "807473",
    "ad2qplv0aa66l11ipq6yh0hd5": "515588",
    "25vb30mtetefhp3ix26nlhx0q": "497478",
    "8y0fi184nbaewtg4t9klt0tg4": "933072",
    "6rg37ej1x7pwi7r4aq1107pih": "413825",
    "1e2hez2ipfx9aqg6h18aao222": "650729",
    "dx47szytc8vttuj4rcn4yzdre": "527188",
    "rlgrvvibryod2g92hqc97ii2": "664604",
    "4whvqapvco3c56audz34s6jv8": "675463",
    "e30x514qvzadcryj2zhoss26s": "900125",
    "1en0bgq0u842snszevlkscxk9": "472591",
    "6n54br4iwdggqvid7oirzfn8q": "615546",
    "bxwa90x92eaokwxwylx7389re": "510292",
    "65v1s740zfmpwkc0z1v3aisd0": "620412",
    "4z9prwdr22kb7vpemekkzqooa": "543462",
    "spjwukiya1mdmpbk7f4baolw": "645048",
    "e91s5lp3fvfaav8w8xi7wdx3p": "349135",
    "oel537m4mtjwwnyusz6efj6d": "240809",
    "8828sbg7wzgjbs1727j0rx84q": "596998",
    "6ie5meimavc8kwohr6lrdyket": "285208",
    "3akb6xex1efr9ypj8yxr2uf4k": "654403",
    "6ir1z8c3o7t4kqx04kw24i415": "469097",
    "dvqog8r05iw9zqr68l4fcnre2": "613296",
    "74n6zo57y4h14zll0p5ncm3ca": "600710",
    "6lfje6glfgycun47flgmc9jvt": "455381",
    "eswxx8pxqyuj7rnpvqawpej1l": "447991",
    "xuk3qlmk4985hs8ocjjd49ka": "539693",
    "ay8tikc1j1r2luqovxrmuf9xw": "942795",
    "arjwwth6yazptr851wu2u6e0a": "498892",
    "8prrhz0d1i4vxkhgro8p42bxl": "401279",
    "cl6720rdjeubt0bc3su0qg3qh": "410730",
    "5ql70wwevaoqpxabylew5f696": "599637",
    "64vve6gzn5mwodos6ynufwa5m": "619933",
    "89s9fm31pcfq7l28kc2kad4kq": "616003",
    "7gwm8sjtl2vyfeh6mio8ve9ec": "606939",
    "cwr29t2879szijm010ae1u5m1": "473145",
    "8nug6t1cmn9pwhnwdf6nyhrrp": "226802",
    "ejnh215cji6xou661kiwcc91x": "142033",
    "ejuw5de99fjgrxdn79aulbm96": "513370",
    "5a9y4yka5m1ft3f4e16f3ycfe": "485977",
    "bf2pf3hs8gcvub4ivlve12ymt": "292187",
    "c1s9pmfkytw0du5ril4kv9i0a": "602558",
    "2nqhczrkd45rdu5fcmq1wjo45": "262027",
    "6a0w73agnkslcc6gea1jxxzvt": "369823",
    "4y167h8sn9cnyrvb097lf8lbd": "465657",
    "7jpasvui43tnyao6ijyuuyuqc": "595804",
    "c0dvcjq2rfqs3jj5g5v2m5zsa": "642265",
    "dvhjw2ieemakzw9o56r6y4foq": "556950",
    "cakrv1htznb13clvaju68v04q": "546623",
    "3nok8qxxj2zl831wgvc7abxuc": "692915",
    "6vkppmpdrvrujfp035ucpib8q": "676380",
    "axj39lx25teh62rih6uv9qor9": "111404",
    "7dayrhr0c60zbc1b6lig8pm8l": "366737",
    "e1islmeew98wa2ge0dicloay2": "530400",
    "17iz3i6kzdxc115bdlgcgqdck": "697303",
    "5ph2ln91ycq1qlq03cnqqs9re": "542264",
    "97u083i6ktyeu7xf6aqfotzp": "231484",
    "3inva12wuqo70czviv1b0us5w": "789685",
    "4qrvwap878sl5dz5n3o8mr71m": "514679",
    "81qmlg0ttijhkywm55ejdr40k": "760594",
    "3ctafpdiixwdyfrx677kp73f8": "893034",
    "amcwh6w0brmkttg4uc5qm6z9w": "710180",
    "6sj31v61vtwwxe5hhwkj80g7o": "643742",
    "e7if3ma2jblaurrokcxadk0k5": "259967",
    "5tg6w4wmwtiwvdvsmju5svdhw": "651049",
    "83usrrx99pkiihnkz44dt2gru": "530961",
    "eolso19u03zxw2pca2i95v4dl": "425562",
    "34z1r2585ifo6zdcfuu6xumfo": "680054",
    "cfg7sawvthk1g1zk06wgyym1g": "789154",
    "2we9yak4ipkr1ljigj20puv6y": "548619",
    "14fw7p4fzaxprndgxnx0gxgbt": "442698",
    "di9k6xr6j4arjoltl7s9yp6cq": "527176",
    "vzbmf6lqvbw398clnt7jyiqy": "508054",
    "a6cke0ad2pvuyahweuch772ay": "600556",
    "bf6s84lavpij33riqec7y8445": "420643",
    "cjok1odm3twxo7sqye3hua6eh": "361662",
    "bkbmygo5f1glcs6xssawl26z9": "291435",
    "4v1bqelw9bk1gftvzwzk6w6w9": "455765",
    "375gnysvjk9bvq02ex1lkmynd": "475905",
    "46vqjnait1zb6tiaverz42bdg": "800529",
    "cxjhkrssym30glew7p7in04k4": "701180",
    "cnf7quyillyf560nh14taliw9": "367921",
    "1ghyb2ozmwm2o9bxzuxzw7yfo": "855762",
    "5rnmjho9ntzolo7ogkhyaey38": "701238",
    "3g9riero16s160evc28u3q3u1": "441955",
    "ekl9e2t93vow1buusgdcs3giy": "610580",
    "rn17zrbsh1g9r1tj4xyvhgr8": "826338",
    "7kjhx78gpi6m3r4j1b4jdyh91": "229649",
    "9t5pmugcj12kr6kju47w4ehw4": "644136",
    "d5mck7rf48chzersephpx29d5": "415412",
    "awda32rw2clw0sjemf7rkcel1": "169056",
    "e36lcgg2vegiecbez2j15fl9m": "518749",
    "clrnb4f1yk8z6fbcwyv9vmkus": "783683",
    "3wsyacqj7ci0ga9bzb988v7qh": "486981",
    "7snt4uu7f2d0g7utjm2xfis8a": "513290",
    "2pjr6yz65f4uqvwniy4vphn85": "263930",
    "ojqb7kv87o0cidbckgtg1rdh": "364855",
    "f2f68n13t1nd3cjwair6jrip6": "565111",
    "3krglbuxncb1fvl3p1sezhoq2": "569016",
    "6s9jrt5xu2i7tqcfhqct64mhh": "367620",
    "ns0d3voludn8of98yc2e6ehh": "229557",
    "47bjfjrtjv3uv5lnguc2ycg0k": "792181",
    "8vhqai1dxnmk0pjqt32tyb5ec": "707309",
    "aw83l7afhw2lhkg8qm7mbnms4": "638524",
    "87kc5hjp3ry2z624wty5h7g4q": "546632",
    "ckjid5lfgbx8tdyoi32vbwn9x": "262049",
    "9b7iei751ersl6ny0o0k8gn3d": "459938",
    "3awoq36w443aauvv1xnffjlyh": "450791",
    "3igg6gfmomgh1t5ohwzbpb5cl": "298724",
    "al6dgtinz0ki8uj8wrvc7fg2c": "804915",
    "1psr9ra8k9j4r94p1xixagzbp": "341169",
    "dgubl900t52nssngev6atayju": "519295",
    "4vy3j1o829f561jf4fqum7ob9": "259299",
    "d3ikbsb9xrytwlf4ls34cvqol": "242414",
    "6ki6rv564ybctrajr2xtgyeax": "480313",
    "2ciak27414tln8ac4t4xj38id": "166543",
    "3e4s03gec7n4fe7llngv6hel0": "805599",
    "atlhc604ri3rr4w012otutyj8": "679992",
    "6mxpnfdozs8iqod835jw9jwus": "650465",
    "91n9wzn3qq2789zq8vdmfrd62": "562538",
    "7gzdg0j9usc3yq0dd1ad57sgl": "264096",
    "4xhnmoqgxoheel005ek6ckfs9": "416099",
    "asxjrv3xorpe30y78qqd5cw0k": "783119",
    "7lai6ovwsl01gonutejt4mms5": "229714",
    "8p2yagsx6ujdbmeonkd3u4c89": "485355",
    "w0wt7gjkdddn63a4258j8frp": "313335",
    "2bsmlmrjtknurmuzuckyr2h3o": "794205",
    "1675dd1p91lb20f9b3w5v067e": "505287",
    "aopmwx748flafzpj58w2afwlx": "263391",
    "44i5i1fr0mw3mymdbepzkj9ck": "639844",
    "du9vq193cqx7gmve30eijws15": "460497",
    "4jetfgij9sfzo09ffr558bwno": "550082",
    "5w7ztsau360j3zd1aai33d4b8": "915669",
    "43n323o8koqdvybews4kihel0": "465967",
    "4l3qk2g87pa3bevo2nlwkf3rp": "137598",
    "980t379w5cp7umv1eltwlfca1": "416092",
    "6go1e6kiezmwexizbpo7pp0yc": "616880",
    "3e79d5436l57bfj3ywbjvfr6y": "660207",
    "egmcpa7j5clzga5m0zvg2f105": "355792",
    "e07b6h22s8ve5yxj4dk3mak2c": "1239917",
    "3mp7p8tytgkbwi8itxl5mfkrt": "453451",
    "e4vr28e9cbq3q5nux1jlpuuei": "520526",
    "2t9287y4uvo424uhvwjpn1jx0": "783686",
    "a9jc36ub52lh0jgq2ya56wyui": "537046",
    "582uvj0i3dvm0zwbou9q68pgp": "457633",
    "d1e8em0pe47h68uq73h8aq1w4": "639085",
    "743i0lyudasctc2cmxz851hxw": "702445",
    "qt1wbjej8amtydluzvfudhxw": "699378",
    "bhrfr8rtpsm889f93erdlbb4k": "903430",
    "adcmwodw7raphk57z8m46f97u": "617191",
    "dw9fzixumboknmucqgqffurmy": "543572",
    "7smbk83rqjkkcqqduw4vyefx0": "614733",
    "avg54tzd7cxjld09569czfgus": "718635",
    "bwhn9ve3o3jh21a4vuyjmzbbo": "811431",
    "bc32mchq3v7fci4vy04e37yms": "697124",
    "1g69rnx39ak976l3yjbg2p1jo": "648263",
    "b9xr5ekjfzw6jk25b4vo7s6c4": "827162",
    "dvic19ojqq6erwene0ijta61g": "608587",
    "7c6034wb3zsuq9nhxxiahiuol": "173268",
    "2dxsntw3djezptdjqzu0oxi7e": "606812",
    "4r3am2657ubdk372od3oqm1g": "699379",
    "5wn1xudozb4s78x0m8ch7vn8q": "570069",
    "acrwmucmu5zajj159f30of384": "856320",
    "7wsv4h6o1ps1vxxvs6dnt6az8": "937265",
    "payije8nojdfrbkuq9hj2sph": "353533",
    "3isbv9egu9vzxnna4ix8gcudx": "297902",
    "2zny241yb0xio4i7k9a5k76s4": "657188",
    "bno18pni4atsobrxawb31vdd6": "530947",
    "xeybxsihh2ggg35oz4ws6jv8": "692094",
    "axcrcuv22693vn0a887samsph": "153968",
    "9fd19beamnr8qmhqdvzr7fcyy": "564529",
    "bhsdzppop8jwjsxwftizot1t6": "569675",
    "7at6knpizbafid4br861pi6zt": "414663",
    "e0ywbn79yd3cd9kfngcgffxg4": "646379",
    "1po7tmdv73zfjentt0p20wdlh": "350226",
    "32ko5zzk7805mp4q4n3iwiihg": "979911",
    "3e7h2fmxpv8wjyj8tkki1oe1g": "921461",
    "2n808wa0h841cn8xi78n21v8q": "532583",
    "edgnkgpt7a6rzffcd012sqfpw": "661699",
    "cywgibmici8hwp1ad1nhk3ufp": "302020",
    "6tzrulqvl1ytj9907ueeanskq": "618992",
    "7hugqbtot3c8fmxtfqld9l15g": "737180",
    "90wsjxdc3ibvah5gm9tnsjwbu": "610035",
    "9itdoft61idx19f23g7xzxpm": "617320",
    "aykbbz6l05b9t5n8uaxp6n2fo": "906129",
    "6hh1y9t572yqk7d1zegi0hm5m": "508417",
    "jflu7a5n4f3ezoj20z0kje5m": "515774",
    "aku4u63qd4l6k1pmp3u8y7x90": "861677",
    "em2wgioc2kw4uqxkhey5cn190": "1574171",
    "cgnl3msfddxlw37gu1jtiu42c": "822233",
    "42ounta8vuqzh8xy2g6ymgjro": "888726",
    "ijttr9nlo90ugxg03kyv7pxw": "678955",
    "cjznkoq68kxguutsoysecwbh0": "904771",
    "8nlw9h93ry3f4p5ci7f8zs0t0": "1564328",
    "f577akgydk4t6ui45iyab2a22": "604533",
    "bs71ipy5lx696fixg10eq0aac": "833890",
    "3gylv681hddh1qhi0p07esf84": "688430",
    "br2uswvdgoj7ndkx7mnbwgyd": "28316",
    "m2nkidcdrspnmeq177yv7kk": "792472",
    "bwrtljwa3px624mxp49xa6psk": "651307",
    "9sexp3trzdm6h50dk2y9hrjl5": "454321",
    "9orn6va4xvbfp1zdqb8ri2oes": "1050905",
    "5ayo0fp6wod7cqg71e38zdz4k": "656515",
    "5kd57453a90zahgdxwkghr816": "551857",
    "do5tibysnhbnbw18nwdo39kut": "364467",
    "b91n9sdabth8oocdawayybdud": "331094",
    "9d5h5wxf44qu4fw3jk2pgis16": "513654",
    "ddvvwqxpsqqboupi3gx1ijhed": "301688",
    "ck7lu09geq8mi6vkf2llyi5ii": "861539",
    "dfcbvsb7o18lavmonbp5ucwoa": "550931",
    "7aoe0u87gxgv9tvgrotcfue7e": "551467",
    "4vlurpsi44g09g159t61u83bp": "375773",
    "83n1qv6ypl625aolzjeqifv11": "338777",
    "dhs8pujk55ewcis7y5alchu22": "531018",
    "6o76owze8y78ue9sb49g8kyz8": "593900",
    "4iijb6llnz28unsz4rirr3umt": "346175",
    "4wic6z72nwmhkheme209fcmp5": "481919",
    "8libvn3hxypz8x7gm4mr7kj55": "450473",
    "73xu8dfkmgivh8l71hkqfe6sp": "413141",
    "e3il1t1s5lrn4g8t85fcm40oa": "512593",
    "80aqmv4ht6rs1812qrr5j8kix": "494051",
    "atigcsq78g14w82lwvay26aj9": "364466",
    "6jgocc12bori2wygyu07c082x": "424596",
    "aqlakf0mo95rlktf6xdbaegh5": "512810",
    "b2rqgjegzeyq6wy6qu63zz2fo": "734730",
    "8qwpdf5jof7o6yy47v6iv11hx": "279262",
    "8hm6d6395johhjsoe8jz6dcyd": "163015",
    "3tzvbdszdrj1tayik9igbve8l": "366854",
    "7ocm7nugzwos59il1pm4eub8q": "621668",
    "26wj6flfqi59vgz6vwjgur2ay": "605314",
    "1xsrdgt40nb6p9qvt6mf272fo": "734727",
    "8ju1opnca42o8i00wq3onzmqd": "263530",
    "19z8jmren3eytg7fbuzqv73kl": "370625",
    "a4kw8u4dqsslfwe1ux08lbmc": "617437",
    "6crmq7vzqts58wg196q48sc7p": "150583",
    "8wvkrrbqqthuwda8twg03yuax": "425940",
    "39gif4xfy8xddarasbsad56ok": "758335",
    "d2hnxi1yi5rgqj1tvxh1813x0": "808752",
    "1fkntyd2z8e169yh98k0zst90": "900608",
    "5e9ilgrz3tzg9kd1gk3yvrahh": "366468",
    "broq8imimhtlejtffissquy5m": "519933",
    "aipyotc87m5bdvmvizd5n69k9": "442002",
    "1i9wi65k2foqwudeqiyih87hl": "415257",
    "actvnm36s31zf8wh8hjikzlqt": "134830",
    "74edqcuzfzy7nswqzn0v3pe22": "538532",
    "8qezzr83ofw7htqufohg2fwlx": "273274",
    "6kicom9a3lzp49urle78bevl6": "521107",
    "4zxrdmwphkxvkvo6bt30uanrp": "253321",
    "58qeglyxdi7y8ttg8sddv8set": "234049",
    "br7zigajqee6fms35zhm1sb8p": "478563",
    "cm7l7qimy4iysm1khmpc7u961": "484685",
    "yq0cm7vwr0tkv7nvt9vo77bp": "379963",
    "1lgrnaje6y7un5dzzll84p91": "264235",
    "e5xxqwz0sdlwkkmp8bgs1k6w9": "450250",
    "7oykphzczagr975xsqt70s89h": "255594",
    "3jln1gzc0859ymphvq83i0mp5": "426937",
    "b4witgokm49tidm1a83qcvbop": "486788",
    "e0cy0gwf04lohf0xjef0af8fe": "595385",
    "a7ip51ik4rkqcvgdsh64ln09g": "808604",
    "atj6u4qul0o2ca57etbmes07o": "617427",
    "b3vvxolwxcukqk76hb4scvh79": "384352",
    "6u2ob6fv950r1qve8uejkq2uh": "442004",
    "1xofhzib5lyqx285j8x36xg8a": "541987",
    "d196vatyvq6ycn1q7d477d2i1": "499512",
    "7ohgxs03szerp6mwiiv58ryay": "632094",
    "b8dd5q3n5irlkcv0ekzqhzc2x": "543823",
    "b3hr4q25jvqr7565z5ydqylt5": "373216",
    "b33rlpjo3kx4477alx82si5wq": "541309",
    "7gyfpskzbb3r5nhiniky22o6h": "482037",
    "2ugzqrpaooto1r24a6kvqf2ll": "385424",
    "288nn7pbq5ewriiyb9o7da86h": "469807",
    "6j0ogojh2b7poyceg7i3k09yi": "485145",
    "6kvtqep8korw8d75n5me0lbmc": "641200",
    "3ua8gs8tzx1dkdi9z88kjk9nt": "442135",
    "dowh6oc93ggduous7ligguqne": "512955",
    "7pirs3v9u80j5qy71cmhzbxn8": "808590",
    "ahz2npxe4geixkaz25f2pc82d": "373271",
    "4st4hurqbtyzw1tbkzuuk78fe": "504064",
    "2p86mzr8qnu9iy01fusvovf56": "595245",
    "4dh4ws8ehn6uywozt6ygczs2d": "277577",
    "5f5e6wufz0x041bvqzor10k16": "635303",
    "5i2tc06romjqx7a7wlu1iye7e": "610567",
    "a536nk8ps5vrgextz3k3hcl0q": "563153",
    "x32fbvwwxkda9ruezw67b3dh": "125938",
    "7sd87ylfbtgwgpb70hf68cel1": "384101",
    "1kmvf5y1wi6jysfkoqet28xnu": "638137",
    "f4p22zbcs9l5dwhvqg6wstmcq": "608395",
    "f2dutxek3uf0yi1ee32a3u2cq": "567769",
    "3i53phcjc5vwe7i0m9pqjo3fu": "516503",
    "7s9o8unhgvf00mn7vdxeeeq96": "579445",
    "clj0vy9st6zmjavz5yf8dbac4": "817036",
    "a07r604q1pzwqxqh6ci2euggl": "279830",
    "61buzozpq09ny7c0op8mj8a95": "456328",
    "6r4w05uhnwtloks9o59g6i221": "472560",
    "chxqf35ulanj3zcino8zrufsa": "690075",
    "b7c3s9rkunqkgc3h3u8xbx71l": "532144",
    "c9lowjmj8dvkqzwtr1cuh1dqt": "549863",
    "9bq6ktvpmk31z74eqdwu4qk7p": "369060",
    "649anpduq5pwrqbek73wr8n6y": "583669",
    "obyc7da7fzaztqjti91oqtp1": "305568",
    "3l8qmtatt3cr27g2lbsy1kvmc": "809715",
    "amuqk3xvo87ppk7fz39cg0pre": "600148",
    "6pavdf2072176dag5nt8qni8k": "786971",
    "48xw6q1zl0wws78a4nxfbir55": "448432",
    "34hf426mfmzrveesligyijmga": "579441",
    "8uj1pf52hctbd2uxjz4s4tnxm": "638020",
    "l469vtpe0jbgg5sq1v2e67e1": "461519",
    "505oa888m5vi62ez2tsmod6ju": "516473",
    "9vdhoij110u7e94lh8uflo5w5": "300334",
    "eh86vsvlme3o95aw2z8tr89gp": "425898",
    "bqdvz9kytf1u5iuv6m70k8i96": "514361",
    "897kbab7cx7bnhxhaghpy3f11": "274163",
    "gq4abws0ogyk223tpkxy5ex": "425636",
    "76ho81gsz5jv1x5mq8wjtek2c": "1743458",
    "5lwvt18g3d2qpuce2nqul4cet": "332809",
    "9qoc020keotb4s72a09zm5pzp": "399996",
    "4l09nrr75hpk80bq7himhav2t": "336742",
    "cx3hbvqw7lw1j4r5k33l63dre": "629309",
    "7oz324ar8tp6nkd934y096q22": "520545",
    "16rhwnvicrl1e9xqw867zuxn9": "290289",
    "8pyq4t68w42u3fgd2w7tjykbu": "598715",
    "do2fwr0qn3kg0qb40e3i36q51": "353823",
    "7gqecbxztxxovmo1b6zqqcgve": "534188",
    "b2ibeioms7t9vb3au7tpqys4p": "490342",
    "38qnvrvf3y1xs22tovwy21jv9": "371881",
    "bjgxlgzxbm2fj3c2xq6mtsru1": "390172",
    "7dnxkce4kn8qchaavv6e4tm21": "448136",
    "2r893xoeuqhgoe2w2auhqb696": "540241",
    "1arzd8hqj73byhduozscqz5uy": "538921",
    "dgki9si023s93nymhod74jlzo": "827147",
    "driu8wojk2aig2t9yesy71vro": "806058",
    "d95uicftg11gdyf5yk2ntt1jo": "852822",
    "d5jihfuxjuw51jgt6k4zhmrmy": "668802",
    "5hst73ivtxknjb3rrdivwygnp": "362904",
    "3zg0pvrja75d3l44dq0lh4kb9": "369321",
    "e5oet393vired282yco4i7gfd": "511190",
    "cxnlzyy9fxaca1u53y4soqk89": "447930",
    "bqh87676f46jsdfftw2gt1mok": "697308",
    "8s5u921me5pvsfyvysjgpu2qy": "441599",
    "b0qvtgy82m0or7vw2brgmpsyd": "267794",
    "yzee990gbkpl00qdgr6h3r2t": "360368",
    "1rjzsyc8yt25tyelzg820if2t": "300038",
    "50y6nq2eok9lnmldevkamkkwl": "302645",
    "bbf1u7db2qw8u4bega6b0uesq": "528820",
    "44f0q2ucrld1rwcwx63vgs7hl": "472034",
    "8ndcu9m0952u79qfvnmhux9wq": "673203",
    "ch0a4pjl5j095773ajdm9pn56": "524892",
    "26wyfq7l14vnr0fvkl509ynkl": "133206",
    "3coml6cxqa86px9up8yy3oz1m": "537058",
    "cu7dqkhlo7kms52cdes451bdh": "366906",
    "9x0m798xryi14snu8a7emtplh": "299046",
    "3ejpzdtnpo1r4yvxcq2e8cqg9": "406438",
    "2zdyvjcz5672e6n7cmgo89tcl": "337004",
    "7goksqm8rew8chdswsx5cidhx": "24032",
    "76n4eg1xu5qvf9bkwy4p8jsut": "425547",
    "4as71su7n7lm5r2osfz1w8p1x": "355253",
    "9rsb1aobamti72d8wm5y6qz56": "620909",
    "9m66crpktao9g80wc8zi9y5ex": "410519",
    "94kzhufmz3ktpn1a9z1y91at": "16088",
    "4pxoxtkjnhgmvxrwsgfzfl7md": "417147",
    "e5gsmkgu13y4f0abcwmeyjwet": "349133",
    "ce2pidh4dpd1ccozn2lm3qtw5": "314177",
    "81aug4xpk4fm2tii5dkg2tc5x": "446586",
    "1v8r5d4v9eh3011wmwhk3v36d": "158725",
    "97vuoqg0x9nx56dmd9u5e12hh": "386503",
    "eyx98nfx3ecgzvrh76wb1nbbo": "854734",
    "degqtleco9n5tlt0yz3q5t9ii": "541317",
    "7y27gzw2djj8q6tx0i8vw9jbo": "1128566",
    "esb4b21x729db8od4c4xt8ciy": "513309",
    "6sv29rmngsiyx4pv6zto3mklx": "309978",
    "cmxmyld8l4gjy03zxskyxf5gq": "456351",
    "evwzikhqpwulci3y20ckeoc15": "506150",
    "661b6x35l9b9uieqbcq7el1hx": "330992",
    "3uc9z96xvain84leorf4ls962": "622075",
    "5e2zgfe3ltc6qbnoqdfshqsph": "421707",
    "7c2wnewpcf1idj6ghj6gu0wyd": "369320",
    "1zxwich342p8fholev7ddkwh6": "593101",
    "8jt4vsixxoqp4uvskyfl7k222": "569624",
    "dczrgxyolp7lcz413wkz7ap61": "494884",
    "eaqqezw2ed1u0tt3zc128mr1m": "594979",
    "dl10343h8yopcgerzur5samwa": "567392",
    "6psklvi66inwws7buzf16yjft": "485205",
    "d9yxninyn4bac8f0ufxsnlqll": "427776",
    "39ccv9t7ydrrcwd1es1xu2e50": "656855",
    "8ezfdv6lgv4gz8kogxvvn1rtg": "855484",
    "47l204bkq2qqjhtazusr0019m": "577021",
    "7dkhv2l8y6jq20l1dc2ye17je": "642083",
    "4n18t6bixl6ba3bx76hym51qs": "631895",
    "cx6fxszjvjam6zb3c3p0dd1jo": "677537",
    "70tsvrcmklvp4ecdhxlugf8ix": "442564",
    "3mctpepmqunc1a8zro2nq1wtm": "525891",
    "baakmd4ndnulbl9npvmq90mvp": "267392",
    "2zkaf848fjcdhuii8783pkm7e": "542722",
    "35qg0rrwtl00pycx468s62m3u": "497462",
    "57btqxe5sy3ygzxpp55p4umdx": "290989",
    "dafbvyorudvujxw7zswicykmh": "409495",
    "almf0gtdjmsdm5zhyot1hvydx": "346005",
    "ahgd3on22t4h7gg9ipnj1itw5": "368872",
    "q6ns1fyw7w10xkkubh8etfc9": "417654",
    "botfgp0oq4wqlwtcs9m90kded": "232676",
    "by2gxuixij1eciu56k8mb3cgl": "168297",
    "19856wqwrmzmvfw9thf0tzrv9": "314143",
    "2r6hs8npijvt4wekd059t6tx": "370974",
    "1v6nfd46wx11jbfertslccbo4": "814907",
    "1xscywgyfqisqexmpfvbf9g45": "101437",
    "bagn0ce4xunsiz3mezrtqx1p1": "10864",
    "66nvc8a4kd3cyeyj3i474cudx": "388224",
    "7wz2sc3d07aaduyhmihffa2hg": "713699",
    "bpprd2haoafk6y0rjans4iytx": "365857",
    "4qejyummzkrfllds8ord642qx": "434092",
    "8hgpvnzy2mra3ps209tniq7f8": "814612",
    "6km3r9cspyz7g6343o9mri63u": "590075",
    "dpcws493fepch23sk26m1a8yd": "267479",
    "4d17grk2qflzake218uz76uei": "540688",
    "1wse4b1hxu37e7t5ty5ykn7c9": "473874",
    "6u7iuum6kqfwb4pbw5lsoff56": "645504",
    "ejbp3sxls7lgrg6y3a9q4u978": "714232",
    "53d0pvr7ylvfhp6p749iniqc5": "327010",
    "9qo448ueot8pfc5oqo378wag9": "513351",
    "9psfk94nduz6icnuwty5v9all": "409131",
    "5ga7g20wsa7oqjbh4ijoeknl6": "513233",
    "7x6mnev1ob4u5ffmdsvusb4rt": "428046",
    "2zfjgh5747ge9r9q0thbk123t": "416097",
    "eziqega9e25bg939pfh4vjp3p": "316361",
    "5ilkkfbsss0bxd6ttdlqg0uz9": "229902",
    "avh60ensgiwz1qalvn1bbqkfd": "478658",
    "dxze3b3fsfl814bjcs7q6wcet": "215233",
    "2k5g68ywtr79lc45wozvifqlm": "542661",
    "c83h08n0vnjvfgglyefy03h0p": "488698",
    "eh1ul4duphy1iz4odwx9tkjjd": "459904",
    "716n1970vi9rvw5b4w9qmjfth": "163477",
    "40gxfsz7bgrkdudqewlpxzyzt": "429890",
    "6xulax65kp4aid70nk7g5jr2t": "377323",
    "3gsprcdyogabeb8lr2y0bmytx": "278821",
    "amxunh6enoc99r07cp7qt621h": "331355",
    "2yt9oajv9dkbju8tgy1g2nmqd": "230732",
    "9e7ybe0nsu3byq2tteey3zuy2": "632334",
    "abq67eup8kd31w8da2i0eftgp": "471263",
    "5es43b4a7fv0lkmp63dj439ey": "606256",
    "b9kfek16otvdorssn0wzkb36d": "164283",
    "3vx94h32ahujciraspdayj9t6": "655389",
    "am6ppbdrbz4ml3xsbty53o73d": "477198",
    "5tbz2hexz7vind39ot6govqzu": "582551",
    "6akzpi6rd6qq0ke07ojnhpoet": "301430",
    "ieu0x9fy8hpqyztdjg8bgpnt": "435112",
    "154gonr6x9vuraxmzd9zi5xck": "947677",
    "d0kzduhj90areaill2gvvw6xg": "722064",
    "a2zavv31d2aadyddk0kjttdgq": "672832",
    "1vr896w03yky9kmu8x5tjkicp": "421272",
    "8z0395s37qe2lqi9qsvyskgk5": "253221",
    "4zy4d60v2qmaplm9xbe51y1gp": "479759",
    "f3v58fkymhrprt5gs0ccm29xx": "368328",
    "cionsifzpx5rhc8es29wv6i95": "485208",
    "54mv7lufwxcy2gih8owyr00lw": "914321",
    "d3dv3vc71981v5oems59892sq": "572071",
    "a71n80h977h7fu99ftnri5zsa": "606043",
    "8h5jl1u3p8sr2pwdmyxl14416": "573600",
    "ecwzzrkn1snbua5yu4gehxm2": "533417",
    "929ho421g2zacylfc97m23uac": "608213",
    "cis0z72hgahfnfjduk7hdnz3e": "589188",
    "130pg17ru5fzq4igokx0k73e1": "729362",
    "b2e12l3s3dxgyr8d2rk5qb9ey": "561329",
    "2fsgc0b4mvwpenawmit0q0bmd": "312667",
    "9q01y4w4dwpaqf8lmpv9wnmc5": "173407",
    "aripnzu9yo2wlr8ud93ufdhih": "448347",
    "7ox43isyywsnrfcd56nm65be": "539094",
    "2idy9ngk2rojseoxxw9n98c7p": "260377",
    "eu9b86opw6n66vftu1r5alfqh": "438600",
    "63tj5b59b7en3tnd4sjff8woa": "653277",
    "1fsum47fkh62rer9xxe3smctm": "567735",
    "bl76cebhta912vfi9z7ky32p6": "507827",
    "11r7kkbcv2bn8lar3unczuz8p": "448809",
    "8b3igmuipfhfzm39ack89de96": "527987",
    "2s2fzli5c7h9dfcertq2dwxec": "805596",
    "9v4l7ic3ve6d22c0gs9p1oe3u": "520919",
    "2u6hj8z2g0r7b5roxpluy4sbu": "570397",
    "4cejhrr3ji36591xf54jue3ca": "604844",
    "20eqyvyrgtafzssdh0zaehdsk": "971613",
    "1f37bo8dikes3350u2a0h9hm2": "511928",
    "70zr0nhl2tgyor1oajhcxg6j8": "1201424",
    "9s9i1a7hdq5bud8ma2dqi295h": "259142",
    "65z99j774kjnbf7vm0u2q0jit": "158259",
    "c589fk8pfqvbukvtdqu1yhjv9": "355716",
    "9sxg58hszjq17avxgumftdu22": "485107",
    "8mjj0wgufggpc1ai2dk21h90p": "526279",
    "18paf5a7rfe4kutxjl4cwd695": "427101",
    "5wengf05apke7rv3kms186j56": "561224",
    "bdmomasg7lrn5pwihecvgpuga": "564705",
    "6f1ljb0an6d0g4nbap6xgxsyd": "168416",
    "bkwxem45cf48k14euwqe7rs44": "833715",
    "awsod0zmnrukk21d4882ji7e1": "508042",
    "4ftlhtels58lyzfluwofzwxuy": "633899",
    "afxjicw89683nlpms9yy5x51x": "17534",
    "2wl6h1rlrfnn2mr65vuo3t815": "440872",
    "5f8kjgsaabn2li5r7bvpebbsa": "530209",
    "604osk9a3lxpfpkavuziqmn6x": "420727",
    "cjll1xrw3xulnl23c9tlf6rys": "801244",
    "6l1y87tlepsvr83d8y2qifeqy": "657963",
    "cfpaejad8i9p2r1fj0wx0g222": "504616",
    "5tbabvk43ljv3z3wd9mh0y8r9": "493957",
    "37d7oej48pb143o5eilue1hhx": "343173",
    "2szgrzcosfeifh664tgt3mfvt": "475490",
    "4jwkz8almo2997hvp09zl0p9l": "423365",
    "4ggz7e009bq3yltc9o6mifbah": "488712",
    "4gq1u1mqg0qzekh1u5djleeax": "359911",
    "3hht0os2uzu234yq550i3fbe2": "605363",
    "1h5s7q9ezqulz6mvvc9981vc9": "480323",
    "3g5ot4cvu4g9lflwa4u8pcvrp": "369053",
    "a15xetizb10ilu9v9inuttqwa": "606979",
    "9wbf00lybk9fqablaqwg5cn2t": "112350",
    "8rfgwq7hbi4a3imda845vdyvp": "304437",
    "dglkt5h4m18p1qcj2uhqymvv9": "360216",
    "4k0ni039sbjs4sqipk4v7k79x": "336243",
    "4603xrdk721lqhd1ejn62x5n9": "262055",
    "f065kc6qn2cpxjxcm6i08rz3e": "595235",
    "cp5hkhz2p2twjtiw8vphfv9hx": "370892",
    "6q0iuwoa8olkezlg4vo04je5m": "701658",
    "drkx7msmzruq5myxk9ani6z11": "239213",
    "eikdf6bvfyzmb0ahxtyokd5gp": "425666",
    "9bqv99e39z86mn7dq3wnyt90p": "401412",
    "7km4xkzmx7pytxxzcu7ugm0np": "231410",
    "1wzbok5h048nfbmusztsc3joq": "535550",
    "5neiwdz7rtkhzj0cneic4xcoa": "572066",
    "83ekq1r2omnsazmp41pio8s89": "444854",
    "9c82id3h8v3cahh5fpwtzqlg4": "973400",
    "cayu6id8xmj67n29s2x3bsbxm": "595413",
    "4x1tm440b5cshi5gxkx5k9m95": "472588",
    "dka9aakcyyvh98m2uhkvs6qz8": "739042",
    "7rvlba00jv66w7wtdmk178a95": "448057",
    "6disrpsqjrkg0ye06a5y6box5": "416343",
    "eee0bq4dkdn91l81e8cf1zxpm": "508119",
    "d1d3v27d4r6vme6n2w5umaacp": "432016",
    "7xl111nfjcmqkj1n2a90p9p7t": "474588",
    "6rtpb71r317mn3nsaqn0ksc89": "396833",
    "dlcwv2hk2e20j76xcq7bdiu7e": "720379",
    "cz1ls8n68toyvln5xduvxbac4": "1144070",
    "c39dl0vqbe8p3o6lvzvlvz0x6": "823176",
    "2tuglrftx5oh6v3vax2rufy6t": "327636",
    "4wvi7b8voeb49ib86xt51uwgl": "103575",
    "8nltgz63ge48r3awx5ogybi3u": "808262",
    "5qoh25z4i5vrunve7yxl2eqz8": "1144121",
    "83khslfie3xuqs32hbfi9b9at": "367040",
    "3ogcxokvirvqgt2o4rfyxx905": "444311",
    "5xk3t1pi394ojwyrhm00com7e": "510632",
    "d9i8y5vlymc2yggwxrax8wcbu": "532116",
    "7ax7vrumfwlxb8a4tchkho650": "709996",
    "3fo37mb4cp6lb0e86hhiyvu8l": "406087",
    "88nmn961vtb3bnt9v9rye1h0q": "610927",
    "9qh33yv2m4youfw1q2xf6vs6i": "916344",
    "6qoj7j99pfhszs5z75kti31wq": "480823",
    "7lm0xrh4646e81mr0oqdtvpxw": "776426",
    "2neid4doevn03b281smpp7o16": "572238",
    "603w7gqz9xm0ines0oq74qwb8": "621314",
    "6w5wyari2p4bh2zzy2x2f6hg5": "140333",
    "i48mf81fxn2af1xxjzfi8gr9": "351497",
    "39c5g6782qlrtw55fsre7exnt": "448876",
    "6g0yegi9hjhxws7obd46a1lp0": "816876",
    "5znvjp1ko1lm8wmiipd2cfget": "466977",
    "e83ula4wockmc2xid7185kcq2": "541929",
    "en2c7z1raqmcwee78297pbnu2": "590838",
    "4o9d3hpjlicgce9gtbewyzhn8": "771848",
    "4uau3xuhrfugr5bo4sannz6x": "555362",
    "8f3eqla9yo5js50fv2tdu5vjd": "448036",
    "5g5wwp5luxo1rz1kp6chvz0x6": "512920",
    "9drh3w3emxjf6aah8pstsdgr8": "730850",
    "e5eiuko5p1yms97xndrvcr0bu": "632338",
    "es8orzwchom47yjt6nwwuc5qs": "802037",
    "5cw4n6kdaa7imeyaiuo2pnq39": "341840",
    "c2mwg1uhug0pbgl72uf9b927e": "596488",
    "as0t8xi6k6nl4l06g23u3jcru": "572082",
    "ek4oa7zejocbbgu1l2vdebitw": "849668",
    "ujb2hkujcnwnyrbsgk3ilmtx": "227900",
    "280fh7f5q9lud8lk8reyu7fxm": "464299",
    "7r2tgpdrr4v6n9d2gkzwmlazt": "428107",
    "1zrqqif7sapaypdyrau1mauei": "516755",
    "asyzhp3qu95vmzdbau6nmoic5": "822",
    "adwfwvdij6onaszluqocifahh": "263056",
    "1wynwp4x95o9w5tt4cdog6i1": "426073",
    "3kdl679ra6mlobdg09xqf7fft": "512957",
    "20o2dr1mdk18xhxmkujzgak89": "479769",
    "a86j56bn5wd6k9ut7ltf6whgq": "525762",
    "7mvqysbmyf6uj3jny3qpqw2ga": "577394",
    "9ikkuxd19avliz1khcrm82gyy": "577467",
    "c90gk99jn34wxtlad784hpnv8": "597591",
    "5zoz3mjooujpv0wdcphyrztd6": "517729",
    "3o0zpl9cnmna2hyk595ja0xrd": "470304",
    "bsdr4bp6qt4qpy303u7l11250": "601109",
    "7joybllup4h9oe6zfhcepjy6t": "223886",
    "9tp35qqu1heburu0g5wa6jv56": "566824",
    "brfa9yhy2llgt9l75unddogk": "924787",
    "7nivkfkngr374fx5totgektm1": "474118",
    "v7isqpxiursyjhj5rmhyhjv9": "301680",
    "by8xbw0rb239l1x4b0t33tpn8": "915304",
    "7fmpgkx58o9pivo2bbnxxkt05": "253477",
    "7ubtan6a51o79w469zawrqqqd": "264597",
    "bpbz94ux2g6awkward9cjwrh0": "734743",
    "ezviixcyaaj162saxs2yl27s9": "373513",
    "cscn06kwqfzo09h0dc5ybt1pl": "433306",
    "abr79wsl0folgkyvl821ggs2c": "805251",
    "6ofu6yc2qwp5ii9cerdq1tk9h": "104379",
    "c80tzy7t4hoa8fpbek1od4lw5": "331149",
    "bzgh5psb1janz9y3btpswngbu": "605317",
    "4et6r42e7q2ojgaumwnua2kgk": "1083785",
    "d3wwlyd3dy9ius9b2hza9o9as": "913068",
    "1av9mmv19jwvc4xdr0p9owyxh": "303116",
    "8vhjmcgjbzpzd4vv3zb945p1w": "644944",
    "308krssmz6irpfntht1ka78tm": "567631",
    "edti8t30h7ukwi3wqlzaczje1": "514621",
    "52bg33ueyjgfvlh0x4n4rks2c": "695355",
    "f5j3vhj805xtkos7l538u0d7t": "487254",
    "az7wa6km1zhvsb8y4mndlogyd": "238788",
    "cm0gwoyh5rdb216fx685a7l5h": "298038",
    "a1q3mystvi6gkv7tjrn75kw6h": "340208",
    "2r1u01vlym0nwcwx86bwbuusq": "530791",
    "2e0o5pwinz3zhg9pqg5vej9ih": "409138",
    "adb8skc3qbvgunhzd9651lij8": "620671",
    "b3974hgsmyff5xtq7qf1onhlh": "316508",
    "85gmjxvy1g5aj1lcizegwuaui": "508609",
    "4cetkl0w2uq40ccti5ka6a4t1": "374383",
    "693z0rzfh3m0h0wsma9v8c9ux": "474120",
    "9prtaifv6stlujgywgq4wd08a": "577464",
    "atzboo800gv7gic2rgvgo0kq1": "449871",
    "drh7wx5zz8c4dwa9o8mrigjro": "670390",
    "2w7xspkzg7b9ghl20me202ove": "472872",
    "2t5s4f41jefzuzth0bhcixtcl": "349139",
    "3gem1jrrkgye0omb88fk1lsk5": "249523",
    "dqfk7czrayirrvonirtk2mk15": "384715",
    "7zru7o3jrzx66f5aa6kggyplg": "826602",
    "6nwn2522yescgrx57wkcxjhwq": "656892",
    "1bnn3tokzwvl4vvw34yxsq9gq": "567601",
    "370bp4zp3mxe27rtx3gwhcems": "672582",
    "3trkre1c81pzretsjsi8jk6sq": "558659",
    "btfanvej91yogqzfml4vmsmei": "571691",
    "e6zf0qj614z50i0bsd4l3xmac": "918794",
    "47zfdb0zeb03nvtjpom42j2ms": "839973",
    "dxmulnxbs11kpi1goq5hl9cve": "497471",
    "cmdeqxibr6holfqg17ap9uihg": "792233",
    "3ojwbw6v83g9b0u2wssnkzzzd": "404296",
    "c6ip6gwp8yvchd1n3dv42go9": "413869",
    "21k54i5a6d9bi4f6gplgzxiw9": "369704",
    "5lvdnoyknuoyr6kdruposgctl": "454296",
    "d4j19ipiaeuetyij08fofgs15": "452072",
    "biee6dvb524juzai7iryyskix": "472194",
    "cs4aca71qkt1ru20ppmi6djl6": "520543",
    "9vf02r3geinhsy732oxyrcacq": "641833",
    "2gsq05yyxwe4f8t79j6d49q6t": "10596",
    "cgsmk5437f466uoqvol7devze": "621826",
    "24sgu58uugxgy49el075dz21g": "859758",
    "6jhavdnaitqn6ydme8a526aui": "531273",
    "azt1lhru9cgyb64h4h4fffrx0": "757431",
    "b1lcxeihx8z6pfv1jef4j5jh1": "352669",
    "65rqu55qbzswixgqw2efna06i": "497278",
    "cnmlhoum9aahwqruxgmz2gcfd": "421804",
    "72m5u1rlgh6e229zpfvp7f5jp": "301301",
    "gw2711y9bgq4w80ntfqvv88a": "585482",
    "8tc7dcuwdeqbjgt7vw5p38xgq": "532444",
    "af5ppqx0gs7ym0to0o3vp5mhg": "835751",
    "4ffmlhvbjvfjjnhr0byktvt62": "512671",
    "acx78ftnm61hm01wpmme77hbe": "586898",
    "c29mprqv2ulztd22b6uckczx1": "114505",
    "ekm47qd8w1x0456lm1tmf5re1": "490011",
    "8bvn7mn5tjfj3l2bnpvm75gmi": "663082",
    "albt55j4oir1veynmos532psk": "849576",
    "eh70fwampgdyfv3hu25o2qx": "380226",
    "3n9jnuteyjx6w6dxviuead0b9": "374545",
    "d27r61wcc9az0shpevisc4iga": "602666",
    "bfdtduknquzhr2br7ahlgvvo4": "702970",
    "b5rea5r4h8bclpenau2au142x": "418606",
    "5054kfjkrimomrhilbe5j3xbe": "623967",
    "cv46mxj5i98p4hgtbomxlxs7o": "704122",
    "3o573dblmfc1o3wkkt2nva8k5": "161665",
    "2x44f29a52v8kpkkjsuiiywdm": "583245",
    "1qkneebzln8byl9td2aswznmy": "664703",
    "2mhvgtcem9qn2yzobtkqiegpg": "829877",
    "4x854vpovag131b2kdutv4qju": "617545",
    "73jvx4opw9wvawwpg0bnt8ay2": "662827",
    "bh3b7e2qzh41dltd6h2obpln9": "301385",
    "et72bvivn2sh4gq9lb2fbsm50": "916799",
    "7de0uy8a51bjehkrlq6iuioh6": "637219",
    "7aak50ydu8nrfxd9qndeygnpw": "660243",
    "66psa7xh8odnlp39ue5vzpes4": "691025",
    "32eyq4xvy8s1ng11jnavvh32t": "333730",
    "8onx3qmoe50w7j40xsvnsvb6y": "658883",
    "cio1emair88b1xnhiol0lr7px": "358706",
    "ebsb7romjjaopsxjtn2ty9qtw": "1395131",
    "dzv5f93w5fsnfzohaev6e3rx0": "792218",
    "ckaqxlw257qzj8vjdumvwbaad": "391993",
    "8ptmy8v6u26pzkzn3doncavis": "783633",
    "5soi8e2hlk77rlsbsl76hg3xl": "482685",
    "6ddxujeb3873j5evwiz8n4wt0": "660542",
    "dydwiixiims98cx2iihfuf8wl": "309149",
    "d0azo0spzov2hg6ul40l58e3u": "676363",
    "ehopba709zukxj4vgcync942d": "234396",
    "drwacyyicuhy3heg4j0ipqj85": "318906",
    "58de7rbubnxjraen49dxpaqne": "598713",
    "1ehcji0j9s8b0qsj8v5zinjvu": "567790",
    "b8if5dg0k9prjik99aiutewh5": "472830",
    "548jzfl9higq44w9bgqvcjh05": "300684",
    "1vyh50nfaq2kq5pmivpkc1psl": "426360",
    "2lt2tw1qypl9hmlz529bo0sus": "757428",
    "4ea0sjczqa5ah1w720zlakkfe": "538539",
    "72m84nwa6dshu3ibmy13dz5rd": "497126",
    "552xyc766gp97a5zu8tcx4xzo": "789519",
    "bhsh1n3qfg8awmctxlh8k7yzt": "531921",
    "bf7ph89zhr5y6rtct5k9bvqc4": "684338",
    "dnw3y6r7bk0aqbta2s7ttivhl": "422567",
    "ar7ybu7dordgt2yfx5inux62": "604656",
    "av18ek8zmx40sazfwerdp8wa2": "553517",
    "lioz4hr2umpne2bwar18qa96": "542303",
    "66jotyvbhtz5cjvhbby6luelm": "646693",
    "5rwicl82hq48g9t0qgthucxec": "884681",
    "7r7wgbcu7vmlj19m9jpjhu1yi": "514521",
    "2945m6rjmwj1viq0a4k1sd0yc": "621385",
    "7yirx71oya71zjsgldj5ucqcq": "530413",
    "bgydmtsi0ngn9k56apo29v0no": "811671",
    "eiqcjlj9kmitoj8g50vaglawa": "555132",
    "dgjl6ks0r7lbh09fe8cuwj7ro": "606889",
    "9vk04uj215dfan7wak7j25hjo": "912078",
    "7w5ivtmbqzi4hfte330r1a505": "14872",
    "el8asgbjqbtvu9dcpyv9d668k": "947674",
    "b8ixf31bdyfqqcwoy4ulai73e": "531189",
    "555z9bynvux7oruirg67r8i51": "255723",
    "c6nl81c1q4unq5js94s6s942x": "372547",
    "29dp5gmu5xbd04mozwxq5tjh1": "349562",
    "4aqkgskbra4wsoo7a8uw7xl9l": "561883",
    "8d04q3yp2kouwog0lj0s7ew2x": "428370",
    "a69r2pf2w8da4dl0zl4k5vil1": "262708",
    "8ztjk6yu7qfb0aabjebf4513p": "166807",
    "330k0yqjq1ubnkfpfshp2h6qy": "478219",
    "cxajw64g1elff3fq3lkzkzi1g": "953665",
    "du4ciqofpkn3nei5q3huwlnje": "574877",
    "4ml8pyt3rxwxakjxslg0c8kb9": "367263",
    "448wxnlqhqqf2hcecwut90n6y": "676877",
    "5r3h17uip2r1dlw1tde1e4hzo": "1420133",
    "9jh6n6ztbudt5aluf0ibzls6h": "456333",
    "1e7d2d9kcstlfayi0wlg2b66s": "819078",
    "s96k2x2cts0vo6y6aaeui5zp": "291835",
    "8fzbg2qdd8d00nwn1kinqr71m": "638881",
    "f414ed8b0apdfxxa56mq04q1h": "354954",
    "38339rg6eqprxc0w976gozjmc": "885504",
    "32avhormhc1dbawwzztesqac": "936753",
    "61psw0tgtithfb7knevi50xec": "1119803",
    "nn4nw9jga8f9a3dpq7wz4o44": "1235495",
    "59e0uusbhyz9wo8c3rtqlcve": "518084",
    "bjob8tftnxojnytcj7juo0ga2": "569837",
    "11iaca5nfeqabdba4646vje1h": "244396",
    "1o7se1aziz6fpes5hey7yijft": "468344",
    "28x7i681wkjueanvkevew3bh1": "314191",
    "csvqjyuk06gzvjm408513nydx": "253617",
    "cegoeac3l2owi83zdvu30tj6y": "682391",
    "b0me6l44boibnwpbtasxoy02x": "513231",
    "emglxnqrlqskt8krglv7sziwa": "572724",
    "2yc1t7u26zctwjizi283g6q6s": "641197",
    "f4pqxviuwzd6a803jfx9bh4o9": "468850",
    "5jk0wq14a8emikh2vh53aw0ve": "562866",
    "f0drogjsrwqv3hyjxuqcnk8vd": "425050",
    "2biwwlvzgsu5kmyw5w1adpmtx": "268467",
    "ev6oj77aergyn1hswvx4cq73e": "573428",
    "9jxhgh1vhc531ho0ez5alfazu": "539578",
    "6ma3oewkllhcu66tbb6d8shzo": "935133",
    "4fu2agdclsyxx1boxxibauzo4": "822263",
    "264gu641hrd38wqf28xolwhlg": "805508",
    "8i46yzejeiwdmz0tywmy42o2y": "608721",
    "esru3us4k7xaj6hjycz78pdsk": "1317608",
    "a2k7c99py1zab3qa0i0pjy590": "971878",
    "3x1y10rgm8bbu3zgef74b05ck": "660054",
    "863y1lnf6rxq7xc478ld6y7tg": "835613",
    "9rtfwu0z7qtk1kglenp2vm13o": "1080479",
    "7jn9kl5wq29d41ekc2fz2rs2d": "253515",
    "d7ofv9d9sbp263uo76cm2qxhw": "844307",
    "1c4nu9s3t3p83pufjf3n3xqay": "562368",
    "dxxc4dioaioidmvamkzqr4b85": "168116",
    "exqldi3zpsfhvhhvphmpw1ez8": "935130",
    "8eq4c5cotvem9ae9uzb2yezo4": "881033",
    "cg6h7oq0b5zpx1g4brhzyk1xx": "26517",
    "2jc6sdkse1kxjztsgystidot1": "372657",
    "6tezw22m241iukjha6vyz0rh0": "792221",
    "38bp85766w04a0nuulq5fiig9": "448430",
    "6q69l3ppqfqbryjubcrujfi6t": "389121",
    "3ub05nnpt9o7s387z6oj8vf56": "620719",
    "7drgir9lcwfst8vxz07jboe6t": "282936",
    "7rfw6pyjslb3p5q7gmoj1ysmi": "620830",
    "9j742o5vdc7d54x1xdz4t9ck5": "229849",
    "4ax49niuix9tiqdv05y3vbdn9": "385021",
    "bcrlwj3yqeuqkhg7ta31dtvkk": "1393844",
    "bvymw4wbcvzoafi5600i3lql1": "225834",
    "2wesmq2wuhnuwh2yhgkuaxqfo": "838458",
    "56nbghr9snc79dt8h99wleej8": "952173",
    "3rve12v22lh39aaqgjlwlmhas": "751264",
    "byaovvyzh22vsvs0iitqeciy1": "369331",
    "6fzbp94hf19ysotdassrqdc5x": "230406",
    "55ashhvkh23ypnct70f9dgvkl": "263545",
    "drmudc3n93faawruj8ct3bwmh": "447210",
    "6yovfcug6e9hykfauqy0fq67d": "449030",
    "bxjc2heo4ve54cyvw98qcck45": "413671",
    "43n6lws8fguddvg3e4ukfrpw": "719674",
    "srzdmbirhvpjuok4mf7lj5zo": "909306",
    "buzh1oolanqmxdm3bqt1sfqxg": "952418",
    "d66tmyj9pt69gub8pcjgo3bh1": "397215",
    "3hpaoy4qzn5xp7qnzdrj1yvsa": "647150",
    "ehbhpv43ealtggnkc4z2dtka1": "472425",
    "ap0l05cfp7i1ifxptxjusls7o": "840534",
    "ddfwtazsntda1pah2l454py3t": "498707",
    "1rqac77f4ll6u3yseozxcgpp0": "1128443",
    "ctq9si3nbc6n8cznhlcvtixd6": "444551",
    "82o91md3nn11eckmgy749ewpg": "789894",
    "d36na8jr6xcc8eronhy8mcz1m": "545181",
    "oi8kw43rorvqooiencbnhxck": "936406",
    "ecmpznived7xp45o7bm96csno": "1146341",
    "3kti58d195gmtzwrjh5nprx05": "230225",
    "e51jmlxup2pdr8ikl98etxgd0": "893524",
    "9jmh0pjjecyisiovvqfr1zoyc": "946606",
    "a8pnwy8wy8ytwek1ovtxkaivo": "1464305",
    "63i6o2zienvxlanzwc6pf8cus": "1695737",
    "9wgavu943u5yn0qu6go17bk7o": "805259",
    "6j3wbk9xlq4om4m8ih6b3tyvp": "271167",
    "ed20ebhqi5c32vbbsze8r6yuh": "356654",
    "asy2ytqb8svtkaqlxwkmaigic": "1286705",
    "b1dfdzazfrr1hqf8xanoc6wic": "1128863",
    "7dpac4vuxwmu25eh9u9cqx91w": "967254",
    "dqdu0arww7z83y4of1nvi42z8": "952170",
    "f1b958d0xab1okq496kx0nfje": "534219",
    "7ew7g18qo649t8ld44omgib55": "423368",
    "37ao6cj3w5pd5v5ap79fqlxw5": "293646",
    "d078o2hgm2fkdjz5vagzx9oq2": "637711",
    "9ksawmk9ligul6vfjihf50r8": "1251212",
    "72d5uxwcmvhd6mzthxuvev1sl": "367421",
    "ai5p5wgft6c09bjbldz9sfeac": "677614",
    "73aues52n0vmq59vvvsqrqcid": "209470",
    "5chuil758xa9c7096hbjp6xw4": "916414",
    "1qva22ouiudjynfrfoeduq9sk": "709588",
    "en2qiiaubgikr1aeklrzkku8k": "795202",
    "5huvpvvrccp5qq5a11vz8v384": "806675",
    "edk9jemtelz51uoob4quyd4kq": "671741",
    "3r4r3w44ski0d4175zfe1iy38": "900116",
    "4r5mejvmxk423kx5j3w4u3n6c": "804918",
    "6j5giieogscravfi7ov556az8": "828588",
    "2fqlri41xq6p924kine7pjr2t": "301327",
    "29pq64smaxdwlraopnxoleqxh": "279932",
    "1jpq7xvsg1xh51ff03qukrj84": "1114991",
    "9ipux4xiejibplsbbhqz8d5gp": "490651",
    "7tnuxlg9l4rjhc7j3ko36hduy": "543229",
    "2spn42sn73gxwyt6ucobiknl6": "662835",
    "8wcpxluqhub8yqrgi1jcvzbx0": "712130",
    "a9ozu4hjaylfr4299ceryskid": "331470",
    "9ocaoc4rmct3neemzpth5c6qc": "638753",
    "ej3r3h5sda64akl1oh2n853pw": "826168",
    "2bfs1dfmyao4e3gzha29t1lw4": "792184",
    "3ww5879aay1xf2a20nl9ihwid": "293134",
    "enpkvxwcyv4sqfzulxwmvxmac": "699372",
    "5m35ycmsvj7ftub65tjmfksus": "1050908"
  }
};

module.exports = playerMapping;